// Ukrainian translations — UI shell.
const uk = {
  /* Zájemci, prohlídky a předání financím
     (pages/RealityZajemciPage.js + pages/ProhlidkaPrihlaskaPage.js).
     Klíče `ver*` mluví na ZÁJEMCE — bez odborných slov, krátké věty.
     Zbytek mluví na makléře. Znění samotných souhlasů tu NENÍ: chodí ze
     serveru (backend/lib/reality_souhlas.py), protože se ukládá jeho otisk
     a ten musí sedět s tím, co člověk doopravdy viděl. */
  realZaj: {
    nadpis: "Зацікавлені та огляди",
    nacitam: "Завантажую…",
    chyba: "Не вийшло. Спробуйте ще раз, будь ласка.",
    terminy: "Дати оглядів",
    terminyPopis: "Оголосіть одну дату та надішліть посилання. Люди запишуться самі.",
    vypsatTermin: "Оголосити дату",
    termin: "Дата і час",
    delka: "Хвилин",
    kapacita: "Скільки людей",
    ulozit: "Зберегти",
    zadneTerminy: "Ви ще не оголосили жодної дати.",
    volno: "Вільно {n} з {z}",
    neplatny: "Посилання вже не діє",
    vDiari: "У щоденнику",
    kopirovat: "Копіювати посилання",
    zkopirovano: "Скопійовано",
    zneplatnit: "Скасувати посилання",
    zajemci: "Зацікавлені",
    pridatZajemce: "Додати зацікавленого",
    rozesilka: "Інші пропозиції можуть отримати {n} з {z}.",
    jmeno: "Імʼя",
    telefon: "Телефон",
    email: "E-mail",
    rucneBezSouhlasu: "Зацікавлений, якого ви вписали вручну, згоди не має — її дає лише він сам у заявці.",
    nikdoTu: "Тут поки що нікого немає.",
    bezJmena: "Без імені",
    stav: "Крок",
    financovani: "Фінансування",
    okamzik: "Коли передати",
    predatPoradci: "Передати раднику",
    predanoPoradci: "Передано раднику",
    bezSouhlasuNejde: "Без згоди це неможливо. Надішліть посилання на заявку, де він попросить сам.",
    odvolat: "Відкликати згоду",
    smazatPotvrzeni: "Видалити зацікавленого та його дані? Передачі залишаться, але без персональних даних.",
    souhlasPoradci: "Згода на радника",
    souhlasAno: "Згода на пропозиції",
    souhlasNe: "Без згоди",
    souhlasNezeptano: "Не питали",
    souhlasOdvolan: "Згоду відкликано",
    souhlasImport: "Зі старої бази",
    predani: "Передача фінансистам",
    zadnePredavky: "Ви ще нікого не передали.",
    odmenaNenastavena: "Винагороду не налаштовано",
    odmenaVysvetleni: "Поки не обрано, від чого рахується частка, система суму не рахує.",
    zpetNaNemovitost: "Назад до нерухомості",
    smlouvaZalozit: "Резерваційний договір",
    smlouvaOtevrit: "Відкрити резерваційний договір",
    smlouvaPodepsana: "Резерваційний договір підписано",
    fin: {
      neptal_jsem_se: "Не питав",
      hotovost: "Готівка",
      hypoteka: "Іпотека",
      nevim: "Не знає",
    },
    predavkaStav: {
      navrzena: "Чекає на радника",
      odeslana: "Надіслано",
      prijata: "Радник узяв",
      odmitnuta: "Радник відмовив",
      propadla: "Протерміновано",
    },
    verNadpis: "Заявка на огляд",
    verNacitam: "Завантажую…",
    verNeplatnyNadpis: "Посилання не діє",
    verNeplatny: "Дата вже минула або посилання закінчилось. Звʼяжіться з ріелтором.",
    verJazyk: "Мова",
    verJmeno: "Імʼя та прізвище",
    verTelefon: "Телефон",
    verEmail: "E-mail",
    verPlno: "Цей огляд уже заповнений. Звʼяжіться з ріелтором.",
    verOdeslat: "Записатися на огляд",
    verOdesilam: "Надсилаю…",
    verPovinne: "Без першої позначки заявку зберегти не можемо.",
    verChybiKontakt: "Залиште, будь ласка, телефон або e-mail, щоб ми могли звʼязатися.",
    verChyba: "Не вдалося надіслати. Спробуйте ще раз.",
    verHotovo: "Готово, ви записані.",
    verHotovoPoradce: "З вами звʼяжеться також іпотечний спеціаліст.",
  },
  /* Kalkulačka na veřejné stránce nemovitosti
     (components/nemovitost/KalkulackaNemovitosti.js). Mluví na KLIENTA,
     ne na poradce — krátké věty, žádný odborný slovník. */
  nemKalk: {
    otazka: "Купуєте для себе чи як інвестицію?",
    proSebe: "Для себе",
    jakoInvestici: "Як інвестицію",
    vlastni: "Власні кошти",
    sazba: "Відсоткова ставка",
    splatnost: "Строк кредиту",
    najem: "Очікувана місячна оренда",
    splatkaPopis: "щомісячний платіж",
    vetaSplatka: "За {podil} власних коштів потрібно {vlastni}, а платіж становитиме {splatka} на місяць.",
    hruby: "Валова дохідність",
    cisty: "Чиста дохідність",
    cashflow: "Місячний грошовий потік",
    vetaMinus: "Оренда не покриє платіж і витрати — щомісяця ви доплачуєте {castka}.",
    vetaPlus: "Після платежу та витрат з оренди щомісяця залишається {castka}.",
    vetaNajem: "Вкажіть очікувану оренду — без неї дохідність порахувати неможливо.",
    predpoklady: "Розраховано з експлуатаційними витратами {naklady} на місяць, зайнятістю {mesicu} з 12 місяців і податком з оренди 15 % із 70 % доходу.",
    orientacni: "Орієнтовний розрахунок, не пропозиція та не гарантія. Реальну ставку визначить банк за вашою кредитоспроможністю.",
    zaM2: "{cena} за м²",
    rokOne: "{n} рік",
    rokFew: "{n} роки",
    rokMany: "{n} років",
  },
  /* Realitni zakazky (/zakazky). Klice musi byt ve VSECH peti slovnicich —
     t() na chybejicim klici tise vrati klic a na obrazovce sviti `zakazky.nazev`.
     Hlida to frontend/src/__tests__/klicVeSlovniku.test.js. */
  poptavka: {
    prohlidka: 'Огляд',
    dorazil: 'прийшов',
    nedorazil: 'не прийшов',
    teplotaVlazno: 'Стоїть довго — зателефонуйте покупцеві',
    teplotaHorko: 'Стоїть надто довго — покупець мовчить',
    stitek: 'Запит на купівлю',
    zpetNaPipeline: 'Назад до ріелторського конвеєра',
    otevritObchod: 'Історія справи',
    otevritKlienta: 'Тека клієнта',
    followUp: 'Follow-up',
    nenalezena: 'Такого запиту немає або він не ваш.',
    faze0: 'Звернувся',
    faze1: 'Огляд призначено',
    faze2: 'Був на огляді',
    faze3: 'Серйозний інтерес',
    faze4: 'Резервація',
    faze5: 'Договір купівлі',
    faze6: 'Передача',
    ukol0: 'Зателефонувати і зʼясувати, що саме шукає і чим платитиме.',
    ukol1: 'Підтвердити час і надіслати адресу.',
    ukol2: 'Запитати про фінансування та відповісти протягом трьох днів.',
    ukol3: 'Перед резервацією переконайтеся, що фінансуванням хтось займається.',
    ukol4: 'Скласти договір резервації на обрану нерухомість.',
    ukol5: 'Передати документи адвокату і стежити за строками.',
    ukol6: 'Передати ключі та закрити справу.',
    akce0: 'Запропонувати нерухомість',
    akce1: 'Підтвердити час огляду',
    akce2: 'Записати, чим платитиме',
    akce3: 'Влаштувати іпотеку',
    akce4: 'Скласти договір резервації',
    akce5: 'Надіслати договір адвокату',
    akce6: 'Передати ключі',
    coHleda: 'Що шукає',
    doptatSe: 'Ще запитати про:',
    typ: 'Тип нерухомості',
    typNevybrano: 'Не визначено',
    lokalita: 'Локація',
    lokalitaPlaceholder: 'Центр міста, до 20 хвилин від центру…',
    rozpocet: 'Максимум, який готовий дати',
    dispozice: 'Планування',
    dispoziceAtypicke: 'Нетипове',
    nabidnoutPoradce: 'Іпотека йому, найімовірніше, знадобиться — знайдіть радника ще до резервації.',
    nabidky: 'Що ми йому запропонували',
    nabidnuto: 'Запропоновано: {n}',
    zadneNabidky: 'Поки що ми нічого не пропонували.',
    coJesteMuzeme: 'Що ще можемо запропонувати',
    zadneDoporucene: 'Він уже знає всю вашу нерухомість.',
    nabidnout: 'Запропонувати',
    stahnout: 'Відкликати',
    nemovitostPryc: 'Нерухомості вже немає в системі',
    nabidkaStazena: 'Пропозицію відкликано.',
    ulozeno: 'Збережено.',
    chybaUlozeni: 'Не вдалося зберегти.',
    chybaFaze: 'Не вдалося змінити етап.',
    chybaNabidky: 'З пропозицією щось пішло не так.',
    chybaSeznamu: 'Не вдалося завантажити запити на купівлю.',
  },
  zakazky: {
    novaPoptavka: 'Новий покупець',
    filtrProdej: 'Продаж',
    filtrNakup: 'Купівля',
    nabidnutoKupujicim: 'Запропоновано покупцям',
    otevritPoptavku: 'Відкрити запит',
    poptavkaPryc: 'Запиту вже немає',
    neaktivni: 'Продаж зупинено',
    tymUlozit: 'Зберегти команду',
    neulozeno: 'Не збережено',
    tymZavolat: 'Подзвонити',
    osaOdkaz: 'Посилання для покупців',
    historieVse: 'Показати всю історію',
    historieMene: 'Показати лише останнє',
    /* Realitni pipeline (/reality) + prokliky z karty. */
    /* Souhrnne dlazdice nad realitni pipeline (vzor: hypotecni pipeline). */
    bezNemovitosti: "До цієї угоди не прив’язана жодна нерухомість, тож немає звідки взяти адресу, покупців ані оголошення. Створи нерухомість у ріелторському огляді.",
    souhrnProdej: "У продажу",
    souhrnProdejSub: "загальний обсяг {v}",
    souhrnNakup: "Покупці",
    souhrnNakupSub: "шукають нерухомість",
    souhrnStoji: "Довго стоїть",
    souhrnStojiSub: "зателефонуй, поки не зателефонували вони",
    souhrnHotovo: "Завершено",
    souhrnHotovoSub: "передано й закрито",
    souhrnNic: "—",
    pipelineNazev: 'Ріелторський пайплайн',
    pipelinePodnadpis: 'Де стоїть кожен обʼєкт і як довго він там стоїть',
    pipelineSeznam: 'Список і новий обʼєкт',
    pipelineOtevrit: 'Відкрити пайплайн',
    prodatNechat: 'Продати, чи залишити?',
    prodatNechatSub: 'Орієнтовний розрахунок для власника — продати зараз чи здавати в оренду',
    sloupecNemovitost: 'Нерухомість',
    sloupecFaze: 'Етап',
    sloupecStani: 'На етапі',
    sloupecDalsiKrok: 'Наступний крок',
    sloupecCena: 'Ціна',
    denOne: '{n} день',
    denFew: '{n} дні',
    denMany: '{n} днів',
    teplotaVlazno: 'Стоїть довго — звʼяжіться з власником',
    teplotaHorko: 'Стоїть надто довго — власник не знає, що відбувається',
    filtrVse: 'Усе',
    filtrStoji: 'Стоїть довго',
    stojiPocet: 'Стоїть довго: {n}',
    coTed: 'Що зробити зараз',
    akce0: 'Запитати документи у власника',
    akce1: 'Домовитися з фотографом',
    akce2: 'Опублікувати оголошення',
    akce3: 'Призначити перегляд',
    akce4: 'Скласти резерваційний договір',
    akce5: 'Передати договір адвокату',
    akce6: 'Передати покупця консультанту',
    zajemci: 'Покупці та перегляди',
    smlouvy: 'Резерваційний договір',
    tym: 'Хто над цим працює',
    tymSub: 'Фотограф, консультант, адвокат. Щоб знати, кому дзвонити, коли все стало.',
    tymPrazdno: 'Поки що ніхто.',
    tymPridat: 'Додати людину',
    tymRole: 'Роль',
    tymJmeno: 'Імʼя',
    tymTelefon: 'Телефон',
    tymOdebrat: 'Прибрати',
    tymUlozeno: 'Команду збережено',
    tymBezObchodu: 'Команда зберігається до угоди, а цей обʼєкт її не має.',
    roleMakler: 'Ріелтор',
    roleFotograf: 'Фотограф',
    rolePoradce: 'Фінансовий консультант',
    roleAdvokat: 'Адвокат',
    roleJine: 'Інша роль',
    osa: 'Хронологія',
    osaSub: 'Коли фотозйомка, коли оголошення, коли які перегляди. Це відповідь власнику на питання, що відбувається.',
    osaHotovo: 'Готово',
    osaNestalo: 'Ще не сталося',
    osaUlozit: 'Зберегти хронологію',
    osaProhlidky: 'Перегляди',
    osaProhlidkyPrazdno: 'Поки що не призначено жодного терміну.',
    osaPrihlaseno: 'записалося',
    osaVypsat: 'Призначити перегляд',
    mkPriprava: 'Підготовка та фотозйомка',
    mkInzerce: 'Портали нерухомості',
    mkSite: 'Соціальні мережі',
    mkPlacenaReklama: 'Платна реклама',
    mkPr: 'Офлайн PR',
    historie: 'Що і кому відправлено',
    historieSub: 'Записи з угоди — листи власнику, зміни етапів, ваші нотатки.',
    historiePrazdno: 'Поки що нічого.',
    historiePridat: 'Записати дзвінок або повідомлення',
    historieUlozit: 'Записати',
    historieZapsano: 'Записано до угоди',
    nazev: 'Об\'єкти',
    podnadpis: 'Нерухомість, яку ви продаєте, і на якому етапі вона є',
    nova: 'Новий об\'єкт',
    nacitam: 'Завантажую…',
    chyba: 'Не вдалося завантажити об\'єкти.',
    zadne: 'Поки що жодного об\'єкта',
    zadneSub: 'Додайте першу нерухомість — адреса, власник, ціна. Решту доповните дорогою.',
    hledat: 'Пошук за адресою або власником',
    typ: 'Тип нерухомості',
    typByt: 'Квартира',
    typDum: 'Будинок',
    typPozemek: 'Земельна ділянка',
    typKomercni: 'Комерційна',
    vlastnictvi: 'Форма власності',
    vlastnictviOsobni: 'Особиста',
    vlastnictviDruzstevni: 'Кооперативна',
    vlastnictviHint: 'Для кооперативного житла діє інший зразок договору резервації.',
    adresa: 'Адреса',
    adresaHint: 'Вулиця, номер і місто. Звідси це бере і договір, і оголошення.',
    majitel: 'Власник',
    vyberMajitele: 'Оберіть власника з контактів',
    majitelHint: 'Продавець. Він має бути в контактах — об\'єкт прив\'язується до нього.',
    cenaNabidkova: 'Ціна пропозиції',
    cenaOdhad: 'Ринкова оцінка',
    cenaHint: 'Порожнє поле означає «ще не оцінено», а не нуль.',
    lvCislo: 'Номер витягу про право власності',
    katUzemi: 'Кадастрова територія',
    podepsano: 'Договір з агентством підписано',
    exkluzivitaDo: 'Ексклюзивність до',
    exkluzivitaHint: 'Зі споживачем щонайбільше 6 місяців (§ 17 з. 39/2020).',
    provizePct: 'Комісія (%)',
    stitek: 'Енергетичний сертифікат',
    stitekMa: 'Є',
    stitekChybi: 'Немає',
    stitekObjednano: 'Замовлено',
    poznamka: 'Примітка',
    nezadano: 'Не заповнено',
    zalozit: 'Створити об\'єкт',
    zrusit: 'Скасувати',
    ulozit: 'Зберегти',
    ulozeno: 'Збережено',
    krok: 'Крок',
    dalsiKrok: 'Наступний крок',
    hotovoKrok: 'Готово, наступний крок',
    zpetKrok: 'На крок назад',
    dokonceno: 'Об\'єкт завершено',
    hotovoStav: 'готово',
    cekaStav: 'чекає',
    tedStav: 'зараз',
    bezObchodu: 'Цей об\'єкт не має угоди, тож етап нема куди записати. Створіть його заново.',
    kdeJsme: 'На якому етапі процесу ми є',
    faze0: 'Набір',
    faze1: 'Підготовка',
    faze2: 'Оголошення',
    faze3: 'Огляди',
    faze4: 'Резервація',
    faze5: 'Договір купівлі-продажу',
    faze6: 'Передача',
    ukol0: 'Підписати договір з агентством, перевірити кадастр і запросити у власника дані.',
    ukol1: 'Домовитися з фотографом, підготувати план і home staging, оформити енергетичний сертифікат.',
    ukol2: 'Опублікувати пропозицію на порталах і в соцмережах. Посилання збережіть до об\'єкта.',
    ukol3: 'Домовлятися про огляди, питати про спосіб фінансування і записувати зацікавлених.',
    ukol4: 'Скласти договір резервації, взяти блокувальний внесок і надіслати його адвокату.',
    ukol5: 'Адвокат готує договір купівлі-продажу. Стежте за етапом і регулярно інформуйте власника.',
    ukol6: 'Записати показники лічильників, підписати акт передачі та переоформити договори на нового власника.',
    komunikace: 'Що надішлемо власнику',
    komunikaceSub: 'Текст складе система. Надіслати можна звідси, або скопіюйте і надішліть по-своєму.',
    podklady: 'Запросити дані',
    podkladySub: 'Одне посилання, де власник заповнить дані з документа, e-mail і телефон. Фото документа нам не потрібне.',
    uvitani: 'Привітання і план',
    uvitaniSub: 'З першого дня власник знає, що буде — фото, оголошення, соцмережі, платна реклама, PR.',
    nahled: 'Попередній перегляд',
    kopirovat: 'Скопіювати текст',
    zkopirovano: 'Скопійовано',
    vEmailu: 'Відкрити в пошті',
    odeslatJmenem: 'Надіслати від мого імені',
    odesilam: 'Надсилаю…',
    odeslanoNa: 'Надіслано на',
    neodeslano: 'Не надіслано — пошта не підключена. Скопіюйте текст і надішліть самі.',
    bezEmailu: 'У контакті власника немає e-mail. Додайте його і спробуйте ще раз.',
    odkazProMajitele: 'Посилання для власника',
    platiDo: 'Діє до',
    udaje: 'Дані про об\'єкт',
    zpetNaSeznam: 'Назад до об\'єктів',
    smazat: 'Видалити об\'єкт',
    smazatPotvrd: 'Видалити об\'єкт? Угода з історією перемовин залишиться.',
    smazano: 'Об\'єкт видалено',
    nenalezena: 'Об\'єкт не знайдено.',
  },
  /* Tri odkazy pro klienty (web nemovitosti /n/:slug, stav prodeje pro
     majitele /z/:token, podklady /f/:token) + obe verejne stranky. */
  nemWeb: {
    sekce: 'Посилання для клієнтів',
    sekceSub: 'Три сторінки, які клієнт відкриє без входу. Створюються одним кліком.',
    nenacetlo: 'Посилання не вдалося завантажити. Спробуйте оновити сторінку.',
    webNazev: 'Сторінка нерухомості',
    webSub: 'Фото, опис і розрахунок для покупців. Адресу можна продиктувати телефоном.',
    majitelNazev: 'Стан продажу для власника',
    majitelSub: 'Приватна сторінка, де власник бачить, що відбувається. Складається сама з того, що ви робите.',
    podkladyNazev: 'Дані від власника',
    podkladyZnovu: 'Показати знову',
    zatimNevyrobeno: 'Ще не створено',
    vyrobit: 'Створити посилання',
    vyrobeno: 'Створено',
    otevrit: 'Відкрити',
    kopirovat: 'Скопіювати посилання',
    odeslatMajiteli: 'Надіслати власнику',
    odeslano: 'Надіслано',
    zatimNeodeslano: 'Ще не надіслано',
    zverejneno: 'Опубліковано',
    jenProTebe: 'Поки що бачите тільки ви',
    zverejnit: 'Опублікувати',
    skryt: 'Приховати',
    platny: 'Дійсне',
    propadly: 'Прострочене',
    obnovit: 'Створити нове',
    obnovitPotvrd: 'Створити нове посилання? Старе перестане працювати і власник не відкриє сторінку з листа.',
    fotky: 'Фото',
    fotkyPrazdno: 'Поки що немає жодного фото.',
    fotkyPridat: 'Додати фото',
    fotkyOdebrat: 'Прибрати',
    fotkyOdmitnuto: 'Не завантажено:',
    dotaznikNadpis: 'Коротка анкета',
    dotaznikSub: 'Коротко дайте відповідь на вісім запитань. Система складе з них заголовок і опис — а ви потім можете його переписати.',
    oDispozice: 'Планування',
    oDispoziceHint: 'напр. 3+1, 2+kk, гарсоньєрка',
    oPlochaM2: 'Площа (m²)',
    oPlochaM2Hint: 'напр. 78',
    oPatro: 'Поверх',
    oPatroHint: 'напр. 2-й поверх з 5, ліфт',
    oStav: 'Стан',
    oStavHint: 'напр. після ремонту 2023 / оригінальний, готовий до заселення',
    oNejlepsi: 'Що тут найкраще?',
    oNejlepsiHint: 'напр. великий балкон з видом на парк',
    oProKoho: 'Кому це підійде?',
    oProKohoHint: 'напр. родина з однією-двома дітьми',
    oOkoli: 'Що є поруч?',
    oOkoliHint: 'напр. садок 200 м, трамвай, парк',
    oProcProdava: 'Чому власник продає?',
    oProcProdavaHint: 'напр. переїжджають через роботу',
    oProcProdavaVarovani: 'Це піде в оголошення. Делікатну причину (розлучення, борги) сюди не пишіть — вона знижує ціну і стосується власника, а не нерухомості.',
    slozit: 'Скласти текст з відповідей',
    slozeno: 'Текст склала система',
    slozenoRucne: 'Текст писали ви',
    slozitPotvrd: 'Переписати текст, який ви писали вручну? Він складеться заново з відповідей.',
    chybi: 'У тексті бракує — доповніть і складіть знову:',
    nadpisPole: 'Заголовок оголошення',
    lokalita: 'Локація',
    fotkyPoradi: 'Перша фотографія головна. Перетягніть її на початок або скористайтеся Зробити головною.',
    fotkyHlavni: 'Головна',
    fotkyDatHlavni: 'Зробити головною',
    cena: 'Ціна',
    najem: 'Оренда поруч',
    najemHint: 'Оренда використовується лише в розрахунку для покупця. Якщо не знаєте, залиште поле порожнім.',
    popis: 'Опис нерухомості',
    ulozitText: 'Зберегти текст оголошення',
    nacitam: 'Завантажую…',
    neplatny: 'Ця пропозиція недоступна. Попросіть ріелтора надіслати нове посилання.',
    neplatnyMajitel: 'Ця сторінка недоступна. Попросіть ріелтора надіслати нове посилання.',
    propocet: 'Що це означає щомісяця',
    zajemNadpis: 'Хочу на огляд',
    zajemSub: 'Залиште контакт і ріелтор зв’яжеться з вами щодо часу.',
    zajemHotovo: 'Дякуємо, ріелтор з вами зв’яжеться.',
    zajemOdeslat: 'Надіслати',
    odesilam: 'Надсилаю…',
    jmeno: 'Імʼя',
    telefon: 'Телефон',
    email: 'Електронна пошта',
    vzkaz: 'Повідомлення (необовʼязково)',
    chybiJmeno: 'Напишіть, будь ласка, імʼя.',
    chybiKontakt: 'Залиште, будь ласка, телефон або пошту, щоб ми могли відповісти.',
    chybaOdeslani: 'Не вдалося надіслати. Спробуйте ще раз.',
    kontaktNadpis: 'Пропозицію веде',
    zavrit: 'Закрити',
    majitelNadpis: 'Продаж вашої нерухомості',
    majitelPata: 'Сторінка оновлюється сама. Заходьте, коли забажаєте.',
    zatimNic: 'Поки що немає чого показати. Щойно щось станеться, ви побачите це тут.',
    veFazi: 'на цьому етапі',
    zajemceOne: 'звернення',
    zajemceFew: 'звернення',
    zajemceMany: 'звернень',
    prohlidkaOne: 'проведений огляд',
    prohlidkaFew: 'проведені огляди',
    prohlidkaMany: 'проведених оглядів',
    prohlidkyChystane: 'заплановано:',
    prohlidkyNadpis: 'Огляди',
    prohlidkaChysta: 'заплановано',
    krokyNadpis: 'Що робимо для продажу',
    krokChysta: 'готується',
    tymNadpis: 'Хто займається продажем',
    inzeratOtevrit: 'Відкрити оголошення',
    inzeratPopis: 'Так нерухомість бачать покупці',
  },
  /* Levá lišta + chrome aplikace. Dřív to byl SK-only overlay `SK_NAV`,
   * takže vietnamec i ukrajinec viděli českou navigaci na KAŽDÉ obrazovce. */
  /* Uvítací modal po prvním přihlášení (components/FirstLoginWizard.js).
   * {jmeno} se dosazuje v komponentě — nesmí se z překladu vypustit. */
  wizard: {
    /* Zástupné slovo, když poradce nemá vyplněné jméno. Do 23. 8. 2026
       bylo v FirstLoginWizard.js natvrdo české „svoji“, takže Vietnamec
       četl „danh thiếp số của svoji“. */
    zastupneJmeno: 'свою',
    vitej: 'Ласкаво просимо до BEplan University',
    nadpis: 'Налаштуй цифрову візитівку {jmeno}',
    popisA: 'Візитівка — твоя публічна сторінка: клієнти звідти забронюють зустріч, зателефонують, знайдуть тебе в LinkedIn.',
    popisZvyraznene: 'Це займе 30 секунд',
    popisB: 'і потім запрацюють усі посилання Leadovač та картка рекомендацій.',
    slugLabel: 'Твоя URL-адреса (slug)',
    nahled: 'Перегляд:',
    nastavitVizitku: 'Налаштувати візитівку',
    preskocit: 'Поки пропустити',
    pozdejiA: 'Якщо пропустиш зараз, візитівку можна налаштувати будь-коли в',
    pozdejiKde: 'Налаштування → Візитівка',
    pozdejiB: 'Але радимо зробити це одразу — без slug не працюватиме Leadovač.',
    hotovo: 'Готово!',
    vrhnemeSe: 'Переходимо до CRM…',
    ulozeno: 'Візитівку збережено!',
    chyba: 'Не вдалося зберегти slug. Спробуй ще раз у Налаштуваннях → Візитівка.',
  },
  lista: {
    nastenka: 'Панель',
    klienti: 'Клієнти',
    obchody: 'Угоди',
    diar: 'Щоденник',
    posta: 'Пошта',
    manazer: 'Менеджер',
    vzdelavani: 'Навчання',
    nastroje: 'Інструменти',
    adresar: 'Довідник',
    zrcadloVolani: 'Дзеркало дзвінків',
    pipelineKlientu: 'Пайплайн клієнтів',
    radarPrilezitosti: 'Радар можливостей',
    mapaKlientu: 'Мапа клієнтів',
    leadyProjekt100: 'Ліди (Проєкт 100)',
    obchodniNastenka: 'Панель угод',
    hypotecniPipeline: 'Іпотечний пайплайн',
    naborovaPipeline: 'Пайплайн найму',
    naborovyRadar: 'Радар найму',
    zakazkyReality: 'Об\'єкти (нерухомість)',
    realitniPipeline: 'Ріелторський пайплайн',
    rezervacniSmlouva: 'Договір бронювання',
    prehledTymu: 'Огляд команди',
    ikKonzultace: 'IK консультації',
    mojiPoradci: 'Мої консультанти',
    vyhlaseniVysledku: 'Оголошення результатів',
    tymoveAkce: 'Командні заходи',
    diarTymu: 'Щоденник команди',
    startNovacka: 'Старт новачка (Шлях 90 днів)',
    adaptace7: '7-денна адаптація',
    adaptaceTymu: 'Адаптація команди',
    akademieModuly: 'Академія — модулі та інфографіка',
    metodikaPlan: 'Методика: Складання плану',
    zkouskaCertifikat: 'Іспит і сертифікат',
    skriptyNamitky: 'Скрипти та заперечення',
    kdeShanetKlienty: 'Де шукати клієнтів',
    videaKurzy: 'Відео та курси',
    rozcestnikNastroju: 'Каталог інструментів',
    financniMatematika: 'Фінансова математика',
    kalkulacky21: 'Калькулятори (20)',
    penzijniKalkulacka: 'Пенсійний калькулятор',
    zivotniPojisteni: 'Страхування життя',
    historickaKalkulacka: 'Історичний калькулятор',
    investicniStrategie: 'Інвестиційні стратегії',
    srovnavacFondu: 'Порівняння фондів',
    nemovitostPronajem: 'Нерухомість в оренду',
    provizniKalkulacka: 'Калькулятор комісій',
    hledat: 'Пошук',
    hledatVCeleAplikaci: 'Пошук у всьому застосунку',
    naNastenku: 'На панель',
    profilPoradce: 'Профіль консультанта (фото змінюється в Налаштуваннях)',
    zavritMenu: 'Закрити меню',
    sbalit: 'Згорнути',
    pripnout: 'Закріпити',
    sbalitListu: 'Згорнути панель',
    pripnoutRozbalene: 'Закріпити розгорнуте',
    novyZaznam: 'Новий запис — клієнт, лід, угода, завдання…',
    novyZaznamTlacitko: 'Новий запис',
    ucet: 'Обліковий запис',
    novyKlient: 'Новий клієнт',
    novyKlientSub: 'Додати в пайплайн',
    novyLead: 'Новий лід',
    novyLeadSub: 'Можливість / теплий контакт',
    obchodniPripad: 'Угода',
    obchodniPripadSub: 'Одразу створити угоду',
    naborKandidat: 'Найм — кандидат',
    naborKandidatSub: 'Одразу створити кандидата',
    ukolSchuzka: 'Завдання / Зустріч',
    ukolSchuzkaSub: 'Відкрити Щоденник',
    leadZDoporuceni: 'Лід за рекомендацією',
    leadZDoporuceniSub: 'Посилання для клієнта',
    // horní lišta záložek (GlobalTabBar) — zbylých 28; ostatní sdílí klíče výše
    tabLeady: 'Ліди',
    tabServisRadar: 'Сервісний радар',
    tabKomunikace: 'Комунікація',
    tabDoporuceni: 'Рекомендації',
    tabCile: 'Цілі',
    tabVyhlaseni: 'Оголошення',
    tabSmlouva: 'Договір',
    tabHypoteky: 'Іпотеки',
    tabNabor: 'Найм',
    tabHlasovyRezim: 'Голосовий режим',
    tabRezervace: 'Бронювання',
    tabTrychtyre: 'Воронки',
    tabHistoricka: 'Історична',
    tabFinMatematika: 'Фін. математика',
    tabInvesticniStudio: 'Інвестиційна студія',
    tabStrategie: 'Стратегії',
    tabPenze: 'Пенсія',
    tabIzp: 'Аналіз для в’єтнамців',
    tabRentaPorovnavac: "Рента — порівняння",
    tabAnalyza: "Аналіз",
    tabFixace: "Фіксація",
    tabSvoboda: "Коли будеш вільним",
    tabHypotekaRozhodnuti: "Іпотека — рішення",
    tabPortfolioDoktor: 'Доктор портфеля',
    tabReality: 'Нерухомість',
    tabZakazky: 'Замовлення',
    tabRezervacniSmlouva: 'Резерваційний договір',
    tabNemovitost: 'Нерухомість',
    tabKalkulackaVizual: 'Калькулятор візуал',
    tabProvize: 'Комісії',
    tabDesignLab: 'Design Lab',
    tabAdmin: 'Адмін',
    tabAiKnowledge: 'AI Knowledge',
    tabHlasovky: 'Голосові',
    tabHromadnyEmail: 'Масова розсилка',
    tabPortfolioAdmin: 'Портфель (адмін)',
    tabTrzniData: 'Ринкові дані',
    tabMesicnikAdmin: 'Щомісячник (адмін)',
    tabMesicnik: 'Щомісячник',
    tabDataHygiena: 'Гігієна даних',
    tabNastaveni: 'Налаштування',
    tabNovinky: 'Що нового',
  },
  nav: { dashboard: "Головна", calculators: "Калькулятори", tools: "Інструменти", admin: "Адмін", logout: "Вийти", theme: "Змінити тему" },
  login: {
    subtitle: "Освітня система для фінансових консультантів",
    welcomePre: "Ласкаво просимо до",
    welcomeEm: "університету",
    name: "Ім'я та прізвище",
    accessCode: "Код доступу",
    registerClosed: "Реєстрація зараз закрита. Попроси адміністратора надіслати запрошення або відкрити реєстрацію.",
    email: "Email",
    password: "Пароль",
    submit: "Увійти",
    register: "Реєстрація",
    loading: "Завантаження…",
    loginOk: "Вхід успішний!",
    registerOk: "Реєстрація успішна!",
    loginErr: "Помилка входу",
    hasAccount: "Вже маєте акаунт? Увійти",
    noAccount: "Немає акаунту? Зареєструватися",
    forgot: "Забули пароль?",
    forgotTitle: "Відновлення пароля",
    sendCode: "Надіслати код на e-mail",
    codeSent: "Якщо e-mail існує, ми надіслали на нього код.",
    codeLabel: "Код відновлення з e-mail",
    newPass: "Новий пароль (мін. 8 символів)",
    resetBtn: "Встановити новий пароль",
    resetOk: "Пароль відновлено — увійдіть",
    backToLogin: "Назад до входу",
  },
  dash: {
    welcome: "Вітаємо в beplan University",
    subtitle: "Освітня система для фінансового консалтингу",
    progress: "Загальний прогрес",
    completedVids: "Завершені відео",
    activeSeries: "Активні серії",
    totalProgress: "Загальний прогрес",
    series: "Освітні серії",
    done: "ЗАВЕРШЕНО",
    inProgress: "В ПРОЦЕСІ",
    vidsDone: "відео завершено",
    lastWatch: "Востаннє переглянуте",
  },
  detail: { notFound: "Серію не знайдено", locked: "Серія заблокована", lockedDesc: "Завершіть попередню серію для розблокування.", back: "Назад на Головну", seriesLabel: "Серія", markDone: "Позначити як завершене", isDone: "Завершено", download: "Завантажити матеріали", noMaterial: "Матеріали недоступні", comments: "Коментарі", writeComment: "Напишіть коментар або відгук…", send: "Надіслати", sending: "Надсилаю…", noComments: "Поки немає коментарів. Будьте першим!", reply: "Відповісти", del: "Видалити", writeReply: "Напишіть відповідь…", vidDone: "Відео позначено як завершене!", saveErr: "Помилка збереження", commentOk: "Коментар додано!", commentErr: "Помилка додавання коментаря", replyOk: "Відповідь додано!", delOk: "Коментар видалено", delErr: "Помилка видалення" },
  calcPage: { title: "Фінансові калькулятори", subtitle: "Професійні інструменти для фінансового планування", all: "Усе", realestate: "Нерухомість", investment: "Інвестиції", insurance: "Страхування & Пенсія", personal: "Особисті фінанси", open: "Відкрити калькулятор" },
  toolsPage: { title: "Інструменти для фінансових консультантів", subtitle: "Професійні інструменти для ефективної роботи", open: "Відкрити", catObchod: "Продажі та комісії", catKalkulacky: "Калькулятори та розрахунки", catVzdelavani: "Навчання", tileObchod: "Продажі", tileKalkulacka: "Калькулятор", tileVzdelavani: "Навчання", },
  admin: { loading: "Завантаження…", title: "Адміністрація", codeTitle: "Код доступу", codeDesc: "Цей код потрібен новим користувачам для реєстрації.", save: "Зберегти", curCode: "Поточний код:", users: "Користувачі", videoTitle: "Управління відео", videoDesc: "Додайте YouTube посилання та матеріали.", vids: "відео", ytUrl: "YouTube URL", matUrl: "Матеріали (Google Drive)", saving: "Зберігаю…", saved: "Відео оновлено!", saveErr: "Помилка збереження", loadErr: "Помилка завантаження", codeOk: "Код доступу оновлено!", codeErr: "Помилка оновлення", noName: "Без імені", confirmDelete: "Дійсно видалити цього користувача?", userDeleted: "Користувача видалено", deleteErr: "Помилка видалення", deleteUser: "Видалити користувача" },
  common: { reset: "Скинути", start: "Старт", pause: "Пауза", min: "хв", progress: "Прогрес", phase: "Фаза", search: "Пошук…", noResults: "Немає результатів", example: "Приклад", save: "Зберегти", saving: "Зберігаю…", cancel: "Скасувати", delete: "Видалити", edit: "Редагувати", add: "Додати", close: "Закрити", back: "Назад", next: "Далі", yes: "Так", no: "Ні", confirm: "Підтвердити", loading: "Завантажую…", copy: "Копіювати", copied: "Скопійовано", open: "Відкрити", new: "Нове", today: "сьогодні", week: "тиждень", total: "усього", name: "Ім'я", phone: "Телефон", email: "Email", note: "Примітка", required: "Обов'язково", optional: "Необов'язково", submit: "Надіслати", submitting: "Надсилаю…", detail: "Детальніше", settings: "Налаштування", backToSettings: "Назад до налаштувань" },
  crm: {
    title: "CRM Консультант",
    advisorWord: "Консультант",
    subtitle: "Контакти, pipeline, дзвінки та консультації IK — усе в одному місці.",
    beginner: "Початківець",
    overview: "Огляд",
    p100: "Проєкт 100",
    calls: "Дзеркало дзвінків",
    pipeline: "Pipeline",
    ik: "Консультація",
    goals: "Цілі & Rocks",
    team: "Мої консультанти",
    leadovac: "Leadovač",
    stages: { lead: "Лід", calling: "До обдзвону", meeting: "Зустріч заплановано", onboarding: "Онбординг", proposal: "Пропозиція", contract: "Договір", active: "Активний клієнт", lost: "Втрачений" },
    actions: { call: "Подзвонити", schedule: "Зустріч", callback: "Передзвонити", later: "Пізніше", noInterest: "Без інтересу", addContact: "Додати контакт", newLead: "Новий лід" },
  },
  leadovac: {
    title: "Leadovač",
    subtitle: "Воронка продажу для отримання лідів. Надішліть клієнту посилання у WhatsApp — він пройде тему, порахує вигоду калькулятором та залишить запит. Ви отримаєте новий лід.",
    latestLeads: "Останні ліди",
    latestLeadsSub: "Оновлюється кожні 20 с · вхідні запити",
    live: "live",
    today: "сьогодні",
    week: "тиждень",
    total: "усього",
    filter: { all: "Усе" },
    tools: "Ваші leadovač інструменти",
    toolsSub: "4 готові преміум воронки — клацніть та поділіться з клієнтом.",
    setSlugFirst: "Спочатку налаштуйте slug у профілі →",
    open: "Відкрити",
    detail: "Детальніше & поділитися →",
    detailRef: "Створити посилання для клієнта →",
    noLeads: "Поки немає лідів. Надішліть клієнту посилання.",
    moreLeads: "інших — відкрийте картку теми",
    badgeLead: "лід",
    badgeLeads: "лідів",
    badgeLink: "посилання",
    badgeLinks: "посилань",
  },
  leadForm: {
    eyebrowConsult: "30 хвилин безкоштовно",
    yourName: "Ваше ім'я",
    yourNamePh: "Іван Іваненко",
    yourPhone: "Телефон",
    yourPhonePh: "+380 50 000 0000",
    yourEmail: "Email (необов'язково)",
    yourEmailPh: "name@example.com",
    note: "Коротке повідомлення (необов'язково)",
    notePh: "Що для Вас найважливіше, коли зателефонувати, тощо.",
    preferredTime: "Бажаний час зустрічі",
    preferredTimePh: "напр. будній день після обіду",
    consent: "Надсилаючи, я погоджуюсь на обробку даних з метою контакту.",
    successTitle: "Дякую!",
    successSubtitle: "Зв'яжуся з Вами протягом 24 годин.",
    successHint: "Тримайте телефон поруч — зазвичай телефоную того ж дня.",
    bookHeading: "Або одразу оберіть термін",
    bookSubtitle: "Оберіть день і час, що Вам зручний. Без зобов'язань.",
    bookCta: "Обрати термін консультації",
    ctaTryCalc: "Спробувати калькулятор",
    ctaWantConsult: "Хочу консультацію",
    notFound: "Сторінку не знайдено",
    unknownTopic: "Невідома тема",
    errName: "Введіть повне ім'я",
    errPhone: "Введіть коректний номер телефону",
    errSend: "Не вдалося надіслати, спробуйте ще раз.",
    calcEyebrow: "Перевірте самі",
    calcTitle: "Калькулятор — {tema}",
    calcSub: "Рухайте параметри й бачте числа в реальному часі. Це не науковий розрахунок, але достатньо точна оцінка для орієнтації.",
    howEyebrow: "Як це працює",
    howTitle: "Чотири кроки від запитання до рішення",
    examplesEyebrow: "Модельні приклади",
    examplesTitle: "Як це може виглядати у вашій ситуації",
    examplesNote: "Ілюстративні сценарії — щоб показати, що саме можна вирішити. Реальний результат завжди залежить від вашої конкретної ситуації.",
    exSituation: "Ситуація:",
    exSolution: "Рішення:",
    preparedBy: "Цю сторінку підготував для вас",
    bookPoint1: "30-45 хвилин, онлайн через Google Meet або особисто",
    bookPoint2: "Жодного тиску щодо підписання договору",
    bookPoint3: "Після зустрічі отримаєте письмовий огляд протягом 48 годин",
    nextWeek: "Наступний тиждень",
    freeEyebrow: "Без зобов'язань · Безкоштовно",
    getTitle: "Що ви отримаєте",
    get1: "Розрахунок за вашими числами — безкоштовно",
    get2: "Зателефоную протягом 24 годин, у зручний для вас час",
    get3: "Без зобов'язань — рішення завжди за вами",
    timeMorning: "До обіду (11–13)",
    timeAfternoon: "По обіді (13–17)",
    timeEvening: "Ввечері (17–20)",
    timeAnytime: "Будь-коли",
    privacy: "Політика конфіденційності",
    weekdayShort: "Пн,Вт,Ср,Чт,Пт,Сб,Нд",
    midCtaHeading: "Лише 30 хвилин. Без втрат.",
    midCtaSub: "Без тиску, без обіцянок. Лише цифри і ясна голова.",
    whatToExpect: "Чого очікувати від співпраці",
    wantToDiscuss: "Хочете це обговорити?",
    freeConsult30: "30 хв консультації безкоштовно · без зобов'язань",
    term: "Термін",
    inquiry: "Запит",
  },
  vizitka: { title: "Цифрова візитка", subtitle: "URL slug, QR код, кольори та друк фізичної візитки.", slug: "URL slug", slugHelp: "3–40 символів, малі літери, цифри, дефіс.", qrTitle: "URL slug & QR код", qrSaveHint: "Збережіть QR у підпис email, на візитку, на сайт…", print: "Згенерувати друковану візитку (A4)", colors: "Кольори візитки", custom: "Власне", bg: "Фон", accent: "Акцент", save: "Зберегти візитку" },
  booking: {
    pub: {
      inactive: "Цей радник поки не активував онлайн-бронювання.",
      notFound: "Радника не знайдено або посилання недійсне.",
      loading: "Завантаження…",
      notAvailable: "Бронювання недоступне",
      meeting: "Зустріч",
      chooseService: "Оберіть тип зустрічі",
      changeService: "Змінити тип зустрічі",
      pickHeading: "Оберіть дату й час",
      pickDate: "Оберіть дату в календарі",
      loadingSlots: "Завантажую вільний час…",
      noSlots: "На цей день вільних термінів немає.",
      prevMonth: "Попередній місяць",
      nextMonth: "Наступний місяць",
      tzLabel: "Часовий пояс",
      reservingFor: "Ви бронюєте",
      changeTime: "Змінити час",
      detailsHeading: "Ваші дані",
      nameLabel: "Імʼя та прізвище",
      emailLabel: "E-mail",
      phoneLabel: "Телефон",
      noteLabel: "Що хочете обговорити?",
      submitBtn: "Підтвердити бронювання",
      submitting: "Бронюю…",
      fillRequired: "Вкажіть імʼя та e-mail",
      badEmail: "Введіть коректний e-mail",
      bookingFailed: "Бронювання не вдалося",
      gdprInfo: "Надсилаючи бронювання, ви передаєте своє імʼя, e-mail, телефон і нотатку раднику, який збереже їх у своїй клієнтській базі, щоб підготуватися до зустрічі та звʼязатися з вами. Ви будь-коли можете попросити про видалення.",
      confirmedTitle: "Зустріч підтверджено",
      date: "Час",
      sentTo: "Підтвердження надіслано на",
      sentNone: "Надіслати підтвердження на e-mail зараз не вдалося — запишіть, будь ласка, час зустрічі. Радник з вами звʼяжеться.",
      advisorContact: "За потреби напишіть раднику на",
      meetLink: "Посилання на Google Meet",
    },
    svc: {
      uvod15: "Вступне знайомство", uvod15d: "Швидке знайомство без зобов'язань — хто я, як працюю і чи підходимо ми одне одному.",
      analyza45: "Фінансовий аналіз", analyza45d: "Пройдемо ваші цілі, доходи і витрати — основа для фінансового плану.",
      hypoteka: "Іпотечна консультація", hypotekad: "Порахуємо іпотеку та порівняємо пропозиції кількох банків.",
      servis60: "Сервісна зустріч", servis60d: "Ревізія чинних договорів та оновлення вашого плану.",
    },
    title: "Онлайн бронювання — налаштування",
    subtitle: "Підключіть Google Calendar, налаштуйте робочі години.",
    enable: "Увімкнути онлайн бронювання",
    embedTitle: "Показати Cal.com embed на візитці",
    embedSub: "Клієнт бронює прямо на візитці (потрібен Calendar URL у профілі).",
    googleConnected: "Google Calendar підключено",
    connectGoogle: "Підключити Google Calendar",
    workHours: "Робочі години",
    meetingLength: "Тривалість зустрічі (хв)",
    buffer: "Перерва між зустрічами (хв)",
    save: "Зберегти налаштування",
    publicLink: "Публічне посилання",
    upcoming: "Майбутні зустрічі",
  },
  settings: {
    jazykAplikace: 'Мова застосунку',
    jazykNeniMena: 'Мова змінює лише тексти. Валюта залежить від країни (Чехія → Kč, Словаччина → €), не від мови.',
    menaAplikace: 'Валюта всього застосунку: {kod} ({symbol}). Перемикання мови валюту НЕ змінює, і суми не перераховуються — застосунок не знає курсу. Зміна країни лише перепозначить нововведені суми, старі дані лишаються у своїй початковій валюті.',
    motivAktivni: 'Активна тема: ',
    motivJenHotove: 'У переліку лише завершені теми. Elite Light прибрано, а темну тему ніколи не довели до кінця, тому їх тут немає.',
    motivPoznamka: ' · Тема — це твоє особисте налаштування в цьому браузері, клієнтам вона не надсилається. Кольори клієнтської візитівки вона НЕ змінює — їх знайдеш у Цифровій візитівці.',
    oMne: 'Про мене (показується на візитівці)',
    oMnePlaceholder: 'Допомагаю людям досягти фінансової свободи...',
    vzhledSub: 'Обери тему застосунку — кольори зміняться миттєво, а вибір збережеться і після перезавантаження сторінки.',
    zeme: 'Країна (визначає валюту)',
    zemeCZ: 'Чехія',
    zemeSK: 'Словаччина',
    title: "Налаштування",
    profile: "Профіль",
    web: "Мій вебсайт",
    webSub: "Профі мінісайт з бронюванням.",
    booking: "Бронювання зустрічей",
    bookingSub: "Google Calendar, робочі години.",
    vizitka: "Цифрова візитка",
    vizitkaSub: "URL slug, QR код, кольори, друк A4.",
    active: "АКТИВНО",
    saveProfile: "Зберегти профіль",
    tabZakladni: "Основні дані", tabVzhled: "Вигляд застосунку", tabManazer: "Мій менеджер", tabSocialni: "Соціальні мережі",
    tabModelace: "Моделювання", tabVideo: "Відео-інтро", tabStatistiky: "Статистика", tabHeslo: "Зміна пароля", tabRezervace: "Бронювання зустрічей",
    fJmeno: "Ім'я *", fTelefon: "Телефон", fEmail: "Публічний email", fSpolecnost: "Компанія",
    stareHeslo: "Старий пароль", noveHeslo: "Новий пароль", potvrditHeslo: "Підтвердити новий", zmenitHeslo: "Змінити пароль",
    fFotka: "Фото консультанта", fLogo: "Логотип компанії (необов'язково)", fEmailManazera: "Email менеджера",
  },
  c: [
    { t: "Іпотечний калькулятор", s: "Розрахунок щомісячного платежу та переплати.", d: "Дізнайтеся щомісячний платіж, переплату і розклад основної суми та відсотків у часі.", i: ["Сума кредиту", "Процентна ставка", "Термін"], o: ["Щомісячний платіж", "Загалом сплачено", "Переплата", "Переплата %"], ds: ["Основна сума", "Відсотки"] },
    { t: "Калькулятор рефінансування", s: "Порівняйте стару і нову іпотеку.", d: "Порівняйте поточну і нову іпотеку. Дізнайтеся щомісячну і повну економію.", i: ["Залишок основної суми", "Поточна ставка", "Нова ставка", "Залишок терміну"], o: ["Щомісячна економія", "Загальна економія", "Старий платіж", "Новий платіж"], ds: ["Стара іпотека", "Нова іпотека"] },
    { t: "Дострокове погашення", s: "Економія від додаткових платежів.", d: "Дізнайтеся, на скільки років скоротиться іпотека завдяки додатковим платежам.", i: ["Сума іпотеки", "Процентна ставка", "Термін", "Додатковий платіж щорічно"], o: ["Скорочення на", "Економія відсотків", "Початковий термін", "Новий термін"], ds: ["Без додаткових", "З додатковими"] },
    { t: "Калькулятор LTV", s: "Співвідношення кредиту до вартості.", d: "LTV показує співвідношення кредиту до вартості нерухомості.", i: ["Вартість нерухомості", "Сума кредиту"], o: ["LTV", "Власні кошти", "Оцінка ставки"], ds: ["Власні кошти", "Кредит"] },
    { t: "Оренда vs купівля", s: "Порівняння повної вартості.", d: "Порівняйте повну вартість оренди та купівлі нерухомості.", i: ["Ціна нерухомості", "Місячна оренда", "Ставка іпотеки", "Горизонт", "Зростання ціни щорічно"], o: ["Повна вартість оренди", "Чиста вартість купівлі", "Щомісячний платіж", "Вартість нерухомості"], ds: ["Оренда (накопичено)", "Купівля (чиста)"] },
    { t: "Регулярні інвестиції", s: "Зростання портфеля.", d: "Регулярне інвестування — найдоступніший шлях до накопичення.", i: ["Щомісячна інвестиція", "Річна дохідність", "Горизонт", "Початковий внесок"], o: ["Кінцева вартість", "Усього внесено", "Прибуток", "Прибуток %"], ds: ["Внесено", "Вартість портфеля"] },
    { t: "Складний відсоток", s: "Сила складного відсотка.", d: "Складний відсоток — восьме чудо світу.", i: ["Одноразова інвестиція", "Річна дохідність", "Горизонт"], o: ["Кінцева вартість", "Початковий внесок", "Загальний дохід", "Дохід %"], ds: ["Вартість інвестиції"] },
    { t: "DCA vs одноразова", s: "Порівняння стратегій.", d: "DCA означає регулярне інвестування незалежно від ринку.", i: ["Щомісячна сума DCA", "Горизонт", "Середня дохідність", "Дохідність ощадного"], o: ["DCA результат", "Одноразова", "Ощадний рахунок", "Усього внесено"], ds: ["DCA", "Одноразова", "Ощадний"] },
    { t: "Калькулятор інфляції", s: "Як інфляція знижує вартість.", d: "Інфляція щороку знижує реальну вартість грошей.", i: ["Поточна сума", "Середня інфляція", "Горизонт"], o: ["Реальна вартість", "Втрата купівельної сили", "Втрата %"], ds: ["Номінальна вартість", "Реальна вартість"] },
    { t: "FIRE калькулятор", s: "Капітал для фінансової незалежності.", d: "FIRE — капітал для фінансової незалежності. Правило 4%.", i: ["Витрати у пенсії", "Поточний вік", "Цільовий вік FIRE", "Дохідність портфеля"], o: ["Необхідний FIRE капітал", "Щомісячна економія", "Років до FIRE"], ds: ["Накопичення капіталу", "Ціль"] },
    { t: "Накопичення на ціль", s: "Скільки часу збирати на ціль.", d: "Маєте конкретну мету? Дізнайтеся, скільки збирати.", i: ["Цільова сума", "Початковий внесок", "Річна дохідність", "Місячна економія"], o: ["Досягнення цілі за", "Усього внесено", "Прибуток"], ds: ["Накопичення", "Ціль"] },
    { t: "Пенсійний калькулятор", s: "Скільки накопичите.", d: "Середня пенсія від держави замінює лише 40-54% зарплати.", i: ["Вік", "Пенсійний вік", "Місячний внесок", "Внесок роботодавця", "Дохідність фонду"], o: ["Накопичена сума", "Внески держави", "Місячна рента (20 р)"], ds: ["Власне", "Роботодавець", "Держава", "Дохідність"] },
    { t: "Пенсійний розрив", s: "Дізнайтеся свій пенсійний розрив.", d: "Державна пенсія недостатня для збереження рівня життя.", i: ["Поточний чистий дохід", "Державна пенсія", "Пенсійний вік", "Тривалість пенсії"], o: ["Місячний розрив", "Загальний розрив", "Необхідний капітал"], ds: ["Поточний дохід (70%)", "Державна пенсія", "Розрив"] },
    { t: "Страхування життя", s: "Рекомендоване покриття.", d: "Правильно встановлена страхова сума покриває втрату доходу.", i: ["Місячний дохід", "Місячні витрати сім'ї", "Сума іпотеки", "Кількість років покриття"], o: ["Покриття при смерті", "Інвалідність 3 ст.", "Непрацездатність/міс"], ds: ["Рекомендоване покриття"] },
    { t: "Будівельне накопичення", s: "Державна підтримка.", d: "Будівельне накопичення — єдиний продукт з гарантованою державною підтримкою.", i: ["Місячний внесок", "Тривалість", "Процентна ставка"], o: ["Кінцева сума", "Власні внески", "Державні внески", "Ефективна дохідність p.a."], ds: ["Внески", "Держ. внески", "Відсотки"] },
    { t: "Інвестиційний калькулятор — DIP", s: "Довгостроковий інвестиційний продукт.", d: "DIP — довгостроковий інвестиційний продукт з податковим відрахуванням до 48 000 Kč на рік. Правило 120/60: зняття після 10 років І у 60 років.", i: ["Місячний внесок", "Внесок роботодавця", "Тривалість інвестування", "Дохідність", "Ставка податку"], o: ["Вартість портфеля", "Річна податкова економія", "Загальна податкова економія", "Внесок роботодавця"], ds: ["Портфель"] },
    { t: "Cash flow", s: "Здоров'я місячного cash flow.", d: "Здорове cash flow — основа фінансового плану.", i: ["Чиста зарплата", "Інші доходи", "Житло", "Їжа і дім", "Транспорт", "Страхування", "Розваги", "Накопичення та інвестиції", "Інші витрати"], o: ["Вільний cash flow", "Загальні доходи", "Загальні витрати", "Оцінка"], ds: ["Житло", "Їжа", "Транспорт", "Страхування", "Розваги", "Накопичення", "Інше", "Вільне"] },
    { t: "Чиста вартість", s: "Найважливіше число фінансового здоров'я.", d: "Чиста вартість = активи мінус пасиви.", i: ["Нерухомість", "Інвестиції та фонди", "Пенсійні накопичення", "Готівка та ощадні", "Авто та інше", "Іпотека (залишок)", "Споживчі кредити", "Інші борги"], o: ["Чиста вартість", "Загальні активи", "Загальні пасиви"], ds: ["Активи", "Пасиви"] },
    { t: "Податкова економія", s: "Максимальна податкова економія.", d: "Правильно налаштовані продукти можуть заощадити тисячі щорічно.", i: ["Місячна брутто-зарплата", "Страхування життя/міс", "Пенсійне накопичення/міс", "Відсотки іпотеки p.a.", "Пожертви та інші відрахування"], o: ["Податкова економія щорічно", "Загальні відрахування", "Податок без відрахувань", "Податок з відрахуваннями"], ds: ["Страхування", "Пенсія", "Іпотека", "Пожертви"] },
    { t: "Кредитний калькулятор — RPSN", s: "Реальна вартість кредиту з усіма комісіями.", d: "RPSN показує реальну вартість кредиту. Завжди порівнюйте RPSN.", i: ["Сума кредиту", "Процентна ставка", "Місячна комісія", "Термін"], o: ["Щомісячний платіж", "Загальна переплата", "RPSN", "Загалом сплачено"], ds: ["Основна сума", "Відсотки", "Комісії"] },
    { t: "Оцінка фінансового здоров'я", s: "Комплексна оцінка фінансів.", d: "Комплексна оцінка фінансової ситуації у 5 вимірах.", i: ["Ліквідний резерв (місяців)", "Заборгованість (% доходу)", "Норма накопичення (% доходу)", "Страхування", "Інвестиції"], o: ["Загальна оцінка", "Категорія", "Рекомендація"], ds: ["Ваша оцінка"] },
  ],
  s: [null,
    { t: "Mindset & Старт", st: "Основи бізнесу і цінності beplan" },
    { t: "Фінансовий план & Система", st: "Основи фінансового планування і CRM" },
    { t: "Процес продажу & Навички", st: "Від першого дзвінка до підписання договору" },
    { t: "Продукти", st: "Огляд фінансових продуктів" },
    { t: "Кейс-стаді", st: "Реальні приклади з практики" },
    { t: "Просунуто", st: "Експертні теми і керування командою" },
  ],
  cui: {
    mortgageModeling: "Іпотечне моделювання",
    loanSummary: "Підсумок кредиту",
    amortTableTitle: "Графік погашення (за роками)",
    tableYear: "Рік",
    remaining: "Залишається сплатити",
    interestOfWhich: "З того на відсотки",
    disclaimerMortgagePdf: "Розрахунок орієнтовний. Реальна пропозиція банку може відрізнятися залежно від платоспроможності клієнта, LTV та поточних умов ринку. Моделювання не замінює обов’язкову кредитну пропозицію.",
    modelReady: "Моделювання готове",
    pdfFailed: "Не вдалося створити PDF. Спробуй ще раз.",
    narrativeRate: "Розмір платежу й загальну вартість кредиту насамперед визначають відсоткова ставка та строк фіксації — їх варто регулярно порівнювати.",
    narrativeInterest: "За весь строк погашення ви заплатите на відсотках помітно більше, ніж становить сам кредит; коротший строк переплату зменшує.",
    live: "Живий розрахунок",
    exportPdf: "Експорт PDF для клієнта",
    mortgageHeadline: "Скільки коштуватиме твоє <em>власне</em> житло?",
    propertyPrice: "Ціна нерухомості",
    downPayment: "Власні кошти",
    rate: "Процентна ставка",
    years: "Термін виплати",
    yearsUnit: "років",
    monthsUnit: "місяців",
    monthlyPayment: "Щомісячний платіж",
    annuitySub: "Ануїтетний платіж за фіксованою ставкою",
    overpayment: "Переплата",
    overPrincipal: "понад основну суму",
    times: "×",
    loanAmount: "Сума кредиту",
    totalPaid: "Всього сплатите",
    interestPaid: "З яких відсотки",
    ltvLow: "Низький LTV — отримаєте кращу ставку.",
    ltvStd: "Стандартний LTV — без проблем у більшості банків.",
    ltvHigh: "Понад обов’язковий ліміт {limit} — потрібно щонайменше {castka} власних коштів.",
    applicantAge: "Вік позичальника",
    ltvLimit: "Обов’язковий ліміт {regulator}: {limit}.",
    ltvBezVeku: "Без віку діє суворіший ліміт {limit} (молодші 36 років: {mladi}).",
    principal: "Основна сума",
    interest: "Відсотки",
    investmentHeadline: "Де можуть бути твої гроші через <em>X</em> років?",
    monthlyDeposit: "Щомісячний внесок",
    initialAmount: "Початкова сума",
    horizon: "Інвестиційний горизонт",
    expectedReturn: "Очікувана дохідність",
    portfolioValue: "Вартість портфеля",
    deposited: "Внесено",
    earned: "Зароблено на відсотках",
    chartLegendDeposit: "Внески",
    chartLegendValue: "Вартість портфеля",
    disclaimer: "Розрахунок є орієнтовним. Реальна пропозиція банку може відрізнятися.",
    disclaimerInv: "Минула дохідність не гарантує майбутньої. Розрахунок орієнтовний.",
    investmentModeling: "Інвестиційне моделювання",
    oneTimeInvest: "Одноразова інвестиція",
    monthlyInvest: "Щомісячна інвестиція",
    investHorizon: "Планована тривалість інвестування",
    riskProfile: "Ризиковий профіль",
    expectedValue: "Очікувана вартість",
    expectedValueSub: "Очікувана вартість на кінець інвестування",
    optimistic: "Оптимістичний сценарій",
    pessimistic: "Песимістичний сценарій",
    totalDeposited: "Усього внесено",
    today: "Сьогодні",
    yearN: "рік",
    deposit: "Внесок",
    zhodnoceni: "Приріст",
    poslatKlientovi: "Надіслати клієнту",
    rizikoPopis: "Вищий ризиковий профіль може принести вищу дохідність, але й більші коливання вартості. Значення ґрунтуються на історичній дохідності світових ринків акцій.",
    narrativeInv1: "Регулярне інвестування використовує силу складного відсотка — що раніше почнете, то більше на вас працює час.",
    narrativeInv2: "Це модельна оцінка за обраним ризиковим профілем; дохідність не гарантована, а вартість інвестиції з часом коливається.",
  },
  webui: {
    bookNow: "Забронювати",
    bookFree: "Домовитись про безкоштовну зустріч",
    bookMeeting: "Домовитись про зустріч",
    advisorRole: "Твій фінансовий консультант",
    freeSlots: "Вільні терміни цього тижня",
    downloadFree: "Завантажити безкоштовно",
    services: "Послуги",
    scroll: "гортати",
    readyToTalk: "Готовий поговорити?",
    firstMeetingFree: "Перша зустріч безкоштовна · 30 хвилин онлайн",
    webNotFound: "Сайт не знайдено або він не опублікований.",
    loadingError: "Помилка завантаження",
    backHome: "Назад на beplan University",
    retry: "Спробувати ще раз",
    webLoadFailed: "Сайт зараз не вдалося завантажити. Перевірте підключення та спробуйте ще раз.",
    lmEmailLabel: "Е-пошта",
    bookingMeta: "Онлайн через Google Meet · Безкоштовно і без зобов'язань · Триває близько 30 хвилин",
    bookingHint: "Перша зустріч безкоштовна. Достатньо обрати термін і підготувати свої запитання.",
    bookSlotBtn: "Забронювати термін",
    // елементи керування (a11y)
    musicPlay: "Увімкнути музику",
    musicMute: "Вимкнути звук",
    themeToDark: "Перемкнути на темний",
    themeToLight: "Перемкнути на світлий",
    playIntroVideo: "Увімкнути інтро відео",
    whatsappWrite: "Написати у WhatsApp",
    // секції
    servicesHeading: "З чим я вмію допомогти",
    aboutEyebrow: "Про мене",
    dayEyebrow: "День зі мною",
    dayHeading: "Ось так виглядає мій день",
    testimonialsEyebrow: "Відгуки",
    testimonialsHeading: "Що кажуть клієнти",
    testimonialItem: "Відгук",
    testimonialPrev: "Попередній відгук",
    testimonialNext: "Наступний відгук",
    quoteOpen: "«",
    quoteClose: "»",
    bookingEyebrow: "Бронювання",
    bookingHeading: "Оберіть термін зустрічі",
    bookingInactive: "Онлайн бронювання поки не активне. Зв'яжіться з консультантом напряму:",
    faqHeading: "Найчастіші запитання",
    partnersLabel: "Співпрацюю з",
    finalCtaHeading: "Поговорімо",
    writeEmail: "Написати email",
    digitalCard: "Цифрова візитка",
    privacy: "Приватність",
    madeIn: "Створено в beplan University",
    prev: "Попереднє",
    next: "Далі",
    close: "Закрити",
    storyPrev: "Попередня історія",
    storyNext: "Наступна історія",
    storyItem: "Історія",
    // перебіг співпраці
    processEyebrow: "Як відбувається співпраця",
    processHeadingSuffix: "до зрозумілих фінансів",
    processScrollHint: "Гортайте вниз – картки пливуть праворуч",
    processNextStep: "Наступний крок",
    stepOne: "крок",
    stepFew: "кроки",
    stepMany: "кроків",
    step1Title: "Перший контакт",
    step1Desc: "Достатньо натиснути бронювання або зателефонувати. Обговоримо, що вас турбує.",
    step2Title: "Аналіз вашої ситуації",
    step2Desc: "Безкоштовно складу огляд – де ви, що маєте, чого бракує.",
    step3Title: "Пропозиція плану",
    step3Desc: "Отримаєте конкретні кроки під себе – іпотека, страхування, інвестиції.",
    step4Title: "Впровадження",
    step4Desc: "Оформлю за вас папери, банки і страхові. Ви займаєтесь своєю роботою.",
    step5Title: "Річний перегляд",
    step5Desc: "Раз на рік разом дивимось, як працює план і що скоригувати.",
    // історії клієнтів
    storiesEyebrow: "Історії клієнтів",
    storiesHeading: "Як я їм допоміг",
    storiesSubtitle: "Конкретні ситуації. Конкретні рішення. Конкретні результати.",
    storyClient: "Клієнт",
    storyProblem: "Ситуація",
    storySolution: "Що ми зробили",
    storyResult: "Результат",
    storyCta: "Хочу подібний результат для себе",
    galleryEyebrow: "Галерея",
    galleryHeading: "За лаштунками",
    galleryPhotoAlt: "Фото {n}",
    blogEyebrow: "Блог",
    blogHeading: "Поради та думки",
    blogRead: "Читати статтю",
    blogLoading: "Завантажую…",
    blogLoadError: "Не вдалося завантажити статтю.",
    // лід-магніт
    lmBadge: "Завантаж безкоштовно",
    lmInstant: "Одразу до завантаження",
    lmNoSpam: "Жодного спаму",
    lmDone: "Готово",
    lmDoneDesc: "PDF завантажено. Перевірте також свою пошту.",
    lmNamePh: "Ваше ім'я (необов'язково)",
    lmEmailPh: "tvuj@email.cz",
    lmDownloading: "Завантажую…",
    lmDownload: "Завантажити PDF безкоштовно",
    lmPrivacy: "Ваші дані використовую лише для надсилання PDF. Ніколи не спамлю.",
    lmInvalidEmail: "Введіть дійсний email",
    lmSuccess: "PDF завантажено + ми надіслали його вам на пошту",
    lmError: "Не вдалося завантажити",
    // калькулятори на сайті консультанта
    calcEyebrow: "Порахуйте без зобов'язань",
    calcHeading: "Спробуйте мої калькулятори",
    calcSubtitle: "Просто, швидко, без реєстрації. Отримайте перші відповіді за хвилину.",
    calcCompare: "Порівняння",
    calcBookCta: "Хочу точний розрахунок на зустрічі",
    calcReset: "Спробувати інші значення",
    calcDisclaimer: "Орієнтовний розрахунок. Точні числа рахую на зустрічі – безкоштовно і без зобов'язань.",
    calcUnitBn: "млрд",
    calcUnitM: "млн",
    calcUnitK: "тис",
    calcUnitYears: "років",
    calcUnitPa: "% p.a.",
    calcUnitCount: "",
    // калькулятор: іпотека
    calcHypoTitle: "Іпотечний калькулятор",
    calcHypoTagline: "Порахуйте щомісячний платіж",
    calcHypoHint: "За 60 секунд знаєте, скільки заплатите",
    calcHypoAmount: "Сума кредиту",
    calcHypoRate: "Процентна ставка",
    calcHypoYears: "Термін виплати",
    calcHypoSubmit: "Порахувати щомісячний платіж",
    calcHypoResult: "Ваш щомісячний платіж становитиме",
    calcHypoSubtitle: "Загалом за {years} {yearsUnit} заплатите {total}",
    calcHypoContext: "Орієнтовний розрахунок за рівномірним ануїтетом. Точна ставка залежить від LTV, кредитоспроможності (bonita) та поточних ставок.",
    calcHypoBank: "Середній банк ({rate} %)",
    calcHypoMine: "З моєю допомогою ({rate} %)",
    calcHypoSavings: "Економія {amount}",
    // калькулятор: інвестиції
    calcInvestTitle: "Інвестиції",
    calcInvestTagline: "Скільки заробите в довгій перспективі?",
    calcInvestHint: "Складний відсоток вас здивує",
    calcInvestMonthly: "Щомісяця відкладаю",
    calcInvestYears: "Інвестиційний горизонт",
    calcInvestRate: "Очікувана дохідність",
    calcInvestSubmit: "Порахувати майбутню вартість",
    calcInvestResult: "За {years} {yearsUnit} матимете",
    calcInvestSubtitle: "З них ваші внески: {deposited}",
    calcInvestContext: "Розрахунок припускає стабільну середню дохідність – насправді вона різнитиметься рік від року.",
    calcInvestBank: "Ощадний рахунок у банку (2 %)",
    calcInvestInvested: "Інвестиції ({rate} %)",
    calcInvestDelta: "На {amount} більше",
    // калькулятор: страхування життя
    calcLifeTitle: "Страхування життя",
    calcLifeTagline: "Скільки покриття справді потрібно",
    calcLifeHint: "Без переплат за зайве",
    calcLifeIncome: "Місячний чистий дохід",
    calcLifeLoans: "Іпотека + кредити разом",
    calcLifeKids: "Кількість дітей",
    calcLifeSubmit: "Порахувати потрібну страхову суму",
    calcLifeResult: "Ви мали б мати покриту страхову суму",
    calcLifeSubtitle: "У разі смерті або постійної інвалідності",
    calcLifeContext: "Ваша родина мала б погашені зобов'язання ({loans}), діти мали б на освіту ({kids}) і 10 років прожили б із заощаджень ({savings}). Більшість людей має покриття у 10× менше – платять за поліс, який нічого не рятує.",
    // калькулятор: фінансова незалежність
    calcFiTitle: "Фінансова незалежність",
    calcFiTagline: "Коли вже можна на пенсію?",
    calcFiHint: "Правило 4 % це покаже",
    calcFiTarget: "Хочу місячний пасивний дохід",
    calcFiCurrent: "Поточні заощадження / інвестиції",
    calcFiYears: "Хочу досягти цього за",
    calcFiRate: "Очікувана дохідність",
    calcFiSubmit: "Порахувати мій шлях до незалежності",
    calcFiResult: "Для фінансової незалежності потрібно накопичити",
    calcFiSubtitle: "Достатньо щомісяця відкладати {monthly} протягом {years} {yearsUnit}",
    calcFiSubtitleDone: "Вітаю – ваші поточні заощадження впораються самі за {years} {yearsUnit} 🎉",
    calcFiContext: "За правилом 4 % річного вилучення цей капітал генеруватиме {annual} на рік ({monthly} на місяць) практично назавжди – без зменшення основної суми.",
  },
  webtpl: {
    universal: {
      headline: "Ваші фінанси під контролем.",
      subheadline: "Допомагаю клієнтам налаштувати фінанси так, щоб більше не боятися майбутнього – іпотека, інвестиції, страхування і пенсія.",
      s1Title: "Іпотека", s1Desc: "Знайду найвигіднішу іпотеку серед усіх банків і проведу вас через увесь процес.",
      s2Title: "Інвестиції", s2Desc: "Складу портфель під ваші цілі та ризиковий профіль.",
      s3Title: "Страхування", s3Desc: "Захист для родини, майна і доходу. Без зайвих договорів.",
      s4Title: "Пенсія", s4Desc: "Покажу, скільки треба відкладати, щоб мати комфортну пенсію.",
    },
    family: {
      headline: "Фінанси для родини, яка хоче спокою.",
      subheadline: "Дбаю про родини, щоб вони мали ясність – що застраховано, куди відкладати дітям і як спокійно прожити пенсію.",
      s1Title: "Захист родини", s1Desc: "Страхування життя і від нещасних випадків, яке справді захищає – а не лише збирає гроші.",
      s2Title: "Накопичення для дітей", s2Desc: "Як почати – і скільки достатньо – щоб діти у 18 мали опору.",
      s3Title: "Житло", s3Desc: "Іпотека, страхування нерухомості, рефінансування.",
      s4Title: "Здоров'я", s4Desc: "Приватне медичне страхування, якщо хочете швидшу допомогу.",
    },
    mortgage: {
      headline: "Іпотека без стресу. Зроблю все за вас.",
      subheadline: "13+ років досвіду. Порівняю пропозиції всіх банків, домовлюсь про ставку і проведу від заявки до видачі коштів.",
      s1Title: "Нова іпотека", s1Desc: "Від квартири до приватного будинку. Оформлю папери за вас.",
      s2Title: "Рефінансування", s2Desc: "Заощаджуйте тисячі щомісяця, перейшовши в банк з кращими умовами.",
      s3Title: "Калькулятор", s3Desc: "Порахуємо, скільки ви можете позичити і під яку ставку.",
      s4Title: "Безкоштовна консультація", s4Desc: "Перша зустріч нічого не коштує – оцінимо вашу ситуацію.",
    },
    corporate: {
      headline: "Корпоративні фінанси без зайвої складності.",
      subheadline: "Допомагаю власникам компаній і менеджерам структурувати винагороду, бенефіти для працівників та власні інвестиції.",
      s1Title: "Бенефіти для працівників", s1Desc: "Пенсійне, страхування життя, талони на харчування – податково ефективно.",
      s2Title: "Винагорода власника", s2Desc: "Оптимальний мікс зарплата/дивіденд/бенефіт для власника s.r.o.",
      s3Title: "Корпоративні інвестиції", s3Desc: "Як заробити на вільних коштах у компанії.",
      s4Title: "Страхування відповідальності", s4Desc: "D&O, кіберстрахування, страхування майна компанії.",
    },
    investments: {
      headline: "Побудова капіталу. Довгостроково. Дисципліновано.",
      subheadline: "Інвестиційний портфель на основі даних, низьких витрат і ваших цілей – а не обіцянок гарантованих 20 % на рік.",
      s1Title: "Глобальний портфель", s1Desc: "Диверсифікація між ринками, валютами та класами активів.",
      s2Title: "Цільове інвестування", s2Desc: "Квартира, пенсія, освіта дітей – для кожної цілі своя стратегія.",
      s3Title: "Ребалансування", s3Desc: "Регулярне обслуговування портфеля, щоб він працював на вас.",
      s4Title: "Фінансовий коучинг", s4Desc: "Навчу вас думати про гроші системно.",
    },
  },
  klienti: {
    srcDoporuceni: 'Рекомендація',
    srcInzerat: 'Оголошення',
    srcJine: 'Інше',
    srcNabor: 'Рекрутинг',
    srcNavolavka: 'Обдзвін через Beplan',
    srcTipar: 'Через рекомендувача',
    srcVlastni: 'Власне коло',
    crm: "CRM",
    title: "Клієнти",
    segmentace: "Сегментація",
    segmDesc: "золото, платина, бронза, стандарт.",
    pipelineView: "Pipeline view",
    smartOnboarding: "Smart Onboarding",
    manual: "Додати нового клієнта",
    advanced: "Розширено",
    search: "Знайдіть клієнта за іменем, телефоном, e-mail або містом…",
    totalClients: "клієнтів усього",
    active: "активних",
    signedMonth: "підписано цього місяця",
    pipelineFull: "Pipeline view (KPI, лійка, етапи)",
    noContact: "Без контакту",
    fAll: "Усе",
    fActive: "Активні",
    fStagnation: "Стагнація 14+",
    fSigned: "Підпис цього місяця",
    fNoContact: "Без контакту 30+",
    fParked: "Без інтересу",
    colClient: "Клієнт",
    colPhase: "Етап",
    colDays: "Днів",
    colBj: "BJ",
    colAction: "ДІЯ",
    loading: "Завантажую…",
    noClients: "Немає клієнтів",
    mNew: "Новий клієнт",
    mSmartAdd: "Дублікати перевіряю на ходу — за іменем, телефоном, e-mail та IČO.",
    mIdent: "Ідентифікація",
    mName: "Ім'я *", mSurname: "Прізвище", mPhone: "Телефон", mEmail: "Email",
    mCity: "Місто", mAge: "Вік", mIco: "IČO (необов'язково)", mCompany: "Фірма / ФОП (OSVČ)",
    mCheckingDup: "Шукаю дублікати…",
    mSegSource: "Сегментація та джерело",
    mDisc: "Типологія DISC (Pavel Procházka)",
    mRecruit: "Кандидат на рекрутинг (у команду консультантів)",
    mNotePh: "Контекст, де ви познайомились, ключова інформація…",
    mCancel: "Скасувати",
  },
  obchody: {
    addDealToPhase: 'Додати угоду до етапу',
    addToPhase: 'Додати до етапу',
    awaitingPayout: 'очікує на виплату',
    dealFew: 'угоди',
    dealMany: 'угод',
    dealOne: 'угода',
    phaseOfTotal: 'Етап {poradi} з {celkem}',
    progressLeftRight: 'Хід угоди зліва направо',
    weighted: 'зважено',
    label: "Угоди",
    caseOne: "випадок", caseFew: "випадки", caseMany: "випадків",
    boardPre: "Дошка", boardEm: "угод",
    subtitle: "BJ у pipeline · колір картки = тип продукту · перетягніть картку на Виграш/Програш/Скасовано",
    newDeal: "Нова угода",
    search: "Шукати угоду, клієнта…",
    fAll: "Усе", fHypo: "Іпотека", fLoans: "Кредити", fInsur: "Страхування", fInv: "Інвестиції", fPension: "Пенсія",
    fReality: "Нерухомість",
    kanban: "Канбан", table: "Таблиця",
    loading: "Завантажую угоди…",
    unknownClient: "Невідомий клієнт",
    stale: "без активності", activeDeal: "активна",
    modalTitle: "Новий торговий випадок", whatAbout: "Чого це стосується", clientFromCard: "Клієнт з картки",
    clientSearchPh: "Введіть ім'я клієнта, телефон або e-mail…", productType: "Тип продукту *", provider: "Постачальник",
    dealName: "Назва угоди *", dealNamePh: "Введіть назву угоди", phase: "Етап", estBj: "Оцінка BJ", valueCur: "Вартість",
    note: "Примітка", cancel: "Скасувати", create: "Створити угоду", selectClient: "Оберіть клієнта", cantCreate: "Не вдалося створити угоду",
  },
  /* Realitni obchod ve slozce klienta (components/crm/RealityVeSlozce.js
     + realitni rezim v NewDealModal). Prodavajici a kupujici maji jiny obsah,
     proto jsou popisky oddelene od `zakazky`, ktere mluvi na kartu zakazky. */
  realSlozka: {
    kterouNemovitostVolitelne: 'Яка нерухомість (необовʼязково)',
    zatimNevybrano: 'Ще не вибрано',
    otevritPoptavku: 'Відкрити запит',
    prodejNem: "Продаж нерухомості",
    koupeNem: "Купівля нерухомості",
    nadpisProdej: "Продає",
    nadpisKoupe: "Купує",
    bezAdresy: "Без адреси",
    cenaChybi: "ціну не вказано",
    veFaziNeznamo: "На цьому етапі — невідомо відколи",
    bezObchodu: "У цієї заявки немає угоди, етап визначити не можна.",
    koupeBezObchodu: "Без угоди — є лише резерваційний договір.",
    zajemcu: "Зацікавлені",
    pristiProhlidka: "Найближчий огляд",
    zadnaProhlidka: "Поки що немає дати",
    prihlaseno: "записалося",
    majitelOdkaz: "Сторінка для власника",
    majitelOdkazSub: "Він сам побачить, на якому ми етапі й що робимо для продажу.",
    majitelChybi: "Ще не створено — створіть на картці заявки.",
    odkazPropadly: "недійсне",
    otevrit: "Відкрити",
    kopirovat: "Скопіювати посилання",
    zkopirovano: "Посилання скопійовано",
    nezkopirovano: "Скопіювати не вдалося — виділіть посилання вручну.",
    otevritZakazku: "Відкрити заявку",
    otevritObchod: "Відкрити угоду",
    zajemciAProhlidky: "Зацікавлені та огляди",
    inzeratOtevrit: "Відкрити оголошення",
    inzeratSkryty: "Оголошення (поки лише для вас)",
    provize: "Комісія з продажу",
    provizeNenastavena: "не налаштовано",
    postupZajemce: "Крок",
    rezervace: "Резерваційний договір",
    rezervacePodepsana: "Підписаний",
    rezervaceRozepsana: "Складений, не підписаний",
    rezervaceZadna: "Поки немає",
    rezervaceSepsat: "Скласти резерваційний договір",
    rezervaceOtevrit: "Відкрити резерваційний договір",
    hypoteka: "Іпотека",
    hypotekaZadna: "Іпотечної справи немає",
    hypotekaZalozit: "Створити іпотеку",
    nemovitostNeznama: "Нерухомості вже немає в системі",
    predani: "Передача контакту",
    predaniSub: "Передача контакту іншому розпоряднику — це обробка персональних даних. Відбувається лише за згодою і залишається тут записаною.",
    predaniTy: "Ви",
    predaniNekdo: "Хтось із команди",
    predaniPoradce: "Радник",
    souhlasDan: "Згоду надано",
    souhlasNeznamy: "Згода без запису часу",
    vzniklObchod: "Виникла угода",
    vzniklObchodJinde: "Радник створив справу",
    vzniklObchodNe: "Угоди з цього поки не вийшло",
    odmena: "Частка",
    odmenaNenastavena: "Винагороду не налаштовано — доки не оберете базу та ставку, ніхто не знає суми.",
    chyba: "Розділ нерухомості не завантажився. Угоди нижче в порядку.",
    adresa: "Адреса нерухомості",
    adresaPlaceholder: "Адреса нерухомості — Kotlářská 12, Brno",
    adresaChybi: "Напишіть адресу нерухомості",
    typNemovitosti: "Тип нерухомості",
    cenaNabidkova: "Ціна пропозиції",
    kterouNemovitost: "Яку нерухомість",
    vyberNemovitost: "Оберіть нерухомість",
    zadnaNemovitost: "У вас немає жодної заявки",
    nacitamNemovitosti: "Завантажую…",
    nemovitostiChyba: "Нерухомість не завантажилася",
    koupePrefix: "Купівля —",
    koupeFaze0: "Звернувся",
    koupeFaze1: "Огляд призначено",
    koupeFaze2: "Був на огляді",
    koupeFaze3: "Серйозний інтерес",
    koupeFaze4: "Резервація",
    koupeFaze5: "Договір купівлі",
    koupeFaze6: "Передача",
    predavkaStav: {
      navrzena: "Запропоновано",
      odeslana: "Надіслано",
      prijata: "Прийнято",
      odmitnuta: "Відхилено",
      propadla: "Прострочено",
    },
  },
  dealmeta: {
    board: {
      analyza: "Фін. аналіз / Запропоновано",
      proces: "Заявка / В процесі",
      podpis: "Схвалення / Підпис",
      cerpani: "Видача коштів (čerpání) / Чекаю на комісію",
    },
    products: {
      hypoteka: "Іпотека", refinancovani: "Рефінансування", podnikatelsky_uver: "Бізнес-кредит",
      spotrebitelsky_uver: "Споживчий кредит", uver: "Кредит", pojisteni_zivot: "Життя", pojisteni_auta: "Авто",
      pojisteni_majetek: "Майно", investice: "Інвестиції", penzijko: "Пенсія", stavebni: "Будівельне накопичення (stavební spoření)", jine: "Інше",
      prodej_nemovitosti: "Продаж нерухомості", koupe_nemovitosti: "Купівля нерухомості",
    },
  },
  /* BLOK:bilanceFlag START — generuje scratchpad/slovnik.py, ručně needitovat */
  bilanceFlag: {
    cfNegative: 'Витрати та платежі перевищують дохід на {castka}/міс',
    dstiHigh: 'Високе боргове навантаження — платежі {pct} % доходу (рекомендація ЧНБ до {max} %)',
    dstiHighBezRegulatora: 'Високе боргове навантаження — платежі {pct} % доходу',
    kidsNoLife: 'Родина з дітьми — перевірте страхування життя (захист доходу)',
    reserveLow: 'Ліквідного резерву лише на {n} міс. — ідеал 6× витрат',
    reserveMid: 'Резерву на {n} міс. — доповніть до 6×',
    reserveOk: 'Резерву на {n} міс. ✓',
  },
  /* BLOK:bilanceFlag END */
  bilancePanel: {
    title: "Живий баланс",
    close: "Закрити",
    netWorth: "Чисті активи",
    assets: "Активи",
    debts: "Борги",
    zTohoFinNefin: "з них фінансові {fin} · нефінансові {nefin}",
    month: "Щомісяця",
    income: "Доходи",
    expenses: "Витрати",
    repayments: "Платежі",
    free: "Вільні",
    deficit: "Дефіцит",
    notEntered: "не введено",
    perMonth: "/міс",
    reserve: "Ліквідний резерв",
    reserveUnit: "× витрат",
    dsti: "Боргове навантаження (DSTI)",
    /* Země bez závazného verdiktu DSTI (SK): jiná definice než NBS — AP-08, 19. 10. 2026. */
    dstiBezRegulatora: "Виплати за кредитами / чистий дохід",
    savingRate: "Норма відкладання",
    cil: {
      reserve: "рекомендовано {cil}×",
      dsti: "рекомендація ЧНБ до {max} %",
      saving: "ідеал {ideal} %",
    },
    stav: {
      reserveLow: "низький резерв",
      reserveMid: "доповніть до {cil}×",
      reserveOk: "виконано",
      dstiOk: "у нормі",
      dstiHigh: "вище рекомендації",
      dstiHighBezRegulatora: "високе боргове навантаження",
    },
    aria: {
      jmeni: "Чисті активи {ciste}: активи {majetek}, борги {dluhy}",
      mesic: "Щомісяця доходи {prijmy}: витрати {vydaje}, платежі {splatky}, вільні гроші {volne}",
      mesicSchodek: "Щомісяця доходи {prijmy}: витрати {vydaje} і платежі {splatky} перевищують їх на {schodek}",
    },
    chipNetWorth: "Чисті активи",
    chipFreeCf: "Вільний ГП",
  },
  kompletnost: {
    jmeno: "Ім'я та прізвище клієнта",
    narozeni: "Дата народження (вік)",
    kontakt: "Контакт (телефон / e-mail)",
    cil: "Щонайменше одна мета із сумою",
    prijmy: "Доходи домогосподарства",
    vydaje: "Звичайні місячні витрати",
    rezerva: "Ліквідний резерв (рахунки / готівка)",
    investice: "Інвестиції / накопичення",
    rizika: "Страхування / ризики",
  },
  crmdash: {
    greetMorning: "Доброго ранку", greetAfternoon: "Доброго дня", greetEvening: "Доброго вечора",
    kObvolani: "{n} до обдзвону",
    poTerminuOne: "{n} завдання прострочено", poTerminuFew: "{n} завдання прострочено", poTerminuMany: "{n} завдань прострочено",
    otevrenychUkoluOne: "{n} відкрите завдання", otevrenychUkoluFew: "{n} відкриті завдання", otevrenychUkoluMany: "{n} відкритих завдань",
    podpisuOne: "{n} підпис цього місяця", podpisuFew: "{n} підписи цього місяця", podpisuMany: "{n} підписів цього місяця",
    bezPodpisu: "цього місяця ще без підпису", cistyStul: "Сьогодні нічого не чекає — чистий стіл.",
    cipSplneno: "План виконано", cipVTempu: "У темпі", cipZbyvaBj: "Залишилось {n} BJ", cipBezPlanu: "Без плану",
    cipPrazdnaPipeline: "Нічого в роботі", cipPoTerminu: "{n} прострочено", cipNicPoTerminu: "Нічого простроченого", cipVolno: "Немає завдань",
    metrPlneni: "Виконання місячного плану BJ", metrMesic: "Минула частина місяця",
    rozvrzeni: "Розкладка", rozvrzeniKlasicke: "Класична", rozvrzeniDenMesic: "День → Місяць", sekceDnes: "Сьогодні", sekceMesic: "Місяць",
    monthProgress: "Прогрес місяця", day: "день", of: "з",
    kpiBj: "BJ цього місяця", planNotSet: "План не встановлено", plan: "План",
    kpiProvize: "Комісія за місяць", coef: "Коеф.",
    kpiPipeline: "Активний pipeline", openDeals: "відкритих угод", contactsTotal: "контактів усього",
    kpiTasks: "Завдання до виконання", noTasks: "Немає завдань", doneOf: "виконано з",
    dealsPipeline: "Торговий pipeline", openBoard: "Відкрити дошку", loadingDeals: "Завантажую угоди…", noDeals: "Немає угод", more: "інших",
    todayCalls: "Сьогодні обдзвонити", upcomingTasks: "Найближчі завдання", stageDistribution: "Розподіл етапів",
    leadSources: "Джерела лідів", noData: "Немає даних", pipelineByStage: "Pipeline за етапами", recentActivity: "Остання активність",
    callAction: "Подзвонити", meetingAction: "Зустріч", noInterestAction: "Без інтересу",
    funnelCalling: "Дзвінки", funnelSigned: "Підпис",
    saved: "Збережено", saveFailed: "Не вдалося зберегти", loadFailed: "Не вдалося завантажити дані CRM",
    noTasksYet: "Немає завдань", noCallsToday: "Сьогодні нікому дзвонити", inPipeline: "У pipeline",
    subtitle: "Огляд портфеля, щоденника та клієнтів — в одному місці.",
    openDiary: "Відкрити щоденник", adviser: "Консультант", adviserRole: "Консультант",
    topClients: "Топ клієнти за AUM", topClientsSub: "Ваші найсильніші портфелі", allClients: "Усі",
    kpiClients: "Клієнти", kpiClientsHint: "Активний портфель", kpiVip: "VIP", kpiVipHint: "Золотий рівень",
    kpiWeek: "Цього тижня", kpiWeekHint: "Запланованих зустрічей", kpiAum: "AUM / BJ", kpiAumHint: "Під управлінням",
    noTopClients: "Поки немає клієнтів",
    bulkToday: "На сьогодні",
    bulkWeek: "На тиждень",
    bulkTodayHint: "Перенести всі прострочені завдання на сьогодні",
    bulkWeekHint: "Відкласти всі прострочені завдання на тиждень",
    bulkConfirmToday: "Перенести {n} прострочених завдань на сьогодні?",
    bulkConfirmWeek: "Відкласти {n} прострочених завдань на тиждень?",
    bulkRunning: "Переношу…",
    bulkDoneOne: "Перенесено {n} завдання",
    bulkDoneFew: "Перенесено {n} завдання",
    bulkDoneMany: "Перенесено {n} завдань",
    bulkPartial: "{ok} перенесено, {err} не вдалося",
    bulkFailed: "Не вдалося перенести завдання",
  /* PANELY NÁSTĚNKY — dřív mapy PANEL_*_SK v pages/crm/CRMDashboardPage.js,
     které uměly jen cs+sk (Vietnamec i Ukrajinec dostal češtinu). */
  panelKat: {
    vse: 'Усе',
    prehledy: 'Швидкі огляди',
    obchod: 'Угоди',
    klienti: 'Клієнти та сервіс',
    nastroje: 'Інструменти',
  },
  panel: {
    zrcadlo: {
      title: 'Дзеркало дзвінків — кому дзвонити сьогодні',
      desc: 'Черга дзвінків: хто чекає найдовше, звідки лід, дзвінок одним кліком.',
      helpLabel: 'Дзеркало дзвінків',
      helpText: 'Хто чекає на дзвінок — та сама черга, що й сторінка Дзеркало дзвінків, лише скорочена. Угорі скільки людей чекає, під тим п’ятеро тих, хто чекає найдовше (хто чекає найдовше, той перший), біля кожного джерело ліда і телефон. Подзвонити відкриє телефон, Домовлено переведе контакт на етап Представлення і він зникне з черги.',
    },
    brifink: {
      title: 'Ранковий брифінг',
      desc: 'Що сьогодні · що прострочено · що готово · що попереду.',
      helpLabel: 'Ранковий брифінг',
      helpText: 'Чотири питання в одному місці: що сьогодні, що прострочено, що готово, що попереду. Біля позиції видно клієнта та угоду, якої вона стосується. Усе зі щоденника, клієнтів і угод — якщо нічого немає, секція так і скаже. Біля позиції: + додати до плану, годинник відкласти на потім, × прибрати з сьогоднішнього брифінгу.',
    },
    diar: {
      title: 'Щоденник — тиждень',
      desc: 'Зустрічі та завдання на цілий тиждень в одному місці.',
      helpLabel: 'Щоденник — тиждень',
      helpText: 'Зустрічі та завдання цілого тижня. Число біля дня = кількість завдань; клік відкриє щоденник.',
    },
    radar: {
      title: 'Сервісний радар',
      desc: 'Клієнти, у яких наближається сервісна зустріч.',
      helpLabel: 'Сервісний радар',
      helpText: 'Клієнти, у яких наближається кінець фіксації ставки, річниця або дожиття — кому варто зателефонувати щодо сервісу.',
    },
    prilezitosti: {
      title: 'Радар можливостей',
      desc: 'Прогалини в портфелі та можливості для звернення.',
      helpLabel: 'Радар можливостей',
      helpText: 'Прогалини в портфелях клієнтів, упорядковані за оцінкою — де найбільша можливість для звернення.',
    },
    kpi: {
      title: 'Плитки KPI',
      desc: 'Ключові числа місяця: BJ, комісія, pipeline, завдання.',
      helpLabel: 'Плитки KPI',
      helpText: 'Ключові числа місяця (BJ, комісія, pipeline, завдання). Клік на плитці відкриє деталі в Угодах або Щоденнику.',
    },
    pipeline: {
      title: 'Торговий pipeline',
      desc: 'Угоди, розподілені за етапами pipeline.',
      helpLabel: 'Торговий pipeline',
      helpText: 'Відкриті угоди за етапами (аналіз → виплата) разом зі зваженим прогнозом комісій. Клік → Угоди.',
    },
    akce: {
      title: 'Потребує дії сьогодні',
      desc: 'Що горить сьогодні й чекає на вашу дію.',
      helpLabel: 'Потребує дії сьогодні',
      helpText: 'Черга на сьогодні: прострочені завдання й угоди без запланованого наступного кроку. Клік → деталі.',
    },
    volani: {
      title: 'Сьогодні обдзвонити',
      desc: 'Контакти, яким сьогодні треба подзвонити.',
      helpLabel: 'Сьогодні обдзвонити',
      helpText: 'Контакти для обдзвону за пріоритетом VIP → A → B → C. Кнопки: телефон = подзвонити · ✓ зустріч домовлено · ✗ не зацікавлений.',
    },
    ukoly: {
      title: 'Найближчі завдання',
      desc: 'Найближчі завдання, упорядковані за терміном.',
      helpLabel: 'Найближчі завдання',
      helpText: 'Найближчі невиконані завдання за терміном. Клік → Щоденник.',
    },
    emaily: {
      title: 'Е-мейли',
      desc: 'Непрочитані е-мейли прямо на панелі.',
      helpLabel: 'Е-мейли',
      helpText: 'Останні непрочитані е-мейли з підключеного Gmailu. Клік → Пошта.',
    },
    klienti: {
      title: 'Остання активність клієнтів',
      desc: 'Останній рух у ваших клієнтів.',
      helpLabel: 'Клієнти',
      helpText: 'Нещодавно змінені клієнти — швидкий доступ до картки. Клік → Клієнти.',
    },
    topklienti: {
      title: 'Топ клієнти за AUM',
      desc: 'Найцінніші клієнти за обсягом активів.',
      helpLabel: 'Топ клієнти за AUM',
      helpText: 'Найцінніші клієнти за обсягом активів (BJ). Клік → Клієнти.',
    },
    faze: {
      title: 'Розподіл етапів',
      desc: 'Розподіл контактів за етапом угоди.',
      helpLabel: 'Розподіл етапів',
      helpText: 'Кількість контактів на кожному етапі угоди — де накопичується робота.',
    },
    zdroje: {
      title: 'Джерела лідів',
      desc: 'Звідки до вас приходить найбільше лідів.',
      helpLabel: 'Джерела лідів',
      helpText: 'Звідки до вас приходить найбільше контактів (лідогенератор, рекомендації, сайт…).',
    },
    nastroje: {
      title: 'Швидкі інструменти',
      desc: 'Швидкі скорочення до калькуляторів та інструментів.',
      helpLabel: 'Швидкі інструменти',
      helpText: 'Скорочення до калькуляторів та інструментів, поділені на категорії.',
    },
    poznamky: {
      title: 'Нотатки',
      desc: 'Чистий аркуш для швидких нотаток з мітками.',
      helpLabel: 'Нотатки',
      helpText: 'Чистий аркуш на будь-що — текст зберігається сам. Міткою нотатки розсортуєте, а вгорі за нею фільтруєте.',
    },
    vyvoj: {
      title: 'Динаміка угод',
      desc: 'Динаміка закритих угод у часі.',
      helpLabel: 'Динаміка угод',
      helpText: 'Закриті угоди в часі — тренд підписаних BJ по місяцях. Період перемикається кнопками.',
    },
    plan: {
      title: 'Виконання плану',
      desc: 'Наскільки ви близько до місячного плану BJ.',
      helpLabel: 'Виконання плану',
      helpText: 'Наскільки ви близько до місячного плану BJ; стрілка показує % виконання та оцінку комісії.',
    },
    trychtyr: {
      title: 'Воронка продажів',
      desc: 'Скільки у вас в роботі на кожному етапі.',
      helpLabel: 'Воронка продажів',
      helpText: 'Скільки угод і BJ у вас на кожному етапі та скільки вони там у середньому лежать.',
    },
  },
  },
  /* BLOK:diar START — generuje scratchpad/slovnik.py, ručně needitovat */
  diar: {
    activity: 'Активність',
    agenda: 'Список',
    agendaSub: 'Список активностей',
    agendaTitle: 'Найближчі',
    allDay: 'Цілий день',
    calls: 'дзвінків',
    dFri: 'Пт',
    dMon: 'Пн',
    dSat: 'Сб',
    dSun: 'Нд',
    dThu: 'Чт',
    dTue: 'Вт',
    dWed: 'Ср',
    day: 'День',
    days: 'днів',
    editActivity: 'Редагування активності',
    filters: 'Фільтри',
    hintKlik: 'Клацни в сітку',
    hintKlikZbytek: '— і швидко створиш подію.',
    hintTah: 'Перетягуванням',
    hintTahZbytek: 'переміщуєш, а тягнучи за нижній край змінюєш тривалість.',
    m01: 'січень',
    m02: 'лютий',
    m03: 'березень',
    m04: 'квітень',
    m05: 'травень',
    m06: 'червень',
    m07: 'липень',
    m08: 'серпень',
    m09: 'вересень',
    m10: 'жовтень',
    m11: 'листопад',
    m12: 'грудень',
    meetings: 'зустрічей',
    month: 'Місяць',
    monthOverview: 'Місячний огляд',
    newActivity: 'Нова активність',
    nextWeek: 'Наступний тиждень',
    prevWeek: 'Попередній тиждень',
    refreshed: 'Щоденник оновлено',
    sync: 'Синхронізація',
    tDopis: 'Лист',
    tEmail: 'Email',
    tSchuzka: 'Зустріч',
    tTelefonat: 'Дзвінок',
    tUdalost: 'Подія',
    tUkol: 'Завдання',
    tasks: 'завдання',
    tip: 'Порада',
    today: 'Сьогодні',
    week: 'Тиждень',
    weekNo: 'тиждень',
  },
  /* BLOK:diar END */
  hypo: {
    active: "Активних", waitOdhad: "Чекає на оцінку (odhad)", naKatastru: "У кадастрі (katastr)", blizkoCerpani: "Близько до видачі коштів", cerpanoMesic: "Видано (місяць)",
    search: "Шукати іпотеку…", colClient: "Клієнт", colBank: "Банк", colPhase: "Етап процесу", colWaiting: "Чекає на", colNextStep: "Наступний крок", aiWatch: "AI СТЕЖИТЬ", colAmount: "Сума / LTV", loading: "Завантажую іпотеки…", shown: "Показано", activeMortgages: "активних іпотек",
  },
  deal: {
    notFound: "Угоду не знайдено", dealValue: "Вартість угоди", caseProgress: "Прогрес справи",
    save: "Зберегти", edit: "Редагувати", nextStep: "Наступний крок справи",
    subject: "Предмет", price: "Ціна", ownFunds: "Власний внесок", note: "Примітка",
    purchasePrice: "Ціна купівлі", ownResources: "Власні кошти", monthlyPayment: "Щомісячний платіж",
    keyParam: "Ключовий параметр", keyPh: "Ключ (напр. LTV)", valuePh: "Значення",
    people: "Люди у справі", addRole: "Швидко додати роль",
    resWon: "Виграш", resLost: "Програш", resCancelled: "Скасовано", resOpen: "В процесі",
    cantSave: "Не вдалося зберегти", cantChangeStage: "Не вдалося змінити етап", cantAddNote: "Не вдалося додати примітку",
    cantWin: "Не вдалося підтвердити виграш", error: "Помилка", cancelled: "Скасовано", deleted: "Видалено",
    roleRealitni: "Ріелтор", roleProdejce: "Продавець", roleKupujici: "Покупець", roleOdhadce: "Оцінювач (odhadce)",
    roleBanker: "Банкір", rolePravnik: "Юрист / нотаріус", roleDruhyKlient: "Другий клієнт", roleDeveloper: "Девелопер", roleHlavniKlient: "Головний клієнт", rolePlaceholder: "Роль (напр. Банкір)", roleSystemovaHint: "Цю роль тримає система — змінити не можна.",
  },
  tools: {
    /* Nástroje ke schůzce — dlaždice na /nastroje. Bez těchhle klíčů by
       titulek i popis zůstaly česky ve všech jazycích (fallback). */
    "kalk-zlato": { t: "Золото — скільки лишиться клієнтові", d: "Коли з'явиться перший грам, скільки з'їдять комісія і різниця купівля/викуп, валютний ризик долара окремо та порівняння з іншими активами. Грами й у chỉ та lượng.", short: "Грами, комісія та курс долара" },
    "kalk-konsolidace": { t: "Об'єднання кредитів", d: "Разом зараз проти разом потім — не два платежі. Обчислює ставку кожного кредиту й уміє показати навіть випадок, коли об'єднання НЕВИГІДНЕ.", short: "Разом зараз проти разом потім" },
    "kalk-podpojisteni": { t: "Недострахування приміщення", d: "Скільки страхова насправді виплатить, коли страхова сума нижча за вартість майна (§ 2854). Із сезонним піком запасів перед Tết і Різдвом.", short: "Скільки страхова справді дасть" },
    "kalk-doplaceni": { t: "Дострокове погашення іпотеки", d: "Доплати проти інвестиції на однаковому грошовому потоці. Графік двох кривих та їхній перетин, три числа для клієнта, сценарій „ринок не дасть нічого“ і спадне покриття. Презентаційний режим для зустрічі.", short: "Доплачувати чи інвестувати?" },
    provize: { t: "Калькулятор комісій", d: "201 продукт із каталогу BJ. Введи позицію та продукти → комісія за 1-й рік і повторна. Для порадника й для набору.", short: "201 продукт із каталогу BJ" },
    analyza: { t: "Фінансовий аналіз", d: "Кероване 45-хвилинне зустріч — цінності, цілі, ресурси, ризики. Скрипти ведуть навіть новачка. Обери клієнта або створи нового.", short: "Кероване 45-хв зустріч від А до Я" },
    posta: { t: "Пошта + AI Email", d: "Твій Gmail у CRM. Голосова або текстова команда → AI створить лист і надішле. Масові AI-кампанії.", short: "Gmail у CRM + AI-листи" },
    leadgen: { t: "Leadovač", d: "15 лідогенераційних воронок — Іпотека, Інвестиції, ФОП, Родина та інші. Поділись посиланням, отримуй ліди в CRM.", short: "15 воронок для лідів → CRM" },
    trychtyre: { t: "Воронки", d: "15 готових лендінгів-воронок (безкоштовна цінність → контакт). Подивись перегляд, скопіюй своє посилання, поділись. Лід потрапить у CRM.", short: "15 лендінгів-воронок для поширення" },
    "funnel-knihovna": { t: "Бібліотека воронок", d: "53 готові воронки повністю: тексти лендінгів, e-mail послідовності, реклама, ебуки, сценарії вебінарів і дзвінків. Плюс форма, яка з твоїх відповідей складе завдання на нову воронку.", short: "53 воронки + складач завдання" },
    mesicnik: { t: "Щомісячник для клієнтів", d: "Опублікований випуск щомісячника надішлеш клієнтам, які дали згоду на маркетинг: попередній перегляд листа і веб-версії, відписка одним кліком. Дані ЧНБ, ЄЦБ та інших відкритих джерел.", short: "Випуск щомісячника клієнтам" },
    "byznys-plan": { t: "Мій бізнес-план", d: "Річний план консультанта за зразком курсу: минулорічні цифри з CRM, бачення, бізнес- та особисті цілі, маркетинг, місячні цілі з нагородою, щоденні звички, дати перегляду. Зберігається на сервері, друк на A4.", short: "Бачення, цілі, маркетинг, місячний план" },
    trychtyrBuilder: { t: "Воронка від А до Я", d: "Покроковий посібник (7 кроків) за методикою Konverzky: магніт, сторінка, сторінка подяки, телефонний скрипт, міні-вебінар, e-mail-послідовність, реклама та вимірювання (піксель). Шаблони для заповнення без ШІ, збережені для тебе; готові лідогенератори, воронки та сайт лише підключаєш.", short: "7 кроків: магніт → піксель" },
    "fin-matematika": { t: "Фінансова математика", d: "Кредит / Іпотека, Інвестиція і Рента. Прапорець = порахуй будь-що. Великий графік, перевірки, частота нарахування.", short: "Кредит, інвестиція, рента — розрахунок" },
    penze: { t: "Пенсійний калькулятор (DPS/DIP)", d: "Пенсійне накопичення і DIP: модель на майбутнє з державною підтримкою і податками, історичний калькулятор на реальних прибутках фондів, порівняння фондів і план ренти.", short: "DPS + DIP, історія, фонди, рента" },
    izp: { t: "Аналіз для в’єтнамців", d: "Пояснює клієнту, навіщо страхування життя: дохід, пакет 10/20/30 %, ризики, графік до 60/65/70 років, що отримає родина і що залишиться.", short: "Страхування та інвестиції крок за кроком" },
    "zivotni-pojisteni": { t: "Страхування життя", d: "Рекомендоване покриття за кілька секунд: смерть, інвалідність, непрацездатність, стійкі наслідки, тяжкі захворювання. Легко продати навіть новачкові.", short: "Рекомендоване покриття за секунди" },
    "rodinny-plan": { t: "Сімейний фінансовий план (CZ/VI)", d: "Пʼятнадцять хвилин із клієнтом: дохід → витрати → що залишається → що станеться при втраті доходу → скільки захисту і скільки на майно. Двома мовами, чеською і вʼєтнамською, режим для клієнта. Не починається продуктом.", short: "Пʼятнадцять хвилин із клієнтом" },
    historicka: { t: "Історичний калькулятор", d: "На реальних даних 1926–2026 покажи клієнту, як би склалася інвестиція. S&P 500, облігації, золото, інфляція.", short: "Реальні дані 1926–2026" },
    "svoboda": { t: 'Коли ти будеш вільним', d: 'Гроші, перекладені на час. Замість п\'яти відсотків понад інфляцію клієнт чує, на скільки років раніше перестане мусити ходити на роботу. Посунь повзунок — позначка поїде ліворуч. Плюс ціна очікування.', short: 'Гроші, перекладені на час' },
    "hypoteka-rozhodnuti": { t: 'Іпотека — чотири рішення', d: 'Кінець фіксації, 20 чи 30 років, скільки дати власних, вплив часу. Порівнює все місячне навантаження, а не лише платіж — тому результат часто протилежний тому, що клієнт очікує. Кожна вкладка закінчується однією фразою.', short: 'Фіксація, строк, власні, час' },
    fixace: { t: 'Фіксація під контролем', d: 'Що буде ПІСЛЯ фіксації. Коротка фіксація проти довгої на одній осі, платіж проти бюджету родини й одне число: ставка, вище якої все ламається. На реальних ставках ЧНБ 2006–2026 — разом із тим, як часто ставка після рефіксації стрибала.', short: 'Що буде після фіксації' },
    "renta-porovnavac": { t: "Виплата ренти — три способи", d: "Скільки клієнт отримає щомісяця за фіксованого %, ковзного середнього та обмежувачів. Видно й ціну: коли і наскільки довелося б скоротити. Портфель з огляду на досвід Нобелівського фонду, підтверджено роками 1966 і 2000.", short: "Фіксований % проти середнього проти обмежувачів" },
    "investicni-strategie": { t: "Інвестиційні стратегії", d: "Як інвестують найбільші фонди та найбагатші — Норвезький фонд, Нобелівський фонд, Рей Даліо, Core-Satellite. Для клієнтів + складні відсотки та безкінечна рента.", short: "Як інвестують найбільші фонди" },
    "srovnavac-fondu": { t: "Порівняння фондів", d: "Порівняй два фонди/ETF — скільки з доходу заберуть комісії. Каталог ETF і чеських фондів, графік, різниця в сумі. Для клієнта, без AI.", short: "Два фонди і що заберуть комісії" },
    "portfolio-doktor": { t: "Портфельний доктор", d: "Увесь портфель клієнта одразу: зважені витрати (і з якої частки майна пораховані), яку різницю це дасть за горизонт, розподіл, вердикт до кожної позиції — включно з «залишити». Витрати вводиш із KID, застосунок нічого не вигадує.", short: "Витрати всього портфеля" },
    "investicni-studio": { t: "Інвестиційна студія (DEMO)", d: "Навчальна презентація для клієнта: HWM Lab (комісія за результат), Сьогодні проти пропозиції, Portfolio Composer, історичні кризи, розклад витрат. Модельний клієнт, не персональна порада.", short: "Навчальна презентація для клієнта" },
    "nemovitost-pronajem": { t: "Нерухомість в оренду", d: "Скільки квартира в оренду СПРАВДІ приносить — грошовий потік у часі, скільки років ти її дотуєш, ефективна дохідність, стрес-тест. Руйнує рожеві уявлення клієнта.", short: "Скільки квартира в оренду приносить" },
    calculators: { t: "Калькулятори", d: "20 фінансових калькуляторів — іпотека, інвестиції, страхування, пенсія, особисті фінанси.", short: "20 фінансових калькуляторів" },
    "portfolio-doctor": { t: "Portfolio Doctor", d: "Діагностика портфеля клієнта — ISIN → альтернатива в ETF + AI-бриф.", short: "ISIN → альтернатива ETF + AI-бриф" },
    "akademie-produkty": { t: "Продуктова академія для новачків", d: "10 модулів: продукти, обдзвін, аргументація, закриття — з квізами та скриптами. З новачка професіонал.", short: "10 модулів із квізами та скриптами" },
    akademie: { t: "Академія порадника (відео)", d: "Освітня серія відео — Mindset, Фінансовий план, Процес продажу та інші.", short: "Освітня серія відео" },
    income: { t: "Цільовий дохід", d: "Зворотний розрахунок від бажаного доходу до кількості зустрічей і дзвінків.", labels: ["Бажаний місячний дохід","Середня комісія/договір","Конверсія зустріч → договір","Конверсія дзвінок → зустріч"], funnel: ["Дзвінків за день","Дзвінків за місяць","Зустрічей за місяць","Договорів за місяць"] },
    objections: { t: "Заперечення & відповіді", d: "Натисніть на картку, щоб побачити рекомендовану відповідь.", q: ["Мені не цікаво","У мене вже є консультант","У мене немає часу","У мене немає грошей","Надішліть email","Мушу порадитися з чоловіком/дружиною","Спробую сам","З моїми договорами все гаразд","Зараз не найкращий час","Звідки ви знаєте, що ви кращі?"], a: ["Розумію. Можу запитати, що саме здається вам нецікавим?","Це чудово! Як часто ваш консультант робить ревізію фінансового плану?","Розумію, час цінний. Пропоную ефективну зустріч на 45 хвилин.","Саме тому варто зустрітися. Ми допомагаємо знайти економію в чинних договорах.","Радо надішлю. Проте кожна ситуація унікальна. Можемо зустрітися на 30 хвилин?","Звісно! Будете на зустрічі обоє — важливо, щоб рішення було спільним.","Поважаю це. Чи знаєте, що людина без консультанта втрачає щороку 15–30 тисяч?","Це чудово! Коли ви востаннє їх переглядали? Ринок змінюється.","Розумію. Коли було б краще? Радо зателефоную.","Ми не претендуємо на звання найкращих. Наша сила — комплексний підхід."] },
    checklist: { t: "Контрольний список зустрічі A1", d: "Повний чек-лист для першої зустрічі.", cols: ["Перед зустріччю","Під час зустрічі","Після зустрічі"], before: ["Підготувати презентацію","Перевірити дані в CRM","Підготувати договори до підпису","Підтвердити доступність клієнта","Підготувати візитки та матеріали","Поставити нагадування"], during: ["Ice break і побудова стосунків","З'ясування очікувань клієнта","Представлення beplan","Фінансовий аналіз (7 сфер)","Презентація рішення","Узгодження наступного кроку","Попросити про рекомендації"], after: ["Записати нотатки в CRM","Надіслати підсумок на email","Підготувати проєкт договорів","Запланувати follow-up","Оновити pipeline"] },
    timer: { t: "Таймер зустрічі", d: "Таймер з 5 фазами для структурованої зустрічі.", phases: ["Ice break","З'ясування очікувань","Представлення","Принцип комплексності","Завершення і термін"] },
    pyramid: { t: "Піраміда особистих фінансів", d: "Натисніть на шар, щоб побачити деталі.", layers: [{ n: "Інвестування", d: "Активна побудова капіталу — акції, фонди, нерухомість." },{ n: "Інші потреби", d: "Ощадні рахунки, будівельне накопичення (stavební spoření), цільові накопичення." },{ n: "Житло", d: "Власне житло або інвестиція в нерухомість." },{ n: "Майбутні доходи (пенсійні)", d: "III пілер пенсійного накопичення (DPS) з державними внесками." },{ n: "Забезпечення доходів", d: "Страхування життя, страхування від нещасних випадків, лікарняні." }] },
    compare: { t: "Порівняння продуктів", d: "Порівняння фінансових продуктів поруч." },
    glossary: { t: "Словник понять", d: "Словник фінансових понять з пошуком." },
  },
  g: [
    { t: "RPSN", d: "Річна процентна ставка витрат — показує реальну ціну кредиту разом з усіма комісіями.", e: "Банк пропонує кредит зі ставкою 5 %, але RPSN становить 6,2 % через комісії." },
    { t: "LTV", d: "Loan to Value — співвідношення суми кредиту до вартості нерухомості.", e: "При купівлі квартири за 5 млн Kč з іпотекою 4 млн Kč LTV дорівнює 80 %." },
    { t: "Інвалідність 1 ступеня (invalidita 1. stupně)", d: "Зниження працездатності на 35–49 %. Право на часткову пенсію по інвалідності.", e: "Клієнт із хронічним захворюванням, який може працювати на неповну ставку." },
    { t: "Інвалідність 2 ступеня (invalidita 2. stupně)", d: "Зниження працездатності на 50–69 %.", e: "Клієнт після тяжкої травми, який може виконувати лише легку роботу." },
    { t: "Інвалідність 3 ступеня (invalidita 3. stupně)", d: "Зниження працездатності на 70 % і більше. Повна пенсія по інвалідності.", e: "Клієнт, не здатний до жодної роботи." },
    { t: "DPS", d: "Doplňkové penzijní spoření — додаткове пенсійне накопичення, III пілер з державними внесками.", e: "При накопиченні 1 000 Kč на місяць отримаєте державний внесок 230 Kč." },
    { t: "Трансформований фонд (transformovaný fond)", d: "Первісні пенсійні фонди з гарантією невід'ємної дохідності.", e: "Старе пенсійне страхування, укладене до 2013 року." },
    { t: "Волатильність (volatilita)", d: "Міра коливання вартості інвестиції в часі.", e: "Акції мають вищу волатильність, ніж облігації." },
    { t: "Диверсифікація (diverzifikace)", d: "Розподіл інвестиції між кількома активами для зниження ризику.", e: "Інвестувати одночасно в акції, облігації та нерухомість." },
    { t: "Складний відсоток (složené úročení)", d: "Відсотки додаються до основної суми і далі заробляють нові відсотки.", e: "100 000 Kč при 7 % p.a. за 20 років = 386 968 Kč." },
    { t: "Cash flow", d: "Грошовий потік — різниця між доходами і витратами за певний період.", e: "Місячний дохід 55 000 Kč мінус витрати 42 000 Kč = вільний cash flow 13 000 Kč." },
    { t: "Фінансовий план (finanční plán)", d: "Комплексний документ, що описує фінансову ситуацію клієнта і пропонує оптимальне рішення.", e: "План охоплює страхування, інвестиції, накопичення і пенсію." },
    { t: "Страховий випадок (pojistná událost)", d: "Випадкова подія, на яку поширюється страхування.", e: "Травма, хвороба, пошкодження майна стихійним лихом." },
    { t: "Страхова виплата (pojistné plnění)", d: "Сума, яку виплачує страхова компанія при страховому випадку.", e: "При травмі з постійними наслідками страхова виплатила 500 000 Kč." },
    { t: "Фіксація ставки (fixace)", d: "Період, протягом якого процентна ставка іпотеки незмінна.", e: "Фіксація на 5 років означає, що ставка не зміниться 5 років." },
    { t: "Ануїтетний платіж (anuitní splátka)", d: "Однаковий щомісячний платіж протягом усього терміну кредиту.", e: "Платіж 15 000 Kč щомісяця протягом усього терміну іпотеки." },
    { t: "Кредитоспроможність (bonita)", d: "Здатність клієнта обслуговувати кредит, яку оцінює банк.", e: "Банк оцінює дохід, витрати і чинні зобов'язання." },
    { t: "ETF", d: "Exchange Traded Fund — фонд, що торгується на біржі та відстежує індекс.", e: "S&P 500 ETF відстежує 500 найбільших американських компаній." },
    { t: "Облігація (dluhopis)", d: "Цінний папір, яким емітент зобов'язується повернути основну суму і відсотки.", e: "Державні облігації вважаються безпечною інвестицією." },
    { t: "Портфель (portfolio)", d: "Сукупність усіх інвестицій та активів клієнта.", e: "Портфель із 60 % акцій і 40 % облігацій." },
    { t: "Ребалансування (rebalancing)", d: "Регулярне приведення складу портфеля до цільового розподілу.", e: "Якщо акції зросли до 70 %, продати частину і докупити облігації." },
    { t: "TER", d: "Total Expense Ratio — сукупні витрати фонду у відсотках.", e: "Фонд з TER 0,5 % щороку утримує 0,5 % від інвестиції." },
    { t: "Державний внесок (státní příspěvek)", d: "Внесок держави до пенсійного або будівельного накопичення.", e: "Макс. 230 Kč на місяць до пенсійного накопичення при внеску 1 700 Kč." },
    { t: "Вінкуляція (vinkulace)", d: "Обмеження розпорядження коштами на користь третьої сторони.", e: "Вінкуляція страхового полісу на користь банку при іпотеці." },
    { t: "Відкладний період (odkladná doba)", d: "Період від настання страхового випадку до початку виплат.", e: "Відкладний період 28 днів при непрацездатності." },
    { t: "Консолідація боргів (konsolidace dluhů)", d: "Об'єднання кількох кредитів в один з вигіднішими умовами.", e: "Заміна 3 споживчих кредитів одним з нижчим платежем." },
    { t: "FIRE", d: "Financial Independence, Retire Early — рух за фінансову незалежність.", e: "Мета: накопичити 25-кратний розмір річних витрат і жити з 4 % вилучення." },
    { t: "Compliance", d: "Відповідність правовим і регуляторним вимогам у галузі.", e: "Дотримання правил ČNB для фінансових консультантів." },
  ],
  poznamky: {
    title: "Нотатки",
    new: "Нова нотатка",
    placeholder: "Пишіть…",
    emptyTitle: "Поки немає жодної нотатки",
    emptyDesc: "Натисніть і пишіть — чистий аркуш, що зберігається сам.",
    allTags: "Усе",
    addTag: "Додати мітку",
    removeTag: "Прибрати мітку",
    tagPlaceholder: "мітка",
    filterEmpty: "З цією міткою нічого немає.",
    clearFilter: "Скинути фільтр",
    delete: "Видалити нотатку",
    deleteConfirm: "Дійсно видалити?",
    saving: "Зберігаю…",
    saved: "Збережено",
    saveFailed: "Не збережено — сховище браузера заповнене",
  },
  /* === NASTROJE: ruční převod jazykových ternárů (dávka „nastroje") === */
  nastroje: {
    /* === ШВИДКІ ІНСТРУМЕНТИ В ПАНЕЛІ АНАЛІЗУ (бічна смужка іконок) ===
     * Калькулятори, які виїжджають ПОВЕРХ відкритого аналізу, уже заповнені
     * числами цього клієнта. Моделювання НЕ зберігається (підвал панелі),
     * а повідомлення рушія погашення йдуть на вже перекладених ключах
     * `nastroje.schuzka.doplaceni.hlaska*`. */
    pruh: {
      nadpis: "Швидкі інструменти",
      otevrit: "Відкрити швидкі інструменти",
      zavrit: "Закрити",
      tabHypo: "Іпотека",
      tabDoplaceni: "Іпотека з інвестицією",
      tabZivot: "Страхування життя",
      tabInvestice: "Інвестиція",
      znovuZAnalyzy: "Завантажити числа з аналізу знову",
      neukladaSeTuk: "Моделювання не зберігається.",
      neukladaSeText: "Числа з цієї панелі не потрапляють ні в аналіз, ні в план, і після оновлення сторінки їх не буде. Те, що хочеш залишити клієнтові, перепиши в аналіз або в пропозицію рішення.",
      padTuk: "Інструмент не вдалося показати.",
      padText: "Аналіз у порядку й залишився відкритим. Спробуй інший інструмент і повідом про помилку — подробиці в консолі браузера.",
      zAnalyzy: "з аналізу",
      zPrebytku: "з надлишку в аналізі",
      bezPrijmu: "Без чистого доходу в аналізі боргове навантаження порахувати не можна.",
      chybiNadpis: "Не вистачає даних",
      chybiObecne: "Якогось показника немає або він поза межами — перевір введені дані.",
      skriptNadpis: "Що сказати клієнтові",
      hypo: {
        zadani: "Нерухомість і кредит",
        cena: "Ціна нерухомості",
        vlastni: "Власні кошти",
        sazba: "Процентна ставка",
        splatnost: "Строк",
        dosaditPrumer: "Підставити середню по ринку {sazba} ({obdobi})",
        prumerNeniNabidka: "Середня ставка пропозицій на ринку, не пропозиція конкретного банку.",
        vysledek: "Платіж і ліміти",
        splatka: "Місячний платіж",
        splatkaNote: "Однаковий платіж на весь строк за введеною ставкою.",
        uver: "Сума кредиту",
        ltv: "LTV — кредит до ціни",
        ltvLimit: "Обов'язковий ліміт {limit}.",
        bezVeku: "віку в аналізі немає, беремо суворіший ліміт {limit}",
        ltvNad: "Понад ліміт — власних коштів потрібно щонайменше {castka}.",
        dsti: "DSTI — платежі до доходу",
        dstiLimit: "Рекомендований ліміт {limit} чистого доходу, наявні платежі враховані.",
        dti: "DTI — борг до доходу",
        dtiLimit: "Рекомендований ліміт {limit}× чистий річний дохід.",
        celkemZaplaceno: "Усього сплачено банку",
        zTohoUroky: "З цього відсотки",
        stavajiciSplatky: "Наявні платежі з аналізу",
        skript: "Банк дивиться на три числа: скільки ви берете щодо ціни нерухомості, скільки платежі забирають з доходу і скільки ви винні щодо річного доходу. Подивимося, як у вас справи — і де треба було б додати власних коштів.",
        chybiCena: "Введи ціну нерухомості.",
        chybiSazba: "Введи процентну ставку — без неї платіж не порахується.",
        chybiSplatnost: "Введи строк у роках.",
        chybiVlastni: "Вкажіть власні кошти — без них неможливо обчислити суму кредиту.",
        bezVlastnich: "Клієнт не має власних коштів",
        chybiVlastniNadCenu: "Власні кошти перевищують ціну нерухомості — на кредит тоді не залишається нічого.",
      },
      doplaceni: {
        zadani: "Іпотека і гроші понад",
        jistina: "Залишок тіла кредиту",
        sazba: "Відсоток за іпотекою",
        splatnost: "Строк",
        volnaCastka: "Вільні гроші щомісяця",
        vynos: "Очікувана дохідність інвестиції",
        horizont: "Хоче погасити через",
        predpoklad: "припущення радника",
        neniVAnalyze: "в аналізі немає — впиши",
        predpokladyPoznamka: "Враховано комісію фонду {ter} на рік і податок з продажу під час погашення. Дохідність вводь номінально, тобто так само як відсоток за іпотекою — інакше інвестиція отримала б задарма всю інфляцію.",
        stitkyPoznamka: "Підписи під полями кажуть, звідки число взялося, коли панель відкрилася. Те, що перепишеш, — твоє припущення.",
        chybiJistina: "Введи залишок тіла іпотеки.",
        chybiSazba: "Введи процентну ставку іпотеки. Нуль — це не ставка, а без ставки інвестиція вигравала б завжди.",
        vysledek: "Через {roky}: що залишиться клієнтові",
        cestaSplaceni: "Платити понад графік",
        cestaSplaceniNote: "Іпотека погашена через {kdy}, далі та сама сума інвестується.",
        cestaInvestice: "Інвестувати й погасити одразу",
        cestaInvesticeNote: "Портфель після податку {portfolio} мінус залишок боргу {dluh}.",
        vitezInvestice: "Краще виходить інвестувати",
        vitezInvesticeText: "Через {roky} клієнтові залишиться на {castka} більше, ніж при доплатах. Це справджується лише тоді, коли ринок дохідність справді дасть.",
        vitezSplaceni: "Краще виходить платити понад графік",
        vitezSplaceniText: "Через {roky} клієнтові залишиться на {castka} більше, якщо гроші спрямує в іпотеку. Платіж гарантований, дохідність ні.",
        remiza: "Обидва шляхи виходять однаково",
        remizaText: "Через {roky} різниця між шляхами незначна. Тож вирішує впевненість, а не дохідність — а гарантована саме дострокова доплата.",
        splatka: "Платіж за іпотекою",
        vydajObe: "З бюджету піде в обох шляхах",
        usporaSplaceni: "Економія на відсотках — платити понад графік",
        usporaInvestice: "Економія на відсотках — інвестувати",
        danPriDoplaceni: "Податок з продажу при погашенні",
        poplatky: "Комісії інвестиції разом",
        hranice: "Гранична дохідність інвестиції",
        hraniceNote: "Нижче цієї дохідності інвестиція програє — уже після податку й комісій. Вище за неї заробить.",
        hraniceNikdy: "Інвестиція не перевершить дострокову доплату навіть за дуже високої дохідності — зазвичай через короткий горизонт, комісії або податок.",
        prusecikText: "Портфель уперше покриє залишок боргу через {roky}. Доплатити довелося б {castka} — від тієї миті клієнт може вибирати.",
        prusecikNikdy: "За заданий горизонт портфель до покриття боргу не доросте.",
        urokyPoznamka: "Економія на відсотках порівнюється аж до повного погашення, не лише до дати доплати — інакше шлях, який ще має борг, виглядав би ощадливішим, ніж є.",
        orientacniNadpis: "Орієнтовне моделювання",
        orientacni: "Це не пропозиція кредиту й не обіцянка виплати, і воно не враховує умов конкретного договору. Ліміт безкоштовного дострокового погашення, комісії банку та ставку після фіксації перевір у договорі; податкові правила до дати погашення можуть змінитися.",
        plnaKalkulacka: "Сценарії падіння ринку, фіксацію та спадне покриття порахує повний калькулятор у розділі Інструменти.",
        skript: "У вас є дві можливості, як позбутися іпотеки. Або доплачуєте до неї, або ці гроші інвестуєте й погашаєте її одразу. Порахуємо обидві — і головне те, що станеться, якщо ринок заробить менше, ніж ми очікуємо.",
      },
      zivot: {
        zadani: "Родина і зобов'язання",
        nezbytne: "Необхідні витрати домогосподарства",
        horizont: "На скільки років покриття",
        dluhy: "Борги разом",
        rezerva: "Ліквідний резерв",
        vdovsky: "Пенсія вдови",
        sirotci: "Пенсія сиротам разом",
        davkaSablona: "шаблон країни — змініть за клієнтом",
        varianta: "Варіант покриття",
        smrt: "Страхова сума — смерть",
        invalidita: "Страхова сума — інвалідність",
        zavazne: "Тяжкі захворювання",
        tnu: "Стійкі наслідки травми",
        pn: "Тимчасова непрацездатність",
        denne: " / день",
        rozpad: "З цього борги {dluhy}, цілі {cile} і витрати домогосподарства {vydaje}.",
        chybiPrijem: "В аналізі ні в кого немає доходу — капітальному методу тоді нема з чого рахувати.",
        chybiVydaje: "Введи необхідні витрати домогосподарства.",
        chybiHorizont: "Введи, на скільки років має вистачити покриття.",
        chybiPozustalostni: "Для цієї країни немає перевіреної пенсії у зв'язку з втратою годувальника — без неї покриття на випадок смерті вийде заниженим. Додайте її до страхових лімітів.",
        skript: "Порахую вам це навпаки, ніж це робить страхова. Не скільки ви можете собі дозволити платити, а скільки родині було б потрібно, щоб жити далі так само й довести до кінця те, що ви запланували. Аж від цього числа говоримо про ціну.",
      },
      invest: {
        zadani: "Внески і горизонт",
        mesicne: "Щомісяця",
        jednorazove: "Одноразово сьогодні",
        rezervaNeni: "ліквідний резерв тут не підставляється",
        roky: "Строк інвестування",
        vynos: "Очікувана дохідність",
        vynosPredpoklad: "припущення радника",
        vysledek: "Скільки з цього буде",
        konecnaHodnota: "Вартість на кінець",
        vDnesnichCenach: "Номінально, без перерахунку на сьогоднішні ціни — інфляція купівельну спроможність зменшить.",
        vlozeno: "Внесено разом",
        vynosCelkem: "З цього дохідність",
        neniGaranceNadpis: "Дохідність не гарантована.",
        neniGarance: "Це припущення, не обіцянка. Ринок може падати кілька років, і вартість може бути навіть нижчою за внесену суму. Скажи це клієнтові раніше, ніж покажеш йому кінцеве число.",
        skript: "Це те, що вам щомісяця залишається. Залиште це лежати на рахунку — і за десять років це буде та сама сума, тільки купите за неї менше. Ось друга можливість — і одразу з нею речення, яке я мушу сказати: дохідність — це припущення, не обіцянка.",
        chybiVklad: "Введи місячний внесок або одноразову суму.",
        chybiRoky: "Введи строк інвестування в роках.",
        chybiVynos: "Введи очікувану дохідність.",
      },
    },
    /* === NÁSTROJE KE SCHŮZCE (zlato / konsolidace / podpojištění) ===
     * Klientské kalkulačky na /kalkulacka/:nastroj. Texty jsou psané tak, aby
     * je poradce mohl na schůzce ŘÍCT NAHLAS — proto tu jsou celé věty, ne
     * jen štítky. Vietnamská verze nese české odborné termíny v závorce,
     * protože klient i úřad je uvidí na smlouvě.
     * ⚠️ Čísla v kalkulačkách jsou ŠABLONA, ne nabídka — viz `sablonaText`. */
    schuzka: {
      sekce: "Інструменти для зустрічі",
      titulek: "Калькулятори, які клієнт бачить на столі",
      podtitulek: "Чотири розрахунки, на яких ламається зустріч: скільки золота клієнтові справді залишиться, чи вигідна консолідація — навіть коли невигідна — скільки страхова насправді виплатить, і чи доплачувати за іпотекою, чи інвестувати й погасити її одним платежем. Валюта береться з країни твого тенанта, не з мови.",
      zpet: "Назад до Інструментів",
      tabZlato: "Золото",
      tabKonsolidace: "Об'єднання кредитів",
      tabPodpojisteni: "Недострахування",
      tabDoplaceni: "Дострокове погашення іпотеки",
      zadani: "Вхідні дані",
      vysledek: "Результат",
      vetaNaSchuzku: "Фраза для зустрічі — скажіть її дослівно",
      kdyNedoporucit: "Коли цього НЕ РАДЬТЕ",
      postup: "Крок за кроком",
      orientacniTuk: "Орієнтовний розрахунок, не пропозиція.",
      orientacniText: "Модель служить лише для пояснення, як працює продукт. Це не пропозиція, не обіцянка виплати й не індивідуальна рекомендація. Зобов'язальні числа дає лише договір, тарифи та страхові умови.",
      sablonaTuk: "Числа є шаблоном — перевірте їх перед зустріччю.",
      sablonaText: "Ціни, ставки й комісії змінюються. Візьміть актуальні значення з партнерського порталу або тарифів станом на день зустрічі та перепишіть їх сюди.",
      mesicOne: "місяць",
      mesicFew: "місяці",
      mesicMany: "місяців",
      rokOne: "рік",
      rokFew: "роки",
      rokMany: "років",
      zlato: {
        popis: "Клієнт купує не лише золото — він купує золото, комісію, різницю між ціною купівлі та викупу і на додачу іноземну валюту. Покажіть йому все це одразу, щоб за два роки не було несподіванок.",
        jednorazove: "Одноразовий внесок",
        mesicne: "Щомісячний платіж",
        roky: "Горизонт",
        typ: "Тип договору — скільки з платежу йде на комісію",
        typJednorazovy: "Одноразова покупка",
        typPopis100: "100/0 — доки комісію не сплачено, клієнт не купує жодного грама. Скажіть це першим.",
        typPopis7030: "70/30 — сімдесят відсотків платежу йде на комісію, тридцять на метал. Грами додаються від початку, але комісія вища.",
        typPopis5050: "50/50 — половина на комісію, половина на метал. Найшвидший старт, найдорожча комісія.",
        typPopisJednorazovy: "Одноразова покупка — з платежів не утримується жодна комісія, клієнт платить лише ціну металу та різницю купівля/викуп.",
        vstupniPoplatek: "Вхідна комісія",
        vstupniPoplatekHint: "У програмах, де комісія платиться за кожен зливок окремо, додайте всі зливки.",
        cenaNakup: "Ціна купівлі за грам",
        cenaVykup: "Ціна викупу за грам",
        cenyHint: "Обидві ціни візьміть з порталу станом на день зустрічі. Різниця між ними — витрата, якої немає в жодному переліку комісій.",
        rustKov: "Зростання ціни металу (у USD) % річних",
        zmenaKurzu: "Зміна курсу USD/{mena} % річних",
        kurzHint: "Золото котирується в доларах, а клієнт живе в національній валюті. Коли національна валюта міцнішає, доларовий прибуток губиться дорогою. Тому тут два повзунки, а не один.",
        gramy: "Скільки золота матиме",
        jednotky: "{chi} chỉ · {luong} lượng (в'єтнамські одиниці)",
        vlozeno: "Внесено разом",
        hodnota: "Вартість при викупі",
        rozdil: "Різниця: {castka}",
        naklady: "Сплачено на комісії та різниці цін",
        spread: "Різниця купівля / викуп",
        vynosPa: "Дохідність річних (внутрішня норма дохідності)",
        nedoplaceno: "Вхідна комісія залишиться несплаченою",
        prvniGramNadpis: "Перший грам золота",
        prvniGramHned: "Клієнт купує метал уже з першого платежу.",
        prvniGramZa: "Клієнт купить перший грам аж на {mesic}-й місяць. До того часу платить комісію.",
        prvniGramNikdy: "За весь обраний горизонт клієнт не купить жодного грама — комісію не встигне сплатити. Скоротіть ціль або збільште платіж.",
        bodZvratuNadpis: "Коли клієнт виходить у нуль",
        bodZvratu: "На {mesic}-й місяць, тобто приблизно через {roky} року.",
        bodZvratuNikdy: "За обраний горизонт клієнт не поверне вкладені гроші. Скажіть йому це до підписання.",
        menoveRizikoNadpis: "Валютний ризик — клієнт купує не лише золото",
        menoveRizikoText: "Ціна золота у доларах, але клієнт платить і отримує в {mena}. Хто купив золото при слабкій національній валюті, втратив частину прибутку, щойно валюта зміцніла. Це число показує, скільки з результату зробив курс — а не метал.",
        kurzUdelal: "З результату зробив курс",
        kurzScenareNadpis: "А якщо курс піде інакше",
        kurzScenarLabel: "Курс {proc} річних",
        grafNadpis: "Вкладені гроші проти вартості металу",
        grafVlozeno: "Внесено",
        grafHodnota: "Вартість при викупі",
        grafRok: "Рік",
        porovnaniNadpis: "Ті самі гроші в інших активах",
        porovnaniText: "Довгострокові номінальні середні з відкритих даних (1928–2024, у доларах), без комісій і податків з обох боків. Служить для порівняння порядку величин, а не для вибору продукту — і аж ніяк не як обіцянка дохідності.",
        aktivumAkcie: "Широкий індекс акцій",
        aktivumZlato: "Золото (історичне середнє)",
        aktivumDluhopisy: "Облігації",
        aktivumNemovitosti: "Нерухомість",
        aktivumHotovost: "Готівка та ощадний рахунок",
        aktivumTentoPlan: "Цей план із золотом",
        mesicuInfo: "Модель рахує помісячно, разом {mesicu}.",
        skript: "„Перш ніж щось підписувати, покажу вам три числа. Перше: перший грам золота ви купите аж у тому місяці, який бачите тут на екрані — до того ви платите комісію. Друге: між ціною купівлі та ціною викупу є різниця, тож одразу після покупки ваше золото коштує менше, ніж ви заплатили. І третє: золото в доларах, а ви живете в національній валюті — коли вона зміцніє, частину прибутку забере курс. Якщо вам це підходить, ідемо далі. Якщо ні, маю для вас інше рішення.“",
        kdyNe: [
          "У клієнта немає ліквідного резерву на три-шість місяців витрат. Золото не резерв — викуп триває днями, а ціна може бути саме внизу.",
          "У клієнта дорогі борги. Кредитна картка під двадцять відсотків річних переможе будь-яку очікувану дохідність золота. Спершу об'єднання кредитів, потім метал.",
          "Горизонт коротший за п'ять-сім років. Вхідна комісія та різниця купівля/викуп за цей час не встигнуть окупитися.",
          "Клієнт не має вирішеного захисту доходу та житла. Золото не сплатить іпотеку, коли після травми він не зможе працювати.",
          "Клієнт хоче вкласти в золото більшість майна або жити з нього. Золото не дає ні відсотків, ні дивідендів — рента із золота є розпродажем майна.",
        ],
      },
      konsolidace: {
        popis: "Менший платіж не означає дешевший кредит. Порівнюються дві загальні суми, а не два платежі. Калькулятор уміє показати й випадок, коли об'єднання невигідне — і саме це робить із вас радника, якому клієнт вірить.",
        predlohy: "Заготовлені ситуації",
        predlohaVyplati: "Приклад: вигідно",
        predlohaNevyplati: "Приклад: невигідно",
        predlohyHint: "Модельні числа для тренування, не дані реального клієнта. Натисніть і перепишіть їх за тим, що клієнт приніс.",
        uveryNadpis: "Що клієнт сплачує сьогодні",
        pridat: "Додати кредит",
        smazat: "Прибрати кредит",
        zustatek: "Залишок",
        splatka: "Щомісячний платіж",
        zbyva: "Залишилось платежів",
        poplatekPredcasne: "Комісія за дострокове погашення",
        dopoctenaSazba: "Обчислена ставка",
        sazbaNelze: "неможливо обчислити",
        nazevKreditka: "Кредитна картка",
        nazevNebankovni: "Небанківська позика",
        nazevSplatkovyProdej: "Покупка в розстрочку",
        nazevBankovniPujcka: "Банківська позика",
        nazevAutoUver: "Кредит на авто",
        nazevNovy: "Інше зобов'язання",
        nabidkaNadpis: "Що пропонує банк",
        novaSazba: "Нова ставка",
        novaSplatnost: "Новий строк",
        poplatekZaSjednani: "Комісія за оформлення",
        splatkaRucne: "Платіж від банку",
        splatkaRucneHint: "Залиште нуль, і платіж обчислиться сам. Якщо банк його назвав, напишіть сюди.",
        celkemTed: "Разом заплатить зараз",
        celkemTedNote: "Сьогоднішні платежі: {splatka}",
        celkemPo: "Разом заплатить після об'єднання",
        celkemPoNote: "Новий платіж: {splatka}",
        uspora: "Економія",
        zaplatiNavic: "Заплатить більше",
        ulevaMesicne: "Полегшення платежу",
        prodlouzeni: "Подовження виплат",
        prodlouzeniZadne: "не подовжується",
        odsunuto: "Скільки з полегшення лише відкладено",
        sazbaTed: "Сьогоднішня зважена ставка",
        novaJistina: "Нове тіло кредиту разом з комісіями",
        poplatkyCelkem: "Комісії разом",
        verdiktVyhra: "Вигідно",
        verdiktVyhraText: "Клієнт платить менше щомісяця і разом. Перевірте комісії за дострокове погашення й візьміть від кожного кредитора підтвердження нульового залишку.",
        verdiktLevnejsi: "Разом дешевше, але платіж буде вищий",
        verdiktLevnejsiText: "Клієнт заплатить менше, але щомісяця має витягнути більше. Перевірте, чи бюджет це дозволить — інакше ви підштовхнули його до прострочення.",
        verdiktUleva: "Менший платіж, але заплатить більше",
        verdiktUlevaText: "Це може бути правильне рішення, коли йдеться про те, щоб не потрапити в прострочення й до реєстрів. Але це має прозвучати вголос: клієнт купує полегшення й платить за нього. Ніколи не продавайте це як економію.",
        verdiktNevyplati: "Невигідно",
        verdiktNevyplatiText: "Ані разом, ані за платежем. Скажіть це клієнтові прямо й запропонуйте інше — позачерговий платіж, інший строк або об'єднання лише найдорожчих зобов'язань.",
        hranice: "Щоб об'єднання вийшло принаймні в нуль за витратами, строк не може бути довшим за {mesicu}.",
        hraniceNelze: "За цією ставкою об'єднання не вийде дешевшим за жодного строку. Попросіть іншу пропозицію.",
        skript: "„Погляньте на ці два числа. Ліворуч — скільки ви заплатите, якщо залишите все як є. Праворуч — скільки заплатите після об'єднання. Платіж зменшиться, це правда. Але вирішуємо за цими двома загальними числами, а не за платежем. Якщо праворуч вийде більше, значить, ви купуєте спокій і платите за нього. Це законне рішення, лише маєте знати, що його ухвалюєте.“",
        kroky: [
          "Випишіть кожне зобов'язання: залишок, платіж, кількість платежів, що лишились, ставку й комісію за дострокове погашення.",
          "Попросіть клієнта принести виписки з кредитних реєстрів. Два-три зобов'язання він зазвичай не згадає — без них рахунок буде хибний.",
          "Порахуйте обидві загальні суми і лише потім говоріть про платіж.",
          "Подайте заявку з документами: документ, що посвідчує особу, договори всіх кредитів, які об'єднуються, підтвердження доходу або виписки з рахунку.",
          "Після виплати візьміть від кожного попереднього кредитора підтвердження нульового залишку. Це найчастіша помилка всього об'єднання.",
          "Скасуйте вивільнені кредитні картки й овердрафти. Інакше клієнт за рік знову набере боргів і ви йому не допомогли.",
        ],
        kdyNe: [
          "Нова ставка така сама або вища, а єдина зміна — довший строк.",
          "Клієнт об'єднав би й зобов'язання, які за кілька місяців закриє — там уже майже не лишилося відсотків.",
          "Комісії за дострокове погашення й за оформлення з'їдять усю економію.",
          "Клієнт залишить кредитні картки та овердрафти відкритими.",
          "Частина боргів у виконавчому провадженні, прострочена, перед державою або в приватних осіб — банк такі до об'єднання не візьме, хоч вони й тиснуть на бюджет.",
        ],
      },
      podpojisteni: {
        popis: "Коли страхова сума нижча за реальну вартість майна, страхова зменшує виплату в тій самій пропорції — і зменшує навіть невеликий збиток. У продуктовому магазині це зазвичай різниця в сотні тисяч.",
        polozkyNadpis: "Порахуйте, що в приміщенні є насправді",
        polozkyHint: "Більшість випадків недострахування виникає через те, що про щось забули. Пройдіть це разом позиція за позицією.",
        stavebniUpravy: "Будівельні роботи та вбудовані елементи",
        vybaveni: "Обладнання та машини",
        elektronika: "Електроніка й каса",
        zasoby: "Товарні запаси",
        hotovost: "Готівка в приміщенні",
        veciKlientu: "Речі, прийняті від клієнтів",
        polozkyCelkem: "Вартість разом",
        dosadit: "Підставити в розрахунок",
        hodnota: "Реальна вартість майна",
        hodnotaHint: "Скільки коштувало б придбати це заново, а не скільки коштувало тоді.",
        castka: "Страхова сума в договорі",
        castkaHint: "Перепишіть її з поліса, а не з пам'яті.",
        skoda: "Розмір збитку",
        spoluucast: "Франшиза",
        sezonni: "Сезонний пік запасів",
        sezonniHint: "Перед Tết і перед Різдвом магазин тримає на складі кратно більше запасів. Страхова сума лишилася з дня укладення — а збиток виникає саме тоді.",
        podpojisteni: "Недострахування",
        pomerNote: "Покрито {pomer} вартості",
        vyplati: "Страхова виплатить",
        doplaci: "Клієнт доплачує сам",
        hodnotaVeSpicce: "Вартість майна на піку",
        chybiVCastce: "На скільки підняти страхову суму",
        ztrataProti: "Втрата проти правильно укладеного договору",
        varovaniTuk: "Цей договір недострахований.",
        varovaniText: "Страхова зменшить виплату в тій самій пропорції, в якій страхова сума відноситься до вартості майна. Це стосується й невеликого збитку. Підніміть страхову суму або одразу скажіть клієнтові, скільки він доплачуватиме.",
        vporadkuTuk: "Покриття відповідає вартості майна.",
        vporadkuText: "Виплату не зменшуватимуть. Перевіряйте це знову на кожній сервісній зустрічі — ціни будівництва й запасів зростають, а страхова сума сама не підніметься.",
        tabulkaNadpis: "Зменшують і невеликий збиток",
        tabSkoda: "Збиток",
        tabPlneni: "Виплатить",
        tabDoplaci: "Доплатить клієнт",
        zakonNadpis: "Звідки це випливає",
        zakonText: "Цивільний кодекс Чехії (89/2012 Sb.), § 2854: якщо на момент страхового випадку страхова сума нижча за страхову вартість застрахованого майна, страховик зменшує виплату в тій самій пропорції — крім випадку, коли в договорі домовлено, що виплата не зменшуватиметься. Завжди перевіряйте конкретні страхові умови.",
        skript: "„Ваша страхова сума нижча, ніж насправді коштує цей магазин. Це не означає, що страхова вам не заплатить — це означає, що з кожного збитку вам заплатять лише стільки відсотків, на скільки відсотків магазин застрахований. Покажу вам: ось ваш збиток, а ось те, що справді прийде на рахунок. А перед Tết, коли склад повний, ця різниця ще більша. Виправмо це зараз, поки нічого не сталося.“",
        kdyNe: [
          "Клієнт не хоче або не може підтвердити вартість майна — тоді не вигадуйте страхову суму, дайте порахувати її з бухгалтерії або оцінювачу.",
          "У договорі домовлено, що виплату не зменшують. Тоді цей розрахунок не діє і треба виходити з конкретних страхових умов.",
          "Клієнт хоче підняти страхову суму, але не виконав вимоги щодо охорони, ревізій чи гігієни — страхова може зменшити виплату з іншої причини, і вища сума не допоможе.",
          "Ідеться про речі особливої цінності, наприклад коштовності та дорогоцінні метали — вони мають у страхуванні власні підліміти, і цей розрахунок їх не охоплює.",
        ],
      },
      /* === DOPLACENÍ HYPOTÉKY (mimořádné splátky vs. investice) ===
       * Nástroj, kterým se klient přemlouvá, aby NESPLÁCEL dluh. Texty proto
       * musí unést i opačný závěr: `verdiktSplaceni`, `rizikoText`, scénáře
       * a `kdyNe` nejsou zdvořilostní vata — bez nich je to slib výnosu.
       * Odborné termíny nechávej v závorce česky, klient je uvidí na smlouvě. */
      doplaceni: {
        popis: "Клієнт має іпотеку та кілька тисяч вільних щомісяця. Або він надсилає їх в іпотеку, або інвестує та в узгоджений момент погашає борг одноразово. Обидва шляхи витрачають з бюджету абсолютно однаково — різниця лише в тому, що клієнтові залишиться наприкінці. І головне: видно момент, коли інвестиція вперше покриє залишок боргу.",
        prezentace: "Запустити презентацію",
        zadaniHypoteka: "Іпотека",
        jistina: "Скільки залишилося сплатити",
        jistinaHint: "Залишок тіла кредиту, а не первісна сума. Візьми з виписки, не з памʼяті клієнта.",
        sazba: "Процентна ставка",
        splatnost: "Строк",
        horizont: "Через скільки років хоче погасити",
        horizontHint: "Дата погашення фіксована. Ринок про неї не питає — тому поруч з економією є панель ризику.",
        fixace: "Фіксація",
        fixaceHint: "Нуль = одна ставка на весь час. Інакше після фіксації перераховується і платіж, так само як у банку.",
        sazbaPoFixaci: "Ставка після фіксації",
        splatkaInfo: "Щомісячний платіж {splatka} · іпотека закінчиться сама через {splatnost}.",
        zadaniInvestice: "Вільні гроші та інвестиція",
        volnaCastka: "Вільна сума щомісяця",
        volnaCastkaHint: "Ті самі гроші йдуть в обох шляхах — раз в іпотеку, раз в інвестицію. Без цього порівняння не було б чесним.",
        jednorazovyVklad: "Одноразово сьогодні",
        vynos: "Очікувана дохідність",
        rezim: "Введена дохідність є",
        rezimNominalni: "Номінальна (як відсоток)",
        rezimRealny: "Реальна (понад інфляцію)",
        rezimHint: "Відсоток за іпотекою номінальний. Поставити реальні 6 % проти номінальних 4,9 % означає безкоштовно віддати інвестиції всю інфляцію — тому це треба обрати, а не вгадувати.",
        poplatekVstupni: "Вхідна комісія з кожного внеску",
        poplatekRocni: "Поточна комісія (TER)",
        poplatkyHint: "Реальний фонд коштує 1–2 % на рік. Нуль — найшвидший спосіб завищити результат інвестиції.",
        trojiceNadpis: "Що залишиться клієнтові через {roky}",
        cestaSplaceni: "Плачу понад графік",
        cestaSplaceniNote: "Іпотеки не буде через {kdy}, потім інвестується звільнений платіж.",
        cestaInvestice: "Інвестую, потім погашу",
        cestaInvesticeNote: "Портфель після оподаткування {portfolio} мінус залишок боргу {dluh}.",
        rozdilZisk: "З інвестицією більше",
        rozdilZtrata: "З інвестицією менше",
        rozdilNote: "Різниця чистих активів обох шляхів.",
        vydajObe: "З бюджету піде в обох шляхах",
        urokyBezZasahu: "Відсотки, якщо нічого не робити",
        urokySplaceni: "Відсотки при доплатах",
        urokyInvestice: "Відсотки при інвестуванні",
        usporaSplaceni: "Заощаджено на відсотках — доплати",
        usporaInvestice: "Заощаджено на відсотках — інвестиція",
        danPriDoplaceni: "Податок з продажу на погашення",
        poplatkyCelkem: "Комісії інвестиції разом",
        urokyPoznamka: "Відсотки рахуються, доки іпотеки справді не стане — не лише до обраного року. Шлях, який у цільовому році ще має борг, інакше хвалився б економією, яку він просто ще не сплатив.",
        verdiktInvestice: "Інвестиція виходить краще — і клієнт має знати чому",
        verdiktInvesticeText: "Різницю робить дохідність понад відсоток за іпотекою, а вона не гарантована. Пройди з клієнтом панель ризику одразу нижче й назви йому граничну дохідність.",
        verdiktSplaceni: "Доплата виходить краще",
        verdiktSplaceniText: "Заощаджений відсоток гарантований і не оподатковується, дохідність інвестиції — ні те, ні інше. Тут нема що пояснювати: рекомендуй доплати.",
        verdiktRemiza: "Обидва шляхи виходять однаково",
        verdiktRemizaText: "Коли різниця копійчана, вирішує впевненість і спокій клієнта, а не таблиця. Платіж гарантований, дохідність ні.",
        grafNadpis: "Борг падає, інвестиція зростає",
        grafDluh: "Залишок боргу",
        grafPortfolio: "Вартість інвестиції після оподаткування",
        grafRok: "Рік",
        grafJednotka: "Вертикальна вісь у тисячах {mena}. Точну суму покаже підказка при наведенні на криву.",
        prusecikNadpis: "Момент, коли на погашення вистачає",
        prusecikText: "Приблизно через {rok} інвестиція вперше покриє залишок боргу ({castka}). Відтоді клієнт може обирати: погасити або дати грошам працювати далі.",
        prusecikNikdy: "За обраний горизонт інвестиція залишок боргу не покриє. Збільш вільну суму або перенеси дату погашення — і скажи це клієнтові раніше, ніж він вирішить.",
        rizikoNadpis: "А що коли ринок не дасть нічого",
        rizikoText: "Платіж за іпотекою гарантований, дохідність інвестиції ні. Покажи клієнтові обидві сторони — довіряють тому раднику, який приносить і поганий сценарій. Додатне число означає, що краще виходить інвестиція, відʼємне — доплата.",
        scenarBezVynosu: "Ринок не дасть нічого",
        scenarPesimisticky: "Песимістична дохідність",
        scenarZadani: "Згідно з введеним",
        scenarPropad: "Обвал ринку в рік погашення",
        hraniceNadpis: "Гранична дохідність",
        hraniceText: "Нижче {nominalni} номінально (тобто {realni} понад інфляцію) доплата вигідніша. Зверни увагу: межа лежить ВИЩЕ за відсоток іпотеки — різницю забирають податок і комісії.",
        hraniceNelze: "Граничну дохідність за цих даних порахувати не можна — інвестиція не перевершить доплату навіть за екстремальної дохідності.",
        pojNadpis: "Спадне покриття",
        pojPopis: "Якби клієнт помер або став інвалідом, поліс покриє залишок боргу. Сума спадає разом з боргом — це площа під кривою. Страхова сума рахується капітальним методом з доходу та витрат домогосподарства; іпотека — лише її спадна частина.",
        pojZapnout: "Рахувати",
        pojVypnout: "Пропустити",
        pojPrijem: "Чистий місячний дохід",
        pojVydaje: "Необхідні витрати домогосподарства",
        pojVydajeHint: "Скільки домогосподарство мусить витрачати щомісяця, щоб функціонувати — без заощаджень і без цілей.",
        pojDeti: "Кількість дітей",
        pojSmrt: "Страхова сума — смерть",
        pojInvalidita: "Страхова сума — інвалідність",
        pojZToho: "З того іпотека {hypoteka} (спадає) і домогосподарство {domacnost} (залишається).",
        pojCena: "Орієнтовний платіж",
        pojCenaNote: "Щомісяця, шаблон ставок. Це не пропозиція.",
        pojGrafKryti: "Страхова сума",
        pojPrumerSplaceni: "Середній непогашений борг — доплати",
        pojPrumerInvestice: "Середній непогашений борг — інвестиція",
        pojRozdilText: "Це ціна стратегії, яку ніхто не каже вголос: інвестиційний шлях тримає борг високо весь час, тож спадний поліс мусить діяти довше й коштує дорожче. Зате справжня діра для родини в нього менша, бо портфель — це майно. Раднику потрібні обидва числа, а не сприятливіше.",
        pojSablona: "Страхові суми та ставки — шаблон з практики радника, не пропозиція й не гарантія. Конкретні ліміти й ціну перевір у страховій.",
        pojBezPrijmu: "Без введеного доходу капітальному методу нема з чого рахувати, тому показано лише спадне покриття на іпотеку. Додай чистий дохід і необхідні витрати — тоді порахується й частина, яка тримає домогосподарство.",
        skript: "„Сьогодні ви надсилаєте додатково {volna} в іпотеку. Покажу вам другий варіант: ті самі гроші працюють, а іпотеку ви погасите одним платежем. Погляньте на графік — тут борг падає, тут інвестиція зростає, а тут вони перетинаються. Це момент, коли ви можете обирати. І одразу покажу другий бік: якби ринок не дав нічого, вийшло б ось так. Саме тому до цього належить поліс, який покриє борг, якби з вами щось сталося.“",
        kroky: [
          "Візьми з виписки залишок тіла кредиту, ставку, платіж і кінець фіксації. Не з памʼяті клієнта — різниця буває в сотнях тисяч.",
          "Запитай, скільки він має вільного щомісяця і чи витримає надсилати це й через пʼять років. Нестабільна сума руйнує весь розрахунок.",
          "Задай, через скільки років він хоче позбутися іпотеки. Ця дата далі не змінюється.",
          "Скажи вголос, чи введена дохідність номінальна, чи понад інфляцію. Це найчастіша помилка в такому розрахунку.",
          "Додай комісії фонду з документа KID. Без них результат інвестиції завищений.",
          "Покажи графік і точку перетину. Лише потім числа.",
          "Пройди панель ризику, включно зі сценарієм, де ринок не дає нічого. Не пропускай його.",
          "Увімкни спадне покриття й порахуй, що станеться, якщо клієнт випаде. Без цього вся стратегія без захисту.",
          "Перевір у договорі ліміт безкоштовного дострокового погашення та комісії за доплату.",
        ],
        kdyNe: [
          "У клієнта немає резерву на три-шість місяців витрат. Спочатку резерв, аж потім це.",
          "Очікувана дохідність нижча або близька до відсотка іпотеки. Тоді інвестиція не має як виграти, а доплата явно краща.",
          "Клієнт не спав би, якби портфель впав на тридцять відсотків. Дата погашення фіксована, а ринок про неї не питає.",
          "Вільна сума непевна — змінний дохід, сезонний ФОП, свіжа декретна відпустка. Доплати переживуть паузу, інвестиція з фіксованою датою гірше.",
          "Фіксація закінчується за рік-два, а нова ставка невідома. Спершу дізнайся ставку, потім рахуй.",
          "У клієнта немає покриття на випадок смерті та інвалідності. Без нього стратегія тримається на тому, що нічого не станеться.",
          "Банк за доплату бере компенсацію понад законний ліміт. Перевір у договорі — розрахунок її не моделює.",
        ],
        metodika: "Податок з продажу рахується за окремими купівлями згідно з чинним сьогодні правом. Продаж у {rok} році оцінюється за сьогоднішніми правилами, а закон до того часу може змінитися кілька разів. Результат орієнтовний, це не пропозиція й не індивідуальна рекомендація.",
        hlaskaJistina: "Введи залишок тіла іпотеки.",
        hlaskaSazbaChybi: "Введи процентну ставку іпотеки.",
        hlaskaHorizontChybi: "Введи, через скільки років клієнт хоче погасити іпотеку.",
        hlaskaHorizontNekladny: "Горизонт погашення має бути щонайменше один рік.",
        hlaskaSplatnost: "Введи строк іпотеки в роках.",
        hlaskaNicNavic: "У клієнта немає нічого вільного — нема чого порівнювати. Введи місячну вільну суму або одноразовий внесок.",
        hlaskaZapornaAmortizace: "Платіж не покриває навіть місячний відсоток — борг зростав би, і іпотека ніколи не була б погашена. Перевір тіло кредиту, ставку і строк.",
        hlaskaVynosPodUrokem: "Очікувана дохідність {vynos} нижча або дорівнює відсотку іпотеки {sazba}. Інвестиція не має як виграти навіть до оподаткування й комісій — рекомендуй доплату.",
        hlaskaDoplaceniNevyslo: "Портфеля на погашення не вистачає. Після продажу та оподаткування бракує {castka}, і клієнтові залишається борг. Збільш вільну суму або перенеси дату погашення.",
        hlaskaHorizontZaSplatnosti: "Іпотека закінчиться сама через {roky}, тобто раніше, ніж клієнт хоче погашати. Нема чого погашати.",
        hlaskaSplatnostNedosazena: "За введеного платежу іпотека не погаситься навіть за весь модельований горизонт. Перевір дані.",
        hlaskaNad25: "Річний обсяг доплат перевищує чверть первісного тіла кредиту. Без компенсації закон гарантує лише погашення до 25 % на рік у місяці перед річницею договору; понад це банк може стягнути відшкодування витрат. Перевір у договорі.",
        hlaskaPrepocetNaNominalni: "Введену реальну дохідність для порівняння з іпотекою перераховано на {vynos} номінально (інфляція {inflace}). Відсоток за іпотекою номінальний.",
        hlaskaPoplatkyNezadany: "Комісії інвестиції не введені — рахується нуль. Реальний фонд коштує 1–2 % на рік, і результат інвестиції на це завищений.",
        hlaskaFixaceBezDelky: "Ти ввів ставку після фіксації, але не її тривалість — інша ставка тому ніколи не застосується.",
        hlaskaSok: "Моделюється обвал ринку на {propad} у {rok}. році.",
        hlaskaObecna: "Розрахунок натрапив на значення, яке не вміє обробити. Перевір дані.",
        krokDluh: "БОРГ",
        krokCesta: "ШЛЯХ",
        krokVysledek: "РЕЗУЛЬТАТ",
        krokRiziko: "РИЗИК",
        krokOchrana: "ЗАХИСТ",
        prezRok: "Рік",
        prezZavrit: "Закрити презентацію",
        prezNapoveda: "клік / → далі · Esc кінець",
        prezKonec: "Порахуймо це під вас",
        prezDisclaimer: "Орієнтовна модель, не пропозиція й не обіцянка виплати. Обовʼязкові числа дасть лише договір, тариф і умови страхування.",
        prezDluhStitek: "Сьогодні ви винні",
        prezDluhVeta: "Платіж {splatka} щомісяця за ставки {sazba}.",
        prezDluhUroky: "На відсотках ви заплатите {castka}, якщо нічого не зміниться",
        prezProtnutoTuk: "Тут вам уже вистачає на погашення",
        prezProtnutoText: "Інвестиція вперше покрила залишок боргу — приблизно на {rok}. році.",
        prezCestaBezi: "Дивіться — борг униз, інвестиція вгору…",
        prezCestaHotovo: "Приблизно на {rok}. році криві перетнуться. Там ви можете обирати. Натисніть на результат →",
        prezCestaNikdy: "За обраний час криві не перетнуться — на погашення поки не вистачає. Натисніть далі →",
        prezVysledekStitek: "Що вам залишиться через {roky}",
        prezVysledekVeta: "Обидва шляхи витрачають з бюджету абсолютно однаково. Різниця лише в тому, де ці гроші тим часом були.",
        prezRizikoStitek: "А що коли ринок не дасть нічого",
        prezRizikoVeta: "Найгірший з порахованих сценаріїв: {scenar}. Відʼємне число означає, що інвестиція вийшла б гірше за доплату.",
        prezRizikoNeznamo: "Сценарії за цих даних порахувати не вдалося.",
        prezOchranaStitek: "Якби з вами щось сталося",
        prezOchranaRozpad: "З того іпотека {hypoteka} — вона спадає разом з боргом. Решта {domacnost} тримає родину на ходу.",
        prezOchranaVeta: "Орієнтовно {cena} щомісяця. Шаблон ставок, не пропозиція.",
        prezOchranaVypnuto: "Спадне покриття вимкнене. Увімкніть його в калькуляторі й пройдіть з клієнтом і цю частину — без неї вся стратегія тримається на тому, що нічого не станеться.",
      },
    },
    finMat: {
      freqCtvrtletni: 'Щоквартально',
      freqDenni: 'Щоденно',
      freqMesicni: 'Щомісяця',
      freqRocni: 'Щорічно',
      rokFew: 'роки',
      rokMany: 'років',
      rokOne: 'рік',
      tabInvestice: 'Інвестиція',
      tabRenta: 'Рента',
      tabUver: 'Кредит / Іпотека',
      varovaniNekonecnaRenta: 'Рента менша або дорівнює доходу → капітал ніколи не вичерпається (безкінечна рента). 🎉',
      varovaniZapornaAmortizace: 'Платіж менший за місячні відсотки → кредит ніколи не буде погашено (від’ємна амортизація). Збільш платіж.',
    },
    investStrategie: {
      aktivaAkcie: 'Акції (S&P 500)',
      aktivaBtc: 'Bitcoin',
      aktivaDluhopisy: 'Облігації',
      aktivaMsci: 'MSCI World',
      aktivaPt: 'Готівка / грошовий ринок',
      aktivaReit: 'Нерухомість',
      aktivaZlato: 'Золото',
      akumulacniInsight: 'Час пом’якшує ризик. На 15+ років акції історично завжди перемагали все інше.',
      akumulacniKdo: 'Для молодих і довгого горизонту',
      akumulacniName: 'Накопичувальна (100 % акції)',
      akumulacniStory: '100 % акції в накопичувальних ETF — дивіденди реінвестуються автоматично (податково ефективно). Що довший горизонт, то більше акцій.',
      coreInsight: 'Головне — дешево і пасивно, дрібка на вищу дохідність. Найкраще співвідношення витрат і результату.',
      coreKdo: 'Стандарт професіоналів і фондів',
      coreName: 'Core–Satellite',
      coreStory: 'Ядро (80 %) = дешевий глобальний індекс, який нудно й надійно зростає. Сателіти (20 %) = приправа — теми, золото, крипто.',
      dalioInsight: 'Коли прийде криза, спатимете спокійно. Менші коливання = менше панічних помилок.',
      dalioKdo: 'Bridgewater, найбільший хедж-фонд світу',
      dalioName: 'Рей Даліо — All Weather',
      dalioStory: 'Портфель «на будь-яку погоду» — збалансований так, щоб пережити зростання, рецесію, інфляцію й дефляцію. Балансується за ризиком, а не за грошима.',
      milionariInsight: 'Багатство виникає не від заощаджень, а від володіння активами, які зростають і виплачують.',
      milionariKdo: 'UBS / Knight Frank Wealth Report',
      milionariName: 'Як інвестують доларові мільйонери',
      milionariStory: 'Багаті не тримають гори готівки — вони володіють активами: акції, нерухомість, бізнес, золото. Широка диверсифікація по всьому.',
      nobelInsight: 'Це рентний портфель: ви виплачуєте, а капітал не зменшується. Саме як ваша майбутня рента.',
      nobelKdo: 'Виплачує Нобелівські премії понад 120 років',
      nobelName: 'Нобелівський фонд',
      nobelStory: 'Щороку роздає мільйони на Нобелівські премії — а капітал сьогодні більший, ніж на початку. Бо гроші інвестує, а не тримає без діла.',
      norskyInsight: 'Держава, якій є що витрачати, натомість інвестує глобально. Диверсифікація і терпіння.',
      norskyKdo: 'Найбільший державний фонд світу (1,8 трлн $)',
      norskyName: 'Норвезький нафтовий фонд',
      norskyStory: 'Норвегія не проїдає гроші з нафти — інвестує їх для майбутніх поколінь у ~9 000 компаній по всьому світу. Понад 70 % в акціях.',
      rokFew: 'роки',
      rokMany: 'років',
      rokOne: 'рік',
    },
    pdDisclaimer: {
      titulek: 'Що клієнт мусить знати',
    },
    pdGraf: {
      let: 'років',
      popisGrafu: 'Динаміка вартості обох варіантів у часі',
      zdroj: 'Джерело: модельний розрахунок за даними порадника — це не історичний розвиток і не прогноз.',
    },
    pdModel: {
      horizont: 'Горизонт (років)',
      horizontAria: 'Горизонт у роках',
      jenPorovnatelna: '— лише та частина портфеля, яку можемо порівняти з нашим варіантом у тій самій категорії.',
      kurzPouzit: 'Іноземні валюти перераховано за курсом від {datum} ({seznam}). Джерело: {zdroj}.',
      kurzNepouzit: 'Іноземні валюти не перераховуються — {duvod} Суми в різних валютах тому не додаються.',
      kurzStary: 'курсовий лист від {datum} старший за 30 днів.',
      kurzChybi: 'бракує курсу для {meny}.',
      kurzBezListku: 'немає чинного курсового листа.',
      tisk: 'Друк / PDF',
      tiskTitle: 'Друкує сторінку або зберігає її як PDF',
      smazat: 'Очистити введене',
      smazatTitle: 'Очищує таблиці та налаштування моделі',
      mena: 'Домашня валюта',
      menaNapoveda: 'за країною організації, а не за мовою',
      nepocitaSe: 'не рахується',
      pocatecniHodnota: 'Початкова вартість моделі',
      popis: 'Модельна дохідність — це ТВОЄ вхідне припущення, а не прогноз. Застосунок жодної дохідності не пропонує — без неї моделювання не рахується.',
      titulek: '3 · Налаштування моделі',
      vklad: 'Щомісячний внесок',
      vkladNapoveda: 'порожньо = регулярних внесків немає',
      vstupni: 'Вхідна комісія поточного портфеля %',
      vstupniAria: 'Вхідна комісія поточного портфеля',
      vstupniNapoveda: 'стосується лише МАЙБУТНІХ внесків — з уже інвестованих грошей вдруге не стягується',
      vynos: 'Модельна валова дохідність % річних',
      vynosAria: 'Модельна валова дохідність',
      vynosNapoveda: 'заповнюєш ти — застосунок нічого не пропонує',
    },
    pdPrazdny: {
      krok1Nadpis: 'Перепиши позиції клієнта',
      krok1Popis: 'З виписки з рахунку або з порталу дистриб’ютора. ISIN необов’язковий — якщо введеш, буде перевірено контрольну цифру.',
      krok2Nadpis: 'Внеси витрати з KID',
      krok2Popis: 'Для кожного фонду існує KID (документ ключової інформації). Поточні витрати та витрати на вході — у розділі «Витрати», рівень ризику 1–7 — у розділі зведеного показника ризику.',
      krok3Nadpis: 'Введи наш варіант і модель',
      krok3Popis: 'Витрати нашої стратегії вводиш ти — застосунок їх не знає. Потім встанови горизонт і модельну валову дохідність.',
      pridatPrvni: 'Додати першу позицію',
      proc: 'Застосунок не знає витрат жодного фонду — не знайде їх за ISIN і не оцінить за категорією. Усі числа вводиш ти з документального джерела. Саме тому результат можна захистити і перед клієнтом, і перед наглядом.',
      titulek: 'Поки що немає чого рахувати',
    },
    pdRozlozeni: {
      bezKategorie: 'Без визначеної категорії',
      bezMeny: 'Без заповненої валюти',
      kategoriePopis: 'За категоріями, які ти ввів. Перетин конкретних акцій усередині фондів не рахуємо — без реального складу фондів це було б вигадане число.',
      kategorieTitulek: 'Розподіл за категоріями',
      menyPopis: 'Лише з заповненого. Відсутня валюта не дописується як крони — вона потрапляє до «не визначено».',
      menyTitulek: 'Валютний розподіл',
    },
    pdTabulka: {
      hodnota: 'Вартість',
      hodnotaNapoveda: 'скільки клієнт у цьому тримає',
      isin: 'ISIN',
      isinNapoveda: 'необов’язково — з виписки або з KID',
      kategorie: 'Категорія',
      kategorieNapoveda: 'порівнюється лише в межах однієї',
      mena: 'Валюта',
      menaNapoveda: 'валюта позиції',
      nazev: 'Назва фонду',
      nazevNapoveda: 'точно так, як у виписці',
      neuveden: 'не вказано',
      prazdno: 'Поки що порожньо — додай перший рядок.',
      pridatRadek: 'Додати рядок',
      smazatRadek: 'Видалити рядок',
      sri: 'Ризик 1–7',
      sriNapoveda: 'KID, зведений показник ризику',
      ter: 'TER % річних',
      terNapoveda: 'KID, розділ «Витрати» — поточні комісії',
      vstupni: 'Вхідна комісія %',
      vstupniNapoveda: 'KID, розділ «Витрати» — витрати на вході',
      zdroj: 'Джерело числа',
      zdrojEmt: 'EMT (документально)',
      zdrojKatalog: 'каталог — орієнтовно',
      zdrojKid: 'KID (документально)',
      zdrojNapoveda: 'документальним є лише KID або EMT',
      zdrojPoradce: 'ввів консультант',
    },
    pdVerdikt: {
      hodnota: 'вартість',
      hodnotaPonechat: 'Вартість із вердиктом «залишити»',
      keZvazeni: 'на розгляд',
      nakladovostPolozky: 'Витрати позиції',
      naseVarianta: 'наш варіант',
      nescitaSe: 'не підсумовується (кілька валют)',
      popis: 'Матеріал для розмови з клієнтом, а не інвестиційна рекомендація чи вказівка продавати. Порівняння відбувається лише в межах однієї категорії.',
      rozdil: 'різниця',
      stitekNelze: 'Неможливо оцінити',
      stitekPonechat: 'Залишити',
      stitekZvazit: 'Розглянути зміну',
      stretZajmu: 'Конфлікт інтересів: ми порівнюємо з продуктом, який самі пропонуємо і за укладення якого отримуємо винагороду.',
      titulek: 'Вердикт за позиціями',
    },
    pdVety: {
      aDalsi: 'та ще {n}',
      bezHodnoty: 'У {n} {polozek} не заповнено вартість.',
      bezKategorie: 'У {n} {polozek} не визначено категорію.',
      bezMeny: 'У {n} {polozek} не заповнено валюту.',
      bezTer: 'У {n} {polozek} витрати нам невідомі.',
      duvodBezReference: 'Не маємо нашого варіанта із заповненими витратами — без нього порівняння не робимо. Додай його з KID.',
      duvodMichaneMeny: 'Порівнянні позиції в кількох валютах без перерахунку. Курсів ядро не знає, тож вони не сумуються — зведи все до однієї валюти або моделюй кожну окремо.',
      duvodNulovaHodnota: 'Усі порівнянні позиції мають нульову вартість, а витрати відрізняються — зважити не вдається.',
      duvodPrazdno: 'Портфель порожній — моделювання не рахуємо.',
      duvodZadnaShoda: 'Жодна позиція клієнта не має нашого варіанта в тій самій категорії з відомими витратами. Між категоріями порівняння не робимо — додай наш варіант до тієї категорії, яку хочеш оцінити.',
      koncentrace: 'Це концентрація — це не помилка, але запитай про неї.',
      menySeznam: 'Валюти: {seznam}. Частки порахувати не вдається — бракує вартостей.',
      modelujeCast: 'Моделюється лише порівнянна частина портфеля — {z} % його вартості.',
      modelujeVse: 'Моделюється весь портфель.',
      nakladovostNejde: 'Витрати портфеля порахувати не вдається — ми не знаємо їх у жодній позиції.',
      nakladovostNulaHodnot: 'Витрати не вдається зважити — усі позиції мають нульову вартість.',
      nejvetsiKategorie: 'Найбільша категорія «{kategorie}» становить {podil} портфеля.',
      nevstupujeFew: 'не входять',
      nevstupujeMany: 'не входять',
      nevstupujeOne: 'не входить',
      orientacniHlavniCislo: 'Частину витрат не підтверджено з KID чи EMT — тому головна цифра лише орієнтовна.',
      orientacniTer: 'У {n} {polozek} витрати орієнтовні — перевір їх у KID.',
      podilyNejdou: 'Частки порахувати не вдається — бракує вартостей.',
      polozkaBezNazvu: 'позиція без назви',
      polozkaBezNazvuCislo: 'Позиція без назви{cislo}',
      polozkaFew: 'позиції',
      polozkaMany: 'позицій',
      polozkaOne: 'позиція',
      porovnaniVKategorii: 'Кожна позиція порівнюється з нашим варіантом у своїй категорії — між категоріями порівняння не робимо.',
      prazdnePortfolio: 'Портфель порожній.',
      rokFew: 'роки',
      rokMany: 'років',
      rokOne: 'рік',
      rozdilZa: 'Різниця за {roky} {rok}',
      souhrnNelze: '{n}× неможливо оцінити',
      souhrnPonechat: '{n}× залишити',
      souhrnZvazit: '{n}× розглянути зміну',
      spocitanoZ: 'Пораховано з {z} % вартості портфеля.',
      uPolozkyFew: 'позиціях',
      uPolozkyMany: 'позиціях',
      uPolozkyOne: 'позиції',
      vazenaNakladovostVeta: 'Зважені витрати портфеля {pct} % річних',
      viceMenHodnoty: 'Вартості в кількох валютах без перерахунку — частки орієнтовні.',
      viceMenPodily: 'Портфель у кількох валютах без перерахунку — частки орієнтовні.',
      viceMenVahy: 'Портфель у кількох валютах без перерахунку — ваги лише орієнтовні.',
      vynechaneVeta: '{n} {polozek} до моделювання {nevstupuje}: {vypis}.',
      vynechanoBezHodnoty: 'не заповнено вартість',
      vynechanoBezKategorie: 'без визначеної категорії',
      vynechanoBezReference: 'у її категорії не маємо варіанта для порівняння',
      vynechanoBezTer: 'не знаємо витрат',
      vynechanoBezTerReference: 'не знаємо витрат нашого варіанта',
      vynechanoJineRiziko: 'помітно інший рівень ризику',
      zadnaMena: 'Валюту не заповнено в жодній позиції.',
    },
    pdVysledek: {
      doModelaceVstupuje: 'У моделювання входить',
      doplnVstupy: 'Заповни вхідні дані моделі.',
      hodnotaNaKonci: 'вартість у кінці',
      hodnotyPortfolia: 'вартості портфеля',
      klientVyhral: 'Поточний портфель дешевший за витратами. Отже, витрати не є підставою для переходу.',
      lepeVychazi: 'Вигідніше виходить: {popis}',
      nepocitaSe: 'Моделювання поки що не рахується',
      neuvedeno: 'не вказано',
      porovnatelnaNase: 'Порівнянна частина — наші варіанти',
      porovnatelnaSoucasne: 'Порівнянна частина — поточний портфель',
      referenceBezNakladu: 'Еталон узагалі без витрат',
      rozdilPorovnatelne: 'Різниця в порівнянній частині',
      rozpadModelace: 'Розклад моделювання',
      rozpadPopis: 'Сплачені комісії та недоотриманий дохід — ДВА РІЗНІ числа. Недоотриманий дохід містить і те, що сплачені гроші заробили б далі — не називай його комісією. Вхідна комісія, яку клієнт колись сплатив на вході, до поточного портфеля вдруге НЕ рахується — це безповоротні витрати.',
      spocitanoZ: 'розраховано з',
      stejnyVynosPoznamka: 'Обидва варіанти рахуємо з однаковою валовою дохідністю {vynos} річних. Модель порівнює ВИТРАТИ, а не здатність фондів заробити. Це модельний розрахунок, не обіцянка дохідності.',
      uslyVynos: 'недоотриманий дохід (з урахуванням складного відсотка)',
      vazenaNakladovost: 'Зважені витрати портфеля',
      vazenaPopis: 'Зважується вартістю позиції. Позиція з невідомими витратами до середнього НЕ входить — нуль не підставляється.',
      vlozenoCelkem: 'Загалом вкладено',
      vyvojVCase: 'Динаміка вартості в часі',
      zanedbatelny: 'Різниця незначна',
      zaplacenePoplatky: 'фактично сплачені комісії',
    },
    portfolioDoktor: {
      karta1: '1 · Портфель клієнта',
      karta1Popis: 'Пишеш прямо в таблицю — жодних модальних вікон, жодних кліків у деталь. Порожнє поле означає «не знаємо», а не нуль.',
      karta2: '2 · Наша стратегія для порівняння',
      karta2Popis: 'Витрати нашого варіанта вводиш ти — ніде не зашиті. Порівняння завжди відбувається лише в межах однієї категорії, тож додай рядок для кожної категорії, яку хочеш оцінити.',
      kteraVarianta: 'Який варіант іде в моделювання',
      nadrazenaSekce: 'Інструменти',
      naseVarianty: 'Наші варіанти (за категоріями)',
      porovnatelnaCast: 'Порівнянна частина поточного портфеля',
      pridejVariantu: 'Додай наш варіант, інакше нема з чим порівнювати.',
      soucasnePortfolio: 'Поточний портфель',
      stretZajmu: 'Конфлікт інтересів: ми порівнюємо з продуктом, який самі пропонуємо і за укладення якого отримуємо винагороду. Тому інструмент має право завершити вердиктом «залишити» — і якщо так виходить, він це й напише.',
      titulek: 'Портфельний доктор',
      uvod1: 'Випиши, що клієнт тримає, додай витрати з KID — і побачиш, скільки портфель йому коштує та яку різницю це дасть за горизонт.',
      uvod2: 'Застосунок не знає витрат жодного фонду',
      uvod3: '— числа вводиш ти з документального джерела.',
      vseZKid: 'Усе з KID',
      vseZKidTitle: 'Позначить заповнені витрати як підтверджені з KID',
    },
    provize: {
      add: 'Додати продукт',
      amount: 'сума',
      koef: 'Коефіцієнт',
      kpi1: 'Комісія за 1-й рік',
      kpi5: 'Загалом за 5 років',
      kpi5Sub: '1-й рік + 4× повторювано',
      kpiRep: 'Повторювано / рік',
      kpiRepSub: 'обслуговування + fee',
      notFound: 'Нічого не знайдено',
      note: '💡 Орієнтовний розрахунок за каталогом. Точні умови — за комісійними додатками на порталі. «Повторювано» = обслуговувальні BJ (авто/майно з 2-го року, інвестиції management fee, життя з 6-го року).',
      pick: '— обери продукт —',
      pos: 'Твоя позиція',
      repeat: 'повторювано',
      sample: 'зразок',
      sub: 'Введи позицію та продукти → побачиш комісію за 1-й рік і повторювану. 201 продукт із каталогу BJ · комісія = BJ × коефіцієнт.',
      title: 'Калькулятор комісій',
      tools: 'Інструменти',
      year1: '1-й рік',
    },
    srovnavacFondu: {
      coSniPoplatky: 'Скільки з’їдять комісії',
      disclaimer: 'Ставки TER і вхідні комісії є орієнтовними — перевір їх у чинному KIID / тарифах. Однакова валова дохідність для обох потрібна для ізоляції витрат; реальні фонди можуть відстежувати різні індекси. Минула дохідність не є гарантією майбутньої.',
      disclaimerTuk: 'Модельний розрахунок, а не обіцянка дохідності.',
      hintA: 'наш фонд / ETF',
      hintB: 'фонд клієнта',
      hledatPlaceholder: 'Введи фонд клієнта… (напр. «динамічний»)',
      hrubyVynos: 'Валова дохідність',
      nadrazenaSekce: 'Інструменти',
      nicNenalezeno: 'Нічого не знайдено — обери власний фонд і введи TER вручну.',
      rok: 'Рік',
      ter: 'TER (річні витрати)',
      uvod1: 'Знайди фонд клієнта в підказці (досить частини назви, навіть без діакритики) і порівняй його з нашим фондом — скільки з дохідності заберуть комісії. Однакова припущена валова дохідність для обох, тож ти бачиш чисто',
      uvod2: 'різницю у витратах',
      uvod3: '. Без ШІ, рахується просто тут.',
      vicNaKonci: 'БІЛЬШЕ В КІНЦІ',
      vlastniFond: 'Власний фонд',
      vlastniFondRucne: 'Власний фонд (ввести TER вручну)',
      vlozenoCelkem: 'Загалом вкладено',
      vstupni: 'вхідна комісія',
      vstupniPoplatek: 'Вхідна комісія',
      vstupniProc: 'Вхідна комісія %',
      vyvojHodnoty: 'Динаміка вартості',
      zisk: 'Прибуток',
    },
  },
  /* === /NASTROJE === */
  /* === ANALÝZA V2+ — stavová lišta ukládání (lib/analyzaV2/stavUkladani.js) === */
  /* BLOK:analyza START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyza: {
    instituceVyber: {
      nabidka: 'Список установ',
      sipka: 'Показати весь список',
    },
    propis: {
      ceka: 'Чекає на перенесення в теку: {n}',
      chyba: 'Зараз не вдалося перенести в теку клієнта, спробую ще раз',
      hotovo: 'Перенесено в теку',
      hotovoNove: 'нові: {n}',
      hotovoUpravene: 'змінені: {n}',
      klid: 'Тека клієнта відповідає аналізу',
      nehotove: 'Незавершені рядки чекають на доповнення: {n}',
      nepropisovane: 'Рахунки та готівка поки не переносяться в теку: {n}',
      probiha: 'Переношу в теку клієнта…',
      smazane: 'Рядок, видалений з аналізу, залишається в теці: {n}',
    },
    uklad: {
      ceka: 'Очікує збереження',
      cekaDetail: 'Остання зміна ще не на сервері.',
      nepovedlo: 'Не збережено — пробую ще раз',
      nepovedloDetail: '{n}. спроба, наступна через {s} с',
      nepovedloPokus: '{n}. спроба',
      obnova: 'Ми знайшли незбережені зміни — відновити?',
      obnovaAno: 'Відновити',
      obnovaNe: 'Відхилити',
      obnovaSCasem: 'Ми знайшли незбережені зміни з {cas} — відновити?',
      uklada: 'Зберігаю…',
      ulozeno: 'Збережено',
      zastaveno: 'Не зберігаю — аналіз не завантажився',
      zastavenoDetail: 'Перезавантаж сторінку, щоб не перезаписати дані.',
    },
  },
  /* BLOK:analyza END */
  /* КРИЗОВИЙ ПЛАН — див. коментар у cs.js. Ніщо тут не може обіцяти поведінку страховика. */
  krize: {
    nadpis: 'Кризовий план',
    podnadpis: 'Що робити, коли щось станеться',
    uvod1: 'Збережіть цю частину. Вона не на сьогодні — вона на той день, коли знадобиться.',
    uvod2: 'Тут немає нічого, що треба встигнути негайно. Порядок завжди однаковий: подбати про себе, зателефонувати мені, повідомити страховика.',
    proKoho: 'Кризовий план для {jmeno}',
    platnost: 'Складено {datum} за договорами, які на той час були в документах.',

    kontaktNadpis: 'Спочатку зателефонуйте мені',
    kontaktText: 'Вам не треба знати, що і де оформлено, ані кому писати. Для цього тут я.',
    kontaktRole: 'Ваш консультант',
    kontaktFirma: 'Компанія',
    kontaktTelefon: 'Телефон',
    kontaktEmail: 'Електронна пошта',
    kontaktWeb: 'Сайт',
    kontaktRezervace: 'Домовитися про зустріч',

    krokyNadpis: 'Порядок дій',
    podkladyNadpis: 'Що підготувати',
    pozorNadpis: 'На що звернути увагу',
    smlouvyNadpis: 'Договори, які можуть стосуватися цієї ситуації',
    smlouvaBezCisla: 'номера договору поки що немає',
    smlouvaBezInstituce: 'установи поки що немає',
    bezSmluv: 'До цього ризику у ваших документах я не маю жодного договору. Це не означає, що договору немає — означає, що ми маємо знайти його разом.',
    bezSmluvVse: 'У документах немає жодного договору страхування. Порядок дій нижче діє й так; спершу лише разом переглянемо, що саме у вас оформлено.',
    navrhNavic: 'Додаткова пропозиція',

    pravniNadpis: 'Звідки ми це знаємо',
    pravniOvereno: 'перевірено',
    disclaimer1: 'Цей огляд каже, ЩО зробити. Він не каже, чи і скільки страховик виплатить — це залежить від тексту вашого договору та його винятків. Ми пройдемо їх разом.',
    disclaimer2: 'Наведені статті — це загальні правила, а не обіцянка виплати. Строки й умови кожен договір має власні.',
    disclaimer3: 'Порядок дій спирається на чеське законодавство. Для договорів, укладених в іншій країні, діють тамтешні правила.',

    chybiNadpis: 'Перш ніж надіслати це клієнтові',
    chybiKontaktVse: 'У профілі консультанта немає ні телефону, ні публічної пошти. Кризовий план без контакту не має сенсу — додайте їх у Налаштуваннях.',
    chybiJmeno: 'Бракує імені консультанта.',
    chybiTelefon: 'Бракує телефону консультанта.',
    chybiEmail: 'Бракує публічної пошти консультанта.',
    chybiWeb: 'Бракує сайту консультанта.',
    chybiRezervace: 'Немає посилання на запис на зустріч — додайте візитівку або календар.',
    chybiSmlouvy: 'У документах немає жодного договору страхування.',
    chybiCislaSmluv: 'У деяких договорів бракує номера. Клієнт у кризі його шукати не буде.',

    pravni: {
      oznameni: 'Про страховий випадок треба повідомити страховика без зайвого зволікання.',
      setreni: 'Після повідомлення страховик без зайвого зволікання розпочинає розслідування. Результат, обґрунтування розміру виплати або причину відмови він повідомляє в текстовій формі.',
      splatnost: 'Якщо в договорі не встановлено інший строк, виплата належить протягом п’ятнадцяти днів від дня ЗАВЕРШЕННЯ розслідування. Це не строк на розгляд усієї справи.',
      zaloha: 'Якщо розслідування не вдається завершити протягом трьох місяців від повідомлення, страховик у текстовій формі повідомляє причини і на запит надає розумний аванс.',
      stupne: 'Ступені інвалідності визначаються за зниженням працездатності: I ступінь 35–49 %, II ступінь 50–69 %, III ступінь щонайменше 70 %.',
      nahradaMzdy: 'За перші 14 календарних днів тимчасової непрацездатності працівник отримує компенсацію заробітної плати від роботодавця.',
      zadostID: 'Заяву про пенсію по інвалідності складають у територіальному управлінні соціального забезпечення або подають електронно. Стан здоров’я оцінює лікар-експерт, зазвичай за медичною документацією. Законний строк для рішення — 90 днів.',
    },

    uraz_nemoc: {
      nadpis: 'Травма або хвороба — коротка непрацездатність',
      kdy: 'Ви вдома на лікарняному й розраховуєте повернутися за кілька тижнів.',
      kroky: [
        { n: 'Оформіть лікарняний', d: 'Лікуючий лікар виписує його електронно. Паперів роботодавцю носити не треба.' },
        { n: 'Повідомте роботодавця', d: 'Достатньо повідомлення, з якого дня ви на лікарняному.' },
        { n: 'Зв яжіться зі мною', d: 'Разом переглянемо ваші договори і скажемо, які з них стосуються цієї ситуації.' },
        { n: 'Повідомте страховика', d: 'Повідомити без зайвого зволікання вимагає § 2796 Цивільного кодексу. Якщо не знаєте як, повідомимо разом.' },
        { n: 'Зберігайте всі документи', d: 'Висновки лікаря, чеки на ліки, довідку про тривалість лікарняного. Потім їх дістати важче.' },
      ],
      podklady: [
        'Номер договору страхування',
        'Документ, що посвідчує особу',
        'Номер рахунку для виплати',
        'Довідка про непрацездатність — з якого до якого дня',
        'Медичні висновки щодо травми або хвороби',
      ],
      pozor: 'Перші 14 календарних днів компенсацію заробітної плати сплачує роботодавець, з 15-го дня допомогу з тимчасової непрацездатності виплачує управління соціального забезпечення. Самозайнята особа отримує таку допомогу лише за умови добровільного страхування. Період очікування в полісі — це інше: він у кожного договору свій, і ми знайдемо його у вашому.',
    },

    dlouhodoba_pn: {
      nadpis: 'Тривала непрацездатність',
      kdy: 'Лікарняний триває місяцями і зрозуміло, що це не на два тижні.',
      kroky: [
        { n: 'Зателефонуйте мені, поки не закінчилися гроші', d: 'Що раніше ми це знаємо, то більше можна зробити з бюджетом і платежами.' },
        { n: 'Порахуємо, скільки бракує щомісяця', d: 'Допомога замінює лише частину чистого доходу. Різниця — це саме те, що треба покрити.' },
        { n: 'Скористайтеся щоденною виплатою з поліса', d: 'Непрацездатність і щоденна виплата за травму заявляються окремо — навіть якщо ви вже повідомляли про травму.' },
        { n: 'Скажіть банку вчасно', d: 'Про відстрочку платежів просять до того, як платіж буде прострочено. Після простроченого платежу це значно важче.' },
        { n: 'Домовимося про контрольну зустріч', d: 'При тривалому лікарняному ситуація змінюється щомісяця. Не хочу, щоб ви стежили за цим самі.' },
      ],
      podklady: [
        'Рішення про тимчасову непрацездатність',
        'Поточні медичні висновки',
        'Номери договорів страхування',
        'Перелік платежів і регулярних доручень',
        'Виписки з рахунку за останні місяці',
      ],
      pozor: 'Допомога не виплачується безкінечно — строк її виплати обмежений, а його тривалість і можливе продовження оцінює управління соціального забезпечення у вашій справі. Перевіримо це разом, щоб знати, коли планувати наступний крок.',
    },

    zavazne_onemocneni: {
      nadpis: 'Тяжке захворювання',
      kdy: 'Встановлено діагноз на кшталт онкології, інфаркту чи інсульту. Такі зазвичай перелічені в полісах поіменно.',
      kroky: [
        { n: 'Спершу лікування', d: 'Нічого з того, що нижче, не на сьогоднішній день. Документи зачекають кілька днів.' },
        { n: 'Зателефонуйте мені', d: 'Подивимося, чи є ваш діагноз серед покритих. Перелік у кожному договорі свій.' },
        { n: 'Попросіть медичний висновок із діагнозом', d: 'Разом із датою встановлення. Без нього страховий випадок не підтвердити.' },
        { n: 'Повідомте страховика', d: 'Без зайвого зволікання, § 2796 Цивільного кодексу. Заяву заповнимо разом.' },
        { n: 'Вирішуйте і втрату доходу', d: 'Тяжке захворювання зазвичай означає й тривалий лікарняний. Заявляємо обидва, не лише одне.' },
      ],
      podklady: [
        'Медичний висновок із діагнозом і датою',
        'Виписка з лікарні',
        'Результати обстежень, на які посилається висновок',
        'Номер договору страхування і документ, що посвідчує особу',
        'Номер рахунку для виплати',
      ],
      pozor: 'Кожен договір має власний перелік діагнозів, власні визначення і власний період очікування. Що діє саме у вас, прочитаємо прямо у вашому договорі — загально цього сказати не можна.',
    },

    invalidita: {
      nadpis: 'Інвалідність',
      kdy: 'Стан здоров’я тривало поганий і повернення до роботи в попередньому обсязі нереальне.',
      kroky: [
        { n: 'Зателефонуйте мені на початку, а не наприкінці', d: 'До рішення минуть місяці. За цей час із платежами та бюджетом можна зробити багато.' },
        { n: 'Подайте заяву про пенсію по інвалідності', d: 'Її складають у територіальному управлінні соціального забезпечення або подають електронно.' },
        { n: 'Підготуйте медичні висновки заздалегідь', d: 'Стан здоров’я оцінює лікар-експерт, зазвичай за документацією. Що повніші документи, то рівніше йде процес.' },
        { n: 'Знайте, про що йдеться в рішенні', d: 'Про ступінь інвалідності за зниженням працездатності: I ступінь 35–49 %, II ступінь 50–69 %, III ступінь щонайменше 70 %. Законний строк для рішення — 90 днів.' },
        { n: 'Віднесіть рішення страховику', d: 'Більшість договорів посилається на визнаний ступінь інвалідності. Рішення збережіть, це ключовий документ.' },
      ],
      podklady: [
        'Документ, що посвідчує особу',
        'Повні медичні висновки',
        'Документи про освіту та огляд трудового шляху',
        'Професійна анкета, яку надішле управління соціального забезпечення',
        'Рішення про інвалідність і номер договору страхування',
      ],
      pozor: 'Визнання інвалідності державою і виплата з поліса — це дві окремі процедури. Страховик оцінює за текстом вашого договору і може дійти іншого висновку, ніж держава. Саме тому не залишайте це на себе.',
    },

    umrti: {
      nadpis: 'Смерть',
      kdy: 'Цю частину читає хтось близький. Тут немає нічого, що треба встигнути сьогодні.',
      kroky: [
        { n: 'Зробіть лише необхідне', d: 'Свідоцтво про смерть видає РАЦС, зазвичай це організовує похоронна служба. Попросіть кілька примірників, вони знадобляться в кількох місцях.' },
        { n: 'Зателефонуйте мені', d: 'Вам не треба знати, що і де було оформлено. Я маю перелік договорів, які ми робили, і пройду їх з вами.' },
        { n: 'Повідомте страховиків', d: 'Повідомити без зайвого зволікання вимагає § 2796 Цивільного кодексу. Повідомимо разом, і за договорами в інших установах теж.' },
        { n: 'Подайте заяву на пенсію у зв’язку з втратою годувальника', d: 'Пенсія вдові, вдівцю чи дитині не призначається сама — про кожну треба подати заяву в управління соціального забезпечення.' },
        { n: 'Не поспішайте з великими рішеннями', d: 'Продаж квартири, розірвання договорів, дострокове погашення кредиту. Нічого з цього не на перші тижні.' },
      ],
      podklady: [
        'Свідоцтво про смерть — краще кілька примірників',
        'Документ, що посвідчує особу того, хто звертається',
        'Номери договорів страхування і кредитних договорів',
        'Свідоцтво про шлюб, свідоцтва про народження дітей',
        'Номер рахунку для виплати',
      ],
      pozor: 'Борги зі смертю самі не зникають, їх вирішують у спадковому провадженні. У деяких кредитів страхування здатності платити оформлене прямо в кредитному договорі, а не в полісі життя. Тому ми звернемося і до банку.',
    },

    skoda_na_majetku: {
      nadpis: 'Шкода майну',
      kdy: 'Залиття, пожежа, буревій, крадіжка зі зломом — або шкода, яку ви заподіяли комусь іншому.',
      kroky: [
        { n: 'Зупиніть шкоду, якщо це безпечно', d: 'Перекрити воду, вимкнути електрику. Якщо є небезпека, телефонуйте 112.' },
        { n: 'Сфотографуйте все, перш ніж почнете прибирати', d: 'Фото й відео — найсильніший доказ. Пошкоджені речі не викидайте, поки їх не побачив страховик.' },
        { n: 'При зломі та при ДТП викликайте поліцію', d: 'Без протоколу поліції таку шкоду підтвердити важко.' },
        { n: 'Повідомте страховика і зв’яжіться зі мною', d: 'Без зайвого зволікання, § 2796 Цивільного кодексу. Допоможу і з переліком шкоди, і з заявою.' },
        { n: 'Опишіть шкоду позиція за позицією', d: 'Що це було, коли придбано, за скільки. Чеки, рахунки, гарантійні талони — усе, що маєте.' },
      ],
      podklady: [
        'Фотографії та відео пошкоджень',
        'Перелік пошкоджених речей з цінами',
        'Чеки, рахунки, гарантійні талони',
        'Номер договору страхування і документ, що посвідчує особу',
        'Протокол поліції при зломі або ДТП',
      ],
      pozor: 'Не починайте ремонт до домовленості зі страховиком — багато договорів вимагають огляд техніком. А якщо ви заподіяли шкоду комусь іншому, нічого не визнавайте і не платіть, поки ми це разом не пройдемо.',
    },
  },

  /* === AUTO: klíče vytažené z jazykových ternárů (scripts/i18n-ternary-codemod.js) === */
  /* BLOK:auto START — generuje scratchpad/slovnik.py, ručně needitovat */
  auto: {
    aIEmailBulkModal: {
      aiFiltrujePise: 'AI фільтрує + пише…',
      cileni: 'Націлювання:',
      hromadnyAiMailSmartemailing: 'Масова AI-розсилка (Smartemailing безкоштовно)',
      jmeno: "Ім'я",
      klientu: 'клієнтів',
      klientuOdpovidaFiltru: 'клієнтів відповідає фільтру',
      klientumOtazka: 'клієнтам?',
      n2NahledEmailuPlaceholders: '2. Попередній перегляд email (заповнювачі підставляться при надсиланні)',
      odeslano: 'Надіслано:',
      opravduOdeslatEmail: 'Справді надіслати email',
      osloveni: 'Звертання',
      poradce: 'Консультант',
      posliVsemCoNemaji: 'Надішли всім, хто не має пенсійного, що триває акція + CTA на дзвінок…',
      prepsano: 'Розпізнано',
      prijemci: 'Одержувачі',
      prijmeni: 'Прізвище',
      prikladyPosliVipKlientum: 'Приклади: „надішли VIP клієнтам новини про ČNB“ · „надішли всім, хто підписав життєве страхування, інформацію про партнера“ · „усім активним пораду щодо податків 2026“',
      selhalo: 'не вдалося',
      skrytSeznamPrijemcu: 'Сховати список одержувачів',
      spustitKampan: 'Запустити кампанію →',
      teloTemplate: 'Текст (шаблон):',
      uspesne: 'успішно',
      vybratVse: 'Вибрати всіх',
      vyfiltrovatKlientyNapsatEmail: 'Відфільтрувати клієнтів + Написати email',
      zadniKlientiNeodpovidajiFiltru: 'Жоден клієнт не відповідає фільтру',
      zadny: 'Жодного',
      zobrazitUpravitSeznam: 'Показати / змінити список',
    },
    aIEmailDraftModal: {
      aiEmailKlientovi: 'AI email клієнту',
      aiPise: 'AI пише…',
      aiVygenerujEmail: 'AI, згенеруй email',
      emailOdeslanSipka: 'Лист надіслано',
      emailOhledne: 'email щодо...',
      klientNemaEmailVCrm: '(у клієнта немає email у CRM)',
      klienta: 'клієнта',
      komu: 'Кому:',
      komuKlientACeho: 'Кому (клієнт) і чого стосується (угода)',
      n2NahledEmailu: '2. Попередній перегляд email',
      obchod: 'угода',
      odeslatNa: 'Надіслати на',
      odeslatZMehoGmailu: 'Надіслати з мого Gmailu',
      odpovezNaEmailOd: 'Дай відповідь на лист від',
      posliPavloviInfoO: 'Надішли Павлу інформацію про сервісну зустріч у вівторок о 14:00…',
      posliPredJmenem: 'Надішли',
      prepsanoKlikniAiVygeneruj: 'Розпізнано — натисни „AI згенеруй“',
      sPredmetem: 'з темою',
      spustitNahravani: 'Почати запис',
      telo: 'Текст:',
      volitelneObchod: "Необов'язково: угода…",
      zastavitNahravani: 'Зупинити запис',
    },
    academyLayout: {
    },
    analyzaTiskPage: {
      analyza: 'Аналіз',
      castka: 'Сума',
      celkem: 'Разом',
      cisteJmeni: 'Чисті активи',
      coBudemeResit: 'Що ми разом вирішуватимемо',
      coBudemeResitUvod: 'Ці теми випливають із цифр, які ми разом переглянули. Ми розглянемо їх під час підготовки вашого плану.',
      coJeProVasDulezite: 'Що для вас важливо',
      coOcekavate: 'Чого ви очікуєте від співпраці',
      coOdVasPotrebuji: 'Що мені від вас потрібно',
      coZnamenajiPenize: 'Що для вас означають гроші',
      dalsiKrok: 'Наступний крок',
      dedictviBudouciProdej: 'Спадщина / майбутній продаж',
      dluhy: 'Борги',
      dobryDenPosilamShrnuti: 'Доброго дня, надсилаю підсумок нашого фінансового аналізу. Перегляньте, будь ласка, і за потреби напишіть.',
      financniAnalyza: 'Фінансовий аналіз',
      financniMajetek: 'Фінансові активи',
      firmaPodnikani: 'Фірма / підприємництво',
      investiceOpfEtfAkcie: 'Інвестиції (пайові фонди/ETF, акції)',
      majetekCelkem: 'Активи разом',
      naZakladeTechtoCisel: 'На основі цих цифр запропонуємо наступні кроки у фінансовому плані — озвіться, і ми пройдемо їх разом.',
      nasobekVydaju: '{n}× витрат',
      nemovitostiAutoCennosti: 'Нерухомість / авто / цінності',
      nezavazne: 'Цей огляд не є зобов’язуючим. Він слугує основою для підготовки фінансового плану. Конкретні рішення, продукти та їхні умови ми обговоримо й погодимо лише під час реалізації.',
      penzijniDip: 'Пенсійне / DIP',
      pocetCilu: 'Кількість цілей',
      prijmyMes: 'Доходи / міс',
      pripravujiAnalyzu: 'Готую аналіз…',
      registrace: 'Реєстрація {regulator}: {cislo}',
      rezerva: 'Резерв',
      schuzkaDne: 'Зустріч {datum}',
      shrnutiNasiAnalyzy: 'Підсумок нашого аналізу: чисті активи {jmeni}, фінансовий резерв {rezerva}× місячних витрат і вільний грошовий потік {cf} на місяць.',
      shrnutiSchuzky: 'Підсумок зустрічі',
      splatkaMes: 'Платіж/міс',
      stavebniSporeni: 'Будівельне накопичення',
      strucneOSituaci: 'Коротко про вашу ситуацію',
      terminDomluvime: 'Дату наступної зустрічі ми узгодимо разом.',
      uctyAHotovost: 'Рахунки та готівка',
      vaseCile: 'Ваші цілі',
      volnyCashFlowMes: 'Вільний грошовий потік / міс',
      vydajeMes: 'Витрати / міс',
      zavazkyCelkem: 'Зобов’язання разом',
      zaznamZAnalyzy: 'Запис аналізу від {datum} у сьогоднішніх цінах. Слугує основою для фінансового плану; оновлюємо його при зміні ситуації.',
      /* Vzhled zeleného PDF (25. 10. 2026): podnadpisy, velká karta volných peněz, pata listu. */
      dulezitUpozorneni: 'Важливе застереження',
      majetekAZavazky: 'Майно та зобов’язання',
      prijmyAVydaje: 'Доходи та витрати',
      volneProstredky: 'Вільні кошти',
      volneProstredkyPopis: 'Скільки вам щомісяця залишається після витрат і виплат за кредитами.',
      vydajePodleKategorii: 'Витрати за категоріями',
      vytvoreno: 'Створено {datum}',
    },
    businessCharts: {
      celkemBj: 'Разом BJ',
      cil: 'ціль',
      nastavMesicniPlanBj: 'Встановіть місячний план BJ у розділі Cíle & Rocks.',
      plneniPlanuBj: 'Виконання плану (BJ)',
      provize: 'Комісія',
    },
    cashflowGraf: {
      cashflowVCaseMesicni: 'Грошовий потік у часі — щомісячний надлишок',
      naKonci: 'наприкінці',
      nastupHypoteky: 'початок іпотеки',
      poNastupuHypoteky: 'після початку іпотеки',
      prebytekKlesneJenO: '). Надлишок зменшиться лише на різницю між платежем і орендою, що відпадає, а не на весь платіж.',
      splatkaHypotekySeV: 'Платіж за іпотекою відображається у грошовому потоці лише від отримання коштів (рік ',
      start: 'старт',
    },
    casovaOsaCilu: {
      casovaOsa: 'Часова шкала',
      casovaOsaCiluOd: 'Часова шкала цілей від сьогодні до року',
      chybi: 'бракує',
      dnes: 'сьогодні',
      dosahne: 'досягне',
      kdySeKteryCil: 'Коли яка ціль буде досягнута',
      let: 'років',
      letech: 'років',
      letos: 'цього року',
      seNesplniChybiCelkem: 'не буде досягнуто — бракує загалом',
      ve: 'у',
      vekKlientaUMilniku: 'Вік клієнта біля віх відсутній — в аналізі немає дати народження.',
      zatimZadnyCilOsa: 'Поки що жодної цілі — шкала заповниться, щойно додаси першу.',
    },
    cilCinema: {
      dalsi: 'Далі',
      poznamkaPoradce: 'Нотатка консультанта ',
      poznamkaPoradceN: 'Нотатка консультанта (N)',
      prehrat: 'Відтворити',
      proKlientskyRezimTu: 'Для клієнтського режиму тут поки немає затвердженого контенту',
      scenyTohotoCileCekaji: 'Сцени цієї цілі очікують на затвердження методики. У режимі консультанта їх можна відтворити — клієнту їх поки не показуємо.',
      zavrit: 'Закрити',
      zpet: 'Назад',
    },
    clientDealsTab: {
      archiv: 'Архів',
      archivovane: 'Архівовані',
      klikniNovyObchodPro: 'Натисніть «Нова угода», щоб її створити.',
      nacitam: 'Завантажую…',
      nelzeNacistObchodyKlienta: 'Не вдалося завантажити угоди клієнта',
      obchodySeNepodariloNacist: 'Не вдалося завантажити угоди',
      otevritDetail: 'Відкрити деталі',
      prohraZruseno: 'Програно/Скасовано',
      rozjednane: 'У процесі',
      rozjednaneObchody: 'Угоди в процесі',
      vProcesu: 'у процесі',
      vyhrane: 'Виграні',
      vyhraneSmlouvy: 'Виграно → договори',
      zadneObchodyVTeto: 'У цій категорії немає угод',
      zkusToZnovuNejde: 'Спробуйте ще раз — це не порожній список, а помилка зʼєднання.',
    },
    clientMapPage: {
      kratkyServis: 'Короткий сервіс',
      seznamKlientu: 'Список клієнтів ({n})',
      vTrase: 'у маршруті: {n}',
      zavritSeznam: 'Закрити список',
      shlukKlientuOne: '{n} клієнт',
      shlukKlientuFew: '{n} клієнти',
      shlukKlientuMany: '{n} клієнтів',
      shlukAOkoli: '{mesto} та околиці',
      shlukStejneMisto: 'В одному місці',
      shlukPriblizit: 'Наблизити до всіх',
      shlukZavrit: 'Закрити список групи',
      shlukTip: '{pocet} — натисніть для списку',
      shlukZpet: 'Назад до списку ({n})',
      shlukSeznam: 'Клієнти в групі',
      typKlient: 'Клієнт',
      typNabor: 'Набір',
      typLead: 'Лід',
      typOstatni: 'Інше',
    },
    composeEmailModal: {
      dobryDen: 'Доброго дня,…',
      eMailOdeslan: 'Лист надіслано',
      komuNapisJakykolivE: 'Кому * — впиши будь-який email (клієнта вибирати не мусиш)',
      neboVyberKlientaVolitelne: "…або вибери клієнта (необов'язково — підставить email і збереже в його історію)",
      nelzeOdeslat: 'Не вдалося надіслати',
      novyEMail: 'Новий лист',
      obchodniPripadVolitelneVazba: "Угода (необов'язково — зв'язок для пізнішого пошуку)",
      odeslat: 'Надіслати',
      predmet: 'Тема *',
      predmetEMailu: 'Тема листа',
      teloZpravy: 'Текст повідомлення *',
      zadejPredmet: 'Вкажи тему',
      zadejPrijemce: 'Вкажи одержувача',
      zadejTextEMailu: 'Введи текст листа',
      zavrit: 'Закрити',
      zrusit: 'Скасувати',
    },
    dashboardPage: {
      akademieProNovackyKlikaci: 'Академія для новачків · покроковий провідник',
      coJePoradenstviEtika: 'Що таке фінансове консультування, етика, процес, продукти, обдзвін, аргументація, укладання угод + тести.',
      vitejteVBeplan: 'Ласкаво просимо до beplan ',
      zNovackaProfikKrok: 'Від новачка до професіонала — крок за кроком',
    },
    dealAutocomplete: {
      najdiObchodniPripadKlienta: 'Знайти угоду клієнта…',
      nejprveVyberKlienta: 'Спершу виберіть клієнта…',
      obchodniPripad: 'Угода',
      vymazat: 'Очистити',
      zadnyOtevrenyObchodniPripad: 'Клієнт не має жодної відкритої угоди.',
    },
    dealResultModal: {
      datumUzavreni: 'Дата закриття',
      duvodVolitelneZapiseSe: 'Причина (необовʼязково — запишеться в історію)',
      konecnaCenaBj: 'Кінцева ціна (BJ)',
      naprKlientZustalU: 'Напр. клієнт залишився у своєму банку…',
      zpet: 'Назад',
    },
    diarPageV3: {
      adresatJmenoAdresa: 'Адресат (ім’я + адреса)',
      aktivitaUlozena: 'Активність збережено',
      aktivitaVytvorena: 'Активність створено',
      aktualizovano: 'оновлено',
      bezKlienta: 'Без клієнта?',
      cehoSeToTyka: 'Чого це стосується',
      celodenni: 'Цілоденна',
      celyDen: ' · цілий день',
      dalsiMesic: 'Наступний місяць',
      dalsiUcastniciVolitelneOddelene: 'Інші учасники (необов’язково, через кому)',
      dalsich: 'ще',
      datum: 'Дата *',
      delkaUpravena: 'Тривалість змінено',
      diarVeTvemKalendari: 'Щоденник у твоєму календарі',
      dnesVelke: 'Сьогодні',
      doba: 'Тривалість',
      doplnitKlienta: 'Додати клієнта',
      editaceAktivity: 'Редагування активності',
      editovat: 'Редагувати',
      importZGoogleCalendar: 'Імпорт з Google Calendar до Щоденника',
      importovano: 'Імпортовано',
      jindeOnline: 'Деінде / онлайн',
      kalendar: 'Календар',
      kalendarSeAktualizujeKazdou: 'Календар оновлюється приблизно щогодини.',
      kdeSeSchuzkaKona: 'Де відбувається зустріч',
      klient: 'Клієнт',
      klientNemaVyplnenouAdresu: 'У клієнта не заповнена адреса — впиши її та вибери з підказок.',
      kopirovat: 'Копіювати',
      mistoAdresa: 'Місце / адреса',
      mistoVolitelne: 'Місце (необов’язково)',
      nacitam: 'Завантаження…',
      nacitamOdkaz: 'Завантаження посилання…',
      nacitamStav: 'Завантаження стану…',
      nacteSchuzkyAUdalosti: 'Завантажить зустрічі та події з твого календаря Google (-7 днів до +6 місяців) і покаже їх у Щоденнику як активності. Зустрічі, створені через beplan, не дублюються.',
      napisAdresuMestoMisto: 'впиши адресу / місто / місце…',
      nastaveni: 'Налаштування',
      nastaveniKalendare: 'Налаштування календаря',
      neboJenExportApple: 'Або лише експорт (Apple / Outlook)',
      nelzeNacistUkoly: 'Не вдалося завантажити завдання',
      nelzePresunoutUkol: 'Не вдалося перенести завдання',
      nelzeUlozit: 'Не вдалося зберегти',
      nelzeVratit: 'Не вдалося повернути',
      nenaplanovano: 'Не заплановано',
      nepodariloSeNacistOdkaz: 'Не вдалося завантажити посилання',
      nepodariloSeVytvoritKlienta: 'Не вдалося створити клієнта',
      nepovedloSe: 'Не вдалося',
      nizka: 'Низький',
      nova: 'Нова',
      novaAktivita: 'Нова активність',
      novouPridasTlacitkemAktivita: 'Нову додаси кнопкою «Активність».',
      novyBezpecnostniKodVytvoren: 'Новий код безпеки створено',
      obchodniPripadVolitelne: 'Угода (необов’язково)',
      obnovit: 'Оновити',
      odchozi: 'Вихідний',
      odkazNaTvujKalendar: 'Посилання на твій календар',
      polozkaUzNeniDostupna: 'Запис уже недоступний',
      pracovniDobaDo: 'Робочий час до',
      pracovniDobaOd: 'Робочий час від',
      predchoziMesic: 'Попередній місяць',
      preskoceno: 'пропущено',
      presunuto: 'Перенесено',
      presunutoDoCasu: 'Перенесено на час',
      prichozi: 'Вхідний',
      pridatDoAppleOutlook: 'Додати в Apple / Outlook',
      pridatDoGoogle: 'Додати в Google',
      priorita: 'Пріоритет',
      resitel: 'Відповідальний',
      schovatRealizovane: 'Сховати виконані',
      smerHovoru: 'Напрямок дзвінка',
      soukromaAktivita: '(приватна активність)',
      soukromaAktivita2: 'Приватна активність',
      stavPropojeniSeNepodarilo: 'Не вдалося визначити стан з’єднання.',
      stredni: 'Середній',
      synchronizace: 'Синхронізація',
      synchronizaceSelhala: 'Синхронізація не вдалася',
      synchronizovatDoGoogleApple: 'Синхронізувати з Google / Apple / Outlook',
      synchronizovatTed: 'Синхронізувати зараз',
      synchronizuji: 'Синхронізація…',
      tahniProCas: '⇅ тягни, щоб змінити час',
      telefonniCislo: 'Номер телефону',
      tentoDen: 'Цей день',
      typAktivity: 'Тип активності',
      uKlienta: 'У клієнта',
      uKlientaProste: 'У клієнта',
      uNas: 'У нас',
      uNasVKancelari: 'У нас в офісі',
      ucet: 'Обліковий запис',
      ukladam: 'Збереження…',
      ukolNaplanovan: 'Завдання заплановано',
      uloziSeDoDiare: 'Збережеться в щоденнику',
      ulozitJakoSoukromou: 'Зберегти як приватну',
      ulozitZmeny: 'Зберегти зміни',
      vice: 'Більше',
      volnoAiZavolejA: 'Вільно · подзвони A-лідам',
      vraceno: 'Повернено',
      vratit: 'Повернути',
      vseNaplanovano: 'Усе заплановано.',
      vychoziDelkaAktivity: 'Стандартна тривалість активності',
      vychoziTypNoveAktivity: 'Стандартний тип нової активності',
      vychoziZobrazeni: 'Стандартний вигляд',
      vysledekHovoruPoDokonceni: 'Результат дзвінка (після завершення)',
      vysoka: 'Високий',
      vytvorit: 'Створити',
      zacatek: 'Початок *',
      zadejDatumACas: 'Введи дату й час',
      zadejNazevPredmet: 'Введи назву / тему',
      zadneNadchazejiciAktivity: 'Немає найближчих активностей',
      zavritFiltry: 'Закрити фільтри',
      zitra: 'Завтра',
      zkopirovano: 'Скопійовано',
      zkopirujOdkazRucne: 'Скопіюй посилання вручну',
      zkusitZnovu: 'Спробувати ще раз',
      zmenitBezpecnostniKod: 'Змінити код безпеки',
      zmenitBezpecnostniKodStary: 'Змінити код безпеки? Старе посилання перестане працювати і календарі доведеться додати заново.',
      zmeskany: 'Пропущений',
      zobrazeni: 'Вигляд',
      zobrazitZrusene: 'Показати скасовані',
      zrusit: 'Скасувати',
    },
    dotaznikCteni: {
      definiceDotaznikuSeNenacetla: 'Визначення анкети не завантажилося.',
      hodnotuSeNepodariloNacist: 'Не вдалося завантажити значення.',
      rodneCisloACislaDokladu: 'Ідентифікаційний номер і номери документів приховані. Показ — це свідомий крок, і за 20 секунд значення знову сховається.',
      skryt: 'Сховати',
      zobraziSeNa20Sekund: 'Показ на 20 секунд',
      zobrazit: 'Показати',
    },
    editableGoals: {
      akontace: 'Перший внесок %',
      akontace2: 'Перший внесок',
      akontaceSplnenaNa: 'Перший внесок виконано на',
      budouciNavyseniVkladu: 'Майбутнє збільшення внесків',
      castJeVProduktech: 'частина лежить у продуктах',
      cil: 'Ціль',
      cilSplnen: 'ціль досягнута',
      dleProfiluVolnaHotovost: '(за профілем). Вільна готівка',
      dobaSplaceniLet: 'Термін погашення (років)',
      financniNezavislostRenta: 'Фінансова незалежність — рента',
      horizont: 'горизонт',
      horizontLet: 'Горизонт (років)',
      hypotecniCil: 'Іпотечна ціль',
      jakNasetritAkontaci: 'Як накопичити перший внесок',
      jednorazove: 'Одноразово',
      jednorazoveDnes: 'Одноразово сьогодні',
      kombinace: 'Комбінація',
      ktereSeMusiZrusit: 'які довелося б розірвати (часто невигідно). Краще інвестувати',
      let: 'років',
      letDosahnes: 'років ти досягнеш',
      letDriv: 'років раніше!',
      letDvojtecka: 'років:',
      letPrida: 'років додасть',
      mesicne: 'Щомісяця',
      navrhniPravidelne: 'Запропонувати регулярно',
      navrhniZMajetku: 'Запропонувати з активів',
      nutnoRusitZvazPravidelne: 'їх довелося б розірвати. Розглянь регулярні внески.',
      o: 'на',
      pocitanoSVynosem: 'Розраховано з дохідністю',
      potrebnyKapital: 'Потрібний капітал',
      pravidelne: 'Регулярно',
      pravidelne2: 'регулярно',
      pridatNavyseniNapr: 'Додати збільшення (напр. після підвищення зарплати)',
      realne: '% реально',
      renta: 'рента',
      splatka: 'платіж',
      splneni: 'Виконання',
      splneni2: 'виконання',
      tolikVolneHotovostiKlient: 'Стільки вільної готівки клієнт не має',
      uver: 'кредит',
      volneMaKlientJen: 'Вільно клієнт має лише',
      za: 'через',
      zaLet: 'Через (років)',
      zaVelke: 'Через',
      zadneCileZAnalyzy: 'Жодних цілей з аналізу. Додай цілі в аналізі та повернись сюди, щоб налаштувати, як їх досягти.',
      zamcenoVProduktech: 'заблоковано у продуктах',
      zbytekJeVeStavebku: '— решта у будівельному накопиченні/пенсійному',
    },
    finMatematikaPage: {
      cerpaniNekonecna: '♾️ безкінечна',
      chartRok: 'Рік',
      dobaCerpani: 'Строк виплат',
      dobaCerpaniRenty: 'Строк виплати ренти',
      dobaSplaceni: 'Строк погашення',
      dopocitatPole: 'Порахувати це поле',
      financniMatematika: 'Фінансова математика',
      frekvenceUroku: 'Частота нарахування відсотків',
      hodnotaInvestice: 'Вартість інвестиції',
      jednorazovyVklad: 'Одноразовий внесок',
      jednotkaLet: 'років',
      kartaCelkemVlozite: 'Разом внесете',
      vstupniPoplatek: 'Вступна комісія з цільової суми',
      kartaPoplatek: 'Комісія',
      kartaCilovaCastka: 'Цільова сума',
      vetaPoplatek: 'Вступна комісія з цільової суми {cilova} — {poplatek} ({pct} %), утримується одразу на початку.',
      dipPrepinac: 'Податкова знижка DIP',
      dipBez: 'Без DIP',
      dipS: 'З DIP',
      kartaStatDip: 'Держава поверне (DIP)',
      kartaSDip: 'Разом з DIP',
      vetaDip: 'З DIP держава за {roky} років поверне з податку {stat} (15 % внесків, макс. 7 200 Kč на рік). Реінвестовано зросте до {hodnota}, з них {vynos} дохід. Умова: виплата не раніше 60 років і після 10 років договору, інакше знижку доплачують.',
      rozpisPoLetech: 'Розпис за роками',
      thSplaceno: 'Сплачено',
      thUrok: 'Відсотки',
      thJistina: 'Основний борг',
      thZustatek: 'Залишок',
      thVlozeno: 'Внесено разом',
      thVynos: 'Дохід разом',
      thHodnota: 'Вартість',
      thVyplaceno: 'Виплачено разом',
      thCelkem: 'Разом',
      tiskZadani: 'Вхідні дані',
      tiskVysledek: 'Результат',
      tiskPripraveno: 'Підготовлено {datum}',
      upozorneniUver: 'Модельний розрахунок ануїтетного платежу за незмінної ставки на весь строк. Фактичний платіж, РПСН і комісії визначить пропозиція банку.',
      upozorneniInvestice: 'Модель із фіксованою річною дохідністю, не гарантія. Реальна дохідність коливається і може бути від’ємною; минулі чи модельні доходи не гарантують майбутніх.',
      upozorneniRenta: 'Модель виплат із фіксованою дохідністю, не гарантія. Реальна дохідність коливається, рента може тривати коротше.',
      kartaCelkemZaplatite: 'Разом заплатите',
      kartaDoba: 'Строк',
      kartaDobaCerpani: 'Строк виплат',
      kartaJednorazovyVklad: 'Одноразовий внесок',
      kartaKonecnaHodnota: 'Кінцева вартість',
      kartaMesicniRenta: 'Щомісячна рента',
      kartaMesicniSplatka: 'Щомісячний платіж',
      kartaPocatecniHodnota: 'Початкова вартість',
      kartaPravidelnaMes: 'Регулярно щомісяця',
      kartaRentaCelkem: 'Рента разом',
      kartaSplatnost: 'Строк погашення',
      kartaUrokPa: 'Відсоток річних',
      kartaVyseUveru: 'Сума кредиту',
      kartaZTohoUroky: 'З того відсотки',
      kartaZhodnoceniPa: 'Дохідність річних',
      konecnaHodnotaInvestice: 'Кінцева вартість інвестиції',
      mesZkratka: 'міс',
      mesicniSplatka: 'Щомісячний платіж',
      pocatecniHodnota: 'Початкова вартість',
      pravidelnaMesInvestice: 'Регулярна міс. інвестиція',
      splatnost: 'Строк',
      urokovaSazba: 'Процентна ставка',
      vetaInvestice: 'З {vlozeno} внесених ви зробите {konec} — це {navic} додатково завдяки складним відсоткам. Час працює за вас.',
      vetaRenta: '{kapital} виплачує вам {renta}/{mes} упродовж {roky} {rok} (разом {celkem}).',
      vetaRentaNekonecna: '{kapital} при {sazba} % приносить більше, ніж ви знімаєте — рента БЕЗКІНЕЧНА. Це фінансова незалежність. 🎉',
      vetaUver: 'Кредит {castka} на {roky} {rok} під {sazba} % — разом заплатите {celkem}, з того {uroky} становлять відсотки.',
      vlozenoCelkem: 'Загалом вкладено',
      vyseMesicniRenty: 'Розмір щомісячної ренти',
      vyseUveru: 'Сума кредиту',
      vyvojHodnotyInvestice: 'Динаміка вартості інвестиції',
      vyvojRentyCerpaniKapitalu: 'Динаміка ренти (використання капіталу)',
      vyvojZustatkuUveru: 'Динаміка залишку кредиту',
      zhodnoceniPA: 'Дохідність річних',
      zhodnoceniRentyPA: 'Дохідність ренти річних',
      zustatek: 'Залишок',
      zustatekUveru: 'Залишок кредиту',
    },
    funnelCalc: {
      casPrida: 'Час додасть ',
      cil: 'ціль',
      coJsiVlozil: 'Що ви вклали',
      investiceNeseRizikoHodnota: 'Інвестиція несе ризик — вартість коливається і може впасти; минулі результати не гарантують майбутніх.',
      jakByToRostlo: 'Як би це зростало з часом',
      mesicnePotrebujesOdkladat: 'Щомісяця треба відкладати',
      orientacniVypocetZeSlozeneho: 'Орієнтовний розрахунок за складними відсотками.',
      potrebnyKapitalNaRentu: 'Потрібний капітал на ренту: ',
      spocitejSiToNazivo: 'Порахуйте самі — наживо',
    },
    globalSearch: {
      beplanGlobalniHledani: 'Beplan · глобальний пошук',
      chytreHledani: 'Розумний пошук',
      hledat: 'Пошук…',
      hledatCmdCtrlK: 'Пошук (Cmd/Ctrl + K)',
      hledatKlientaUkolHashtag: 'Шукати клієнта, завдання, #хештег, телефон…',
      navigaceOtevritEscZavrit: '↑↓ навігація · ↵ відкрити · ESC закрити',
      otevrit: 'Відкрити',
      ukoly: 'Завдання',
      zadneVysledkyPro: 'Немає результатів для',
      zavrit: 'Закрити',
    },
    globalTabBar: {
      hledat: 'Пошук',
      nastaveni: 'Налаштування',
      odhlasit: 'Вийти',
      zavritVse: 'Закрити все',
      zavritVsechnyZalozky: 'Закрити всі вкладки',
    },
    gmailConnectCard: {
      gmailOdpojen: 'Gmail відключено',
      gmailPropojen: 'Gmail підключено',
      nacitamStavGmailPropojeni: 'Завантажую стан підключення Gmail…',
      odpojeniSelhalo: 'Не вдалося відключити',
      odpojit: 'Відключити',
      opravduOdpojitGmailNebudes: 'Справді відключити Gmail? Ви не зможете надсилати листи прямо з CRM.',
      pripojSvujGmail: 'Підключіть свій Gmail',
      pripojitGmail: 'Підключити Gmail',
      propojeniGmailuZatimNeni: 'Підключення Gmail поки не увімкнене',
      serverNeodpovedelNevimeJestli: 'Сервер не відповів. Невідомо, чи Gmail підключений — спробуйте оновити сторінку.',
      stavEMailuSe: 'Не вдалося визначити стан ел. пошти',
    },
    gmailMessageDetail: {
      komu: 'Кому',
      kopie: 'Копія',
      nepodariloSeNacistEmail: 'Не вдалося завантажити лист',
      odpovedetAi: 'Відповісти за допомогою AI',
      otevritVGmailu: 'Відкрити в Gmailu',
      textZpravyTadyNezobrazime: 'Текст повідомлення тут не показуємо',
    },
    hypotecniPipelinePage: {
      excelLikePrehledVsech: 'Excel-подібний огляд усіх відкритих іпотек і рефінансувань · клік на рядок відкриє угоду',
      hypotekaZalozena: 'Іпотеку створено',
      kanbanPohledPouzivaObchodni: 'Kanban-вигляд використовує Панель продажів — для іпотек радимо табличний вигляд. ',
      klikNaRadekDetail: 'Клік на рядок → деталі угоди',
      nelzeNacistHypoteky: 'Не вдалося завантажити іпотеки',
      otevritObchodniNastenku: 'Відкрити Панель продажів ›',
      pripraveno: 'готово',
      tabulka: 'Таблиця',
      tentoTyden: 'Цього тижня',
      urgentni: 'терміново',
      uverovaPipeline: 'Кредитна воронка',
      vLimitu: 'у межах строку',
      vReseni: 'у роботі',
      vse: 'Усі',
      vyzadujeAkci: 'Потребує дії',
      zadneHypotekyNeodpovidajiFiltru: 'Жодна іпотека не відповідає фільтру.',
    },
    investicniStrategiePage: {
      celkemVlozi: 'Разом внесе',
      cenaNecinnosti: 'Ціна бездіяльності',
      citat: '«Скільки це достатньо? Стільки, щоб дохід покривав ваші витрати. Тоді ви фінансово незалежні — гроші працюють за вас.»',
      coSiKlientOdnese: 'Що клієнт забере із собою',
      doba: 'Строк',
      hodnotaLegenda: 'Вартість',
      inflaceNiciHotovost: 'Інфляція знищує готівку',
      inflaceText: 'Гроші в готівці тихо втрачають вартість. За {roky} {rok} при 3 % інфляції з {vlozeno} залишиться купівельна спроможність лише ~{realne}. Не робити нічого — теж рішення, і найдорожче.',
      investicniStrategie: 'Інвестиційні стратегії',
      kapital: 'Капітал',
      kapitalZustava: '…а капітал {kapital} залишається недоторканим для дітей.',
      kino: 'Кіно',
      kinoTooltip: 'Запустити кінопрезентацію',
      klientTip: 'Важить не стільки «скільки» — важливо почати й дати часу працювати.',
      mes: 'міс',
      mesSlash: '/міс',
      mesicniVklad: 'Щомісячний внесок',
      naKonciMa: 'У кінці має',
      nekonecnaMesicniRenta: 'Безкінечна щомісячна рента ({sazba} річних)',
      nekonecnaRentaSazba: 'Безкінечна рента ({sazba} річних)',
      nevymyslimeNicNovehoKopirujeme: 'Ми не вигадуємо нічого нового — копіюємо найкращих',
      odklada: 'Відкладає',
      odkladaHodnota: '{castka}/{mes} × {roky} {rok}',
      podnadpisA: 'Покажіть клієнту, що його план спирається на стратегії, які роками працюють для найбільших фондів світу. Клік на стратегію → порахуєте її на 100 роках реальних даних. Або запустіть ',
      podnadpisB: ' з інтерактивною картою світу.',
      podnadpisTucne: 'кінопрезентацію',
      prezentovatKlientovi: 'Показати клієнту',
      procInvestovat: 'Навіщо інвестувати',
      procNedojde: 'Чому рента ніколи не закінчиться',
      rentaMilion: 'кожен мільйон = ~{naMilion} {symbol} щомісяця назавжди',
      rentaNavzdy: 'Рента назавжди',
      rentaText: 'З {kapital} при {sazba} річних маєте ренту {renta}/{mes} — назавжди, а капітал залишається. Це фінансова незалежність.',
      rentaVetaA: 'Коли ви знімаєте лише ',
      rentaVetaB: ' (а не тіло), капітал ніколи не вичерпається. При {sazba} річних ',
      rentaVetaC: ' — і мільйон вам однаково залишається.',
      rentaVynos: 'дохід',
      silaSlozeneho: 'Сила складних відсотків',
      spocitat: 'Порахувати на 100 роках',
      svoboda: 'Свобода',
      urokText: 'За {roky} {rok} ваші гроші самі заробляють {rust}. Що раніше почнете, то довше складні відсотки працюють на вас.',
      urokZUroku: 'Відсоток від відсотка',
      vlozenoLegenda: 'Внесено',
      vynosPa: 'Дохідність річних',
      zTohoVydelaly: 'З того заробили самі гроші',
      zadejteVklad: 'Введіть внесок — покажіть клієнту його зростання',
    },
    klientiPage: {
      aresNapoviADoplni: 'ARES підкаже й доповнить',
      chybaPriUkladani: 'Помилка при збереженні: ',
      coMaUMe: 'Що має у мене',
      coVlastni: 'Що має у власності',
      dnes: 'сьогодні',
      jmeno: 'Імʼя',
      jmenoJePovinne: 'Імʼя обовʼязкове',
      jmenoNazev: 'Імʼя / назва',
      karty: 'Картки',
      kategorie: 'Категорія',
      kategorieKlienta: 'Категорія клієнта',
      klientPridan: 'Клієнта додано',
      klientTrvaleSmazan: 'Клієнта видалено назавжди',
      klientVracenDoPipeline: 'Клієнта повернуто у воронку',
      kos: 'Кошик',
      kosJePrazdny: 'Кошик порожній',
      kosOdstraneniKlientiKdykoli: 'Кошик — вилучені клієнти; їх можна будь-коли відновити',
      kosSeNepodariloNacist: 'Не вдалося завантажити кошик',
      moznaDuplicita: 'Можливий дублікат',
      moznaDuplicitaPotvrdZe: 'Можливий дублікат — підтвердіть, що все одно хочете додати',
      naborKandidat: 'Набір — кандидат',
      nacitamKos: 'Завантажую кошик…',
      nactenoZAres: 'Завантажено з ARES',
      napisteJmenoNeboNazev: 'Введіть імʼя або назву клієнта…',
      nepovedloSeUlozit: 'Не вдалося зберегти',
      neznamaChyba: 'невідома помилка',
      obnoveniSeNezdarilo: 'Не вдалося відновити',
      obnovit: 'Відновити',
      odlozenDoSkupinyBez: 'відкладено до групи без інтересу',
      odlozitZatimBezZajmu: 'Відкласти — поки без інтересу',
      odstraneniKlientiSeObjevi: 'Вилучені клієнти зʼявляться тут — їх можна будь-коли повернути у воронку.',
      otevrit: '→ відкрити',
      poznamkaPriZakladani: 'Нотатка при створенні',
      pridejKlientaVCrm: 'Додайте клієнта у CRM Pipeline.',
      prijmeni: 'Прізвище',
      resetovatFiltry: 'Скинути фільтри',
      smazaniSeNezdarilo: 'Не вдалося видалити: ',
      smazatNavzdy: 'Видалити назавжди',
      tabulka: 'Таблиця',
      telefon: 'Телефон',
      titoKlientiSeVelmi: 'Ці клієнти дуже схожі — відкрийте когось із них або підтвердіть, що справді хочете створити новий запис.',
      trvaToDlouhoKlikni: 'Довго вантажиться? Натисніть, щоб оновити',
      trvaleSmazatNevratne: 'Видалити назавжди — без повернення',
      typologie: 'Типологія',
      ukladam: 'Зберігаю…',
      ulozit: 'Зберегти',
      ulozitAOtevrit: 'Зберегти та відкрити',
      vKosiKlientiNejsou: 'у кошику · клієнти не видалені — будь-коли їх відновите',
      vKosiOd: 'у кошику з',
      vimZeToNeni: 'Знаю, що це не дублікат — хочу створити новий запис',
      volat: 'Подзвонити',
      vratitDoPipeline: 'Повернути у воронку',
      vratitKlientaZpetDo: 'Повернути клієнта у воронку',
      vse: 'Усі',
      vymazat: 'Очистити',
      vymazatVsechnyPokrocileFiltry: '× Очистити всі розширені фільтри',
      zadniKlienti: 'Немає клієнтів.',
      zadnyKlientNeodpovidaHledani: 'Жоден клієнт не відповідає пошуку.',
      zadnyKlientNeodpovidaKombinaci: 'Жоден клієнт не відповідає комбінації фільтрів. Спробуйте звузити вибір або скинути фільтри.',
      zdroj: 'Джерело',
      zpetNaKlienty: 'Назад до клієнтів',
    },
    leadgenCalculatorPremium: {
      orientacniVypocetPresnouNabidku: '* Орієнтовний розрахунок. Точну пропозицію підготую після короткої консультації.',
    },
    newDealModal: {
      klientaSeNepodariloZalozit: 'Не вдалося створити клієнта',
      krokAnalyza: 'Аналіз',
      krokCerpani: 'Отримання коштів',
      krokPodpis: 'Підпис',
      krokProces: 'Процес',
      napisNejdrivJmenoNoveho: 'Спочатку впиши ім’я нового клієнта в пошук',
      pravdepodobnostUzavreni: 'Ймовірність закриття',
      ulozitAOtevrit: 'Зберегти й відкрити',
      zadejNazevObchodnihoPripadu: 'Введи назву угоди',
    },
    notFoundPage: {
      strankaNenalezena: 'Сторінку не знайдено',
      tatoAdresaNeexistujeNebo: 'Такої адреси не існує або вона змінилася.',
      zpetNaHlavniStranku: 'Повернутися на головну',
    },
    notesPanel: {
      klikneteAPistePrazdny: 'Натисніть і пишіть — чистий аркуш, який збережеться сам.',
      neulozenoUlozisteProhlizeceJe: 'Не збережено — сховище браузера заповнене',
      sTimtoStitkemNic: 'З цією міткою нічого немає.',
      ulozeno: 'Збережено',
      vse: 'Усі',
      zatimZadnaPoznamka: 'Поки що жодної нотатки',
    },
    notificationCenter: {
      celyDen: 'весь день',
      pripominkySeNepodariloNacist: 'Не вдалося завантажити нагадування.',
      tohleNeniStavMas: 'Це НЕ означає, що все зроблено — дані не завантажилися.',
    },
    obchodyPage: {
      akce: 'Дія',
      akciSeNepodariloDokoncit: 'Не вдалося завершити дію',
      archivSoftDelete: 'Архів · М’яке видалення',
      cekaNaVyplatu: 'очікує на виплату',
      cekamNaProvizi: 'Чекаю на комісію',
      duvod: 'Причина',
      faze: 'Етап',
      kategorieKlienta: 'Категорія клієнта',
      klient: 'Клієнт',
      klientObchod: 'Клієнт · Угода',
      n1SchuzkaPredstaveni: '1-ша зустріч — представлення',
      nacitamOdlozeneObchody: 'Завантаження відкладених угод…',
      nelzeNacistArchiv: 'Не вдалося завантажити архів',
      nelzePresunoutObchod: 'Не вдалося перенести угоду',
      nelzeReaktivovat: 'Не вдалося реактивувати',
      nelzeSmazat: 'Не вдалося видалити',
      obchod: 'Угода',
      obchodVytvoren: 'Угоду створено',
      odlozene: 'Відкладені',
      odlozeneObchodySoftDelete: 'Відкладені угоди — архів м’якого видалення, з якого угоди можна знову реактивувати',
      odlozeno: 'Відкладено',
      odlozenychObchoduMuzesKdykoliv: 'відкладених угод — можеш будь-коли реактивувати',
      otevritSlozku: 'Відкрити теку',
      otevritSlozkuKlienta: 'Відкрити теку клієнта',
      planUzavreni: 'План — закриття',
      prejitNaSloupec: 'Перейти до колонки',
      presunutoDo: 'Перенесено до',
      pretahnoutObchodSem: 'Перетягни угоду сюди',
      pridatAktivitu: 'Додати активність',
      produkt: 'Продукт',
      prohra: 'Програно',
      prohraUzavrenoK: 'Програно — закрито',
      reaktivovat: 'Реактивувати',
      spustitPrezentaciFinancnihoPlanu: 'Запустити презентацію фінансового плану — веде клієнта до підпису',
      spustitPrezentaciPro1: 'Запустити презентацію для 1-ї зустрічі — веде клієнта до фінансового аналізу',
      trvaleSmazatZDatabaze: 'Назавжди видалити з бази даних (незворотно)',
      typ: 'Тип',
      vazena: 'Зважено:',
      vratitObchodDoAktivni: 'Повернути угоду в активний pipeline',
      vyhraSmlouva: 'Виграно → Договір',
      vyhraUzavrenoK: 'Виграно — закрито',
      zadneObchody: 'Немає угод',
      zadneOdlozeneObchody: 'Немає відкладених угод',
      zruseno: 'Скасовано',
      zrusenoK: 'Скасовано',
    },
    onePagePlanPage: {
      dnesSPlanemAz: 'сьогодні · з планом аж до',
      dobryDenPosilamVas: 'Доброго дня, надсилаю ваш фінансовий план. Перегляньте, будь ласка, і за потреби напишіть.',
      financniNezavislost: 'Фінансова незалежність',
      financniPlan: 'Фінансовий план',
      financniPlanNaJedne: 'Фінансовий план на одній сторінці',
      financniZdravi: "Фінансове здоров'я",
      financniZdraviDnesS: "Фінансове здоров'я (сьогодні → з планом)",
      hypotekouSplatka: 'іпотекою · платіж',
      jednorazove: 'одноразово',
      kapital: 'капітал',
      kapitalProRentu: 'Капітал для ренти',
      klesajiciCastkyKryjeDeficit: 'спадні суми · покриває дефіцит родини, борги та цілі',
      mesicneNaCileA: 'Щомісяця на цілі та ренту',
      mesicneProCile: 'Щомісяця на цілі (погоджено)',
      naAnalyzu: 'До аналізу',
      naplneniFinancniNezavislosti: 'Досягнення фінансової незалежності',
      naplneno: 'виконано',
      narativCislaVDnesnichCenach: 'Цифри подано в сьогоднішніх цінах. Реальна дохідність понад інфляцію: акції {akcie} %, облігації {dluhopisy} %, готівка {cash} %; середня дохідність накопичення ≈ {prumer} % на рік. Ренту знімаємо {renta} % на рік від капіталу. Минулі результати не гарантують майбутніх.',
      narativPlanNaJednuStranu: 'Фінансовий план на одну сторінку — ваше «навіщо», три кроки на наступні 90 днів і як ви досягнете цілей та ренти.',
      navrhReseni: 'Пропозиція рішення',
      nepodariloSeNacistData: 'Не вдалося завантажити дані',
      oLetDrive: ' · на {n} років раніше',
      ochranaPrijmuVarianta: 'Захист доходів ({varianta})',
      planJeVDnesnich: 'План подано в сьогоднішніх цінах. Реальна дохідність понад інфляцію: акції {akcie} %, облігації {dluhopisy} %, готівка {cash} %; середня дохідність накопичення ≈ {prumer} % на рік. Ренту знімають {renta} % на рік від капіталу. Рекомендації залежать від наданих даних; оновлюємо їх приблизно раз на 3 роки або при зміні ситуації. Минулі результати не гарантують майбутніх.',
      prijmyRodiny: 'Доходи родини',
      pripravujiPlan: 'Готую план…',
      procToVsechnoDelame: 'Навіщо ми все це робимо — вашими словами',
      rentaFinancniNezavislost: 'Рента (фінансова незалежність)',
      vDnesnichCenachRealne: 'у сьогоднішніх цінах (реально, понад інфляцію)',
      vasPoradce: 'Ваш консультант',
      vaseBilance: 'Ваш баланс',
      vaseCileAJak: 'Ваші цілі та як їх досягнемо',
      volnyCashFlow: 'Вільний грошовий потік',
      vydajeSplatky: 'Витрати + платежі',
      zkontrolujtePripojeni: "Перевірте з'єднання і спробуйте ще раз.",
      zkusitZnovu: 'Спробувати ще раз',
    },
    pipelineFunnelCompact: {
      bjVPipeline: 'BJ у pipeline',
      pipelinePoFazich: 'Воронка за етапами',
      vymazatFiltr: 'Очистити фільтр',
    },
    planPrehled: {
      azPoCilovemDatu: ' — лише після цільової дати',
      rentaOdVekuPenzijka: ' — до ренти з {vek} років: рента +{castka}',
      bezCerpaniZdroju: 'без використання джерел',
      cerpani: 'Отримання коштів',
      doraziV: 'надійде у ',
      finMajetek: 'Фін. активи',
      investice: 'Інвестиції',
      jednorazove: 'одноразово',
      let: 'років',
      letech: ' роках',
      likvidni: 'Ліквідні',
      likvidni2: 'ліквідні',
      mesice: 'місяця',
      nefinancni: 'Нефінансові',
      nezapojeno: 'Незадіяно',
      od: 'з',
      ostatniUcty: 'Інші рахунки',
      penzijkoRenta: 'Пенсійне → рента',
      poPlanu: 'Після плану:',
      pravidelne: 'регулярно',
      prebytek: 'Надлишок',
      precerpanoO: 'перевитрата на',
      precerpanoTolikKlient: '— перевитрата, стільки клієнт не має',
      prubeznyPrehled: 'Поточний огляд',
      stavebko: 'Будівельне накопичення',
      stavebko2: 'будівельне накопичення',
      volnyPrebytek: 'вільний надлишок',
      za: 'через',
      zbyva: 'залишається',
      zbyvaLikvidni: 'залишається ліквідних',
    },
    planPrezentacePage: {
      abysteDosahliSvychCilu: '„…щоб ви досягли своїх цілей **якнайбезпечнішим шляхом**.“',
      abysteNemuselRusit: '„Щоб вам не довелося зі збитком закривати стратегічні інвестиції через несподівані витрати. Гроші йдуть на ощадний рахунок (~3 %) — тут **ідеться не про збагачення, а про спокій**. Шість зарплат у резерві означають, що план ніхто не зачепить.“',
      akcie: 'акції',
      akciePodilyVNejvetsich: '„Акції — це частки у найбільших компаніях світу. Короткостроково вони коливаються, але це **єдине, що надійно перемагає інфляцію на довгій дистанції** — а гроші на рахунку тим часом гарантовано втрачають купівельну спроможність.“',
      aleJePotrebaPro: '„…але для цього треба щось зробити.“',
      anoCimZacneme: 'Так — з чого почнемо?',
      barva: 'колір',
      bezJednorazovehoVkladu: 'без одноразового внеску',
      bezPlanuUcetInflace: 'Без плану (рахунок + інфляція)',
      chtelJsteVeta: 'Ви хотіли **{castka}** за **{roky}**.',
      chtelJsteVetaBezTerminu: 'Ви хотіли **{castka}**. Термін ми ще не визначили.',
      chtelJsteVetaHned: 'Ви хотіли **{castka}** — і **зараз**.',
      chybi: 'бракує',
      chybiCastka: 'бракує {castka}',
      cilPokryt: '✓ ціль покрита',
      ciluFinancnePodlozeno: 'цілей фінансово забезпечено',
      coDnesPlanOhrozuje: 'Що сьогодні загрожує плану',
      coToCelkemStoji: 'Скільки це коштує разом',
      coZaToMate: 'Що ви за це маєте',
      dalsiZpetNamitkyEsc: '→ далі · ← назад · ? заперечення · Esc вихід',
      davaVamToSmysl: 'Це для вас **має сенс?**',
      deficitBezOchrany: 'Дефіцит без захисту',
      den: '/день',
      dluhopisy: 'облігації',
      dnesSiVymenimeRole: 'Сьогодні ми поміняємося ролями.',
      doRokaBudeteMit: 'За рік ви матимете',
      dobraZpravaMatePlan: 'Хороша новина: **у вас є план.**',
      dobreALevneZajistit: 'Добре й недорого захистити майно та майбутні доходи',
      domluvenoCoKdoPripravi: 'Домовилися — хто що підготує',
      doplnitLikvidniRezervu: 'Поповнити ліквідний резерв',
      dotazySiProsimNechte: '„Запитання, будь ласка, залиште на кінець — спершу хочу, щоб ви побачили цілу картину, всю стратегію.“',
      druhaBezpecnejsiCesta: 'А друга ще краща: **ми підемо безпечнішим шляхом.**',
      druhaNezavislostDrive: 'А друга ще краща: **незалежність на {roky} раніше.**',
      dveBudoucnostiVyberteSi: 'Два майбутні — оберіть',
      financniMajetekCelkem: 'Фінансові активи разом',
      glideRokTooltip: 'рік {rok}: акції {akcie} % · облігації {dluhopisy} % · готівка {hotovost} %',
      hotovost: 'готівка',
      iVNejhorsimObdobi: 'Навіть у **найгіршому** з {pocet} історичних періодів план завершився на **{vysledek}** — усе одно {kde} вкладених {vlozeno}. __Вирішує час, а не вгадування ринку.__',
      invalidita: 'інвалідність',
      investice: 'інвестиції',
      jaPoradce: 'Я (консультант)',
      jedenZOsmiInvalidita: 'Тривала інвалідність — ми страхуємо **зарплату, а не смерть**',
      jednorazoveOdkud: 'Одноразово — звідки',
      jenVicNavic: 'Лише **{vklad}** додатково → через {roky} це **{kdobru}** на плюс. Це робить час, а не ви.',
      kazdyCilSiVezme: 'Кожна ціль забирає свою частку — і **ви бачите, що лишиться**.',
      kazdyMilionRentaMesicne: '„кожен мільйон = {naMilion} щомісяця, назавжди“',
      kdeJsteDnesStartovni: 'Де ви сьогодні — стартова лінія',
      kdybysteInvestovalPred20: '„Якби ви інвестували 20 років тому…“ — 100 років історії',
      kdybysteTenhlePlanJel: 'Якби ви вели цей план **{roky}** будь-коли за останні 100 років…',
      kdybysteTohleInvestoval: 'Якби ви інвестували це останні **{roky}**, за **реальними даними** сьогодні мали б:',
      krok_bezVsSPlanem: 'БЕЗ vs. З ПЛАНОМ',
      krok_cile: 'ЦІЛІ',
      krok_coDelateDobre: 'ЩО ВИ РОБИТЕ ДОБРЕ',
      krok_dveZpravy: 'ДВІ НОВИНИ',
      krok_kdeJsteDnes: 'ДЕ ВИ СЬОГОДНІ',
      krok_kroky: 'КРОКИ',
      krok_motivace: 'МОТИВАЦІЯ',
      krok_proc: 'ЧОМУ',
      krok_rezerva: 'РЕЗЕРВ',
      krok_rizika: 'РИЗИКИ',
      krok_rozpocet: 'БЮДЖЕТ',
      krok_silaCasu: 'СИЛА ЧАСУ',
      krok_souhrn: 'ПІДСУМОК',
      krok_uvod: 'ВСТУП',
      krok_vaseCesta: 'ВАШ ШЛЯХ',
      krok_zaver: 'ЗАВЕРШЕННЯ',
      krytiInvalidita: 'Інвалідність',
      krytiInvaliditaProc: 'тривала втрата доходу, яку резерв не покриє — а витрати ще й зростають',
      krytiOdskodne: 'Щоденна виплата за травму',
      krytiOdskodneProc: 'травма зупиняє дохід з першого дня — без періоду очікування',
      krytiPn: 'Тимчасова непрацездатність',
      krytiPnProc: 'лікарняні покривають лише частину доходу; виплата вирівнює бюджет з {mesic}-го місяця',
      krytiSmrt: 'Смерть',
      krytiSmrtProc: 'замінює дохід родині — витрати, платежі та цілі; спадна сума = дешевше',
      krytiTrvaleHodnota: '{castka} з прогресією',
      krytiTrvaleNasledky: 'Постійні наслідки травми',
      krytiTrvaleProc: 'тяжчі наслідки = вища виплата (у нашій моделі щонайбільше 2,8× суми — у страховиків різниться)',
      mamProVasDve: 'У мене для вас дві новини',
      mate: 'У вас є:',
      mateZCehoStavet: 'вам є на чому будувати — це величезна перевага',
      mesicneNaStejnouRentu: 'щомісяця на ту саму ренту',
      mezernik: 'ПРОБІЛ',
      minuleJsemSePtal: '„Минулого разу питав я, а говорили ви — сьогодні говоритиму я.“',
      motivAplikace: 'Тема застосунку',
      motorPlanu: 'Це двигун плану — **{rok}/рік**, з якими працюватимемо далі. Нічого понад те.',
      moznaJeTechCisel: 'Можливо, цифр забагато — але все просто',
      naCileARentu: ' на цілі та ренту',
      naNavrh: 'До пропозиції',
      naZacatkuJsteRekl: '„На початку ви сказали, що найважливіше для вас — **„{hodnota}“** — і це саме той план, як цього досягти. Якщо це має сенс, домовмося, з чого почнемо.“',
      nadPrebytek: 'Ваш вільний грошовий потік — {prebytek} на місяць, план на {rozdil} більший. Разом пройдемо, звідки взяти різницю.',
      nadVlozenymi: 'вище за',
      namitka1: '„Мені треба подумати.“',
      namitka1Odpoved: '„Розумію — що саме вас непокоїть? Цифри, страхування чи сума? Розберімо це зараз, щоб вам не довелося думати самому.“ (Знайди СПРАВЖНЄ заперечення — „подумати“ це прикриття.)',
      namitka2: '„Обговорю це з дружиною/чоловіком.“',
      namitka2Odpoved: '„Цілком слушно — це сімейне рішення. Домовмося про зустріч утрьох, щоб партнерові пояснив я, а вам не довелося захищати цифри, які не ваші.“ (Ніколи не давай клієнту продавати замість тебе.)',
      namitka3: '„Зараз у мене немає на це грошей.“',
      namitka3Odpoved: '„План не коштує нічого понад те — він працює лише з надлишком, який ви самі погодили. А якщо він менший, почнемо з меншої суми. Коли краще почати: сьогодні чи через 5 років на 40 % дорожче?“ (Покажи слайд Ціна очікування.)',
      namitka4: '„Страхування — це викидання грошей.“',
      namitka4Odpoved: '„Погоджуюся — погане страхування так. Саме тому ми скасовуємо дорогі поліси й лишаємо тільки захист зарплати, щоб дефіциту в бюджеті ніколи не сталося. Це парашут — ви платите не за падіння, а за виживання.“ (Поверніться на слайд Ризики.)',
      namitka5: '„Акції — це азартна гра / боюся кризи.“',
      namitka5Odpoved: '„На короткій дистанції ви маєте рацію — тому в плані є резерв і гальмо. Але покажу вам 100 років даних: кожна криза закінчувалася і ринок повертався. Азартна гра — це залишити гроші лежати й напевно віддати їх інфляції.“ (Відкрий історичний калькулятор — політ крізь кризи.)',
      nasporenoZaLet: 'Накопичено за {roky}',
      navrhKrytiJeV: 'пропозицію покриття наведено в аналізі',
      nejdrivToCoUz: 'Спершу те, що ви вже робите добре',
      nejdrivVyplnAnalyzu: 'Спочатку заповніть аналіз',
      nemateZadneSpatneDluhy: 'У вас немає жодних поганих боргів',
      nepojisteno: 'Не застраховано: {co}',
      nesplaceneZavazky: 'Непогашені зобовʼязання',
      neuplnaRezerva: 'Неповний резерв',
      nezSePustimeDo: '„Перш ніж братися за цілі, раджу захистити ваше **майно** і насамперед **майбутні доходи**.“',
      nezUkazuPlan: 'Перш ніж показати план, покажу, **звідки ми стартуємо**.',
      nezZacnemeInvestovatOchranime: 'Перш ніж почати інвестувати — захистимо вас',
      nicJsmeSiNevymysleli: '„Ми нічого не вигадали — ми почали з того, що ви маєте сьогодні, і розподілили це між вашими цілями. Нуль в останньому рядку означає, що кожна ваша гривня і кожен місячний надлишок мають своє завдання.“',
      nikdyNebudeteMitVice: '„У вас ніколи не буде **більше часу, ніж сьогодні**. Кожне зволікання коштує грошей.“',
      oMinMene: 'На **{vklad}** менше → через {roky} це **{mene}** менше. Бачите різницю?',
      ochrana: 'захист',
      osvc: ' · ФОП',
      pilirMajetek: 'майно та відповідальність',
      pilirPrace: 'робота',
      pilirPrijem: 'ваш дохід (страхування життя)',
      poKazdemCiliVidite: 'Після кожної цілі ви бачите, **скільки залишається**.',
      poblizVlozenym: 'близько до',
      pochvalaMajetek: 'Ви створили фінансові активи {castka}',
      pochvalaOdkladate: 'Ви відкладаєте {pct} % доходу ({castka})',
      pochvalaRezerva: 'Ваш резерв наповнено на {pct} %',
      posunteSiSamiMesicni: 'Посуньте самі — щомісячна інвестиція:',
      povinne: 'обовʼязкові',
      pravidelne: 'регулярно',
      pravidelneInvestovatVolneCash: 'Регулярно інвестувати вільний грошовий потік',
      prebytekNeznamy: 'Вільний грошовий потік ще не порахований — додамо витрати й порівняємо суму.',
      prezentaceFinancnihoPlanu: 'Презентація фінансового плану',
      prijem: 'дохід',
      pripravujiPrezentaci: 'Готую презентацію…',
      proTentoHorizontA: 'Для цього горизонту та внесків поки бракує історичних вікон.',
      projitZnovu: 'Пройти ще раз',
      protiPlanu: 'проти плану',
      prvniJeDobra: 'Перша хороша: **ваші цілі вдасться виконати.**',
      realneVynosyNadInflaci: 'Реальна дохідність понад інфляцію (SBBI 1926–2026). Минула дохідність не гарантує майбутньої — це діапазон, а не гарантія.',
      renta: 'рента',
      rentaJeZatimNa: 'Рента поки що на **{pct} %** — і ми точно знаємо, що з цим робити.',
      rentierskePortfolio5035: 'рентний портфель 50 / 35 / 15',
      rentierskePortfolioDrziSe: 'Рентний портфель (тримається й під час виплат)',
      rizikoDluhy: '{castka} — у разі події залишається родині',
      rizikoInvalidita: 'у разі інвалідності бракує {castka}',
      rizikoRezerva: 'покрито на {pct} % із 6 зарплат',
      rocneRealne: 'річних у реальному вимірі',
      rodinaZajistenaAtSe: 'захист доходу родини',
      rozdilProtiPlanu: 'Різниця проти плану',
      rozdilZaLet: 'Різниця за {roky}: {castka}',
      rozkliknoutNa100Letech: 'Відкрити на 100 роках історії + стратегія',
      rozlozeniVCaseGlide: 'Розподіл у часі — ближче до кінця менше акцій',
      rozlozitSoucasneUsporyNa: 'Розподілити наявні заощадження на цілі',
      rozpocetPlanuKamJdou: 'Бюджет плану — куди йдуть ваші гроші',
      sNefinancnim: 'разом із нефінансовими',
      sPlanem: 'З планом',
      scenarOptimisticky: 'Оптимістичний сценарій',
      scenarOptimistickyPozn: 'найкращі 5 % періодів',
      scenarPesimisticky: 'Песимістичний сценарій',
      scenarPesimistickyPozn: 'найгірші 5 % періодів (навіть великі кризи)',
      scenarRealisticky: 'Реалістичний сценарій',
      scenarRealistickyPozn: 'медіана — половина періодів була кращою',
      silaCasuCoRika: 'Сила часу — що каже 100 років історії',
      silaSlozenehoUroceniRoste: 'Сила складних відсотків зростає з часом',
      smrt: 'смерть',
      souhrnDoporuceniCelehoPlanu: 'Підсумок рекомендацій усього плану',
      splneno: 'виконано',
      spravneZajisteniJeZaklad: '„Правильний захист — основа плану. Ми захищаємо не поліс, а те, що ви назвали найважливішим: **„{hodnota}“**.“',
      stavimeNaDobrychZakladech: '„Ми будуємо на добрій основі — тепер доведімо це до кінця.“',
      stejnePenizeStejnyClovek: '„Ті самі гроші, та сама людина — інші рішення.“',
      styl: 'стиль',
      tahakNaNamitkyJen: 'Шпаргалка щодо заперечень (тільки для тебе)',
      tahakNaNamitkyKlient: 'Шпаргалка щодо заперечень (клієнт не бачить)',
      takhleToDopadneKdyz: '„Ось як це закінчиться, якщо нічого не робити…“ — натисніть',
      toNedela8Z: 'регулярне відкладання — основа всього подальшого',
      tohleJeVaseCestaRok: 'Це ваш шлях — **рік за роком**.',
      tohleJeVychoziBod: '„Це відправна точка. Тепер покажу, як з неї побудуємо весь план.“',
      tohleNejsouStatistiky: '„Це не статистика — це **ваш бюджет**. Того дня, коли не буде зарплати, родині бракуватиме __{castka}__. Щомісяця.“',
      uCileBezTrzniho: 'для цілі без ринкового ризику',
      udelJstePrvniKrok: 'Ви зробили перший крок — замовили собі план',
      ukazuVamCoUz: 'Я покажу вам, **що ви вже робите добре**, **де ви, можливо, втрачаєте гроші** — і головне, __на скільки відсотків вдасться досягти ваших цілей__ і що для цього потрібно зробити.',
      ukolKlient1: 'відсканувати наявні договори (до пʼятниці)',
      ukolKlient2: 'заповнити інвестиційну анкету',
      ukolKlient3: 'надіслати запитання щодо плану поштою',
      ukolPoradce1: 'договори страхування відповідно до плану',
      ukolPoradce2: 'комісійний договір (шлях до інвестування)',
      ukolPoradce3: 'налаштування портфелів згідно з планом',
      vasMajetek: 'Ваше майно',
      vaseCestaKamTecou: 'Ваш шлях — куди течуть ваші гроші',
      vaseCestaKdySe: 'Ваш шлях — коли яка ціль здійсниться',
      vaseCileJedenPo: 'Ваші цілі — одна за одною',
      vaseCileStojiNa: '▲ ваші цілі тримаються на…',
      ve25MajiLide: '„У 25 людям здається, що треба насолоджуватися життям. У 35 дохід іде на іпотеку. У 45 платять за школи дітям. А в 60 дізнаються, що **вже пізно**. Ви починаєте сьогодні.“',
      vejdeSeDoPrebytku: '= вкладається у вільний грошовий потік {prebytek} на місяць, який ми порахували.',
      vetsinaLidiFinanceOdklada: 'перший крок часто найважчий',
      vetsinaRodinNemaAni: 'резерв — це основа, на якій стоїть увесь план',
      vkladNavicNeZ: 'додатковий внесок, не з нинішніх заощаджень',
      vlozenoCelkem: 'Загалом вкладено **{celkem}** ({jedn} одноразово + {mes}) · стратегія {akcie} % акції / {dluhopisy} % облігації',
      volneCashFlow: 'Вільний грошовий потік',
      volnyPrebytekKazdyMesic: 'Вільний надлишок щомісяця',
      vy: 'Ви',
      vyhovujeVamSchuzkaZase: '„Чи підходить вам зустріч знову в середу в той самий час?“',
      vypadekPrijmu: 'Втрата доходу',
      vzacnostGratuluji: 'рідкість — вітаю',
      zPrebytkuDokudNedoplnime: 'з надлишку, доки не поповнимо',
      zToho: 'з них',
      zaLet: ' (через {roky} р.)',
      zaLetBudeteMit: 'Через {roky} ви матимете',
      zaLetProste: 'через {roky} р.',
      zacnuDnes: 'почну СЬОГОДНІ',
      zadneZasadniRizikoZ: 'З аналізу не випливає жодного суттєвого ризику — чудова стартова позиція.',
      zdrojInvestice: 'Інвестиції та заощадження',
      zdrojInvesticePozn: 'працює на вас',
      zdrojLikvidni: 'Ліквідні (рахунки, готівка)',
      zdrojLikvidniPozn: 'доступні одразу',
      zdrojNefinancni: 'Нефінансові активи',
      zdrojNefinancniPozn: 'нерухомість, бізнес, спадщина',
      zivotniStyl: 'спосіб життя',
      zmeniloSeZaTen: '„Чи змінилося за цей тиждень щось важливе?“',
    },
    planVystupPage: {
      akceKoupit: 'Купити',
      akceNavysit: 'Збільшити',
      akcePonechat: 'Залишити',
      akceProdat: 'Продати',
      akcie2: 'Акції',
      alokaceDela92Vysledku: 'розподіл активів дає ~92 % результату',
      alokaceRadek: 'акції {akcie} % · облігації {dluhopisy} % · готівка {penize} %',
      alokaceStartGlide: 'Розподіл на старті. Що ближча ціль, то більше план переходить з акцій в облігації та готівку — останній рік перед ціллю повністю в готівці.',
      casuDost: 'Часу досить…',
      co: 'Що',
      coKdyProc: 'що / коли / чому',
      davkyOdhadPozn: 'Пенсія по інвалідності — орієнтовна оцінка за доходом; фактичну суму визначає орган соціального забезпечення за страховим стажем.',
      dluhopisy: 'Облігації',
      dnes: 'сьогодні',
      doporucenaAlokace: 'Рекомендований розподіл',
      doporucenePortfolio: 'Рекомендований портфель',
      doporuceniProVas: 'Рекомендації для вас',
      doporuceniVychazejiZPoskytnutych: 'Рекомендації ґрунтуються на наданих даних. Реальна дохідність понад інфляцію: акції {akcie} %, облігації {dluhopisy} %, готівка {cash} %; середня дохідність накопичення ≈ {prumer} % на рік. Ренту знімають {renta} % на рік від капіталу. Документ є робочою основою; його потрібно регулярно оновлювати. Минула дохідність не гарантує майбутньої.',
      doporucujemeDiverzifikovatMenove: 'Радимо диверсифікувати за валютою та регіонами (світ ~72 % США), фонди великих керуючих компаній з рейтингом Morningstar. Натхнення: Норвезький фонд, Нобелівський фонд.',
      financniNezavislost: 'Фінансова незалежність',
      financniNezavislostPoRealizaci: 'Фінансова незалежність після реалізації',
      horizont: 'Горизонт',
      hotovost2: 'Готівка',
      invalidita: 'Інвалідність',
      kapitalovaMetodaKlesajiciPojistn: 'Капітальний метод (спадні страхові суми): покриває дефіцит доходу, борги та цілі після вирахування майна й надлишку домогосподарства, що залишилось. Капітал ренти враховується лише при інвалідності — після смерті його вже ніхто не отримує.',
      kdy: 'Коли',
      klient: 'Клієнт',
      klient1: 'Клієнт 1',
      klient2: 'Клієнт 2',
      konkretniProdukty: 'конкретні продукти',
      likvidniRezerva: 'Ліквідний резерв',
      mesicneInvestovatNaCile: 'Щомісяця інвестувати на цілі та ренту',
      narativ1: 'Це ваш фінансовий план — скільки щомісяця відкладати і як розподілити інвестиції, щоб досягти фінансової незалежності та інших цілей.',
      narativ2: 'Цифри наведені в сьогоднішніх цінах. Реальна дохідність понад інфляцію: акції {akcie} %, облігації {dluhopisy} %, готівка {cash} %; середня дохідність накопичення ≈ {prumer} % на рік. Ренту знімаємо {renta} % на рік від капіталу; план ми регулярно оновлюємо разом. Минула дохідність не гарантує майбутньої.',
      naseDoporuceni: 'Наші рекомендації',
      nehledejteVymluvy: 'НЕ ШУКАЙТЕ ВИПРАВДАНЬ',
      nejdrivVyplnAnalyzu: 'Спочатку заповніть аналіз',
      nepodariloSeNacistData: 'Не вдалося завантажити дані',
      oSveBudoucnostiRozhodnete: 'Вирішіть про своє майбутнє вже СЬОГОДНІ.',
      planProDosazeniFinancni: 'План досягнення фінансової незалежності та інших цілей',
      planVytvorenDne: 'План створено',
      poRealizaci: 'після реалізації',
      poznamka: 'Примітка:',
      prijmyCelkem: 'Доходи разом',
      proc: 'Чому',
      produkt: 'Продукт',
      profilDynamicky: 'Динамічний',
      profilKonzervativni: 'Консервативний',
      profilVychozi: 'за замовчуванням — інший профіль не обрано',
      profilVyvazeny: 'Збалансований',
      riziko: 'Ризик',
      rizikovyProfil: 'Профіль ризику',
      rizikovyProfil2: 'профіль ризику',
      skorePlanuDnesS: 'Оцінка плану (сьогодні → з планом)',
      smrt: 'Смерть',
      socialniDavky: ' Соціальні виплати: пенсія по інвалідності {inval}/міс{davka}.',
      socialniDavkyStarobni: ', пенсія за віком {starobni}/міс',
      soucasnePortfolio: 'Поточний портфель',
      souhrnMajetkuADluhu: 'Підсумок майна та боргів',
      splatkyUveru: 'Платежі за кредитами',
      vaseHodnoty: 'Ваші цінності',
      vaseStrategickeCile: 'Ваші стратегічні цілі',
      vasichHodnotACilu: 'ваших цінностей і цілей',
      vekNejlepsiCas: 'Вам сьогодні {vek} — найкращий час почати саме зараз.',
      vstupniInformace: 'вхідні дані',
      vydajeSpotreba: 'Витрати (споживання)',
      vymluva25: 'Ми молоді й тільки починаємо. Заробляємо ще небагато. Немає з чого відкладати.',
      vymluva35: 'Платіж за іпотеку і витрати забирають увесь дохід. А на відпустку ми теж маємо право!',
      vymluva45: 'Ми не можемо дозволити собі відкладати. Діти вчаться — найкраще за кордоном.',
      vymluva55: 'У цьому віці почати непросто.',
      vymluva65: 'Нам треба було почати багато років тому. Сьогодні вже пізно.',
      zajisteniPrijmuVPripade: 'захист доходу на випадок несподіваної події',
      zivotniPojisteni: 'Страхування життя',
    },
    popisZdroje: {
      jednorazovyVklad: 'одноразовий внесок',
    },
    portfolioDoctorPage: {
      aktualniTerAVstupni: '— актуальні TER і вхідні комісії із сайтів керуючих компаній',
      bezJmena: '(без імені)',
      briefProSchuzkuClaude: 'Бриф для зустрічі · Claude Haiku 4.5',
      briefSCnbCompliant: 'Бриф із формулюваннями, що відповідають вимогам ČNB',
      celkovyModelovyRozdilVe: 'Загальна модельна різниця на користь ETF · ',
      coDoctorUmi: 'Що вміє Doctor',
      diagnostikaSelhalaZkusTo: 'Діагностика не вдалася. Спробуй ще раз.',
      doporuceni: 'Рекомендація',
      etfAlternativa: 'Альтернатива ETF:',
      fondIsinNeboNazev: 'Фонд — ISIN або назва',
      hledamFondyNaWebu: 'Шукаю фонди в інтернеті… (15–30 с)',
      ie00b4l5y983NeboConseqActive: 'IE00B4L5Y983 або «Conseq Active Invest Dynamický»',
      investovanaCastkaKc: 'Інвестована сума (Kč)',
      janNovak: 'Ян Новак',
      kategorieFonduUrcujeEtf: 'Категорія фонду (визначає заміну на ETF)',
      klientJmeno: 'Клієнт (ім’я)',
      klientovyPoziceIsinCastky: 'Позиції клієнта (ISIN + суми)',
      knihovna35NejcastejsichCz: 'Бібліотека 35+ найпоширеніших чеських фондів з реальними параметрами',
      knihovnaFondu: 'бібліотека фондів',
      marketingoveSdeleniCnbEsma: 'Маркетингове повідомлення · застереження ČNB / ESMA',
      mesicneDaleKc: 'Щомісяця далі (Kč)',
      modelovaKalkulaceMinulaVykonnost: 'Модельний розрахунок. Минула дохідність не є гарантією майбутньої дохідності.',
      modelovyRozdilVeProspech: 'Модельна різниця на користь ETF:',
      naprConseqActiveInvest: 'Напр. «Conseq Active Invest Dynamický»',
      naprKlientSeBoji: 'Напр. «Клієнт боїться волатильності, дружина хоче на пенсію в 60».',
      nazevFondu: 'Назва фонду',
      nepodariloSeNacistDiagnostiku: 'Не вдалося завантажити діагностику.',
      odebratFond: 'Видалити фонд',
      otevritZdroj: 'Відкрити джерело ↗',
      overenoNaWebu: 'Перевірено в інтернеті:',
      posledniDiagnostiky: 'Останні діагностики',
      pozice: 'Позиція',
      poznamkaProAiBrief: 'Примітка для AI-брифу (необов’язково)',
      prepocitanoSTvymiHodnotami: 'Перераховано з твоїми значеннями',
      prepocitatSMymiHodnotami: 'Перерахувати з моїми значеннями',
      pridatIsin: 'Додати ISIN',
      pridejAlesponJednuPozici: 'Додай щонайменше одну позицію.',
      rozpoznaUcitsEtfPres: 'Розпізнає UCITS ETF через justETF (~2 800 фондів)',
      rucniZadani: 'ручне введення',
      smazaniSelhalo: 'Не вдалося видалити.',
      smazano: 'Видалено',
      smazat: 'Видалити',
      smazatTutoDiagnostiku: 'Видалити цю діагностику?',
      spocita20LetyDopad: 'Порахує 20-річний вплив комісій у Kč',
      spustitDiagnostikuPortfolia: 'Запустити діагностику портфеля',
      tentoFondJeUz: 'Цей фонд уже якісний.',
      terEtfCelkem: 'TER ETF разом',
      terFondCelkem: 'TER фонду разом',
      terMusiByt0: 'TER має бути 0–10 %',
      terPod05: 'TER нижче 0,5 % і накопичувальний ETF — міняти не рекомендуємо.',
      tvojeKnihovna: 'твоя бібліотека',
      ulozeniSelhalo: 'Не вдалося зберегти',
      uloziFondDoKnihovny: 'Збереже фонд у бібліотеці — наступного разу Doctor розпізнає його автоматично',
      ulozitDoKnihovny: 'Зберегти в бібліотеці',
      upravit: 'Редагувати',
      upravitParametryFondu: 'Редагувати параметри фонду',
      upravitRucne: 'Редагувати вручну',
      veProspechEtf: 'на користь ETF',
      vek: 'Вік',
      vlozenoCelkem: 'Загалом вкладено:',
      vstupni: 'Вхідна комісія (%)',
      vstupni010: 'Вхідна комісія 0–10 %',
      vstupni2: 'Вхідна комісія',
      vstupniPop: 'Вхідна ком.',
      vyberKategorii: 'Вибери категорію',
      vyplnNazevTerA: 'Заповни назву, TER і вхідну комісію',
      zadejteFondIsinNebo: 'Введіть фонд (ISIN або назву), скільки клієнт тримає та горизонт. За 30 секунд отримаєте модельну діагностику комісій, порівняння з альтернативою UCITS ETF і бриф на 3 абзаци для зустрічі.',
      zatimZadneUlozeneDiagnostiky: 'Поки що немає збережених діагностик.',
      zavrit: 'Закрити',
      zrusit: 'Скасувати',
    },
    postaPage: {
      aHlasTextPrikazem: 'і голосовою чи текстовою командою згенеруй новий лист.',
      aiEmailKlientovi: 'AI email клієнту',
      bezPristupuKeGoogle: 'Застосунок не має від адміністратора доступу до Google — на Gmail чекати не варто.',
      firemniEmailSmtp: 'корпоративний email (SMTP)',
      gmailPrepojenyPredek: 'Твій Gmail хоч і підключений, але для',
      gmailPrepojenyTucne: 'читання пошти в CRM',
      gmailPrepojenyZadek: 'потрібно розширити дозвіл. Досить ще раз пройти екран OAuth — це триває 10 секунд.',
      gmailZatimPripojitNejde: 'Gmail поки що підключити не вдається',
      hledatVGmailu: 'Шукати в Gmailu…',
      klikneTeToNa: 'Це перекине тебе на екран Google, де ти лише підтвердиш „Читати пошту“.',
      nacteniEmailuSelhalo: 'Не вдалося завантажити листи',
      neboKlikniNa: 'Або натисни',
      neboSpojka: ', або',
      nepodariloSeOveritGmail: 'Не вдалося перевірити Gmail',
      nepodariloSeSpustitReconnect: 'Не вдалося запустити повторне підключення',
      noveOpravneniPosta: 'Новий дозвіл Пошта',
      obnovit: 'Оновити',
      otevritNastaveni: 'Відкрити Налаштування',
      postaSeObjeviZde: "Пошта з'явиться тут, щойно в Налаштуваннях підключиш email. Маєш два варіанти:",
      pripojSiEMail: 'Підключи собі email',
      pripojitFiremniEMail: 'Підключити корпоративний email',
      sLibovolnouAdresou: 'і з будь-якою адресою (Seznam, Microsoft 365, @beplan.cz…). Підключиш його за кілька хвилин і писатимеш та читатимеш звідси.',
      slozkaDorucene: 'Вхідні',
      slozkaHvezdickovane: 'Із зірочкою',
      slozkaKoncepty: 'Чернетки',
      slozkaKos: 'Кошик',
      slozkaOdeslane: 'Надіслані',
      slozkaVse: 'Усі',
      slozky: 'Теки',
      smtpFungujeHned: 'Корпоративний email (SMTP) працює одразу',
      spojeniNaChviliSelhalo: "Зв'язок на мить обірвався. Спробуй ще раз — твій Gmail, найімовірніше, досі підключений.",
      tenFungujeSLibovolnou: '— він працює з будь-якою адресою і не чекає на Google.',
      vyberEmail: 'Вибери лист',
      zadneEmailyVeSlozce: 'У теці немає листів',
      zkusitZnovu: 'Спробувати ще раз',
      znovuPripojitGmail1: 'Підключити Gmail знову (1 клік)',
      zpetNaSeznam: 'Назад до списку',
    },
    publicBookingPage: {
      vybratTermin: 'Вибрати час',
    },
    radarPrilezitostiPage: {
      dalsi: 'ще',
      detailMezer: 'Деталі прогалин',
      kdeMaKlientMezeru: 'Де в клієнта прогалина — вибери, напиши, доведи до кінця.',
      klientuKOsloveni: 'клієнтів для звернення',
      kritickychMezer: 'критичних прогалин',
      napsatEMail: 'Написати e-mail',
      napsatNaWhatsapp: 'Написати у WhatsApp',
      obchodSeNepodariloZalozit: 'Угоду не вдалося створити.',
      obchodniPripadZalozen: 'Угоду створено.',
      obnovit: 'Оновити',
      odlozenoO30Dni: 'Відкладено на 30 днів.',
      odlozitNa30Dni: 'Відкласти на 30 днів',
      otevritSlozkuKlienta: 'Відкрити картку клієнта',
      prilezitostiCelkem: 'можливостей загалом',
      radarPrilezitosti: 'Радар можливостей',
      radarSeNepodariloNacist: 'Радар не вдалося завантажити. Спробуй за хвилину.',
      radarSeNepodariloNacist2: 'Радар не вдалося завантажити',
      sbalit: 'Згорнути',
      skenujiSmlouvyAAnalyzy: 'Сканую договори та аналізи…',
      skorePrilezitostiKlikniPro: 'Оцінка можливості — натисни для деталей',
      terminyFixaceVyrociHlida: 'Терміни (фіксація, річниця) відстежує Сервісний радар. Відкладені прогалини повернуться за 30 днів.',
      tohleNeniZadnePrilezitosti: 'Це НЕ «немає можливостей» — дані не завантажилися.',
      ukol: 'Завдання',
      ukolSeNepodariloVytvorit: 'Завдання не вдалося створити.',
      ukolVytvorenZa3: 'Завдання створено (за 3 дні).',
      vse: 'Усе',
      zadneOtevrenePrilezitosti: 'Немає відкритих можливостей.',
      zkusitZnovu: 'Спробувати ще раз',
    },
    reseniCilu: {
      akcie: 'акції',
      akontacePct: 'початковий внесок {pct} %',
      bezRustuNeboKroku: 'Без зростання або без кроків — шаблон нічого не заповнить.',
      bezpecneCerpani4: 'безпечне вилучення 4 %',
      castka: 'Сума',
      chybi: 'Бракує',
      chybiProkazatelnyPrijem: 'В аналізі немає підтвердженого доходу — застосунок не знає, від чого зарплата має зростати.',
      cil: 'ціль',
      cilJeVTomhle: 'Ціль з цими налаштуваннями недосяжна — число є лише орієнтовною межею.',
      cilKrytyJednorazoveBez: 'Ціль покрита одноразово — без регулярних інвестицій.',
      cilVelke: 'Ціль',
      cilovaCastka: 'Цільова сума',
      cimSeCilPoridi: 'Чим ціль оплачується',
      cnbDo36Let: 'ČNB: до 36 років достатньо 10 % власних коштів (LTV 90 %), інакше 20 %. 100% фінансування — рішення консультанта: 10 % ціни покриває кредит з будівельного накопичення. Платіж зʼявиться у грошовому потоці лише від отримання кредиту',
      dluhopisy: 'облігації',
      dopocitat: 'розрахувати',
      dopocteno: 'розраховано',
      dynamicky: 'Динамічний',
      glidePathAlokaceV: 'Поступове зниження ризику з часом',
      horizontVLetech: 'Горизонт у роках',
      hotovost: 'готівка',
      hypotekou: 'іпотекою',
      inflacePct: 'Інфляція (%)',
      jakToVyresit: 'Як це вирішити',
      jeNadVolnymPrebytkem: 'перевищує вільний надлишок домогосподарства',
      jednorazove: 'Одноразово',
      jednorazoveDnesNavic: 'Одноразово сьогодні (додатково)',
      jednorazovy: 'одноразовий',
      kCili: 'До цілі',
      kapital: 'капітал',
      kazdychLet: 'Кожні (років)',
      konzervativni: 'Консервативний',
      krokuRustu: 'кроків',
      ktereSeTuNezapocitava: ', яке тут не враховується.',
      let: 'років',
      mesice: 'місяця',
      mesicne: 'Щомісяця',
      mesicniRentaKlienta: 'Щомісячна рента клієнта',
      mimoradnyPrijem: 'позаплановий дохід',
      navrh: 'пропозиція',
      nbsAkontace: 'НБС: зазвичай 20 % власних коштів (LTV 80 %), 10 % лише як виняток. 100% фінансування — рішення консультанта: 10 % ціни покриває кредит з будівельного накопичення. Платіж зʼявиться у грошовому потоці лише від отримання кредиту',
      neresiSe: 'не використовується',
      nominalne: 'номінально',
      nominalneMinusInflace: 'номінально − інфляція',
      nominalneNeprekonaInflaci: 'номінально не перевищує інфляцію',
      oboji: 'Обидва',
      od: 'з',
      odR: 'з',
      odebratPritok: 'Видалити надходження',
      planSlibujeVicNez: '— план обіцяє більше, ніж клієнт сьогодні може собі дозволити.',
      pocetKroku: 'Кількість кроків',
      pocitaSeJakoSporeni: 'Рахується як НАКОПИЧЕННЯ: клієнт має накопичити всю суму {castka}. З кредитом накопичує лише перший внесок.',
      polovina: 'половина',
      posledni: 'останній',
      posledniRok100Hotovost: '— останній рік 100 % готівка: жодного ринкового ризику',
      pravidelnaInvestice: 'Регулярна інвестиція',
      pridat: 'Додати',
      pridatBudouciPritok: 'Додати майбутнє надходження',
      pripadnyKoncikiNajem: '; оренда, що закінчується, частково покриє платіж.',
      realneNadInflaci: 'реально (понад інфляцію)',
      realneTempoDoKroku: 'реально — цей темп іде в кроки зростання зарплати.',
      renta: 'рента',
      rentaDrziRentierskePortfolio: '— рента тримає рантьє-портфель 50/35/15 навіть під час вилучення',
      rentaVCerpaniPortfolio: '— під час виплат рента тримає портфель {a}/{d}/{c}',
      posledniRokTabulka: '— останній рік {c} % готівка і {d} % облігації',
      rentierskePortfolio: 'рантьє-портфель',
      resiSeUverem: 'Накопичується лише перший внесок, решту покриває кредит — платіж починається з моменту видачі.',
      resimeJenZeZdroju: 'Вирішуємо лише з джерел і щомісячно.',
      rocniRustPct: 'Зростання (%)',
      rok: 'рік',
      rustMzdy: 'зростання зарплати',
      rustVkladuNastaveni: 'Зростання вкладу — налаштування',
      sablonaNicNepredvyplni: 'Шаблон зараз нічого не заповнить.',
      sablonaPredvyplniPritoky: 'Шаблон заповнює майбутні надходження зарплати в усьому плані — консультант потім їх коригує.',
      splatka: 'платіж',
      splatnost: 'строк',
      splatnostHypotekyLet: 'Строк іпотеки в роках',
      typ: 'Тип',
      urok: 'ставка',
      urokHypotekyPa: 'Ставка іпотеки у % річних',
      uverZeStavebka: 'кредит з будівельного накопичення',
      uverem: 'кредитом',
      vR: 'у',
      vkladNadRamecZdroju: 'Внесок понад джерела — щомісячний платіж буде розрахований.',
      vlastniZdroje: 'власні кошти',
      vlozenoCelkem: '— внесено загалом',
      vybrano: 'вибрано',
      vychazi: 'досягається',
      vychozi: 'за замовчуванням',
      vychoziHodnoty: 'типові значення',
      vychoziParametryHypo: 'Не заповнено = план рахує зі значеннями за замовчуванням {sazba} % річних на {roky} р., а не з пропозицією банку. Кредит із будівельних заощаджень у варіанті 100 % має власну ставку, і ці поля її не змінюють.',
      vyvazeny: 'Збалансований',
      zAnalyzy: 'з аналізу',
      zTohoVlastni: 'з них власні кошти',
      zTohoVyjde: 'Із цього виходить',
      zVlastnichPenez: 'власними грошима',
      za: 'через',
      zaLet: 'Через (років)',
      zadanePctJe: 'Введений % — це',
      zadano: 'введено',
      zadat: 'ввести',
      zadneCilSeResi: 'Жодних — ціль вирішується регулярною інвестицією з надлишку.',
      zadnyRealnyRust: 'реальне зростання нульове, шаблон нічого не заповнить.',
      zahoditKroky: 'Відкинути кроки зростання зарплати',
      zpetNaHodnotuZ: 'Повернути значення з аналізу',
      zpetNaVychozi: 'повернути за замовчуванням',
      zpetNaVychoziRust: 'повернути типові',
      zrusit: 'Скасувати',
    },
    rezerva: {
      poznKlientuvCilNezbytne: 'Методика рекомендує 6× необхідні витрати та платежі, тобто {metodika}. Ваша ціль — {nasobek}× цієї бази.',
      poznKlientuvCilObvykle: 'Методика рекомендує 6× необхідні витрати та платежі. Необхідних витрат в аналізі немає, тож зі звичайних витрат і платежів виходить {metodika} — ваша ціль {nasobek}× цієї бази.',
      poznNeznamy: 'Ціль резерву поки немає з чого розрахувати — бракує витрат.',
      poznObvykle: 'Необхідні витрати в аналізі не заповнені — розраховано зі звичайних витрат. Додайте їх, і сума уточниться.',
      titulKlientuvCil: 'Резерв — ваша ціль',
      titulNezbytne: 'Резерв (6× необхідні витрати + платежі)',
      titulNeznamy: 'Резерв',
      titulObvykle: 'Резерв (6× звичайні витрати + платежі)',
    },
    rozpocetPlanu: {
      aniTakToAleNa: 'Але навіть так на всі цілі не вистачає —',
      cekaNaCil: ' чекає на ціль.',
      chybiCelkem: 'бракує загалом',
      doraziAzPoCilovem: 'надійде лише ПІСЛЯ цільової дати — на цільову суму не впливає',
      financniMajetekJednorazove: 'Фінансові активи — одноразово',
      hned: 'одразу',
      jePenzijniSporeniDps: ' — це пенсійні заощадження (DPS/DIP): це актив клієнта і план цілком враховує його на ренту, лише до цілі надійде ',
      jePenzijniSporeniDps2: ' — це пенсійні заощадження (DPS/DIP). Це актив клієнта, але жодна ціль його поки не використовує — воно належить ренті, а цілі фінансової незалежності клієнт не має. Залишається в „залишається“.',
      jednorazove: 'одноразово',
      jednorazoveA: ' одноразово і ',
      jednorazoveO: 'одноразово на',
      jesteNeniRozdelenoVsechno: 'Ще не все розподілено: ',
      kolikZbyvaPoKazdem: 'Скільки залишається після кожної цілі',
      let: 'років',
      letech: 'роках',
      mesicneO: 'щомісяця на',
      mesicniPrebytekPravidelne: 'Щомісячний надлишок — регулярно',
      mesicu: 'місяців',
      miraUspor: 'Норма заощаджень',
      necerpaZRozpoctu: 'не бере з бюджету',
      planJeHotovy: ' План готовий.',
      planJednorazovePrerozdeluje: 'План одноразово перерозподіляє ліквідні рахунки, будівельне накопичення та пенсійне. Поза ним залишається ',
      planNemaZCeho: 'плану немає з чого платити. Спершу бюджет домогосподарства.',
      podiloveFondyKzpOstatni: ' (пайові фонди, накопичувальне страхування, інші рахунки) — усі фінансові активи ',
      povinneVydaje: 'Обовʼязкові витрати',
      pravidelne: 'регулярно',
      prebytek: 'Надлишок',
      prebytekJeVAnalyze: 'Надлишок в аналізі введено вручну — він не збігається точно з доходами мінус витрати.',
      prebytekNesediNaRozpad: 'Надлишок не збігається з доходами мінус витрати та платежі — перевірте бюджет в аналізі.',
      prebytekNulaKlientskyVystup: 'Місячний надлишок дорівнює нулю — клієнтський план з нуля не складемо. Внесіть в аналіз суму, яку ви погодили з клієнтом.',
      precerpano: 'Перевитрата',
      precerpanoPlanNevychazi: 'Перевитрата — план не сходиться',
      prideleno: 'Розподілено',
      prijmy: 'Доходи',
      rozpocetPlanu: 'Бюджет плану',
      tolikKlientNema: ' — стільки клієнт не має.',
      v: 'у',
      vydajeASplatkyPrevysuji: 'Витрати і платежі перевищують доходи на ',
      vyrovnanoVsePrideleno: 'Збалансовано — усе розподілено',
      zBudoucihoPritoku: 'з майбутнього надходження (поза бюджетом)',
      zPenzijkaDpsDip: 'з пенсійного (DPS/DIP) · надійде ',
      zToho: 'З цього ',
      za: 'через',
      zatimNeniCoRozdelovat: 'Поки що немає що розподіляти — у клієнта немає ні вільних фінансових активів, ні щомісячного надлишку. План починається з бюджету домогосподарства, а не з продукту.',
      zatimZadnyCilRozpocet: 'Поки що жодної цілі — бюджет заповниться, щойно додаси першу.',
      zbyva: 'Залишається',
      zbyva0A0: 'Залишається 0 і 0 — кожна монета та кожен щомісячний надлишок має своє завдання.',
    },
    sekceCinema: {
      dalsi: 'Далі',
      prehrat: 'Відтворити',
      tvojeVeta: 'Ваша фраза ',
      zavrit: 'Закрити',
      zpet: 'Назад',
    },
    spolecne: {
      aiGeneraceSelhala: 'AI-генерація не вдалася',
      chybaPrepisu: 'Помилка розпізнавання мовлення',
      chybaSite: 'Помилка мережі',
      cil: 'Ціль',
      jedMes: '/міс',
      klient: 'клієнт',
      klientu: 'клієнтів',
      let: ' років',
      mikrofonNeniDostupny: 'Мікрофон недоступний',
      n1HlasovyNeboTextovy: '1. Голосова або текстова команда',
      napisNeboNahrajPrikaz: 'Напиши або надиктуй команду',
      napsatEMail: 'Написати email',
      nevimeCile: 'В аналізі поки немає жодної цілі із сумою — тому тут немає відсотка.',
      nevimeHorizont: 'У цілі бракує горизонту — вкажіть, через скільки років її хочете.',
      nevimeRenta: 'Ціль ренти не задана — вкажіть, скільки клієнт хоче щомісяця і від коли.',
      nevimeRezerva: 'Ціль резерву невідома — в аналізі бракує витрат домогосподарства.',
      nevimeSkore: 'Оцінку неможливо обчислити — в аналізі бракує базових даних.',
      nevimeVydaje: 'Витрати домогосподарства не введені — вільний грошовий потік порахувати не можна.',
      odesilam: 'Надсилаю…',
      odeslaniSelhalo: 'Не вдалося надіслати',
      poradce: 'консультант',
      poslatKlientovi: 'Надіслати клієнту',
      prazdnaAnalyzaText: 'В аналізі поки немає доходів, витрат, майна чи цілей. Додайте їх — план порахуємо з даних клієнта; вигаданим числам у клієнтському документі не місце.',
      prazdnaAnalyzaTitul: 'З цього аналізу план скласти неможливо',
      prebytekChybiTextDopocet: 'З доходів, витрат і платежів виходить місячний надлишок нуль. План з нуля не складаємо. Перевірте бюджет домогосподарства в аналізі — або внесіть надлишок, який ви погодили з клієнтом.',
      prebytekChybiTextNezadano: 'Місячний надлишок поки невідомий — в аналізі бракує витрат, з яких його можна порахувати. Додайте їх або одразу впишіть суму, яку ви погодили з клієнтом.',
      prebytekChybiTextNula: 'Погоджений місячний надлишок дорівнює нулю. План з нуля не складаємо — не малюємо графіки з грошей, яких немає, і не стверджуємо клієнтові, що місячне рішення вкладається в його надлишок. Внесіть в аналіз суму, про яку ви домовилися з клієнтом, або спершу пройдіть бюджет домогосподарства.',
      prebytekChybiTitul: 'Скільки щомісяця ми погодили?',
      predmet: 'Тема:',
      prepisSeNezdarilNapis: 'Не вдалося розпізнати мовлення — введи команду вручну',
      rentaOdvozena: 'Ціль ренти не задана — рахуємо з сьогоднішніх витрат клієнта.',
      ukladam: 'Зберігаю…',
      ulozit: 'Зберегти',
      vytisknoutUlozitPdf: 'Друкувати / зберегти PDF',
      zavrit: 'Закрити',
      zkusitZnovu: 'Спробувати знову',
      zmenitPrikaz: 'Змінити команду',
      zrusitFiltr: 'Скинути фільтр',
    },
    srovnavacFonduPage: {
      horizont: 'Горизонт: {roky} {rok}',
      jednorazoveKc: 'Разово ({mena})',
      mesicneKc: 'Щомісяця ({mena})',
      rozdilVeProspech: 'Різниця за {roky} {rok} на користь:',
      srovnavacFondu: 'Порівняння фондів',
      vlastniA: 'Власний A',
      vlastniB: 'Власний B',
    },
    tokPenez: {
      beznyUcet: 'Поточний рахунок',
      budouciPritok: 'Майбутнє надходження',
      chybi: 'бракує',
      chybiPrecerpano: 'бракує / перевитрата',
      coKlientDnesNema: 'чого клієнт сьогодні не має',
      dnesniMajetek: 'сьогоднішні активи',
      doraziAzPoCilovem: 'надійде лише ПІСЛЯ цільової дати',
      doraziAzPoCilovem2: 'надійде лише ПІСЛЯ цільової дати — на цільову суму не впливає',
      doraziV: 'надійде у',
      hotovost: 'Готівка',
      jednorazoveZFinancniho: 'Одноразово — з фінансових активів',
      klikniZnovuZpetNa: 'Клікни ще раз = назад до розрахунку системи',
      letech: 'роках',
      mesicneZPrebytku: 'Щомісяця — з надлишку',
      mesicniPrebytek: 'Щомісячний надлишок',
      mesicniPrebytek2: 'щомісячний надлишок',
      najedteNaProudUkaze: 'Наведи на потік — покаже звідки, куди і скільки.',
      nezarazenyZdroj: 'Некласифіковане джерело',
      odkudKamTecouVase: 'Звідки й куди течуть ваші гроші',
      penzijkoAzPozdeji: 'пенсійне — лише пізніше',
      penzijkoDpsDip: 'Пенсійне DPS/DIP',
      posliCelyTenhleZdroj: 'Надішли все це джерело на цю ціль',
      posliSem: 'надішли сюди',
      precerpanoTolikKlient: 'Перевитрата — стільки клієнт не має',
      splneno: 'виконано',
      sporiciUcet: 'Ощадний рахунок',
      stavebniSporeni: 'Будівельне накопичення',
      tokPenez: 'Потік грошей',
      uvolnenePenizeARustMzdy: 'Звільнені кошти та зростання зарплати',
      vkladNavic: 'Додатковий внесок',
      zatimNeniCoRozdelovat: 'Поки що немає що розподіляти — у клієнта немає ні вільних фінансових активів, ні щомісячного надлишку.',
    },
    whatsAppSender: {
      klientNemaTelefonDopln: 'У клієнта немає телефону — додайте його в контакті.',
      navrhDleFazeKlienta: 'Пропозиція за етапом клієнта',
      otevreWhatsappSTimto: 'Відкриє WhatsApp із цим текстом — надіслати треба вручну (безкоштовно, без API).',
      otevritWhatsapp: 'Відкрити WhatsApp',
      sablona: 'Шаблон',
      zpravaUpravPodlePotreby: 'Повідомлення (за потреби відредагуйте)',
      zrusit: 'Скасувати',
    },
  },
  /* BLOK:auto END */
  /* === /AUTO === */
  /* Клієнтське «чому» у страхуванні життя — див. cs.js. */
  /* VEŘEJNÁ SDÍLENÁ MODELACE /m/:token — čte to KLIENT, ne poradce.
   * Snapshot je uložený natrvalo, ale texty jsou KLÍČE, takže se přeloží do
   * jazyka toho, KDO SE DÍVÁ — ne toho, kdo modelaci vytvořil. */
  modelace: {
    nacitam: 'Завантажую моделювання…',
    neplatnyOdkaz: 'Це посилання недійсне або його строк минув.',
    proVas: 'Моделювання для вас',
    vaseModelace: 'Ваше моделювання',
    pripravenoPro: 'Підготовлено для',
    jakRozumet: 'Як це читати',
    vasPoradce: 'Ваш консультант',
    paticka: 'Орієнтовне моделювання. Минула дохідність не гарантує майбутньої.',
    ctaSchuzka: 'Домовитися про зустріч',
    ctaWhatsApp: 'Написати у WhatsApp',
    ctaSpojit: 'Звʼязатися',
    chybaNacteni: 'Моделювання зараз не вдалося завантажити. Перевірте підключення та спробуйте ще раз.',
    zkusitZnovu: 'Спробувати ще раз',
    prehrat: 'Відтворити',
    zastavit: 'Зупинити',
    nahledKlient: 'Що побачить клієнт',
  },
  /* Popisky snapshotu životní kalkulačky pro /m/:token (a PDF).
   * ⚠️ Placeholder {castka} musí být ve všech pěti jazycích STEJNÝ. */
  zivotkoModelace: {
    heroSmrt: 'Скільки потрібно родині (смерть годувальника)',
    pocetOsob: 'Кількість осіб',
    nezbytneVydaje: 'Необхідні витрати',
    zaMesic: '{castka}/міс',
    zaDen: '{castka}/день',
    variantaKryti: 'Варіант покриття',
    varianta_narocna: 'Для вимогливих',
    varianta_stredni: 'Золота середина',
    varianta_uskromnit: 'Затягнути пояс',
    varianta_cena: 'Дивлюся лише на ціну',
    krytiSmrt: 'Покриття на випадок смерті',
    krytiInvalidita: 'Покриття на випадок інвалідності',
    pnRodina: 'Тимчасова непрацездатність (родина)',
    narativ1: 'Цифри кажуть, скільки родина отримала б, якби сталося найгірше — щоб і далі мати житло, свій рівень життя, а діти закінчили школу.',
    narativ2: 'Інвалідність виходить дорожчою за смерть, бо хвора людина вдома потребує ще й догляду та переобладнання. Виплати за непрацездатності покривають втрату доходу під час короткої хвороби чи травми.',
    narativ3: 'Незобовʼязуюча орієнтовна пропозиція. Конкретні умови та ціни узгодимо разом.',
  },
  zivotkoProc: {
    nadpis: 'Чому інвалідність — найважливіша',
    podnadpis: 'Крок за кроком, з ваших власних цифр',
    osloveni: '{kdo}, це ваш розрахунок — і головне, ЧОМУ саме такі цифри.',
    proOsobu: 'Розраховано для: {kdo}.',
    proOsobuVice: 'Розраховано для: {kdo} — це найбільший дохід у родині. Для решти є власний розрахунок.',
    proOsobuViceBezJmena: 'Розраховано для члена родини з найбільшим доходом. Для решти є власний розрахунок.',
    k1Nadpis: 'Сьогодні',
    k1Popis: 'Родина має {prijem} на місяць, з них на найнеобхідніше потрібно {vydaje}.',
    k1PopisBezVydaju: 'Сьогодні родина має {prijem} на місяць.',
    k2Nadpis: 'Дохід зникає',
    k2Popis: '{kdo} більше не може працювати. З доходів родини залишається {zbytek} на місяць.',
    k2PopisBezJmena: 'Цей дохід більше не надійде. З доходів родини залишається {zbytek} на місяць.',
    k2PopisNic: '{kdo} більше не може працювати. Жодного іншого трудового доходу в родини не залишається.',
    k2PopisNicBezJmena: 'Цей дохід більше не надійде. Жодного іншого трудового доходу в родини не залишається.',
    k3Nadpis: 'А витрати ЗРОСТУТЬ',
    k3Popis: 'Рахунки нікуди не зникнуть — навпаки, додасться догляд, ліки, поїздки до лікаря, переобладнання житла. Модель враховує зростання на {pct} %, тобто {vydaje} на місяць. Саме в цьому різниця зі смертю: людина живе далі, і це життя чогось коштує.',
    k3PopisBezNarustu: 'Рахунки нікуди не зникнуть. Родині й далі потрібно {vydaje} на місяць.',
    k4Nadpis: 'Держава покриє лише частину',
    k4Popis: 'Пенсія по інвалідності — {duchod} на місяць. Якщо додати всі решту доходів і виплат, щомісяця все одно бракує {chybi}.',
    k4PopisBezDiry: 'Пенсія по інвалідності — {duchod} на місяць. Поточні витрати родина покрила б із решти доходів і виплат — потреба виникає аж на боргах і цілях.',
    k5Nadpis: 'І бракує щомісяця, {roky} років',
    k5Popis: 'Щоб закрити цю діру всі {roky} років, потрібен капітал {kapital}. Це не проста сума {naivne} — гроші тим часом працюють, тож достатньо менше. Розрахунок бере {sazba} % річних понад інфляцію.',
    k5PopisBezSazby: 'Щоб закрити цю діру всі {roky} років, потрібен капітал {kapital}.',
    k6Nadpis: 'Плюс борги та цілі',
    k6NadpisDluhy: 'Плюс борги',
    k6NadpisCile: 'Плюс цілі родини',
    k6Popis: 'Капітал на витрати — це одна частина. Друга — зобов’язання та плани. Борги при цьому не зменшуються ніколи: іпотеку не можна погасити на 80 %.',
    k6PopisBezDluhu: 'Капітал на витрати — це одна частина. Друга — плани родини, які не мають зупинитися.',
    k6Dluhy: 'Борги до погашення: {castka}',
    k6Cile: 'Цілі родини: {castka}',
    souhrnNadpis: 'Разом на інвалідність',
    souhrnNadpisOsoba: 'На інвалідність — {kdo}',
    souhrnNadpisJedna: 'На інвалідність — ця одна особа',
    souhrnPopis: 'Саме така сума має бути в договорі, щоб родина прожила ще {roky} років і не втратила житло.',
    souhrnPopisBezLet: 'Саме така сума має бути в договорі, щоб родина жила далі й не втратила житло.',
    srovnaniVyssi: 'На випадок смерті виходить {smrt}. Інвалідність на {rozdil} більша — і це вся причина, чому вона перша. Померла людина не їсть, не потребує житла й догляду. Жива — потребує.',
    srovnaniStejne: 'На випадок смерті виходить {smrt}. У вашому випадку обидві цифри близькі — тоді вирішує те, що станеться раніше.',
    pausalNadpis: 'Чому не «п’ять річних доходів»',
    pausalMene: 'Правило з підручників — п’ять річних доходів — дало б у вас {pausal}. Це на {rozdil} менше, ніж виходить із ваших власних витрат, виплат і років. Таке правило не знає ні вашої іпотеки, ні ваших дітей, тому тут його немає.',
    pausalVice: 'Правило з підручників — п’ять річних доходів — дало б у вас {pausal}, тобто на {rozdil} більше, ніж виходить із ваших цифр. Таке правило не знає ні ваших витрат, ні ваших виплат, тому тут його немає.',
    rizikaNadpis: 'Інші ризики — і що вони закривають',
    rizikaNadpisOsoba: 'Інші ризики — {kdo}',
    rizikaNadpisJedna: 'Інші ризики — і що вони закривають для тієї самої особи',
    coJe: 'Що це таке',
    bez: 'Що станеться без страхування',
    resi: 'Скільки це закриває',
    smrtNazev: 'Смерть',
    smrtCoJe: 'Годувальник помирає — через нещасний випадок або хворобу.',
    smrtBez: 'Витрати й борги залишаються, один дохід зникає. Родина продає житло саме того року, коли має на це найменше сил.',
    trvNazev: 'Стійкі наслідки травми',
    trvCoJe: 'Травма, після якої залишається стійке обмеження — рука, нога, зір, хребет.',
    trvBez: 'Одноразові витрати (реабілітація, безбар’єрне переобладнання, інше авто) йдуть із резерву. Коли його бракує — із кредиту.',
    trvResiPopisek: 'Прогресивна виплата: що серйозніший наслідок, то вища виплата — у нашій моделі до {nasobek}× узгодженої суми, у страховиків різниться.',
    pnNazev: 'Тимчасова непрацездатність',
    pnCoJe: 'Хвороба або травма на тижні чи місяці. Потім людина повертається до роботи.',
    pnBez: 'Дохід падає до лікарняних, витрати лишаються ті самі. Резерв тане за кілька місяців.',
    pnBezOsvc: 'Підприємець без страхування на випадок хвороби не отримає від держави нічого. Витрати тривають, а резерв тане за кілька місяців.',
    pnResiDen: '{castka} / день',
    pnKarenceOd: 'Резерв покриє перші місяці, тож виплата запропонована з {od}-го місяця.',
    pnKarenceHned: 'Запропоновано з першого дня.',
    zavNazev: 'Критичне захворювання',
    zavCoJe: 'Рак, інфаркт, інсульт та інші діагнози з переліку страхової компанії.',
    zavBez: 'Лікування та відновлення тривають місяці або роки. Людина працює менше, платить більше — і не має часу думати про гроші.',
    zavResiPopisek: 'Одноразово, у розмірі {nasobek} річного доходу.',
    ditNazev: 'Тяжка подія з дитиною',
    ditCoJe: 'Після травми або хвороби дитина назавжди залишається залежною від догляду.',
    ditBez: 'Найбільша діра — не лікування, а той із батьків, хто через догляд назавжди залишає роботу.',
    ditResiPopisek: 'Сума в договорі кожної дитини. Розраховується з утраченого доходу того з батьків, хто доглядав би дитину.',
    ditResiStrop: 'Сума в договорі кожної дитини. Частину потреби ({castka}) на дитину не візьме жодна страхова — вона належить до резерву й інвестицій.',
    cenaNadpis: 'Ціна',
    cenaZadana: 'Захист виходить на {cena} на місяць. Це сума з пропозиції, яку ввів консультант — остаточну ціну підтвердить страхова в договорі після оцінки стану здоров’я. До того це оцінка, а не пропозиція.',
    cenaChybi: 'Ціни в цьому документі свідомо немає. Консультант додасть її за конкретною страховою — доки договір не підписано, жодна цифра тут не є пропозицією.',
    cenaDen: 'На день це {denne}.',
    cenaPct: 'Це {pct} % чистого доходу родини.',
    poznamkaModelace: 'Це розрахунок, а не договір страхування й не персональна рекомендація. Цифри походять із того, що ви вказали — якщо зміняться дохід, витрати або цілі, зміниться й результат.',
    poznamkaSablona: 'Суми щодо стійких наслідків, критичних захворювань і ризику дитини — орієнтовний зразок із практики консультанта. Конкретні ліміти, винятки та періоди очікування визначає страхова компанія.',
    poznamkaDavky: 'Пенсія по інвалідності та лікарняні — це оцінка за чеськими правилами. Фактичний розмір визначає ČSSZ.',
    poznamkaMetodika: 'Методика {verze}.',
  },

  /* Klientské formuláře (/f/:token) — JEDINÁ obrazovka appky, kterou otvírá
   * klient, ne poradce. Otevře ji v telefonu, bez přihlášení, a může to být
   * Vietnamec nebo Ukrajinec — proto tu nesmí být ani jeden dvoujazyčný ternár.
   *
   * ZNĚNÍ OTÁZEK TU NENÍ. Popisky polí, nápovědy i texty souhlasu chodí ze
   * serveru přeložené (backend/lib/formulare/*). Backend je jediný zdroj pravdy
   * o tom, jaká pole formulář má a která z nich jsou citlivá; kdyby si seznam
   * držel frontend, stačila by jedna překlepnutá klíčovka a rodné číslo by
   * skončilo v nešifrované části dokumentu.
   */
  formKlient: {
    castZ: "Частина {n} з {celkem}",
    /* Příjmy a výdaje — obrazovka skupiny výdajů a „Váš přehled“ (26. 10. 2026). */
    pv: {
      prehledNadpis: "Ваш огляд",
      prehledPodnadpis: "Перевірте цифри та надішліть їх консультанту. Що не збігається, виправте.",
      prijmy: "Доходи",
      vydaje: "Витрати",
      mesicne: "щомісяця",
      zbyva: "Залишається щомісяця",
      zbyvaPopis: "доходи − витрати − платежі за кредитами",
      zbyvaZaporne: "Витрати та платежі за кредитами вищі за доходи.",
      bezPrijmu: "Без доходів неможливо порахувати, скільки залишається.",
      rozpad: "Куди йдуть гроші",
      rozpadPrazdno: "Ви ще не заповнили витрати.",
      rozpadAria: "Місячні витрати за групами, найбільша — {skupina}: {castka}",
      porovnaniAria: "Доходи {prijmy}, витрати {vydaje}",
      splatky: "Платежі за кредитами",
      sporeni: "Заощадження та інвестиції",
      neniVydaj: "не рахується як витрата",
      firma: "Підприємництво (ведеться окремо від домогосподарства)",
      minimum: "необхідний мінімум",
      minimumCelkem: "Необхідний мінімум разом",
      osoba1: "Ви",
      osoba2: "Партнер / партнерка",
      dalsiPrijmy: "Оренда, доходи від інвестицій, бонуси",
      pravidlo: "Орієнтовне правило 50 / 30 / 20",
      pravidloPopis: "Обов'язкові витрати та кредити 50–60 %, життя 20–30 %, майбутнє в ідеалі 20 % доходів. Це орієнтир, а не оцінка.",
      povinne: "Обов'язкові",
      zivot: "Життя",
      budoucnost: "Майбутнє",
      cil: "ціль {rozsah}",
      skupinaCelkem: "Разом за групу",
      vydajeZatim: "Витрати поки що",
      podrobnosti: "Деталі: необхідний мінімум",
      podrobnostiSkryt: "Сховати деталі",
      minimumPopis: "Скільки з цього є необхідним мінімумом — сума, без якої не обійтися в місяць без доходу.",
    },
    nacitam: "Завантажую форму…",
    neplatnyNadpis: "Посилання вже недійсне",
    neplatnyText: "Посилання на форму мають обмежений термін дії. Напишіть своєму консультанту, і він надішле нове.",
    chybaNadpis: "Не вдалося завантажити форму",
    chybaText: "Спробуйте перезавантажити сторінку. Якщо це не допоможе, зверніться до свого консультанта.",
    hotovoNadpis: "Надіслано, дякуємо",
    hotovoText: "{poradce} зв яжеться з вами. Те, чого ви не заповнили, доповните разом.",
    hotovoTextBezJmena: "Ваш консультант зв яжеться з вами. Те, чого ви не заповнили, доповните разом.",
    jazyk: "Мова",
    krokZ: "Питання {n} з {celkem}",
    sekceOtazek: "Питань у цій частині: {n}",
    zacit: "Почати",
    pokracovat: "Продовжити",
    zpet: "Назад",
    dale: "Далі",
    preskocit: "Пропустити",
    nepovinne: "Необов'язково",
    ukladam: "Зберігаю…",
    ulozeno: "Збережено — можете закрити й повернутися пізніше.",
    chybaUlozeni: "Останні зміни не вдалося зберегти. Спробуємо знову під час наступного редагування.",
    chybaUlozeniOdkaz: "Посилання вже недійсне — зверніться, будь ласка, до свого консультанта.",
    zamek: "Зберігаємо зашифровано",
    ulozenoZasifrovane: "Збережено зашифровано: {maska}. Залиште порожнім, якщо не потрібно змінювати.",
    platiDo: "Посилання дійсне до {datum}.",
    vyberte: "Виберіть",
    nevyplneno: "Не заповнено",
    pridatRadek: "Додати рядок",
    smazatRadek: "Видалити рядок",
    zvlastniKategorie: "Особлива категорія даних",
    souhlasNadpis: "Перш ніж почати",
    souhlasPokracovat: "Погоджуюсь і хочу продовжити",
    souhlasOdmitnout: "Не погоджуюсь",
    souhlasNutny: "Без згоди заповнювати форму неможливо.",
    souhlasOdmitnutoNadpis: "Зрозуміло",
    souhlasOdmitnutoText: "Ми нічого не зберегли й закрили посилання. Якщо передумаєте, консультант надішле нове.",
    odvolatSouhlas: "Відкликати згоду й закрити посилання",
    rekapitulaceNadpis: "Перевірте й надішліть",
    rekapitulacePodnadpis: "Те, чого ви не заповнили, доповните з консультантом. Тут не мусить бути все.",
    upravit: "Змінити",
    prazdno: "Ви ще нічого не заповнили.",
    odeslat: "Надіслати консультанту",
    odesilam: "Надсилаю…",
    chybiPovinne: "Для надсилання ще бракує: {pole}.",
    chybaOdeslani: "Не вдалося надіслати. Спробуйте, будь ласка, ще раз.",
    poradce: {
      /* Příjmy a výdaje — banner v analýze a složka (26. 10. 2026). */
      pv: {
        banner: "Клієнт надіслав доходи та витрати ({datum})",
        prevzit: "Перенести в аналіз",
        prevzato: "Перенесено в аналіз",
        zobrazit: "Показати",
        skryt: "Сховати",
        coSeZapise: "Що буде записано в аналіз",
        drivTed: "раніше {pred} → тепер {po}",
        partnerChybi: "Клієнт заповнив і партнера, але в аналізі другої особи немає. Запишеться лише особа 1 — додайте партнера і перенесіть ще раз.",
        splatkySporeni: "Платежі за кредитами та заощадження клієнт вказав лише для огляду — у витрати вони не записуються (належать до Зобов'язань і Ресурсів).",
        nicKPrevzeti: "Форма порожня — нічого переносити.",
        hotovo: "Доходи та витрати перенесено в аналіз.",
        chybaRazitka: "Цифри в аналізі є, але позначку «перенесено» не вдалося зберегти — повідомлення може з'явитися знову.",
        chyba: "Перенесення не вдалося.",
        chybaNacteni: "Не вдалося завантажити відповіді клієнта.",
        pole: {
          prokaz1: "Особа 1 — підтверджений дохід",
          ostatni1: "Особа 1 — підприємництво / інше",
          prokaz2: "Особа 2 — підтверджений дохід",
          ostatni2: "Особа 2 — підприємництво / інше",
          pasivni: "Пасивні доходи",
          bonusyRok: "Бонуси за рік",
          obvykle: "Звичайні витрати (разом зі страховкою з аналізу)",
          minimalni: "Необхідні витрати",
          rozpis: "Позицій у розписі витрат",
        },
      },
      nadpis: "Форми для клієнта",
      popis: "Виберіть тип, згенеруйте посилання й надішліть його клієнту своїм каналом. Застосунок сам нічого не надсилає.",
      typ: "Тип форми",
      platnost: "Термін дії посилання",
      dnu: "{n} днів",
      vytvorit: "Створити посилання",
      vytvarim: "Створюю…",
      zkopirovat: "Скопіювати посилання",
      zkopirovano: "Скопійовано",
      zkopirovatZpravu: "Скопіювати повідомлення для клієнта",
      zneplatnit: "Анулювати",
      zneplatnitPotvrzeni: "Справді анулювати? Клієнт більше не відкриє посилання.",
      stavCeka: "Очікує на клієнта",
      stavRozpracovano: "Заповнюється",
      stavVyplneno: "Заповнено",
      stavVyprselo: "Термін посилання минув",
      stavZneplatneno: "Анульовано",
      stavOdvolano: "Клієнт відкликав згоду",
      zobrazit: "Показати відповіді",
      skryt: "Сховати відповіді",
      zvlastniKategorie: "Особлива категорія — дані про здоров я",
      zvlastniHint: "Відповіді зашифровані повністю й не показуються в попередньому перегляді. Кожне відкриття записується в журнал аудиту.",
      kUklidu: "Дані зберігаються тут довше ніж {n} днів. Подумайте, чи вони ще потрібні.",
      bezFormularu: "Ви ще не надсилали цьому клієнту жодної форми.",
      chybaNacteni: "Не вдалося завантажити форми.",
      chybaVytvoreni: "Не вдалося створити посилання.",
      chybaOdpovedi: "Не вдалося завантажити відповіді.",
      odhalit: "Показати",
      platiDo: "Дійсне до {datum}",
      vyplneno: "Заповнено {n} з {celkem} полів",
      jazykOdkazu: "Мова для клієнта",
      nicNeodesilame: "Посилання лише створюється. Повідомлення надішліть своїм каналом, щоб бачити, кому воно йде.",
    },
  },
  /* Porovnávač tří způsobů čerpání renty (/renta-porovnavac).
   * 🔴 PRÁVNÍ: „poučené Nobelovou nadací“ NIKDY ne „portfolio Nobelovy nadace“;
   * modelace ≠ investiční doporučení; historie ≠ příslib budoucího výnosu. */
  /* Kdy budeš volný (KFP 20) — peníze přeložené na čas.
   * 🔴 PRÁVNÍ: modelace ≠ investiční doporučení; výnos je NAD inflací,
   * takže renta je v dnešních penězích. Nesmí se to podat jako příslib. */
  /* Hypotéka — čtyři rozhodnutí (KFP 02, 10, 11, 13).
   * 🔴 PRÁVNÍ: modelace, NE úvěrová ani investiční nabídka. Sazby zadává
   * poradce. Porovnává se celé měsíční zatížení, ne jen splátka. */
  hypoR: {
    zalRefixace: 'Кінець фіксації',
    zalSplatnost: '20 чи 30 років',
    zalVyse: 'Скільки власних',
    zalCas: 'Вплив часу',
    vyseMeneVlastnich: 'Менше власних, більше інвестувати',
    vyseVicVlastnich: 'Більше власних, менший кредит',
    chybiVstupy: 'Заповни поля ліворуч. Доки вони порожні, нічого не рахується — порожнє поле це не нуль.',
    zpet: 'Інструменти',
    nadpis: 'Іпотека — чотири рішення',
    podnadpis: 'Чотири питання, які клієнт справді ставить про іпотеку. Кожне закінчується однією фразою, а не таблицею. Порівнюється все місячне навантаження — інакше це було б порівняння яблук з грушами.',
    vstupyLabel: 'Іпотека клієнта',
    cena: 'Ціна нерухомості',
    vlastniA: 'Варіант A — власні гроші',
    sazbaA: 'Варіант A — ставка',
    vlastniB: 'Варіант B — власні гроші',
    sazbaB: 'Варіант B — ставка',
    sazbaBHint: 'Банк дає кращу ставку за нижчого LTV. Саме про цю різницю тут і йдеться — без неї розрахунок не мав би сенсу.',
    jistina: 'Сума кредиту',
    sazba: 'Ставка',
    splatnost: 'Строк',
    let: 'років',
    fixace: 'Фіксація',
    kratsi: 'Коротший варіант',
    kratsiHint: 'Довший варіант — це поле Строк вище. У ньому різниця в платежі інвестується з першого місяця.',
    prijem: 'Чистий дохід на місяць',
    vydaje: 'Інші витрати на місяць',
    zaLet: 'Подивитися через',
    rustPrijmu: 'Зростання доходу',
    vynos: 'Дохідність інвестиції',
    inflace: 'Інфляція',
    inflaceHint: 'Кожна різниця показується двічі: у майбутніх грошах (велике число) і в сьогоднішніх (що за це справді купиш).',
    refVerdiktLabel: 'Коли закінчиться фіксація',
    refVerdiktVeta: 'на місяць більше, якби ставка зросла на 1 в.п. За решту {roky} років це {celkem}.',
    refTabulka: 'Платіж за новою ставкою',
    refDnes: 'Сьогодні',
    refPoznamka: 'За {roky} років фіксації клієнт погасить {splaceno} тіла кредиту ({pct} %). Решта перекредитується новою ставкою — звідси стрибок платежу.',
    splVerdiktLabel: 'За однакового місячного навантаження виграє',
    splRemiza: 'нічия',
    splRemizaVeta: 'Обидва варіанти виходять практично однаково. Вирішує те, що клієнту приємніше.',
    splVerdiktVeta: 'На {rozdil} у майбутніх грошах — це {dnes} у сьогоднішніх. Обидва варіанти коштують клієнту однаково {zatizeni} на місяць.',
    splMajetek: 'Майно наприкінці',
    splRadek: '{let} років · платіж {splatka}',
    splPoznamka: 'У довшому варіанті різниця в платежі ({rozdil} на місяць) інвестується з першого місяця. У коротшому після погашення починає інвестуватися весь платіж. Тому обидва коштують однаково, а різниця лише в результаті.',
    vyseVerdiktLabel: 'Через {roky} років краще вийде',
    vyseVerdiktVeta: 'На {rozdil}, тобто {dnes} у сьогоднішніх грошах.',
    vyseTabulka: 'Обидва варіанти поруч',
    vyseVlastni: 'Власні',
    vyseUver: 'Кредит',
    vyseSazba: 'Ставка',
    vyseSplatka: 'Платіж',
    vyseVolne: 'Вільно на інвестиції',
    vyseMajetek: 'Майно наприкінці',
    casVerdiktLabel: 'Платіж не змінюється, усе інше — так',
    casVerdiktVeta: 'Частка платежу в доході через {roky} років. При цьому {umazala} боргу з\'їдає сама інфляція — без жодного додаткового платежу.',
    casRozpocet: 'Місячний бюджет',
    casDnes: 'Сьогодні',
    casPozdeji: 'Через {roky} років',
    casPrijem: 'Дохід',
    casSplatka: 'Платіж',
    casVydaje: 'Інші витрати',
    casZbyva: 'Залишиться',
    casZatizeni: 'Платіж забирає з доходу',
    casPoznamka: 'Залишок боргу через {roky} років: {nom} номінально, але лише {real} у сьогоднішніх грошах. Різниця {umazala} — робота інфляції, а не клієнта.',
    disclaimer: 'Моделювання, не кредитна і не інвестиційна пропозиція. Ставки вводить консультант — застосунок не стверджує, що клієнт їх отримає. Дохідність не гарантована, реальний результат залежить від ринків, податків і комісій.',
  },

  svoboda: {
    rok: 'рік',
    roky: 'роки',
    let: 'років',
    mesic: 'місяць',
    mesice: 'місяці',
    mesicu: 'місяців',
    hned: 'просто зараз',
    zpet: 'Інструменти',
    nadpis: 'Коли ти будеш вільним',
    podnadpis: 'Гроші, перекладені на час. Додай будь-що зверху — і побачиш, наскільки раніше майно почне оплачувати рахунки замість роботи.',
    nedosazitelneNadpis: 'Так туди не дійти.',
    zNedosazitelnehoNadpis: 'Тепер туди дійти можна.',
    nedosazitelneText: 'З того, що відкладається сьогодні, ціль не буде досягнута і за ціле життя. Це не помилка розрахунку — це відповідь. Спробуй збільшити щомісячну суму або знизити цільову ренту.',
    zNedosazitelnehoText: 'Раніше ціль не досягалася взагалі. Після цього збільшення вже досягається — але наскільки раніше, сказати не можна, бо раніше терміну не було.',
    ziskLabel: 'Це збільшення дає тобі',
    zatimNic: 'поки нічого',
    ziskDovetek: 'раніше, ніж якби все залишилося як є',
    ziskVyzva: 'посунь повзунки нижче й подивися, що станеться',
    dnesPlan: 'Сьогоднішній план',
    sNavysenim: 'Зі збільшенням',
    osaLabel: 'Шлях до незалежності',
    zaStropem: 'Термін за кінцем осі — позначка стоїть на краю.',
    dnes: 'сьогодні',
    cilKapital: 'Ціль',
    cilVysvetleni: '= рента {renta} на місяць у сьогоднішніх грошах',
    vstupyLabel: 'Як це виглядає сьогодні',
    renta: 'Рента, яку хоче щомісяця',
    rentaHint: 'У сьогоднішніх грошах. Скільки мало б надходити, щоб не треба було ходити на роботу.',
    majetek: 'Що вже на це є',
    majetekHint: 'Інвестиції та заощадження справді під цю ціль — не резерв і не гроші на авто.',
    mesicne: 'Скільки відкладає щомісяця',
    vynos: 'Дохідність понад інфляцію',
    vynosHint: 'ПОНАД інфляцію, не загальна. Тому числа нижчі, ніж клієнт очікує — і тому рента в сьогоднішніх грошах.',
    coKdyby: 'А що якби додав',
    jednorazove: 'Одноразово зараз',
    skokNula: 'нічого',
    navic: 'Щомісяця додатково',
    pomerLabel: 'Що за це',
    pomerText: 'За {penize} додатково отримає {cas} життя, у якому не мусить.',
    cokdybyPrazdno: 'Повзунки на нулі. Підніми один і дивись, як акцентна позначка на осі поїде ліворуч.',
    cekaniLabel: 'Ціна очікування',
    cekaniText: 'Якби почали пізніше. Гроші тим часом лежать на рахунку — номінально ті самі, реально їх з\'їдає інфляція. Саме тому втрата більша за саме очікування.',
    inflace: 'Інфляція',
    cekaniOdklad: 'Почне на {doba} пізніше',
    cekaniNedosazitelne: 'вже не вийде',
    cekaniDovetek: 'довше, ніж сьогодні',
    disclaimer: 'Моделювання, не інвестиційна рекомендація і не обіцянка дохідності. Рахується в сьогоднішніх грошах (дохідність задана понад інфляцію). Реальний результат залежить від ринків, податків і комісій.',
  },

  rentaPorov: {
    zPlanuOdkaz: "Порівняти три способи виплат",
    zaMesic: "/міс",
    zpusobPevne: "Фіксований відсоток",
    zpusobKlouzavy: "Ковзне середнє",
    zpusobMantinely: "Обмежувачі",
    jakPevne: "{pct} від поточної вартості",
    jakKlouzavy: "{pct} від середнього за {let} р.",
    jakMantinely: "старт {pct}, далі коригування за правилами",
    vyhodaPevne: "Капітал теоретично ніколи не вичерпається — завжди береться лише частина.",
    vyhodaKlouzavy: "Рента спокійніша, один поганий рік не обвалить її повністю.",
    vyhodaMantinely: "Найвища рента на початку.",
    presetPoucene: "З огляду на Нобеля",
    presetOpatrne: "Обережне",
    presetDynamicke: "Динамічне",
    cenaPevne: "Рента коливається разом із ринком, повністю й одразу.",
    cenaKlouzavy: "Після падіння виплачує більше, ніж відповідає вартості портфеля.",
    cenaMantinely: "Скорочення, коли ринок підводить. Це не краще правило — це інший ризик.",
    rok: "Рік",
    mil: "млн",
    tis: "тис.",
    zpet: "Назад до інструментів",
    kicker: "Виплата ренти",
    title: "Три способи виплати поруч",
    subtitle: "Той самий капітал, три правила виплат. Скільки клієнт отримає щомісяця, що залишиться — і чого це коштує.",
    zPlanu: "Капітал узято з плану клієнта",
    pouceneTitul: "Портфель з огляду на досвід Нобелівського фонду",
    pouceneText: "Нобелівський фонд орієнтується на 3 % реальної дохідності на рік і, крім акцій, облігацій та готівки, тримає близько п'ятої частини в альтернативних активах і десятої — у нерухомості та інфраструктурі. Їх ми тут не моделюємо. Розподіл нижче — це наше спрощення для клієнта, який їх не має; це не портфель Нобелівського фонду.",
    jenModelace: "Це моделювання, а не інвестиційна рекомендація.",
    vstupyTitul: "З чого виплачується",
    vstupyPopis: "Усі суми реальні, у сьогоднішніх цінах — дохідність уже понад інфляцію, а рента не індексується.",
    kapital: "Капітал для виплат",
    roky: "Як довго виплачувати",
    letPocet: "{n} р.",
    alokace: "Розподіл портфеля",
    vynosPortfolia: "Реальна дохідність портфеля",
    paNadInflaci: "річних понад інфляцію",
    akcie: "Акції",
    dluhopisy: "Облігації",
    penezniTrh: "Грошовий ринок",
    scenar: "Сценарій дохідності",
    scenarModel: "Модельна дохідність",
    scenarHistorie: "Реальна історія",
    scenarPoradi: "Ті самі роки навпаки",
    scenarModelHint: "Щороку однаково: {pct}. Показує принцип, а не реальність — ринок так ніколи не рухається.",
    scenarHistorieHint: "Роки {od}–{do} так, як вони справді минули. Реально, після інфляції. Це не прогноз, а лише відповідь на питання „що якби це повторилося“.",
    scenarPoradiHint: "Той самий набір дохідностей, те саме середнє — лише зворотний порядок. Показує ризик послідовності дохідностей.",
    startRok: "Рік старту",
    historieKratsi: "Від {rok} року історія охоплює лише {let} років. Рахується коротший період — нічого не добудовується моделлю.",
    cpiNespolehliva: "Дані про інфляцію за 1927–1946 роки пласкі. Реальна дохідність від такого давнього старту тому ненадійна.",
    pokrocile: "Розширені налаштування",
    sazbaCerpani: "Ставка виплат",
    startMantinelu: "Стартова ставка обмежувачів",
    oknoLet: "Вікно ковзного середнього",
    naStartuMes: "На старті щомісяця",
    rozpetiRenty: "Діапазон ренти",
    zbudePo: "Залишиться через {let} р.",
    celkemVyplaceno: "Усього виплачено",
    nejhlubsiPropad: "Найглибше падіння ренти",
    vRoce: "{rok}-й рік",
    bezPropadu: "рента не падала",
    kapitalDosel: "Капітал вичерпався на {rok}-му році",
    pocetSkrtu: "{n} скорочень",
    pocetZvyseni: "{n} підвищень",
    nadvyplata: "За весь горизонт це на {castka} більше, ніж за фіксованим відсотком.",
    cenaTitul: "Чого коштує вища рента на початку",
    cenaPopis: "Обмежувачі — це не „краще правило 4 %“. Ви міняєте малий ризик вичерпання грошей на середній ризик глибоких скорочень на багато років.",
    cenaPridano: "Додатково на старті",
    cenaOprotiPevnemu: "порівняно з фіксованим відсотком",
    cenaSkrtStitek: "Ціна цього",
    cenaSkrtVeta: "На {rok}-му році ренту довелося б скоротити на {pct}",
    cenaSkrtZNa: "з {z} до {na} на місяць",
    cenaSkrtuCelkem: "{n} скорочень за весь горизонт",
    cenaDno: "Найглибше: {pct} нижче за найвищу ренту ({rok}-й рік) — {castka} на місяць",
    cenaBezSkrtuStitek: "У цьому сценарії скорочень немає",
    cenaBezSkrtu: "Це не означає, що скорочень не було б ніколи. Погляньте на задокументовані роки нижче — там вони були потрібні.",
    cenaVycerpano: "У цьому сценарії капітал вичерпався б на {rok}-му році.",
    dolozenoTitul: "Підтверджено реальними роками",
    dolozenoKdo: "Той, хто почав виплати у {rok} році",
    dolozenoKratsi: "стільки даних є в історії",
    dolozenoDno: "дно ренти −{pct}",
    dolozenoSkrty: "{n} скорочень, перше на {rok}-му році, дно −{pct}",
    dolozenoBezSkrtu: "без скорочень",
    dolozeno1966: "У сімдесятих втрачали не лише акції — інфляція з'їла й облігації, і грошовий ринок. Диверсифікація тоді не допомогла.",
    dolozeno2000: "2000 рік був проблемою акцій. Облігації та грошовий ринок тоді заробляли, тож портфель із їхньою часткою тримався краще.",
    dolozenoObecne: "Історичний ряд від цього старту, реально після інфляції.",
    grafRenta: "Щомісячна рента в часі",
    grafRentaPopis: "Це те, що клієнт справді отримає на рахунок. У сьогоднішніх цінах.",
    grafKapital: "Капітал у часі",
    grafKapitalPopis: "Що залишається на рахунку. Нуль означає, що гроші закінчилися.",
    poradiTitul: "Ризик послідовності дохідностей",
    poradiPopis: "Ті самі роки, та сама середня дохідність — лише в іншому порядку. Падіння на початку виплат є вбивчим, бо продаєш на дні.",
    poradiVpred: "Як роки {od}–{do} справді минули",
    poradiVzad: "Ті самі роки навпаки",
    poradiVyplaceno: "Клієнт отримав загалом",
    poradiKapital: "Наприкінці залишилося",
    poradiDno: "Дно ренти",
    poradiSkrtu: "Скорочень при обмежувачах",
    poradiZaverShoda: "Наприкінці капітал виходить абсолютно однаковий, але на руки клієнт отримав у {pomer}× інші гроші. Увесь ризик — у доході, а не у виписці з рахунку.",
    poradiZaverObecne: "Порядок років змінив виплату у {pomer}×.",
    prehledTitul: "Усі історичні старти",
    prehledPopis: "{n} періодів по {let} років, роки {od}–{do}. Реально, після інфляції.",
    prehledSelhani: "Закінчилося без грошей",
    prehledSelhaniPocet: "{n} з {celkem}",
    prehledZadne: "жодного",
    prehledMedianDno: "Звичайне падіння ренти",
    prehledNejhorsiDno: "Найглибше падіння",
    prehledNejhorsiStart: "Найгірший старт",
    prehledDoslo: "{rok} — вичерпалося на {kdy}-му році",
    prehledPozor: "Нуль провалів — це не доказ безпеки. За фіксованого відсотка завжди береться лише частина того, що лишилося: рахунок не спорожніє, навіть якщо рента впаде майже до нуля. Тому поряд із кількістю провалів читайте падіння ренти.",
    pravniTitul: "Чим ця сторінка є і чим не є",
    pravni1: "Моделювання, а не інвестиційна рекомендація. Воно не оцінює ситуацію, знання чи цілі конкретного клієнта.",
    pravni2: "Історичні дані не є обіцянкою майбутньої дохідності. Ринки можуть падати — і падатимуть.",
    pravni3: "Портфель з огляду на досвід Нобелівського фонду — а не портфель Нобелівського фонду. Нобель тримає ще й альтернативи (~20 %) та нерухомість (~9 %), яких тут немає, і орієнтується на 3 % реально.",
    pravni4: "Усі суми реальні, у сьогоднішніх цінах. Дохідність уже понад інфляцію, рента не індексується.",
    pravni5: "Історичний ряд — це дані США (акції, державні облігації, казначейські векселі), переведені в реальну дохідність через інфляцію США. Чеський портфель поводиться інакше.",
  },
  manazerUi: {
    obnovit: 'Оновити',
    pozvankyDole: 'Створені запрошення знайдеш нижче серед карток радників — разом із посиланням і готовим текстом повідомлення.',
    pridatPoradce: 'Додати радника до команди',
    pridatPoradceHint: 'Введи e-mail радника. Створиться запрошення, яке він має прийняти у своїх Налаштуваннях — лише тоді ти побачиш його клієнтів, воронку, календар і цілі. E-mail поки що не надсилаємо, скажи йому про це.',
    vytvoritPozvanku: 'Створити запрошення',
    zadnyTym: 'Поки що немає команди',
    zadnyTymHint: 'Запроси радника кнопкою вище. Він з\'явиться тут, щойно прийме запрошення у своїх Налаштуваннях — до того часу ти не бачиш його даних. Потім побачиш його результати й зможеш ставити йому завдання.',
  },
  naborUi: {
    hledatKandidata: 'Шукати кандидата…',
    nikdoSeNenasel: 'Нікого не знайдено',
    klikniAUvidis: 'Натисни й побачиш, про кого йде',
    coJeNabor: '📣 Що таке рекрутинг:',
    coJeNaborText: 'ти переманюєш досвідчених радників від конкурентів.',
    eyebrow: 'Воронка рекрутингу',
    inProc: 'у процесі',
    kpiPipe: 'У рекрутингу',
    krok1: 'додай кандидата',
    krok2: 'заповни його числа (продукція, мережа, клієнтська база) — ми порахуємо бал 🔥',
    krok3: 'надсилаєш йому пропозицію, від якої не відмовляються, побудовану на його ж числах',
    krok4: 'перетягуєш картку воронкою аж до «активний».',
    prvniKandidat: 'Додай першого кандидата',
    sub: 'Рекрутинг радників від конкурентів · бал = продукція × мережа × клієнтська база · перетягуй картку між етапами',
    title: 'Рекрутинг',
    zadnyKandidat: 'Поки що немає кандидатів',
    zadnyKandidatHint: 'Почни з одного імені від конкурента — того, кого хотів би мати в команді. Додай його, заповни його числа, і ми порахуємо, наскільки йому вигідно перейти до тебе.',
  },
  motivApp: {
    aktivni: 'Активна',
    midnight: 'Темна — для вечірньої роботи',
    violet: 'Яскраве, молодіжне, інше',
    lime: 'Технічне, контрастне, чітке',
    cobalt: 'Холодний акцент, тепла площина',
    indigo: 'Чиста, дата-орієнтована, фінтех',
    legenda: 'Тема застосунку',
    sage: 'Тепла, органічна, надійна',
    vybrat: 'Перемкнути тему застосунку на',
  },
  pojVar: {
    cena: 'Вирішує лише ціна',
    cenaPopis: 'необхідні витрати, цілі −60 %',
    narocna: 'Для вимогливих',
    narocnaPopis: 'цілі та витрати в повному обсязі',
    sablonaUpozorneni: 'Шаблонні суми з практики консультанта — орієнтовний зразок, не пропозиція і не гарантія. Конкретні ліміти та ціни консультант перевірить у страховій компанії.',
    stredni: 'Золота середина',
    stredniPopis: 'цілі −30 %, витрати без змін',
    uskromnit: 'Обмежити себе',
    uskromnitPopis: 'необхідні витрати, цілі −50 %',
    variantaBezKratceni: 'варіант урізає ЦІЛІ, а не рівень життя. Борги не урізаються ніколи.',
  },
  davkyUi: {
    invalidI: 'Пенсія по інвалідності I ступеня',
    invalidIHint: 'часткове обмеження працездатності',
    invalidII: 'Пенсія по інвалідності II ступеня',
    invalidIIHint: 'серйозне обмеження працездатності',
    invalidIII: 'Пенсія по інвалідності III ступеня',
    invalidIIIHint: 'повна інвалідність — ви не можете працювати',
    nemocenska: 'Лікарняні (з 15-го дня)',
    nemocenskaHint: 'коротка хвороба / травма — 60 % зменшеної бази',
    poznamka: 'Орієнтовна оцінка за правилами, чинними з 1. 1. 2025. Значення змінюються щосічня — консультант перевірить актуальні цифри соцстраху. Не є гарантією чи пропозицією.',
    starobni: 'Пенсія за віком',
    starobniHint: 'оцінка, якби ви вийшли на пенсію з нинішнім доходом (без індексації)',
  },
  duchodCil: {
    nazev: 'На пенсію — зберегти рівень життя',
  },
  zdrojAnalyza: {
    naposledy: 'Останнє оновлення',
    vysvetleni: 'Перенесено з фінансового аналізу. Суми та назву перезаписує аналіз, нотатки й адресу тримає консультант.',
    zaklad: 'з аналізу',
  },
  osaObchodu: {
    bezData: 'без дати',
    bezDataHlavicka: 'Без дати',
    diar: 'щоденник',
    dnes: 'Сьогодні',
    faze: 'етап',
    naplanovano: 'заплановано',
    poznamkaChyba: 'Не вдалося зберегти зміну',
    poznamkaDlouha: 'Нотатка задовга ({delka} із максимум {max} символів).',
    poznamkaPrazdna: 'Нотатка не може бути порожньою.',
    poznamkaUlozena: 'Нотатку змінено',
    prazdna: 'Активності ще немає. Додай першу нотатку нижче.',
    stav: { deleted: 'скасовано', detached: 'відʼєднано', done: 'виконано', planned: 'очікує' },
    typ: { call: 'дзвінок', email: 'е-мейл', note: 'нотатка', sms: 'SMS', system: 'система' },
    ulozit: 'Зберегти',
    upraveno: 'змінено',
    upravenoTitul: 'Змінено',
    upravitPoznamku: 'Змінити нотатку',
    zaznamu: 'записів',
    zeZalozeni: 'зі створення',
    zobrazitStarsi: 'Показати старіші ({pocet})',
    zrusit: 'Скасувати',
  },
  /* M13 · rizika samotného dítěte v Návrhu řešení — components/plan/DetskaRizikaBlok.js */
  /* BLOK:detiRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  detiRizika: {
    deti: 'Діти ({n}×)',
    dite: 'Дитина',
    hlavicka: 'дитячий договір',
    hlavickaKazde: 'суми на кожну дитину',
    hospitalizace: 'Госпіталізація',
    hospitalizacePozn: 'за кожну ніч у лікарні — хтось із батьків поруч із дитиною замість роботи, а державна допомога покриває лише частину',
    kojenec: 'до 1 року',
    naDite: ' / дитина',
    nadpis: 'Страховий захист дитини ({n}×)',
    odskodne: 'Щоденна виплата на час лікування травми',
    odskodnePozn: 'з першого дня лікування, без періоду очікування — одужання вдома коштує батькам ще кількох робочих днів',
    odskodneStrop: 'Щоденні виплати перевищують чистий денний дохід того з батьків, хто доглядає ({strop}) — понад ліміт андеррайтингу, перевірте у страховика.',
    pc: 'Страхова сума в договорі дитини',
    pcPozn: 'сума обох позицій вище, обмежена межею страхування',
    radekTrvale: 'Стійкі наслідки та догляд',
    rodic: 'хтось із батьків',
    sablona: 'ШАБЛОН',
    sablonaPozn: 'Суми — це зразок із практики консультанта, а не пропозиція чи гарантія. Конкретні ліміти, винятки та ціну консультант перевірить у страховій компанії.',
    sekceTrvale: 'Якщо дитина назавжди залишиться залежною від догляду',
    sekceVlastni: 'Ризики самої дитини — окремі додаткові покриття',
    stitekNadStropem: 'понад ліміт',
    stitekSablona: 'шаблон',
    strop: 'Уся потреба становить {potreba}; у дитячому договорі страховики беруть орієнтовно до {strop}. Решта {zbytek} належить до резерву та інвестиційного плану, а не до поліса.',
    tnu: 'Стійкі наслідки нещасного випадку в дитини',
    tnuPozn: 'прогресивна виплата за діапазонами — у нашій моделі щонайбільше 2,8× суми, у страховиків різниться',
    uvod: 'У дитини ще немає доходу, який можна страхувати. Страхується те, що справді коштує родині грошей: той із батьків, хто через догляд або лікування залишає роботу, і витрати на лікування.',
    vekFew: '{n} роки',
    vekMany: '{n} років',
    vekOne: '{n} рік',
    vypadekRodice: 'Втрачений дохід того з батьків, хто доглядає',
    vypadl: 'роботу залишить {kdo}',
    vypadlAuto: 'роботу залишить {kdo} — припущення, рахується той із батьків, хто має менший дохід',
    zaDen: '/день',
    zaNoc: '/ніч',
    zavazne: 'Критичні захворювання',
    zavazneBezZakladu: 'У того з батьків, хто доглядає, в аналізі не вказано дохід — суму додасть консультант, система її не вигадує.',
    zavaznePozn: 'лейкоз, пухлини, діабет 1 типу, епілепсія — одноразова виплата на лікування і на те, щоб хтось із батьків міг залишитися з дитиною вдома',
    zavazneStrop: 'Розрахована потреба з доходу того з батьків, хто доглядає, становить {potreba}; дитячі договори покривають орієнтовно до {strop}. Решта {zbytek} належить до резерву.',
  },
  /* BLOK:detiRizika END */

  /* BLOK:zivotkoKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoKalk: {
    celkemMesicne: 'Разом на місяць',
    cenaNadpis: 'Ціна покриття (страховий внесок)',
    cenaPopis: 'Введіть реальний місячний внесок обраної страхової — порахується загальна ціна захисту.',
    cil: 'Ціль',
    cilBydleni: 'Погасити житло',
    cilDuchod: 'Пенсія',
    cilVzdelani: 'Освіта дітей',
    cileMale: 'цілі',
    cilePlanNadpis: 'Цілі — скільки інвестувати щомісяця',
    cilePlanPopis: 'За дохідності {vynos} % на рік. Рента перераховується на капітал коефіцієнтом ×{nasobek} — це {pct} % безпечного вилучення на рік (1 млн = {koef}).',
    cilePripocet: 'Сума додається до покриття (смерть/інвалідність). Фінансова незалежність = рента → інвестиційний план нижче (скільки інвестувати щомісяця).',
    cileRodiny: 'Цілі родини',
    cileZadanych: 'Цілі: введено',
    cilovaCastka: 'Цільова сума',
    cistyPrijem: 'Чистий місячний дохід',
    cistyPrijemMaly: 'чистий дохід',
    davkyNadpis: 'Огляд державних виплат і втрати доходу',
    davkyPopis: 'Скільки клієнт реально отримає від держави — і скільки йому щомісяця бракує. Орієнтовна оцінка за доходом і віком.',
    davkyPoznamka: 'Орієнтовна оцінка (реальні дані соцстраху можуть відрізнятися). Вкажіть вік особи для точнішої оцінки.',
    davkyPoznamkaKratka: 'Орієнтовна оцінка (реальні дані соцстраху можуть відрізнятися).',
    den: 'день',
    denNaHlavu: 'день на людину',
    denniDavkyPn: 'Щоденні виплати (лікарняний)',
    dluhy: 'Борги (до погашення)',
    dluhyMale: 'борги',
    dnesniHodnota: 'сьогоднішня вартість',
    do1Roku: 'до 1 року',
    grafNadpis: 'Що залишиться, коли дохід зменшиться',
    grafPopis: 'Зелене — це подушка: те, що лишається після оплати обовязкових витрат.',
    hned: 'одразу',
    invDuchodPodleZakona: 'за законом',
    invalidita: 'Інвалідність',
    invalidniDuchodMaly: 'пенсія по інвалідності',
    invalidniDuchodMes: 'Пенсія по інвалідності / міс',
    jehoPodil: 'його частка',
    klient: 'Клієнт',
    likvidniRezerva: 'Ліквідний резерв',
    mesTecka: 'міс.',
    mesZkratka: 'міс',
    mesicneInvestovat: 'Інвестувати щомісяця',
    naXLet: 'на {roky} років',
    navrhOchrany: 'Пропозиція захисту родини',
    nazevCile: 'Назва цілі',
    nejvetsiDopad: 'Найбільший вплив',
    nemocenska: 'лікарняні',
    nezbytneVydaje: "Обов'язкові витрати / міс",
    odMesice: 'з {n}-го місяця',
    odPrvnihoDne: 'з 1-го дня',
    odkazTitle: 'Надіслати клієнту посилання на цю модель',
    osoba: 'Особа',
    osobaN: 'Особа {n}',
    osobaPlaceholder: "Особа {n} — ім'я",
    osvc: 'ФОП',
    osvcPlne: 'ФОП (без лікарняних)',
    osvcVarovani: 'Під час непрацездатності не отримає від держави нічого → більша потреба у виплатах за лікарняним.',
    paramKoefRenty: 'Коефіцієнт ренти',
    paramKoefRentyHint: '= {pct} % безпечного вилучення на рік · рента → капітал ×{nasobek} (менша сума = вищий множник)',
    paramNarust: 'Зростання витрат при інвалідності',
    paramNarustHint: 'догляд, переобладнання житла, ліки',
    paramPokles: 'Зниження витрат після смерті',
    paramPoklesHint: 'родина після втрати члена витрачає менше',
    paramTnPrah: 'Поріг стійких наслідків (виплата від %)',
    paramTnPrahHint: 'нижче порогу виплати немає; повне покриття приблизно при 60 %',
    paramVynos: 'Дохідність інвестиції (p. a.)',
    paramVynosHint: 'для розрахунку щомісячної інвестиції на цілі',
    parametryMetodiky: 'Параметри методики',
    patickaDavky: 'Соціальні виплати (вдовина {vdovsky}{sirotci}, пенсія по інвалідності) є ОРІЄНТОВНОЮ ОЦІНКОЮ за доходом — не обіцянкою держави. Реальний розмір перевірить консультант.',
    patickaMetodika: 'Орієнтовне рекомендоване покриття за методикою beplan (методика {verze}): інвалідність/смерть капітальним методом @ 4 % реально — витрати домогосподарства після події мінус доходи, які лишаться родині, мінус державні виплати. Лікарняний = чистий дохід − виплата за лікарняним. Конкретний внесок і умови залежать від обраної страхової. Останнє слово має консультант.',
    patickaSirotci: ', сирітські разом {castka}',
    pdfInvaliditaPopis: 'коли ви більше не можете працювати',
    pdfJakRozumet: '<b>Як це читати:</b> Цифри показують, скільки родина отримала б, якби сталося найгірше — щоб могла й далі жити у своєму житлі, тримати рівень життя, а діти доучилися. <b>Інвалідність</b> має вищу суму, ніж смерть, бо хвора людина вдома потребує ще й догляду та переобладнання. <b>Непрацездатність</b> покриває нестачу доходу під час короткої хвороби чи травми.',
    pdfPaticka: 'Необовязкова орієнтовна пропозиція. Конкретні умови та ціни узгодимо разом.',
    pdfPnPopis: 'коротка хвороба або травма',
    pdfSmrtPopis: 'щоб родині не було чого боятися',
    pdfTitle: 'Завантажити / роздрукувати PDF для клієнта',
    pdfTnuPopis: 'серйозніша травма = більша виплата',
    pdfZavaznePopis: 'рак, інфаркт, інсульт…',
    perex: 'Введіть доходи та витрати родини → я порахую рекомендоване покриття: інвалідність, смерть, непрацездатність, стійкі наслідки травми та тяжкі захворювання.',
    pnCelkem: 'Родині потрібні виплати за лікарняним разом',
    pnUraz: 'Непрацездатність / травма',
    pocetDeti: 'Кількість дітей',
    podPrahem: '→ нижче порогу',
    podilDluhu: 'частка боргів',
    podilNezbytnych: 'частка обовязкових витрат',
    pojistnaCastka: 'Страхова сума:',
    poskozeni: 'ушкодження',
    poslatKlientovi: 'Надіслати клієнту',
    potrebnyKapital: 'Потрібний капітал',
    pozustalostniDavky: 'виплати на утриманців',
    pracNeschopnost: 'Непрацездатність',
    pracovniNeschopnost: 'Непрацездатність',
    prezentovat: 'Презентувати',
    pridatCil: 'Додати ціль',
    pridatOsobu: 'Додати особу',
    prijemMaly: 'дохід',
    prijmyOstatnich: 'доходи інших',
    procInvalidita: 'Дохід зникає назавжди, а витрати ЗРОСТАЮТЬ (доглядальник, переобладнання). Часто руйнує родину швидше за смерть — тому це ризик номер один.',
    procNadpis: 'Чому цей захист важливий',
    procPn: 'Хвороба чи травма на кілька місяців: держава дає мало (ФОП нічого). Щоденна виплата покриває нестачу — вдома ви думаєте про одужання, а не про рахунки.',
    procSmrt: 'Щоб після годувальника родині лишилася впевненість, а не борги та іпотека. Діти доучаться, партнер не мусить міняти життя.',
    procTnu: 'Серйозна травма = стійке обмеження. Прогресивна виплата: що важча травма, то більша одноразова сума на переобладнання та життя.',
    progresivni: 'прогресивна',
    renta: 'рента',
    rentaMes: 'Рента / міс',
    rezervaHint: 'вистачить на ~{mes} міс.',
    rezervaPokryje: 'резерв покриє перші {mes} міс., виплату запропоновано з {odMes}-го місяця',
    rodina: 'Родина',
    sloupecChybi: 'Бракує /міс',
    sloupecChybiMes: 'Бракує / міс',
    sloupecDokryt: 'Покрити страховкою',
    sloupecDostane: 'Отримає від держави',
    sloupecSituace: 'Ситуація',
    sloupecStat: 'Держава /міс',
    sloupecStupen: 'Ступінь',
    smrt: 'Смерть',
    stupneNadpis: 'Інвалідність за ступенем',
    stupneNota: 'Стовпчик покрити страховкою = капітал, щоб закрити нестачу на {roky} років.',
    stupnePopis: 'Вищий ступінь = більша виплата від держави, але й більша втрата доходу → більше треба покрити страховкою. III = повна інвалідність (не може працювати), I = часткове обмеження.',
    tela: 'тіла',
    titul: 'Калькулятор страхування життя',
    tnuNadpis: 'Стійкі наслідки — прогресивна виплата',
    tnuPrah: 'Виплата від {prah} % ушкодження, повне потрібне покриття приблизно при 60 %.',
    tnuVzorec: 'Виплата = сума × множник × %.',
    tnuZeCastky: 'Зі страхової суми',
    toJePctPrijmu: 'це {pct} % чистого доходу родини',
    trvaleNasledky: 'Стійкі наслідки',
    trvaleNasledkyUrazu: 'Стійкі наслідки травми',
    typCastka: 'Сума',
    typRenta: 'Фін. незалежність',
    uvodniZprava: 'Доброго дня, надсилаю пропозицію щодо захисту вашої родини — скільки родині було б потрібно, якби щось сталося. Погляньте і сміливо звертайтеся.',
    variantaKryti: 'Варіант покриття (смерть + інвалідність)',
    variantaKrytiKratce: 'Варіант покриття',
    variantaSlovo: 'варіант',
    vek: 'Вік (років)',
    vekHint: 'для огляду державних виплат',
    vekPrijem: '{vek} років · дохід {castka}',
    vydajeRodiny: 'витрати родини',
    vyssiVydaje: 'витрати вищі на {pct} % (догляд, переобладнання)',
    waTitle: 'Надіслати клієнту пропозицію через WhatsApp',
    xLet: '{n} років',
    xOsob: '{n} осіб',
    xRocniPrijem: '{n}× річний дохід',
    zaKolikLet: 'Через скільки років',
    zadejPrijem: 'Введіть хоча б один дохід.',
    zajistitNa: 'Забезпечити на (років)',
    zamestnanec: 'Найманий працівник',
    zavazneOnemocneni: 'Тяжкі захворювання',
  },
  /* BLOK:zivotkoKalk END */
  rozvahaGraf: {
    bezOceneni: 'Без оцінки лишається {pocet} {polozka} — до підсумку не входять.',
    cisteJmeni: 'Чисті активи',
    cisteJmeniPod: 'що має мінус що винен',
    coDluzi: 'Що винен',
    coVlastni: 'Що має',
    financni: 'Фінансові активи',
    nefinancni: 'Нерухомість і речі',
    podilDluhu: 'Борг становить {pct} % майна — решта справді його.',
    vecnyMajetek: 'З того матеріальні активи',
    zavazky: 'Зобовʼязання',
  },
  menaAnalyzy: {
    bezRazitka: 'Цей аналіз із часів, коли валюта не зберігалася в даних — читаємо його як {mena}. Обліковий запис сьогодні працює в {ucet}.',
    neprepocitava: 'Суми НЕ ПЕРЕРАХОВУЮТЬСЯ — лишаються такими, як були введені, застосунок не знає курсу. Підписи нижче показують {symbol}. Перевірте числа, перш ніж показувати їх клієнту.',
    pozor: 'Увага на валюту.',
    ulozena: 'Аналіз збережено в {mena}, обліковий запис сьогодні працює в {ucet}.',
  },
  zivotkoGraf: {
    celyPrijem: '— увесь дохід',
    cenaDenne: '{castka} на день на кожного з {hlav} членів родини.',
    cenaInvalidita: 'інвалідність',
    cenaPctPrijmu: 'Це {pct} % вашого доходу.',
    cenaPresahuje: 'Перевищує його — і ми цього не приховуємо.',
    cenaSablona: 'Приблизна оцінка з нашого зразка тарифів — ШАБЛОН, не пропозиція. Точну ціну визначить страхова за віком і медичною анкетою.',
    cenaSmrt: 'смерть',
    cenaStrop: 'Ліміт {pct} % доходу = {castka}.',
    cenaVejde: 'Вкладається в нього.',
    cenaZavira: 'Це закриває дірку, яку ви щойно бачили:',
    davkaInvalidIII: 'Пенсія по інвалідності',
    davkaNemocenska: 'Лікарняні',
    davkaObecna: 'Виплата',
    davkaPozustalostni: 'Вдовина + сирітська',
    mesZkr: 'міс.',
    mesZkratka: 'міс',
    nazevDnes: 'Сьогодні',
    nazevInvalidita3: 'Інвалідність III ступеня',
    nazevMzda5: 'Шеф зріже 5 %',
    nazevPn: 'Тривала хвороба',
    nazevSmrt: 'Смерть годувальника',
    popisChybi: 'Бракує щомісяця.',
    popisDnes: 'Стільки лишається, коли все гаразд.',
    popisDnesNapjato: 'Бюджет напружений уже сьогодні — подушки немає.',
    popisNastve: 'Це вас розлютить. Але ви впораєтеся самі.',
    popisRezervaMesice: 'Резерв витягне це {mes} місяця.',
    popisRezervaZadna: 'Жодного резерву на це немає.',
    popisZvladnete: 'Ви впораєтеся. Заощадження та відпустки закінчаться.',
    proporceNecerpa: 'Резерв не витрачається — дохід і виплати покривають витрати.',
    proporceRezerva: 'Ваш резерв',
    proporceSchodek: 'За нестачі {castka} на місяць резерв покриє {pct} % цього часу.',
    proporceStat: 'Держава під час хвороби — період підтримки',
    proporceStrop: 'Лікарняні мають ліміт {dni} днів.',
    proporceTrvani: 'До пенсії залишилося',
    proporceVek: '{vek} років, до пенсії ({duchodVek}) лишається {roky} років.',
    vynechanoCena: 'Крок із ціною пропущено: ціну покриття не введено і оцінити її неможливо.',
    vynechanoHlavy: 'Щоденний розподіл ціни не показано: немає з чого порахувати кількість членів родини.',
    vynechanoMena: 'Графік не показано: державні виплати застосунок поки що вміє лише для Чехії. Чеські виплати, поділені на курс, не є словацькими виплатами.',
    vynechanoPoDuchodu: 'Крок „як довго це триває“ пропущено: головна особа вже пенсійного віку.',
    vynechanoPrijem: 'Графік не показано: не введено жодного доходу. Без доходу всі щаблі були б нулем.',
    vynechanoVek: 'Крок „як довго це триває“ пропущено: у головної особи не вказано вік.',
    vynechanoVydaje: 'Графік не показано: не введено обовязкових витрат. Без них немає з чим порівнювати дохід.',
  },
  navrhVystupy: {
    jednaStrana: '1 сторінка',
    jednaStranaTitul: 'План на одну сторінку',
    plnyPlan: 'Повний план',
    plnyPlanTitul: 'Повний фінансовий план',
    poznamka: 'Нотатка до пропозиції',
  },
  slozkaKlienta: {
    adresyKontakty: 'Адреси та контакти',
    aktivita: 'Активність',
    analyza: 'Аналіз',
    kraj: 'Область',
    mobil: 'мобільний',
    nabor: 'НАБІР',
    odhadPotencialu: 'Оцінка потенціалу клієнта',
    prijmeniPriklad: 'Шевченко',
    sidloKlienta: 'Адреса клієнта',
    stitky: 'Мітки',
    vlastnik: 'Власник',
    vztahKlient: 'Клієнт',
    vztahPartner: 'Партнер',
    zalozkyKlienta: 'Вкладки клієнта',
    zdrojKontaktu: 'Джерело контакту',
    zdrojLeadovac: 'Leadovač',
    zdrojReklama: 'Реклама',
  },
  duchodKarta: {
    aktualizovatCil: 'Оновити ціль',
    bezVeku: 'вкажіть вік, інакше горизонт накопичення порахувати не можна (і вгадувати його не будемо).',
    chceMitMesicne: 'Хоче мати щомісяця',
    chybi: 'Бракує',
    cilovyStandard: 'Цільовий рівень життя на пенсії',
    daStat: 'Дасть держава',
    disclaimer: 'Державна пенсія — ОРІЄНТОВНА ОЦІНКА за доходом і віком, без індексації — не обіцянка держави. Цільовий рівень життя обирає консультант, це не вимірювання. Суми в сьогоднішніх грошах.',
    doDuchodu: '· до пенсії {roky} років',
    duchodovyVek: 'Пенсійний вік',
    kapitalRadek: 'капітал {castka} · {roky} років · {vynos} % p. a.',
    mesicneOdkladat: 'Відкладати щомісяця',
    nadpis: 'До пенсії — зберегти рівень життя',
    nahradiPct: 'замінить {pct} % чистого доходу',
    odPoradce: 'від консультанта',
    osoba: 'Особа',
    poDuchodovemVeku: 'Вік уже за пенсійним — на накопичення часу не лишається, сума потрібна одразу.',
    popis: 'Скільки з доходу замінить держава і скільки клієнт має додати сам. Кнопкою з цього стане ціль типу фінансова незалежність.',
    prepsatDuchod: 'Переписати державну пенсію',
    pridatJakoCil: 'Додати як ціль',
    radekVek: '{vek} років · {castka}/міс',
    sablona: 'Шаблон',
    standardHint: '% сьогоднішнього чистого доходу. Менше ніж 100 %, бо на пенсії відпадає те, що клієнт платить САМЕ ТОМУ, що працює і відкладає на пенсію.',
    statNeodhadujeme: 'Державну пенсію тут не оцінюємо',
    statNeodhadujemeHint: 'оцінка діє лише для Чехії. Введіть суму, і я дорахую решту.',
    statPokryjeCely: 'держава покриє всю ціль',
    statPokryvaPct: 'держава покриє {pct} % цілі',
    vekHint: 'оцінка, можна переписати',
  },
  /* Srovnávač fondů (/srovnavac-fondu). Doplněno 23. 8. 2026 — klíče se
     volaly, ale nebyly v žádném slovníku, takže vietnamský i ukrajinský
     poradce viděl český fallback. */
  fondy: {
    export: {
      chyba: "Не вдалося підготувати графік.",
      hotovo: "Завантажено.",
      pngChyba: "Не вдалося створити PNG. Спробуй SVG — його можна відкрити у браузері.",
      nese: "Зображення містить джерело, дату та застереження.",
      csvSrovnani: "Завантажити CSV з порівнянням",
      csvRady: "Завантажити CSV з рядами",
    },
    tabulka: {
      popisek: "Шість критеріїв поруч. Застосунок не ранжує фонди за якістю і жодного з них не рекомендує — вибір за консультантом.",
    },
    prazdno: {
      nadpis: "У каталозі поки немає даних про фонди",
      veta: "Порівнювач готовий — чекає лише на дані. Історичні значення сюди не переписуються з графіків, вони завантажуються імпортом трьох CSV-файлів за інструкцією в docs/penze/JAK-DODAT-DATA.md. Порожній екран чесніший за вигадані числа.",
      demo: "Показати на демоданих",
    },
    srovnavac: {
      nadpis: "Історичний порівнювач фондів",
      kotva: "Період рахується назад від останнього дня наданих даних, а не від сьогодні — інакше у п'ятирічному вікні було б лише чотири роки.",
    },
    filtr: {
      obdobi: "Період",
      zobrazeni: "Показати",
      jednotlive: "Окремі фонди",
      prumeryNapoveda: "Середнє рахується лише з фондів, які покривають увесь період.",
      prumery: "Середні за стратегіями",
      strategie: "Стратегія",
      skupiny: "Інвестиційні групи",
      spolecnost: "Пенсійна компанія",
      historie: "Коротша історія",
      jenPlna: "Виключити фонди без повної історії",
      zrusit: "Скасувати фільтри",
      prazdno: {
        nadpis: "Жоден фонд не відповідає фільтру",
        veta: "Спробуй прибрати частину обмежень — або такого фонду в каталозі поки немає.",
      },
    },
    vyloucene: "Ти виключив з порівняння:",
    varianty: {
      metrika: "ПОРІВНЯТИ ЗА",
    },
    vyber: {
      nadpis: "Як вибрати фонд",
      veta: "Найвища історична дохідність не є критерієм. Поруч мають стояти горизонт клієнта, коливання, наскільки довгу історію фонд узагалі має, його розмір, законодавчий показник ризику SRI та витрати. Застосунок показує числа; оцінити, що з цього підходить конкретному клієнтові, може лише консультант.",
    },
    prumery: {
      nadpis: "З чого розраховані середні",
    },
    demo: {
      odznak: "ДЕМОДАНІ",
      veta: "Приклад вигаданих чисел. Не використовувати з клієнтом.",
      vysvetleni: "Ці ряди ніхто не публікував — вони вигадані, щоб можна було розробляти екрани. Вони зростають щороку на однаковий відсоток, чого в реальності не буває. Справжні дані надаються імпортом, інструкція в docs/penze/JAK-DODAT-DATA.md.",
    },
  },

  penzeUi: {
    zaklad: { nominalne: "Номінально", dnesniCeny: "У сьогоднішніх цінах", nominalneKratce: "номінально", dnesniCenyKratce: "у сьогоднішніх цінах" },
    rada: { vlastni: "Власні внески", zamestnavatel: "Роботодавець", stat: "Державна дотація", zhodnoceni: "Дохідність" },
    most: { vklad: "Власний внесок", zamestnavatel: "Роботодавець", strategie: "Стратегія" },
    strategie: { konzervativni: "Консервативна", vyvazena: "Збалансована", dynamicka: "Динамічна", stare: "Стара пенсійна схема" },
    cesta: { dnes: "Поточний стан", kombinace: "Комбінація DPS + DIP", zamestnavatel: "З роботодавцем" },
  },
  /* Страхування осіб (Пропозиція рішення + презентація плану). */
  /* BLOK:pojisteniOsob START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniOsob: {
    bezPrijmu: 'Немає залежного доходу — втрату покриває надлишок домогосподарства.',
    cena: '≈ Орієнтовна премія',
    cenaCelkem: '≈ Орієнтовна премія за всіх осіб',
    denni: '/день',
    diteRozporText: "В аналізі є рядок дитини без імені та дати народження. Пенсія у зв'язку з втратою годувальника за дитину, якої немає в аналізі, зменшила б страхові суми — тому такий рядок не враховано. Додайте дитину до аналізу або видаліть порожній рядок.",
    diteRozporTitul: 'Дитина без імені не враховується',
    doplnitNarozeni: 'Додати дату народження',
    invalidita: 'Інвалідність (2–3 гр.)',
    klient1: 'Клієнт 1',
    klient2: 'Клієнт 2',
    mesicni: '/міс',
    metodika: 'Капітальний метод @ 4 % реально: витрати домогосподарства після події − доходи, які залишаються родині, − державні виплати, на {roky} років + борги ({dluhy}) + цілі − ліквідне майно. Варіант {varianta} рахує цілі ×{kCile} і {vydaje}; борги не зрізаються ніколи. Суми є пропозицією — останнє слово має радник.',
    odskodne: 'Щоденна виплата за травму',
    osvc: 'ФОП',
    partnerNespocteno: '{jmeno}: захист не розраховано — бракує дати народження',
    partnerNespoctenoText: 'План не страхує партнера і не рахує ціну його страхування.',
    pn: 'Непрацездатність',
    pnPozn: 'з {mesic}-го місяця — доти тримає резерв',
    pnPoznNic: 'резерв і лікарняні покриють втрату',
    pnPoznOsvc: 'з {mesic}-го місяця — доти тримає резерв',
    popisInvalidita: 'Інвалідність — це тривала втрата доходу, яку резерв не покриє, а витрати ще й зростають (догляд, переоблаштування житла). Фінансово більший ризик, ніж смерть.',
    popisOdskodne: 'Травма зупиняє дохід з першого дня — без періоду очікування. Щоденна виплата компенсує втрачений дохід протягом лікування.',
    popisPn: 'Коротка втрата доходу понад резерв: лікарняні покривають лише частину чистого доходу, виплата вирівнює бюджет. Перші місяці тримає резерв, тож довший період очікування означає нижчу премію.',
    popisSmrt: 'Замінює дохід родині: покриває звичайні витрати, платежі за кредитами та вже розпочаті цілі, щоб родині не довелося міняти життя за один день. Лише до фінансової незалежності; сума, що спадає, дешевша.',
    popisTnu: 'Стійке пошкодження після травми означає постійно вищі витрати. Прогресивна виплата за діапазонами: що важчі наслідки, то вища виплата (у нашій моделі щонайбільше 2,8× суми — у страховиків різниться).',
    popisZavazne: 'Рак, інфаркт, інсульт: лікування триває місяцями, дохід падає, а витрати зростають. Одноразова виплата дає змогу припинити роботу й лікуватися, не витрачаючи резерв чи інвестиції родини.',
    prijem: 'дохід',
    rozporText: 'У другої особи заповнений дохід {castka}, але немає ні імені, ні дати народження. Покриття для людини, якої немає в аналізі, перед клієнтом не захистиш. Додайте партнера до аналізу або виправте дохід.',
    rozporTitul: 'Друга особа не рахується — її немає в аналізі',
    smrt: 'Смерть',
    titul: 'Страхування осіб — розраховане на досягнення всіх цілей',
    tnu: 'Стійкі наслідки травми',
    tnuPozn: 'прогресивна виплата за діапазонами — у нашій моделі щонайбільше 2,8× суми, у страховиків різниться',
    tnuPrilepek: ' з прогресією',
    zavazne: 'Критичні захворювання',
    zavaznePozn: '{nasobek}× річний дохід',
    zavaznePoznVyplata: 'Одноразова виплата на лікування та на час, коли клієнт не може працювати.',
  },
  /* BLOK:pojisteniOsob END */
  /* РУЧНІ ЗНАЧЕННЯ КОНСУЛЬТАНТА — перезапис страхових сум і цін у пропозиції. */
  rucniPojisteni: {
    chip: "вручну",
    upravit: "Змінити вручну",
    hotovo: "Готово",
    vratit: "Повернути до розрахованого",
    system: "Система рахує {castka}",
    titul: "Ціни та суми перепишіть за реальною пропозицією",
    vysvetleni: "Натисніть на олівець біля будь-якої суми чи ціни та введіть те, що клієнт справді має укладене. Ручне значення позначене, а розраховане залишається поруч, тож різницю можна будь-коли показати або скасувати.",
    pocet: "{n}× вручну",
    vratitVse: "Повернути все до розрахованого",
    cenaOsoby: "Орієнтовний внесок",
    nezadanaVarianta: "Для цього варіанта ціну не введено",
    perVarianta: "Ліміти і ціни зберігаються ОКРЕМО ДЛЯ КОЖНОГО ВАРІАНТА (зараз {varianta}). Змоделюйте варіанти у страховій і введіть для кожного його ліміти та ціну — з клієнтом потім перемикаєтеся між ними й показуєте ліміт разом із ціною.",
    odhadSablona: "оцінка за шаблоном тарифів, не пропозиція страхової",
    ukladam: "Зберігаю ручні значення…",
    ulozeno: "Ручні значення збережено",
    chyba: "Ручні значення не вдалося зберегти — спробуйте кнопку Зберегти пропозицію",
  },
  /* BLOK:srovnaniPojisteni START — generuje scratchpad/slovnik.py, ručně needitovat */
  srovnaniPojisteni: {
    aspon: 'мін.',
    celkem: 'Разом',
    chybi: {
      cena: '{kdo}: для варіанта {varianta} не введено ціну. Змоделюйте її у страховій і запишіть олівцем у картці Страхування осіб — ціна зберігається окремо для кожного варіанта.',
      cenaBezVarianty: '{kdo}: для вибраного варіанта не введено ціну. Змоделюйте її у страховій і запишіть олівцем у картці Страхування осіб — ціна зберігається окремо для кожного варіанта.',
      cenaCastecna: 'Ціну введено лише для частини осіб, тому підсумок частково є оцінкою. Допишіть її олівцем і для решти осіб у картці Страхування осіб.',
      cenaDetske: 'У пропозиції є й дитячий договір, а його премію застосунок може лише оцінити — сума за дорослих тому не є ціною всієї пропозиції. Введіть загальну ціну з пропозиції страхової.',
      limitRizika: '{kdo}: у наявному договорі немає страхової суми — {riziko}. Додайте її в аналізі біля договору.',
      platba: '{kdo}: у наявному договорі немає місячного платежу — без нього не можна сказати, скільки платить сьогодні.',
      platbaCastecna: '{kdo}: у договорах {smlouvy} немає місячного платежу, тому „платить сьогодні“ нижче за дійсність.',
      prirazeni: 'У договорах {smlouvy} ризики записані без особи, тому зараховуються годувальнику. За особами вони розділяться, коли в аналізі біля договору виберете, чиї це ризики (Страхові договори → Ризики в договорах).',
      smlouvaPartnera: 'Договори {smlouvy} призначені партнеру, якого немає в аналізі — до порівняння вони не входять.',
      smlouvaPartneraNespocteno: 'Договори {smlouvy} належать партнеру, чий захист план не розрахував (бракує дати народження) — до порівняння вони не входять і план їх не скасовує.',
      smlouvaSpolecnaBezPartnera: 'Зі спільних договорів {smlouvy} враховується лише частина клієнта — партнера немає в аналізі.',
      smlouvaSpolecnaNespocteno: 'Договори {smlouvy} можуть покривати й партнера, чий захист план не розрахував (бракує дати народження) — тому план їх не скасовує. Додайте в аналізі дату народження партнера.',
      zadneSmlouvy: 'В аналізі немає жодного страхового договору зі страховою сумою.',
    },
    dnesNekryty: 'сьогодні без покриття',
    dnesNeplati: 'сьогодні не платить',
    domacnost: 'Домогосподарство (обидві особи)',
    doplnKde: "Додайте її в аналізі: Зобов'язання та договори → Страхові договори → Ризики в договорах → інвалідність / смерть в особи. Лише тоді можна показати клієнту, що новий ліміт у кілька разів вищий, а ціна ні.",
    doplnTitul: 'Без страхової суми старого договору це не порівняння, а подорожчання',
    doplnTlacitko: 'Додати в аналізі',
    hlavicka: {
      budePlatit: 'Платитиме',
      nasobekCeny: 'Ціна',
      nasobekKryti: 'Покриття',
      novy: 'Новий ліміт',
      platil: 'Платить сьогодні',
      puvodni: 'Ліміт сьогодні',
      riziko: 'Ризик',
    },
    nezadano: 'не введено',
    novyNula: 'покриття не пропонуємо',
    podtitul: 'варіант {varianta}',
    poznamka: '„Платитиме“ — це ціна з пропозиції страхової, яку ви ввели вручну для цього варіанта; застосунок не бере її з шаблону тарифів. Порожнє поле означає, що ще не введено, а не нуль.',
    prirazenoZiviteli: 'ризики без особи — враховано годувальнику, уточніть в аналізі',
    riziko: {
      invalidita: 'Інвалідність',
      smrt: 'Смерть',
    },
    titul: 'До і після — що має сьогодні і що матиме',
    vyhra: '{kdo}: покриття зростає у {pomer}× швидше, ніж ціна.',
    zivitel: 'годувальник родини',
  },
  /* BLOK:srovnaniPojisteni END */
  /* POJIŠTĚNÍ MAJETKU A ODPOVĚDNOSTI (karta v Návrhu řešení).
     Násobek u odpovědnosti vůči zaměstnavateli je ZÁKONNÝ STROP a v každé zemi
     jiný (CZ 4,5× / SK 4×) — do vět chodí parametrem `{nasobek}`, NIKDY ho sem
     nepiš natvrdo. Zdroj předpisu drží lib/odpovednostZamestnavateli.js. */
  pojisteniMajetku: {
    titul: "Страхування майна та відповідальності",
    nemovitost: "Нерухомість",
    nemovitostPopis: "На повну вартість з аналізу — страхова сума дорівнює вартості будівництва наново (стережіться недострахування).",
    domacnost: "Домашнє майно",
    domacnostPopis: "Меблі, техніка, цінності. Оцініть за наявним обладнанням і уточніть разом із клієнтом.",
    odpovednost: "Цивільна відповідальність",
    odpovednostPopis: "Шкода, завдана іншим, не має межі (здоров'я, затоплення, збитий велосипедист) — ліміт беріть якнайвищий.",
    zamestnavatel: "Відповідальність перед роботодавцем",
    zamestnavatelOsoba: "Відповідальність перед роботодавцем — {jmeno}",
    zamestnavatelPopis: "Роботодавець може вимагати відшкодування збитків до {nasobek}-кратного середнього місячного заробітку — ліміт рахується з валової зарплати. На шкоду, завдану навмисно або в стані сп'яніння, ця межа не поширюється.",
    zamestnavatelPopis2: "Окремий договір для другої особи — ліміт рахується з ЇЇ валової зарплати, а не з доходу домогосподарства. Тут теж діє {nasobek}-кратний середній місячний заробіток.",
    hrubaMzda: "Валова зарплата",
    limit: "Ліміт {nasobek}×",
    zdrojLimitu: "Кратність — це законна межа, а не наша оцінка: {predpis}. Перевірено {datum}. Основою є середній місячний заробіток — з преміями він зазвичай вищий за валову зарплату, тож ліміт беріть як нижню межу.",
    pravni: "Юридичний захист",
    pravniPopis: "Адвокат і судові витрати у спорах — трудових, сусідських, споживчих.",
    nabidnout: "запропонувати",
    nenabizet: "не пропонувати",
    osvcTitul: "Підприємництво — ФОП і компанія",
    osvcPodtitul: "В аналізі є дохід від підприємництва або компанія в майні. Пройдіть із клієнтом, що він насправді має і що його підкосило б.",
    podnikatelske: "Підприємницьке страхування",
    podnikatelskePopis: "Професійна відповідальність, майно фірми, перерва в діяльності. Поліс на домашнє майно цього не покриває — шкода на замовленні з нього не сплачується.",
    resit: "вирішувати",
    neresit: "не вирішувати",
    zasoby: "Запаси",
    zasobyPopis: "Матеріали, товар і незавершене замовлення на складі та в авті. Якщо склад згорить, без цієї позиції клієнт не отримає нічого.",
    moviteVeci: "Рухоме майно та обладнання",
    moviteVeciPopis: "Інструменти, машини, техніка, обладнання приміщення. Порахуйте, що клієнт мусив би купити знову, щоб завтра працювати.",
    odpovednostPodnikatele: "Відповідальність підприємця",
    odpovednostPodnikatelePopis: "Шкода, завдана під час підприємництва клієнтові або третій особі. Рекомендований мінімум {limit} — одне затоплене приміщення або травма клієнта легко перевищать мільйон.",
    bezLimitu: "не вирішувати",
    mil: "млн",
    odhadTitul: "Орієнтовна загальна премія за майно",
    disclaimer: "Орієнтовна оцінка за шаблоном тарифів — це не пропозиція і не гарантія ціни. Конкретну премію уточнить радник за віком, станом здоров'я, тарифом, франшизою та виключеннями обраної страхової компанії.",
    mesic: "/міс",
    patka: "Завжди з франшизою — дрібні збитки покриває резерв, а поліс дешевший. Конкретні тарифи та виключення обирає радник.",
  },
  /* Рекомендація до кожної цілі — пропозиція системи з чисел плану + текст радника. */
  /* HORIZONT CILE — jedno misto pro "hned" a pro sklonovani let (audit R13).
   * Do 25. 8. 2026 si horizont dopocitavalo osm mist a kazde jinak: rezerva
   * "hned" (roky = 0) byla na karte "za 1 let", v tisku "—" a na slajdu
   * "za 0 let". Sklonovani dela t.plural (Intl.PluralRules podle jazyka),
   * ne ceske pravidlo 1 / 2-4 / 5+ — jinak ukrajinstina cte "za 21 rokiv".
   * Trojice One/Few/Many musi byt ve vsech peti slovnicich. */
  /* SHRNUTI — ROZDELOVNIK PLANU (predloha majitele, obrazovka „Shrnutí“ z FIP).
   * Tri pocitadla nahore, radek na cil. Texty NIKDY netvrdi nulu tam, kde je
   * neznamo: „bez vkladu“ / „doplň termín cíle“ misto „0“ a misto „0 %“.
   * Presplneny cil se rika slovem („splněno · přebývá X“), ne minusem —
   * predloha psala −749 471 a majitel si to sam vytkl. */
  /* BLOK:shrnutiPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  shrnutiPlan: {
    azPoCilovemDatu: 'після цільової дати — до цільової суми не входить',
    bezCiluKde: 'Додай їх в аналізі в розділі Цілі — без цільової суми ціль до плану взагалі не потрапить.',
    bezCiluTitul: 'План поки не має жодної цілі.',
    bezVkladu: 'без внеску',
    dnesPosle: 'сьогодні клієнт надішле {kc}',
    doplnCastku: 'додай цільову суму',
    doplnTermin: 'додай термін цілі',
    doplnenoEnginem: 'додано системою',
    doraziPozdeji: 'з них {kc} надійде пізніше',
    doraziVeVeku: 'з них {kc} надійде у {vek} років',
    dorovnat: 'дорівняти',
    dorovnatJednJak: 'Фіксує місячний платіж, а одноразовий внесок до нього розрахує система, щоб ціль була виконана повністю.',
    dorovnatPravJak: 'Фіксує одноразовий внесок, а місячний платіж до нього розрахує система, щоб ціль була виконана повністю.',
    editaceJak: 'Числа у стовпцях «Одноразовий внесок» і «Регулярний внесок» можна переписати прямо в рядку — переписане число відніметься від горщика вгорі, а друге до нього розрахує система. ↺ повертає розрахунок системи.',
    financni: 'Фінансові активи',
    kapital: 'капітал',
    mesicne: '/міс',
    nadKapacitu: 'понад спроможність домогосподарства',
    neboJednorazove: 'або {kc} одноразово',
    neboPravidelne: 'або {kc} щомісяця',
    nedosazitelne: 'ціль неможливо покрити',
    nefinancni: 'Нефінансові активи',
    nefinancniJak: 'Нерухомість і фірма. Спадок до цієї суми не входить — він окремо як майбутнє майно. До цілей вони потрапляють лише як майбутнє надходження (продаж) — воно задається в Пропозиції рішення у Досягненні цілей.',
    nelzeInvestovat: 'Не можна використати для інвестування.',
    nezapojeno: 'Не задіяно',
    nezapojenoJak: 'Пайові фонди, інвестиційне страхування, термінові вклади та іноземна валюта. План не перерозподіляє їх одноразово, тому вони не входять ні в «Розподілено», ні в «Залишилось».',
    nicNeni: 'нічого більше',
    plusKroky: '+ поступове збільшення ({n})',
    pocitam: 'Обчислюю підсумок…',
    podtitul: 'Три горщики вгорі, рядок на ціль. Розподіляй ресурси, доки в обох не світиться «Залишилось 0». Цифри ті самі, що в Пропозиції рішення — цей екран другий погляд на них, і розподіляти можна прямо тут.',
    poradce: 'Консультант',
    poznPlaceholder: 'Примітка до цілі для клієнта…',
    poznPrebiji: 'перекриває пропозицію системи у виводах',
    poznZpet: 'назад до пропозиції',
    prebytek: 'Місячний надлишок',
    prebytekNeznamy: 'Надлишок невідомий — додай витрати в аналізі',
    prebyva: 'надлишок {kc}',
    precerpano: 'Перевищено — стільки клієнт не має',
    pridatJenJedn: '← вирішується одноразово',
    pridatJenPrav: 'вирішується щомісяця →',
    prideleno: 'Розподілено',
    rezervaJednNelze: 'Резерв план формує з ресурсів і з надлишку — одноразовий внесок до нього не фіксується.',
    rezimJednorazove: 'Одноразово',
    rezimMesicne: 'Щомісяця',
    rezimOboji: 'І те, і те',
    rezimZpet: 'розрахунок системи',
    rozdano: 'Розподілено — залишилось 0',
    schodek: 'Витрати та платежі перевищують доходи — план нічим платити',
    splneno: 'виконано',
    systemBezVkladu: 'Система сама жодного додаткового внеску не рахує.',
    thCil: 'Опис цілі (що?)',
    thDosazeno: 'Досягнута сума',
    thJedn: 'Одноразовий внесок',
    thKdy: 'За скільки років? (коли?)',
    thKolik: 'Сума (скільки?)',
    thPozn: 'Примітка',
    thPrav: 'Регулярний внесок',
    thPridatJedn: 'Додати одноразово',
    thPridatPrav: 'Додати щомісяця',
    titul: 'Таблиця — розподільник плану',
    tlacitko: 'Таблиця',
    uklada: 'Зберігаю…',
    ulozeniJak: 'Цифри зберігаються самі — трохи після того, як ти перестанеш писати, і під час виходу зі сторінки. «Збережено» світиться лише тоді, коли їх уже має сервер. Пропозиція рішення залишається поруч: той самий план, лише в картках.',
    ulozeniSelhalo: 'Зберегти не вдалося — зміна залишилася тільки на екрані.',
    ulozeno: 'Збережено',
    vkladNavic: 'додатково понад ресурси',
    vysvetlivka: '«Додати» = скільки ще потрібно, щоб ціль була виконана повністю, понад те, що план їй уже виділив. Це не платіж, це частина, якої бракує. Виконана ціль має тут слово, а не число.',
    vysvetlivkaRezim: '«Додати» показує лише той стовпець, що відповідає тому, як ціль вирішується: одноразовий внесок, або регулярний. Коли вирішується і так, і так, обидва числа є АЛЬТЕРНАТИВОЮ — або одноразово, АБО щомісяця. Не додавайте їх: кожне діє лише за умови, що другий внесок залишиться, як є.',
    zPritoku: '+ {kc} з майбутнього надходження',
    zadneZdroje: 'Нічого розподіляти — клієнт не має вільних фінансових активів',
    zbyva: 'Залишилось',
    zdrojeDoRentyJak: 'Пенсійне або DIP можна скасувати, але зазвичай воно йде на довгу ціль. «У ренту» відправить його на ренту — а якщо в клієнта ренти немає, на ціль із найдовшим горизонтом.',
    zdrojeDoRentyTitul: 'Житлові та пенсійні накопичення',
    zdrojeDoRentyVyp: 'на найближчу ціль',
    zdrojeDoRentyZap: 'у ренту',
    zpetNaNavrh: 'Назад до пропозиції рішення',
  },
  /* BLOK:shrnutiPlan END */
  /* POŘADÍ KROKŮ — JEDNO PRO CELOU APPKU (diktát majitele 24. 9. 2026).
     Kroky i jejich stavy drží lib/poradiKroku.js; tady jsou jen jejich názvy
     a věty. Čísla kroků se do textů NEPÍŠÍ — dopočítá je `poradiKroku(id)`,
     jinak by text po přeskládání lhal. Věty `chybi*` vidí JEN PORADCE na své
     obrazovce: je to jeho domácí úkol, ne text pro klienta. */
  /* BLOK:poradiKroku START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiKroku: {
    chybiMajetkove: 'Крок {cislo} — майнове страхування: заповніть і збережіть картку Страхування майна вище.',
    chybiRezerva: 'Крок {cislo} — резерв: заповніть в аналізі необхідні витрати. Без них цілі резерву не буде, а рядок брехав би нулем.',
    chybiTitulek: 'До таблиці не потрапили кроки, для яких бракує даних:',
    chybiZivotni: 'Крок {cislo} — життєве страхування: без доходів і витрат в аналізі немає з чого порахувати страхові суми.',
    cile: 'Цілі',
    cilePozn: 'регулярно інвестувати вільні кошти на цілі та на ренту',
    dluhy: 'Позбутися поганих боргів',
    dluhyPozn: 'дорогі кредити та кредитки закрити першими — відсотки ви сплачуєте напевно, дохід від інвестицій не гарантований',
    majetkove: 'Майнове страхування',
    majetkovePozn: 'нерухомість, домашнє майно, авто, відповідальність, а у підприємця й майно фірми',
    na90Dni: 'Кроки на наступні 90 днів',
    rezerva: 'Створити резерв',
    rezervaPozn: '3–6 місяців необхідних витрат під рукою, щоб план не зупинив перший неочікуваний ремонт',
    slideZaver: '„До вашої ренти та фінансової незалежності ведуть ці кроки — і саме в такому порядку.“',
    tabMajetekCo: 'Застрахувати майно та відповідальність ({kryti}) — орієнтовно {cena} на місяць.',
    tabMajetekKdy: 'Одразу',
    tabMajetekProc: 'Одна шкода на нерухомості або завдана іншому тягне весь план на дно.',
    tabRezervaCo: 'Поповнити ліквідний резерв до {cil} — сьогодні бракує {gap}.',
    tabRezervaCoFondy: 'Поповнити ліквідний резерв до {cil} — сьогодні бракує {gap}, з них {fondy} буде поповнено з фондів (продаж пайових фондів, ETF або акцій).',
    tabRezervaHotovo: 'Тримати резерв {cil} наповненим — готово.',
    tabRezervaKdy: 'Перед інвестуванням',
    tabRezervaProc: 'Подушка на неочікувані витрати. Без неї перша поломка вирішується боргом або продажем інвестиції.',
    ukolCile: 'Запустити регулярні інвестиції {castka} на цілі та ренту',
    ukolDluhy: 'Позбутися поганих боргів — сьогодні {castka}',
    ukolMajetkove: 'Оформити страхування майна та відповідальності — орієнтовно {cena}',
    ukolOsoba: '{jmeno}: інвалідність {invalidita}, смерть {smrt}',
    ukolOsobaBezInvalidity: '{jmeno}: смерть {smrt}',
    ukolRezerva: 'Поповнити резерв до {cil} (бракує {gap})',
    ukolRezervaFondy: 'Поповнити резерв до {cil} (бракує {gap} — {fondy} буде поповнено з фондів)',
    ukolRezervaHotovo: 'Резерв {cil} наповнений — тримати його',
    ukolZivotni: 'Оформити ризикове страхування — інвалідність {invalidita}, смерть {smrt}',
    ukolZivotniBezInvalidity: 'Оформити ризикове страхування — смерть {smrt}; покриття інвалідності без доходу не розраховуємо',
    ukolZivotniOsoby: 'Оформити ризикове страхування — {osoby}',
    ukolZivotniOsobyBezInvalidity: 'Оформити ризикове страхування — {osoby}; покриття інвалідності без доходу не розраховуємо',
    uvod: '…але для цього треба щось зробити. У такому порядку:',
    zivotni: 'Життєве страхування',
    zivotniPozn: 'добре й недорого застрахувати інвалідність та смерть — втрата доходу не має покласти родину',
  },
  /* BLOK:poradiKroku END */
  cilHorizont: {
    hned: "зараз",
    bezTerminu: "термін ще не визначено",
    zaOne: "через {n} рік",
    zaFew: "через {n} роки",
    zaMany: "через {n} років",
    rokOne: "рік",
    rokFew: "роки",
    rokMany: "років",
  },
  /* NAVRH — TABULKY „NASE DOPORUCENI" A „PRODUKTY" (audit R11).
   * Skladaji se ZIVE z aktualnich cisel planu; ukladaji se jen prepisy poradce.
   * Radky jednotlivych cilu tu nejsou schvalne — ty ma plan ve vlastni, taky
   * zive pocitane sekci (dopCil.*). Viz lib/navrhTabulky.js. */
  /* BLOK:navrhTabulky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhTabulky: {
    alokaceCo: 'Інвестувати за профілем: акції {akcie} %, облігації {dluhopisy} %, готівка {penize} %.',
    alokaceKdy: 'Одразу',
    alokaceProc: 'Алокація визначає близько 92 % результату; натхнення — Норвезький фонд і Нобелівський фонд.',
    alokaceZProfilu: 'Розподіл на старті за обраним профілем (Розвʼязання цілей вище). Ближче до цілі він сам поступово зміщується до безпеки.',
    davkyOdhadPodlePrijmu: 'Орієнтовна оцінка за доходом — те саме число, з якого виходять страхові суми.',
    diverzifikaceCo: 'Диверсифікувати за валютами та регіонами (світовий індекс — близько 72 % США).',
    diverzifikaceKdy: 'Одразу',
    diverzifikaceProc: 'Стабільніший портфель, захист від локального падіння.',
    dluhyCo: 'Позбутися дорогих боргів (сьогодні {castka}).',
    dluhyKdy: 'Якнайшвидше',
    dluhyProc: 'Відсотки ви сплачуєте напевно, дохід від інвестицій не гарантований.',
    pojisteniCo: 'Захистити дохід страхуванням — інвалідність {invalidita}, смерть {smrt} (спадні суми).',
    pojisteniCoBezInvalidity: 'Захистити страхуванням — смерть {smrt} (спадні суми). Покриття інвалідності без доходу не розраховуємо, додайте дохід.',
    pojisteniCoOsoby: 'Захистити дохід страхуванням — {osoby} (спадні суми).',
    pojisteniCoOsobyBezInvalidity: 'Захистити страхуванням — {osoby} (спадні суми). Покриття інвалідності без доходу не розраховуємо, додайте дохід.',
    pojisteniKdy: 'Одразу',
    pojisteniProc: 'Якщо дохід зникне, родина не повинна втратити рівень життя ані свої цілі.',
    produktAkcie: 'Акційний ETF (світ, MSCI World)',
    produktDluhopisy: 'Облігаційний ETF (світ)',
    produktPenize: 'Грошовий ринок / накопичувальний рахунок (резерв + готівка)',
    upravenoPoradcem: 'змінено радником',
    zivyNavrh: 'пропозиція системи — перераховується з поточних чисел плану',
    zpetNaNavrh: 'Назад до пропозиції системи',
  },
  /* BLOK:navrhTabulky END */
  /* RESENI U POJISTKY — navrh systemu + text poradce (lib/doporuceniPojisteni.js).
   * Sklada se ZIVE z cisel srovnani „pred a po“; uklada se jen prepis poradce
   * (navrh.solver.doporuceniPojisteni). Zadny produkt ani pojistovna — je to
   * regulovany vystup (IDD), navrh rika CO chybi, ne u koho to sjednat. */
  dopPoj: {
    titul: "Рішення щодо страхування",
    podtitul: "Пропозицію система складає з цифр порівняння, останнє слово має консультант.",
    domacnost: "Усе домогосподарство",
    titulVystup: "Що ми рекомендуємо щодо страхування",
    odSystemu: "пропозиція системи",
    odPoradce: "текст радника",
    upravit: "Редагувати текст",
    zpetNaNavrh: "Повернутися до пропозиції системи",
    placeholder: "Що радимо клієнтові щодо страхування…",
    hint: "Пропозицію системи складено з чисел цього порівняння. Останнє слово має радник — його текст друкується у плані та в презентації для клієнта.",
    prazdneVarovani: "Порожня рекомендація для клієнта не друкується. Поверніться до пропозиції системи або напишіть власний текст.",
    nicKRict: "Поки немає з чого скласти рекомендацію — додайте сьогоднішні страхові суми та ціну варіанта.",
    rizikoSmrt: "Смерть",
    rizikoInvalidita: "Інвалідність",
    bezSmlouvy: "Сьогодні клієнт не має жодного договору зі страховою сумою — захист доходу потрібно будувати з нуля.",
    nekrytyRiziko: "{riziko}: сьогодні без покриття, потрібно {novy}.",
    nekrytyRizikoBezCastky: "{riziko}: сьогодні без покриття.",
    nizkyLimit: "{riziko}: сьогоднішні {puvodni} нижче за потрібні {novy} — бракує {rozdil}.",
    pokrytoRiziko: "{riziko}: сьогоднішні {puvodni} потрібні {novy} покривають.",
    argument: "Покриття зростає ×{kryti}, ціна ×{cena}.",
    argumentVyhra: "Покриття зростає ×{kryti}, ціна лише ×{cena} — непорівнянно більше покриття за непорівнянно менші гроші.",
    brzdaLimit: "{riziko}: додайте в аналіз сьогоднішню страхову суму — без неї не скажеш, чого клієнтові бракує.",
    brzdaNovy: "{riziko}: у вибраному варіанті страхова сума ще не розрахована.",
    brzdaPlatba: "Додайте, скільки клієнт платить за наявні договори сьогодні — без цього ціну не порівняти.",
    brzdaPlatbaCastecna: "В одному з наявних договорів немає платежу — тому порівняння ціни лише часткове.",
    brzdaCena: "Додайте ціну вибраного варіанта — без неї не скажеш, скільки клієнт платитиме.",
  },
  /* REZERVA — na kolik mesicu (majitel 25. 9. 2026: „rezerva bud 3 - 6 - 12
   * mesicu, no to je jedno“). Jeden prepinac, tri volby: pocet mesicu plati na
   * CELY zaklad, tedy nezbytne vydaje i splatky. Prepinac stoji u cile rezervy,
   * ne v nastaveni; volby 18 / 24 / 36 se zrusily i s rozdelenym zakladem. */
  rezervaMesicu: {
    titul: "Резерв на",
    m3: "3 місяці",
    m6: "6 місяців",
    m12: "12 місяців",
    hint: "На скільки місяців вистачить резерву. Рахується з необхідних витрат і платежів за кредитами — у кризу триває і те, і те.",
  },
  /* ZTRATA Z PREDCASNEHO ZRUSENI PENZIJKA (planSolver, ztrata.kody).
   * ZADNE CISLO — engine nezna sazbu ani kolik uz klient dostal, takze veta
   * mluvi o tom, CO se vraci, nikdy o kolik. */
  ztrataPenzijka: {
    titul: "Скільки коштує взяти це раніше",
    statniPrispevek: "Дострокове розірвання означає повернути державні внески.",
    danovaVyhoda: "Дострокове розірвання означає доплатити податок із раніше отриманої пільги.",
    druhNeznamy: "В одному з договорів не вибрано вид продукту (DPS / DIP) — додайте його, щоб було ясно, що саме клієнт втрачає.",
  },
  /* BLOK:dopCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  dopCil: {
    brzdaBezCastky: 'У цілі не задана сума — заповніть її в аналізі.',
    brzdaBezHorizontu: 'У цілі немає горизонту — заповніть, за скільки років клієнт її хоче. Без цього ціль не можна розрахувати й додати до плану.',
    brzdaKapacita: 'Увага: {prav} щомісяця — це більше, ніж вільний надлишок домогосподарства ({kapacita} на місяць). Потрібен довший горизонт, менша ціль або місце в бюджеті.',
    brzdaNedosazitelne: 'З цим налаштуванням ціль не виходить навіть за максимального внеску — потрібен довший горизонт або менша сума.',
    hint: 'Пропозицію системи складено з чисел цього плану. Останнє слово має радник — його текст друкується у плані, у плані на одну сторінку та в презентації для клієнта.',
    jakGlide: 'Інвестиційно: перший рік {start}, останній рік {konec} (акції/облігації/готівка) — ризик під кінець вимикається.',
    jakJedn: 'Рішення: {jedn} одноразово, щомісяця нічого додатково.',
    jakNic: 'Рішення: грошей, які ви маєте сьогодні, вистачає на ціль без додаткових внесків.',
    jakNicNevychazi: 'Рішення: наразі немає з чого фінансувати цю ціль — план не виділив ані одноразового внеску, ані щомісячної суми.',
    jakOboji: 'Рішення: {jedn} одноразово і {prav} щомісяця.',
    jakPrav: 'Рішення: {prav} щомісяця.',
    jakRenta: 'Рентне портфоліо {alokace} (акції/облігації/готівка) тримається і під час виплат — рента йде з дохідності.',
    jakRezerva: 'Резерв не інвестується — його місце на ощадному рахунку, щоб був доступний з дня на день.',
    jakStabilni: 'Інвестиційно {start} (акції/облігації/готівка) протягом усього горизонту.',
    nicKRict: 'Поки немає з чого скласти рекомендацію — заповніть суму та горизонт цілі.',
    odPoradce: 'текст радника',
    odSystemu: 'пропозиція системи',
    placeholder: 'Що радимо клієнтові щодо цієї цілі…',
    prazdneVarovani: 'Порожня рекомендація клієнтові не друкується. Поверніться до пропозиції системи або напишіть власний текст.',
    titul: 'Рекомендація до цілі',
    titulVystup: 'Що ми рекомендуємо до кожної цілі',
    upravit: 'Редагувати текст',
    vysledekChybi: 'За {roky} років з цього виходить {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekChybiHned: 'За рік з цього виходить {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekOk: 'За {roky} років з цього виходить {konec} — ціль покрита на {pct} %.',
    vysledekOkHned: 'За рік з цього виходить {konec} — ціль покрита на {pct} %.',
    zadaniBezne: 'Ціль {cil} за {roky} років.',
    zadaniBezneBezLet: 'Ціль {cil}.',
    zadaniHypo: 'Власні кошти {cil} за {roky} років (варіант {varianta}). Платіж потім {splatka} на місяць.',
    zadaniHypoBezLet: 'Власні кошти {cil} (варіант {varianta}). Платіж потім {splatka} на місяць.',
    zadaniRenta: 'Рента {renta} на місяць означає капітал {cil} — з нього можна постійно знімати 4 % на рік. Горизонт {roky} років.',
    zadaniRentaBezLet: 'Рента {renta} на місяць означає капітал {cil} — з нього можна постійно знімати 4 % на рік.',
    zadaniRezerva: 'Ліквідний резерв {cil} — подушка на несподівані витрати. Він має перевагу перед інвестуванням.',
    zdroje: 'Одноразово з: {zdroje}.',
    zdrojeFondyRezerva: 'Бракуючі {fondy} буде поповнено з фондів — продаж пайових фондів, ETF або акцій, які клієнт уже має.',
    zpetNaNavrh: 'Повернутися до пропозиції системи',
  },
  /* BLOK:dopCil END */
  /* ── boLab — NÁHLED MOTIVU „beplan“ (design-lab/beplan-orange) ───────────
   * Texty interní náhledové stránky /design-lab/beplan-orange. NENÍ v produkční
   * navigaci a NEPŘEBARVUJE aplikaci — tokeny motivu jsou zavřené v `.bo-scope`
   * (frontend/src/design-lab/brand-orange/motiv.css).
   * Klíč po klíči shodné ve všech pěti jazycích (214 klíčů) — hlídá
   * design-lab/brand-orange/__tests__/klicePetJazyku.test.js.
   * ⚠️ Barva se jmenuje neutrálně „brand oranžová“. Pracovní název ze zadání se
   * nepoužívá: koliduje s historickým pojmem z války ve Vietnamu a aplikaci
   * používají vietnamští poradci i klienti.
   * ──────────────────────────────────────────────────────────────────────── */
  boLab: {
    boLab: {
      cil: {
        brzda: "Гальмо плану",
        brzdaText: "Цілі потребують",
        brzdaText2: "але вільний надлишок лише",
        brzdaText3: "Бракує",
        bydleniText: "ЧНБ: до 36 років достатньо 10 % власних коштів (LTV 90 %). Із ціни 4 500 000 Kč це 450 000 Kč.",
        chybi: "Бракує",
        cilova: "Цільова сума",
        cilu: "цілі",
        dnes: "Сьогодні",
        historie: "Історія змін",
        hned: "одразу",
        let: "років",
        mesicne: "Щомісяця",
        plneni: "Виконання",
        prebytek: "Вільний надлишок",
        prepocitat: "Перерахувати план",
        prijem: "Чистий дохід",
        rezervaText: "Резерв покриває неповні 2 місяці витрат замість рекомендованих 6. Доки його немає, збільшувати інвестиції не має сенсу.",
        rozdeleno: "Розподілено",
        srovnat: "Вирівняти пріоритети",
        stavNevime: "Не знаємо",
        stavNevychazi: "Не виходить",
        stavSplneno: "Виходить",
        stavTesne: "Впритул",
        titul: "План — цілі",
        upravit: "Змінити ціль",
        zaHorizont: "На горизонті",
        zbyva: "Залишається",
      },
      jedMes: "/міс",
      klient: {
        bezneVydaje: "Звичайні витрати",
        chybiPrijemPartnera: "Бракує доходу партнера",
        chybiUdaje: "Бракує 3 даних",
        cistyPrijem: "Чистий дохід",
        deti: "Діти",
        domacnost: "Домогосподарство",
        dopad: "Що це означає",
        dopadHorniOdhad: "верхня оцінка, державну допомогу ще ніхто не з’ясував.",
        dopadText: "За інвалідності 3 ступеня зникає весь дохід. Бракує покриття приблизно",
        dps: "Пенсійні заощадження",
        fazeRealizace: "Етап: Реалізація",
        hotovo: "Готово",
        invalidita: "Інвалідність 3 ступеня",
        investice: "Інвестиції",
        jmeno: "Ім’я",
        kOvereni: "До перевірки",
        klientOd: "клієнт від",
        let: "років",
        majetekZavazky: "Майно та зобов’язання",
        mezera: "Прогалина",
        narozeni: "Народження",
        nekryto: "не покрито",
        overeno: "перевірено",
        partner: "Партнер",
        pn: "Непрацездатність",
        pojisteni: "Страхування",
        prijemPartnera: "Дохід партнера",
        prijmyVydaje: "Доходи та витрати",
        rezerva: "Ліквідний резерв",
        roky: "роки",
        sdeleno: "повідомлено",
        sekce: "Розділи клієнта",
        servis: "Сервіс 14. 11. 2026",
        smrt: "Смерть",
        splatkyUveru: "Платежі за кредитами",
        spotrebitelsky: "Споживчий кредит",
        statniDavka: "Пенсія по інвалідності від держави",
        stavSmlouva: "За договором",
        telefon: "Телефон",
        telefonPartner: "Телефон партнера",
        tisk: "Друк",
        ulozit: "Зберегти",
        zalozkaAnalyza: "Аналіз",
        zalozkaDokumenty: "Документи",
        zalozkaHistorie: "Історія",
        zalozkaObchody: "Угоди",
        zalozkaPlan: "План",
      },
      lab: {
        coJeVidet: "Що видно на цьому екрані",
        dnes: "Сьогодні",
        dnesBezTmave: "Сьогоднішній вигляд темного варіанта НЕ МАЄ — застосунок жодного не має, тож ліворуч залишається світлий. Це не помилка перегляду.",
        dnesPopis: "Sage & Clay — що радник бачить зараз",
        jenDnes: "Лише сьогодні",
        jenNavrh: "Лише пропозиція",
        miraTitul: "Ширина вмісту проти ширини рамки. Коли вміст виходить за межі, сторінка отримує горизонтальну прокрутку.",
        motiv: "Тема",
        navrh: "Пропозиція",
        navrhPopis: "бренд-помаранчевий + navy — світла",
        navrhPopisTmava: "бренд-помаранчевий + navy — темна",
        notebook: "Ноутбук 1440",
        obrazovky: "Екрани",
        odznak: "Перегляд — застосунок не змінюється",
        preteka: "виходить за межі",
        sedi: "вміщується",
        sirka: "Ширина",
        svetla: "Світла",
        telefon: "Телефон 390",
        titul: "Design Lab · тема beplan",
        tmava: "Темна",
        vedleSebe: "Поруч",
        zobrazeni: "Показ",
        zpet: "Назад",
      },
      login: {
        claim: "Фінансовий план, який клієнт розуміє.",
        claimSub: "Аналіз, план і сервіс в одному місці — для радника й для клієнта.",
        email: "Ел. пошта",
        heslo: "Пароль",
        prihlasit: "Увійти",
        sso: "або через робочий обліковий запис",
        zalozkaPrihlaseni: "Вхід",
        zalozkaRegistrace: "Реєстрація",
        zapomenute: "Забутий пароль",
        zpusob: "Спосіб входу",
      },
      mesic: {
        cerven: "Ч",
        cervenec: "Л",
        kveten: "Т",
        rijen: "Ж",
        srpen: "С",
        zari: "В",
      },
      nastenka: {
        bj: "Бали (BJ)",
        bjZPlanu: "BJ з місячного плану",
        diar: "Щоденник — сьогодні",
        dnesUkoly: "сьогодні 5 завдань",
        kpi: "Ключові числа місяця",
        mezera: "Прогалина",
        mezeraText: "Гаєк — інвалідність 3 ступеня не покрита.",
        mezeraText2: "Дворжакова — резерв менше 2 місяців витрат.",
        nadKapacitu: "План перевищує можливості домогосподарства.",
        novyKlient: "Новий клієнт",
        obchodu: "9 угод",
        pipeline: "Воронка",
        plneniPlanu: "Виконання плану",
        poTerminu: "прострочено 11 днів",
        podtitul: "Вівторок 25 серпня · 3 зустрічі · 2 прострочені завдання",
        prebytek: "План у роботі — Гаєк",
        prilezitosti: "Радар можливостей",
        provize: "Комісія",
        radar: "Сервісний радар",
        rozdeleno: "Розподілено на цілі",
        rust: "+18 %",
        titul: "Доброго ранку, пане Чунг",
        typPlan: "План",
        typPrvni: "Перша зустріч",
        typServis: "Сервіс",
        ukoly: "Прострочено",
        vejdeSe: "Вміщується в надлишок.",
        volnyPrebytek: "Вільний надлишок",
        vyplaceno: "виплачено 15. 8.",
        vyvoj: "Динаміка угод",
        zPlanu: "68 % плану",
        za2mesice: "сервіс за 2 місяці",
        za3tydny: "сервіс за 3 тижні",
        zbyva: "До кінця місяця лишається 6 робочих днів.",
      },
      nav: {
        diar: "Щоденник",
        hlavni: "Головна навігація",
        klienti: "Клієнти",
        nastenka: "Панель",
        nastroje: "Інструменти",
        obchody: "Угоди",
        plan: "План",
        poradce: "Пан Чунг",
      },
      nevyplneno: "не заповнено",
      neznamo: "невідомо",
      obrazovka: {
        cil: "Картка цілі",
        klient: "Картка клієнта",
        nastenka: "Панель",
        prihlaseni: "Вхід",
        verejna: "Публічна сторінка",
        vystup: "Документ для клієнта",
      },
      pozn: {
        cil: "Найскладніший екран. Чотири цілі зразкового клієнта, гальмо потужності вгорі (план на 5 300 Kč на місяць перевищує можливості домогосподарства) і проблема, наслідок, крок під числами.",
        cilSazba: "Єдине місце перегляду, де відрізняється й верстка, а не лише кольори. Переключи ширину на Телефон 390 і порівняй лічильники над панелями.",
        klient: "Щільність форми. Межі полів, читабельність дрібних підписів і головне різниця між не заповнено та нуль: порожні поля пунктирні й бурштинові, а не нульові.",
        nastenka: "Скільки помаранчевого екран витримає. Правило: одна насичена помаранчева площина на екран (кнопка Новий клієнт). Стани — зелений, бурштиновий, червоний і синій як темний текст на світлому тоні, тож дія і стан різняться вже формою.",
        prihlaseni: "Перше враження. Логотип, помаранчева кнопка, підкреслена активна вкладка. Фото пляжу зі зразка замінене площиною navy зі стрілкою з логотипа — текст на фото лежить на невідомій світлості, тож контраст гарантувати не можна.",
        verejna: "Те, що клієнт бачить першим. Єдиний екран, де помаранчевий може бути великим — це площина бренду, а не елемент керування. Текст на ній navy, не білий.",
        vystup: "Найсуворіше місце теми. Папір лишається білим і в темному режимі, помаранчевий на ньому завжди темніший відтінок, і кожна смуга має поруч число та слово, щоб чорно-білий друк нічого не втратив.",
      },
      vystup: {
        castka: "Сума",
        chybi: "бракує",
        cil: "Ціль",
        disclaimer: "Рекомендації спираються на дані, надані клієнтом станом на дату опрацювання. Це не інвестиційна рекомендація й не обіцянка дохідності. Наведені моделі є орієнтовними.",
        eyebrow: "Фінансовий план",
        kdeJsteDnes: "Де ви сьогодні",
        mesice: "місяця",
        mesicneCelkem: "Щомісяця разом",
        pokryto: "покрито",
        poslat: "Надіслати клієнту",
        prebytek: "Вільний надлишок",
        prijem: "Чистий дохід",
        prvniKrok: "Перший крок",
        prvniKrokText: "Довести ліквідний резерв до 168 000 Kč. До того часу резерв має перевагу над інвестуванням — без нього будь-яка несподівана витрата зруйнує решту плану.",
        rezervaMa: "Резерву вистачить на",
        splneniCilu: "Виконання ваших цілей",
        tisk: "Друк / зберегти PDF",
        vaseCile: "Ваші цілі",
        vytvoreno: "Опрацював пан Чунг · 25 серпня 2026",
      },
      web: {
        claim: "Нехай ваші гроші мають план, а не випадковість.",
        claimSub: "Перша зустріч безкоштовна й ні до чого не зобов’язує. Триває близько 30 хвилин, онлайн через Google Meet.",
        oMne: "Про мене",
        online: "Онлайн, 30 хвилин",
        otazky: "Питання",
        reference: "Відгуки",
        referenceSablona: "Місце для відгуків, які радник заповнює сам. Перегляд навмисно їх не заповнює — вигаданий відгук із іменем це юридичний ризик.",
        rezervace: "Бронювання",
        rezervovat: "Домовитися про зустріч",
        role: "Твій фінансовий радник",
        sCimPomuzu: "З чим я можу допомогти",
        sluzba1: "Резерв і бюджет",
        sluzba1Sub: "Щоб несподівана витрата вас не поклала.",
        sluzba2: "Власне житло",
        sluzba2Sub: "Скільки потрібно й коли це вийде.",
        sluzba3: "Рента й незалежність",
        sluzba3Sub: "Скільки відкладати, щоб колись вистачило.",
        sluzby: "Послуги",
        volneTerminy: "Вільні терміни цього тижня",
        vyberTermin: "Обери час зустрічі",
        vybratTermin: "Обрати час",
        zdarma: "Безкоштовно",
      },
    },
  },
  rezSmlouva: {
    nazev: 'Договір бронювання',
    podnadpis: 'Заповни заголовок, ціну та завдаток. Решту система додасть сама і перевірить договір ще до друку.',
    zpetNaZakazku: 'Назад до об\'єкта',
    jizRozepsane: 'На цій нерухомості вже є розпочатий договір:',
    bezKupujiciho: 'без покупця',
    vzorLabel: 'Шаблон договору',
    pracovniVzor: 'Робочий шаблон — текст ще не затвердив юрист. Поки не використовуй його з клієнтом.',
    skupina_penize: 'Гроші та строк',
    skupina_hlavicka: 'Заголовок',
    skupina_strany: 'Сторони договору',
    skupina_nemovitost: 'Нерухомість',
    skupina_kancelar: 'Агенція нерухомості',
    skupina_ostatni: 'Інші дані',
    doplneno: 'додано',
    vyber: '— обери —',
    ano: 'Так',
    ne: 'Ні',
    neniVyplneno: 'не заповнено',
    odvozeneNadpis: 'Обчислює система',
    slovyPopis: 'Суму словами, залишок і кінець бронювання пише система. Тому вони не можуть розійтися з цифрою.',
    odvozene_kupni_cena_slovy: 'Ціна купівлі словами',
    odvozene_blokacni_poplatek_slovy: 'Завдаток словами',
    odvozene_doplatek: 'Залишок ціни',
    odvozene_doplatek_slovy: 'Залишок словами',
    odvozene_rezervace_do: 'Бронювання дійсне до',
    kontrolaNadpis: 'Перевірка перед друком',
    kontrolaCisto: 'Зауважень немає. Можна друкувати.',
    kontrolaBlokuje: 'Поки це не виправиш, друк закритий.',
    pocitam: 'Рахую…',
    nahledNadpis: 'Попередній перегляд договору',
    ulozit: 'Зберегти',
    ulozeno: 'Збережено',
    vytisknout: 'Друк',
    podepsano: 'Позначити як підписаний',
    jePodepsana: 'Підписано',
    podepsanaZamek: 'підписаний договір уже не можна змінювати',
    advokat: 'Лист юристові',
    advokatHotovo: 'Повідомлення лише підготовлене. Надішли його зі своєї пошти разом із додатком.',
    zkopirovat: 'Копіювати',
    zkopirovano: 'Скопійовано',
    nejdrivUloz: 'Спершу збережи договір.',
    tiskZablokovan: 'Браузер заблокував вікно друку. Дозволь спливаючі вікна і спробуй ще раз.',
    chybaNacteni: 'Не вдалося завантажити. Спробуй ще раз.',
    chybaUlozeni: 'Не збережено.',
    chybaKopie: 'Не вдалося скопіювати.',
  },
  /* BLOK:izp START — generuje scratchpad/slovnik.py, ručně needitovat */
  izp: {
    argumenty: {
      jak1: 'Ви платите один місячний платіж. Частина його йде на покриття ризиків, решта — в інвестиційну частину.',
      jak2: 'Обсяг покриття можна змінювати з часом — додати ризик, підвищити або знизити страхову суму.',
      jak3: 'З інвестиційної частини зазвичай можна зняти гроші або зменшити її. Строки та умови в різних договорах різні.',
      jak4: 'Договір можна припинити. Що саме виплачують у такому разі, визначають його умови.',
      jak5: 'Якщо дохід зміниться, можна змінити й те, скільки йде на захист, а скільки на інвестицію.',
      jakNadpis: 'Як це працює загалом',
      nadpis: 'Навіщо це мати і як це загалом працює',
      nasobekCeny: 'ціна ×{x}',
      nasobekKryti: 'покриття ×{x}',
      oci: 'Аргументи',
      pomerChybi: 'Впишіть у ризиках те, що клієнт має сьогодні — покриття і ціну. Без цього співвідношення покриття та ціни порахувати не можна.',
      pomerNadpis: 'Покриття проти ціни',
      pomerNejslabsi: 'Береться найслабший із порівняних ризиків (кількість: {pocet}).',
      pomerVyhra: 'Покриття зростає швидше, ніж ціна.',
      pomerZdroj: 'Розраховано з ризиків, де вписане і сьогоднішнє, і нове покриття (кількість: {pocet}). Береться найслабший ризик, а не найкращий.',
      popis: 'Загальний принцип, а не умови конкретного договору.',
      potvrdiKratce: 'Загальний принцип, а не умови конкретного договору. Що дозволить договір, підтвердить консультант за пропозицією.',
      potvrdiText: 'Це загальний принцип, а не умови конкретного договору. Що саме договір дозволить — зміни, зняття грошей, припинення та їхні умови — підтвердить консультант за конкретною пропозицією.',
      potvrdiTuk: 'Що підтвердить консультант',
      proc1: 'Дохід — це двигун сім’ї. Коли він зникає, витрати залишаються, а деякі ще й зростають.',
      proc2: 'Держава дає лише частину, і не одразу. Решту сім’я вирішує сама.',
      proc3: 'Зобов’язання не оплатиш рішучістю, лише грошима. Іпотека йде далі, навіть коли дохід зупинився.',
      proc4: 'Захист і накопичення ви вирішуєте одним платежем, який розподіляєте самі.',
      procNadpis: 'Навіщо це мати',
    },
    davka: {
      pozustalostni: 'Пенсії для близьких — вдові та дітям-сиротам',
    },
    diagnoza: {
      detskeChronicke: 'Хронічні захворювання, що виникли в дитинстві, наприклад цукровий діабет першого типу або епілепсія',
      detskeNadory: 'Дитячі онкологічні захворювання, наприклад лейкемія',
      infarkt: 'Інфаркт міокарда',
      mozkovaPrihoda: 'Інсульт (порушення мозкового кровообігу)',
      nadory: 'Онкологічні захворювання',
      neurologicka: 'Неврологічні захворювання — розсіяний склероз, хвороба Паркінсона та хвороба Альцгеймера',
      ochrnuti: 'Параліч після травми або хвороби',
      operaceSrdce: 'Операції на серці та великих артеріях',
      selhaniOrganu: 'Відмова органів — нирок, печінки, дихальної системи',
      smysly: 'Втрата зору, слуху або мовлення',
      transplantace: 'Трансплантація життєво важливого органа',
      zenska: 'Захворювання, які стосуються лише жінок, і ускладнення вагітності',
    },
    diagnozy: {
      deti: 'У дитячому договорі список інший — у ньому діагнози, які трапляються в дитинстві.',
      nadpis: 'Які хвороби покриває страхування',
      smlouva: 'Точний перелік діагнозів, їхні визначення, стадії та періоди очікування визначає страховий договір, і в кожній страховій компанії він різний. Що застраховано саме у вас, пройдемо у страхових умовах.',
      uvod: 'Це групи діагнозів, про які при критичних захворюваннях говорять найчастіше.',
    },
    graf: {
      aria: 'Графік: усього сплатите {zaplaceno}, з них в інвестиції {investice}. Вартість інвестицій у моделі через {roky}: {hodnota}. Модель, не гарантія.',
      celkemVlozeno: 'Усього внесено',
      dnesnimiOcima: 'Сьогоднішніми грошима {hodnota} (інфляція {inflace})',
      hodnotaVModelu: 'Вартість інвестицій у моделі',
      horizonty: {
        d: {
          hodnota: 'Вартість у моделі',
          nasobek: 'Кратність внесків',
          vlozeno: 'Внесено',
          vlozenoPoplatek: 'з них комісія {poplatek}',
          vynos: 'З них дохід',
        },
        detailNadpis: 'Через {roky}',
        maStitek: 'має',
        nadpis: 'Що довше, то більше',
        oci: 'Час',
        poPoplatkuStitek: 'вкладено після комісії',
        predpoklad: 'За модельної дохідності {vynos} на рік',
        sloupec: '{roky}: модельна вартість {hodnota}, внесено {vlozeno}',
        vlozenoStitek: 'внесено',
        vrstvy: {
          nadpis: 'Сила складних відсотків',
          vklady: 'Внески',
          vkladyPoPoplatku: 'Внески після комісії',
          zVkladu: 'Дохід із внесків',
          zVynosu: 'Дохід із доходу',
        },
        vyber: 'Виберіть, через скільки років',
      },
      konec: {
        hodnota: 'Модель',
        investice: 'Інвестиції',
        zaplaceno: 'Сплачено',
      },
      krivka: {
        hodnota: 'Вартість у моделі',
        investice: 'В інвестиції',
        ochrana: 'Захист (не повертається)',
        zaplaceno: 'Сплачено разом',
      },
      legendaHodnota: 'Модельна вартість',
      legendaVlozeno: 'Внесено',
      milnik: {
        kratce: {
          plnoletost: '18',
          vysoka: 'ВНЗ',
        },
        plnoletost: '{jmeno}: 18 років',
        vysoka: '{jmeno}: університет',
      },
      modelText: 'Графік — це модельний розрахунок із заданої суми та обраної дохідності. Майбутня дохідність не гарантована, реальний розвиток може бути нижчим або вищим. Конкретне рішення підтвердить консультант.',
      modelTuk: 'Модельний сценарій, не гарантія',
      modelovaHodnota: 'Модельна вартість',
      modeloveZhodnoceni: 'Модельний приріст',
      nadpis: 'Що буде з інвестиційною частиною до обраного віку',
      oci: 'Графік',
      osaRok: 'Рік {rok}',
      osaVekKonec: '{vek} р.',
      popis: 'Виберіть вік і очікувану дохідність. Графік показує модельний перебіг, а не гарантований результат.',
      poplatek: {
        naKonci: 'Наприкінці',
        naKorunu: 'На 1 {symbol} сплачених грошей',
        nadpis: 'Три способи сплатити збір',
        navic: 'з них {poplatek} — збір одразу понад внески',
        oci: 'Вступний збір',
        pole: 'Вступний збір (% від цільової суми)',
        poleHint: 'зазвичай {min}–{max} %',
        poslano: 'Усього сплачено',
        radek: {
          expres: 'Комісія {poplatek} · з платежів ({mesicu} міс.)',
          expresHned: 'Комісія {poplatek} · доплатите одразу',
          pulNaPul: 'Комісія {poplatek} · наполовину з платежів ({mesicu} міс.)',
        },
        souhrn: '{pct} від цільової суми {cilova} — це {poplatek}',
        varianta: {
          expres: {
            nazev: 'Експрес із внесків',
            popis: 'Весь внесок іде на збір, доки його не сплачено ({mesicu} міс.).',
          },
          expresHned: {
            nazev: 'Сплатити одразу',
            popis: 'Збір окремо, весь внесок інвестується з першого місяця.',
          },
          pulNaPul: {
            nazev: '50/50 із внесків',
            popis: 'Половина внеску на збір, половина одразу інвестується ({mesicu} міс.).',
          },
        },
        zToho: 'з них {poplatek} на збір',
      },
      poradcePozn: 'Перемикайте вік і дохідність перед клієнтом — нехай бачить, як змінюється число.',
      priVynosu: 'При дохідності {vynos}',
      rizika: {
        deti: 'Діти',
        doplnte: 'доповніть у Ризиках',
        doporucene: 'Рекомендоване покриття, розраховане з даних родини. Вибір ризиків і точні суми порадник уточнить у розділі Ризики.',
        klient: 'Клієнт',
        nadpis: 'За захист {cena} на місяць родина отримає, якщо щось станеться',
        nadpisBezCeny: 'Що родина отримає, якщо щось станеться',
        podminky: 'Виплата за умовами страхування. Суми не додаються.',
        zadna: 'Ризики ще не вибрані — доповніть у Ризиках.',
      },
      tooltip: {
        dnes: 'Сьогодні · вік {vek}',
        vek: 'Вік {vek} · через {roky}',
        vynos: 'Дохід у моделі {castka}',
      },
      vek60: '60 років',
      vek65: '65 років',
      vek70: '70 років',
      vekLabel: 'До якого віку',
      vekVlastni: 'до {vek} років',
      vekVlastniLabel: 'Або введіть вік',
      vynos4: '4 % на рік',
      vynos7: '7 % на рік',
      vynos9: '9 % на рік',
      vynosLabel: 'Очікувана дохідність',
      vynosProti: 'порівняно з {investice} в інвестиції · {vynos} на рік',
      vynosVModelu: 'Дохід у моделі',
      zaplaceno: {
        investice: 'З них в інвестиції',
        investicePopis: '{mesicne} щомісяця',
        ochrana: 'З них захист',
        ochranaPopis: 'ціна покриття, не повертається',
        popis: '{mesicne} щомісяця × 12 × {roky}',
        popisPoplatek: '{mesicne} щомісяця × 12 × {roky} + комісія {poplatek}',
        stitek: 'Усього сплатите',
      },
    },
    hadani: {
      odkryt: 'Показати реальність',
      pole: 'Ваша здогадка (на місяць)',
      rozdil: 'Різниця проти вашої здогадки',
      skutecnost: 'Держава дає щомісяця',
      vyzva: 'Як ви думаєте, скільки вам дасть держава? Спробуйте вгадати, перш ніж ми покажемо.',
    },
    hranice: {
      davkyOdhad: 'Державні виплати — це лише орієнтовна оцінка. Точну суму визначає державна установа в ЧР.',
      modelace: 'Це модельний сценарій, а не страховий договір і не особиста рекомендація.',
      odhadKlienta: 'Ваша догадка — лише для порівняння. У розрахунок і в друк вона не входить.',
      potvrdiPoradce: 'Конкретне рішення, ліміти та страховий платіж підтвердить консультант у страховій компанії.',
      sablona: 'Позначені суми — це орієнтовний приклад із практики консультанта, а не пропозиція і не гарантія.',
      vynosNeniGarantovan: 'Майбутня дохідність не гарантована. Реальний розвиток може бути іншим, навіть суттєво.',
    },
    jednotka: {
      denni: 'денна виплата',
      jednorazova: 'одноразова сума',
      renta: 'місячна рента',
      zaDen: 'на день',
      zaMesic: 'за місяць',
    },
    karta: {
      cenaHint: 'Перепишіть із розрахунку страхової компанії. Якщо його ще не маєте, залиште порожнім.',
      cenaNezadana: 'Ціну не введено — цей ризик не входить до суми.',
      cenaPole: 'Ціна за місяць',
      dnesCenaPole: 'Платить сьогодні',
      dnesHint: 'Перепишіть з його поточного договору. Без цього співвідношення не порахується.',
      dnesKrytiPole: 'Покриття сьогодні',
      dnesNadpis: 'Що має сьогодні',
      formaNezadana: 'Форму доходу не вказано — лікарняні пораховано як для найманого працівника.',
      jakSePocita: 'Як це рахується',
      jenZeny: 'тільки жінки',
      krytiPole: 'Страхова сума',
      nezadano: 'не введено',
      osvcBezNemocenske: 'Як самозайнятий (OSVČ) без добровільного страхування на випадок хвороби ви не отримуєте лікарняних.',
      otazka: 'Питання до клієнта',
      oznacProbrano: 'Позначити як обговорене',
      poOsobach: 'За особами',
      pomerCena: 'ціна',
      pomerKryti: 'страхова сума',
      pomerNadpis: 'Співвідношення до нинішнього стану',
      potreba: 'Скільки потрібно',
      preskoceno: 'Пропущено',
      preskocit: 'Пропустити',
      proDeti: 'також для дітей',
      probrano: 'Обговорено',
      radekPotreba: 'потреба',
      sbalit: 'Згорнути',
      statDa: 'Що дасть держава',
      tvar: 'Форма виплати',
      vCene: 'входить у ціну',
      varianty: 'Варіанти страхової суми',
      vratit: 'Повернути',
      vyradit: 'Виключити',
      zapsat: 'Записати числа',
      zaradit: 'Включити',
    },
    neznamo: 'Не вказано',
    poznamka: {
      cenaOdPoradce: 'Ціну та конкретне рішення підтвердить консультант за пропозицією страхової компанії.',
      hodnotaDnesnimaOcima: 'У сьогоднішніх грошах, при інфляції {inflace} % на рік, це',
      investiceVynesla: 'Інвестиційна частина за моделлю принесла',
      modelovyScenar: 'Модельний сценарій, а не страховий договір і не персональна рекомендація.',
      nezbytneJsouCeleVydaje: 'Потреба в покритті рахується з усіх витрат домогосподарства. Необхідні витрати зазвичай нижчі — точне число порахує повний калькулятор страхування життя.',
      odhadKlientaNeniUdaj: 'Ваш здогад лише для порівняння — у розрахунок і на папір він не входить.',
      vlozenoDoOchrany: 'За {roky} років ви вклали в захист',
      vynosNeniGarantovan: 'Майбутня дохідність не гарантована. Вартість інвестиції може як падати, так і зростати.',
    },
    prehled: {
      balicekVysvetleni: 'Пакет — це відсоток від доходу, а не від залишку. Тому видно, чи він вміщається у вільні гроші. Це модельний сценарій, конкретне рішення підтвердить консультант.',
      balicky: 'Скільки можна відкладати',
      balickyPodnadpis: 'Натисніть на пакет. Частина йде на захист, решта інвестується — розподіл налаштуєте одразу під цим.',
      chybi: 'Не вистачає',
      doporuceno: 'Найбільше, що вміщається',
      nadVolnymi: 'Це не заборона — клієнт може вибрати більше. Це лише означає, що разом треба знайти, звідки взяти ці гроші.',
      nadpis: 'Скільки проходить через руки',
      podnadpis: 'Два числа, які клієнт про себе знає. І одне, якого зазвичай не знає.',
      prijem: 'Чистий дохід родини',
      prijemNotePar: 'Чоловік і дружина разом.',
      vejdeSe: 'Вміщається у вільні гроші.',
      vlastni: 'Власна сума',
      vlastniHint: 'Запишіть число, яке сказав клієнт.',
      vlastniLabel: 'Скільки хоче відкладати',
      vlastniPopis: 'скільки скаже клієнт',
      vlastniPrazdna: 'Напишіть суму, яку сказав клієнт — інакше немає з чого рахувати.',
      volne: 'Залишається вільних',
      volneKratce: 'Дохід мінус витрати.',
      volneNote: 'Дохід мінус витрати. Із цього можна відкладати.',
      volneZaporne: 'Родина витрачає більше, ніж заробляє. Перш ніж говорити про страхування, треба знайти, куди тікають гроші.',
      vybrano: 'Вибрано',
      vydaje: 'Витрати родини',
      vydajeNote: 'Разом із платежами за кредити.',
      zPrijmu: 'від доходу',
      zTohoRodine: 'з них батькам / родині {castka}',
    },
    prezentace: {
      dal: 'Далі: {nazev}',
      krok: {
        cas: {
          nadpis: 'Як сплатити комісію і що робить час',
          otazka: 'Що буде, якщо дати грошам працювати довше?',
          say: 'Оберіть стовпчик. Побачите, скільки ви вклали і що з цього зробив час.',
          stitek: 'Комісія і час',
          tip: 'Нехай клієнт клацне сам. Це модель, а не обіцянка.',
        },
        cisla: {
          nadpis: 'Ваші числа',
          otazka: 'Скільки у вас удома щомісяця надходить і скільки з цього знову йде?',
          say: 'Достатньо приблизно, точно уточнимо разом.',
          stitek: 'Числа',
          tip: 'Вільних грошей клієнт здебільшого не знає — нехай прочитає їх сам.',
        },
        investice: {
          nadpis: 'Решта пакета працює',
          otazka: 'Скільки років ці гроші могли б працювати?',
          say: 'Графік — це модель, а не обіцянка. Він показує, що робить час.',
          stitek: 'Інвестиція',
          tip: 'Вік нехай обере клієнт сам.',
        },
        konecne: {
          brana: 'Спочатку запишіть рішення клієнта: Так, хочу, Змінити або Поки ні.',
          nadpis: 'Остаточне рішення',
          otazka: 'Тепер ви знаєте ціну й умови. Хочете цей захист?',
          say: 'Так, зміни й поки ні — усе це нормально.',
          stitek: 'Підтвердження',
          tip: 'Якщо «Змінити» — запитайте, що саме.',
          volba: {
            ano: 'Так, хочу',
            upravit: 'Змінити',
            zatimNe: 'Поки ні',
          },
        },
        potvrzeni: {
          celkem: 'Захист разом',
          cena: 'Ціна',
          cenaUTemat: 'Ціна поки що є для {n} з {celkem} тем.',
          kryti: 'Покриття',
          nadpis: 'Ваш захист',
          otazka: 'Чи підходить вам такий захист, чи хочете щось змінити?',
          riziko: 'Ризик',
          rucne: 'У розподілі пакета захист змінено вручну на {castka}.',
          say: 'Покриття і ціну ще підтвердить пропозиція страховика.',
          stitek: 'Захист',
          tip: 'Якщо це дорого, зменште страхові суми і скажіть уголос, якого покриття клієнт позбудеться.',
        },
        predstaveni: {
          say: 'Представлюся й розповім, як працюю.',
          tip: 'Реєстр клієнт може перевірити одразу в телефоні.',
        },
        rizika: {
          dalsi: 'Наступний ризик',
          nadpis: 'Що могло б статися',
          otazkaSmrtBezUveru: 'Якщо одного дня ви не повернетеся додому, на що житиме родина?',
          otazkaZavazkyBezCastky: 'Чи маєте кредит, який за вас довелося б сплачувати комусь іншому?',
          poradi: 'Ризик {n} / {celkem}',
          predchozi: 'Попередній ризик',
          say: 'Спробуйте вгадати, а потім подивимося, як є насправді.',
          smysl: 'Чи має це для вас сенс?',
          stitek: 'Ризики',
          tip: 'Після відкриття запитайте, чи це має сенс.',
          vsePreskoceno: 'Немає ризику для обговорення — усі пропущено.',
        },
        smlouva: {
          nadpis: 'Як працює договір',
          otazka: 'Що вас цікавить у договорі, перш ніж вирішите?',
          say: 'Кажу це заздалегідь, щоб потім нічого вас не здивувало.',
          stitek: 'Договір',
          tip: 'Читайте анкету здоров’я з клієнтом питання за питанням.',
        },
        souhlas: {
          brana: 'Спочатку запишіть відповідь клієнта: Так, Пізніше або Ні.',
          nadpis: 'Рішення за вами',
          otazka: 'Бажаєте застрахувати дохід родини?',
          say: 'Так, пізніше і ні — усе це нормально.',
          stitek: 'Рішення',
          tip: 'Після запитання помовчіть і дайте клієнту відповісти.',
        },
        svoleni: {
          nadpis: 'Що сьогодні розглянемо',
          otazka: 'Можна поставити кілька запитань, щоб я показав, як справи у вашої родини?',
          say: 'Це займе кілька хвилин, а рішення завжди за вами.',
          stitek: 'Вступ',
          tip: 'Дочекайтеся відповіді, не поспішайте.',
        },
        zaver: {
          balicek: 'Скільки щомісяця',
          dalsiKrok: 'Наступний крок',
          dalsiKrokText: {
            ano: 'Підготуємо пропозицію на міру і разом її переглянемо. Покриття і ціну підтвердить страховик.',
            ne: 'Рішення за вами. Повернутися до цього можна будь-коли.',
            nezadano: 'Наступний крок домовимо разом.',
            pozdeji: 'Домовимося, коли до цього повернемося.',
            upravit: 'Змінимо пропозицію під вас і ще раз разом її переглянемо. Покриття і ціну підтвердить страховик.',
            zatimNe: 'Рішення за вами. Повернутися до цього можна будь-коли.',
          },
          nadpis: 'На завершення',
          otazka: 'Який наступний крок має для вас сенс?',
          poznamka: 'Примітка',
          rozhodnuti: 'Ваша відповідь',
          say: 'Ось два числа. Висновок за вами.',
          sayBez: 'Дякую за ваш час. Рішення за вами, і воно чинне.',
          stitek: 'Підсумок',
          termin: 'Дата й час',
          terminKlient: 'Домовлена дата: {kdy}',
          tip: 'Не поєднуйте числа в одне речення.',
          tipBez: 'Не переконуйте — лише домовтеся, коли зв’яжетеся.',
        },
      },
      predstaveni: {
        jakText: 'Я покажу, як справи у вашої родини. Чи і як страхуватися, вирішуєте ви.',
        odmenaText: 'Як мене винагороджують за роботу, я скажу, а до підписання ви отримаєте це письмово.',
      },
      uvod: {
        nadpis: 'Як справи у вашої родини',
        rodina: 'Ваша родина',
        slib: 'Покажемо, ви запитаєте і вирішите самі.',
      },
    },
    rizika: {
      nadpis: 'Ризики',
    },
    riziko: {
      bezmocnost: {
        coJe: 'Стан, коли ви не можете обслужити себе сам — не поїсте, не помиєтеся, не дійдете до туалету. Хтось має бути з вами щодня.',
        nazev: 'Повна залежність від догляду',
        pozn: 'У розрахунках це називають найвищим ступенем. Що саме запускає виплату, визначає страховий договір.',
      },
      denniOdskodne: {
        coJe: 'Виплата за кожен день лікування після травми. Покриває той період, коли виплата за тимчасову непрацездатність ще не йде.',
        nazev: 'Денна компенсація за час лікування травми',
      },
      detiHospitalizace: {
        coJe: 'Виплата за кожну ніч, яку дитина лежить у лікарні. Один з батьків біля неї і не працює.',
        nazev: 'Перебування дитини в лікарні',
      },
      detiOdskodne: {
        coJe: 'Виплата за кожен день лікування дитини після травми — та сама втрата доходу батьків, тільки вдома.',
        nazev: 'Денна компенсація дитині за час лікування',
      },
      detiPeceRodice: {
        coJe: 'Після травми або хвороби дитина залишається постійно залежною від догляду. Найбільша дірка — це не лікування, а те, що один з батьків через догляд назавжди йде з роботи.',
        nazev: 'Серйозна подія з дитиною — втрата доходу батьків',
        pozn: 'Сума залежить від договору кожної дитини. Частину потреби на дитину не візьме жодна страхова — вона належить до резерву та до інвестицій.',
      },
      detiTrvale: {
        coJe: 'Одноразова сума на реабілітацію, засоби та переобладнання житла, якщо в дитини після травми залишиться постійне обмеження.',
        nazev: 'Постійні наслідки травми в дитини',
      },
      detiZavazne: {
        coJe: 'Одноразова виплата при діагнозі зі списку в дитини — на лікування і на те, щоб один з батьків міг залишитися вдома.',
        nazev: 'Критичні захворювання дитини',
        pozn: 'Скільки страхова візьме на дитину, обмежено. Решта потреби належить до резерву та до інвестицій.',
      },
      hospitalizace: {
        coJe: 'Виплата за кожну ніч у лікарні. Це на короткий час — у дорослого це зазвичай покриє резерв.',
        nazev: 'Перебування в лікарні',
      },
      invalidita1Klesajici: {
        coJe: 'Часткове обмеження працездатності зі страховою сумою, яка з часом зменшується.',
        nazev: 'Інвалідність 1 ступеня — сума, що зменшується',
      },
      invalidita1Konstantni: {
        coJe: 'Часткове обмеження працездатності. Дохід впаде, витрати залишаться.',
        nazev: 'Інвалідність 1 ступеня — постійна сума',
      },
      invalidita2Klesajici: {
        coJe: 'Серйозне обмеження працездатності зі страховою сумою, яка з часом зменшується.',
        nazev: 'Інвалідність 2 ступеня — сума, що зменшується',
      },
      invalidita2Konstantni: {
        coJe: 'Серйозне обмеження працездатності: щось зможете, але свою професію на повну ставку вже ні.',
        nazev: 'Інвалідність 2 ступеня — постійна сума',
      },
      invalidita3Klesajici: {
        coJe: 'Повна інвалідність, але страхова сума рік за роком зменшується.',
        nazev: 'Інвалідність 3 ступеня — сума, що зменшується',
        pozn: 'Дешевший варіант. Має сенс лише тоді, коли ви справді інвестуєте і майно поступово заповнить дірку — інакше покриття зменшується, а потреба ні.',
      },
      invalidita3Konstantni: {
        coJe: 'Повна інвалідність: працювати ви не можете взагалі. Страхова сума залишається весь час однаковою.',
        nazev: 'Інвалідність 3 ступеня — постійна сума',
      },
      pece12: {
        coJe: 'Денна виплата на той час, коли більшість справ ви робите сам, але в деяких потрібна допомога.',
        nazev: 'Довготривалий догляд — нижчі ступені залежності',
      },
      pece34: {
        coJe: 'Місячна рента на весь час, коли вам потрібен щоденний догляд іншої людини.',
        nazev: 'Довготривалий догляд — вищі ступені залежності',
        pozn: 'Потрібний розмір ренти цей застосунок не рахує — суму додасть консультант зі свого розрахунку.',
      },
      pnOd29: {
        coJe: 'Денна виплата, яка починається після чотирьох тижнів непрацездатності. Перший місяць покриє резерв.',
        nazev: 'Тимчасова непрацездатність з 29 дня',
      },
      pnOd61: {
        coJe: 'Денна виплата лише після двох місяців. Найдешевший варіант — має сенс, коли резерв витримає два місяці.',
        nazev: 'Тимчасова непрацездатність з 61 дня',
      },
      pnPlus: {
        coJe: 'Денна виплата з м’якшими умовами — виплачується і в тих ситуаціях, які базовий варіант виключає.',
        nazev: 'Тимчасова непрацездатність із розширеною виплатою',
        pozn: 'Що саме входить і що виключено, написано в умовах страхування. Пройдіть їх разом із консультантом.',
      },
      smrtInvaliditaKombinace: {
        coJe: 'Одна страхова сума, яка виплачується за тим, що настане раніше — смерть або інвалідність.',
        nazev: 'Смерть або інвалідність в одній сумі',
        pozn: 'Комбінація виплачується один раз. Хто хоче покрити обидві ситуації повністю, потребує двох сум, а не однієї.',
      },
      smrtKlesajici: {
        coJe: 'Страхова сума рік за роком зменшується, бо зменшується і залишок іпотеки, а ваше майно зростає.',
        nazev: 'Смерть — сума, що зменшується',
        pozn: 'Дешевший варіант. Пасує до боргу, який ви виплачуєте — не до рівня життя родини, він не знижується.',
      },
      smrtKonstantni: {
        coJe: 'Страхова сума залишається однаковою весь час. Родина отримає те саме і в перший, і в останній рік.',
        nazev: 'Смерть — постійна сума',
      },
      smrtKratsiDoba: {
        coJe: 'Покриття на коротший час, ніж триває весь договір. Зазвичай до виплати кредиту або поки діти не стануть дорослими.',
        nazev: 'Смерть — покриття лише на кілька років',
        pozn: 'Власний коротший строк застосунок не рахує — він працює з одним горизонтом для всього аналізу. Суму і строк додасть консультант.',
      },
      smrtUraz: {
        coJe: 'Виплачується лише тоді, коли причиною є травма. Тому воно дешеве — і тому не може бути головним покриттям: смерть від хвороби з нього не виплачується взагалі.',
        nazev: 'Смерть внаслідок травми',
      },
      trvaleOd1: {
        coJe: 'Виплачується навіть при невеликому постійному пошкодженні. Дорожчий варіант, але з найширшим обсягом виплати серед цих варіантів.',
        nazev: 'Постійні наслідки травми від найнижчих відсотків',
      },
      trvaleOd10: {
        coJe: 'Дрібні пошкодження пропускає і виплачує лише за ті, які справді змінять вам життя.',
        nazev: 'Постійні наслідки травми від десяти відсотків',
      },
      trvalePremium: {
        coJe: 'Чим серйозніший наслідок, тим вища виплата — при важких пошкодженнях це кілька разів більше за страхову суму.',
        nazev: 'Постійні наслідки травми з вищою прогресією',
        pozn: 'Як швидко прогресія зростає і де в неї межа, визначає страховий договір.',
      },
      zavazkyDluh: {
        coJe: 'Частка в іпотеці та інших виплатах, які не зникнуть. Це складова суми при смерті та при інвалідності, а не додаткове покриття.',
        nazev: 'Зобов’язання — хто їх доплатить',
        pozn: 'Борги не зменшуються ні в одному варіанті покриття. Іпотеку не можна виплатити на вісімдесят відсотків.',
      },
      zavazneKlesajici: {
        coJe: 'Те саме покриття із сумою, яка рік за роком зменшується. Дешевше, якщо водночас зростає ваше майно.',
        nazev: 'Критичні захворювання — сума, що зменшується',
      },
      zavazneOpakovane: {
        coJe: 'Виплачується більше ніж один раз — якщо після одужання прийде інший діагноз зі списку, виплата буде знову.',
        nazev: 'Критичні захворювання з повторною виплатою',
        pozn: 'Загальну межу повторних виплат визначає страховий договір.',
      },
      zavazneRozsirene: {
        coJe: 'Те саме покриття, лише з довшим списком діагнозів і м’якшими умовами виплати. Що саме входить, написано в договорі.',
        nazev: 'Критичні захворювання — розширений обсяг',
      },
      zavazneZakladni: {
        coJe: 'Одноразова виплата при діагнозі зі списку в договорі. Ці гроші не на оплату рахунків — вони на те, щоб ви могли перестати працювати і лікуватися.',
        nazev: 'Критичні захворювання — базовий обсяг',
      },
      zavazneZeny: {
        coJe: 'Додаток, спрямований на захворювання, які стосуються лише жінок, і на ускладнення під час вагітності.',
        nazev: 'Критичні захворювання для жінок',
      },
    },
    rokFew: '{n} роки',
    rokMany: '{n} років',
    rokOne: '{n} рік',
    rozdeleni: {
      balicek: 'Місячний пакет:',
      chybiBalicekTuk: 'Пакет ще не вибрано',
      investice: 'Інвестиції',
      nadpis: 'Скільки на захист і скільки на інвестиції',
      ochrana: 'Захист',
      podilOchrany: 'На захист йде {pct} пакета',
      popis: 'Пакет ділиться на дві частини. Повзунком можете спробувати самі.',
      posuvnik: 'Скільки з пакета йде на захист',
      prekrocenoText: 'На інвестиції не залишилося б нічого, а в пакеті бракує {chybi}. Або зменшиться покриття, або зросте сума, яку клієнт відкладає.',
      prekrocenoTuk: 'Захист дорожчий за пакет',
      skript: 'У вас {balicek} на місяць. Скільки з цього хочете дати на захист родини, а скільки залишити на інвестиції? Спробуйте посунути самі.',
      skriptNadpis: 'Фраза для зустрічі',
      zdrojNeznamy: 'Ціна захисту ще не вказана в жодному ризику.',
      zdrojPosuvnik: 'Суму ви встановили повзунком.',
      zdrojSoucet: 'Із суми цін за ризиками: {soucet} · ризиків із ціною: {pocet}',
      zpetNaSoucet: 'Назад до суми цін',
    },
    rozpad: {
      cile: 'Цілі',
      deficitMes: 'Не вистачає щомісяця',
      detiCelkem: 'Потреба родини',
      detiNepojistitelne: 'З них не можна застрахувати',
      detiSoucet: 'Сума договорів',
      detiZavazne: 'Критичні захворювання дитини',
      diskont: 'Переведено на сьогодні за ставкою',
      dluhy: 'Борги',
      karence: 'Резерв покриє (місяців)',
      naDite: 'На одну дитину',
      nasobekPrijmu: 'Кратність річного доходу',
      prijem: 'Дохід',
      statniDavka: 'Державна виплата',
      tnuSablona: 'Постійні наслідки — шаблон',
      vydaje: 'Капітал на витрати до кінця горизонту',
      vydajePoUdalosti: 'Витрати після події',
    },
    skupina: {
      deti: {
        nazev: 'Діти',
        otazka: 'Хто з вас двох залишився б удома, якби дитина хворіла цілий рік?',
        podtitul: 'Хвороба дитини — це втрата доходу батька або матері',
      },
      invalidita: {
        nazev: 'Інвалідність',
        otazka: 'Скільки, на вашу думку, держава давала б вам щомісяця, якби ви вже не могли працювати?',
        podtitul: 'Коли ви вже не можете працювати — а жити треба далі',
      },
      neschopnost: {
        nazev: 'Довга тимчасова непрацездатність',
        otazka: 'Скільки держава надішле вам за місяць на лікарняному? Спробуйте вгадати.',
        podtitul: 'Місяці вдома, а витрати не зникають',
      },
      pece: {
        nazev: 'Довготривалий догляд',
        otazka: 'Хто б за вами доглядав — і з чого ви платили б за цей догляд?',
        podtitul: 'Коли ви не даєте собі раду самі',
      },
      smrt: {
        nazev: 'Смерть',
        otazka: 'Хто доплатить іпотеку, якщо ви не повернетеся додому?',
        podtitul: 'Що залишиться родині, а що — банку',
      },
      uraz: {
        nazev: 'Травма',
        otazka: 'Що змінилося б у вас удома, якби після травми ви не могли працювати, як раніше?',
        podtitul: 'Стійкі наслідки і дні лікування',
      },
      zavazky: {
        nazev: 'Зобов’язання',
        otazka: 'Хто доплатить ці {castka}?',
        podtitul: 'Платежі, які не зникнуть',
      },
      zavazne: {
        nazev: 'Критичні захворювання',
        otazka: 'Якби вам завтра сказали діагноз — з чого ви жили б той рік, коли хочете тільки лікуватися?',
        podtitul: 'Діагноз, після якого лікування триває місяці або роки',
      },
    },
    smlouva: {
      dlouhodoba: {
        nadpis: 'Страховка — на роки',
        odstoupeni: 'Відмова невдовзі після підписання',
        odstoupeniText: 'Невдовзі після укладення ви можете відмовитися від договору без пояснення причин. Строк встановлює закон, його вказано в договорі.',
        preruseni: 'Якщо перестанете платити',
        preruseniText: 'Що станеться, визначають умови страхування.',
        text: 'Має сенс на довгий строк, а не на кілька місяців.',
        ukonceni: 'Якщо розірвете договір',
        ukonceniDusledek: 'У перші роки, поки сплачується вступний збір, у разі розірвання ви можете отримати назад мало або нічого.',
        ukonceniText: 'Можете. Покриття закінчується в день розірвання. Що отримаєте назад, визначають умови страхування.',
        znovu: 'Новий договір пізніше означає нову анкету здоров’я — за віком і здоров’ям на той момент.',
      },
      dotaznik: {
        nadpis: 'Анкета здоров’я: правдиво і повністю',
        podpis: 'Не підписуйте нічого, чого не розумієте.',
        spolu: 'Пройдемо її разом, питання за питанням. Чого не розумієте — навіть через мову — про те запитайте.',
        text: 'Неправдива або неповна відповідь може означати, що страховик не заплатить або заплатить менше — навіть після років сплати.',
      },
      investice: {
        dny: 'зазвичай протягом {dny} днів',
        dnyPodleSmlouvy: 'Точний строк указано в договорі.',
        dostupne: 'Гроші доступні',
        nadpis: 'Інвестиційну частину можна змінювати',
        pozastavit: 'Призупинити',
        pozastavitText: 'на час припинити інвестувати',
        pridat: 'Додати',
        pridatText: 'більший внесок або додатковий вклад',
        ubrat: 'Зняти',
        ubratText: 'зняти частину грошей',
      },
      nadpis: 'Як працює договір',
      oci: 'Договір',
      platba: {
        investice: 'Інвестиція',
        investiceText: 'Має вартість, і з неї можна брати. Коли і як — визначає договір.',
        nadpis: 'Внесок має дві частини',
        ochrana: 'Захист',
        ochranaText: 'Ціна за покриття. Не повертається — як обов’язкове страхування авто.',
      },
      vyluky: {
        nadpis: 'Коли страховик не платить',
        text: 'Кожен договір має винятки — випадки, коли страховик не виплачує. Вони в умовах страхування, і ми пройдемо їх разом.',
      },
    },
    souhrn: {
      cenaMesic: 'Ціна за місяць',
      cenaNezadana: 'Ціну впише консультант із розрахунку страховика',
      cenaUTemat: 'Ціна поки що є для {s} з {z} тем.',
      nadpis: 'Підсумок',
      osoba: 'Особа',
      pozn: 'Ціну та конкретне рішення підтвердить консультант за пропозицією страхової компанії.',
      preskoceno: 'Пропущено',
      probrano: 'Розглянуто',
      sCenou: 'З ціною',
      vybrano: 'Вибрано',
      zbyva: 'Залишилось',
    },
    spolecne: {
      let: 'років',
      nezadano: 'не вказано',
      podtitulek: 'Від доходу через кожен ризик до двох чисел: що отримає родина, якщо щось станеться, — і що залишиться, якщо ні.',
      rezimKlient: 'Показати клієнту',
      rezimPoradce: 'Назад до режиму радника',
      sekce: 'Страхування життя',
      titulek: 'Аналіз для в’єтнамців',
      ukazka: 'Зразковий клієнт',
      ukazkaJmeno: 'Зразок',
      ukazkaZnacka: 'Зразкові числа для тренування зустрічі — це не дані клієнта, який тут сидить.',
      vycistit: 'Новий клієнт',
      zaDen: '/ день',
      zaMesic: '/ місяць',
      zpet: 'Назад до інструментів',
    },
    stav: {
      doplniPoradce: 'Бракує даних. Їх додасть консультант — ми числа не додумуємо.',
      jeSlozka: 'Це частина страхової суми на випадок смерті та інвалідності, а не додаткове покриття.',
      kombinace: 'Комбінація виплачує один раз. Складається з: {rizika}',
      neumimeSpocitat: 'Це покриття застосунок не розраховує — суму додасть консультант із моделювання.',
    },
    stop: {
      bezBalicku: 'Виберіть пакет або напишіть власну суму.',
      bezCastky: 'Вкажіть суму.',
      bezCenyOchrany: 'Ціна захисту поки невідома — вкажіть її біля ризиків або задайте повзунком.',
      bezHorizontu: 'Виберіть, до скількох років рахувати.',
      bezKapitalu: 'Без модельної вартості інвестиції рента не рахується.',
      bezKatalogu: 'Каталог ризиків не завантажився.',
      bezPoplatku: 'Вхідна комісія інвестиції не вказана.',
      bezPrijmu: 'Вкажіть чистий місячний дохід — без нього пакети не порахуємо.',
      bezRizik: 'Поки не вибрано жодного ризику.',
      bezVeku: 'Вкажіть вік клієнта та цільовий вік.',
      bezVydaju: 'Вкажіть місячні витрати — інакше не знаємо, скільки насправді залишається.',
      cilovyVekNizsi: 'Цільовий вік {vekCilovy} менший за сьогоднішній вік {vekDnes} — виберіть пізніший.',
      pctMimoRozsah: 'Відкладати можна від {min} до {max} відсотків доходу.',
      poplatekMimoRozsah: 'Вхідна комісія поза діапазоном — зазвичай {min} до {max} % від цільової суми.',
      rokyMimoRozsah: 'Рахувати можна від {min} до {max} років.',
      vynosMimoRozsah: 'Очікувана дохідність має бути від 0 до {max} відсотків на рік.',
    },
    tvar: {
      klesajici: 'спадна',
      konstantni: 'постійна',
    },
    varovani: {
      balicekNadVolne: 'Пакет {pct} % на {chybi} вищий, ніж те, що залишається сьогодні. Це не заборона — шукати гроші є роботою консультанта.',
      cenaChybiUNekterych: 'У {pocet} вибраних ризиків не вказано ціну — у сумі їх немає.',
      denniCenaJenPodPrahem: 'Денна ціна на одну особу вища за {prah} — як аргумент для продажу не показується, лише як інформація.',
      ochranaNadBalicek: 'Захист на {chybi} дорожчий, ніж увесь пакет — на інвестицію не залишається нічого.',
      poplatekNadObvykly: 'Комісія {pct} % виходить за звичайний діапазон {min}–{max} % від цільової суми.',
      poplatekNesplacenyVHorizontu: 'За заданий горизонт комісія не буде сплачена повністю.',
      poplatekNezadan: 'Вхідну комісію не вказано — число орієнтовне, без комісії.',
      splatkyNadPolovinu: 'Платежі за кредитами перевищили половину доходу — числа потрібно дотягнути вручну.',
      splatkyNadRozpocet: 'Платежі за кредитами витрачають більше, ніж залишається після відкладання — це правило цій родині не підходить.',
      vlastniNadPrijem: 'Вказана сума вища за весь місячний дохід — можливо, це описка?',
      vynosMimoScenare: 'Дохідність {vynos} % не є одним із трьох модельних сценаріїв (4 / 7 / 9 %).',
      zadnaCenaZadana: 'Ціну не вказано ні в одного вибраного ризику — ціну додасть консультант.',
    },
    vstupy: {
      bezJmena: 'Клієнт',
      bezPartnera: 'Без партнера',
      deti: 'Кількість дітей',
      detiHint: 'Діти, яких утримує родина.',
      diteJmeno: 'Ім’я дитини',
      diteN: 'Дитина {n}',
      diteVek: 'Вік дитини',
      domacnost: 'Домогосподарство',
      dvojice: '{a} і {b}',
      forma: 'Форма доходу',
      formaOsvc: 'Самозайнятий (OSVČ)',
      formaZamestnanec: 'Найманий працівник',
      jistina: 'Основна сума боргів',
      jistinaHint: 'Скільки ще залишилося виплатити — іпотека та інші кредити разом.',
      jistinaZbyva: 'Залишок основної суми всіх кредитів',
      jmenoOsoby: 'Ім’я',
      klient: 'Клієнт',
      klientka: 'Клієнтка',
      manzel: 'Чоловік',
      manzelka: 'Дружина',
      muz: 'Чоловік',
      nadpis: 'Кого моделюємо',
      oci: 'Вхідні дані',
      partnerHint: 'Партнера робить ім’я, а не дохід. Без імені його дохід не враховується.',
      podnadpis: 'Вісім даних — і починаємо. Решту додамо, коли про це буде мова.',
      podporaRodine: 'Надсилає батькам / родині щомісяця',
      pohlavi: 'Стать',
      pohlaviHint: 'Впливає на тариф ризику, а не на звертання.',
      prijem: 'Чистий дохід за місяць',
      prijemHint: 'Скільки насправді приходить на рахунок.',
      souhrnNadpis: 'Моделювання для',
      vek: 'Вік',
      vekCil: 'Вік фінансової незалежності',
      vekCilHint: 'До якого віку відкладаєте. Далі має заробляти портфель, а не клієнт.',
      vydaje: 'Витрати родини за місяць',
      vydajeHint: 'Разом із виплатами кредитів — усе, що йде з рахунку.',
      vydajeVcSplatek: 'Витрати родини за місяць разом із виплатами кредитів',
      zena: 'Жінка',
    },
    vysledek: {
      bezKrytiStitek: 'Без зазначеного покриття: {pocet}',
      chybiKryti: 'У розглянутих ризиків бракує страхової суми (кількість: {pocet}). Поки суми немає, ризик у виплаті не з’явиться.',
      hodnotaInvestice: 'Вартість інвестиційної частини в моделі',
      hodnotaPopis: 'вкладено в інвестиції {castka}',
      iddKratce: 'Модельний дохід не гарантований і це не обіцянка повернення сплачених страхових платежів.',
      iddText: 'Ліворуч страхові суми, які задав консультант, праворуч модельний розвиток інвестиційної частини. Обидва числа стоять окремо: модельний дохід не гарантований і це не обіцянка повернення сплачених страхових платежів. Висновок робить клієнт, конкретне рішення підтвердить консультант.',
      iddTuk: 'Два окремі числа',
      nescitajiSe: 'Ризики не виплачуються разом, тому суми не додаються.',
      nestaloNadpis: 'Що залишиться в кінці',
      nestaloOci: 'Якби нічого не сталося',
      ochranaZaplatite: 'За захист заплатите за {roky}',
      ochranaZaplatiteBezRoku: 'Загалом за захист заплатите',
      poradceNadpis: 'Для консультанта',
      poradcePozn: 'Не з’єднуйте числа в одне речення. Дайте клієнту зробити висновок самому.',
      renta: 'Модельна місячна рента з цієї суми',
      rentaPozn: 'Рента за безпечного зняття {sazba} на рік. Модельний розрахунок, не гарантована виплата.',
      rizikoBezNazvu: 'Ризик без назви',
      staloNadpis: 'Що отримає родина',
      staloOci: 'Якби щось сталося',
      staloPodnadpis: 'За окремими ризиками, які ви вибрали:',
      staloZdroj: 'Суми взяті зі страхових сум, які ви задали в ризиках. Ризики не виплачуються разом, тому не додаються.',
      zadnaRizika: 'Поки не вибрано жодного ризику із заданою страховою сумою.',
    },
    zaRokFew: 'за {n} роки',
    zaRokMany: 'за {n} років',
    zaRokOne: 'за {n} рік',
  },
  /* BLOK:izp END */
  /* BLOK:prodejKit START — generuje scratchpad/slovnik.py, ručně needitovat */
  prodejKit: {
    namitky: {
      analyza: {
        mamPoradce: {
          n: 'У мене вже є свій консультант.',
          o: 'Це добре, нічого змінювати не потрібно. Аналіз покаже, яка у вас ситуація сьогодні, і з результатом ви можете спокійно піти й до нього.',
        },
        nechciNicKupovat: {
          n: 'Я не хочу нічого купувати.',
          o: 'Розумію. Сьогодні ви нічого не підписуєте — я покажу вам цифри, а чи робити з ними щось, вирішуєте тільки ви.',
        },
        nemamCas: {
          n: 'У мене на це немає часу.',
          o: 'Розумію, час дорогий — скільки його у вас сьогодні? Пройдемо лише головне, а про решту домовимося іншим разом.',
        },
        partner: {
          n: 'Мені треба обговорити це з партнером.',
          o: 'Звісно, це стосується вас обох. Зустрінемося наступного разу разом, щоб партнер почув те саме, що й ви?',
        },
        prijmyNereknu: {
          n: 'Свої доходи я вам не скажу.',
          o: 'Розумію, це ваше рішення. Достатньо приблизного діапазону — а що не заповнимо, залишиться порожнім, я нічого не домислюю.',
        },
        procToChcete: {
          n: 'Навіщо вам усе це знати?',
          o: 'Без ваших цифр я радив би наосліп. На що не хочете відповідати, те пропустимо.',
        },
      },
      jenPoradce: 'бачить лише консультант',
      kontext: {
        analyza: 'Аналіз',
        pojisteni: 'Страхування',
      },
      pojisteni: {
        drahe: {
          n: 'Це дорого.',
          o: 'Розумію, свій бюджет ви знаєте найкраще. Можемо зменшити страхові суми там, де втрату доходу покриє ваш резерв, — і вголос скажемо, якого покриття ви при цьому позбудетеся.',
        },
        mamPojisteni: {
          n: 'Страхування в мене вже є.',
          o: 'Це добре — ми його врахуємо, щоб ви не платили двічі за одне й те саме. Подивимося в договір: скільки він виплатить і чи покриває також інвалідність, а не лише смерть?',
        },
        manzel: {
          n: 'Мені треба порадитися з чоловіком / дружиною.',
          o: 'Звісно, це рішення вас обох. Зустрінемося наступного разу разом, щоб він чи вона бачили ті самі цифри, що й ви, — коли вам було б зручно?',
        },
        nechciSeVazat: {
          n: 'Не хочу привʼязуватися надовго.',
          o: 'Розумію — договір можна припинити, але в перші роки, поки сплачується вступний збір, ви можете отримати назад мало або нічого. У довгостроковій перспективі це має сенс, бо ціна й прийняття залежать від віку та здоровʼя на день укладення, а здоровʼя заднім числом не докупиш.',
        },
        nicSeMiNestane: {
          n: 'Зі мною нічого не станеться.',
          o: 'Бажаю вам цього, і, найімовірніше, ви маєте рацію. Я страхую не те, що ймовірне, а те, що було б незворотним, — скільки місяців протрималася б ваша родина, якби це все-таки сталося?',
        },
        rozmyslim: {
          n: 'Я подумаю.',
          o: 'Звісно, це рішення на роки, і ми нікуди не поспішаємо. Щоб я знав, що вам надіслати: ви хочете подумати, чи взагалі страхувати цей ризик, чи скільки на це виділити?',
        },
      },
      titul: 'Заперечення',
    },
    ram: {
      brana: 'Цей крок ще не завершено.',
      dalsi: 'Далі',
      hotovo: 'Готово',
      hotovyKrok: 'готово',
      klavesy: '→ або пробіл: далі · ←: назад · Esc: кінець',
      klient: 'Клієнт',
      krok: 'Крок {n} / {celkem}',
      poradce: 'Консультант',
      prejitNa: 'Крок {n}: {nazev}',
      prezentace: 'Презентація',
      rozbalit: 'Розгорнути',
      skryt: 'Сховати',
      tahak: 'Підказка',
      tip: 'Порада',
      zavrit: 'Закрити презентацію',
      zpet: 'Назад',
    },
    souhlas: {
      ano: 'Так',
      ne: 'Ні',
      nezadano: 'Не вказано',
      pozdeji: 'Пізніше',
      poznamka: 'Примітка (необовʼязково)',
      vymazat: 'Стерти відповідь',
      zapsano: 'Записано {kdy}',
    },
  },
  /* BLOK:prodejKit END */
  /* BLOK:planPojistne START — generuje scratchpad/slovnik.py, ručně needitovat */
  planPojistne: {
    budouci: 'у майбутньому {castka} — поки не враховується',
    driveNe: 'Клієнт раніше сказав, що не хоче вирішувати захист доходу — план не віднімає страхову премію.',
    nadPrebytek: 'Страхування {cena} коштує більше, ніж місячний надлишок {prebytek} — на цілі нічого не лишається.',
    nezadana: 'Вартість страхування не вказана — план її не враховує.',
    nula: 'Вартість страхування 0 — з надлишку нічого не віднімається.',
    odmitnuto: 'Клієнт поки не хоче захисту доходу.',
    prebytekBezPrijmu: 'Місячний надлишок поки невідомий — в аналізі бракує доходів. Додайте їх або одразу впишіть суму, яку ви погодили з клієнтом.',
    segment: 'Страхування',
    tokPrebytek: 'Надлишок після страхування',
    zToho: 'з них страхування {pojisteni} · на цілі {naCile}',
  },
  /* BLOK:planPojistne END */
  /* BLOK:analyzaProdej START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaProdej: {
    cas: {
      ano: 'Так, має час',
      drivejsiZapis: 'Попередній запис',
      potvrzeno: 'Клієнт підтвердив 45 хвилин',
    },
    cesta: {
      dnes: 'СЬОГОДНІ',
      popis: 'Цілі зʼявляються по черзі, як спливає час',
      prehrat: 'Відтворити',
      preskocit: 'Пропустити',
      vek: '{n} р.',
      za: 'через {n} р.',
      znovu: 'Відтворити ще раз',
    },
    dedictvi: {
      druh: 'Тип',
      druhJine: 'Інше',
      druhNemovitost: 'Нерухомість від батьків',
      nadpis: 'Майбутнє майно (спадщина)',
      nepocita: 'у майбутньому — поки не враховується',
      panel: 'Майбутнє майно',
    },
    forma: {
      jiny: 'Інше джерело',
      majitel: 'Власник фірми',
      osvc: 'Самозайнята особа (OSVČ)',
      zamestnanec: 'Найманий працівник',
    },
    majetek: {
      nefinPod: 'нерухомість, бізнес',
    },
    oceneni: {
      do: 'до',
      ebitda: 'Річний операційний прибуток (EBITDA)',
      ebitdaPopis: 'Прибуток до сплати відсотків, податків і амортизації — не прибуток до оподаткування.',
      horni: 'Верхня межа',
      majetkove: 'За майном',
      nasobek: 'Мультиплікатор',
      nezadano: 'не вказано',
      od: 'від',
      otevrit: 'Помічник оцінки',
      pouzit: 'Використати як вартість',
      spodni: 'Нижня межа',
      stred: 'Середина',
      substance: 'Скільки коштувало б повністю облаштувати фірму',
      upozorneni: 'Орієнтовна оцінка, не експертний висновок.',
      vynosove: 'За прибутком',
      ztrata: 'За нульового чи від’ємного прибутку оцінка за прибутком не робиться.',
    },
    podklady: {
      dotaznik: 'Інвестиційна анкета',
      investicni: 'Інвестиційні договори',
      pojistne: 'Страхові договори',
      uverove: 'Кредитні договори',
      vypisy: 'Виписки з рахунків',
    },
    prebytek: {
      nicNezbyva: 'Із доходів сьогодні нічого не залишається — вільний грошовий потік {castka}.',
    },
    predstaveni: {
      jakText: 'Сьогодні я лише знайомлюся з вашою ситуацією та цілями. Пропозицію принесу наступного разу — рішення завжди за вами.',
      jakTitul: 'Як я працюю',
      kdoText: 'Мою реєстрацію в публічному реєстрі {dohled} ви можете перевірити самі.',
      kdoTitul: 'Хто я',
      kicker: 'Перш ніж почати',
      odmenaText: 'За укладений договір комісію мені платить фінансова установа. Подробиці ви отримаєте письмово до підписання.',
      odmenaTitul: 'Моя винагорода',
    },
    prez: {
      dialog: 'Презентація аналізу',
      predstaveni: {
        q: 'Перш ніж почати: хто я і як працюю',
        tab: 'Знайомство',
        tahak: 'Що вам важливо знати про те, як я працюю?',
        tip: 'Реєстр клієнт може перевірити одразу в телефоні.',
      },
    },
    reference: {
      gdprPotvrzeno: '✓ Підтверджено {datum}',
      gdprText: 'Клієнт підтверджує, що передає контакти за згодою рекомендованих осіб, або бере до відома, що консультант під час першого звернення повідомить їх про джерело та обробку персональних даних згідно зі ст. 14 GDPR.',
      gdprTitul: 'Згода GDPR:',
      tahak: '«Маю одне прохання. Якщо сьогоднішня зустріч була для Вас корисною, порадьте мені двох-трьох людей, які зараз щось вирішують: житло, сім’ю, роботу? Переконувати їх не треба. Достатньо імені та телефону, і я зателефоную лише один раз.»',
    },
    rizika: {
      chybi: 'Бракує',
      chybiHorizont: 'роки в цілях',
      chybiPozustalostni: 'виплата родині після втрати годувальника для цієї країни',
      chybiPrijem: 'дохід',
      chybiUdaje: 'Для розрахунку бракує',
      chybiVydaje: 'необхідні витрати',
      kicker: 'Якби ви не могли працювати',
      krytiInvalidita: 'Покриття на випадок інвалідності',
      krytiSmrt: 'Покриття на випадок смерті',
      mesicne: 'на місяць',
      potrebujete: 'Вам потрібно',
      poznamka: 'Модель за вашими цифрами, а не гарантія. Державні виплати — лише оцінка.',
      statDa: 'Держава дасть',
      stavajici: 'Наявні поліси · інвалідність',
      zustane: 'Залишиться дохід',
    },
    tabulky: {
      budouciPrijmyPopis: 'Дохід, який додасться через два, три або п’ять років. План враховує його в ренті.',
      zatimNic: 'Поки нічого.',
    },
    tisk: {
      dalsiSchuzka: 'Наступна зустріч',
      nadpis: 'Підсумок зустрічі',
      nezadano: 'не введено',
      podklady: 'Документи, які потрібно надати',
      prebytek: 'Погоджений місячний надлишок',
      shrnutiJenJmeni: 'Підсумок нашого аналізу: чисті активи {jmeni}.',
    },
    vydaje: {
      podpora: 'Підтримка батьків / родини',
    },
    zastava: {
      popis: 'Нерухомість від батьків може забезпечити кредит — лише за згоди власника. Нічого не перераховується.',
      titul: 'Можлива застава для кредиту',
      zvoleno: 'обрано як заставу',
      zvolit: 'обрати як заставу',
    },
    zaver: {
      bezDat: 'Коли додамо цифри, тут з’явиться, що вирішувати.',
      diarPoPrezentaci: 'Записати термін у щоденник після презентації',
      diarPoPrezentaciAno: '✓ Щоденник відкриється після завершення презентації',
      model: 'Модель за вашими цифрами, а не гарантія.',
      nadpis: 'Що ми разом вирішуємо',
      rizikaNadpis: 'Захист доходу',
      rizikaText: '{jmeno}: у разі інвалідності бракує {castka} на місяць.',
      terminOtevrit: 'Відкрити зустріч у щоденнику',
      terminRadek: 'Наступна зустріч: {kdy}',
      terminVAnalyze: 'записано в аналізі',
      terminVDiari: 'у щоденнику',
      vseOk: 'Зараз із цифр нічого не потребує вирішення.',
    },
  },
  /* BLOK:analyzaProdej END */
  /* BLOK:nastenkaGrafy START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastenkaGrafy: {
    trychtyr: {
      otevrenychFew: 'відкриті',
      otevrenychMany: 'відкритих',
      otevrenychOne: 'відкритий',
      prumerDniFew: 'у сер. {n} дні на етапі',
      prumerDniMany: 'у сер. {n} днів на етапі',
      prumerDniOne: 'у сер. {n} день на етапі',
    },
    vyvoj: {
      mesiceFew: '{n} місяці',
      mesiceMany: '{n} місяців',
      mesiceOne: '{n} місяць',
      obchodyFew: '{n} угоди',
      obchodyMany: '{n} угод',
      obchodyOne: '{n} угода',
      popisGrafu: 'Динаміка угод: за {obdobi} {obchody}, {bj}, найбільше в місяці {mesic}',
      slovoObchoduFew: 'угоди',
      slovoObchoduMany: 'угод',
      slovoObchoduOne: 'угода',
    },
  },
  /* BLOK:nastenkaGrafy END */
  /* BLOK:analyzaPrezentace START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrezentace: {
    chip: {
      bydleni: 'Житло',
      deti: 'Діти',
      dluhy: 'Борги',
      duchod: 'Пенсія',
      investice: 'Інвестиції',
      plan: 'Загальний план',
      pojisteni: 'Страхування',
      rezerva: 'Резерв',
    },
    chybi: {
      a: 'і',
      castka: 'сума',
      castka4: 'суму',
      horizont: 'горизонт',
      horizont4: 'горизонт',
      limity4: 'ліміти покриття',
      platba4: 'щомісячний внесок',
      pojistovna4: 'страховика',
    },
    cislo: {
      mil: '{n} млн',
      tis: '{n} тис.',
    },
    hlaska: {
      cashflowIncomplete: 'Вільний грошовий потік поки що неможливо розрахувати.',
      cashflowNic: 'Ще не введено ні доходів, ні витрат.',
      cashflowPrijmy: 'Доповніть доходи домогосподарства.',
      cashflowVydaje: 'Доповніть звичайні витрати, щоб ми могли розрахувати вільний грошовий потік.',
      cilIncomplete: 'Ціль ще в роботі. Доповніть {chybi}.',
      hypotekaIncomplete: 'Іпотеку зареєстровано. Доповніть залишок і щомісячний платіж.',
      investiceIncomplete: 'Договір зареєстровано. Доповніть поточну вартість або регулярний внесок.',
      investiceIncompleteVice: 'Договори зареєстровано. Доповніть поточну вартість або регулярний внесок.',
      majetekNeuplny: 'Ще не введено: {chybi}. Тому чисті активи лише орієнтовні й неповні.',
      pojistkaIncomplete: 'Страховий договір зареєстровано. Доповніть {chybi}.',
      pojistkaIncompleteVice: 'Страхові договори зареєстровано. Доповніть {chybi}.',
      rezervaIncomplete: 'Для розрахунку резерву доповніть: {chybi}.',
      rizikoOrientacni: 'Орієнтовна місячна різниця між витратами родини і доходом, який залишився б після його втрати. Це не страхова потреба — її розрахуємо після врахування резервів, соціальних виплат та наявного страхування.',
      zavazkyEmpty: 'Жодних зобовʼязань не зареєстровано.',
      zavazkyIncomplete: 'Зобовʼязання зареєстровано. Доповніть залишок і щомісячний платіж.',
      zavazkyIncompleteVice: 'Зобовʼязання зареєстровано. Доповніть залишки і щомісячні платежі.',
    },
    horizont: {
      bezTerminu: 'Термін ще не визначено',
    },
    krok: {
      cile: {
        q: 'Чого ви хочете досягти? ЩО / КОЛИ / СКІЛЬКИ',
        tab: 'Цілі',
      },
      hodnoty: {
        q: 'Чим для вас важливі гроші?',
        tab: 'Цінності',
      },
      ocekavani: {
        q: 'Чого ви очікуєте від сьогоднішньої зустрічі?',
        tab: 'Очікування',
      },
      prijmy: {
        q: 'Скільки ви заробляєте і скільки залишається?',
        tab: 'Доходи та витрати',
      },
      rizika: {
        q: 'Що може загрожувати плану?',
        tab: 'Ризики',
      },
      rodina: {
        q: 'Для кого ми сьогодні плануємо?',
        tab: 'Родина',
      },
      zavazky: {
        q: 'Що ви сьогодні сплачуєте і які у вас є договори?',
        tab: 'Зобовʼязання та договори',
      },
      zaver: {
        q: 'Давайте підсумуємо.',
        tab: 'Підсумок',
      },
      zdroje: {
        q: 'Які у вас є ресурси для ваших цілей?',
        tab: 'Ресурси',
      },
    },
    pasmo: {
      dlouhodoby: 'Довгостроковий',
      kratkodoby: 'Короткостроковий',
      strednedoby: 'Середньостроковий',
    },
    pasmoPopis: {
      dlouhodoby: '10 років і більше',
      kratkodoby: 'до 3 років',
      strednedoby: '4–9 років',
    },
    platno: {
      cesta: {
        nadpis: 'Життєвий шлях',
        orientacniPozn: 'Фінансову незалежність перераховано на капітал за правилом 4 % — методика не затверджена, сприймайте число як орієнтовне.',
        orientacniTitul: 'Перерахунок ренти на капітал (правило 4 %) не є затвердженою методикою — число орієнтовне.',
      },
      citat: '«{text}»',
      hodnoty: {
        nadpis: 'Що для вас важливо',
        prazdno: 'Напишіть ліворуч, що для клієнта означають гроші…',
      },
      ocekavani: {
        cil: 'Моя мета — перевірити, **що ви вже робите добре**, де, можливо, **втрачаєте гроші** і що **могли б робити краще**.',
        nadpis: 'Чого ви очікуєте від сьогодні',
        prazdno: 'Запишіть ліворуч слова клієнта…',
      },
      prijmy: {
        poznamka503020: '50 / 30 / 20 — орієнтир, а не обовʼязкове правило: реальний розподіл залежить від життя родини.',
        rozdilNezadano: 'Різницю покажемо, щойно матимемо і розрахований надлишок, і суму, яку клієнт погодив.',
      },
      rizika: {
        kino: 'Запустити кіно: захист від ризиків',
      },
      rodina: {
        cilKicker: 'Яка сьогодні мета',
        cilText: 'Давайте разом **перевіримо, що ви вже робите добре**, — і де у фінансах **можна щось покращити**. Жодного продажу, лише чітка картина і рекомендація.',
        nadpis: 'Родина, для якої ми плануємо',
        prazdno: 'Заповніть ліворуч імена клієнтів і дітей…',
      },
      zavazky: {
        dodaPozdeji: 'клієнт надасть пізніше: {n}',
        fixace: 'найближче закінчення фіксації {datum}',
        konec: 'кінець погашення {datum}',
        splatka: 'платіж {castka}',
      },
      zdroje: {
        bezKurzu: 'У підсумку немає {n} позицій в іноземній валюті — для них бракує придатного курсу. Краще їх не наводити, ніж назвати число, яке ніхто не перевірив.',
        bezKurzuKat: '{n}× іноземна валюта без курсу — не враховано',
      },
    },
    pole: {
      bonusy: 'Бонуси за рік',
      cas: 'Час',
      cilCo: 'ЩО — опис цілі',
      cilCoPh: 'Напр. більше житло',
      cilKdy: 'КОЛИ — через скільки років',
      cilKolik: 'СКІЛЬКИ — цільова сума',
      cilTyp: 'Тип цілі',
      coDodat: 'Що має надати клієнт',
      dalsiSchuzka: 'Наступна зустріч',
      datum: 'Дата',
      doslovne: 'Дослівний запис…',
      formaKlient: 'Форма доходу — клієнт {n}',
      katOpf: 'Інвестиції (фонди / ETF / акції)',
      klientEmail: 'Клієнт {n} — e-mail',
      klientJmeno: 'Клієнт {n} — імʼя',
      klientN: 'Клієнт {n}',
      klientTelefon: 'Клієнт {n} — телефон',
      mamDnes: 'Маю сьогодні',
      navrh: 'Пропозиція',
      nezbytne: 'Необхідні місячні витрати',
      obvykle: 'Звичайні місячні витрати',
      ocekavani: 'Чого очікує клієнт (його словами)',
      pasivni: 'Пасивні доходи',
      penize: 'Що для клієнта означають гроші? (його словами)',
      penizePh: 'свобода, впевненість, спокій, час із родиною…',
      poznPrijmy: 'Примітка до доходів',
      predvyplnitZCrm: 'Натисніть, щоб заповнити дані з картки в CRM',
      refTelefon: 'Телефон / контакт',
      refVztah: 'Стосунок / примітка',
      vlastniPh: 'напр. виписка з пенсійного фонду',
      vlastniPolozka: 'Власна позиція',
      vydajePozn: 'Платежі за кредитами — у зобовʼязаннях, не рахуйте їх удруге. Необхідні витрати — мінімум на випадок втрати доходу.',
      zDomacnosti: 'З домогосподарства:',
    },
    riziko: {
      evidovano: 'Зареєстровано',
      nezadano: 'Не введено',
      proverit: 'Перевірити',
      vyreseno: 'Вирішено',
    },
    role: {
      dite: {
        m: 'Син',
        z: 'Донька',
      },
      klient: {
        m: 'Клієнт',
        z: 'Клієнтка',
      },
      manzel: {
        m: 'Чоловік',
        z: 'Дружина',
      },
      partner: {
        m: 'Партнер',
        z: 'Партнерка',
      },
    },
    sablona: {
      c1: 'Обовʼязковий ліквідний резерв',
      c2: 'Житло / ремонт',
      c3: 'Освіта для дітей / старт у життя',
      c4: 'Фінансова незалежність',
      d1: 'Спадщина',
      f1: 'Компанія / бізнес',
      kz1: 'Накопичувальне страхування життя',
      kz2: 'Інвестиційне страхування життя',
      n1: 'Квартира / будинок',
      n2: 'Комерційні приміщення',
      n3: 'Ділянки / ліси / поля',
      n4: 'Авто / транспортні засоби',
      n5: 'Цінності (годинники, мистецтво, колекції…)',
      n6: 'Золото та дорогоцінні метали',
      o1: 'Акційні фонди/ETF',
      o2: 'Облігаційні фонди/ETF',
      o3: 'Фонди/ETF грошового ринку',
      o4: 'Фонди/ETF нерухомості та інші',
      o5: 'Окремі акції',
      o6: 'Корпоративні облігації',
      o8: 'Криптовалюти',
      pj1: 'Ризикове страхування життя',
      pj2: 'Страхування від нещасних випадків',
      pj3: 'Страхування нерухомості / домашнього майна',
      pj4: 'Страхування відповідальності',
      pj5: 'ОСЦПВ / КАСКО',
      pj6: 'Страхування правового захисту',
      pz1: 'Старе додаткове пенсійне страхування',
      pz2: 'Додаткові пенсійні заощадження',
      pz3: 'Довгостроковий інвестиційний продукт',
      r1: 'Страхування нерухомості / будівлі',
      r2: 'Страхування домашнього майна',
      r3: 'Страхування відповідальності',
      r4: 'ОСЦПВ (авто)',
      r5: 'КАСКО',
      s1: 'Будівельні заощадження',
      u1: 'Строковий депозит',
      u2: 'Ощадний рахунок',
      u3: 'Поточний рахунок',
      u4: 'Готівка вдома',
      u5: 'Іноземна валюта',
      zb1: 'Іпотека / кредит на житло',
      zb2: 'Споживчі кредити',
      zb3: 'Лізинг',
      zb4: 'Кредитні картки',
      zo1: 'Бізнес-кредит',
      zo2: 'Револьверний кредит',
    },
    smluvFew: '{n} договори',
    smluvMany: '{n} договорів',
    smluvOne: '{n} договір',
    tab: {
      bydleni: {
        celkem: 'Зобовʼязання разом',
        konec: 'Кінець погашення',
        mesicne: 'Щомісячні платежі',
        nadpis: 'Житло',
        nejblizsi: 'Найближче закінчення фіксації',
        pocet: 'Кредитів',
      },
      investicni: {
        celkem: 'Поточна вартість',
        mesicne: 'Регулярні внески',
        nadpis: 'Інвестиційні договори',
        nejblizsi: 'Найближча річниця',
        pocet: 'Продуктів',
      },
      ostatni: {
        celkem: 'Інші кредити',
        mesicne: 'Щомісячні платежі',
        nadpis: 'Інші кредити',
        nejblizsi: 'Найближчий строк сплати',
        pocet: 'Кредитів',
      },
      pojistky: {
        mesicne: 'Щомісячні внески',
        nadpis: 'Страхові поліси',
        nejblizsi: 'Найближча річниця',
        pocet: 'Договорів',
      },
    },
    tahak: {
      cile: {
        say1: 'Погляньмо на ваші стратегічні цілі за схемою ЩО – КОЛИ – СКІЛЬКИ.',
        say2: 'Що вам потрібно буде фінансувати? Коли вам потрібні гроші? Скільки коштуватиме ціль?',
        say3: 'Якщо клієнт сам не згадає, завжди перевірте: житло, майбутнє дітей і фінансову незалежність.',
        tip: 'Для цілі, яку клієнт недооцінює, увімкніть Кіно — воно покаже число замість умовлянь.',
      },
      hodnoty: {
        say1: 'Якщо клієнт скаже, наприклад, свобода, запитайте: Що для вас означає свобода?',
        say2: 'Що ще спадає вам на думку? Чому це важливо для вас саме зараз?',
        say3: 'Місток: Якщо фінансовий план забезпечить вам {slovaKlienta}, це буде для вас правильне рішення?',
        tip: 'Не питайте про суми. Тут ідеться про причину, а не про цифри.',
      },
      ocekavani: {
        say1: 'Чого ви очікуєте від сьогоднішньої зустрічі?',
        say2: 'Повторіть слова клієнта і продовжте: Моя мета — перевірити, що ви вже сьогодні робите добре, де, можливо, втрачаєте гроші і що могли б робити краще.',
        tip: 'Записуйте дослівно. Власні слова клієнта використаєте в підсумку і на наступній зустрічі.',
      },
      prijmy: {
        say1: 'Ще одне важливе джерело для досягнення ваших цілей — ваші доходи.',
        say2: 'За введеними цифрами у вас виходить приблизно {castka}. Скільки ви справді й довгостроково готові спрямовувати на свій фінансовий план?',
        tip: 'Погоджений надлишок — це число клієнта, а не ваше. Краще менше, зате стабільно.',
      },
      rizika: {
        say1: 'У межах фінансового плану ми подивимося і на ваш захист — що у вас є сьогодні, що він покриває, а що ні.',
        say2: 'Перевіримо, чи можна заощадити або застрахуватися розумніше, і покажемо, як захист виглядатиме в усьому плані: родина, цілі, резерв.',
        tip: 'Не оцінюйте і не лякайте. Лише зафіксуйте стан і те, що треба перевірити.',
      },
      rodina: {
        say1: 'Телефоном ми домовилися, що в нас буде 45 хвилин. У мене нічого не змінилося. Хочу лише переконатися, що ви теж розраховуєте приблизно на 45 хвилин.',
        say2: 'Спочатку лише перевірю основні дані про вас і вашу родину.',
        tip: 'Підтвердьте час одразу на початку — тоді ніхто не дивиться на годинник.',
      },
      zavazky: {
        say1: 'Важлива інформація для досягнення ваших цілей — зобовʼязання та договори, які у вас уже є.',
        say2: 'Спочатку подивимося на іпотеки та інші кредити, потім на наявні інвестиційні, пенсійні та страхові договори.',
        tip: 'Дата закінчення фіксації та річниця договору — найцінніші дані всієї зустрічі: без них пропозицію не вдасться вчасно спланувати.',
      },
      zaver: {
        say1: 'Чи є щось важливе, про що я забув вас запитати?',
        say2: 'Тепер у нас є потрібні дані, щоб підготувати вашу фінансову стратегію та фінансовий план.',
        say3: 'На наступній зустрічі ми покажемо: що рекомендуємо, скільки це коштуватиме, у якому порядку зробимо окремі кроки і як план приведе до ваших цілей.',
        tip: 'Не конкретизуйте рішення. Сьогодні домовляєтеся лише про термін і документи.',
      },
      zdroje: {
        say1: 'Тепер ми вже знаємо ваші цілі. Погляньмо на ресурси, які у вас є для їх досягнення.',
        tip: 'Питайте за категоріями, а не загалом — інакше клієнт забуде половину.',
      },
    },
    typCile: {
      auto: 'Авто',
      bydleni: 'Житло',
      deti: 'Майбутнє дітей',
      investice: 'Інвестиції',
      nezavislost: 'Фінансова незалежність',
      ostatni: 'Інші цілі',
      podnikani: 'Бізнес',
      podnikatelsky: 'Бізнес-кредит',
      rekonstrukce: 'Ремонт',
      rezerva: 'Резерв',
      spotrebitelsky: 'Споживчий кредит',
      uver: 'Кредит',
    },
    vydajKat: {
      bydleni: 'Житло (оренда / ОСББ / ремонтний фонд)',
      deti: 'Діти, школа, гуртки',
      doprava: 'Транспорт / авто / громадський транспорт',
      dovolena: 'Відпустка (у середньому за місяць)',
      energie: 'Енергія (електрика, газ, вода)',
      jidlo: 'Їжа та господарство',
      ostatni: 'Інше',
      pojisteni: 'Страхування (без платежів за кредитами)',
      predplatne: 'Підписки та послуги',
      telekom: 'Телефон, інтернет, ТБ',
      volnyCas: 'Дозвілля, хобі, ресторани',
      zdravi: 'Здоровʼя, ліки, засоби гігієни',
    },
    zaver: {
      bezTerminu: 'Дату наступної зустрічі ми ще не домовили. Щойно домовимося, разом пройдемо підготовлений план.',
      sTerminem: 'Я підготую план, і ми разом пройдемо його на наступній зустрічі {kdy}.',
      vHodin: '{datum} о {cas}',
    },
  },
  /* BLOK:analyzaPrezentace END */
  /* BLOK:planKlient START — generuje scratchpad/slovnik.py, ručně needitovat */
  planKlient: {
    letFew: '{n} роки',
    letMany: '{n} років',
    letOne: '{n} рік',
    metodika: 'Досягнення цілей: реальна дохідність понад інфляцію за класами активів (акції {akcie} / облігації {dluhopisy} / готівка {cash} % річних, поступове зниження ризику до цілі). Страхові суми: капітальний метод @ 4 % реально. Соціальні виплати (вдовина, сирітська разом на родину, пенсія по інвалідності) — ОРІЄНТОВНА ОЦІНКА за шаблоном, а не обіцянка держави; консультант їх перевірить. Останнє слово за консультантом.',
    shrnuti: {
      podtitul: 'Три кошики вгорі, рядок на ціль. Цифри ті самі, що й у Пропозиції рішення.',
      rozdavej: 'Розподіляйте ресурси прямо в таблиці, доки в обох кошиках не буде „Залишилось 0“.',
    },
    tahak: 'Підказка для консультанта',
    uvod: {
      dobraCile: 'Перша — добра: [[ваші цілі вдасться досягти.]]',
      dobraPlan: 'Добра новина: [[у вас є план.]]',
      lepsiCesta: 'Ще краща: ви йдете до них [[безпечнішим шляхом]].',
      lepsiDrive: 'Ще краща: жити з ренти ви зможете [[вже через {za}]] — на {o} раніше.',
      rentaNa: 'Рента поки що на [[{pct} %]] — і ми точно бачимо, що з цим робити.',
      rentaNezadana: 'Ціль ренти ще не задана.',
    },
  },
  /* BLOK:planKlient END */
  /* BLOK:denniCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  denniCrm: {
    chybaPopis: 'Дані нікуди не зникли — просто зараз не вдалося з’єднатися із сервером.',
    klientiNenacteno: 'Не вдалося завантажити клієнтів',
    nacitam: 'Завантаження…',
    obchodyNenacteno: 'Не вдалося завантажити угоди',
    offlineKopie: 'офлайн-копія від {cas}',
    offlineKopieBezCasu: 'офлайн-копія',
    zavritZalozku: 'Закрити вкладку {nazev}',
    zkusitZnovu: 'Спробувати ще раз',
  },
  /* BLOK:denniCrm END */
  /* BLOK:nastrojeBezSlibu START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastrojeBezSlibu: {
    namitkaRizikoOdpoved: 'Цілком розумію. Ризик можна знизити, але дохід понад інфляцію вам наперед ніхто пообіцяти не може. Покажу консервативні варіанти — ощадний рахунок, облігаційні фонди, консервативний пенсійний фонд — і що від кожного реально очікувати. Ви оберете, що вам ближче.',
    pojisteniVkladu: 'Страхування вкладів',
  },
  /* BLOK:nastrojeBezSlibu END */
  /* BLOK:penzeBezKavy START — generuje scratchpad/slovnik.py, ručně needitovat */
  penzeBezKavy: {
    aRentu: 'і ренту',
    podleModeluVDuchodu: 'За моделлю на пенсію у вас накопичено',
  },
  /* BLOK:penzeBezKavy END */
  /* BLOK:funnelReference START — generuje scratchpad/slovnik.py, ručně needitovat */
  funnelReference: {
    sablona: '[Вставте сюди справжній відгук за згодою клієнта]',
    titul: 'Відгуки (лише справжні, за згодою клієнта)',
  },
  /* BLOK:funnelReference END */
  /* BLOK:ikony START — generuje scratchpad/slovnik.py, ručně needitovat */
  ikony: {
    aktivita: {
      cesta: 'Маршрут',
      dopis: 'Лист',
      email: 'Електронний лист',
      hotovo: 'Готово',
      misto: 'Місце',
      narozeniny: 'День народження',
      obchod: 'Угода',
      pripominka: 'Нагадування',
      radar: 'Радар можливостей',
      schuzka: 'Зустріч',
      servis: 'Сервісний термін',
      sms: 'SMS',
      telefonat: 'Дзвінок',
      udalost: 'Подія',
      ukol: 'Завдання',
      whatsapp: 'WhatsApp',
    },
    cil: {
      auto: 'Автомобіль',
      budoucnostDeti: 'Майбутнє дітей',
      bydleni: 'Житло',
      investice: 'Інвестиції',
      nezavislost: 'Фінансова незалежність',
      obecny: 'Ціль',
      ostatni: 'Інші цілі',
      podnikani: 'Бізнес',
      podnikatelskyUver: 'Бізнес-кредит',
      rekonstrukce: 'Ремонт',
      rezerva: 'Резерв',
      spotrebitelskyUver: 'Споживчий кредит',
      uver: 'Кредит',
    },
    produkt: {
      analyza: 'Аналіз',
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      jine: 'Інше',
      penzijko: 'Пенсійні заощадження',
      pojisteni_auta: 'Автострахування',
      pojisteni_majetek: 'Страхування майна',
      pojisteni_odpovednost: 'Страхування відповідальності',
      pojisteni_ostatni: 'Інше страхування',
      pojisteni_zivot: 'Страхування життя',
      rezerva: 'Резерв',
      stavebni: 'Будівельне накопичення',
      uver: 'Кредит',
      zdravotni: 'Медичне страхування',
    },
    profil: {
      dynamicky: 'Динамічний',
      konzervativni: 'Консервативний',
      vyvazeny: 'Збалансований',
    },
    riziko: {
      dite: 'Страхування дитини',
      hospitalizace: 'Госпіталізація',
      invalidita: 'Інвалідність',
      odskodne: 'Щоденна компенсація за травму',
      pn: 'Тимчасова непрацездатність',
      rodicovska: 'Відпустка по догляду за дитиною',
      smrt: 'Смерть',
      stari: 'Старість',
      tnu: 'Стійкі наслідки травми',
      zavazne: 'Тяжкі захворювання',
    },
    stav: {
      chyba: 'Помилка',
      info: 'Інформація',
      ok: 'Усе гаразд',
      pozor: 'Увага',
    },
  },
  /* BLOK:ikony END */
  /* BLOK:vzorkovna START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzorkovna: {
    ikony: {
      doplnky: 'Додаткові малюнки',
      doplnkyPopis: 'Те, чого немає в lucide. Узято разом з ліцензією.',
      mena: 'Валюта за країною тенанта',
      velikosti: 'Розмір і вибраний стан',
      vybrany: 'Вибрано',
    },
    motivNahledu: 'Перегляд у темі',
    motivy: {
      kino: 'Екран презентації',
      popis: 'Огляд цілей і резерву',
      titulek: 'Фінансовий план',
      tlacitko: 'Зберегти',
    },
    nadpis: 'Зразки стилю',
    obsah: 'Зміст',
    pismo: {
      cisla: 'Числа в стовпчик',
      jazyky: 'П’ять мов, один шрифт',
      nadpisUkazka: 'Фінансовий план домогосподарства',
      nadpisy: 'Заголовки',
      stupnice: 'Шкала розмірів',
      ukazka: 'Резерв покриває шість місяців витрат домогосподарства.',
    },
    prazdny: {
      akce: 'Запланувати зустріч',
      kratky: 'Поки що немає завдань.',
      text: 'На сьогодні у вас немає запланованих зустрічей.',
    },
    sekce: {
      ikony: 'Іконки в чипах',
      motivy: 'Шість тем',
      pismo: 'Шрифт',
      prazdny: 'Порожній стан',
      stavy: 'Стани',
      tokeny: 'Кольори',
      vystup: 'Вихідний набір',
    },
    skupina: {
      aktivity: 'Активності',
      cile: 'Цілі',
      produkty: 'Продукти',
      profily: 'Інвестиційний профіль',
      rizika: 'Ризики',
      stavy: 'Стани',
    },
    stavy: {
      bezTextu: 'Без тексту',
      chyba: 'Не вдалося зберегти зміни',
      ikona: 'Іконка',
      info: 'Дані з минулої зустрічі',
      ok: 'Резерв покриває 6 місяців витрат',
      pozor: 'Бракує покриття інвалідності',
      stitek: 'Мітка',
      tecka: 'Крапка',
    },
    stitek: 'Design lab · внутрішній перегляд',
    tokeny: {
      akcent: 'Акцент',
      kategorie: 'Категорії',
      plochy: 'Поверхні',
      stavy: 'Стани',
      text: 'Текст',
    },
    uvod: 'Шрифт, кольори, іконки та стани в одному місці. Екрани беруть лише те, що є тут.',
    zpet: 'Назад',
  },
  /* BLOK:vzorkovna END */
  /* BLOK:novyCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  novyCrm: {
    akce: {
      otevrit: 'Відкрити: {nazev}',
      otevritVAppce: 'Відкрити в поточній CRM',
      vPrototypu: 'У прототипі поки недоступно',
      zkusitZnovu: 'Спробувати знову',
      zobrazitDalsi: 'Показати ще {n}',
      zrusitFiltr: 'Скинути фільтр',
    },
    aktivita: {
      dopis: 'Лист',
      email: 'E-mail',
      schuzka: 'Зустріч',
      telefonat: 'Дзвінок',
      udalost: 'Подія',
      ukol: 'Завдання',
    },
    analyza: {
      bezAnalyzy: 'Аналізу ще немає. Створіть його в поточному застосунку — тут він потім з’явиться повністю.',
      chybaBloku: 'Цю частину аналізу не вдалося розрахувати',
      chybi: {
        cil: 'Ціль «{nazev}»: доповніть {co}',
        dalsiNaRade: 'на черзі',
        dalsichFew: 'і ще {n} у застосунку',
        dalsichMany: 'і ще {n} у застосунку',
        dalsichOne: 'і ще {n} у застосунку',
        deti: 'Рядок дитини без імені та дати народження не враховується',
        faze: 'Частини аналізу',
        fazeSouhrn: 'Готово {n} з {celkem} частин аналізу',
        hotovo: 'Аналіз заповнено, нічого не бракує',
        nadpis: 'Що бракує заповнити',
        nezbytne: 'Необхідні витрати — без них немає розподілу 50 / 30 / 20 і потреби захисту',
        partner: 'Дохід партнера заповнено, але партнера в аналізі немає (бракує імені або дати народження)',
        rezerva: 'Рахунки і готівка — без них не можна розрахувати резерв',
        zadnaPolozka: 'Конкретних даних не бракує — завершіть решту частин аналізу',
        zajisteni: 'Захист доходу не можна розрахувати — бракує: {co}',
        zavaznost: {
          nizka: 'Дрібниця',
          stredni: 'Доповнити',
          vysoka: 'Важливо',
        },
      },
      chybiUdajuFew: 'Бракує {n} пунктів',
      chybiUdajuMany: 'Бракує {n} пунктів',
      chybiUdajuOne: 'Бракує {n} пункту',
      cile: {
        chybi: 'бракує: {co}',
        mesicne: '{mena}/міс.',
        pocetFew: '{n} цілі за терміном',
        pocetMany: '{n} цілей за терміном',
        pocetOne: '{n} ціль за терміном',
        uverem: 'у кредит',
      },
      doplnitVAppce: 'Доповнити в застосунку',
      faze: {
        cile: 'Цілі',
        hodnoty: 'Цінності',
        prijmy: 'Доходи і витрати',
        rizika: 'Ризики',
        uvod: 'Вступ',
        zavazky: 'Зобов’язання',
        zdroje: 'Джерела',
      },
      majetek: {
        budouci: 'Спадщина і майбутнє майно',
        budouciStitek: 'у майбутньому · поки не враховується',
        cisteJmeni: 'чисті активи (майно сьогодні − борги)',
        dluhy: 'борги (залишки)',
        dnes: 'майно сьогодні',
        dsti: 'платежі становлять {pct} % доходу',
        fixace: 'найближча фіксація {datum}',
        nadpis: 'Майно і борги',
        prazdno: 'Майно і борги ще не записані',
        splatky: 'платежі {castka} на місяць',
        uveruFew: '{n} кредити',
        uveruMany: '{n} кредитів',
        uveruOne: '{n} кредит',
        vysokeZadluzeni: 'Високе боргове навантаження (понад 40 % доходу)',
      },
      menaJina: 'Аналіз ведеться в {mena}',
      menaStara: 'Старіший аналіз без валюти — суми в {mena}',
      nadpis: 'Аналіз',
      penize: {
        chybiDo20: 'До ідеалу 20 % бракує {castka} на місяць',
        nadpis: 'Доходи і витрати',
        odklada: 'Відкладає {pct} % доходу · ідеал 20 % = {castka}',
        rozpadBezNezbytnych: 'Розподіл 50 / 30 / 20 з’явиться, коли будуть вказані необхідні витрати.',
        splneno: 'Відкладає ідеальні 20 % доходу і більше',
      },
      rezerva: {
        bezVydaju: 'Без необхідних витрат не можна розрахувати, на скільки місяців вистачить резерву',
        castkaPopisek: 'на рахунках і готівкою',
        dnes: 'Резерв сьогодні',
        doporuceno: 'Рекомендовано {n} місяців',
        grafPopis: 'Резерву вистачить на {n} місяців із рекомендованих {cil}',
        jednotka: 'міс.',
        mesicuPopisek: 'на стільки місяців необхідних витрат і платежів вистачить',
        nadpis: 'Резерв',
        nezapsana: 'Рахунки і готівку ще не записано',
        stav: {
          reserve_low: 'Менше 3 місяців',
          reserve_mid: 'Поповнити до 6 місяців',
          reserve_ok: 'Щонайменше 6 місяців',
        },
      },
      rodina: {
        bezDeti: 'без дітей',
        detiFew: '{n} дитини',
        detiMany: '{n} дітей',
        detiOne: '{n} дитина',
        dospelychFew: '{n} дорослих',
        dospelychMany: '{n} дорослих',
        dospelychOne: '{n} дорослий',
        nadpis: 'Родина і профіль',
        prazdno: 'Родину в аналізі ще не заповнено',
        prijem: 'дохід {castka} на місяць',
        vekNezadany: 'вік не вказано',
      },
      upraveno: 'Оновлено {datum}',
      upravitVAppce: 'Змінити в застосунку',
      zacit: 'Почати аналіз у застосунку',
      zajisteni: {
        bezDiry: 'Місячний дохід покрито',
        dira: 'Щомісяця бракує {castka}',
        domacnost: 'Покриття за домогосподарство',
        mesicne: 'У разі інвалідності: родині потрібно {potreba} на місяць · залишиться {zustane} · держава дасть {stat}',
      },
      zpetNaKlienta: 'Назад до клієнта',
    },
    cas: {
      dnes: 'сьогодні',
      predFew: '{n} дні тому',
      predMany: '{n} днів тому',
      predOne: '{n} день тому',
      vcera: 'вчора',
    },
    cesta: {
      hotovo: 'виконано',
      krokZ: '{n} з {celkem}',
      kroky: {
        analyza: 'Аналіз',
        plan: 'План',
        predstaveni: 'Знайомство',
        realizace: 'Реалізація',
        servis: 'Обслуговування',
      },
      nadpis: 'Шлях клієнта',
      vseHotovo: 'Усі кроки виконано',
      ziskani: 'Залучення · до першої зустрічі',
      ztraceno: 'Втрачено',
    },
    chyba: {
      aktivity: 'Не вдалося завантажити нотатки й завдання',
      analyza: 'Не вдалося завантажити аналіз',
      analyzaTvar: 'Дані аналізу мають неочікуваний формат',
      cile: 'Не вдалося завантажити план',
      fixace: 'Не вдалося завантажити фіксації',
      klient: 'Не вдалося завантажити клієнта',
      klienti: 'Не вдалося завантажити клієнтів',
      obchody: 'Не вдалося завантажити угоди',
      obecne: 'Не вдалося завантажити дані',
      pipeline: 'Не вдалося завантажити підсумок угод',
      plan: 'Пропозицію рішення не вдалося завантажити',
      radar: 'Не вдалося завантажити радар можливостей',
      rizika: 'Не вдалося розрахувати потребу в покритті',
      ukoly: 'Не вдалося завантажити щоденник',
    },
    diar: {
      aDalsichFew: 'і ще {n}',
      aDalsichMany: 'і ще {n}',
      aDalsichOne: 'і ще {n}',
      agenda: 'Порядок дня',
      akciFew: '{n} активності',
      akciMany: '{n} активностей',
      akciOne: '{n} активність',
      bezCasu: 'Без часу',
      celyDen: 'увесь день',
      dalsiTyden: 'Наступний тиждень',
      drive: 'Раніше',
      drivePocet: 'Раніше: {n}',
      hodiny: 'Години дня',
      hotovo: 'виконано',
      minut: '{n} хв',
      naDnes: 'Сьогодні',
      naplanovat: 'Запланувати в щоденнику',
      nejblizsi: 'найближче',
      nicPoTerminu: 'Нічого не прострочено',
      odskrtnout: 'Позначити як виконане',
      otevrit: 'Відкрити в щоденнику',
      otevritPolozku: 'Відкрити в щоденнику',
      poTerminu: 'Прострочено',
      poTerminuPocetFew: '{n} прострочено',
      poTerminuPocetMany: '{n} прострочено',
      poTerminuPocetOne: '{n} прострочено',
      pozdeji: 'Пізніше',
      pozdejiPocet: 'Пізніше: {n}',
      prazdnoDen: 'На цей день нічого не заплановано',
      prazdnoDnes: 'Сьогодні нічого не заплановано',
      predchoziTyden: 'Попередній тиждень',
      schuzekFew: '{n} зустрічі',
      schuzekMany: '{n} зустрічей',
      schuzekOne: '{n} зустріч',
      souhrn: 'Підсумок дня',
      souhrnPoTerminu: 'прострочено за всі дні',
      souhrnSchuzky: 'зустрічі',
      souhrnUkoly: 'завдання, дзвінки й e-maily',
      tyden: 'Тиждень',
      typ: {
        dopis: 'Лист',
        email: 'E-mail',
        poznamka: 'Нотатка',
        schuzka: 'Зустріч',
        telefonat: 'Дзвінок',
        udalost: 'Подія',
        ukol: 'Завдання',
      },
      ukoluFew: '{n} завдання',
      ukoluMany: '{n} завдань',
      ukoluOne: '{n} завдання',
    },
    faze: {
      a1: 'Знайомство',
      a2: 'Аналіз',
      calling: 'Дзвінки',
      done: 'Завершено',
      lead: 'Лід',
      lost: 'Втрачено',
      p1: 'Фінансовий план',
      p2: 'Презентація',
      servis: 'Обслуговування',
      signed: 'Підписано',
    },
    fazeObchodu: {
      analyza: 'Аналіз',
      cerpani: 'Виплата',
      podpis: 'Підписання',
      proces: 'У процесі',
    },
    graf: {
      oblouk: {
        nastavit: 'Встановити план у застосунку',
        nenastaveno: 'План не встановлено',
        popisek: 'Виконання плану BJ',
        zPlanu: '{bj} з {plan} BJ',
      },
      rozpad: {
        cile: 'Цілі',
        nezbytne: 'Необхідне',
        zivotniStyl: 'Спосіб життя',
      },
      trychtyr: {
        popis: 'Відкриті угоди за етапами',
      },
    },
    hlavicka: {
      hledat: 'Шукати клієнта ({zkratka})',
    },
    klient: {
      aktivity: {
        bezDalsiho: 'Наступний крок не заплановано',
        dalsiKrok: 'Наступний крок',
        diar: 'Відкрити щоденник',
        nadpis: 'Нотатки й наступний крок',
        naplanovat: 'Запланувати в щоденнику',
        napsat: 'Написати нотатку',
        posledni: 'Останні активності',
        zadne: 'Поки жодних нотаток чи активностей',
      },
      analyza: 'Аналіз',
      bezAnalyzy: 'Аналізу ще немає. Баланс, цілі та майно з’являться, щойно його заповните.',
      bezUdaju: 'Вік і місто не вказані',
      bilance: 'Баланс',
      bilancePrazdna: 'Доходи й витрати ще не заповнені',
      cile: {
        bezCastkyFew: '{n} цілі без суми',
        bezCastkyMany: '{n} цілей без суми',
        bezCastkyOne: '{n} ціль без суми',
        bezNazvu: 'Ціль без назви',
        bezTerminu: 'без терміну',
        chybi: 'Бракує',
        cil: 'Ціль',
        cilKlienta: 'ціль {castka}',
        dalsichFew: 'і ще {n} цілі у пропозиції',
        dalsichMany: 'і ще {n} цілей у пропозиції',
        dalsichOne: 'і ще {n} ціль у пропозиції',
        definice: 'Уже має = сьогоднішні гроші на дату цілі.',
        dnes: 'одразу',
        grafPopis: '{nazev}: уже має {uzMa} з {cil}',
        jenBezCastkyFew: 'Цілі ще не мають суми ({n})',
        jenBezCastkyMany: 'Цілі ще не мають суми ({n})',
        jenBezCastkyOne: 'Ціль ще не має суми ({n})',
        nadpis: 'Цілі',
        prazdno: 'Цілі ще не вказані',
        regulace: 'Орієнтовний огляд за планом, не пропозиція.',
        renta: 'рента {castka} на місяць',
        uverem: 'власні кошти до кредиту',
        uzMa: 'Уже має',
        vlastniZdroje: 'Власні кошти',
        zaFew: 'через {n} роки',
        zaMany: 'через {n} років',
        zaOne: 'через {n} рік',
      },
      doplnitVAnalyze: 'Доповнити в аналізі',
      kategorie: 'Категорія {k}',
      kontaktNezadany: 'Телефон і e-mail не вказані',
      krok: {
        analyza: 'Аналіз',
        navrh: 'Пропозиція рішення',
        plan: 'План',
        prezentace: 'Презентація',
      },
      majetek: {
        celkem: 'усього',
        dluhy: 'Борги: {castka}',
        grafPopis: 'Майно усього {celkem}: {dily}',
        kategorie: {
          firma: 'Бізнес',
          kzp: 'Страхування життя з накопиченням',
          nemovitosti: 'Нерухомість і авто',
          opf: 'Фонди й акції',
          ostatni: 'Інше',
          penzijko: 'Пенсійні заощадження',
          stavebko: 'Будівельні заощадження',
          ucty: 'Рахунки й готівка',
        },
        nadpis: 'Майно',
        prazdno: 'Майно ще не записане',
      },
      nadpis: 'Клієнт',
      napsat: 'Написати e-mail: {email}',
      nenalezen: 'Цього клієнта в CRM немає — можливо, його видалено.',
      neuplnaData: 'Частина даних аналізу має неочікуваний формат',
      obchody: {
        bezBj: 'BJ не вказано',
        nadpis: 'Угоди клієнта',
        novy: 'Нова угода в застосунку',
        prazdno: 'Клієнт не має відкритої угоди',
        vsechny: 'Усі угоди',
      },
      otevritAnalyzu: 'Відкрити аналіз',
      otevritNavrh: 'Відкрити пропозицію рішення',
      otevritPlan: 'Відкрити план',
      pokracovat: 'Продовжити: {krok}',
      prijmy: 'доходи на місяць',
      profil: 'Профіль',
      regulace: 'Орієнтовний огляд з аналізу, не пропозиція.',
      rizika: {
        chybi: {
          horizont: 'строк захисту',
          pozustalostni: 'виплати для близьких',
          prijem: 'дохід',
          vydaje: 'необхідні витрати',
        },
        chybiCastka: 'до рекомендованого покриття бракує {castka}',
        domacnost: 'домогосподарство',
        grafPopis: '{riziko}, {kdo}: чинні договори {kryti} з рекомендованого покриття {potreba}',
        invalidita: 'Інвалідність',
        klient1: 'Клієнт',
        klient2: 'Партнер',
        kryti: 'Чинні договори',
        krytiSpolecne: 'договір без особи — в аналізі в розділі Ризики в договорах виберіть, чий він',
        model: 'Рекомендоване покриття розрахував калькулятор аналізу (капітальний метод) — модель, не пропозиція. План показує страхові суми варіанта, обраного в Пропозиції, тому вони можуть відрізнятися.',
        nadpis: 'Захист доходу',
        nelzeSpocitat: 'Потребу в покритті поки не можна розрахувати. Бракує: {co}.',
        pokryto: 'покрито',
        potreba: 'Рекомендоване покриття',
        prazdno: 'Потреби в покритті й чинних договорів в аналізі ще немає',
        radek: 'Рекомендоване покриття {potreba} · чинні договори {kryti}',
        smrt: 'Смерть',
      },
      splatky: 'платежі за кредитами на місяць',
      vekFew: '{n} роки',
      vekMany: '{n} років',
      vekOne: '{n} рік',
      volneCf: 'вільний грошовий потік на місяць',
      vydaje: 'витрати на місяць',
      zacitAnalyzu: 'Почати аналіз',
      zavolat: 'Зателефонувати: {cislo}',
      zpet: 'Назад до клієнтів',
    },
    klienti: {
      bezJmena: 'Без імені',
      filtr: {
        faze: 'Етап',
        kategorie: 'Категорія',
        produkt: 'Продукт',
        vse: 'Усі',
      },
      hledat: 'Шукати ім’я, телефон, e-mail…',
      hledatPopisek: 'Шукати клієнта',
      kpi: {
        bezKontaktu: 'Без контакту 90+ днів',
        celkem: 'Усього',
        podepsano: 'Підписано цього місяця',
        skupina: 'Швидкі фільтри',
        vBehu: 'У роботі',
      },
      nalezenoFew: 'Знайдено {n} клієнти',
      nalezenoMany: 'Знайдено {n} клієнтів',
      nalezenoOne: 'Знайдено {n} клієнта',
      odebratFiltr: 'Скасувати фільтр: {nazev}',
      odhad: 'оцінка',
      otevrit: 'Відкрити клієнта: {jmeno}',
      popis: 'Список клієнтів',
      prazdno: 'Поки що немає клієнтів',
      pridat: 'Додати в застосунку',
      seznam: 'Усі клієнти',
      skupina: {
        klient: 'Клієнт',
        proces: 'У процесі',
        ziskani: 'Залучення',
        ztraceno: 'Втрачено',
      },
      sloupec: {
        akce: 'Відкрити',
        bj: 'BJ',
        dalsiKrok: 'Наступний крок',
        faze: 'Етап',
        klient: 'Клієнт',
        kontakt: 'Останній контакт',
        produkty: 'Продукти',
      },
      vymazat: 'Очистити пошук',
      zrusitVse: 'Скинути все',
    },
    legendaObchodu: {
      plna: 'Виплачується',
      srafa: 'У роботі',
      tecky: 'Інтерес',
    },
    nastroje: {
      cekani: {
        cenaPopisek: 'на стільки менше матиме в цілі, якщо почне на {roky} пізніше',
        dohnat: 'Щоб наздогнати, треба відкладати',
        grafPopis: 'Модель: якщо почне одразу, через {roky} матиме {hned}; якщо зачекає — {pozdeji}.',
        hned: 'Почне одразу',
        horizont: 'Ціль через',
        legendaModel: 'Пунктиром = модельний розрахунок',
        letFew: '{n} роки',
        letMany: '{n} років',
        letOne: '{n} рік',
        mesicne: 'Щомісяця інвестує',
        mesicnePole: 'Щомісячна сума',
        model: 'Модель за сталої дохідності {pct} % на рік, без комісій і податків — не гарантія. За дохідності {od}–{do} % ціна становить {nizsi} – {vyssi}.',
        nadpis: 'Ціна очікування',
        neplatne: 'Відкладення має бути коротшим за строк до цілі.',
        neposlano: 'Невнесені внески',
        nominalne: 'Номінальні суми, без урахування інфляції',
        odklad: 'Почне пізніше на',
        otazka: 'Скільки коштує клієнту зачекати з регулярним інвестуванням?',
        pasmo: 'Діапазон: дохідність {od}–{do} %',
        pozdeji: 'Почне через {roky}',
        ukazka: 'Приклад',
        uslyVynos: 'Втрачена дохідність',
        vynos: 'Очікувана дохідність',
        vynosText: '{pct} % на рік',
        zaLetFew: 'через {n} роки',
        zaLetMany: 'через {n} років',
        zaLetOne: 'через {n} рік',
        zaMesic: 'щомісяця',
      },
      dlazdice: {
        finMatematika: {
          nazev: 'Фінансова математика',
          popis: 'Кредит, інвестиція й рента — обчислить будь-яке значення.',
        },
        funnely: {
          nazev: 'Бібліотека воронок',
          popis: 'Готові воронки й конструктор завдання.',
        },
        historicka: {
          nazev: 'Історичний калькулятор',
          popis: 'Як зростали б гроші клієнта на реальних ринках з 1926 року.',
        },
        hypoteky: {
          nazev: 'Іпотеки',
          popis: 'Іпотеки в роботі в одному місці.',
        },
        investicniStrategie: {
          nazev: 'Інвестиційні стратегії',
          popis: 'Відомі стратегії та сила складних відсотків.',
        },
        investicniStudio: {
          nazev: 'Інвестиційна студія',
          popis: 'Портфель сьогодні й після пропозиції, кризи та витрати.',
        },
        kalkulacky: {
          nazev: 'Калькулятори',
          popis: 'Іпотека, інвестиції та інші швидкі розрахунки.',
        },
        mapa: {
          nazev: 'Мапа клієнтів',
          popis: 'Клієнти на мапі й дорога на зустріч.',
        },
        penze: {
          nazev: 'Пенсійний калькулятор',
          popis: 'Скільки клієнт накопичить на пенсію і скільки додасть держава.',
        },
        provize: {
          nazev: 'Комісія',
          popis: 'Скільки BJ і грошей принесе угода.',
        },
        radar: {
          nazev: 'Радар можливостей',
          popis: 'Клієнти з прогалиною в захисті чи фінансах.',
        },
      },
      novyStyl: 'Калькулятор у новому стилі',
      proMe: 'Для мене',
      uStolu: 'Для клієнта за столом',
    },
    nav: {
      diar: 'Щоденник',
      hlavni: 'Навігація нової CRM',
      klienti: 'Клієнти',
      nastroje: 'Інструменти',
      obchody: 'Угоди',
      poradce: 'Увійшов консультант: {jmeno}',
      prehled: 'Огляд',
      preskocit: 'Перейти до вмісту',
      rezimSvetly: 'Увімкнути світлий режим',
      rezimTmavy: 'Увімкнути темний режим',
      znacka: 'Нова CRM – огляд',
      zpet: 'Назад до поточної CRM',
      zpetKratce: 'Назад до CRM',
    },
    nazev: 'Нова CRM',
    nenalezeno: {
      akce: 'Назад до огляду',
      nadpis: 'Сторінку не знайдено',
      text: 'Такої адреси в новій CRM немає.',
    },
    obchody: {
      bezKlienta: 'Клієнта не вказано',
      bezNazvu: 'Угода без назви',
      dnyFew: '{n} дні на етапі',
      dnyMany: '{n} днів на етапі',
      dnyOne: '{n} день на етапі',
      dnyZkratka: '{n} дн.',
      fazeVyber: 'Етап угоди',
      kpi: {
        bjVBehu: 'BJ у роботі',
        cekaPodpis: 'Очікує підпису',
        pocetFew: '{n} угоди',
        pocetMany: '{n} угод',
        pocetOne: '{n} угода',
        uzavreno: 'Закрито цього місяця',
      },
      nicVeFazi: 'Нічого на цьому етапі',
      novy: 'Нова угода в застосунку',
      otevrit: 'Відкрити угоду: {nazev}',
      prazdno: 'Поки що немає угод у роботі',
      trychtyr: 'Угоди за етапами',
    },
    plan: {
      bezAnalyzy: 'Аналізу ще немає. План виникне лише з аналізу.',
      bezNavrhu: 'Пропозицію рішення ще не збережено. Щойно збережете її в застосунку, з’явиться тут.',
      chybaBloku: 'Цю частину плану не вдалося обчислити',
      chybaVypoctu: 'План не вдалося обчислити',
      cile: {
        bezCastky: 'Суму цілі не задано — досягнення не можна обчислити',
        bezHorizontu: 'Строк цілі не задано — досягнення не можна обчислити',
        chybi: 'бракує {castka}',
        dalsichFew: 'і ще {n} цілі у пропозиції',
        dalsichMany: 'і ще {n} цілей у пропозиції',
        dalsichOne: 'і ще {n} ціль у пропозиції',
        dnes: 'сьогодні {pct}',
        grafPopis: '{nazev}: сьогодні {dnes}, з планом {po} від цілі {cil}',
        jednorazove: '{castka} одноразово',
        legendaChybi: 'бракує і з планом',
        legendaMa: 'має вже сьогодні',
        legendaPlan: 'додасть план',
        mesicne: '{castka} щомісяця',
        nadpis: 'Досягнення цілей',
        prazdno: 'У пропозиції ще немає цілей',
        prepocetProfil: 'Власний профіль цілі — досягнення з ним порахує Пропозиція',
        prepocetRucni: 'Ручна місячна сума — досягнення з нею порахує Пропозиція',
        sPlanem: 'з планом {pct}',
        souhrn: 'З планом досягнуто: {n} з {m}',
        splneno: 'з планом досягнуто',
        vlastniZdroje: 'з них власні кошти {castka}',
        zAnalyzy: 'змінено в Пропозиції · з аналізу {castka} · {termin}',
      },
      kroky: {
        chybi: {
          majetkove: 'Страхування майна — у пропозиції заповніть і збережіть картку Страхування майна',
          rezerva: 'Резерв — в аналізі бракує необхідних витрат, без них ціль резерву не виникне',
          zivotni: 'Страхування життя — без доходів і витрат в аналізі не можна обчислити страхові суми',
        },
        chybiTitulek: 'Кроки, для яких бракує даних:',
        hotovo: 'Готово',
        naRade: 'Наступний',
        nadpis: 'Найближчі кроки реалізації',
        prazdno: 'План ще не має кроків реалізації',
      },
      majetek: {
        grafPopis: 'Накопичено на цілі за планом, у сьогоднішніх цінах: найбільше {castka} у {rok} році. Модель, не гарантія.',
        legenda: 'точки й пунктир = модель за планом',
        model: 'Сума накопиченого на цілі за планом при {vynos} дохідності, у сьогоднішніх цінах (дохідність уже після інфляції) — модель, не гарантія, дохідність не гарантована. Коли ціль настає, гроші витрачаються і крива падає.',
        nadpis: 'Розвиток майна в часі',
        nula: 'За планом на цілі зі строком поки нічого не накопичується',
        prazdno: 'План ще не має цілей зі строком',
        rada: 'Накопичено на цілі',
        rokVek: '{rok} · {vek}',
        vrchol: 'Найбільше {castka} у {rok} році',
      },
      nadpis: 'План',
      navrh: 'Пропозиція рішення',
      ochrana: {
        bezCastek: 'Страхові суми поки не можна обчислити — бракує доходів або витрат',
        castky: 'інвалідність {invalidita} · смерть {smrt}',
        cenaDoplni: 'щомісяця за домогосподарство — ціну додасть консультант',
        cenaNeznama: 'Ціна захисту ще невідома',
        cenaNula: 'Ціна від консультанта 0 — з надлишку нічого не віднімається',
        cenaPoradce: 'щомісяця за домогосподарство, ціна від консультанта',
        cenaPoradceCast: 'щомісяця, ціна від консультанта — поки лише частина ціни',
        nadpis: 'Захист родини',
        odhadOrientacne: '≈ {castka} щомісяця — лише орієнтовна оцінка',
        odmitnuto: 'Клієнт поки не хоче захисту доходу',
        rozdil: 'Зараз платить {stara} → нова {nova} ({rozdil}). Старий договір скасовується, план віднімає лише різницю.',
        rucne: 'змінено консультантом',
        staraNeznama: 'У договору, що скасовується, бракує платежу — у різниці його ще не віднято.',
        varianta: 'Варіант покриття в пропозиції',
        zdroj: 'Страхові суми варіанта {varianta} із Пропозиції. Рекомендоване покриття в Аналізі рахує калькулятор аналізу, тому воно може відрізнятися.',
      },
      otevritNavrh: 'Відкрити пропозицію в застосунку',
      prazdnaAnalyza: 'Аналіз порожній — плану немає з чого рахувати.',
      prezentace: 'Презентація',
      profil: 'Профіль: {nazev}',
      regulace: 'Модельний план із пропозиції рішення, не пропозиція продукту. Дохідність не гарантована.',
      rezerva: {
        bezCile: 'Ціль резерву не можна обчислити — бракує витрат',
        dopocetNezbytneFew: 'ціль резерву · {n} місяці необхідних витрат і платежів',
        dopocetNezbytneMany: 'ціль резерву · {n} місяців необхідних витрат і платежів',
        dopocetNezbytneOne: 'ціль резерву · {n} місяць необхідних витрат і платежів',
        dopocetObvykleFew: 'ціль резерву · {n} місяці звичних витрат і платежів',
        dopocetObvykleMany: 'ціль резерву · {n} місяців звичних витрат і платежів',
        dopocetObvykleOne: 'ціль резерву · {n} місяць звичних витрат і платежів',
        jednorazove: 'доповнить одноразово',
        mesicne: 'доповнить щомісяця',
        nadpis: 'Резерв',
        plnaDnes: 'Наповнений уже сьогодні',
        plnaSPlanem: 'З планом наповнений',
        zadana: 'ціль резерву, задана в аналізі',
      },
      rozpocet: {
        cile: 'Цілі',
        jednorazove: 'Із заощаджень одноразово {prideleno} з {celkem}',
        legendaPlan: 'спрямовує план',
        nadPrebytek: 'Додатковий страховий внесок більший за надлишок — бракує {castka} щомісяця',
        nadpis: 'Місячний бюджет плану',
        ochranaNeznama: 'Консультант ще не вказав ціну захисту — план її не враховує',
        ochranaNula: 'Ціна захисту від консультанта 0 — нічого не віднімається',
        ochranaOdmitnuta: 'Клієнт поки не хоче захисту доходу — не віднімається',
        pojistneNove: 'Страховий внесок {nova} — серед обов’язкових платежів',
        pojistneZmena: 'Страховий внесок серед обов’язкових платежів: зараз {stara} → новий {nova} ({rozdil})',
        prebytek: 'місячний надлишок — куди йде',
        prebytekNejisty: 'З доходів, витрат і платежів виходило б {castka} щомісяця — перевірте погоджений надлишок у застосунку.',
        prebytekNezadany: 'Надлишок не задано',
        prebytekNula: 'Надлишок нульовий',
        prebytekPoPojistnem: 'місячний надлишок після страхових внесків — куди йде',
        precerpano: 'План розподіляє більше, ніж становить надлишок',
        renta: 'Інвестиції на ренту',
        rezerva: 'Резерв',
        vyrovnano: 'Усі гроші мають завдання',
        zadneZdroje: 'Плану нема з чого розподіляти — немає ні надлишку, ні вільних заощаджень.',
        zbyva: 'Поки без завдання',
      },
      ulozeno: 'Збережено {datum}',
      vynos: {
        optimisticky: 'Оптимістична дохідність',
        pesimisticky: 'Песимістична дохідність',
        realisticky: 'Реалістична дохідність',
      },
      vynosVeVete: {
        optimisticky: 'оптимістичній',
        pesimisticky: 'песимістичній',
        realisticky: 'реалістичній',
      },
    },
    prehled: {
      dnes: {
        bezCasuFew: '{n} завдання без часу',
        bezCasuMany: '{n} завдань без часу',
        bezCasuOne: '{n} завдання без часу',
        dalsichFew: 'І ще {n} події сьогодні',
        dalsichMany: 'І ще {n} подій сьогодні',
        dalsichOne: 'І ще {n} подія сьогодні',
        nadpis: 'Сьогодні',
        nejblizsiCas: 'Найближча подія о {cas}',
        nejblizsiNadpis: 'Найближче в щоденнику',
        nicDnes: 'Сьогодні в щоденнику більше нічого немає',
        otevritDiar: 'Відкрити щоденник',
        poTerminuFew: '{n} прострочено',
        poTerminuMany: '{n} прострочено',
        poTerminuOne: '{n} прострочено',
        seznam: 'Інші події сьогодні',
      },
      klienti: {
        nadpis: 'Останні клієнти',
      },
      obchody: {
        bjVBehu: 'BJ у роботі загалом',
        nadpis: 'Угоди в роботі',
        prazdno: 'Немає угод у роботі',
      },
      pece: {
        bezKontaktu: 'Без контакту',
        dalsichFew: 'і ще {n}',
        dalsichMany: 'і ще {n}',
        dalsichOne: 'і ще {n}',
        dniFew: '{n} дні',
        dniMany: '{n} днів',
        dniOne: '{n} день',
        fixace: 'Кінець фіксації',
        konecSmlouvy: 'Кінець договору',
        nadpis: 'Клієнти, які потребують уваги',
        prazdno: 'Жодної фіксації протягом 120 днів і нікого без контакту понад 90 днів',
        vyroci: 'Річниця договору',
      },
      plan: {
        nadpis: 'План місяця',
      },
      provize: {
        bezPozice: 'Посаду не задано',
        koef: '{koef} {mena} за BJ · посада {pozice}',
        koefVychozi: '{koef} {mena} за BJ (за замовчуванням)',
        nadpis: 'Орієнтовна комісія',
      },
      radar: {
        dalsiMezeryFew: '+{n} ще прогалини',
        dalsiMezeryMany: '+{n} ще прогалин',
        dalsiMezeryOne: '+{n} ще прогалина',
        dalsichKlientuFew: 'і ще {n} клієнти з прогалиною',
        dalsichKlientuMany: 'і ще {n} клієнтів із прогалиною',
        dalsichKlientuOne: 'і ще {n} клієнт із прогалиною',
        kriticka: 'Критична прогалина',
        krok: 'Рекомендований крок',
        nadpis: 'Радар можливостей',
        otevrit: 'Відкрити радар у поточній CRM',
        prazdno: 'Немає відкритих можливостей',
        skore: 'бал {n}',
      },
    },
    produkt: {
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      majetek: 'Майно',
      penze: 'Пенсія',
      uver: 'Кредит',
      zp: 'Страхування життя',
    },
    produktObchodu: {
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      jine: 'Інше',
      koupe_nemovitosti: 'Купівля нерухомості',
      penzijko: 'Пенсійні заощадження',
      podnikatelsky_uver: 'Бізнес-кредит',
      pojisteni_auta: 'Автострахування',
      pojisteni_majetek: 'Страхування майна',
      pojisteni_zivot: 'Страхування життя',
      prodej_nemovitosti: 'Продаж нерухомості',
      refinancovani: 'Рефінансування',
      spotrebitelsky_uver: 'Споживчий кредит',
      stavebni: 'Будівельні заощадження',
      uver: 'Кредит',
    },
    prototyp: 'Прототип · лише перегляд',
    pruvodce: {
      nadpis: 'Це чернетка нової CRM',
      rozumim: 'Зрозуміло',
      text: 'Дані справжні, лише для перегляду. Вигляд і порядок екранів ще можуть змінитися.',
      zapis: 'Редагувати й записувати можна й надалі в поточній CRM.',
    },
    stav: {
      fazeNezadana: 'Етап не вказано',
      nacitam: 'Завантаження…',
      nezadano: 'не вказано',
      nicNeodpovida: 'Фільтру нічого не відповідає',
      prazdno: 'Тут поки нічого немає',
      starsiData: 'Старіші дані · {cas}',
    },
    termin: {
      dnes: 'сьогодні',
      poFew: 'прострочено на {n} дні',
      poMany: 'прострочено на {n} днів',
      poOne: 'прострочено на {n} день',
      zaFew: 'через {n} дні',
      zaMany: 'через {n} днів',
      zaOne: 'через {n} день',
      zitra: 'завтра',
    },
    zalozky: {
      analyza: 'Аналіз',
      klient: 'Клієнт',
      nadpis: 'Розділи клієнта',
      plan: 'План',
      prezentace: 'Презентація',
      vAppce: 'відкриє поточну CRM',
    },
    zastupny: {
      nadpis: 'Екран готується',
      text: 'Ця частина нової CRM ще в розробці. Поки що вона є в поточній CRM.',
    },
  },
  /* BLOK:novyCrm END */
  /* BLOK:vystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  vystup: {
    bullet: {
      aria: {
        chybi: '{popisek}: потреба {potreba}, покрито {kryto}, бракує {chybi}.',
        kryto: '{popisek}: потреба {potreba}, покрито {kryto}. Повністю покрито.',
        nezadano: '{popisek}: потребу не вказано.',
        neznameKryti: '{popisek}: потреба {potreba}, укладене покриття не вказано.',
      },
      chybi: 'Бракує {castka}',
      krytiNezadane: 'Покриття не вказано',
      kryto: 'Покрито',
      nadRamec: 'Покрито, понад {castka}',
      potreba: 'Потреба {castka}',
      potrebaNezadana: 'Потребу не вказано',
      sjednano: 'Укладено {castka}',
      stat: 'Держава {castka}',
    },
    cara: {
      aria: 'Прогноз на {roky}: середній сценарій {stred}, діапазон від {od} до {do}.',
      ariaSrovnani: 'Для порівняння {popisek}: {hodnota}.',
      pasmo: 'Гірший — кращий сценарій',
      prazdno: 'Прогноз не вказано',
      stred: 'Середній сценарій',
    },
    kobliha: {
      aria: 'Розподіл {celkem}: {dily}.',
      celkem: 'Разом',
      nezadano: 'Без суми: {polozky}',
      ostatni: 'Інше',
      prazdno: 'Немає що розподілити',
    },
    kroky: {
      aktivni: 'ви тут',
      aria: 'Прогрес: крок {n} з {celkem}, {popisek}',
      ceka: 'очікує',
      hotovo: 'виконано',
    },
    letFew: '{n} роки',
    letMany: '{n} років',
    letOne: '{n} рік',
    mesicne: 'щомісяця',
    modelNeniGarance: 'Модель, а не гарантія. Фактичний результат може бути вищим або нижчим.',
    nezadano: 'не вказано',
    rezim: {
      nazev: 'Режим перегляду',
      obrazovka: 'Екран',
      papir: 'Папір',
      prezentace: 'Презентація',
    },
    splatka: {
      aria: 'Платіж {splatka} щомісяця, {roky}. Загалом {celkem}, з них відсотки {urok}.',
      ariaUrokNejdriv: 'Спочатку більша частина платежу йде на відсотки, наприкінці — на основну суму.',
      jistina: 'Основна сума',
      popisek: 'Платіж',
      prazdno: 'Кредит не вказано',
      rok: '{n}-й рік',
      souhrn: 'Загалом заплатите {celkem}, з них відсотки {urok}.',
      urok: 'Відсотки',
    },
    tok: {
      aria: 'Куди йдуть гроші: {toky}.',
      krok: '{z} → {do}: {castka}',
      krokKam: '{z} → {do}: {castka}, {kam}',
      nezadano: 'Без суми: {toky}',
      ostatni: 'Інше',
      prazdno: 'Немає руху грошей',
    },
    ukazka: {
      bullet: 'Потреба vs. укладено',
      cara: 'Прогноз із діапазоном',
      d: {
        akcie: 'Акції',
        analyza: 'Аналіз',
        bezPlanu: 'Без плану',
        deti: 'Інвестиція для дітей',
        dluhopisy: 'Облігації',
        dps: 'додаткове пенсійне накопичення',
        fondy: 'пайові фонди',
        hotovost: 'Готівка',
        hotovostTrida: 'Готівка',
        hypoteka: 'Платіж за іпотекою',
        invalidita: 'Інвалідність',
        jednorazove: 'Разово',
        mesicne: 'Щомісяця',
        nemovitosti: 'Фонди нерухомості',
        nezbytne: 'Необхідні витрати',
        plan: 'План',
        pn: 'Непрацездатність',
        podminkyUveru: '{castka} · {roky} · ставка {sazba}',
        pojisteni: 'Страхування',
        prebytek: 'Щомісячний надлишок',
        predstaveni: 'Знайомство',
        prijem: 'Чистий дохід',
        realizace: 'Реалізація',
        renta: 'Рента',
        rezerva: 'Резерв',
        sPlanem: 'З планом',
        servis: 'Сервіс',
        smrt: 'Смерть',
        sporiciUcet: 'ощадний рахунок',
        stavebko: 'Платіж за кредитом з будівельних заощаджень',
        styl: 'Стиль життя',
        volne: 'Вільні гроші',
        zlato: 'Золото',
      },
      kdeBullet: 'Ризики та резерв у презентації плану',
      kdeCara: 'З планом vs. без плану',
      kdeKobliha: 'Портфель щонайбільше з пʼяти класів',
      kdeKroky: 'Шлях клієнта',
      kdeSplatka: 'Ціль іпотека — замість Історичного калькулятора',
      kdeStavebko: 'Решта цілі як кредит з будівельних заощаджень',
      kdeTok: 'Куди йдуть гроші — разово й щомісяця окремо',
      kdeVelkeCislo: 'Головне число калькулятора або слайда',
      kdeVlozeno: 'Інвестиція для дітей: разово й регулярно, потім виплати',
      kdeVodopad: 'Дохід → витрати → вільні гроші',
      kobliha: 'Кільцева діаграма',
      kroky: 'Індикатор кроків',
      navrh: 'Попередній перегляд для погодження — у плані, презентації та друці поки нічого не замінено.',
      prehrat: 'Відтворити знову',
      splatka: 'Платіж і відсотки',
      tok: 'Рух грошей',
      ucebniCisla: 'Навчальні числа, без клієнта.',
      velkeCislo: 'Велике число',
      vlozeno: 'Вкладено vs. прибуток',
      vodopad: 'Каскадна діаграма',
    },
    vlozeno: {
      aria: 'За {roky} накопичите {hodnota}: вкладено {vlozeno}, прибуток {zhodnoceni}.',
      ariaCerpani: 'Потім {roky} виплат по {castka} щомісяця.',
      cerpani: 'Виплати',
      cerpaniVeta: 'Потім {roky} виплат по {castka} щомісяця',
      pasmo: 'Діапазон сценаріїв',
      pasmoVeta: 'Гірший — кращий сценарій: {od} – {do}',
      popisek: 'За {roky}',
      prazdno: 'Внесок не вказано',
      vlozeno: 'Вкладено',
      zhodnoceni: 'Прибуток',
    },
    vodopad: {
      aria: '{kroky}. Результат {vysledek}.',
      ariaNelze: '{kroky}. Результат неможливо обчислити.',
      nelze: 'Результат неможливо обчислити, бракує: {polozky}',
      vysledek: 'Результат',
    },
    zaMesic: '/ міс.',
  },
  /* BLOK:vystup END */
  /* BLOK:vnRodina START — generuje scratchpad/slovnik.py, ručně needitovat */
  vnRodina: {
    cile: {
      bydleni: {
        akontace: 'Власний внесок {pct} %:',
        akontaceHned: 'Власний внесок потрібен одразу',
        cena: 'Житло за',
        cenaPole: 'Ціна житла',
        doRoku: 'до {rok} року',
        dopocteno: 'платіж розрахований',
        letPole: 'Скільки років ще платити',
        na: 'протягом',
        nadpis: 'Житло',
        odkladatNaAkontaci: 'На власний внесок відкладати щомісяця',
        otazka: 'Сплачуєте кредит чи тільки хочете купити житло?',
        pakSplatka: 'потім платіж приблизно',
        platite: 'Вже зараз платите щомісяця',
        rezimDluh: 'Сплачуємо кредит',
        rezimKoupit: 'Хочемо купити',
        rezimNic: 'Вирішено',
        uver: 'Кредит',
        vyreseno: 'Житло у вас вирішене.',
        za: 'через',
        zaPole: 'Через скільки років хочете купувати',
        zbytekPole: 'Залишок кредиту',
        zbyva: 'Лишилося виплатити',
      },
      deti: {
        bezDeti: 'Без дітей до 23 років.',
        naDiteMesicne: 'на одну дитину на місяць',
        nadpis: 'Діти до 23 років',
        nakladPole: 'Скільки на місяць коштує одна дитина',
        radek: '{n}-а дитина · {mesicu} міс.',
        samostatne: 'Самостійні діти не враховуються: {pocet}',
        stoji: 'До 23 років це коштує',
        zVyplaty: 'Сьогодні із зарплати щомісяця',
      },
      duchod: {
        aria: 'Пенсія: скільки дасть держава і скільки бракує: {radky}',
        ariaRadek: '{kdo}: держава {stat}, бракує {chybi}',
        chybi: 'бракує',
        chybiRadek: 'бракує',
        cilPole: 'Скільки кожен хоче мати на місяць на пенсії',
        naOsobu: 'на місяць на кожного',
        nadpis: 'Пенсія',
        odchodV: 'Вихід на пенсію у віці',
        odkladat: 'відкладати щомісяця',
        rezimAria: 'Як визначити пенсійну ціль',
        rezimCastka: 'Сума',
        rezimStandard: 'Зберегти рівень життя',
        standardText: 'Зберегти нинішній рівень: 80 % теперішнього чистого доходу кожного з вас.',
        stat: 'держава (оцінка)',
        statRadek: 'держава орієнтовно',
        uzVDuchodu: 'вже в пенсійному віці',
        vekPole: 'Вік виходу на пенсію',
      },
      nadpis: 'Цілі родини',
      odkladatCelkem: 'На цілі потрібно відкладати щомісяця',
      odkladatModelove: '(модель, дохідність не є певною)',
      prijemRodiny: 'Дохід родини',
      uvod: 'Житло, діти до 23 років і пенсія.',
    },
    hlavicka: {
      navAria: 'Розділи аналізу',
      podtitul: 'Історія родини: цілі та що їх убезпечить',
      poradce: 'Для консультанта',
      priklad: 'Заповнити приклад',
      promitani: 'Показати клієнту',
      promitaniKonec: 'Завершити показ',
      zpet: 'Назад до Аналізу для в’єтнамців',
    },
    investice: {
      ariaRozdeleni: 'З пакета {balicek} на захист іде {ochrana}, а в інвестиції {investice}.',
      cenaOdPoradce: 'Ціна захисту від консультанта',
      dnesnimaOcima: 'у сьогоднішніх грошах {castka}',
      doInvestic: 'в інвестиції',
      doVeku: 'До віку',
      dopadPoplatku: 'Обидва збори разом зменшують модельну вартість на {castka}.',
      grafAria: 'До {vek} років ви сплатите загалом {zaplaceno}, з них {ochrana} на захист, який не повертається. Модельна вартість інвестицій за {vynos} % становить {hodnota}, у діапазоні від {od} до {do}. Модель, а не обіцянка.',
      hodnotaModel: 'вартість · модель {vynos} %',
      hodnotaPri: 'вартість за {vynos} %',
      hodnotaVeVeku: 'Вартість у {vek} років · модель {vynos} %',
      investuje: 'інвестується',
      naOchranu: 'на захист (не повертається)',
      nadpis: 'Якщо нічого не станеться',
      nakladyNaKonci: 'у {vek} років',
      nakladyNadpis: 'Витрати в часі',
      nakladyPoLetechFew: 'через {n} роки',
      nakladyPoLetechMany: 'через {n} років',
      nakladyPoLetechOne: 'через {n} рік',
      nezadano: 'не введено',
      ochranaPopisek: 'з них на захист {castka}, не повертається',
      pasmo: 'діапазон моделей',
      pasmoOdDo: 'за {od}–{do} %: від {hodnotaOd} до {hodnotaDo}',
      poplatkyDosud: 'збори до того часу',
      poplatkyNadpis: 'Скільки коштують комісії',
      protiCili: 'За вашими цілями на пенсію бракує {potreba} у сьогоднішніх грошах. Модель інвестиції становить {pct} % цієї суми.',
      prubezny: 'Поточний збір',
      prubeznyRadek: '{pct} на рік від залишку інвестиції, загалом за {roky}',
      uvod: 'З пакета оплачується захист, решта інвестується до обраного віку.',
      vekTooltip: '{vek} років',
      vstupni: 'Вступний збір',
      vynos: 'Модельна дохідність на рік',
      zBalicku: 'З пакета {balicek} на місяць:',
      zTohoOchrana: 'з них на захист',
      zaplaceno: 'Сплачено загалом',
      zaplacenoJak: 'увесь пакет {balicek} × 12 місяців × {roky}',
    },
    jednotka: {
      rokFew: 'роки',
      rokMany: 'років',
      rokOne: 'рік',
      vekFew: 'роки',
      vekMany: 'років',
      vekOne: 'рік',
    },
    nav: {
      cile: 'Цілі',
      investice: 'Інвестиції',
      ochrana: 'Захист',
      odkladat: 'Відкладання',
      otazky: 'Питання',
      prijmy: 'Доходи',
      rodina: 'Родина',
      srovnani: 'Порівняння',
      vypadek: 'Якщо дохід зникне',
      zaver: 'Підсумок',
    },
    neuplne: {
      cilBydleni: 'ціна або строк житла',
      nadpis: 'Неповно, бракує:',
      uver: 'залишок або роки кредиту',
      vekDitete: 'вік {n}-ї дитини',
    },
    ochrana: {
      bezMesicne: 'Щомісяця бракує {castka}. Ця частина не має жодного джерела.',
      bezPn: 'За кожен день хвороби бракує {castka}.',
      bezZo: 'Лікування триває місяцями, витрати тривають, а доходу бракує.',
      detiCastka: 'Кожна дитина: {castka}.',
      dil: {
        bydleni: 'Житло',
        deti: 'Діти до 23 років',
        dluh: 'Частка кредиту',
        duchod: 'Пенсія',
        duchodPozustaleho: 'Пенсія партнера',
        renta: 'Дохід для родини',
        zivot: 'Повсякденне життя до пенсії',
      },
      doplniPoradce: 'додасть консультант',
      kazdeDite: 'Кожна дитина',
      kdoAria: 'Чий розрахунок показати',
      krokMetodou: 'За розрахунком (потреба − держава)',
      krokMinimum: 'Мінімум = страхова сума',
      naDen: '/ день',
      naDnesek: 'перераховано на сьогоднішні гроші (4 % на рік)',
      naNoc: '/ ніч',
      nadpis: 'Захист родини за ризиками',
      nepojistujeSe: 'не страхується',
      pnBezPrijmu: 'Без доходу. Покриття додасть консультант.',
      pnNicNechybi: 'Лікарняні від держави покриють ваш дохід.',
      pnPotreba: 'Ваш чистий дохід за день',
      pnStat: 'Лікарняні від держави',
      podRiziko: {
        dou: 'за день лікування травми',
        hosp: 'за ніч у лікарні',
        invalidita: 'за повної інвалідності',
        pn: 'за день хвороби чи травми',
        smrt: 'одноразово родині',
        tnu: 'після травми, залежно від ступеня',
        zo: 'одноразово при діагнозі',
      },
      popis: {
        dou: 'Виплата за кожен день лікування після травми. Скільки днів оплачується за травму, визначає таблиця страховика.',
        hosp: 'Виплата за кожну ніч у лікарні.',
        invalidita: 'Коли через здоров’я ви тривалий час не можете працювати. Держава поділяє це на ступені залежно від того, наскільки знизилася працездатність.',
        pn: 'Коли через хворобу чи травму ви деякий час не можете працювати. Лікарняні від держави замінять лише частину доходу.',
        smrt: 'Родина отримає одноразову суму: погасить частку кредиту та витрат на дітей до 23 років, яку ніс цей дохід, і доповнить дохід, якого бракує.',
      },
      riziko: {
        dou: 'Добова виплата при травмі',
        hosp: 'Госпіталізація',
        invalidita: 'Інвалідність',
        pn: 'Непрацездатність',
        smrt: 'Смерть',
        tnu: 'Постійні наслідки травми',
        zo: 'Тяжкі захворювання',
      },
      sJednorazove: 'Родина отримає {castka}, і цілі збережуться.',
      sPn: 'Добова виплата {pn}, при травмі додатково {dou}.',
      sPnBezDou: 'Добова виплата {pn}.',
      sZo: 'Одноразово {castka} при діагнозі зі списку в договорі.',
      stat: {
        invalidita: 'Пенсія по інвалідності (оцінка)',
        smrt: 'Пенсія вдові та сиротам (оцінка)',
      },
      statStupen: 'держава орієнтовно {castka} на місяць',
      stupen: {
        I: 'I ступінь · 35–49 %',
        II: 'II ступінь · 50–69 %',
        III: 'III ступінь · 70 % і більше',
        nad40: 'зниження понад 40 %',
        nad70: 'зниження понад 70 %',
      },
      tabulkaAria: 'Захист за ризиками та особами',
      tnuPasma: 'Виплата за діапазонами:',
      tnuPasmo: '{od}–{do} % ×{k}',
      tnuTabulka: 'Скільки виплатять із {castka} залежно від ступеня ушкодження',
      uvod: 'Скільки отримала б родина за кожної події. Ризики не виплачуються разом, тому суми не додаються.',
      vodopadAria: 'Потреба {potreba}, держава орієнтовно {stat}, бракує {chybi}.',
      zoRokyFew: '{n} роки чистого доходу',
      zoRokyMany: '{n} років чистого доходу',
      zoRokyOne: '{n} рік чистого доходу',
      zoRucne: 'Сума, яку ввів консультант',
    },
    odkladat: {
      ariaVolne: 'Після витрат і платежів лишається {volne}, пакет становить {balicek}.',
      celyPlan: 'Пакет — це весь план родини: захист і інвестиції. Скільки з нього коштує захист, порахує консультант за пропозицією страхової компанії.',
      doplnPrijmy: 'Пакети з’являться після введення доходів.',
      doporuceno: 'рекомендовано',
      nadpis: 'Скільки родина може відкладати',
      nevejdeSe: 'не вміщається, бракує',
      nevejdeSeKratce: 'не вміщається',
      odkladate: 'відкладаєте',
      rozdeleniInvestice: 'а в інвестиції',
      rozdeleniOchrana: 'на захист іде',
      rozdeleniZ: 'З',
      uvod: 'На цілі родини: від 10 до 30 % чистого доходу.',
      uvodDoporuceni: 'З {prijem} на місяць радимо відкладати {pct} %.',
      vlastni: 'Власна сума:',
      vyberAria: 'Який відсоток доходу відкладати',
      zVolnych: 'з вільних грошей',
      zbyvaVolne: 'лишається вільним',
      zpetNaDoporuceni: 'назад до рекомендації',
    },
    osa: {
      ariaDite: '{n}-а дитина самостійна у {rok} році',
      ariaDospely: '{kdo} на пенсію у {rok} році',
      ariaUver: 'кредит виплачено у {rok} році',
      diteZkratka: 'Д{n}',
      dnes: 'сьогодні',
      duchod: 'пенсія у {vek} · {rok}',
      prazdno: 'Часова шкала з’явиться після введення віку.',
      samostatne: 'вже самостійна',
      samostatneRok: '23 роки · {rok}',
      uver: 'Кредит',
      uverDo: 'виплачено {rok}',
    },
    otazky: {
      faq: {
        dlouho: {
          odpoved: 'У перші роки сплачується вступний збір, тож у разі раннього припинення ви отримаєте назад мало або нічого. Залежно від договору платіж можна зменшити, інвестування на час призупинити або зняти гроші з інвестиційної частини. Від договору можна відмовитися протягом 30 днів після укладення.',
          otazka: 'Чому надовго? А якщо мені треба буде призупинити, змінити платіж або зняти гроші?',
        },
        kamInvest: {
          odpoved: 'У фонди, які ви обираєте зі списку страховика: акційні, облігаційні або змішані. Стратегію можна змінювати протягом дії договору. Вартість може впасти навіть нижче вкладених грошей.',
          otazka: 'Куди інвестуються гроші?',
        },
        nemocny: {
          odpoved: 'Залежить від хвороби та страховика. Вас можуть прийняти за звичайною ціною, з надбавкою, з виключенням цієї хвороби або відмовити. Вкажіть хворобу в анкеті правдиво, інакше страховик може не виплатити.',
          otazka: 'Я хворий. Чи можу я застрахуватися?',
        },
        podvod: {
          odpoved: 'Страховик і консультант повинні мати ліцензію та бути в реєстрі центрального банку — це можна перевірити самостійно за іменем. Перед підписанням ви отримаєте письмово умови, огляд витрат і запис зустрічі. Нічого не треба підписувати одразу.',
          otazka: 'Це не шахрайство?',
        },
        poplatky: {
          odpoved: 'Вступний збір — це відсоток від цільової суми, поточний збір — відсоток від залишку щороку. Біля графіка обидва показано в грошах, а всі витрати є й у документах страховика.',
          odpovedCisla: 'Вступний збір {pct} від цільової суми становить {vstupni}. Поточний збір {prubeznyPct} на рік за весь час становить {prubezne}. Усі витрати є й у документах страховика.',
          otazka: 'Скільки коштують комісії?',
        },
        vratiSe: {
          odpoved: 'Не все. Частина, що оплачує захист, — це ціна того, що родина весь час була захищена, і вона не повертається, як обов’язкове страхування авто. Гроші на старість виникають лише з інвестиційної частини, і їхня сума не певна.',
          otazka: 'Якщо нічого не станеться, мені повернуть те, що я заплатив?',
        },
        vybrat: {
          odpoved: 'З інвестиційної частини зазвичай так. Скільки, як швидко і з якою комісією, визначає договір. Захисна частина не повертається, тому гроші на швидкі потреби варто тримати в резерві на рахунку поруч із договором.',
          otazka: 'Якщо мені забракне грошей, чи можу я їх зняти?',
        },
        vynos: {
          odpoved: 'Бо гроші працюють довго й регулярно. 5, 7 і 9 % — це модельні ставки, а не обіцянка: справжня дохідність може бути нижчою і навіть від’ємною. Тому графік завжди показує, скільки ви сплатите загалом.',
          otazka: 'Чому це стільки заробляє?',
        },
      },
      nadpis: 'Ваші питання',
      vedet: {
        dlouho: 'Це надовго. У разі припинення в перші роки ви отримаєте назад мало або нічого.',
        nadpis: 'Три речі, які треба знати',
        poplatky: 'Комісії ви бачите вище в грошах, а не лише у відсотках.',
        vynos: 'Дохідність не певна. Вартість інвестиції може й знизитися.',
      },
    },
    pomocnik: {
      hledat: 'Шукати питання',
      nadpis: 'Про що питають в’єтнамці в Чехії',
      nicNenalezeno: 'Нічого не знайдено.',
      otevrit: 'Помічник консультанта · {pocet} питань',
      pravo: 'Відповіді за чеським правом, перевірено 30.09.2026.',
      zdroj: 'Джерело: {zdroj}',
    },
    prijmy: {
      ariaPrijem: 'Дохід родини {celkem}: {dily}',
      ariaVydaje: 'Куди йде дохід: {dily}',
      chybi: 'бракує',
      doDuchodu: 'до пенсії',
      doplnPrijmy: 'Смуга доходів з’явиться після введення віку та доходу.',
      mesicne: 'на місяць',
      nadpis: 'Скільки грошей проходить через ваші руки',
      rocne: 'на рік',
      splatky: 'платежі за кредитом',
      uvod: 'Доходи обох разом і куди вони йдуть.',
      volne: 'залишається',
      vydaje: 'витрати',
      vydajePole: 'Витрати родини на місяць (без платежів за кредитами, включно з дітьми)',
      vydajeUpresneni: 'без платежів за кредитами, включно з дітьми',
      vydajeVeta: 'Родина щомісяця витрачає',
    },
    rodina: {
      bezDeti: 'поки немає',
      bezPrijmu: 'без доходу',
      bezPrijmuPrepinac: 'Зараз без доходу (декретна відпустка, вдома)',
      deti: 'Діти',
      diteCislo: '{n}-а дитина',
      mesicne: 'на місяць',
      nadpis: 'Ваша родина',
      odebratDite: 'Прибрати {n}-у дитину',
      odebratPartnera: 'Прибрати другого дорослого',
      osvc: 'самозайнятий',
      pridatDite: 'Додати дитину',
      pridatPartnera: 'Додати партнера',
      prijem: 'чистий дохід',
      prijemKoho: '{kdo} · чистий дохід на місяць',
      uvod: 'Хто в родині, скільки кому років і хто скільки заробляє.',
      vek: 'вік',
      vekDitete: '{n}-а дитина · вік',
      vekKoho: '{kdo} · вік',
    },
    role: {
      bo: 'Тато',
      boZkratka: 'Т',
      me: 'Мама',
      meZkratka: 'М',
    },
    srovnani: {
      balicek: 'Пакет',
      cimDriv: 'Якби ви почали лише у {vek} років, сплатили б на {mene} менше, але за моделлю мали б на {cena} менше (у сьогоднішніх грошах).',
      legenda: 'У клітинці модельна вартість, під нею — скільки ви сплатите загалом. Суми в {symbol}.',
      mesicne: '{castka} на місяць',
      nadpis: 'Чим більше і чим раніше',
      ochranaStejna: 'захист {castka} на місяць у кожному пакеті',
      prazdno: 'Порівняння з’явиться після введення доходів і ціни захисту.',
      startDnes: 'Почати сьогодні',
      startZa: 'Через {roky} років',
      tabulkaAria: 'Модельна вартість у {vek} років за {vynos} % за пакетом і початком',
      uvod: 'Модельна вартість у {vek} років за {vynos} %: залежно від того, скільки ви відкладаєте і коли почнете.',
    },
    stitek: {
      bezNarokuInv: 'без права на пенсію по інвалідності',
      bezPrijmuDoplniPoradce: 'без доходу, покриття додасть консультант',
      bezPrubeznehoPoplatku: 'без поточного збору, насправді буде менше',
      bezRustuMzdy: 'у сьогоднішніх грошах, без зростання зарплати',
      bezVstupnihoPoplatku: 'без вступного збору, насправді буде менше',
      bezVynosuKratkyCil: 'короткострокова ціль, розраховано без дохідності',
      dnesniPenize: 'у сьогоднішніх грошах (інфляція 2,5 %)',
      duchodBezNaroku: 'без права: менше 5 років страхування з 10',
      duchodMinimum: 'законний мінімум',
      duchodOsvcMinimalni: 'ФОП: пенсія з мінімальних внесків',
      duchodOveritNarok: 'право невідоме, розраховано без нього: перевірити виписку ČSSZ',
      invaliditaBezPrijmuB: 'батько/мати без доходу: покриваються на 20 % вищі витрати мінус пенсія по інвалідності',
      invaliditaPoOdchodu: 'після пенсійного віку інвалідність не страхують',
      modelovyVynos: 'модельна дохідність, не обіцянка; вартість може й знизитися',
      narokNeovren: 'право не перевірено',
      ochranaJeNaklad: 'захист — це ціна покриття, вона не повертається',
      osvcBezNemocenske: 'самозайнятий без добровільного лікарняного страхування: держава не платить',
      osvcNeodecteno: 'самозайнятий: державну пенсію не віднято, суму знає лише ČSSZ',
      overitUPojistovny: 'перевірити у страховика (зазвичай до {strop})',
      podilNaPrijmu: 'частка цілей відповідно до частки в доході родини',
      podlePodminekPojistovny: 'згідно з умовами страхування',
      pozustalostniBezNaroku: 'без потрібного страхового стажу: пенсію вдові та сиротам не віднято',
      pozustalostniBezPrijmu: 'без доходу: пенсію вдові та сиротам не віднято, додасть консультант',
      pozustalostniOsvc: 'самозайнятий: пенсію вдові та сиротам не віднято, право знає лише соціальне страхування',
      sablona: 'шаблон, перевірить консультант',
      statOdhad: 'оцінка, право лише після 5 років страхування з останніх 10',
      statPoradce: 'ввів консультант',
      statSkDoplniPoradce: 'пенсію за віком додасть консультант',
      statSkSablona: 'середнє значення Sociálna poisťovňa, перевірить консультант',
      vdovskyJenManzelum: 'пенсія вдові чи вдівцю лише для подружжя: не віднято',
      vdovskyNevime: 'пенсію вдові чи вдівцю не віднято: шлюб не вказано',
      zoBezOdectuStatu: 'лікарняні покривають лише непрацездатність, від тяжких захворювань не віднімаються',
    },
    stop: {
      bezBalicku: 'Оберіть пакет або введіть власну суму.',
      bezCenyZajisteni: 'Ціну захисту вводить консультант із розрахунку страхової компанії.',
      bezCileDuchodu: 'Вкажіть, скільки на місяць хоче мати на пенсії.',
      bezHorizontu: 'Цільовий вік має бути більшим за нинішній.',
      bezNakladuNaDite: 'Вкажіть, скільки на місяць коштує одна дитина.',
      bezOsob: 'Введіть хоча б одного дорослого.',
      bezPrijmu: 'Бракує чистого доходу. Якщо людина вдома без доходу, увімкніть «без доходу».',
      bezVeku: 'Бракує віку.',
      bezVydaju: 'Бракує щомісячних витрат родини.',
      celyBalicekNaOchranu: 'Увесь пакет іде на захист. На старість із нього нічого не накопичиться.',
      cilBydleniNeuplny: 'Для житла бракує ціни або через скільки років.',
      dluhNeuplny: 'У кредиті бракує залишку або кількості років сплати.',
      nejdrivRozpocet: 'Витрати більші за доходи. Спершу бюджет, потім пакет.',
      nejmensiNevejde: 'Навіть {pct} % ({balicek}) не вміщується у вільні гроші {volne}. Виберіть власну суму або спершу бюджет.',
      prubeznyMimoRozsah: 'Поточний збір має бути від 0 до {max} % на рік.',
      vekMimoRozsah: 'Вік має бути від {min} до {max} років.',
      vekOdchoduMimoRozsah: 'Вік виходу на пенсію має бути від {min} до {max} років.',
      vynosMimoRozsah: 'Дохідність після зборів виходить за межі, з якими ми рахуємо.',
    },
    suplik: {
      ano: 'Так',
      balicek: 'Пакет',
      cenaOchrany: 'Вартість захисту на місяць',
      cenaOchranyNapoveda: 'З розрахунку страхової компанії. Застосунок ціну не оцінює.',
      davkyNapoveda: 'Порожньо = оцінка застосунку за законом.',
      douDospely: 'Добова виплата при травмі дорослого, за день',
      invPodilNad40: 'Зниження понад 40 %: скільки % страхової суми',
      invalidniDuchod: 'Пенсія по інвалідності за повної інвалідності за випискою, щомісяця',
      manzelstvi: 'Шлюб',
      nadpis: 'Для консультанта',
      narok: 'Право на пенсію по інвалідності (5 років страхування з останніх 10)',
      ne: 'Ні',
      nevim: 'Не знаю',
      ochranaInvestice: 'Захист та інвестиції',
      osvc: 'Самозайнятий',
      prubeznyPoplatek: 'Поточний збір (% на рік)',
      role: 'Хто це',
      sazba: 'Процентна ставка',
      sezdani: 'Чи вони в шлюбі? Пенсія вдові чи вдівцю лише для подружжя.',
      splatka: 'Щомісячний платіж',
      splatkaNapoveda: 'Порожньо = платіж розрахується.',
      statniDuchod: 'Пенсія за віком за випискою, щомісяця',
      stavDat: 'Стан даних',
      tnu: 'Постійні наслідки травми: страхова сума',
      typ: 'Форма доходу',
      uver: 'Кредит за договором',
      varianta: 'Як сплачується вступний збір',
      vekCil: 'Інвестувати до віку',
      vlastniBalicek: 'Власна сума на місяць (замість 10–30 %)',
      volbyOchrany: 'Параметри захисту',
      vseZadano: 'Нічого не бракує.',
      vstupniPoplatek: 'Вступний збір (% від цільової суми)',
      vynos: 'Модельна дохідність на рік',
      zamestnanec: 'Працівник',
      zavrit: 'Закрити',
      zoRoky: 'Тяжкі захворювання: скільки річних доходів',
      zoRokyVolbaFew: '{n} роки',
      zoRokyVolbaMany: '{n} років',
      zoRokyVolbaOne: '{n} рік',
      zoRucne: 'Тяжкі захворювання вручну · {kdo}',
    },
    trapeni: {
      cesky: {
        odpoved: 'Документи можуть бути чеською або іншою узгодженою мовою. Я все поясню в’єтнамською, але обов’язковим є текст договору, і ви отримаєте запис зустрічі. Підписувати сьогодні не обов’язково — візьміть документи додому, прочитайте з тим, кому довіряєте, і не підписуйте нічого, чого не розумієте.',
        otazka: 'Договір увесь чеською, і я його не розумію. Чи треба підписати сьогодні?',
        otazkaVi: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        zdroj: '§ 79, 90 Закону ЧР про дистрибуцію страхування; § 2789 Цивільного кодексу ЧР; KID (регламент PRIIPs)',
      },
      dane: {
        odpoved: 'Внески на пільгове життєве страхування можна відняти від податкової бази, щонайбільше 48 000 Kč на рік разом із пенсійними заощадженнями та DIP. Умова — виплата не раніше року, коли вам виповниться 60 (для договорів з 2024 ще й після 120 місяців); у разі ранішого зняття відраховані суми оподатковуються до 10 років назад. Ви заощаджуєте лише податок із відрахованої суми — за ставки 15 % щонайбільше 7 200 Kč на рік; платники паушального податку та нерезиденти поза ЄС відрахування не мають.',
        otazka: 'Чи можу я відняти це від податків? Скільки?',
        otazkaVi: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        zdroj: '§ 15, 15a, 15b Закону ЧР про податки з доходів; Фінансова адміністрація ЧР',
      },
      deti: {
        odpoved: 'Спершу захищаємо дохід батьків, бо з нього живуть діти. Страхування дитини покриває передусім серйозну травму чи хворобу, коли батько чи мати залишаються вдома, а витрати зростають; за замовчуванням тяжкі захворювання 2 млн Kč, постійні наслідки 2 млн Kč, добова виплата 500 Kč і госпіталізація 1 000 Kč на день. Межа 23 роки — це вибір плану; чеська держава вважає дитину, що навчається, утриманцем щонайдовше до 26.',
        otazka: 'Діти маленькі. Чи страхувати і їх? До якого віку їм будуть потрібні гроші?',
        otazkaVi: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        zdroj: '§ 20, 52 Закону ЧР про пенсійне страхування; методика цього аналізу',
      },
      dotaznik: {
        odpoved: 'Так — на кожне запитання правдиво й повністю, навіть на дрібниці, про які питає страховик. Якщо приховування виявиться, страховик може відмовитися від договору або відмовити у виплаті саме тоді, коли родині потрібні гроші. Правдива відповідь може означати надбавку або виключення, але договір тоді надійний.',
        otazka: 'Чи треба писати в анкеті все? А якщо дрібницю не напишу?',
        otazkaVi: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        zdroj: '§ 2788, 2808, 2809 Цивільного кодексу ЧР',
      },
      duchodOsvc: {
        odpoved: 'Пенсія за віком і по інвалідності рахується з баз, з яких ви платили внески, тож за мінімальних внесків вона буде низькою. Пенсія по інвалідності ще й потребує стажу (після 28 років — 5 років за останні 10). Точний перелік років і внесків надасть чеська служба соціального забезпечення (особовий лист на ePortál).',
        otazka: 'Я сплачую соціальні внески лише мінімально. Яка буде в мене пенсія? І що дасть держава при інвалідності?',
        otazkaVi: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        zdroj: '§ 16, 40 Закону ЧР про пенсійне страхування; чеська служба соціального забезпечення',
      },
      invalidita: {
        odpoved: 'Інвалідність — це тривале зниження здатності працювати через здоров’я; чеська держава має три ступені: 35–49 %, 50–69 % і 70 % та більше. Поліс платить за своїми умовами — одні спираються на рішення соціальної служби, інші на власну оцінку, зазвичай після стабілізації стану. Тому я завжди показую, з якого ступеня і скільки він виплачує.',
        otazka: 'Що таке інвалідність? Коли я отримаю гроші?',
        otazkaVi: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        zdroj: '§ 39 Закону ЧР про пенсійне страхування; умови страхування',
      },
      kamInvest: {
        odpoved: 'Інвестиційна частина купує частки у фондах, які ви обираєте зі списку страховика, — акційних, облігаційних, змішаних або грошового ринку. Чим більше акцій, тим вища можлива дохідність і більші коливання, і вартість може впасти навіть нижче вкладених грошей. Стратегію зазвичай можна змінювати, умови й комісії є в тарифах.',
        otazka: 'У що інвестуються ці гроші? Чи можу я втратити все?',
        otazkaVi: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        zdroj: '§ 86 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs)',
      },
      kolikStoji: {
        odpoved: 'Ціну захисту знає лише страхова компанія — вона залежить від віку, здоров’я, професії та суми покриття, тому в аналізі стоїть тільки ціна з її розрахунку, жодної оцінки. Перед підписанням страховик має показати, скільки з платежу йде на покриття ризиків (це витрачається), скільки на витрати і скільки інвестується. Пакет 10–30 % доходу — це рамка бюджету, а не ціна.',
        otazka: 'Скільки я платитиму щомісяця? І скільки з цього — страхування, а скільки інвестується?',
        otazkaVi: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        zdroj: '§ 84, 86 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs); методика цього аналізу',
      },
      komu: {
        odpoved: 'Той, кого ви впишете в договір як вигодонабувача, — це може бути й батько чи мати у В’єтнамі (ім’я, дата народження, контакт). Якщо нікого не визначено, закон дає перевагу чоловікові чи дружині, потім дітям, батькам і спадкоємцям. Вигодонабувача можна будь-коли змінити письмово; виплату за кордон перевіримо в умовах.',
        otazka: 'Якщо я помру, хто отримає гроші? Чи можуть їх отримати батьки у В’єтнамі?',
        otazkaVi: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        zdroj: '§ 2829, 2831, 2832 Цивільного кодексу ЧР',
      },
      krach: {
        odpoved: 'Страховики в Чехії перебувають під наглядом Чеського національного банку й мусять тримати капітал і технічні резерви; у разі ліквідації активи, що покривають зобов’язання, йдуть першочергово на страхові вимоги. Страхування вкладів, як у банків, на життєве страхування не поширюється. Інвестиційна частина до того ж коливається разом із вартістю фондів незалежно від страховика.',
        otazka: 'Що, як страховик збанкрутує? Що буде з моїми грошима?',
        otazkaVi: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        zdroj: '§ 123 Закону ЧР про страхування',
      },
      nemocny: {
        odpoved: 'Залежить від діагнозу, лікування та страховика: прийняття за звичайною ціною, надбавка, виключення лише цієї хвороби, відкладення або відмова. Страховик вирішує після анкети, іноді після медичного висновку, а деякі додаткові ризики мають період очікування. Тому хворобу вкажіть одразу — наперед нічого пообіцяти не можна.',
        otazka: 'У мене високий тиск, діабет… Чи можу я взагалі застрахуватися?',
        otazkaVi: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        zdroj: '§ 2788 Цивільного кодексу ЧР; § 84 Закону ЧР про дистрибуцію страхування; умови страхування',
      },
      nesezdani: {
        odpoved: 'Пенсію для вдови чи вдівця держава дає лише чоловікові або дружині. Але вигодонабувачем у полісі може бути будь-хто, тому впишіть партнера в договір на ім’я. Без визначення закон віддає гроші чоловікові чи дружині, дітям, батькам і спадкоємцям — партнер без шлюбу до них не належить.',
        otazka: 'Ми живемо разом, але не одружені. Якщо я помру, чи отримає щось партнер?',
        otazkaVi: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        zdroj: '§ 49, 50 Закону ЧР про пенсійне страхування; § 2829, 2831 Цивільного кодексу ЧР',
      },
      osvcPn: {
        odpoved: 'Самозайнятий отримує лікарняні лише тоді, коли щонайменше 3 місяці до хвороби добровільно сплачує страхування на випадок хвороби, — і навіть тоді лише з 15-го дня та з низької бази. Без нього лікарняних від держави немає, а витрати тривають. Тому для самозайнятих ми рахуємо страхування непрацездатності; з якого дня воно платить, визначають умови.',
        otazka: 'Я самозайнятий. Якщо я хворітиму кілька місяців, чи заплатить мені щось держава?',
        otazkaVi: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        zdroj: '§ 24, 26, 29 Закону ЧР про страхування на випадок хвороби; чеська служба соціального забезпечення',
      },
      podvod: {
        odpoved: 'Страхова компанія повинна мати ліцензію Чеського національного банку, а консультант — бути в її реєстрі; це можна перевірити самостійно за іменем. Перед підписанням ви отримаєте письмово умови, документ з ключовою інформацією (KID) з витратами та запис зустрічі, включно з ризиками. Нічого не треба підписувати одразу, а в разі спору можна безкоштовно звернутися до фінансового арбітра.',
        otazka: 'Це не шахрайство? У В’єтнамі люди купили страховку через банк і втратили гроші.',
        otazkaVi: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        zdroj: 'реєстр Чеського національного банку; § 79, 88 Закону ЧР про дистрибуцію страхування; § 18 Закону ЧР про фінансового арбітра',
      },
      poplatky: {
        odpoved: 'Усі витрати є в документах: структура внеску перед підписанням, витрати в часі в KID і окремі комісії в тарифах. Частина витрат сплачується в перші роки, тому тоді інвестиційний рахунок росте повільно; вступний збір від цільової суми в аналізі видно окремо в грошах. Щороку приходить виписка з вартістю рахунку, викупною сумою та витратами.',
        otazka: 'Які там комісії? Куди йдуть гроші в перші роки?',
        otazkaVi: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        zdroj: '§ 84, 86, 89 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs)',
      },
      provize: {
        odpoved: 'Я отримую винагороду від страховика; її вид я маю вам повідомити, і ви знайдете його в інформації перед підписанням. Закон розподіляє її на 5 років — якщо договір закінчиться раніше, частину винагороди я повертаю. Тому мені йдеться про договір, який ви зможете сплачувати довго.',
        otazka: 'Скільки на цьому заробляєте ви?',
        otazkaVi: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        zdroj: '§ 50, 88 Закону ЧР про дистрибуцію страхування',
      },
      rodice: {
        odpoved: 'Підтримку батьків ми додамо до витрат родини, щоб її врахував і розрахунок потрібного захисту. Якщо хвороба чи травма забере дохід, виплата зі страхування допоможе платити і цю статтю. На випадок смерті ви можете визначити батьків вигодонабувачами; виплату до В’єтнаму перевіримо в умовах.',
        otazka: 'Щомісяця я надсилаю гроші батькам. Хто їм надсилатиме, якщо я захворію?',
        otazkaVi: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        zdroj: '§ 2829 Цивільного кодексу ЧР; методика цього аналізу',
      },
      rozvod: {
        odpoved: 'Після розлучення перевірте вигодонабувача: колишній чоловік чи дружина, вписані на ім’я, залишаються ним, доки ви письмово не зміните. Договором керує страхувальник, і якщо застрахована інша особа, для зміни вигодонабувача та викупної суми потрібна і її згода. Як поділити інвестиційну частину, вирішує поділ майна — це нехай оцінить адвокат.',
        otazka: 'Якби ми розлучилися, кому належить договір і гроші в ньому?',
        otazkaVi: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        zdroj: '§ 2826, 2829, 2830, 2832 Цивільного кодексу ЧР',
      },
      sezona: {
        odpoved: 'Лише якщо договір це прямо дозволяє — що саме дозволяє продукт (зменшити платіж, тимчасово не платити, списувати захист з інвестиційного рахунку), я покажу в умовах. Якщо не платити, прийде нагадування з додатковим строком щонайменше місяць, після чого страхування може припинитися. Тому платіж налаштовуємо за слабкими місяцями, а не за найкращими.',
        otazka: 'Буває по-різному. Чи можна в слабкий сезон призупинити або зменшити платіж?',
        otazkaVi: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        zdroj: '§ 2804, 2838 Цивільного кодексу ЧР; умови страхування',
      },
      skoncit: {
        odpoved: 'Початкові витрати зазвичай стягуються в перші роки, тому короткий договір дорогий, а викупна сума спочатку низька. Ми плануємо договір під ціль — на старість і на роки дітей. Але припинити можна: відмовитися протягом 30 днів від підтвердження укладення, розірвати протягом 2 місяців від укладення, а пізніше припинити з викупною сумою.',
        otazka: 'Чому треба платити так довго? А якщо я захочу припинити?',
        otazkaVi: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        zdroj: '§ 2805, 2808, 2842 Цивільного кодексу ЧР; § 86 Закону ЧР про дистрибуцію страхування',
      },
      staraSmlouva: {
        odpoved: 'Не розривайте старий договір заради нового, доки ми не порівняємо їх письмово: знову сплачуються початкові витрати, нова анкета оцінює сьогоднішній вік і здоров’я, а за договором із податковим відрахуванням може бути донарахування податку. Чеський національний банк прямо застерігає від зайвого розірвання договорів. Часто достатньо старий змінити або доповнити лише те, чого бракує.',
        otazka: 'У мене вже є договір від іншого консультанта. Розірвати його і укласти новий?',
        otazkaVi: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        zdroj: 'застереження ЧНБ щодо розірвання договорів; § 15b Закону ЧР про податки з доходів',
      },
      stari: {
        odpoved: 'Допомога дітей — це прекрасно, і мета в тому, щоб вона була подарунком, а не необхідністю. Власні гроші на старість дають вибір: де жити, чи повертатися до В’єтнаму, як допомагати онукам. Сума на графіку модельна і без гарантії.',
        otazka: 'У нас є діти, на старість вони про нас подбають. Навіщо мені це?',
        otazkaVi: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        zdroj: 'методика цього аналізу; § 86 Закону ЧР про дистрибуцію страхування',
      },
      vietnam: {
        odpoved: 'Чи продовжиться договір після переїзду, чи діє він поза Чехією і як платити та отримувати виплати за кордоном, визначають умови страхування — тому перед підписанням запитаємо страховика письмово, а відповідь ви збережете. Після переїзду змінюються й податки (нерезидент поза ЄС не може застосувати відрахування). Чеську пенсію можна отримувати і у В’єтнамі, умови підтвердить чеська служба соціального забезпечення.',
        otazka: 'Що буде з договором, якщо вся родина повернеться до В’єтнаму?',
        otazkaVi: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        zdroj: '§ 2789 Цивільного кодексу ЧР; § 84 Закону ЧР про дистрибуцію страхування; § 15 Закону ЧР про податки з доходів; чеська служба соціального забезпечення',
      },
      vratiSe: {
        odpoved: 'Не все. Частина, що оплачує захист, — це ціна того, що родина весь час була захищена, і вона не повертається, так само як страхування авто. Гроші на старість виникають лише з інвестиційної частини, після витрат і без гарантії дохідності.',
        otazka: 'Якщо нічого не станеться, мені повернуть те, що я заплатив?',
        otazkaVi: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        zdroj: '§ 86 Закону ЧР про дистрибуцію страхування',
      },
      vybrat: {
        odpoved: 'З інвестиційної частини зазвичай можна зробити позачергове зняття; мінімальний залишок, комісію та строк визначають умови. У разі припинення всього договору виникає право на викупну суму (після сплати щонайменше за два роки, якщо договір її не виключає), яку страховик виплатить протягом трьох місяців. Тому гроші на швидкі потреби варто тримати в резерві на рахунку поруч із договором.',
        otazka: 'Якщо мені терміново знадобляться гроші, чи можу я їх зняти? Як швидко я їх отримаю?',
        otazkaVi: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        zdroj: '§ 2842 Цивільного кодексу ЧР; § 86 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs)',
      },
      vyluky: {
        odpoved: 'Кожен ризик має в умовах своє визначення та виключення — я покажу їх перед підписанням. Постійні наслідки та добова виплата покривають лише нещасний випадок; інвалідність, тяжкі захворювання й непрацездатність — залежно від умов і хворобу. Втрата роботи чи закриття магазину зазвичай не є страховим випадком.',
        otazka: 'Коли страховик не заплатить? Це діє і на хворобу, чи лише на нещасний випадок?',
        otazkaVi: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        zdroj: '§ 84 Закону ЧР про дистрибуцію страхування; § 2837 Цивільного кодексу ЧР; умови страхування',
      },
      vynos: {
        odpoved: '5, 7 і 9 % — це модельні ставки для ілюстрації, а не обіцянка. Інвестиція може й втрачати, ризик несе клієнт — тому KID показує також несприятливий і стресовий сценарій. Довший строк пом’якшує коливання, але не усуває їх, тому графік завжди показує, скільки ви заплатили загалом.',
        otazka: 'Чому це стільки заробляє? Ці 7 % точно будуть?',
        otazkaVi: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        zdroj: '§ 86 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs)',
      },
      zavazneOnem: {
        odpoved: 'Виплачує одноразову суму, коли лікар підтвердить діагноз зі списку в умовах; список, визначення та стадії в різних страховиків різні. Гроші можна використати на що завгодно — втрату доходу, догляд, поїздки на лікування. У нашому аналізі за замовчуванням це один рік чистого доходу (на вибір два або три).',
        otazka: 'Що таке страхування від тяжких захворювань? Чи заплатить, якщо в мене буде рак?',
        otazkaVi: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        zdroj: '§ 84 Закону ЧР про дистрибуцію страхування; умови страхування; методика цього аналізу',
      },
      zdravotniCizinec: {
        odpoved: 'Комерційне медичне страхування оплачує лікування, але не замінить дохід, коли ви не можете працювати, і нічого не дасть родині в разі смерті чи інвалідності. До державного медичного страхування належать переважно люди з постійним проживанням або працівники чеського роботодавця. Слово «bảo hiểm» означає обидва, тому я завжди кажу, про яке йдеться.',
        otazka: 'У мене є комерційне медичне страхування для іноземців. Хіба цього не досить?',
        otazkaVi: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        zdroj: '§ 2 Закону ЧР про державне медичне страхування',
      },
      zvlast: {
        odpoved: 'Можна й так: ризикове страхування життя лише для захисту, а інвестиції окремо. Вирішує, що після всіх витрат вийде вигідніше і чого ви справді дотримуватиметесь, — обидва шляхи я можу порахувати поруч із KID і тарифів. Рішення за вами, і я запишу його в запис зустрічі.',
        otazka: 'Чому б не купити лише дешеве ризикове страхування, а інвестувати окремо самому?',
        otazkaVi: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        zdroj: '§ 78, 79 Закону ЧР про дистрибуцію страхування; KID (регламент PRIIPs)',
      },
    },
    ui: {
      chybaVypoctu: 'Розрахунок не вдався. Перевірте введені дані.',
      hotovo: 'Готово',
      metodika: 'Методика розрахунку від {verze}.',
      vymazat: 'Очистити',
    },
    varovani: {
      balicekNadVolne: 'Пакет {pct} % не вміщається в бюджет, бракує {chybi} на місяць.',
      detiSamostatne: 'Діти від {vek} років не враховуються: {pocet}.',
      duchodNadBalicek: 'На пенсію треба було б відкладати {odkladat} на місяць, більше за весь пакет {balicek}.',
      ochranaNadBalicek: 'Захист коштує більше за пакет, на інвестиції нічого не лишається.',
      poVekuOdchodu: 'У пенсійному віці або старше.',
      splatkaDopocitana: 'Платіж розраховано ({splatka} при {sazbaPct} % річних). Точний перепишіть із договору.',
      vydajeNadPrijmy: 'Витрати й платежі перевищують доходи на {chybi}.',
      vynosMimoScenare: 'Дохідність {vynos} % не є одним зі сценаріїв 5 / 7 / 9 %.',
    },
    vypadek: {
      bez: 'Без страхування',
      bezZdroje: 'Ця частина не має жодного джерела.',
      chybiCastka: 'бракує {castka} на місяць',
      chybiJednorazove: 'Щомісяця нічого не бракує, але на цілі бракувало б {castka}.',
      chybiMesicne: 'Щомісяця бракує',
      cip: {
        infarkt: 'Інфаркт',
        ledviny: 'Ниркова недостатність',
        mrtvice: 'Інсульт',
        ochrnuti: 'Параліч',
        rakovina: 'Рак',
        roztrousena: 'Розсіяний склероз',
        srdce: 'Операція на серці',
        uraz: 'Серйозна травма',
      },
      cipyAria: 'Приклади хвороб і подій',
      cipyPoznamka: 'Приклади. Що саме покриває договір, визначають умови страхування.',
      jakSpocitano: 'Як ми дійшли до суми',
      kdoAria: 'Чий дохід зникне',
      krokChybi: 'Чого бракує = страхова сума',
      krokPotreba: 'Що потрібно родині (з ваших цілей)',
      krokStat: 'Що дасть держава',
      krytoCastka: 'покрито {castka} на місяць',
      legendaChybi: 'бракує, без джерела',
      legendaKryto: 'покриває страхування',
      legendaPartner: 'далі несе {kdo}',
      nadpis: 'Якби один дохід зник',
      nesePartner: '{kdo} і далі несе {pct} % цілей своїм доходом.',
      nicNechybi: 'Дохід другого з вас покрив би цю ситуацію.',
      nicNechybiSam: 'Жодна із заданих вами цілей не лишилася б без джерела.',
      pojistnaCastka: 'Страхова сума',
      prazdno: 'Порахуємо, щойно буде введено вік, доходи й витрати родини.',
      radek: {
        bydleni: 'Платіж за житло',
        deti: 'Діти до 23 років',
        duchod: 'Відкладання на пенсію',
        zivot: 'Повсякденне життя родини',
      },
      s: 'Зі страхуванням',
      sZdrojem: 'Прогалину закрито, цілі родини залишаються.',
      udalost: {
        invalidita: 'Не може працювати',
        smrt: 'Смерть',
      },
      udalostAria: 'Що станеться',
      uvod: 'Хвороба чи нещасний випадок можуть прийти несподівано. Що станеться з цілями родини і що її втримає.',
      veta: {
        invalidita: {
          bo: 'Якби тато довго не міг працювати, його дохід припинився б.',
          me: 'Якби мама довго не могла працювати, її дохід припинився б.',
        },
        smrt: {
          bo: 'Якби тата не стало, родина назавжди втратила б його дохід.',
          me: 'Якби мами не стало, родина назавжди втратила б її дохід.',
        },
      },
    },
    zaver: {
      nadpis: 'Два шляхи',
      nestane: 'Якщо нічого не станеться — у вас є гроші на старість і не треба покладатися на дітей.',
      nestanePuvod: 'Виникає лише з інвестиційної частини: {investice} на місяць протягом {roky}, загалом {zaplaceno}. Дохідність не певна.',
      nestaneVek: 'у {vek} років · модель {vynos} %',
      stane: 'Якби щось сталося — уся родина захищена.',
      stanePuvod: 'Оплачується з пакета {balicek}: {ochrana} на місяць іде на захист. Це ціна покриття, і вона не повертається.',
      staneRiziko: {
        invalidita: '{kdo} · інвалідність',
        smrt: '{kdo} · смерть',
      },
    },
  },
  /* BLOK:vnRodina END */
  /* BLOK:kalkLista START — generuje scratchpad/slovnik.py, ručně needitovat */
  kalkLista: {
    cekani: {
      aria: 'Зараз {hned}, при відкладенні {pozdeji}, ціна очікування {cena}. Стовпець на кожні 5 років, шар на кожен блок внесків.',
      blok: 'Внески {od}–{do} рік',
      budeMit: 'Матиме через {roky}',
      hned: 'Зараз',
      horizont: 'Горизонт',
      mesicne: 'Щомісяця',
      otazkaHned: 'Якщо почне зараз, через {roky} матиме',
      otazkaPozde: 'Якщо почне на {roky} пізніше, втратить',
      pracuji: 'Гроші, що працюють',
      vetaHned: 'Кожні 5 років внесків — окремий шар; нижній працює найдовше.',
      vetaPozde: 'Стільки б наросли внески з перших {roky} — вони працюють найдовше.',
      vlozi: 'Вкладе',
      vynos: 'Дохідність на рік',
      zacne: 'Почне через',
      ztrata: 'Втрачено очікуванням',
    },
    dopl: {
      aria: 'Борг {dluh} зменшується, портфель після податку зростає. Вони перетнуться за {doba}, коли залишиться погасити {castka}. Гранична дохідність {hranice}.',
      ariaNikdy: 'Борг {dluh} зменшується, портфель після податку не наздожене його за {roky}.',
      bublinaMim: 'Борг із достроковими платежами',
      chybiDo: 'До погашення бракує',
      hranice: 'Гранична дохідність',
      hraniceNad: 'понад 30 %',
      hraniceZnacka: 'межа {pct}',
      investice: 'Інвестиція',
      investiceMes: 'Інвестиція щомісяця',
      jistina: 'Залишилося погасити',
      konecSplatnosti: 'кінець строку',
      lzeDoplatit: 'можна погасити',
      mimBezDluhu: 'Дострокові платежі: без боргу за',
      mimoradne: 'Дострокові платежі',
      nadInflaci: 'Понад інфляцію',
      nastejno: 'Однаково',
      nelze: 'З цими значеннями розрахунок неможливий — перевірте ставку і строк.',
      nesplati: 'За такого платежу іпотеку не буде погашено навіть за 80 років.',
      nevyslo: 'За {roky} портфеля на погашення не вистачить — після продажу і податку бракує {castka}.',
      nominalne: 'Номінально',
      nominalnePct: 'номінально {pct}',
      otazka: 'За дохідності {vynos} інвестиція {castka} щомісяця погасила б іпотеку за',
      otazkaRealne: 'За дохідності {vynos} понад інфляцію інвестиція {castka} щомісяця погасила б іпотеку за',
      poDani: 'після податку і комісій',
      podleVynosu: 'За дохідністю',
      poznamka: 'Дохідність інвестиції не гарантована, платіж за іпотекою — так. Податок із продажу за чинним законодавством.',
      poznamkaSk: 'Дохідність інвестиції не гарантована, платіж за іпотекою — так. Податок із продажу інвестиції не враховано (до податку) — словацькі правила застосунок поки не рахує.',
      propad: 'Падіння 35 %',
      radaDluh: 'Залишок боргу',
      radaMim: 'Дострокові платежі',
      radaPortfolio: 'Портфель після податку',
      realne: 'реально {pct}',
      rezim: 'Дохідність задано',
      riziko: 'Ризик',
      sazba: 'Ставка іпотеки',
      slRozdil: 'Портфель − борг',
      srovnatZa: 'Порівняти за',
      tabulkaPopis: 'Суми в {mena} на кінець року · портфель після податку і комісій (разом {naklady})',
      ter: 'Річна комісія (TER)',
      trh: 'Ринок у рік порівняння',
      trhNic: 'Ринок нічого не дасть',
      vetaChybi: 'ви винні {dluh}, портфель після податку {portfolio}, до погашення бракує {chybi}.',
      vetaDnes: 'ви винні {dluh}, інвестиція починається з нуля.',
      vetaSplaceno: 'іпотеку погашено, портфель після податку {portfolio}.',
      vetaZbylo: 'ви винні {dluh}, портфель після податку {portfolio} — після погашення залишилося б {zbylo}.',
      vicNez: 'понад {roky}',
      vstupni: 'Вхідна комісія',
      vyhodnejsi: 'Вигідніше за {roky}',
      vyhravaInvestice: 'виграє інвестиція',
      vyhravaSplaceni: 'виграє погашення',
      vynos: 'Дохідність на рік',
      vynosPodUrokem: 'Дохідність {vynos} не перевищить ставку іпотеки {sazba} — вигідніше погашати.',
      zbyloBy: 'Після погашення залишилося б',
      zbyvaLet: 'Залишилося років',
    },
    historie: {
      aria: 'Реальна історія з {od} до {do}: вкладено {vlozeno}, сьогодні {hodnota}.',
      dynamicky: 'Динамічний',
      hodnota: 'Вартість',
      jednorazove: 'Одноразово',
      konzervativni: 'Консервативний',
      mesicne: 'Щомісяця',
      otazka: 'Якби почав у {rok} році, сьогодні мав би',
      otazkaObecna: 'Скільки мав би сьогодні',
      portfolio: 'Портфель',
      roky: 'Скільки років тому',
      veta: 'Реальна історія ринків {od}–{do}. Минуле не гарантує майбутнього.',
      vklad: 'внесок',
      vlozeno: 'Вкладено',
      vlozil: 'Вклав',
      vydelal: 'Заробило',
      vyvazeny: 'Збалансований',
      zdroj: 'Джерело даних: SBBI/Ibbotson (США)',
    },
    hypo: {
      aria: 'Основна сума {uver} за {roky} знизиться до нуля; разом відсотків {urok}.',
      bezJinychUveru: 'без інших кредитів',
      bezPrijmu: 'дохід не введено',
      bezUveru: 'Власні кошти покривають усю ціну — кредит не потрібен.',
      bezVeku: 'вік не введено',
      bezZavazku: 'борги не введено',
      bublinaJistina: 'Основна сума на кінець року',
      bublinaUroky: 'Усього сплачено відсотків',
      celkem: 'Разом сплатите',
      cena: 'Ціна нерухомості',
      doporuceniNad: 'понад рекомендацію ČNB {limit}',
      doporuceniV: 'у межах рекомендації ČNB {limit}',
      dstiCo: 'Платежі до чистого доходу, рекомендація ČNB',
      dstiCoBez: 'Платежі до чистого доходу',
      dtiCo: 'Борг до річного доходу, рекомендація ČNB',
      dtiCoBez: 'Борг до річного доходу',
      dtiCoNbs: 'Усі кредити до річного чистого доходу, обов’язковий ліміт NBS',
      jineNevyplneno: 'Не заповнено',
      jineUvery: 'Інші кредити клієнта',
      jineZadne: 'Немає',
      ltvCo: 'Кредит до ціни нерухомості, обов’язковий ліміт {regulator}',
      ltvNad: 'понад ліміт {limit}',
      ltvV: 'у межах ліміту {limit}',
      minVlastni: 'мін. {castka} (LTV {limit})',
      minVlastniRok: 'мін. {castka} (LTV {limit} при купівлі у {rok} році)',
      nbsLimit: 'ліміт NBS {limit}',
      nbsLimitNejvys: 'ліміт NBS щонайбільше {limit}',
      nbsMaxUver: 'макс. кредит {castka}',
      nbsMaxUverNejvys: 'макс. кредит щонайбільше {castka}',
      nbsNad: 'понад ліміт NBS {limit}',
      nbsV: 'у межах ліміту NBS {limit}',
      otazka: 'Щомісячний платіж',
      poznamkaCz: 'LTV — обов’язковий ліміт ČNB, DSTI і DTI — лише рекомендації ČNB.',
      poznamkaSk: 'LTV — обов’язковий ліміт NBS.',
      poznamkaSkNbs: 'LTV і DTI — обов’язкові ліміти NBS.',
      radaJistina: 'Основна сума',
      radaUroky: 'Сплачені відсотки',
      sazba: 'Ставка',
      slUmor: 'Погашення основної суми',
      slUrok: 'Сплачені відсотки',
      splatkaNevyplnena: 'платіж за кредитом не заповнено',
      splatkyNadPrijem: 'Платежі перевищують чистий дохід на {castka} щомісяця.',
      splatnost: 'Строк',
      ukazatele: 'Показники кредиту',
      ukazateleCnb: 'Показники ČNB',
      vetaDnes: 'борг {jistina}, платіж {splatka} на місяць.',
      vetaRoku: 'борг {jistina}, сплачено відсотків {uroky}.',
      vlastni: 'Власні кошти',
      zTohoJistina: 'З них основна сума',
      zTohoUrok: 'З них відсотки',
      zustatekNevyplnen: 'залишок кредиту не заповнено',
    },
    jakoVPlanu: 'як у плані',
    kostra: {
      celkem: 'Разом',
      dnes: 'Сьогодні',
      grafOvladani: 'Стрілками виберете рік, Home і End переходять на початок і кінець.',
      grafRole: 'інтерактивний графік',
      rok: 'Рік {n}',
      sloupecRok: 'Рік',
      tabulka: 'Таблиця за роками',
      tabulkaPopis: 'Суми в {mena}, стан на кінець року',
      zaRoky: 'За {roky}',
    },
    letFew: '{n} роки',
    letMany: '{n} років',
    letOne: '{n} рік',
    mesFew: '{n} місяці',
    mesMany: '{n} місяців',
    mesOne: '{n} місяць',
    mesicne: 'на місяць',
    modelova: 'модельне значення',
    nezadano: 'не введено',
    paticka: 'Орієнтовний розрахунок, не пропозиція і не гарантія. До аналізу нічого не зберігається.',
    prebytek: 'вільні кошти {castka}',
    prumerTrhu: 'середнє по ринку',
    refi: {
      aria: 'Загалом сплатить зараз {dnes}, після рефінансування {nove}.',
      dnes: 'Зараз',
      jistina: 'Залишок боргу',
      naklady: 'Витрати на перехід',
      nakladyPopisek: '+ {castka} витрати на перехід',
      nakladySerie: 'Витрати на перехід',
      novaSazba: 'Нова ставка',
      nove: 'Після переходу',
      otazka: 'Після рефінансування заощадить',
      otazkaHorsi: 'Нова ставка не нижча — платіж зросте на',
      splatkaDnes: 'Платіж зараз',
      splatkaNova: 'Новий платіж',
      staraSazba: 'Поточна ставка',
      veta: 'За {roky} заощадить загалом {castka}; витрати окупляться за {mesice}.',
      vetaBezNakladu: 'За {roky} заощадить загалом {castka}.',
      vetaHorsi: 'За {roky} переплатить {castka}.',
      zbyvaLet: 'Залишилось',
    },
    renta: {
      aria: 'Капітал {kapital} на ренту {renta} на місяць. За {roky} буде виплачено {vyplaceno}, наприкінці залишиться {zbude}.',
      bublinaKapital: 'Капітал на кінець року',
      bublinaVyplaceno: 'Виплачено разом',
      cerpani: 'Виплачувати',
      cerpaniNavzdy: 'Виплата назавжди',
      cerpaniRoky: 'Виплата {roky}',
      navzdy: 'Назавжди',
      otazka: 'На ренту {castka} на місяць потрібно',
      poznamka: 'Дохідність понад інфляцію, рента в сьогоднішніх грошах. Дохідність не гарантована.',
      renta: 'Рента на місяць',
      slKapital: 'Капітал',
      slVyplaceno: 'Виплачено разом',
      vetaDnes: 'капітал {kapital}, рента {renta} щомісяця.',
      vetaNavzdy: 'Рента йде лише з доходу — капітал залишається цілим.',
      vetaRoku: 'капітал {kapital}, виплачено разом {vyplaceno}.',
      vetaRoky: 'За {roky} капітал вичерпається до нуля.',
      vynos: 'Дохідність понад інфляцію',
      vyplaceno: 'Виплачено за {roky}',
      vyplacenoRada: 'Виплачена рента',
      zbude: 'Залишиться в кінці',
      zustatek: 'Капітал',
    },
    splac: {
      aria: 'Залишок боргу в часі: спочатку до {puvodni} року, з достроковою виплатою до {novy} року.',
      driv: 'Без боргу раніше на',
      mimoradna: 'Дострокова виплата',
      nad25: 'Понад 25 % основного боргу на рік банк може стягнути комісію.',
      nove: 'З достроковою виплатою',
      otazka: 'Дострокова виплата заощадить на відсотках',
      puvodne: 'Спочатку',
      rezim: 'Після дострокової виплати',
      snizit: 'Зменшити платіж',
      splatkaZustava: 'Платіж залишається',
      veta: 'Борг зникне у {novy} році замість {puvodni}.',
      vetaDoplaceno: 'Дострокова виплата покриває весь борг.',
      vetaSnizit: 'Платіж зменшиться на {castka} щомісяця до кінця.',
      zkratit: 'Скоротити строк',
    },
    tab: {
      cekani: 'Ціна очікування',
      doplaceni: 'Іпотека з інвестицією',
      historie: 'Історична',
      hypoteka: 'Іпотека',
      refinanc: 'Рефінансування',
      renta: 'Рента',
      splaceni: 'Погасити раніше',
    },
    upravit: '{popisek}: {hodnota}. Ввести точно',
    vratitVychozi: 'Повернути початкові значення',
    zAnalyzy: 'з аналізу',
    zmensitKlavesa: 'Зменшити (клавіша Z)',
    zvetsit: 'Збільшити калькулятор',
    zvetsitKlavesa: 'Збільшити (клавіша Z)',
  },
  /* BLOK:kalkLista END */
  /* BLOK:brifink START — generuje scratchpad/slovnik.py, ručně needitovat */
  brifink: {
    poTerminu: 'Прострочено ({datum})',
  },
  /* BLOK:brifink END */
  /* BLOK:planVek START — generuje scratchpad/slovnik.py, ručně needitovat */
  planVek: {
    doplnte: 'Додайте вік клієнта',
    proc: 'Без дати народження не можна перевірити виняток для молодих до 36 років, тому перший внесок 10 % не пропонується.',
  },
  /* BLOK:planVek END */
  /* BLOK:pojisteniPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniPlan: {
    castCeny: 'поки лише частина ціни',
    cenaCelkemNadpis: 'Внесок разом',
    cenaCelkemPopis: 'План рахує лише з ціною з пропозиції страховика.',
    cenaChybiDeti: 'Ціна дитячого договору відсутня — план віднімає лише дорослих.',
    cenaChybiOsoba: 'Ціна для {jmeno} відсутня — план віднімає лише введену частину.',
    cenaDeti: 'Ціна дитячого договору',
    cenaDoplnte: 'Доповніть ціну від страховика',
    cenaOdPojistovny: 'Ціна з пропозиції страховика',
    chybiCena: 'бракує ціни',
    detiZavazneNadStropem: 'Понад ліміт андеррайтингу {strop} — перевірте у страховика.',
    jakProgrese: 'Як працює прогресія',
    kalkCenyVarianta: 'Ціни для варіанта {varianta} — кожен варіант має власну пропозицію.',
    mesicneProCilePoPojistnem: 'Щомісяця на цілі (після страхових внесків)',
    naCile: 'На цілі',
    nulaZdrojeKryji: 'Сума 0 = ресурси родини (дохід партнера, майно) покривають цю потребу.',
    orientacne: 'орієнтовно ≈ {castka} — план із цим не рахує',
    platbaNezadana: 'платіж не введено',
    pojistneZmena: 'Внесок — зміна',
    pouzitProVsechny: 'Застосувати до всіх варіантів',
    prebytekPoPojistnem: 'Профіцит після страхових внесків',
    prezBezCenyPozn: 'Суми — це пропозиція покриття, а не пропозиція страховика. Ціну й обсяг виплат, зокрема винятки, визначить страховик у договорі та умовах страхування.',
    prezCenaPozn: 'Ціна з пропозиції, яку ввів консультант, — остаточну ціну підтвердить страховик у договорі після оцінки стану здоров’я. Обсяг виплат і винятки визначають умови страхування.',
    prezZavazneProc: 'одноразова виплата на лікування — дає змогу не працювати й лікуватися',
    rozpocetPojistne: 'Внесок: зараз {stara} → новий {nova} ({rozdil})',
    rozpocetPojistneNove: "Новий внесок {nova} — входить до обов'язкових витрат",
    rucne: 'вручну',
    rusiSe: 'скасовується',
    skrytProgresi: 'Сховати прогресію',
    staraZustava: 'старий договір залишається',
    stareBezCeny: 'Різниця порахується, коли введете ціну нового договору.',
    stareBezKrytiZivota: 'Не віднімається — нова угода не дає цій особі покриття смерті чи інвалідності, тож стара залишається.',
    stareBezNahrady: 'Бракує ціни — не віднімається, нова угода поки не покриває цю особу.',
    stareIdd: 'Старий договір скасовуйте лише після прийняття нового, до річниці, а причину запишіть у протокол зустрічі.',
    stareMajetekBezCeny: 'Вивільниться після введення ціни нової угоди.',
    stareMajetekBezNahrady: 'Жодна нова угода її не замінює — у плані вона й далі оплачується.',
    stareNadpis: 'Чинні договори',
    stareNespoctenoPartner: 'Не віднімається — захист партнера план не розрахував (бракує дати народження), тож договір залишається.',
    stareNeznama: 'Доповніть платіж чинного договору {nazev} — поки віднімається вся нова ціна.',
    stareNic: 'Новий внесок {nova} — жоден чинний договір не скасовується, віднімається повністю.',
    stareRozdil: 'Внесок: зараз {stara} → новий {nova} · віднімається лише різниця {rozdil}',
    tnuAria: 'Виплата за стійкі наслідки із суми {castka}: при {pct} % ушкодження виплата {vyplata}, при 100 % щонайбільше {max}.',
    tnuOrientacne: 'Орієнтовно — діапазони й коефіцієнти у страховиків різняться, точну таблицю виплат має страховик.',
    tnuPasmo: 'діапазон ×{n}',
    tnuPoskozeni: 'Ушкодження {pct} %',
    tnuPri: 'при {pct} %',
    tnuVolby: 'Страхова сума за стійкі наслідки',
    tnuVyplati: 'виплата',
    tnuVysvetleni: 'У нашій моделі кожен діапазон множиться окремо: до 20 % ×1, 20–40 % ×2, 40–60 % ×3, понад 60 % ×4. При 100 % це щонайбільше {max}× суми.',
    vetaNad: 'Додатковий внесок {rozdil} більший за місячний профіцит {prebytek} — на цілі нічого не лишається.',
    vetaNove: 'Внесок {nova} · на цілі {naCile}',
    vetaZmena: 'Внесок: зараз {stara} → новий {nova} ({rozdil}) · на цілі {naCile}',
    vydajeNezbytne: 'необхідні витрати',
    vydajeObvykle: 'звичайні витрати',
    vydajeSplatkyPojistne: 'Витрати + платежі за кредитами + страхові внески',
    vydajeZObvyklych: 'Необхідні витрати не задані — варіант {varianta} рахує з 90 % звичайних.',
    zadanaCast: 'введена частина',
    zaverOchranaPovinne: 'захист {nova} — серед обов’язкових витрат',
    zaverOchranaZmenaPovinne: 'захист зараз {stara} → нове {nova} — серед обов’язкових витрат',
    zaverZVolnehoCf: 'Скільки це бере з вільного грошового потоку',
    zoVolby: 'Скільки років чистого доходу',
    zustava: 'залишається',
  },
  /* BLOK:pojisteniPlan END */
  /* BLOK:minimumSmrti START — generuje scratchpad/slovnik.py, ručně needitovat */
  minimumSmrti: {
    ariaHodnotaNaklad: '{castka} на місяць',
    ariaNaklad: 'Щомісячні витрати на дитину {jmeno}',
    ariaPruh: 'Мінімум {castka}: {casti}',
    ariaVek: 'До якого віку родина утримує дитину {jmeno}',
    bezPrijmu: 'без доходу',
    bezPrijmuText: 'Без доходу — страховка на випадок смерті погасить щонайменше борги родини.',
    dluhy: 'борги',
    doVekuFew: '{n} роки',
    doVekuMany: '{n} років',
    doVekuOne: '{n} рік',
    kalkVeta: 'Мінімум {castka} = борги {dluhy} + 1 рік доходу родини {prijem} + діти {deti}',
    kalkVetaBezDeti: 'Мінімум {castka} = борги {dluhy} + 1 рік доходу родини {prijem}',
    kalkVetaSablona: 'Мінімум {castka} = борги {dluhy} + 1 рік доходу родини {prijem} + діти {deti} — для дітей оцінка за шаблоном ({naklad} на місяць на дитину до {vek} років), не дані з аналізу',
    klientSrovnani: 'На випадок смерті виходить {smrt}, на {rozdil} більше, ніж на інвалідність. Це мінімум, нижче якого покриття смерті не опускається: борги, рік доходу родини і діти до самостійності.',
    klientSrovnaniBezDeti: 'На випадок смерті виходить {smrt}, на {rozdil} більше, ніж на інвалідність. Це мінімум, нижче якого покриття смерті не опускається: борги і рік доходу родини.',
    klientSrovnaniSmrtVyssi: 'На випадок смерті виходить {smrt}, на {rozdil} більше, ніж на інвалідність. Обидві суми мають своє місце в договорі — кожна покриває іншу ситуацію.',
    letFew: '{n} роки',
    letMany: '{n} років',
    letOne: '{n} рік',
    metodou: 'За методикою виходить {castka} — діє мінімум:',
    nakladChybi: 'витрати на дитину відсутні — додайте їх до витрат (категорія Діти)',
    nakladDite: 'Витрати на дитину / міс.',
    nakladHint: 'порожньо = шаблон {castka}',
    nakladHintBez: 'заповніть — шаблону для цієї країни немає',
    podMinimem: 'Нижче мінімуму {castka} (борги + 1 рік доходу родини + діти) — введено вручну, свідомо.',
    podMinimemBezPrijmu: 'Нижче мінімуму {castka} (погашення боргів) — введено вручну, свідомо.',
    posuvnikNaklad: 'Щомісяця',
    posuvnikVek: 'До віку',
    pozn: 'Мінімум: борги + 1 рік доходу родини + діти до самостійності',
    poznBezPrijmu: 'Мінімум: погашення боргів (без доходу)',
    prezProc: 'Щонайменше стільки: борги {dluhy} + 1 рік доходу родини {prijem} + діти до самостійності {deti}.',
    prezProcBezDeti: 'Щонайменше стільки: борги {dluhy} + 1 рік доходу родини {prijem}.',
    prezProcBezPrijmu: 'Щонайменше стільки: погашення боргів {dluhy}.',
    prezProcSablona: 'Щонайменше стільки: борги {dluhy} + 1 рік доходу родини {prijem} + діти до самостійності {deti} — для дітей оцінка за шаблоном ({naklad} на місяць на дитину до {vek} років), не дані з аналізу.',
    prijemRok: '1 рік доходу родини',
    radekDite: '{jmeno}, {vek}: {naklad} × {roky} =',
    radekDiteBezVeku: '{jmeno}, вік не вказано: {naklad} × {roky} =',
    radekDluhy: 'Погасити борги',
    radekPrijem: '1 рік доходу родини: {mes} × 12 =',
    sablona: 'шаблон {castka} на місяць на дитину',
    stavMetoda: 'За методикою виходить більше ({castka}) — діє вища сума.',
    stavMinimum: 'За методикою виходить {castka} — діє мінімум.',
    stitek: 'мінімум',
    titul: 'Мінімальне покриття на випадок смерті',
    vekDeti: 'Вік дітей (років)',
    vekDitete: 'Дитина {n}',
    vekFew: '{n} роки',
    vekHint: 'порожньо = від народження',
    vekMany: '{n} років',
    vekNeznamy: 'вік дитини не вказано — рахується від народження',
    vekOne: '{n} рік',
    vetaBezPrijmu: 'Мінімум {castka} = погашення боргів — без доходу рік доходу й діти не враховуються',
    vratit: 'Повернути',
    vratitAria: 'Повернути {jmeno} до значення з аналізу',
    vystupMetodika: 'У разі смерті діє мінімум, якщо капітальний метод дає менше.',
    zCeho: 'З чого складається мінімум',
    zCehoSkryt: 'Сховати склад мінімуму',
    zadano: '{castka} на місяць на дитину',
    zdrojAnalyza: 'з аналізу',
    zdrojSablona: 'шаблон',
    zdrojUpraveno: 'змінено',
  },
  /* BLOK:minimumSmrti END */
  /* BLOK:analyzaCisla START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaCisla: {
    auto: {
      chybiCil: 'У цілях бракує заміни авто. Ваше авто сьогодні коштує {castka} — до цього рівня ви повернетеся за кілька років.',
      maCil: 'Ціль на авто у вас є. Тримайте її близько {castka} — у цій ціновій категорії ви їздите зараз.',
      nadpis: 'Заміна авто',
    },
    bydleni: {
      bezStropu: 'Ціль на житло {cil} — це {nasobek}× ваш річний дохід.',
      limitNbs: 'На житло вам потрібен кредит {uver}. Ліміт НБС для всіх ваших кредитів — {limit} ({max}× річного чистого доходу).',
      limitNbsSDluhy: 'На житло вам потрібен кредит {uver}. Ліміт НБС для всіх ваших кредитів — {limit} ({max}× річного чистого доходу), після інших кредитів ({dluhy}) лишається {strop}.',
      limitNbsVek: 'Залежно від віку ліміт може бути нижчим.',
      nadpis: 'Ціна житла',
      strop: 'Ціль на житло {cil} — це {nasobek}× ваш річний дохід. Стеля — {max}×, тобто {strop}.',
    },
    jednotky: {
      mil: 'млн',
    },
    odkladani: {
      chybi: 'До мінімуму {min} % бракує {chybi} щомісяця.',
      dnes: 'Зараз відкладається {pct} % доходу.',
      dohodnuto: 'З погодженими {castka} на місяць відкладатиметься {pct} % доходу.',
      dohodnutoVklady: 'З погодженими {castka} на місяць і регулярними внесками {vklady} відкладатиметься {pct} % доходу.',
      ideal: 'Це ідеал {ideal} %. При {rychle} % цілі виконуються дуже швидко.',
      minimum: 'Мінімум {min} % виконано, ідеал — {ideal} %.',
      nadCilem: 'Це {rychle} % і більше — цілі виконуються дуже швидко.',
      nadpis: 'Скільки відкладається',
      schodek: 'Витрати й платежі вищі за доходи, тож зараз нічого не відкладається.',
    },
    panel: {
      cerpani: 'ставка зняття',
      kProjednani: '{n} до обговорення',
      kapital: 'Потрібний капітал',
      nadpis: 'Що випливає з цифр',
      orientacni: 'орієнтовно',
      orientacniTitle: 'Оцінка, а не гарантоване значення',
      vseOk: 'усе гаразд',
    },
    renta: {
      bezHypoteky: 'Іпотеку виплатите до {rok} року, у ренті її не рахуємо.',
      bezSplatek: 'Без платежів, які виплатите до початку ренти.',
      bezSplatekISporeni: 'Без платежів, які виплатите до початку ренти, і без сьогоднішніх заощаджень.',
      bezSporeni: 'Без сьогоднішніх заощаджень.',
      chybiCil: 'У цілях бракує ренти. Сьогодні ви витрачаєте {vydaje} на місяць — стільки має покривати рента.',
      chybiCilSplatky: 'У цілях бракує ренти. Сьогодні ви витрачаєте {vydaje} і сплачуєте {splatky} на місяць — рента має покривати {potreba}.',
      doplnUrokHypoteky: 'Для іпотеки додайте відсоткову ставку — тоді порахуємо, чи закінчиться вона до ренти.',
      doplnUrokUveru: 'Для кредиту додайте відсоткову ставку — тоді порахуємо, чи закінчиться він до ренти.',
      doplnZustatekHypoteky: 'Для іпотеки додайте залишок і відсоткову ставку — тоді порахуємо, чи закінчиться вона до ренти.',
      doplnZustatekUveru: 'Для кредиту додайте залишок і відсоткову ставку — тоді порахуємо, чи закінчиться він до ренти.',
      nadpis: 'Ціль ренти проти витрат',
      nesedi: 'Ціль ренти — {zadano}, але сьогодні ви витрачаєте {vydaje} на місяць. Бракує {rozdil}.',
      nesediSplatky: 'Ціль ренти — {zadano}, але витрати разом із платежами — {potreba} на місяць. Бракує {rozdil}.',
      odvozena: 'Ціль ренти не задана — рахуємо з сьогоднішніх витрат і платежів, без платежів, які виплатите до ренти, і без сьогоднішніх заощаджень.',
      sedi: 'Ціль ренти {zadano} покриє сьогоднішні витрати {vydaje}.',
      sediSplatky: 'Ціль ренти {zadano} покриє сьогоднішні витрати разом із платежами {potreba}.',
    },
    rezerva: {
      doplnit: 'Доповнимо необхідні витрати й розрахуємо з них резерв.',
      nadpis: 'Ліквідний резерв',
      poRuce: 'Під рукою у вас {likvidni}, тобто на {mesicu} місяця.',
      poRuceBezMesicu: 'Під рукою у вас {likvidni}.',
      pravidlo: 'Резерв ({m}× необхідні витрати й платежі за кредитами) становить {potreba}.',
      vlastniCil: 'Ваша ціль резерву — {cil}.',
      vlastniCilPravidlo: 'За правилом {m}× необхідні витрати й платежі це було б {potreba}.',
    },
    stav: {
      chybi: 'Потрібно вирішити',
      info: 'Для інформації',
      ok: 'Виконано',
      pozor: 'Понад ліміт',
    },
    zivotni: {
      nadpis: 'Страхування життя',
      platba: 'За захист доходу ви платите {castka} на місяць.',
      platbaPodil: 'За захист доходу ви платите {castka} на місяць, тобто {podil} % доходу.',
    },
  },
  /* BLOK:analyzaCisla END */
  /* BLOK:analyzaStranka START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaStranka: {
    cesta: {
      orientacniKlient: 'Орієнтовна модель, не гарантія.',
    },
    coBudeLabel: 'Пункти, які будуть далі',
    detiFew: '{n} дитини',
    detiMany: '{n} дітей',
    detiOne: '{n} дитина',
    firmaNema: 'Клієнт не має компанії чи бізнесу',
    jmenoKlienta: "Ім'я (Клієнт {n})",
    kompletnostChybi: 'Для точного плану бракує: {seznam}.',
    mostek: '«Якщо фінансовий план виконає **ці цілі**, чи буде це для вас правильним рішенням?»',
    napoveda: {
      auto: 'Заощаджують на різницю: ціна наступного авто мінус те, що виручите за теперішнє. Коли матимете більше, ціль скоригуємо.',
      bydleni: '{prijem} чистого × 12 × {nasobek} = {castka} (межа ЧНБ). Реально — з теперішнього житла на подібне, не палац.',
      bydleniBezRegulatora: 'Ціна житла має відповідати чистому доходу домогосподарства. Реально — з теперішнього житла на подібне, не палац.',
      bydleniChybi: 'Справедлива ціна житла ≈ {nasobek}× річного чистого доходу. Для розрахунку межі бракує доходів.',
      bydleniNad: 'Вище за рекомендацію ЧНБ ({strop}) — іпотеку можуть не схвалити.',
      bydleniNadNbs: 'Кредит {uver} перевищує ліміт НБС ({strop}) — банк надає такий лише як виняток.',
      bydleniNadNbsVycerpano: 'На новий кредит {uver} з ліміту НБС нічого не лишається — банк надає такий лише як виняток.',
      bydleniNadNbsZbyva: 'Кредит {uver} більший, ніж лишається з ліміту НБС ({strop}) — банк надає такий лише як виняток.',
      bydleniNbs: 'Ліміт НБС: усі кредити разом не більше {max}× річного чистого доходу = {limit}.',
      bydleniNbsBezDluhu: 'Розраховано без інших кредитів.',
      bydleniNbsChybiPrijem: 'Ліміт НБС рахується лише з підтвердженого та іншого доходу клієнтів — додайте його.',
      bydleniNbsDluhyChybi: 'Ліміт НБС діє для всіх кредитів разом — додайте залишки інших кредитів.',
      bydleniNbsPravidlo: 'Ліміт НБС: усі кредити разом не більше {max}× річного чистого доходу.',
      bydleniNbsSDluhy: 'Ліміт НБС: усі кредити разом не більше {max}× річного чистого доходу = {limit}. Після вирахування інших кредитів ({dluhy}) на новий кредит лишається {strop}.',
      bydleniNbsVek: 'З 41 року ліміт нижчий, якщо кредит закінчується після 65 років — додайте дату народження.',
      bydleniNbsVycerpano: 'Інші кредити ({dluhy}) вже вичерпали весь ліміт НБС ({max}× річного доходу).',
      bydleniOrientacni: 'Справедлива ціна житла ≈ {nasobek} × 12 × {prijem} = {castka}.',
      bydleniPravidlo: 'Справедлива ціна житла ≈ {nasobek}× річного чистого доходу.',
      doporucit: 'Запропонувати {castka}',
      naHistorii: 'На історії',
      naHistoriiTitul: 'Показати на реальних даних 1928–2025',
      orientacniPrijem: 'Орієнтовний чистий дохід домогосподарства',
      ostatni: 'Що – коли – скільки, у сьогоднішніх цінах.',
      renta: '{vydaje} витрати + {splatky} платежі = {castka} на місяць. Рента має забезпечити таке саме життя, як сьогодні, — не лише необхідне.',
      rentaBezHypoteky: '{vydaje} витрати + {splatky} платежі = {castka} на місяць — іпотеку виплатите до {rok} року, у ренті її немає. Рента має забезпечити таке саме життя, як сьогодні.',
      rentaBezHypotekyBezSplatek: '{vydaje} витрати = {castka} на місяць — іпотеку виплатите до {rok} року, у ренті її немає. Рента має забезпечити таке саме життя, як сьогодні.',
      rentaBezSplatek: '{vydaje} витрати = {castka} на місяць. Рента має забезпечити таке саме життя, як сьогодні, — не лише необхідне.',
      rentaChybi: 'Рента = усі сьогоднішні витрати, включно з платежами та способом життя. Для розрахунку бракує витрат.',
      rentaNizka: 'Витрати разом із платежами становлять лише {pct} % доходу — у витратах, мабуть, чогось бракує.',
      rentaVysoka: 'Витрати разом із платежами становлять {pct} % доходу — перевищують дохід.',
      rezerva: '({nezbytne} необхідні витрати + {splatky} платежі) × {mesicu} = {castka}. Діапазон {min}–{castka} залежно від того, наскільки стабільний ваш дохід.',
      rezervaBezSplatek: '{nezbytne} необхідні витрати × {mesicu} = {castka}. Діапазон {min}–{castka} залежно від того, наскільки стабільний ваш дохід.',
      rezervaChybi: 'Резерв = 3–6× необхідні витрати + платежі. Для розрахунку бракує необхідних витрат.',
      vzdelani: '{mesicne} на місяць × {mesicu} місяців × {let} = {castka}. Навчання в Чехії {od}–{do}, за кордоном приблизно у два з половиною рази більше.',
      vzdelaniDeti: '{mesicne} на місяць × {mesicu} місяців × {let} × {deti} = {castka}. Навчання в Чехії {od}–{do}, за кордоном приблизно у два з половиною рази більше.',
      vzdelaniJednoDite: '{mesicne} на місяць × {mesicu} місяців × {let} = {castka} на одну дитину. Навчання в Чехії {od}–{do}, за кордоном приблизно у два з половиною рази більше.',
      vzdelaniJinaMena: 'Навчання дітей: місячні витрати × місяці на рік × роки навчання. Навчання за кордоном виходить приблизно у два з половиною рази дорожче.',
    },
    penzijko: {
      dpsDip: '(DPS {dps} + DIP {dip})',
      jenDip: '(DIP — з першої крони)',
      jenDps: '(внесок понад {hranice} на місяць)',
      nadLimit: 'понад річну межу {limit}: {castka} не врахується',
      odpocet: 'Податкова знижка',
      statni: 'Державний внесок (DPS)',
      zaMesic: '{castka}/міс',
      zaRok: '{castka}/рік',
    },
    prebytekSouhlas: '«Чи погоджуєтеся, що {castka} щомісяця ми можемо використати на ваші цілі?»',
    skript: {
      cas: 'Телефоном ми домовилися, що матимемо **45 хвилин**. У мене нічого не змінилося — лише хочу переконатися, що ви теж розраховуєте на 45 хвилин.',
      cile: '«Подивімося на стратегічні цілі у структурі **ЩО – КОЛИ – СКІЛЬКИ**. Що спадає вам на думку першим?» Якщо клієнт не згадає, перевірте **житло**, **освіту дітей** і **фінансову незалежність**.',
      ocekavani: '«Чого ви очікуєте від сьогоднішньої зустрічі?» → повторіть слова клієнта й додайте: «Моя мета — перевірити, **що ви вже робите добре**, **де, можливо, втрачаєте гроші** і **що можна робити краще**.»',
      penize: '«Почну з незвичного запитання: **Чим для вас важливі гроші?**» → повторіть слово («свобода… що вона означає для вас?») і розпитайте: «Що ще спадає вам на думку?»',
      pojistky: '«Які у вас зараз **страхові договори** — життя, від нещасних випадків, майна, авто? Для кожного мене цікавить страховик, номер договору, місячний платіж і річниця.» Після збереження договори з’являться в теці клієнта, і з них одразу можна згенерувати відмову.',
      prijmy: '«Ще один дуже важливий ресурс для досягнення ваших цілей — **ваші доходи**. Скільки ви отримуєте щомісяця з роботи?» (бонуси = середнє за 2–3 роки)',
      rizika: '«У межах фінансового плану ми подивимося і на ваш **захист**. Пройдемо, що у вас є сьогодні — **що він покриває, а що ні**. Перевіримо, чи можна **заощадити** або застрахуватися розумніше. І я покажу, як захист виглядатиме в **усьому плані**: родина, цілі, резерв.»',
      vydaje: '«Скільки, на вашу думку, ви здатні щомісяця **заощадити**?» — не розбирайте витрати до дрібниць. Перевірка: витрати ≈ бажана рента; доходи − витрати = вільний грошовий потік.',
      zavazky: '«Важлива інформація для досягнення цілей — це **зобов’язання**. Спершу іпотечні кредити — кредити на житло, потім інші.»',
      zaver: '«Чи є щось важливе, про що я забув запитати? {veta}»',
      zdroje: '«**Ще одне джерело** для досягнення ваших цілей — **гроші, які ви вже маєте**: будівельні заощадження, пенсійні заощадження, інвестиції, рахунки та майно. Пройдімо їх разом — почнемо з будівельних заощаджень. Користуєтеся ними?»',
    },
    smazatDite: 'Видалити дитину',
  },
  /* BLOK:analyzaStranka END */
  /* BLOK:kinoMetodika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoMetodika: {
    APPROVED: 'З даних клієнта',
    CANDIDATE: 'Очікує схвалення методики',
    PROVISIONAL: 'Робоче твердження — без підтвердженого джерела',
  },
  /* BLOK:kinoMetodika END */
  /* BLOK:analyzaPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrijmy: {
    bonusy: 'Бонуси / 13-та зарплата (річно)',
    chybiJmeno: 'немає імені',
    domacnost: 'Спільне для домогосподарства',
    forma: 'Форма доходу',
    jinaForma: 'внесено раніше — належить до іншої форми, перенесіть або видаліть',
    klient: 'Клієнт {n}',
    osobaCelkem: 'Дохід особи за місяць',
    pasivni: 'Пасивні доходи (оренда…)',
    pole: {
      davky: 'Пенсія, батьківська допомога, виплати',
      mzdaFirma: 'Чиста зарплата у власній фірмі',
      ostatniJiny: 'Підробітки, аліменти та інше',
      osvcOstatni: 'Підприємництво (OSVČ) та інше',
      podilyFirma: 'Частка прибутку та інше',
      podnikani: 'Чистий дохід від підприємництва',
      vedlejsiOsvc: 'Додаткові доходи (зарплата, пенсія, батьківська допомога)',
      vedlejsiZam: 'Додаткові доходи (підробітки, аліменти, підприємництво)',
      zamestnani: 'Чистий дохід від роботи за наймом',
    },
    poleKlient: '{pole} — клієнт {n}',
    prace: 'Ким працює',
    pracePh: 'напр. водій, бухгалтерка, власний ресторан',
    pridatDruhou: 'Друга особа',
    pridatVedlejsi: 'Додатковий дохід',
  },
  /* BLOK:analyzaPrijmy END */
  /* BLOK:prebytekModel START — generuje scratchpad/slovnik.py, ručně needitovat */
  prebytekModel: {
    mesicneProCile: 'Щомісяця на цілі',
    neodsouhlaseno: 'ще не погоджено з клієнтом',
    planNespocita: 'Без доходів план не порахувати — додайте доходи або погоджену суму.',
    planPocita: 'План поки рахує з {castka}',
    pravidloNula: 'Платежі за кредитами забирають увесь дохід, тож план не має звідки взяти навіть 20 % доходу. Додайте в аналіз витрати або суму, яку ви погодили з клієнтом.',
    zdrojDopocet: 'модель: доходи − витрати − платежі',
    zdrojPravidlo: 'модель: 20 % чистого доходу',
  },
  /* BLOK:prebytekModel END */
  /* BLOK:vysvetleniInfo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vysvetleniInfo: {
    aria: 'Пояснення: {nazev}',
    cipVyberteOsobu: 'виберіть особу в полісі',
    jakCistPredAPo: 'Як читати порівняння',
    jakSeCastkyPocitaji: 'Як розраховуються суми',
    rucniKratce: 'Ціни та суми змініть олівцем',
  },
  /* BLOK:vysvetleniInfo END */
  /* BLOK:cilDeti START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilDeti: {
    doAnalyzy: 'Додати в аналізі',
    pridat: 'Додати дитину',
    upozorneni: 'Є ціль для дітей, але жодної дитини не внесено — додайте її (ім’я, дата народження).',
  },
  /* BLOK:cilDeti END */
  /* BLOK:cilHned START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHned: {
    badgeNavrh: 'пропозиція',
    bezMesicniInvestice: 'без щомісячної інвестиції',
    bezMesicniInvesticeVelke: 'Без щомісячної інвестиції',
    brzdaChybi: 'Решту {chybi} сьогоднішні джерела не покриють — оберіть інше джерело, перенесіть термін або дозаощадьте з профіциту.',
    coSTim: 'Що з цим робити:',
    dalsiZdroj: 'інше джерело додайте в аналізі (рахунки, строковий вклад, будівельні заощадження)',
    doMesKDispozici: 'Доступно протягом ~{mesicu} міс.:',
    dosporeni: 'Дозаощадження з профіциту',
    dosporitNabidka: 'дозаощадити {castka} щомісяця протягом {mesicu} міс.',
    hnedKDispozici: 'Доступно зараз:',
    jakBezMesicni: 'Рішення: поки без щомісячної інвестиції.',
    jakDosporit: 'Рішення: {jedn} одноразово з джерел і {prav} щомісяця протягом {mesicu} міс.',
    jakDosporitBezZdroju: 'Рішення: {prav} щомісяця протягом {mesicu} міс.',
    krytoJenZeZdroju: 'ціль «зараз» покривається лише з грошей, які клієнт має.',
    mesicu: 'міс.',
    nulaRespektovana: 'Без щомісячної інвестиції — рішення консультанта, пропозиція не повертається.',
    odebratZdroj: 'Не брати це джерело на цю ціль',
    poDobu: 'протягом',
    poMesicich: 'Через {mesicu} міс. дозаощадження:',
    pocetMesicu: 'Кількість місяців',
    posunoutNaRok: 'перенести термін на 1 рік',
    povinnaRezerva: 'Обовʼязковий ліквідний резерв',
    prebytekNestaci: 'на дозаощадження немає вільного профіциту',
    pridatZdroj: 'Додати джерело:',
    rozdelovnikHned: 'Ціль «зараз» покривається лише з джерел — дозаощадження з профіциту обирається в картці цілі в Пропозиції рішення.',
    terminSankce: 'дострокове зняття може коштувати штраф',
    vychaziDoMes: '— з джерел протягом ~{mesicu} міс.',
    vychaziHned: '— одразу з джерел.',
    vychaziSDosporenim: '— з джерел і з дозаощадження.',
    vysledekChybi: 'Доступно зараз {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekChybiDoMes: 'Доступно протягом ~{doMes} міс. {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekDosporitChybi: 'Зараз {hned}, через {mesicu} міс. дозаощадження {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekDosporitChybiDoMes: 'Протягом ~{doMes} міс. {hned}, через {mesicu} міс. дозаощадження {konec} — бракує {chybi} ({pct} % цілі).',
    vysledekDosporitOk: 'Зараз {hned}, через {mesicu} міс. дозаощадження {konec} — ціль покрита на {pct} %.',
    vysledekDosporitOkDoMes: 'Протягом ~{doMes} міс. {hned}, через {mesicu} міс. дозаощадження {konec} — ціль покрита на {pct} %.',
    vysledekOk: 'Доступно зараз {konec} — ціль покрита на {pct} %.',
    vysledekOkDoMes: 'Доступно протягом ~{doMes} міс. {konec} — ціль покрита на {pct} %.',
    zVasichPenez: 'з ваших грошей',
    zadneZdroje: 'Немає — клієнт не має миттєво доступних грошей.',
    zdrojTermin: 'Строковий вклад',
  },
  /* BLOK:cilHned END */
  /* BLOK:zdrojNazev START — generuje scratchpad/slovnik.py, ručně needitovat */
  zdrojNazev: {
    bezny: 'поточний рахунок',
    fondy: 'фонди та інвестиційне страхування життя',
    fondyRezerva: 'буде поповнено з фондів',
    fondyUzel: 'Фонди та інвестиційне страхування життя',
    fondyZbytek: 'залишок після поповнення резерву',
    hotovost: 'готівка',
    penzijko: 'пенсійні накопичення (DPS — доступні з {vek} років)',
    sporici: 'ощадний рахунок',
    stavebko: 'будівельні заощадження',
    stavebkoZruseni: 'скасування триває ~{mesicu} міс.',
    termin: 'строковий вклад',
  },
  /* BLOK:zdrojNazev END */
  /* BLOK:navrhC9 START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhC9: {
    krokyUvodBezPlanu: 'Що зробити, у такому порядку:',
  },
  /* BLOK:navrhC9 END */
  /* BLOK:metodikaPlanu START — generuje scratchpad/slovnik.py, ručně needitovat */
  metodikaPlanu: {
    bezZmeny: 'Для цього клієнта цифри не зміняться.',
    coJeJinak: 'Що в новій методиці інакше:',
    coSeZmeni: 'Що зміниться після перерахунку для цього клієнта:',
    coSeZmenilo: 'Що змінилося після перерахунку для цього клієнта:',
    dalsiCile: 'Інші цілі:',
    dalsiZmeny: 'Інші зміни та що в новій методиці інакше',
    mesicne: 'щомісяця',
    prepocitano: 'Перераховано за новою методикою.',
    prepocitat: 'Перерахувати за новою методикою',
    pruhStary: 'План розраховано за методикою, чинною до {datum}.',
    vraceno: 'План знову рахує за методикою до {datum}.',
    vratit: 'Повернути початковий розрахунок',
    vratitTitulek: 'Повернути можна, доки ви не підете зі сторінки пропозиції.',
    zmenaAkontaceSK: 'Словаччина: перший внесок за правилами NBS — при купівлі до кінця 2026 року гарантовано 80 % LTV, з 2027 року 10 % вистачить лише для першого житла: кожному позичальникові не більше 35 років (другий клієнт без дати народження умову не виконує), жодної квартири чи будинку для проживання або оренди і жодної іпотеки в зобов’язаннях.',
    zmenaAkontaceVek: 'Перший внесок 10 % (виняток для молодих) оцінюється за віком у рік купівлі (сьогоднішній вік + роки до цілі), а не за сьогоднішнім віком.',
    zmenaCilBezTerminu: 'Ціль без строку не отримує гроші з рахунків ані щомісячну суму — у виходах буде «доповніть строк», а гроші залишаться цілям зі строком.',
    zmenaCilHned: 'Ціль „зараз“ (0 років) покривається лише з грошей, які клієнт має — щомісячну інвестицію система сама не додасть, лише запропонує.',
    zmenaDosporeniStupne: 'Після поповнення резерву за вибрану кількість місяців інші цілі отримують вивільнені гроші від кінця поповнення — поступово, а не найменшу суму на весь час. Збільшення і рік, з якого воно діє, друкуються в Повному плані та на 1 сторінці.',
    zmenaFondyDoRenty: 'Пайові фонди, акції та страхування життя з викупною сумою, які клієнт уже має, йдуть до першої ренти — лише один раз, навіть якщо рент дві — і до її початку зростають за профілем ренти. Консультант може в потоці грошей направити їх на іншу ціль. Раніше план не призначав їх жодній цілі.',
    zmenaFondyDoRezervy: 'Якщо клієнту бракує резерву, а він має пайові фонди, ETF або акції, план спершу поповнить із них бракуючу частину резерву (лише її, ніколи більше), і лише решта фондів іде до ренти. Інвестиційне страхування життя до резерву не йде — викупна сума виплачується лише після розірвання договору. Раніше всі фонди йшли до ренти, а резерв чекав на донакопичення з надлишку.',
    zmenaHrubaZCiste: 'Лікарняні (непрацездатність) рахуються з брутто-зарплати, обчисленої з чистої за податками й внесками 2026 (за діапазонами), а не з чистої × 1,39. Особа з доходом, молодша 22 років, має право на пенсію по інвалідності.',
    zmenaInvaliditaBezPrijmu: 'Батько/мати без доходу має покриття інвалідності лише на 20 % вищі витрати домогосподарства мінус пенсія по інвалідності, якщо має право — однаково для першої і другої особи.',
    zmenaInvaliditaNikdoNevydelava: 'Коли в домогосподарстві ніхто не заробляє, покриття інвалідності не розраховується і план напише «без доходу – покриття інвалідності не розраховуємо, додайте дохід».',
    zmenaInvaliditaNulaTisk: 'Батько/мати без доходу, кому пенсія по інвалідності покриє на 20 % вищі витрати домогосподарства, має в повному плані й на 1 сторінці в інвалідності 0 Kč із причиною (раніше «—»).',
    zmenaInvalidniDuchod: 'Державна пенсія по інвалідності: для особи з доходом — середня (у Чехії 13 000 Kč на місяць), консультант може змінити її на картці — а не розрахунок із зарплати. Без права — 0, без доходу — законний мінімум.',
    zmenaMajetekMzda: 'Відповідальність працівника друкується з лімітом лише з брутто-зарплати, яку консультант ввів або підтвердив — оцінка з нетто-зарплати залишається на екрані консультанта, а в плані стоїть „ліміт після введення зарплати“. Після зміни страхової суми ціна страхування майна не входить ні до суми, ні до друку, доки консультант її знову не підтвердить.',
    zmenaMajetekNahrada: 'Чинне страхування майна (домашнє майно, нерухомість, відповідальність) у плані вивільняється лише тоді, коли нова майнова угода має ціну від консультанта — тоді план рахує заміну повністю: старий платіж вивільнить, а ціну нової відніме. Раніше скасування рахувалося як вивільнені гроші разом зі страхуванням життя, навіть коли ціни нової угоди не було.',
    zmenaMajetekSmlouvy: 'Страхування майна друкується в плані за договорами й лише з ціною з пропозиції страховика; орієнтовна оцінка залишається тільки на екрані консультанта.',
    zmenaMiraOdkladani: 'Норма заощаджень у Пропозиції, у бюджеті плану та в презентації — те саме число, що й в аналізі: погоджена сума (без неї вільні гроші з доходів і витрат) плюс регулярні внески на заощадження та інвестиції, поділені на чистий дохід. Раніше лише надлишок після страхових внесків, поділений на дохід, без внесків.',
    zmenaOchranaNadPrebytek: 'Коли захист дорожчий за надлишок, сума, якої бракує, видна в графіку «Грошовий потік у часі», у написі про дефіцит, у бюджеті плану, у Поточному огляді, у презентації та в Підсумку. Раніше внесок обрізався до розміру надлишку, і гроші, яких бракувало, зникали.',
    zmenaPartnerBezNarozeni: 'Партнер без дати народження: план не розраховує його захист (смерть, інвалідність, хвороба, травма, ані ціну), а у виходах буде «не розраховано — бракує дати народження». Його чинні договори план не скасовує. Раніше покриття партнера рахувалося і без дати народження.',
    zmenaDveCesty: 'Графік «Без плану і з планом» порівнює ті самі гроші плану — інвестовані та на ощадному рахунку, зі смугою гіршого й кращого сценарію та лінією після комісій; план із дефіцитом графік не малює. Раніше графік інвестував увесь капітал без виплат на цілі.',
    zmenaAlokaceFichtner: 'Розподіл грошей цілі (акції, облігації, готівка) визначає таблиця за ризиковим профілем і кількістю років до цілі, а не поступовий продаж акцій. Останній рік перед ціллю тримає 97 % у готівці та 3 % в облігаціях (у динамічного профілю 71 % і 29 %). Рента до початку виплат має частку акцій за профілем і роками до початку виплат (збалансований профіль, 15 і більше років: 88 %), раніше наближалася до 50 % акцій. Тому щомісячні суми цілей зміняться: у консервативного та збалансованого профілю короткі цілі трохи подорожчають, рента у збалансованого й динамічного профілю вийде дешевшою.',
    zmenaPenzijkoDoRenty: 'Пенсійні заощадження не розриваються: якщо рента починається раніше, ніж їх виплата (у Чехії з 60 років), рента до виплати йде з інших грошей, а з виплати зросте на заощадження (4 % на рік від їх вартості) — без втрати державних внесків. Раніше заощадження, виплачені після початку ренти, до ренти не враховувалися зовсім.',
    zmenaPojistneMajetku: 'Ціна нового страхування майна (домогосподарство, нерухомість, відповідальність) від консультанта належить до обов’язкових платежів і віднімається з надлишку повністю, як і страхування життя. Розірваний старий договір майна й далі рахується як заощадження. Раніше віднімалася лише різниця при заміні розірваного договору.',
    zmenaNizsiVarianty: 'Варіанти «Обмежити себе» та «Вирішує лише ціна» тепер знижують і непрацездатність, і тяжкі захворювання: денна виплата покриває лише необхідні витрати та платежі за кредитами (замість усього доходу), тяжкі захворювання знижуються в тій самій пропорції, що й інвалідність. Раніше вони лишалися як у варіанті «Для вимогливих».',
    zmenaPenzijkoJednou: 'Пенсійні заощадження та одноразовий дохід без визначеної цілі отримує лише перша рента за порядком — дві ренти вже не розділять ту саму крону двічі.',
    zmenaPotrebaRenty: 'Рента без заданої цілі рахується як в аналізі: сьогоднішні витрати без власних внесків на заощадження плюс платежі за кредитами, які триватимуть і в ренті. Іпотека, виплачена до ренти (за датою закінчення, інакше за оцінкою із залишку, ставки й платежу), не рахується, інші кредити залишаються. Раніше рента = усі сьогоднішні витрати без платежів.',
    zmenaProfilCile: 'Власний ризиковий профіль цілі діє і в розрахунку — картка цілі та всі виходи показують для цілі однаковий відсоток.',
    zmenaRenta13: 'Старий розрахунок спрямовує гроші на ренту лише з 13-го місяця — перший рік увесь надлишок іде на поповнення резерву.',
    zmenaRentaNavyseni: 'Збільшення ренти з грошей, вивільнених після виконання попередніх цілей, друкується в Повному плані та на 1 сторінці разом з роком, з якого діє — як в інших цілей.',
    zmenaRezervaJednoCislo: 'Резерв має в усьому плані одне число: ціль точно за формулою з аналізу (без округлення до 10 000), а що клієнт має, скільки бракує і на скільки відсотків він наповнений, рахує одна функція — разом з будівельним заощадженням, яке надійде протягом ~4 місяців.',
    zmenaRucniCastka: 'Щомісячна сума, введена вручну в цілі, діє і в розрахунку — друкується в повному плані, на 1 сторінці, у підсумку та презентації, а інші цілі отримують решту.',
    zmenaRucniNula: 'Видалена щомісячна сума в цілі діє і в розрахунку — вивільнені гроші отримають інші цілі.',
    zmenaRustMzdySchodek: 'Якщо родина сьогодні витрачає більше, ніж заробляє, зростання зарплати спочатку покриє цей дефіцит — цілі та платіж за кредитом отримають лише те, що залишиться. Раніше все зростання зарплати йшло на цілі.',
    zmenaSkoreZajisteni: 'Показник фінансового здоровʼя не рахує порожні рядки майнових ризиків як зазначене забезпечення — без зазначеної суми ця складова показника не рахується (раніше 20 балів за порожній шаблон).',
    zmenaSmrtBezMinima: 'Покриття на випадок смерті у великому аналізі лише капітальним методом, без мінімуму (мінімум лише в Аналізі для в’єтнамців).',
    zmenaSpatneDluhy: 'Крок „Позбутися поганих боргів“ враховує лише кредити на вкладці Особисті кредити — споживчі кредити, кредитні картки, овердрафти, револьверні кредити, особистий лізинг і старші рядки без вибраного типу. Іпотека та кредити на вкладці Бізнес-кредити до поганих боргів не належать.',
    zmenaSplatkaUveru: 'Після отримання кредиту платіж віднімається з грошей на інші цілі та ренту (у житла додається оренда з розпису витрат, яка після купівлі відпадає). Якщо платіж перевищує бюджет, план напише, з якого часу і скільки бракує.',
    zmenaSrovnaniStejnyZaklad: 'Графік „без плану і з планом“ у презентації починає обидві криві з того самого фінансового майна; незадіяне майно росте так само, як задіяне, а інфляція становить 2,5 % за методикою (раніше зелена крива починалася лише з грошей, призначених цілям, а червона рахувала 2,7 %).',
    zmenaUverSpotrebitelsky: 'Авто та інші цілі в кредит поза житлом рахують платіж споживчого кредиту або кредиту з будівельних заощаджень (строк щонайбільше 12 років, орієнтовна ставка), а не іпотеки на 30 років.',
    zmenaZajisteniVzdy: 'План завжди враховує захист доходу — попереднє «Ні» клієнта з аналізу вже не вилучає страхову премію з профіциту.',
    zmenaZamestnavatel: 'Внесок роботодавця враховується і у відкладанні, і в доході: норма заощаджень = (погоджена сума або вільні гроші + власні внески + внесок роботодавця) поділити на (чистий дохід + внесок роботодавця). Раніше лише у відкладанні, тож норма виходила трохи вищою.',
    zmenaZdrojeHned: 'Резерв і ціль із горизонтом „зараз“ (0 років) беруть поточний рахунок, ощадний рахунок, готівку, строковий вклад і будівельні заощадження (у такому порядку).',
  },
  /* BLOK:metodikaPlanu END */
  /* BLOK:prahyOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  prahyOdkladani: {
    flagPodMinimem: 'Відкладає ~{pct} % доходу — мінімум {min} %, ідеал {ideal} %',
    hladina: {
      ideal: 'ідеал',
      minimum: 'мінімум',
      pod: 'нижче мінімуму',
      rychle: 'швидко до цілей',
    },
    novyCrm: {
      chybiDoMinima: 'До мінімуму {min} % бракує {castka} на місяць',
      minimumDoIdealu: 'Мінімум {min} % виконано · до ідеалу {ideal} % бракує {castka}',
    },
    plan: {
      cileIdeal: 'ЦІЛІ — ідеал {ideal} %',
      pravidlo503020: 'Правило 50/30/20: ~50 % обовʼязкові витрати, 30 % спосіб життя, 20 % відкладати на цілі та ренту. Мінімум {min} %, при {rychle} % цілі виконуються дуже швидко. Детальний розпис витрат розбираємо на сервісній зустрічі.',
    },
    rozpocet: {
      ideal: '✓ ідеал {ideal} %',
      minimum: '✓ мінімум {min} % · ідеал {ideal} %',
      nezname: 'дохід невідомий · мінімум {min} %',
      pod: '▲ нижче мінімуму {min} %',
      rychle: '✓ {rychle} % і більше — цілі виконуються швидко',
      vcVkladu: 'вкл. внески {castka}',
    },
  },
  /* BLOK:prahyOdkladani END */
  /* BLOK:rozpisPanel START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisPanel: {
    hotovo: 'Готово',
    kicker: 'Детальний розпис · пункт за пунктом',
    prijmy: {
      nadpis: 'Доходи домогосподарства',
    },
    vydaje: {
      nadpis: 'Витрати родини',
    },
    zavrit: 'Закрити',
  },
  /* BLOK:rozpisPanel END */
  /* BLOK:planCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  /* BLOK:rustMzdyEfekt START — generuje scratchpad/slovnik.py, ručně needitovat */
  rustMzdyEfekt: {
    klikNedosahne: 'Після натискання «{tlacitko}» рента не зміниться — гроші з кроків бере інша ціль або вони надійдуть лише після початку ренти.',
    klikUver: 'Після натискання «{tlacitko}» рента не зміниться — зростання зарплати поглине платіж за кредитом: з {rok} р. на нього навіть зі зростанням бракує {chybi} щомісяця.',
    konec: '{horizont}: {bez} → {ted}',
    krokRocne: 'Крок = +{pct} % доходу раз на {obdobi} (≈ {rocne} % на рік).',
    nepocitaBezMesicni: 'Рента без щомісячної інвестиції — кроки зростання зарплати до неї не зараховуються.',
    nepocitaBezTerminu: 'Рента не має терміну — до розподілу грошей не входить, навіть зі зростанням зарплати.',
    nepocitaHned: 'Рента з терміном «зараз» не примножується — зростання зарплати її не змінить.',
    nepocitaNedosahne: 'Зростання зарплати, яке зараз є в плані, до цієї ренти не дійде — гроші з нього бере інша ціль або вони надійдуть лише після початку ренти.',
    nepocitaRezim: 'Для ренти вибрано режим розв’язання — кроки зростання зарплати до неї не зараховуються. Щоб зараховувалися, натисніть у ренти „назад до початкової пропозиції“.',
    nepocitaSplneno: 'Рента виходить і без зростання зарплати ({bez} %).',
    nepocitaUver: 'Зростання зарплати, яке зараз є в плані, до ренти не дійде — його поглине платіж за кредитом: з {rok} р. на нього навіть зі зростанням зарплати бракує {chybi} щомісяця.',
    poHorizontu: 'Кроки з {roky} р. починаються лише з початком ренти — до неї не зараховуються.',
    poKliku: 'Після натискання «{tlacitko}»: рента з {pred} % до {po} %',
    poKlikuBezZmeny: 'Після натискання «{tlacitko}» рента не зміниться.',
    radekNepocita: 'у плані ({n} кроків), але до ренти не зараховуються',
    toastNepocita: 'Заповнено кроків зростання зарплати: {pocet} — рента від цього не зміниться, чому — пише картка ренти біля рядка «Зростання зарплати».',
    toastPredvyplneno: 'Заповнено кроків зростання зарплати: {pocet} — рента {pred} % → {po} %.',
    toastPredvyplnenoBezRenty: 'Заповнено кроків зростання зарплати: {pocet} — скоригуй під клієнта.',
    toastPredvyplnenoVice: 'Заповнено кроків зростання зарплати: {pocet} — {zmeny}.',
    toastUzVPlanu: 'Кроки зростання зарплати вже є в плані й відповідають налаштуванням — нічого не змінюється. Рента з ними рахує: {ted} % (без них {bez} %).',
    toastUzVPlanuBezCisel: 'Кроки зростання зарплати вже є в плані й відповідають налаштуванням — нічого не змінюється.',
    toastUzVPlanuNepocita: 'Кроки зростання зарплати вже є в плані — нічого не змінюється. Але до ренти вони не зараховуються, чому — пише картка ренти біля рядка «Зростання зарплати».',
    toastUzVPlanuVice: 'Кроки зростання зарплати вже є в плані й відповідають налаштуванням — нічого не змінюється. Без них → з ними: {renty}.',
    vPlanu: 'Зростання зарплати в плані піднімає ренту з {bez} % до {ted} %',
  },
  /* BLOK:rustMzdyEfekt END */
  planCil: {
    akontaceDo2026: 'При купівлі у {rok} році у Словаччині гарантовано 80 % кредиту (20 % власних коштів) — ні вік, ні перше житло не впливають.',
    akontaceK2BezVeku: 'Другий клієнт не має дати народження — умову 10 % має виконати кожен позичальник, тому рахуємо 20 %. Додайте дату народження в аналізі.',
    akontaceNemovitost: 'За аналізом клієнт має квартиру чи будинок (для проживання або оренди) або сплачує іпотеку — у Словаччині з 2027 року 10 % вистачить лише для першого житла, тому 20 %.',
    doplnenoAutomaticky: 'додано автоматично',
    jakJednZatim: 'Рішення: {jedn} одноразово, щомісяця поки нічого додатково.',
    jakZatimNic: 'Рішення: щомісяця поки нічого додатково.',
    krokNavyseni: 'З {mesic}-го місяця ({rok} р.) збільшити на {o} до {celkem} на місяць.',
    krokRadek: 'з {rok} р. +{o}',
    krokZacatek: 'З {mesic}-го місяця ({rok} р.) надсилати {celkem} на місяць.',
    nbsAkontace2027: 'NBS: при купівлі до кінця 2026 року гарантовано 80 % (20 % власних коштів), 90 % лише в межах квоти банку. З 2027 року 10 % вистачить лише для першого житла до 35 років без іншої житлової нерухомості (для проживання чи здачі в оренду). 100% фінансування — рішення консультанта: 10 % ціни покриває кредит із будівельних заощаджень. Платіж з’явиться в грошовому потоці лише з моменту отримання кредиту',
    profilMimoVypocet: 'Розрахунок і друк поки рахують із профілем плану — власний профіль цілі набуде чинності після перерахунку за новою методикою.',
    rucniMimoVypocet: 'Розрахунок і друк поки рахують із {castka} — сума, введена вручну, набуде чинності після перерахунку за новою методикою.',
    varianta100: '100% фінансування',
    variantaAkontace: 'Перший внесок {pct} %',
    vekVRoceKoupe: 'У рік купівлі ({rok}) клієнтові буде {vek} — саме за цим віком оцінюється перший внесок 10 %.',
    vekVRoceKoupeK2: 'У рік купівлі ({rok}) клієнтові буде {vek}, а другому клієнтові {vek2} — 10 % вистачить, лише якщо обом не більше 35 років.',
    vyrazenBezTerminu: 'Без строку ціль у розподілі грошей не враховується — доповніть строк.',
  },
  /* BLOK:planCil END */
  /* BLOK:kinoOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoOdkladani: {
    a1: {
      aria: 'Окремі витрати не розбираємо, стежимо лише за сумою, яку відкладаєте',
      kicker: 'Витрати',
      radek1: 'Витрати в деталях не розбираємо.',
      radek2: 'Стежимо за одним числом: скільки йде вбік.',
      stranou: 'Відкладено',
      stranouPopis: 'єдине число, за яким стежимо',
      tahak: '«Не будемо рахувати кожну копійку. Мені вистачить одного числа — скільки щомісяця залишається вбік.»',
      titulek: 'Справа не в кожній копійці',
      velkePopis: 'Чистий дохід домогосподарства',
    },
    a2: {
      aria: 'Три рівні відкладання',
      dnes: 'Сьогодні ви відкладаєте {pct} %.',
      dnesDohoda: 'З погодженою сумою відкладається {pct} %.',
      kicker: 'Скільки вбік',
      radek: 'При {rychle} % цілі виконуються дуже швидко.',
      tahak: '«Десять відсотків — мінімум. Двадцять — ідеал. Тридцять — і цілі виконуються дуже швидко.»',
      titulek: '{min} % мінімум, {ideal} % ідеал',
      velkePopis: '{pct} % з {prijem}',
    },
    a3: {
      aria: 'При {pct} % ({castka} на місяць) за моделлю за 30 років виросте до {fv}, з них вкладено {vlozeno}.',
      kicker: 'Ваше число',
      nejistota: 'Модель за профілем плану ({profil}), у сьогоднішніх грошах, без комісій і податків. Дохідність не є певною — може бути вищою чи нижчою.',
      radekCas: 'Решту робить час — модель, а не обіцянка.',
      radekNula: 'Без відкладання нічого не виросте.',
      radekVlozite: 'Ви вкладете {castka}.',
      tahak: '«Це модель, а не обіцянка. Але вона показує, що роблять час і регулярність.»',
      titulek: 'Скільки з цього може вирости',
      velkePopis: 'за 30 років · модель',
      vlozeno: 'вкладено',
      vynos: 'дохідність',
    },
    a4: {
      aria: 'При {pct} %: {popis}.',
      cilBezNazvu: 'Ціль',
      cilRenta: 'Рента',
      cilRezerva: 'Резерв',
      dalsiCile: '+ інші цілі: {n}, вчасно {splneno}',
      dnes: 'зараз',
      hned: 'одразу',
      kTerminu: 'до терміну лише {pct} %',
      kTerminuSplneno: 'до терміну',
      kicker: 'Ваші цілі',
      nejistota: 'Той самий розрахунок, що й у Пропозиції рішення: дохідність за профілем плану, порядок цілей за планом. Модель, а не обіцянка.',
      radekHladina: '{pct} % → {n} з {celkem} цілей вчасно',
      radekHladinaVse: '{pct} % → усі цілі вчасно ✓',
      rezervaZUspor: 'із заощаджень, зараз {pct} %',
      tahak: '«Подивіться, як із відсотком зсувається, коли у вас буде резерв, житло і рента.»',
      titulek: 'Що виконається і коли',
      velke: '{n} з {celkem}',
      velkePopis: 'цілей виконаєте вчасно',
    },
    a5: {
      aria: 'Із зарплати {prijem} наступного дня йде {stranou} вбік, {zivot} залишається на життя.',
      denPo: 'наступного дня після зарплати',
      kicker: 'Почніть',
      naZivot: 'На життя',
      radek: 'Те, що залишиться, витрачайте спокійно.',
      stranou: 'Відкласти',
      tahak: '«Найкраще це працює автоматично — постійне доручення наступного дня після зарплати, і більше про це не думаєте.»',
      titulek: 'Спершу собі, потім рахункам',
      velkePopis: 'постійним дорученням наступного дня після зарплати',
      vyplata: 'Зарплата',
    },
    doplnPrijmy: 'Додайте доходи, і ми це порахуємо',
    jezdec: {
      aria: 'Скільки відсотків доходу відкладати',
      dnes: 'зараз',
      mesicne: 'на місяць',
      odkladate: 'Ви відкладаєте',
      valuetext: '{pct} %, {castka} на місяць',
    },
    nazev: 'Витрати та відкладання',
    prezTlacitko: 'Запустити кіно: витрати та відкладання',
    prijmy: {
      a2Tahak: '«Перевірене правило: половина на необхідне, третина на життя і п’ята частина вбік на майбутнє. Мінімум — десята частина.»',
      a3BezVydaju: 'Додайте витрати, і ми порахуємо, скільки ви насправді відкладаєте.',
      a3Ideal: 'Зараз ви відкладаєте ~{pct} % — це ідеал. ✓',
      a3Minimum: 'Зараз ви відкладаєте ~{pct} % — мінімум є, до ідеалу {ideal} % бракує {chybi} на місяць.',
      a3Pod: 'Зараз ви відкладаєте ~{pct} % — до мінімуму {min} % бракує {chybi} на місяць.',
      a3Rychle: 'Зараз ви відкладаєте ~{pct} % — цілі виконаються дуже швидко. ✓',
      a3Tahak: '«Витрати детально розпишемо на сервісній зустрічі. Зараз важливо одне — щоб убік ішло щонайменше десять відсотків, ідеально двадцять.»',
      a3VelkePopis: 'Ідеально стільки щомісяця вбік',
      a6Radek3: 'Мінімум {min} %, ідеал {ideal} % — головне почати.',
    },
    profil: {
      dynamicky: 'динамічний',
      konzervativni: 'консервативний',
      vychozi: '{profil}, типовий',
      vyvazeny: 'збалансований',
    },
    rokyFew: '{n} роки',
    rokyMany: '{n} років',
    rokyOne: '{n} рік',
    tlacitko: 'Кіно відкладання',
    tlacitkoTitle: 'Відтворити кіно: витрати та відкладання',
    utraty: {
      bydleni: 'Житло',
      deti: 'Діти',
      doprava: 'Транспорт',
      dovolena: 'Відпустка',
      energie: 'Енергія',
      jidlo: 'Їжа',
      obleceni: 'Одяг',
      restaurace: 'Ресторани',
    },
    zaRokyFew: 'за {n} роки',
    zaRokyMany: 'за {n} років',
    zaRokyOne: 'за {n} рік',
  },
  /* BLOK:kinoOdkladani END */
  /* BLOK:vodopad START — generuje scratchpad/slovnik.py, ručně needitovat */
  vodopad: {
    coKdyby: {
      naBudoucnost: 'На майбутнє',
      presah: 'На {castka} більше, ніж залишається — довелося б урізати витрати на життя.',
      prijmu: 'доходу',
      startDnes: 'сьогодні',
      startDohoda: 'домовленість',
      tlacitko: 'А якби на майбутнє йшло більше',
      valuetext: '{pct} % доходу, {castka} на місяць',
      zVolnych: 'З вільних грошей',
      zbyva: 'Залишається вільно',
      zpetDnes: 'Назад до сьогодні',
      zpetDohoda: 'Назад до домовленості',
    },
    grafSelhal: 'Графік не вдалося відобразити — числа є в огляді.',
    klikRadek: 'Торкніться рядка = позиції',
    klikSloupec: 'Клік на стовпець = позиції',
    majetek: {
      celkem: '= Майно разом',
      celkemPod: 'сума обох',
      ciste: '= Чиста вартість',
      cistePod: 'належить родині',
      cisteZapPod: 'борг перевищує майно',
      dedictvi: 'Спадщина',
      fin: '+ Фінансові',
      finPod: 'заощадження, інвестиції, рахунки',
      kat: {
        dedictvi: 'Спадщина',
        firma: 'Бізнес',
        kzp: 'Накопичувальне страхування життя',
        nemovitosti: 'Нерухомість',
        opf: 'Фонди та ETF',
        penzijko: 'Пенсійні заощадження',
        stavebko: 'Будівельні заощадження',
        ucty: 'Рахунок',
        zavazkyB: 'Кредит на житло',
        zavazkyO: 'Кредит',
      },
      nadpis: 'Підсумок майна',
      nefin: 'Нефінансові',
      nepocita: 'поки не враховується',
      podily: '{rodina} % майна належить родині, {banka} % банку.',
      pointa: 'Після вирахування боргів вам із майна залишається {castka}.',
      pointaBezJistiny: 'У боргів бракує залишку основного боргу — наскільки вони зменшують майно, поки не знаємо.',
      pointaBezZavazku: 'Майно разом {castka} — зобов’язання ще не введені.',
      pointaPrazdne: 'Ані майно, ані зобов’язання ще не введені.',
      pointaZaporne: 'Борги перевищують майно на {castka}.',
      zavazky: '− Зобов’язання',
      zavazkyPod: 'залишки основного боргу',
    },
    navic: 'Позиції перевищують стовпець на {castka}',
    nerozepsano: 'Без розпису по позиціях',
    penize: {
      bonusy: 'Бонуси (щомісяця)',
      chybiPrijmy: 'Додайте доходи — без них вільні гроші не показуємо.',
      chybiVydaje: 'Додайте витрати — без них вільні гроші не показуємо.',
      dilNaBudoucnost: 'на майбутнє {castka}',
      dilPrebytek: 'надлишок {castka}',
      dilZbyva: 'залишається {castka}',
      hrdina: 'Вільні гроші',
      hrdinaSchodek: 'Дефіцит',
      jdeVam: 'ваше',
      jenUkazka: 'Лише приклад — у план не переноситься.',
      kazdyMesic: 'щомісяця',
      kicker: 'Доходи та витрати · щомісяця',
      klient: 'Клієнт {n}',
      mesicne: 'щомісяця',
      nadVolneCastka: 'понад вільні {castka}',
      nezadano: 'не введено',
      nezbytne: '− Необхідні витрати',
      nezbytnePod: 'житло, їжа, транспорт',
      nezbytnePrehled: 'Необхідні витрати',
      odkladDnes: 'Сьогодні відкладається {castka} = {pct} % доходу (внески {vklady} + вільні гроші {volne}).',
      odkladDohoda: 'Відкладається {castka} = {pct} % доходу (внески {vklady} + погоджена сума {dohoda}).',
      ostatni: '− Інші витрати',
      ostatniPod: 'дозвілля, відпустка, заощадження',
      ostatniPrehled: 'Інші витрати',
      pasivni: 'Пасивні доходи',
      pointa: 'З {prijmy} доходу після витрат і платежів вам залишається {volne}.',
      pointaSchodek: 'Витрати й платежі перевищують доходи на {castka}.',
      pokryto: 'Внески, що вже йдуть ({castka}), покривають ціль — з вільних грошей нічого додатково.',
      posuvnikNeni: 'Зараз нема з чого відкладати: щомісяця бракує {castka}. Спершу вирівняйте витрати.',
      prehrat: 'Відтворити ще раз',
      prijmy: 'Доходи',
      prijmyPod: 'чисті, за домогосподарство',
      prijmyPrehled: 'Доходи',
      schodek: '= Дефіцит',
      schodekPod: 'бракує щомісяця',
      schodekPrehled: 'Дефіцит',
      splatky: '− Платежі за кредитами',
      splatkyPod: 'кредити',
      splatkyPrehled: 'Платежі за кредитами',
      sporeni: 'Заощадження, що вже йдуть',
      sporeniNesedi: 'заощадження не сходяться',
      sporeniProuzek: 'з них заощадження {castka}',
      stranouDnes: 'сьогодні відкладається {pct} % доходу',
      stranouDohoda: 'з погодженою сумою відкладається {pct} % доходу',
      volne: '= Вільні гроші',
      volnePod: 'залишається вам',
      volnePrehled: 'Вільні гроші',
      vydaje: '− Витрати',
      vydajePod: 'необхідні ще не введені',
      vydajePrehled: 'Витрати',
      zivotniStyl: 'Спосіб життя',
    },
    prehled: 'Огляд',
    rozkliknuto: 'Розгорнуто',
    sedi: 'Сума позицій сходиться: {castka}',
    stovka: {
      kopieChyba: 'Не вдалося скопіювати речення.',
      kopirovano: 'Скопійовано',
      kopirovat: 'Копіювати',
      mesicne: '{castka} на місяць',
      nadpis: 'Із кожних 100 {sym} доходу',
      nazev: {
        budoucnost: 'Майбутнє',
        povinne: 'Обов’язкові',
        vydaje: 'Витрати й виплати',
        zbyva: 'Залишається',
        zivot: 'Життя',
      },
      nesedi: {
        dohoda: 'Погоджена сума {castka} на {nad} більша за вільні гроші, і це більше, ніж залишається на життя. Перевірте домовленість.',
        sporeniOstatni: 'Заощадження {castka} на місяць більші за інші витрати {ostatni}. Перевірте, чи заощадження внесено у витрати.',
        sporeniVydaje: 'Заощадження {castka} на місяць більші за витрати {ostatni}. Перевірте, чи заощадження внесено у витрати.',
        titul: 'Сотню поки не вдається розділити.',
        ukazka: 'Стільки на майбутнє не вийде — не вистачило б навіть усіх витрат на життя.',
      },
      podNadPrijem: '{pct} понад дохід',
      podNadVolne: '{pct} понад вільні гроші',
      podPrijem: 'дохід',
      podZbyva: 'залишається {pct}',
      pravidlo: 'Правило: обов’язкові 50–60 · майбутнє щонайменше 20 · решта на життя',
      schodekPozn: '{pct} понад дохід · щомісяця бракує {castka}',
      slozeni: {
        nadVolne: 'понад вільні {castka}',
        nezbytne: 'необхідні {castka}',
        nic: 'поки нічого',
        prebytek: 'надлишок {castka}',
        schodek: 'заощадження зараз оплачуються з боргу або із запасів',
        splatky: 'виплати за кредитами {castka}',
        sporeni: 'заощадження {castka}',
        volne: 'вільні гроші {castka} (поки без домовленості)',
        vydajeBez: 'витрати без заощаджень {castka}',
        zVolnych: 'з вільних грошей {castka}',
        zamestnavatel: 'від роботодавця {castka}',
        zivot: 'інші витрати без заощаджень',
        zivotSchodek: 'інші витрати разом із заощадженнями {castka}',
      },
      stav: {
        bezDohodyLatka: '{latka}, якщо відкласти всі вільні гроші',
        bezDohodyPod: 'менше 10 навіть з усіма вільними',
        idealSplneno: 'щонайменше 20 виконано',
        latkaIdeal: 'щонайменше 20',
        latkaMinimum: 'мінімум 10',
        minimumSplneno: 'мінімум 10 виконано · до 20 бракує {castka}',
        nadVolneLatka: '{latka}, лише якщо з життя урізати {castka}',
        nadVolnePod: 'менше 10 навіть з урізанням життя',
        neniZCeho: 'зараз нема з чого',
        nezbytneNezadane: 'необхідні не введено',
        pod: 'менше 10 · до 10 бракує {castka}',
        povinneNad: 'понад рекомендовані 60 на {n}',
        povinnePod: 'менше 50',
        povinneV: 'у рекомендованих 50–60',
        zivotMene: 'на {castka} менше, ніж зараз',
      },
      ukazka: 'приклад',
      veta: {
        bezDohody: '{zac}, а решту {b} можете відкласти на майбутнє.',
        bud: '{zac}, а {b} відкладаєте на своє майбутнє.',
        budZbyvaFew: '{zac}, {b} відкладаєте на своє майбутнє, і ще {zb} поки залишаються.',
        budZbyvaMany: '{zac}, {b} відкладаєте на своє майбутнє, і ще {zb} поки залишається.',
        budZbyvaOne: '{zac}, {b} відкладаєте на своє майбутнє, і ще {zb} поки залишається.',
        domluvime: 'Скільки з вільних грошей ви справді відкладете, домовимося зараз.',
        konecDobre: 'у вас є і те, і те, тож ви в доброму становищі.',
        konecDobreBez: 'щонайменше 20 на майбутнє у вас є, тож ви в доброму становищі.',
        konecMinimum: 'мінімум 10 у вас є, до ідеальних 20 бракує {castka} на місяць.',
        konecMinimumZbytek: 'мінімум 10 у вас є, до ідеальних 20 бракує {castka} на місяць — це покриєте із залишку.',
        konecNadVolne: '{latka} так виконаєте, лише на життя будете витрачати на {castka} на місяць менше, ніж зараз.',
        konecNadVolnePod: 'і так у вас менше 10, а на життя будете витрачати на {castka} на місяць менше, ніж зараз.',
        konecPod: 'зараз у вас менше 10, тож знайдімо {castka} на місяць.',
        konecPodZbytek: 'зараз у вас менше 10, бракує {castka} на місяць, і це покриєте із залишку.',
        konecPovinnePod: 'обов’язкові у вас навіть менше 50, а майбутнє понад 20, тож ви в доброму становищі.',
        pravidlo: 'Раджу 50–60 на обов’язкове і щонайменше 20 на майбутнє, решту на життя',
        pravidloNad: 'Раджу не більше 60 на обов’язкове і щонайменше 20 на майбутнє, решту на життя — обов’язкові зараз забирають більше, тому на майбутнє залишається лише {b}.',
        schodek: 'Із кожних 100 {sym}, які ви заробляєте, сьогодні витрачаєте {celkem} — щомісяця бракує {castka}, тож спершу разом упорядкуємо витрати.',
        zac: 'Із кожних 100 {sym}, які ви заробляєте, {povinne} іде на те, що мусите платити, {zivot} на життя',
        zacBez: 'Із кожних 100 {sym}, які ви заробляєте, {vydaje} іде на витрати й виплати',
      },
      vetaTitul: 'Речення для клієнта',
      zbyvaPozn: '{castka} на місяць, поки не розподілено',
      znackaBudoucnost: 'майбутнє 20+',
      znackaPovinne: 'обов’язкові 50–60',
    },
    zadnePolozky: 'Позиції ще не розписані.',
    zpetAria: 'Назад до огляду',
  },
  /* BLOK:vodopad END */
  /* BLOK:majetekSmlouvy START — generuje scratchpad/slovnik.py, ručně needitovat */
  majetekSmlouvy: {
    bezMzdaPozn: 'В аналізі немає доходу від роботи за наймом. Зарплату вводьте, лише якщо має роботодавця.',
    castkaSeZmenila: 'страхова сума змінилася — перевірте ціну',
    cenaNecitelna: 'Введіть ціну числом, наприклад 420.',
    cenaPlati: 'Ціна дійсна',
    cenaPoNabidce: 'ціна після пропозиції страховика',
    cenaSmlouvy: 'Ціна договору',
    cenaZNabidky: 'Ціна з пропозиції',
    chybiCenaFew: 'бракує ціни в {n} договорах',
    chybiCenaMany: 'бракує ціни в {n} договорах',
    chybiCenaOne: 'бракує ціни в {n} договорі',
    cipLimit: 'ліміт {limit}',
    cipNenabizet: 'не пропонувати',
    cipPripojisteni: 'додаткове страхування',
    coKryje_domacnost: 'Речі вдома.',
    coKryje_dum: 'Будинок — саму будівлю.',
    coKryje_dumDomacnost: 'Будинок і речі всередині.',
    coKryje_dumOdpovednost: 'Будинок і шкоду, яку ненавмисно заподієте іншим.',
    coKryje_majetek: 'Речі вдома та шкоду, яку ненавмисно заподієте іншим.',
    coKryje_majetekDum: 'Будинок, речі всередині та шкоду, яку ненавмисно заподієте іншим.',
    coKryje_odpovednost: 'Шкоду, яку ненавмисно заподієте іншим.',
    coKryje_podnik: 'Фірму, запаси, обладнання та шкоду клієнтам.',
    coKryje_pravni: 'Адвоката й суд, коли дійде до спору.',
    coKryje_zam: 'Шкоду, яку з необережності заподієте на роботі.',
    doplnteCenu: 'Введіть ціну від страховика',
    infoMajetek: 'Один договір, одна ціна з пропозиції страховика.',
    infoVlastni: 'Окремий договір — пункт оформлено окремо (інший страховик або інший продукт), тому має власну ціну.',
    infoZamJedna: 'Один чи два договори? За пропозицією страховика: один номер договору й одна ціна = один договір. Дві ціни = кожен свій. Ліміт кожен має окремо за своєю брутто-зарплатою.',
    kazdaSvouCenu: 'кожен має свою ціну',
    kinoBezCenFew: 'без {n} договорів, ціна прийде з пропозиції',
    kinoBezCenMany: 'без {n} договорів, ціна прийде з пропозиції',
    kinoBezCenOne: 'без {n} договору, ціна прийде з пропозиції',
    kinoBezKraceni: 'На повну вартість — без зменшення',
    kinoBlok: '1 блок = брутто-зарплата {mzda}',
    kinoBlokyAria: '{nasobek} × брутто-зарплата {mzda} — це щонайменше {limit}',
    kinoCelkem: 'Разом',
    kinoCenuDoplnime: 'ціну доповнимо з пропозиції',
    kinoChybiHodnota: 'Суми доповнимо, коли буде відома вартість — поки у відсотках від шкоди.',
    kinoCyklista: 'На велосипеді ви ненавмисно збили іншого велосипедиста',
    kinoDalsi: 'Далі',
    kinoHotovo: 'Готово',
    kinoJezdecPct: '{pct} відсотків вартості',
    kinoJezdecText: '{castka}, {pct} відсотків вартості',
    kinoKraceni: 'Страховик зменшує до {pct} % кожної шкоди',
    kinoKrok: 'Пояснення для клієнта · {i} з {n}',
    kinoMisto_doma: 'вдома',
    kinoMisto_firma: 'у фірмі',
    kinoMisto_prace: 'на роботі',
    kinoMisto_spor: 'у спорі',
    kinoNazev_odpovednost: 'Чому відповідальність з високим лімітом',
    kinoNazev_plna: 'Чому страхувати на повну вартість',
    kinoNazev_prace: 'Відповідальність на роботі',
    kinoNazev_shrnuti: 'Що оформимо',
    kinoNazev_smlouvy: 'Що покриває кожен договір',
    kinoOdpPozn: 'Ілюстрація без сум. Затоплений сусід або розбитий товар у магазині сюди теж належать. Автомобілем? Це покриває обов’язкове страхування цивільної відповідальності водія, а не цей договір.',
    kinoOdpVeta: 'Шкоду здоров’ю оплачує той, хто її заподіяв. Це не один рахунок — деякі статті оплачуються роками.',
    kinoOsa1: '1 рік',
    kinoOsa10: '10 років',
    kinoOsa20: '20 років +',
    kinoOsaAria: 'Ілюстрація без сум: лікування й біль оплачуються одразу, догляд і роками, втрата заробітку щомісяця навіть десятиліттями.',
    kinoOsaBolest: 'Біль і погіршення життя',
    kinoOsaLecba: 'Витрати на лікування',
    kinoOsaNehoda: 'аварія',
    kinoOsaPece: 'Догляд за потерпілим',
    kinoOsaVydelek: 'Втрата заробітку — щомісяця',
    kinoOsobaMzda: '{jmeno} · {mzda}',
    kinoOsobaPodnika: '{jmeno} · підприємець, не стосується',
    kinoPlnaDum: 'Збудувати будинок заново коштувало б {castka}',
    kinoPlnaDumBez: 'Будинок · вартість відбудови доповнимо',
    kinoPlnaVeta: 'Коли страхова сума нижча, ніж коштувало б придбати заново, страховик зменшує кожну виплату в тому ж співвідношенні — навіть малу.',
    kinoPlnaVybaveni: 'Придбати обладнання заново коштувало б {castka}',
    kinoPlnaVybaveniBez: 'Обладнання · вартість доповнимо',
    kinoPlnaVyska: 'повна висота = вся вартість',
    kinoPojistenoCastka: '{castka} ({pct} %)',
    kinoPojistenoNa: 'Застраховано на',
    kinoPojistenoPct: '{pct} % вартості',
    kinoPojistovna: 'Страховик',
    kinoPoznPodpojisteni: 'Ілюстрація за загальним правилом недострахування, без франшизи. Конкретний договір може бути оформлено інакше.',
    kinoPoznPodpojisteniCZ: 'Ілюстрація за загальним правилом недострахування (§ 2854 Цивільного кодексу Чехії), без франшизи. Конкретний договір може бути оформлено інакше.',
    kinoPraceKde: '{jmeno} · брутто-зарплата {mzda}',
    kinoPraceSmlouva: 'Для цього є договір з лімітом {nasobek}× зарплати. Обсяг і винятки визначить страховик.',
    kinoPraceVeta: 'З необережності пошкодить верстат чи обладнання, з яким працює. Роботодавець може вимагати відшкодування. За необережності закон обмежує його {nasobek}-кратним середнім місячним заробітком.',
    kinoPraceVyjimky: 'Ліміт не діє для шкоди, заподіяної навмисно, у стані сп’яніння чи під дією наркотичних речовин, ані для нестачі та втрати довірених речей — там відшкодовується вся шкода. Норма: {predpis}.',
    kinoProtoLimit: 'Тому ліміт у мільйонах:',
    kinoShrnPozn: 'Суми — це пропозиція покриття, а не оферта. Ціну, обсяг виплат і винятки визначить страховик у договорі.',
    kinoSkoda: 'Шкода',
    kinoStropNejmene: 'Законний ліміт за необережність щонайменше',
    kinoStropPozn: '— рахується із середнього заробітку, з преміями виходить більше.',
    kinoTeckaAria: 'Крок {i}: {nazev}',
    kinoVetaJedna: '{mista} — це вирішує один договір з однією ціною.',
    kinoVetaKazde: '{mista} — кожне вирішує інший договір. Кожен має свою ціну.',
    kinoVetaVicFew: '{mista} — {n} договори, кожен має свою ціну.',
    kinoVetaVicMany: '{mista} — {n} договорів, кожен має свою ціну.',
    kinoVetaVicOne: '{mista} — {n} договір, кожен має свою ціну.',
    kinoVetaZadna: 'Поки що ми не вибрали жодного договору.',
    kinoZavrit: 'Закрити пояснення',
    kinoZeSveho: 'Зі своїх',
    kinoZpet: 'Назад',
    kratceOdpovednost: 'Відповідальність',
    kratcePodnik: 'Фірма й діяльність',
    kratceVybaveni: 'Обладнання',
    krytiNemovitostChybi: 'нерухомість — вартість буде доповнено',
    krytiPolozka: '{nazev} {castka}',
    krytiZam: 'ліміт {limit}',
    krytiZamChybi: 'ліміт після введення зарплати',
    krytiZamChybiOsoba: '{jmeno} — ліміт після введення зарплати',
    krytiZamOsoba: '{jmeno} — ліміт {limit}',
    limitDoplnte: 'введіть зарплату',
    limitNetyka: 'не стосується',
    mzdaOdZamestnavatele: 'Зарплата від роботодавця — {jmeno}',
    mzdaOsoby: 'Брутто-зарплата — {jmeno}',
    mzdaPlati: 'Зарплата правильна',
    mzdaPlatiAria: 'Брутто-зарплата {jmeno} {mzda} правильна',
    nabidnoutV: 'Запропонувати',
    nabizetV: 'Пропонувати',
    nazevDomacnost: 'Домашнє майно',
    nazevDomacnostOdpovednost: 'Домашнє майно і відповідальність',
    nazevMajetek: 'Майно',
    nazevMajetekDomacnost: 'Майно та домашнє господарство',
    nazevNemovitost: 'Нерухомість',
    nazevNemovitostOdpovednost: 'Нерухомість і відповідальність',
    nazevOdpovednost: 'Цивільна відповідальність',
    nazevPodnik: 'Страхування бізнесу',
    nazevPravni: 'Правовий захист',
    nazevVlastni: '{polozky} — окремо',
    nazevZam: 'Відповідальність працівника — {jmeno}',
    nazevZamDva: 'Відповідальність працівника — {jmeno1} і {jmeno2}',
    nenabizetV: 'Не пропонувати',
    neresitV: 'Не вирішувати',
    netykaSe: 'не стосується',
    nezadanoPlaceholder: 'не введено',
    obsahSeZmenil: 'зміст змінився — перевірте ціну',
    orientacne: 'орієнтовно ≈ {cena}, не пропозиція',
    osvcMzdaPozn: 'Дохід в аналізі — від підприємницької діяльності. Зарплату вводьте, лише якщо має й роботодавця.',
    overitCenuFew: 'перевірити ціну в {n} договорах',
    overitCenuMany: 'перевірити ціну в {n} договорах',
    overitCenuOne: 'перевірити ціну в {n} договорі',
    podepiseFew: 'Клієнт підпише {n} договори',
    podepiseMany: 'Клієнт підпише {n} договорів',
    podepiseOne: 'Клієнт підпише {n} договір',
    podnikNeresit: 'Страхування домашнього майна не покриває фірму, запаси й обладнання.',
    podtitulJedna: 'Один договір · одна ціна',
    podtitulNenabizime: 'Не пропонуємо',
    podtitulNeresime: 'Не вирішуємо',
    podtitulNetyka: '{jmeno} підприємець — не має роботодавця.',
    podtitulNetykaBez: '{jmeno} не має в аналізі доходу від роботи за наймом.',
    podtitulPrazdna: 'Поки нічого не покрито — доповніть пункти',
    podtitulSamostatna: 'Окремий договір',
    podtitulZam: 'Ліміт {nasobek}× брутто-зарплати · одна ціна',
    pojistneCelkem: 'Страхова премія разом',
    popisekCastka: 'Страхова сума',
    popisekLimit: 'Ліміт',
    popisekVybaveni: 'Вартість обладнання',
    popisekZasoby: 'Вартість запасів',
    pravniNabidka: 'Правовий захист: пропонувати чи ні',
    pravniPripojisteni: 'Додаткове страхування до договору Майно',
    pravniSamostatna: 'Окремий договір',
    pravniUmisteni: 'Як оформлено правовий захист',
    prepinacAria: '{nazev}: пропонувати чи не вирішувати',
    presunAria: '{nazev}: належить до договору',
    presunNova: '+ Новий окремий договір',
    presunPopisek: 'Оформлено інакше? Належить до договору',
    prezSmlouvyFew: '{n} договори',
    prezSmlouvyMany: '{n} договорів',
    prezSmlouvyOne: '{n} договір',
    prezSouhrnBezCen: '{smlouvy} · ціни після пропозиції',
    prezSouhrnCast: '{smlouvy} · {cena} + інші ціни після пропозиції',
    prezSouhrnCena: '{smlouvy} · {cena}',
    proc_majetek: 'Одна шкода на нерухомості або заподіяна іншим потягне весь план на дно.',
    proc_podnik: 'Страхування домашнього майна не покриває бізнес.',
    proc_pravni: 'Спір про гроші чи роботу коштує адвоката й суду.',
    proc_vlastni: 'Оформлено окремо — власний договір і власна ціна.',
    proc_zam: 'Шкоду з необережності на роботі роботодавець може вимагати від працівника; законний ліміт діє не завжди.',
    radekSmlouvy: '{nazev} ({kryti}) — {cena}',
    radekSmlouvyBezKryti: '{nazev} — {cena}',
    regul: 'До суми йде лише ціна з пропозиції. Суми — це пропозиція покриття, а не оферта — ціну, обсяг виплат і винятки визначить страховик у договорі.',
    resitV: 'Вирішувати',
    smlouvaAria: 'Договір {cislo}: {nazev}',
    staraMetodika: 'План має старішу методику: до друку йде по-старому один рядок — орієнтовно {cena}. Договори, ціни та «Не вирішувати» звідси потраплять до друку лише після «{prepocitat}».',
    staraMetodikaBezTisku: 'План має старішу методику: страхування майна до друку не потрапить. Договори й ціни звідси перенесуться лише після «{prepocitat}».',
    stavChybiHodnota: 'бракує вартості',
    stavChybiMzda: 'бракує брутто-зарплати',
    stavNeresit: 'не вирішувати',
    stavNetyka: 'не стосується — підприємець',
    stavNetykaBez: 'не стосується — без роботи за наймом',
    stavNevlastni: 'не володіє',
    stavNezadano: 'не введено',
    stavOdhadMzdy: 'оцінка з нетто — перевірте',
    ukolSmlouvyFew: 'Оформити страхування майна — {n} договори:',
    ukolSmlouvyMany: 'Оформити страхування майна — {n} договорів:',
    ukolSmlouvyOne: 'Оформити страхування майна — {n} договір:',
    ulozit: 'Зберегти',
    upravitCenu: 'Змінити ціну: {nazev}',
    vetaSjednat: 'Оформити {nazev} ({kryti}) — {cena}',
    vetaSjednatBezKryti: 'Оформити {nazev} — {cena}',
    vsechnyCeny: 'усі ціни з пропозицій',
    vysvetlitKlientovi: 'Пояснити клієнтові',
    zNabidky: 'з пропозиції',
    zadatMzdu: 'Має також роботу? Ввести зарплату',
    zadnaKPodpisu: 'Поки що жодного договору для підпису',
    zamJakPoznat: 'Як розпізнати один чи два договори',
    zamJakText: 'Подивіться на пропозицію страховика: один номер договору й одна ціна = один договір для обох. Дві ціни = кожен свій. Ліміт кожен має окремо за своєю брутто-зарплатою.',
    zamKazdy: 'Кожен свій договір',
    zamSkupina: 'Відповідальність працівника',
    zamSpolecna: 'Один договір для обох',
  },
  /* BLOK:majetekSmlouvy END */
  /* BLOK:duchodInvalidni START — generuje scratchpad/slovnik.py, ručně needitovat */
  duchodInvalidni: {
    ano: 'Так',
    bezPrijmuB: 'Батько/мати без доходу: витрати вищі на 20 % ({narust}) мінус пенсія по інвалідності ({duchod}).',
    bezPrijmuDomacnosti: 'Без доходу – покриття інвалідності не розраховуємо, додайте дохід.',
    narok: 'Право на пенсію по інвалідності',
    narokPozn: 'Понад 28 років — 5 років страхування з останніх 10. Догляд за дитиною зараховується лише при державному медичному страхуванні. «Не знаю» = розраховується без права.',
    ne: 'Ні',
    nevim: 'Не знаю',
    odStatu: 'Державна пенсія по інвалідності {castka}',
    odStatuLabel: 'Державна пенсія по інвалідності',
    stitek: {
      bezNaroku: 'без права: менше 5 років страхування з 10',
      bezNarokuPoradce: 'без права',
      chybiNarozeni: 'додайте дату народження',
      minimum: 'законний мінімум',
      osvcMinimalni: 'ФОП, мінімальні внески',
      overitNarok: 'перевірити виписку ČSSZ',
      prumer: 'середня',
    },
  },
  /* BLOK:duchodInvalidni END */
  /* BLOK:kinoCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoCile: {
    bydleni: {
      a1: {
        kicker: 'Оренда чи власне',
        l1: 'Оренда: нижчі початкові витрати, легше переїхати, ремонти вирішує власник — але майно ви не накопичуєте.',
        l2: 'Іпотека: потрібен перший внесок і довгострокове зобовʼязання, але частина платежу погашає основну суму — нерухомість поступово стає вашою.',
        l3: 'Вирішують гнучкість, щомісячний грошовий потік і те, чи хочете ви накопичувати майно.',
        nar: '„Оренда — це не викинуті гроші: ви платите за житло й гнучкість. Різниця в тому, що в іпотеці частина платежу погашає основну суму, тож ви поступово накопичуєте майно. Подивімося на цифри та припущення моделі.“',
        title: 'Оренда та іпотека: чим відрізняються',
      },
      a5: {
        big: 'Що почнемо відкладати',
        nar: '„Запустімо план уже сьогодні — щоб ключі тримали ви, а не договір оренди.“',
        title: 'Дім має свій план',
        titleVek: 'Дім через {roky} р., у ваші {vek}',
      },
      cnb: {
        bigCena: 'Реальна ціна житла',
        bigNad: '{nasobek}× річного доходу — понад рекомендацію',
        bigOk: '{nasobek}× річного доходу — в межах рекомендації',
        kicker: 'Здорова межа ціни',
        lBezCeny1: 'Доповніть РЕАЛЬНУ ціну нерухомості — інакше план не зійдеться.',
        lBezCeny2: 'З нинішнього житла на подібне, не палац.',
        lBezPrijmu: 'Доповніть доходи — і ми перевіримо співвідношення ціни до доходу.',
        lCena: 'Ціна нерухомості: {cena} (реальна, щоб план зійшовся).',
        lCenaHola: 'Ціна нерухомості: {cena}.',
        lNad: 'Це {nasobek}× вашого річного доходу — понад здорову межу!',
        lOk: 'Це {nasobek}× вашого річного доходу — в порядку.',
        nar: '„Здорова ціна — приблизно до девʼяти річних доходів. Маємо рахувати з реальною ціною, інакше весь план не зійдеться.“',
        title: 'Здорова ціна ≈ 9× річного доходу',
      },
      nbs: {
        bigNad: 'Кредит понад ліміт NBS',
        bigOk: 'Кредит у межах ліміту NBS',
        bigUver: 'Потрібний кредит',
        kicker: 'Ліміт NBS',
        lLimit: 'Ліміт для всіх ваших кредитів: {limit}.',
        lLimitNejvys: 'Ліміт для всіх ваших кредитів: не більше {limit}.',
        lUver: 'Потрібний кредит: {uver}.',
        lUverNad: 'Потрібний кредит: {uver} — понад ліміт NBS!',
        lUverOk: 'Потрібний кредит: {uver} — в порядку.',
        lVek: 'Залежно від віку ліміт може бути нижчим.',
        lZbyva: 'Після інших кредитів залишається: {strop}.',
        nar: '„У Словаччині NBS стежить за всіма вашими кредитами разом — не більше восьмикратного річного чистого доходу, від 41 року менше. Подивімося, куди ви вмістите.“',
        title: 'Усі кредити ≤ {max}× річного доходу',
      },
      paka: {
        bigHotove: 'Загальна ціна',
        bigUver: 'Потрібний перший внесок ({pct})',
        kicker: 'Важіль іпотеки',
        lAkontace: 'Перший внесок {pct}: {castka}.',
        lHotove: 'Готівкою = вся сума зараз.',
        lSHypotekou: 'З іпотекою вистачить ~{pct} першого внеску, а решту грошей інвестуєте.',
        lZbytek: 'Решту покриє іпотека — ваші гроші працюють деінде.',
        narHotove: '„Зважимо готівку проти іпотеки. Важіль може бути вашим другом.“',
        narUver: '„З іпотекою не потрібна вся сума — лише перший внесок. Решта грошей може й далі рости.“',
        titleHotove: 'Готівкою чи з важелем?',
        titleUver: 'Вкладаєте лише {pct} першого внеску',
      },
    },
    ostatni: {
      a1: {
        big: 'Розрахуймо це',
        kicker: 'Ваша ціль',
        l1: 'Кожна велика мрія потребує плану й числа.',
        l2: 'Назвемо, скільки й коли.',
        nar: '„Кожна ціль заслуговує на чітке число й термін. До справи.“',
        title: 'Ваша мрія',
      },
      a2: {
        big: 'Цільова сума',
        kicker: 'Скільки й коли',
        lHorizont: 'Горизонт {roky} р.',
        lHorizontVek: 'Горизонт {roky} р. — у ваші {vek}.',
        nar: '„Ось число й термін. З цього вже порахуємо щомісячне відкладання.“',
        titleRoky: '{castka} через {roky} р.',
      },
      a3: {
        big: 'Ціль на відстані руки',
        kicker: 'Три важелі',
        l1: 'Чим раніше почнете, тим менше треба відкладати.',
        l2: 'Регулярність перемагає разові спроби.',
        nar: '„Працюють три важелі: час, регулярність і дохідність. Усі вміємо ввімкнути.“',
        title: 'Час × регулярність × дохідність',
      },
      a4: {
        big: 'Ваша ціль',
        l1: 'Сплануємо щомісячне відкладання одразу.',
        l2: 'Маленький крок сьогодні = велика ціль завтра.',
        nar: '„Мрія без плану — лише бажання. Зробімо з неї план.“',
        title: 'План стає реальністю',
      },
    },
    renta: {
      a1: {
        big: 'Скільки — це „досить“ за ВАШИМИ витратами?',
        kicker: 'Вершина плану',
        l1: 'День, коли робота — вибір, а не обовʼязок.',
        l2: 'Рента має покрити весь ваш спосіб життя — довічно й понад інфляцію.',
        nar: '„Фінішна мета: день, коли не треба працювати заради грошей. Рента має покрити все ваше нинішнє життя, без скорочень.“',
        title: 'Фінансова незалежність',
      },
      a2: {
        big: 'Рента, яка вам потрібна (сьогоднішні ціни)',
        kicker: 'Ваш спосіб життя',
        lBez1: 'Рента має покрити ваші ЗАГАЛЬНІ щомісячні витрати (спосіб життя).',
        lBez2: 'Доповніть витрати в аналізі, щоб сума зійшлася.',
        lRenta: 'Рента, задана в цілі: {renta}.',
        lVydaje: 'Ваші загальні щомісячні витрати за аналізом: {vydaje}.',
        nar: '„Це ваші нинішні витрати з аналізу та рента, яку ви задали в цілі. Від цих двох чисел залежить усе інше.“',
        title: 'Ваші нинішні щомісячні витрати',
      },
      a3: {
        big: 'Потрібний капітал (у сьогоднішніх цінах)',
        kicker: 'Правило 4 %',
        l2: '4 % — це реальна дохідність ПОНАД інфляцію: основна сума лишається, вилучаєте назавжди.',
        lRocne: '{renta}/міс = {rocne} на рік.',
        nar: '„Безпечно можна щороку вилучати ~4 % майна понад інфляцію назавжди. З ваших витрат порахуємо потрібний капітал.“',
        title: 'Рента × 12 ÷ 4 % = капітал',
      },
      a4: {
        big: 'Цільовий капітал для свободи',
        l1: 'Регулярна інвестиція + час = сніжна куля, рента довічно.',
        lCil: 'Ціль через {roky} р.',
        lCilVek: 'Ціль через {roky} р., у ваші {vek}.',
        lKazdy: 'Кожен місяць відкладання — це додатковий місяць свободи.',
        nar: '„Незалежність не купують грошима одразу, а часом і регулярністю. Сніжна куля складних відсотків зробить решту.“',
        title: 'Свободу купують часом',
      },
    },
    rezerva: {
      a1: {
        big: 'Скільки місяців спокою маєте зараз?',
        kicker: 'А що, якби…',
        l1: 'Авто, звільнення, хвороба, зламаний холодильник.',
        l2: 'Без резерву приходить борг — кредитка, позика, стрес.',
        nar: '„Уявіть, що завтра зникне дохід. Як довго витримаєте звичайне життя без змін?“',
        title: 'А якщо завтра ви втратите дохід?',
      },
      a2: {
        big: 'чехів не мають резерву навіть на місяць',
        kicker: 'Реальність у Чехії',
        l1: '14 % не мають жодного резерву.',
        l2: 'Майже третина не має відкладеним навіть одного місячного доходу.',
        l3: 'Джерело: STEM/MARK для Home Credit, 2024.',
        nar: '„Ви в цьому не самі — але саме тому резерв — перший крок. 14 % людей не мають нічого, третина не протримається місяць.“',
        title: 'Майже третина чехів не протримається й місяця',
      },
      a3: {
        bigCil: 'Цільовий резерв',
        bigMes: '= {mes} місяців спокою',
        kicker: 'Правило',
        lBez1: 'Відкладені витрати на 3–6 місяців = спокій.',
        lBez2: 'Доповніть необхідні витрати — і ми точно порахуємо місяці.',
        lCil: 'Ціль {cil} = {mes} місяців спокою.',
        lNez: 'Ваші необхідні витрати: {nez}/міс.',
        nar: '„Мета — 3–6 місяців необхідних витрат. У вас це виходить на таку суму.“',
        title: 'Резерв = 3–6× необхідних витрат',
      },
      a4: {
        big: 'Ваш щит від невдач',
        lDnes: 'Термін: сьогодні — резерв вирішується першим.',
        lTermin: 'Термін: через {roky} р.',
        nar: '„Не обовʼязково мати все одразу. Почнемо потроху — головне почати. Резерв — основа, на якій стоїть увесь план.“',
        title: 'Подушку будують потроху',
      },
    },
    spolecne: {
      cenaZadani: 'Ціна за заданням: {castka}.',
      cilovaCastka: 'Цільова сума за заданням: {castka}.',
      dejstvi: 'Дія {n}',
      hotovo: 'Готово ✓',
      modelNajmu: 'Модель: оренда 0,35 % ціни на місяць із зростанням 3 % на рік; іпотека рівномірно погашає ціну без відсотків і витрат на утримання. Насправді залежить від місця, ставки та стану нерухомості.',
      osaDnes: 'СЬОГОДНІ',
      osaVek: 'у віці {vek}',
      osaZa: 'через {n} р.',
      pauza: 'Пауза',
      termin: 'Термін: через {roky} р.',
      terminNeni: 'Термін поки не визначено.',
      terminVek: 'Термін: через {roky} р., у ваші {vek}.',
      zacniDnes: 'Почніть сьогодні',
    },
    vzdelani: {
      a1: {
        big: 'Скільки коштуватиме навчання?',
        kicker: 'Найбільший дар',
        l1: 'Диплом, мови, закордон, старт карʼєри.',
        l2: 'Найкраще, що можете дати дітям, — і це коштує грошей.',
        nar: '„Найкраща інвестиція — у власних дітей. Подивімося, що на них чекає.“',
        title: 'Освіта = старт у життя',
      },
      a2: {
        big: 'Ваша ціль для: {deti}',
        kicker: 'Ціна освіти',
        l1: 'Навчання в Чехії ≈ 300–600 тис. (житло, харчування, матеріали).',
        l2: 'Закордонний університет ≈ 1–3 млн Kč.',
        nar: '„Навчання вдома коштує сотні тисяч, за кордоном — і мільйони. Добре знати заздалегідь.“',
        title: 'Чехія — сотні тисяч, закордон — мільйони',
      },
      a3: {
        big: 'Цільова сума',
        bigRoky: 'Встигнете за {roky} р.',
        kicker: 'Час біжить',
        nar: '„Час грає на вашому боці. Почати вчасно — означає відкладати значно менше.“',
        title: 'Час — ваш союзник',
        titleRoky: 'Потрібно через {roky} р.',
      },
      a4: {
        big: 'Майбутнє дітей',
        l1: 'Регулярні інвестиції від сьогодні = спокій, коли прийде час.',
        l2: 'Сплануємо щомісячне відкладання на освіту.',
        nar: '„Кілька сотень на місяць сьогодні = відчинені двері для ваших дітей завтра.“',
        title: 'Мала сума, великий диплом',
      },
      deti: 'діти',
      dite: 'дитина',
    },
    zdroj: {
      akontaceCZ: 'ČNB, загальний захід № I/2021 (LTV: молодші 36 років — 90 %, інакше 80 %), перевірено {datum}',
      akontaceSK: 'NBS, постанова № 10/2016 § 7 і § 9d (LTV: до кінця 2026 року гарантовано 80 %, з 2027 перше житло до 35 років — 90 %), перевірено {datum}',
      cnb: 'ČNB (Чеський національний банк) — рекомендація щодо кредитних показників',
      ctyriProcenta: 'Правило безпечного вилучення 4 % (Trinity study)',
      klient: 'Дані з аналізу клієнта',
      najemModel: 'Модельне порівняння оренди та іпотеки (припущення біля графіка)',
      nbs: 'NBS — постанова № 10/2016 § 8a (ліміт DTI)',
      rezervaPravidlo: 'Внутрішня методика — ліквідний резерв 3–6× необхідних витрат',
      stem: 'STEM/MARK для Home Credit',
    },
  },
  /* BLOK:kinoCile END */
  /* BLOK:invaliditaVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  invaliditaVysvetleni: {
    aria: 'Після інвалідності потрібно {potreba}, надійде {prijde}, бракує {chybi}.',
    ariaPrebyva: 'Після інвалідності потрібно {potreba}, надійде {prijde}, залишиться {prebyva}.',
    bezVydaju: 'Покриття на випадок інвалідності неможливо розрахувати — в аналізі бракує витрат.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} у сьогоднішніх цінах. Рахуємо, що виплачені гроші будуть вкладені з модельною дохідністю 4 % понад інфляцію (модель, не гарантія). Тому сьогодні достатньо {kapital}.',
    chybiVeta: 'бракує {castka} щомісяця · {roky}',
    cilBezHorizontu: 'ціль {nazev} без горизонту, не враховано',
    duchod: 'державна пенсія по інвалідності',
    duchodSablona: 'пенсія по інвалідності (шаблон країни)',
    jenUkazka: 'Лише ілюстрація — до плану нічого не записується.',
    krok1: 'Витрати після інвалідності',
    krok1B: 'На скільки зростуть витрати домогосподарства',
    krok1BPod: '+20 % від {vydaje}',
    krok1Pod: 'лікування, догляд, облаштування житла',
    krok2: 'Що надійде родині',
    krok2B: 'Що дасть держава',
    krok3: 'Чого бракує — аж до ренти ({roky})',
    krok3B: 'Чого бракує — на {roky}',
    krok4: 'Ліміт на інвалідність',
    krok4BPod: 'борги, цілі та ренту покриває страхування годувальника',
    krok4Pod: 'чого бракує + борги + цілі + рента − що вже маєте',
    model: 'Орієнтовна модель, не гарантія: рахує з дохідністю 4 % понад інфляцію, за нижчої дохідності ліміт вищий. Пенсія по інвалідності — для III ступеня (повна інвалідність), для I і II ступеня нижча. Виплати визначають умови страхування.',
    nepotreba: 'Родині залишився б достатній дохід — покриття на випадок інвалідності не потрібне.',
    nicNechybi: 'Доходи покривають витрати родини точно.',
    odvozenaRenta: 'виведено: рента = сьогоднішні витрати',
    odvozenaRentaPotreba: 'виведено: рента = сьогоднішні витрати й платежі без заощаджень і платежів, виплачених до ренти',
    odvozeneRoky: 'виведено: горизонт ренти {roky} за шаблоном',
    orezano: 'Доходів і майна родині вистачить — покриття на випадок інвалідності не потрібне.',
    partner: '{jmeno} далі заробляє',
    pasivniAria: 'Пасивний дохід {castka}, ліміт на інвалідність {limit}',
    pasivniTitul: 'Якби ви сьогодні мали пасивний дохід',
    pasivniVeta: 'Страхування — це ціна за те, що поки не маємо пасивного доходу.',
    prahMezera: 'покриє прогалину',
    prahNula: 'поліс не потрібен',
    prebyvaVeta: 'Доходів родині вистачить і залишиться {castka} — на стільки ліміт нижчий.',
    rada: {
      chybi: 'бракує',
      dnes: 'сьогодні',
      duchod: 'пенсія по інвалідності',
      narust: '+20 % після інвалідності',
      partner: 'дохід партнера',
      pasivni: 'пасивний дохід',
    },
    radekChybi: 'Чого бракує аж до ренти',
    radekCile: 'Інвестувати на цілі (сьогоднішня вартість)',
    radekDluhy: 'Погасити борги',
    radekMajetek: 'Що вже маєте на рахунках',
    radekPrebytek: 'Що родині залишиться з доходів понад потребу — аж до ренти ({roky})',
    radekRenta: 'Інвестувати на ренту (сьогоднішня вартість)',
    radekRentaPod: '{castka} у сьогоднішніх цінах через {roky}, вилучення 4 %',
    rucne: 'На картці вручну {rucni}, розраховано {spocitano}.',
    skryt: 'Сховати розрахунок',
    titul: 'Як складається сума на інвалідність',
    toggle: 'Як рахується інвалідність',
    vysledek: 'Ліміт на інвалідність',
    zaokrouhleni: 'Рядки заокруглені, їхня сума може трохи відрізнятися.',
  },
  /* BLOK:invaliditaVysvetleni END */
  /* BLOK:staraZtrata START — generuje scratchpad/slovnik.py, ručně needitovat */
  staraZtrata: {
    invalidita: 'Старий договір має покриття інвалідності {castka}, новий — ні.',
    jine: 'Старий договір має {riziko} {castka}, новий — ні.',
    smrt: 'Старий договір має покриття смерті {castka}, новий — ні.',
  },
  /* BLOK:staraZtrata END */
  /* BLOK:schodPoSchodu START — generuje scratchpad/slovnik.py, ručně needitovat */
  schodPoSchodu: {
    bezDat: 'З цього аналізу поки нічого порахувати не можна.',
    bezPrijmu: 'Без доходів і витрат порядок порахувати не можна. Доповніть їх в аналізі.',
    e: {
      doporucene: 'Рекомендований порядок',
      hlasDoporucene: 'Повернено рекомендований порядок.',
      hlasPosun: '{nazev} тепер на {n}-му місці.',
      nadpis: 'Що для вас найважливіше?',
      niz: '{nazev} нижче',
      podnadpis: 'Угорі те, що хочете мати найперше.',
      renta: 'Рента · отримує те, що залишиться',
      rovne: 'Для мене все однаково важливе',
      seznam: 'Порядок цілей',
      tahnout: 'Перетягнути: {nazev}',
      ulozit: 'Зберегти порядок',
      vys: '{nazev} вище',
      zaklad: 'Основа: резерв і захист доходу · завжди першим',
      zakladRezerva: 'Основа: резерв · завжди першим',
      zakladZajisteni: 'Основа: захист доходу · завжди першим',
      zrusit: 'Скасувати',
    },
    k: {
      cilCast: '{nazev}: до {rok} року накопичено {pct}, бракує {chybi}.',
      cilHotovo: '{nazev}: досягнуто до {rok} року, вчасно.',
      cileFew: '{vcas} з {celkem} цілей вчасно',
      cileMany: '{vcas} з {celkem} цілей вчасно',
      cileOne: '{vcas} з {celkem} цілі вчасно',
      dalsiCast: 'Інші цілі ({n}): до строків накопичено {pct}, бракує {chybi}.',
      dalsiHotovo: 'Інші цілі ({n}): досягнуто до строків.',
      nezadaneFew: '{n} цілі не мають суми або строку.',
      nezadaneMany: '{n} цілей не мають суми або строку.',
      nezadaneOne: '{n} ціль не має суми або строку.',
      renta: 'Рента з {rok} року: за моделлю готово {pct} (песимістично {pes}), бракує {chybi}.',
      rentaHotovo: 'Рента з {rok} року: за моделлю готово {pct} (песимістично {pes}).',
      shrnuti: 'При {castka} щомісяця: {cile}, рента {renta}.',
      shrnutiBezRenty: 'При {castka} щомісяця: {cile}.',
      shrnutiJenRenta: 'При {castka} щомісяця: рента {renta}.',
      srovnani: 'При {castka} щомісяця: {cile} (було {vcasDrive}), рента {renta} замість {rentaDrive}.',
      srovnaniBezRenty: 'При {castka} щомісяця: {cile} (було {vcasDrive}).',
      srovnaniJenRenta: 'При {castka} щомісяця: рента {renta} замість {rentaDrive}.',
      uvod: 'Ви відкладаєте {castka} щомісяця. Скільки буде до бажаних строків?',
      zajisteni: 'Захист доходу оформимо після зустрічі.',
      zaklad: 'Спершу основа.',
      zakladCast: 'Спершу основа: до {rok} року резерв на {pct}, бракує {chybi}.',
      zakladHotovo: 'Спершу основа: резерв поповнено до {rok} року.',
      zakladMa: 'Спершу основа: резерв у вас уже є.',
    },
    nadpis: 'Крок за кроком',
    neodsouhlaseno: 'клієнт ще не погодив',
    o: {
      dal: 'Наступний крок',
      dalsi: 'Інші',
      krok: 'Крок {n}: {nazev}',
      kroky: 'Кроки відтворення',
      otazka: 'Порядок',
      pauza: 'Пауза',
      pokracovat: 'Продовжити',
      prehrat: 'Відтворити',
      preskocit: 'Пропустити',
      uvod: 'Початок',
      zaklad: 'Основа',
      znovu: 'Ще раз',
      zpet: 'Крок назад',
    },
    odkladani: 'Відкладання щомісяця',
    p: {
      bezPojistneho: 'Ціну страхування ще не вказано, з надлишку нічого не віднімається.',
      dnes: '«Зараз» = що ви зараз регулярно відкладаєте (заощадження, пенсійні внески, фонди).',
      model: 'Модель, не гарантія. Такий самий розрахунок, як у Пропозиції рішення: ціль отримує гроші лише до свого строку, і видно, скільки буде до строку. Песимістично = гірша дохідність.',
      pojistne: 'Надлишок після страхування = вільний надлишок мінус ціна страхування від консультанта.',
    },
    precerpano: 'Ручні суми в цілях: перевищено на {castka} — рахуємо лише з {dostupne} на місяць.',
    prehravac: 'програвач',
    q: {
      ano: 'Так',
      nemeniCisla: 'Цифри вище рахує Пропозиція рішення за строками. Порядок клієнта записано, на розрахунок поки не впливає.',
      otazka: 'Ви згодні з таким порядком?',
      popis: 'Основа → {cile} → рента',
      popisBezCilu: 'Основа → рента',
      popisBezRenty: 'Основа → {cile}',
      popisRovne: 'Основа, далі все однаково важливе: {cile}, решта на ренту',
      popisRovneBezRenty: 'Основа, далі все однаково важливе: {cile}',
      potvrzeno: 'Порядок підтверджено {datum}',
      upraveno: 'Порядок клієнта записано {datum}',
      upravit: 'Змінити',
      zmenit: 'Змінити',
    },
    s: {
      bezUdaju: 'без даних',
      castkaNezadana: 'суму не вказано',
      chybi: 'бракує {castka}',
      cil: 'ціль',
      cileFew: '{n} цілі',
      cileMany: '{n} цілей',
      cileOne: '{n} ціль',
      dalsiFew: 'ще {n}',
      dalsiMany: 'ще {n}',
      dalsiOne: 'ще {n}',
      doplneno: 'поповнено',
      doplnit: 'доповніть',
      drive: 'було {pct}',
      kRoku: 'до {rok}',
      maDnes: 'уже є',
      mesicne: '{castka}/міс.',
      nepocitaSe: 'не враховується',
      pesimisticky: 'песимістично {pct}',
      poSchuzce: 'після зустрічі',
      pojisteni: 'Страхування',
      potreba: 'потрібно',
      pripraveno: 'готово',
      renta: 'Рента',
      rezerva: 'Резерв',
      sjednat: 'оформити',
      ted: 'зараз',
      terminNezadan: 'строк не вказано',
      vcas: 'вчасно',
    },
    schodyAria: 'Сходи цілей. {shrnuti}',
    stitek: 'Модель',
    tlacitko: 'Відтворити',
    tlacitkoPopis: 'крок за кроком',
    tlacitkoTitul: 'Коротка анімація: скільки буде до строків за порядком цілей',
    vekFew: '{n} роки',
    vekMany: '{n} років',
    vekOne: '{n} рік',
    volbaDnes: 'Зараз {castka}',
    volbaPlan: 'Надлишок {castka}',
    volbaPlanPoPojistnem: 'Надлишок після страхування {castka}',
    zavrit: 'Закрити відтворення',
  },
  /* BLOK:schodPoSchodu END */
  /* BLOK:smlouvaEditor START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaEditor: {
    celkova: 'Загальна сума ({mena})',
    chybaPoli: 'Сервер не прийняв дані — перевірте заповнені поля.',
    chybaServeru: {
      jenPojistne: 'Лист про розірвання можна створити лише для договорів страхування',
      klientNenalezen: 'Клієнта не знайдено',
      neplatneId: 'Недійсне посилання — оновіть сторінку й спробуйте ще раз.',
      smlouvaNenalezena: 'Договір не знайдено',
    },
    cislo: 'Номер договору',
    fixace: 'Кінець фіксації',
    hodnota: 'Поточна вартість ({mena})',
    instituce: 'Банк / страховик',
    mazaniSelhalo: 'Не вдалося видалити',
    mesicni: 'Щомісячна сума ({mena})',
    nadpisEditace: 'Редагування договору',
    nadpisNova: 'Новий договір',
    napr: 'напр. {x}',
    nasporeno: 'Накопичено ({mena})',
    poznamky: 'Нотатки',
    poznamkyNapr: 'Що важливо щодо цього договору…',
    pridano: 'Договір додано',
    pridat: 'Додати договір',
    sazba: 'Відсоткова ставка (%)',
    smazano: 'Договір видалено',
    smazat: 'Видалити',
    smazatPotvrzeni: 'Справді видалити цей договір? Пов’язані завдання в щоденнику теж буде видалено.',
    stav: 'Статус',
    stavActive: 'Активний',
    stavCancelled: 'Скасований',
    stavExpired: 'Закінчився',
    typChybi: 'Оберіть тип договору',
    typSmlouvy: 'Тип договору *',
    typy: {
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      jine: 'Інше',
      penzijko: 'Пенсія (DPS/DIP)',
      pojisteni_auta: 'Страхування авто',
      pojisteni_majetek: 'Страхування майна',
      pojisteni_odpovednost: 'Страхування відповідальності',
      pojisteni_ostatni: 'Інше страхування (правовий захист, подорожі…)',
      pojisteni_zivot: 'Страхування життя',
      stavebni: 'Будівельні заощадження',
      uver: 'Кредит',
      zdravotni: 'Медичне',
    },
    ukladaniSelhalo: 'Не вдалося зберегти',
    ulozeno: 'Договір збережено',
    ulozenoJakoJine: 'Збережено як «Інше» — сервер поки не знає цього типу договору.',
    ulozitZmeny: 'Зберегти зміни',
    vyber: '— Оберіть —',
    vyroci: 'Річниця договору',
    zacatek: 'Початок договору',
    zavrit: 'Закрити',
    zbyva: 'Залишилось сплатити ({mena})',
    zrusit: 'Скасувати',
  },
  /* BLOK:smlouvaEditor END */
  /* BLOK:cilHistorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHistorie: {
    cilCastka: 'ціль {castka}',
    hero: '{roky}-річних періодів історії (1946–2026) ціль було б [[досягнуто]]',
    heroPozn: '{ok} з {n} ковзних вікон. Усе в реальних цінах, після вирахування тодішньої інфляції.',
    jednotka: {
      milion: 'млн',
      tisic: 'тис.',
    },
    legenda: {
      median: 'медіана',
      nejhorsi: 'найгірше вікно',
      nejlepsi: 'найкраще вікно',
      projekce: 'прогноз ({varianta})',
    },
    nadpis: 'Історичний калькулятор — якби клієнт інвестував так у минулому',
    tip: {
      median: 'Медіана',
      nejhorsi: 'Найгірше вікно',
      nejlepsi: 'Найкраще вікно',
      projekce: 'Прогноз',
    },
    tipRok: 'Рік {rok} · +{n} р.',
  },
  /* BLOK:cilHistorie END */
  /* BLOK:smlouvaKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaKarta: {
    aktualniHodnota: 'Поточна вартість',
    bezCisla: 'номер не заповнено',
    celkem: 'Усього',
    cislo: '№ {cislo}',
    druh: {
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      jine: 'Інше',
      penzijko: 'Пенсійні заощадження (DPS)',
      pojisteni_auta: 'Страхування авто',
      pojisteni_majetek: 'Страхування майна',
      pojisteni_odpovednost: 'Страхування відповідальності',
      pojisteni_ostatni: 'Інше страхування',
      pojisteni_zivot: 'Страхування життя',
      stavebni: 'Будівельні заощадження',
      uver: 'Кредит',
      zdravotni: 'Медичне',
    },
    fixaceDo: 'Фіксація до',
    generuji: 'Створюю…',
    kratce: {
      hypoteka: 'Іпотека',
      investice: 'Інвестиції',
      jine: 'Інше',
      penzijko: 'Пенсія',
      pojisteni_auta: 'Страх. авто',
      pojisteni_majetek: 'Страх. майна',
      pojisteni_odpovednost: 'Відповідальність',
      pojisteni_ostatni: 'Інше страх.',
      pojisteni_zivot: 'Страх. життя',
      stavebni: 'Будівельні',
      uver: 'Кредит',
      zdravotni: 'Медичне',
    },
    mesicne: 'Щомісяця',
    nasporeno: 'Накопичено',
    okno: {
      datumMinulo: 'Дата припинення {datum} уже минула — виправте її в листі на кінець поточного страхового періоду.',
      jazyk: {
        cs: 'чеська',
        sk: 'словацька',
      },
      jazykDopisu: 'Текст листа мовою страховика ({jazyk}).',
      kopirovat: 'Копіювати текст',
      lhutySK: 'Розірвання до кінця страхового періоду щонайпізніше за 6 тижнів (§ 800 ч. 1). Протягом 2 місяців після укладення — лише якщо договір це дозволяє, з 8-денним строком (§ 800 ч. 2).',
      sablona: 'Шаблон — перед підписом перевірте дані, строки й адресу страховика в договорі та умовах.',
      staryServer: 'Сервер поки що повернув чеський шаблон. Словацька версія з’явиться після оновлення сервера — до того виправте текст перед відправленням.',
      tisk: 'Друк / зберегти PDF',
      titulek: 'Розірвання — {pojistovna} / {klient}',
      zaklad: 'Правова підстава: {zaklad}',
      zavrit: 'Закрити',
      zkopirovano: 'Скопійовано в буфер обміну',
    },
    pocetFew: '{n} договори',
    pocetMany: '{n} договорів',
    pocetOne: '{n} договір',
    poznamkaZAnalyzy: 'З аналізу — договір, укладений до аналізу',
    prazdnoNadpis: 'Немає договорів',
    prazdnoText: 'Додайте перший договір клієнта — іпотеку, страхування, інвестицію…',
    predAnalyzou: 'до аналізу',
    predAnalyzouTitle: 'Договір перенесено з фінансового аналізу — клієнт уклав його ще до аналізу',
    prehled: {
      fixaceLet: 'фікс. {n} р.',
      mesicne: '{castka} / міс.',
      smlouvy: 'Договори',
      smlouvyPocet: 'Договори ({n})',
      zadneSmlouvyZatim: 'Договорів поки немає — додайте їх на вкладці договорів.',
      zobrazitDalsi: '+ Показати ще {n}',
    },
    pridat: 'Додати договір',
    toastChyba: 'Не вдалося створити лист',
    toastHotovo: 'Лист створено — роздрукуйте або збережіть як PDF',
    toastPopup: 'Браузер заблокував вікно — дозвольте спливаючі вікна.',
    toastStaryServer: 'Сервер поки що має лише чеський шаблон — перед відправленням виправте текст за словацьким правом.',
    upravit: 'Редагувати договір',
    vypoved: 'Лист про розірвання страховику',
    vypovedTitle: 'Створить шаблон листа про розірвання за {zakon} — роздрукуйте або збережіть як PDF',
    vyroci: 'Річниця',
    zAnalyzy: 'З аналізу: {popis}',
    zacatek: 'Початок',
    zakon: {
      CZ: '§ 2807 Цивільного кодексу Чехії',
      SK: '§ 800 Цивільного кодексу Словаччини',
    },
    zbyvaSplatit: 'Залишилось сплатити',
  },
  /* BLOK:smlouvaKarta END */
  /* BLOK:navrhDavky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhDavky: {
    invalidniMes: 'Пенсія по інвалідності (міс.)',
    starobniMes: 'Пенсія за віком (міс.)',
  },
  /* BLOK:navrhDavky END */
  /* BLOK:variantaVynosu START — generuje scratchpad/slovnik.py, ručně needitovat */
  variantaVynosu: {
    optimisticky: 'Оптимістично',
    pesimisticky: 'Песимістично',
    realisticky: 'Реалістично',
  },
  /* BLOK:variantaVynosu END */
  /* BLOK:penze2 START — generuje scratchpad/slovnik.py, ručně needitovat */
  penze2: {
    chyby: {
      bezData: 'Дата народження: заповніть її або увімкніть ручне введення років накопичення.',
      cele: '{pole}: введіть ціле число.',
      cislo: '{pole}: введіть число.',
      datum: 'Дата народження: не може бути в майбутньому чи недійсною.',
      nadpis: 'Виправте виділені поля. Результати поки відповідають останнім правильним даним.',
      prazdne: '{pole}: введіть значення.',
      rozsah: '{pole}: введіть значення від {min} до {max}.',
      vPenzi: 'Клієнт уже досяг пенсійного віку. Увімкніть ручне введення років накопичення.',
    },
    f: {
      bezDat: 'Для цього вибору в періоді немає даних.',
      dataDo: 'дані лише до {rok}',
      dataOd: 'дані з {rok}',
      grafAria: 'Лінійна діаграма динаміки 100 Kč у фондах за {obdobi}. Найвище {fond}: {hodnota}',
      grafNadpis: 'Динаміка 100 Kč, {obdobi}',
      grafPopis: 'Індекс 100 = вартість наприкінці {rok} року',
      historie: 'Історія',
      kontext: 'Інші вибрані фонди сірим на тлі',
      maxZvyr: 'Виділити можна щонайбільше {max} фондів. Спершу зніміть позначку з одного.',
      mimoVyber: 'поза вибором',
      nic: 'Скасувати вибір',
      o10: '10 років',
      o3: '3 роки',
      o5: '5 років',
      oVse: 'Усе',
      obdobi: 'Період',
      pocet: 'Фонди: {n} · виділено {z} з {max}',
      prumery: 'Середнє стратегії (пунктиром)',
      slAkce: 'Дія',
      slCelkem: 'За період разом',
      slFond: 'Фонд / середнє',
      slPa: 'Прибуток p. a.',
      slRust: 'Зростання 1 Kč',
      slStrategie: 'Стратегія',
      slVolatilita: 'Волатильність',
      spolecnost: 'Пенсійна компанія',
      strategie: 'Стратегія',
      tabulka: 'Фонди',
      tabulkaInfo: 'Виділити можна до 5 фондів позначкою. Зірочка = фонд не має даних за весь період; його прибуток p. a. рахується від заснування, і лінія починається в році заснування.',
      uvod: 'Як зростали 100 Kč у фондах пенсійних компаній. Річні прибутки після комісій (APS ČR, banky.cz).',
      vse: 'Вибрати все',
      vsechnySpolecnosti: 'усі компанії',
      vyber: 'Вибір фондів',
      vyberteAspon: 'Виберіть щонайменше одну стратегію та одну пенсійну компанію.',
      vysvetlivky: 'Як читати таблицю',
      vysvetlivkyInfo: 'Прибуток p. a. = середня річна прибутковість за період (геометричне середнє). За період разом = на скільки відсотків зросла вартість. Волатильність = стандартне відхилення річних прибутків. Трансформовані фонди (стара пенсійна схема) не мають від’ємного результату, бо його за законом покриває пенсійна компанія.',
      vznik: 'заснування {datum}, перший рік лише частково',
      zadnyZvyr: 'Жоден фонд не виділено. Позначте його в таблиці.',
      zrusitZvyr: 'Скасувати виділення: {fond}',
    },
    h: {
      chybaCastka: '{pole}: введіть число 0 або більше, напр. 1 000.',
      chybaObdobi: 'Початок накопичення має бути раніше за кінець.',
      chybaRok: '{fond}: за {rok} рік немає прибутків. Дані є з {od} року.',
      danVyber: 'Податок при одноразовому вилученні (орієнтовно)',
      danVyberInfo: 'При одноразовому вилученні з прибутку і внесків роботодавця сплачується 15 % податку. При ренті на 10 і більше років податок не сплачується.',
      dipFond: 'У що інвестує DIP',
      dipInfo: 'DIP існує з 2024 року. Для раніших років це симуляція тих самих внесків у вибраний фонд без державного внеску. Податкова економія (відрахування до 48 000 Kč на рік, 15 %) рахується лише з 2024 року.',
      dipPozn: 'До DIP держава не робить внесків.',
      dipPoznInfo: 'При вилученні після 60 років і 10 років дії прибуток не оподатковується.',
      doMesice: 'До місяця',
      doRoku: 'До року',
      drive: 'раніше {nazev}',
      duchod: 'Клієнт отримує пенсію за віком',
      fond: 'Фонд або середнє',
      grafAria: 'Динаміка вартості рахунку {od}–{do}: найвище {fond} {castka}, власні внески {vklady}',
      grafNadpis: 'Вартість рахунку наприкінці року',
      grafNadpisMesic: 'Вартість рахунку наприкінці року (останній рік до вибраного місяця)',
      kpiNasporeno: 'Накопичено',
      kpiNove: 'Нова схема',
      kpiRozdil: 'Різниця',
      kpiStare: 'Стара схема',
      kpiStat: 'Держава разом',
      kpiUsporaDip: 'Податкова економія разом',
      kpiVDip: 'Накопичено в DIP',
      kpiVklady: 'Власні внески',
      kpiZhod: 'Прибутковість власних грошей',
      mesicuStat: '{mesicu}, держава {stat}',
      nove: 'Нова схема (фонд або середнє)',
      noveOd2013: 'Нова схема існує з 2013 року.',
      od: 'з {rok}',
      odMesice: 'З місяця',
      odRoku: 'З року',
      pohled: {
        cmp: 'Стара vs. нова схема',
        dip: 'DIP',
        fund: 'Конкретний фонд',
        str: 'Порівняння стратегій',
      },
      pohledy: 'Вигляд',
      pole: {
        emp: 'Внесок роботодавця на місяць',
        lump: 'Одноразовий внесок на початку',
        own: 'Власний внесок на місяць',
      },
      pravidlaInfo: 'З 7/2024 без державного внеску. Державний внесок: 2000–2012 макс. 150 Kč (шкала орієнтовна), 2013–6/2024 макс. 230 Kč (від 1 000 Kč), з 7/2024 20 % від внеску, макс. 340 Kč. Податкова економія рахується з 2013 року, ставка 15 %.',
      skupinaNove: 'Нова схема – {spolecnost}',
      skupinaPrumery: 'Середні значення',
      skupinaStare: 'Стара схема',
      slHodnota: '{fond} – вартість',
      slVynos: '{fond} – прибуток',
      slozeni: 'З чого складається',
      stare: 'Стара схема (трансформований фонд)',
      statSub: 'внески {stat} + податкова економія {uspora}',
      tfZkratka: 'TF',
      transformovany: 'трансформований фонд',
      usporaDipSub: 'відрахування до 48 000 Kč на рік, з 2024 року',
      usporaObdobi: 'Податкова економія з відрахувань за весь період',
      vProspechNoveho: 'на користь нової схеми',
      vProspechStareho: 'на користь старої схеми',
      vlastniVklady: 'Власні внески',
      vynosFondu: 'прибуток фонду {pct} на рік',
      zadani: 'Вхідні дані',
      zdroje: 'Джерела: APS ČR, banky.cz. Прибутки після комісій.',
      zdrojeInfo: 'APS ČR (фонди учасників 2017–2025, трансформовані фонди 2013–2025, пенсійні фонди 1995–2012), banky.cz (фонди учасників 2013–2016). Внески на початку місяця, річний прибуток рівномірно розподілений на місяці, державний внесок у тому самому місяці. Минулі прибутки не гарантують майбутніх. Це не пропозиція і не інвестиційна порада.',
      ztrata: 'Збиток',
    },
    m: {
      dalsi: 'Наявний договір та інші припущення',
      danZVynosu: 'Врахувати податок із прибутку пенсійного накопичення',
      danZVynosuInfo: '15 % із прибутку (і внесків роботодавця) при одноразовому вилученні з пенсійного накопичення. При ренті на 10 і більше років не сплачується. DIP після виконання умов без податку.',
      danZVynosuOdectena: 'Податок із прибутку (уже віднято)',
      danZam: 'Оподатковувати й внески роботодавця в пенсійне накопичення',
      danZamInfo: 'При одноразовому вилученні 15 % оподатковується прибуток і внески роботодавця в пенсійне накопичення (так рахує завдання калькулятора). На DIP не поширюється.',
      dip: 'DIP',
      dip2: 'DIP 2',
      dipKratce: 'DIP',
      doMaxima: 'до максимуму бракує {castka}',
      dodaneni: 'Доподаткування відрахувань при невиконанні умов',
      duchod: 'Клієнт отримує пенсію за віком',
      duchodInfo: 'З 7/2024 отримувач пенсії за віком державний внесок не отримує.',
      duchodceNe: 'пенсіонер: внесок не належить',
      grafAria: 'Складена стовпчикова діаграма накопиченої суми за роками, у {rok} році разом {castka}',
      grafNadpis: 'Накопичено наприкінці кожного року',
      jednotkaLet: 'років',
      jednotkaMesicu: 'місяців',
      jizInfo: 'Зараховується до умови мінімального строку накопичення. Залишок наявного договору введіть як одноразовий внесок або переказ.',
      kategorie: {
        dite: 'Дитина',
        dospely: 'Дорослий',
        senior: 'Сеньйор',
      },
      klient: 'Клієнт',
      kpiNasporeno: 'Разом накопичено на пенсію',
      kpiNavic: 'Отримаю понад',
      kpiRenta: 'Щомісячна рента',
      kpiVynos: 'Прибуток p. a.**',
      letFew: '{n} роки',
      letMany: '{n} років',
      letOne: '{n} рік',
      maxVyuzito: 'максимум {castka} використано',
      mesicuFew: '{n} місяці',
      mesicuMany: '{n} місяців',
      mesicuOne: '{n} місяць',
      naKonci: 'наприкінці накопичення',
      nadVklady: 'понад власні внески {castka}',
      narozeni: 'Дата народження',
      nelze: 'неможливо',
      nesplneno: 'Не виконано',
      odStatu: 'Від держави разом на рік',
      odchod: 'Вихід на пенсію',
      odebratDip2: 'Прибрати другу стратегію DIP',
      odpocty: 'Клієнт використає податкові відрахування',
      odpoctyInfo: 'З власних внесків у пенсійне накопичення понад 1 700 Kč на місяць і з DIP, разом макс. 48 000 Kč на рік. Економія = відрахування × 15 %; до накопиченої суми не додається.',
      odpoctyNe: 'відрахування не враховано',
      penzeVRoce: 'Пенсія в році',
      penzijko: 'Пенсійне накопичення (DPS)',
      penzijkoKratce: 'Пенсійне',
      plnaPodpora: 'Повна підтримка: {a} на місяць у пенсійне накопичення для державного внеску і ще {b} на місяць у пенсійне накопичення або DIP для податкового відрахування.',
      poDani: 'після податку з прибутку {castka}',
      pocatek: 'Одноразовий внесок або переказ',
      pocatekInfo: 'Залишок наявного договору або одноразовий внесок. У Прибуток* рахується як власні гроші, внесені на початку.',
      podminky: 'Умови і податки',
      podpora: 'Використання державної підтримки',
      podporaInfo: 'Державний внесок: 20 % від власного внеску від 500 Kč, макс. 340 Kč на місяць (при внеску 1 700 Kč). Податкова економія: 15 % від відрахування, макс. 7 200 Kč на рік. Максимум від держави — 11 280 Kč на рік.',
      pole: {
        dip2Vlastni: 'DIP 2 – власні внески',
        dip2Vynos: 'DIP 2 – прибуток',
        dip2Zam: 'DIP 2 – роботодавець',
        dipVlastni: 'DIP – власні внески',
        dipVynos: 'DIP – прибуток',
        dipZam: 'DIP – роботодавець',
        dpsPocatek: 'Пенсійне накопичення – одноразовий внесок',
        dpsVlastni: 'Пенсійне накопичення – власні внески',
        dpsVynos: 'Пенсійне накопичення – прибуток',
        dpsZam: 'Пенсійне накопичення – роботодавець',
        jizMesicu: 'Уже накопичено за наявним договором',
        narozeni: 'Дата народження',
        rentaLet: 'Кількість років на пенсії',
        rentaVynos: 'Прибуток на пенсії',
        roky: 'Роки накопичення',
      },
      pravidlo: 'Правило 60 років + 120 (60) місяців',
      pravidloAno: 'Виконано',
      pravidloAuto: 'Оцінити за віком і строком накопичення',
      pravidloDetail: 'вік при виплаті {vek}, накопичення {mesicu} (мінімум {min} місяців)',
      pravidloInfo: 'Виплата без повернення підтримки: вік 60 років і строк накопичення щонайменше 120 місяців (договори до 2023: 60 місяців). Якщо не виконано, калькулятор орієнтовно поверне державні внески, оподаткує прибуток і доподаткує відрахування за останні 10 років.',
      pravidloNe: 'Не виконано (дострокове вилучення)',
      pravidloPredpoklad: 'вік не введено, вважається виконаним',
      pravidloRucne: 'задано вручну (мінімум {min} місяців)',
      predpoklady: 'Модельний розрахунок, а не гарантія.',
      predpokladyInfo: 'Припущений прибуток після комісій на весь строк накопичення, щомісячне нарахування (річний прибуток / 12), внески на початку місяця. Рента — ануїтет із виплатою на початку місяця. Правила державної підтримки, чинні з 1. 7. 2024, без змін на весь строк. Податкова економія до накопиченої суми не додається. Минулі прибутки не гарантують майбутніх, це не інвестиційна порада.',
      pridatDip2: 'Додати другу стратегію DIP',
      priklad: 'Приклад',
      produkty: 'Результати за продуктами',
      produktyInfo: 'Прибуток* = річна прибутковість власних внесків разом із державним внеском. Прибуток** = ще й із внеском роботодавця. У рядках продуктів рахується із суми до податку, у рядку Разом — після податку.',
      renta: 'Рента на пенсії',
      rentaBezZhod: '{roky}, без подальшого прибутку',
      rentaInfo: 'Рента — це ануїтет із виплатою на початку місяця. При 0 % накопичена сума лише ділиться на однакові щомісячні виплати.',
      rentaSeZhod: '{roky}, прибуток {pct} на рік',
      rokyDoPenze: 'Років до пенсії',
      rokyRucne: 'Ввести роки накопичення вручну',
      rokyRucneInfo: 'Коли дата народження невідома або клієнт хоче накопичувати інший строк, ніж до 60 / 65 років.',
      slozeni: 'З чого складається накопичена сума',
      smlouva2024: 'Договір укладено після 1. 1. 2024',
      smlouva2024Info: 'Договір, укладений з 1. 1. 2024, для виплати без санкцій потребує щонайменше 120 місяців накопичення, старший договір — 60 місяців.',
      splneno: 'Виконано',
      statMes: 'Державний внесок на місяць',
      strategie: 'Стратегія',
      strategieInfo: 'Передвстановлення підставить прибуток за середнім фондів цієї стратегії за {od}–{do} (після комісій). Лише підказка, не прогноз.',
      usporaCelkem: 'Податкова економія за весь строк (повертається в податку, на рахунку її немає)',
      usporaRok: 'Податкова економія на рік',
      v60: 'у 60 років',
      v65: 'у 65 років',
      vRoce: 'у {rok} році',
      vek: 'Вік',
      vklady: 'Щомісячні внески і прибуток',
      vkladyInfo: 'Щомісячні внески в пенсійне накопичення (DPS) і DIP. Прибуток — припущення після комісій, нараховується щомісяця (річний прибуток / 12), внески на початку місяця.',
      vlastni: 'Власні внески',
      vlastniVynos: 'Власний прибуток',
      vlastniZadani: 'Власні дані',
      vynos: 'Прибуток на рік',
      vyuzitoAria: 'Використано {pct} % максимуму',
      vzorPokrocily: 'Приклад: пенсійне накопичення + DIP',
      vzorZakladni: 'Приклад: 1 000 Kč у пенсійне накопичення',
      zMaxima: 'з макс. {castka} · {pct}',
      zamestnavatel: 'Роботодавець',
      zhodVlastnich: 'прибутковість власних грошей',
    },
    prumer: {
      dynamicky: 'Середнє динамічних фондів',
      jina: 'Середнє',
      konzervativni: 'Середнє консервативних фондів',
      transformovany: 'Середнє трансформованих фондів',
      vyvazeny: 'Середнє збалансованих фондів',
    },
    prumerKratce: {
      dynamicky: 'Ø динамічні',
      jina: 'Ø',
      konzervativni: 'Ø консервативні',
      transformovany: 'Ø трансформовані',
      vyvazeny: 'Ø збалансовані',
    },
    r: {
      coPocitat: 'Що рахувати',
      dan: 'Відняти 15 % податку з прибутку',
      dostavat: 'Скільки отримуватиму',
      f: {
        castka: 'Накопичено на початку пенсії',
        let: 'Роки виплат',
        letS: 'Роки накопичення',
        pocatek: 'Уже накопичено',
        renta: 'Бажана щомісячна рента',
        vynos: 'Прибуток на пенсії',
        vynosS: 'Прибуток під час накопичення',
        zam: 'Роботодавець на місяць',
      },
      grafCerpani: 'Залишок під час виплат',
      grafCerpaniAria: 'Площинна діаграма залишку протягом {roky} виплати ренти {renta} на місяць',
      grafSporeni: 'Накопичення і виплата ренти',
      grafSporeniAria: 'Площинна діаграма: накопичення {sporeni} до {castka}, потім {roky} виплати ренти {renta}',
      kpiNasporeno: 'Накопичено за такого внеску',
      kpiPotreba: 'Потрібна сума на пенсії',
      kpiRenta: 'Щомісячна рента',
      kpiSporit: 'Накопичувати на місяць',
      kpiStatZam: 'Держава і роботодавець на місяць',
      kpiVyplaceno: 'Виплачено разом',
      kpiZUroku: 'З них прибуток на пенсії',
      kpiZtrata: 'Збиток на пенсії',
      letRenty: '{roky} ренти',
      letRentyPo: '{roky} ренти по {renta}',
      nadCastku: 'понад накопичену суму {castka}',
      nelze: {
        nedosazitelne: 'За заданого прибутку недосяжно. Спробуйте довший строк або вищий прибуток.',
        nulovaDoba: 'Строк накопичення 0 місяців. Спробуйте довший строк.',
      },
      nelzeSpocitat: 'неможливо розрахувати',
      nicKPrevzeti: 'Модель поки не має правильного результату.',
      odchod: 'Вихід на пенсію {rok}',
      osaRokPenze: 'Вісь: рік пенсії (0 = початок пенсії)',
      pokryto: 'На бажану ренту вистачить уже введених заощаджень і внесків роботодавця. Власний щомісячний внесок не потрібен.',
      pozn: 'Модельний розрахунок, а не гарантія.',
      poznDostavatInfo: 'Рента — ануїтет із виплатою на початку місяця: місячна ставка = річний прибуток / 12, наприкінці строку виплат залишок нульовий. При 0 % сума лише ділиться на однакові виплати. Інфляція і податки з виплат не враховуються.',
      poznSporitInfo: 'Щомісячний внесок — найменша ціла сума в Kč, за якої накопичене покриє бажану ренту. Накопичення: щомісячне нарахування (річний прибуток / 12), внески на початку місяця, державний внесок за правилами з 7/2024. Рента — ануїтет із виплатою на початку місяця. Інфляція не враховується.',
      prevzato: 'Узято з моделі.',
      prevzit: 'Узяти з моделі',
      rentaMes: 'рента {renta} на місяць',
      rokRenty: '{n}-й рік ренти',
      rokSporeni: '{n}-й рік накопичення',
      slCelkem: 'Виплачено разом',
      slFaze: 'Фаза',
      slRokPenze: 'Рік пенсії',
      slVklady: 'Внески за рік',
      slVyplaty: 'Виплати за рік',
      slZaRok: 'Виплачено за рік',
      slZustatek: 'Залишок наприкінці року',
      sporit: 'Скільки накопичувати',
      staciUspory: 'вистачить уже введених заощаджень і внесків',
      stat: 'Накопичувати в пенсійному накопиченні з державним внеском',
      statInfo: '20 % від власного внеску від 500 Kč, макс. 340 Kč на місяць.',
      statZamSub: 'держава {stat}, роботодавець {zam}',
      uvod: 'Скільки клієнт отримуватиме з накопиченої суми або скільки треба накопичувати на бажану ренту.',
      vyplatFew: '{n} щомісячні виплати',
      vyplatMany: '{n} щомісячних виплат',
      vyplatOne: '{n} щомісячна виплата',
      zaokrouhleno: 'власний внесок, округлено вгору',
      zustatek: 'Залишок',
    },
    sdileni: {
      doba: 'Строк накопичення',
      mesicne: '{castka} на місяць',
      uvod: 'Добрий день, надсилаю модель пенсійного накопичення і DIP — скільки щомісяця і що з цього може бути на пенсії. Перегляньте і напишіть мені.',
      veta1: 'Пенсія — це довга дистанція: що раніше почати, то більше працює складний відсоток.',
      veta2: 'Це модельний розрахунок із припущеним прибутком, а не гарантія. Фактичний результат буде іншим.',
    },
    sl: {
      celkem: 'Разом',
      danPriVyberu: 'Податок при виплаті',
      danZVynosu: 'Податок з прибутку',
      nasporeno: 'Накопичено',
      predDani: 'Накопичено до податку',
      produkt: 'Продукт',
      rok: 'Рік',
      vek: 'Вік',
      vynos1: 'Прибуток*',
      vynos2: 'Прибуток**',
      vynosFondu: 'Прибуток фонду',
    },
    slozky: {
      stat: 'Держава',
      vlastni: 'Власні внески',
      zamestnavatel: 'Роботодавець',
      zhodnoceni: 'Прибуток',
      zhodnoceniPoDani: 'Прибуток після податку',
    },
    stranka: {
      nadpis: 'Пенсійне накопичення і DIP',
      paticka1: 'Модель, а не гарантія. Минулі прибутки не гарантують майбутніх. Це не інвестиційна порада.',
      paticka2: 'Прибутки фондів після комісій (APS ČR, banky.cz). Правила державної підтримки чинні з 1. 7. 2024, стан на жовтень 2026. Розрахунок не є пропозицією укласти договір.',
      podnadpis: 'Модель на майбутнє, історія фондів, порівняння фондів і план ренти.',
      poslat: 'Надіслати клієнту',
      skVeta: 'Калькулятор рахує чеське пенсійне накопичення (DPS) і DIP за правилами ЧР, суми в Kč.',
      stitek: 'Пенсійний калькулятор',
      tisk: 'Друк / PDF',
      zalozky: {
        fondy: 'Порівняння фондів',
        historie: 'Історична',
        modelace: 'Модель DPS + DIP',
        renta: 'План ренти',
      },
      zalozkyAria: 'Пенсійні калькулятори',
    },
    strategieNazev: {
      dynamicky: 'Динамічна',
      jina: 'Інша',
      konzervativni: 'Консервативна',
      transformovany: 'Трансформовані фонди',
      vyvazeny: 'Збалансована',
    },
    tabulkaPoLetech: 'Таблиця за роками',
    upozorneni: {
      duchodceBezStatu: 'Отримувач пенсії за віком державний внесок не отримує (з 7/2024).',
      pravidloNesplneno: 'Правило 60 років + {min} місяців не виконано: державні внески повертаються, прибуток і внески роботодавця оподатковуються 15 %, відрахування доподатковуються (орієнтовно).',
      zamNadLimit: 'Внесок роботодавця {rocne} на рік перевищує звільнений ліміт {limit} (DPS + DIP + страхування життя разом).',
    },
  },
  /* BLOK:penze2 END */
  /* BLOK:vydajePravidlo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vydajePravidlo: {
    tip: 'Витрати заповнені за правилом ({pct} %) — це оцінка з доходу, а не цифри від клієнта. Сміливо перепишіть їх.',
    tipNazev: 'Витрати за правилом',
  },
  /* BLOK:vydajePravidlo END */
  /* BLOK:rozpisKategorii START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisKategorii: {
    planPocita: 'план зараз рахує з цією сумою',
    pouzit: 'Використати як звичайні витрати',
    prepis: 'Розпис за категоріями ({castka}) буде перезаписано сумами з деталей — інакше план бере більше з двох чисел.',
    radek: 'З розпису за категоріями',
    sedi: 'збігається зі звичайними витратами',
    smazano: 'Розпис за категоріями видалено',
    smazat: 'Видалити розпис',
    vratit: 'Повернути',
  },
  /* BLOK:rozpisKategorii END */
  /* BLOK:smrtVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  smrtVysvetleni: {
    aria: 'Після смерті родині потрібно {potreba}, надійде {prijde}, бракує {chybi}.',
    ariaPrebyva: 'Після смерті родині потрібно {potreba}, надійде {prijde}, залишиться {prebyva}.',
    bezVydaju: 'Покриття на випадок смерті неможливо розрахувати — в аналізі бракує витрат.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} у сьогоднішніх цінах. Рахуємо, що виплачені гроші будуть вкладені з модельною дохідністю 4 % понад інфляцію (модель, не гарантія). Тому сьогодні достатньо {kapital}.',
    chybiVeta: 'бракує {castka} щомісяця · {roky}',
    cilBezHorizontu: 'ціль {nazev} без горизонту, не враховано',
    duchod: 'пенсія вдови та сироти від держави',
    duchodBezDeti: 'пенсія вдови від держави',
    duchodSablona: 'пенсія у разі втрати годувальника (шаблон країни)',
    jenUkazka: 'Лише ілюстрація — до плану нічого не записується.',
    krok1: 'Витрати родини після смерті',
    krok1Pod: 'на {pct} % менше, ніж сьогодні ({vydaje})',
    krok2: 'Що надійде родині',
    krok3: 'Чого бракує — на {roky}',
    krok4: 'Ліміт на випадок смерті',
    krok4Metoda: 'Капітальний метод',
    krok4Pod: 'чого бракує + борги + цілі − що вже маєте',
    krok5Minimum: 'Старіша методика: щонайменше борги + річний дохід + діти до самостійності',
    krok5MinimumBezPrijmu: 'Старіша методика: щонайменше погашення боргів',
    mezisoucet: 'за капітальним методом',
    minimumDite: '{jmeno} до {vek} років',
    minimumDiteBezJmena: 'дитина',
    minimumPrijem: 'Річний дохід родини',
    minimumVeta: 'Вийшло більше, ніж за капітальним методом, тому діє це.',
    model: 'Орієнтовна модель, не гарантія: рахує з дохідністю 4 % понад інфляцію, за нижчої дохідності ліміт вищий. Пенсія вдови та сироти — орієнтовний шаблон, справжню суму визначить держава. Рента (фінансова незалежність) до смерті не зараховується — після смерті її вже ніхто не отримує; спільні цілі залишаються. Виплати визначають умови страхування.',
    nepotreba: 'Родині залишився б достатній дохід — покриття на випадок смерті не потрібне.',
    nicNechybi: 'Доходи покривають витрати родини точно.',
    odvozeneRoky: 'виведено: горизонт {roky} за шаблоном',
    orezano: 'Доходів і майна родині вистачить — покриття на випадок смерті не потрібне.',
    partner: '{jmeno} далі заробляє',
    pasivniAria: 'Пасивний дохід {castka}, ліміт на випадок смерті {limit}',
    pasivniTitul: 'Якби ви сьогодні мали пасивний дохід',
    pasivniVeta: 'Страхування — це ціна за те, що поки не маємо пасивного доходу.',
    poPrepoctu: 'Після перерахунку за новою методикою діє капітальний метод ({castka}).',
    prahMezera: 'покриє розрив',
    prahNula: 'поліс не потрібен',
    prebyvaVeta: 'Доходів родині вистачить і залишиться {castka} — на стільки ліміт нижчий.',
    rada: {
      chybi: 'бракує',
      dnes: 'витрати після смерті',
      duchod: 'пенсія від держави',
      partner: 'дохід партнера',
      pasivni: 'пасивний дохід',
    },
    radekChybi: 'Чого бракує на {roky}',
    radekCile: 'Інвестувати на цілі (сьогоднішня вартість)',
    radekDluhy: 'Погасити борги',
    radekMajetek: 'Що вже маєте на рахунках',
    radekPrebytek: 'Що родині залишиться з доходів понад потребу — за {roky}',
    rucne: 'На картці вручну {rucni}, розраховано {spocitano}.',
    skryt: 'Сховати розрахунок',
    staraMetodika: 'Старіша методика — діє мінімум.',
    titul: 'Як складається сума на випадок смерті',
    toggle: 'Як рахується смерть',
    vysledek: 'Ліміт на випадок смерті',
    zaokrouhleni: 'Рядки заокруглені, їхня сума може трохи відрізнятися.',
  },
  /* BLOK:smrtVysvetleni END */
  /* BLOK:poradiRizik START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiRizik: {
    invaliditaSmrt: 'інвалідність / смерть',
  },
  /* BLOK:poradiRizik END */
  /* BLOK:splatkaUveru START — generuje scratchpad/slovnik.py, ručně needitovat */
  splatkaUveru: {
    infoNazev: 'З чого складається сума',
    rozpad: 'З {rok} р.: платіж за кредитом {uver}/міс. + цілі, введені вручну понад бюджет, {rucni}/міс.',
    rozpadOchrana: 'З {rok} р.: платіж за кредитом {uver}/міс. + захист понад надлишок {ochrana}/міс.',
    rozpadOchranaRucni: 'З {rok} р.: платіж за кредитом {uver}/міс. + захист понад надлишок {ochrana}/міс. + цілі, введені вручну понад бюджет, {rucni}/міс.',
    schodek: 'З {rok} р. бракує {castka}/міс. — платіж вищий, ніж дозволяє бюджет.',
    schodekNejvic: 'Найбільше бракує {castka}/міс. з {rok} р.',
  },
  /* BLOK:splatkaUveru END */
  /* BLOK:kartaCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kartaCile: {
    akontace: 'Перший внесок',
    bezUveru: 'Усю суму заплатите з власних грошей — кредит не потрібен.',
    cashflowBezNajmu: 'З {rok} платіж {splatka} протягом {roky}.',
    cashflowDvaUvery: 'З {rok} р. платіж {splatka} — з того будівельні заощадження {stavebko} лише {rokyStavebko}, іпотека {roky}.',
    cashflowGraf: 'грошовий потік у часі',
    cashflowKlesne: 'З {rok} р. платіж {splatka}, оренда {najem} відпаде — надлишок зменшиться на {zmena}.',
    cashflowSNajmem: 'З {rok} платіж {splatka}, оренда {najem} зникне — надлишок {zmena}.',
    cashflowStoupne: 'З {rok} р. платіж {splatka}, оренда {najem} відпаде — надлишок зросте на {zmena}.',
    celkem: 'разом',
    celkemZaplatite: 'Загалом заплатите',
    celyText: 'повний текст',
    cerpani: 'отримання',
    cilCara: 'ціль {castka}',
    cnbKratce: 'до 36 років вистачить 10 % власних коштів, інакше 20 %',
    detailInvestice: 'Деталі інвестиції',
    detailInvesticePod: 'розподіл у часі, історія',
    dofDopadProdej: 'Власні кошти зменшаться на {snizeni} — залишається накопичити {zbyva}.',
    dofDopadZastava: 'Банк оцінює кредит щодо обох нерухомостей: до {uver} ({ltv} % з {zaklad}) → власні кошти {vlastni}. Згоду заставодавця, оцінку і платоспроможність перевірити в банку.',
    dofHodnotaZastavy: 'вартість застави',
    dofJiny: 'інше майно',
    dofNe: 'ні',
    dofOdebrat: 'прибрати',
    dofPouzitZastavu: 'використати як заставу',
    dofPouzitoU: 'використано для цілі {cil}',
    dofProdej: 'продаж нерухомості',
    dofStaraMetodika: 'План розраховано за старішою методикою — доплата проявиться після перерахунку за новою методикою.',
    dofStitekOcekavane: 'очікуване',
    dofStitekOverteDruh: 'перевірте вид',
    dofStitekStehovani: 'лише при переїзді',
    dofStitekZatizeni: 'перевірте обтяження (іпотека {castka})',
    dofStitekZatizeniBez: 'перевірте обтяження іпотекою',
    dofVynos: 'виручка з продажу',
    dofZAnalyzy: 'В аналізі обрано як заставу: {nazev} · {hodnota}',
    dofZadnaZastava: 'В аналізі немає нерухомості — введіть вартість вручну.',
    dofZadnyJiny: 'В аналізі немає нічого на продаж — введіть суму вручну.',
    dofZadnyProdej: 'В аналізі немає нерухомості на продаж — введіть суму вручну.',
    dofZastava: 'застава нерухомості (власної або батьків)',
    dofZbyde: 'З продажу залишиться {castka}.',
    dofZrusenoChybi: '«{nazev}» вже немає в аналізі — збережений вибір не враховується.',
    dofZrusenoJiny: '«{nazev}» — це нерухомість, вона належить до продажу або застави. Збережений вибір не враховується.',
    dofZrusenoPouzito: '«{nazev}» вже враховано для цілі {cil} — кожну позицію лише один раз. Збережений вибір не враховується.',
    dofZrusenoProdej: '«{nazev}» в аналізі не є нерухомістю — збережений продаж не враховується.',
    dofZrusenoUver: 'Застава при споживчому кредиті неможлива — збережений вибір не враховується.',
    dofZrusenoZastava: '«{nazev}» не можна заставити — застава лише для нерухомості. Збережений вибір не враховується.',
    doporuceno: 'рекомендовано',
    grafAriaModel: 'Вкладете {vlozeno}, за {roky} модельно {hodnota}, дохід {vynos} — модель, не гарантія.',
    hotove: 'готівкою',
    hotovePct: 'готівкою {pct} %',
    hypoVychozi: 'Порожнє поле = типові {sazba} % на {roky} р., не пропозиція банку.',
    hypotekaVyse: 'Іпотека',
    hypotekaZaRoky: 'Іпотека за {roky}',
    jednorazoveDnes: 'Разово сьогодні',
    jenHypotekaAria: 'Графік показує лише іпотеку, без кредиту з будівельних заощаджень.',
    kolikHotove: 'Скільки заплатите готівкою',
    kombinace: 'Ваші вільні гроші + решта щомісяця',
    kombinacePod: '{jedn} разово з ваших грошей, решта {mes} щомісяця',
    kombinacePodNestaci: '{jedn} одноразово з ваших грошей, решта {mes} щомісяця — більше, ніж надлишок дає на ціль',
    krok1: 'Накопичити',
    krok1Hotove: 'Накопичити те, що заплатите готівкою',
    krok1Rezerva: 'Наповнити резерв',
    rezervaBezVydaju: 'Резерв не можна розрахувати — в аналізі бракує витрат.',
    krok1Vlastni: 'Накопичити власні кошти',
    krok2Hypo: 'Позичити іпотекою',
    krok2Uver: 'Позичити кредитом',
    krok3: 'Доплатити з майна',
    krytoZeZdroju: 'Покрито з ваших грошей — нічого додатково не потрібно.',
    mesNestaci: 'надлишок на це дає {prideleno} — бракує {chybi}',
    mesNestaciKroky: 'у плані відтепер {prideleno}, потім більше — див. по черзі',
    mesPakVic: 'сьогодні, потім більше — див. по черзі',
    modelovaHodnota: 'Модельна вартість',
    modelove: 'модельно',
    nadPrebytek: 'більше, ніж вільний надлишок',
    nbsKratce: '20 % власних коштів, 10 % лише винятково',
    neboMesicne: 'або щомісяця',
    neboMesicneRenta: 'або щомісяця',
    nejistota: 'Модель ({scenar}) у сьогоднішніх цінах, не гарантія — фактичний дохід буде іншим.',
    nicSporit: 'Нема що заощаджувати.',
    nicSporitUver: 'Нема що заощаджувати — усю ціну покриває кредит і майно (крок 2 і 3).',
    obaUvery: 'Обидва кредити разом',
    obojiUlozene: 'Разово і щомісяця (збережено в плані)',
    odRoku: 'з {rok}',
    odTed: 'відтепер',
    osaJednorazove: 'разово — {zdroj}',
    osaJednorazovePoCili: 'одноразово — {zdroj} · аж після терміну цілі, не враховується',
    osaJednorazovePoRente: 'одноразово — {zdroj} · аж після початку ренти, не враховується',
    osaMzdaNedorazi: '{rust} — до ренти не дійде',
    osaMzdaPoCili: '{rust} — аж після терміну цілі, не враховується',
    osaMzdaPoRente: '{rust} — аж після початку ренти, не враховується',
    osaMzdaSplatka: '{rust} — увесь його з’їдає платіж за кредитом, до ренти не дійде',
    osaRustMzdy: 'зростання зарплати',
    osaRustMzdyPozde: '{rust} з {rok} — доти його з’їдає платіж за кредитом',
    osaRustMzdyPozdeObecne: '{rust} з {rok}',
    osaRustMzdySablona: 'зростання зарплати (оцінка)',
    osaUverSplacen: 'кредит на {cil} буде сплачено',
    osaUvolneno: 'звільнені гроші з надлишку',
    osaZCile: 'звільниться з цілі {cil} (накопичено)',
    osaZaklad: 'регулярна інвестиція',
    osaZakladMzda: 'з того +{castka} завдяки зростанню зарплати з {rok}',
    pasmo: 'гірший — кращий сценарій',
    pasmoBublina: 'Гірший – кращий сценарій',
    pasmoSouhrn: 'гірший — кращий сценарій {od} – {do}',
    pctZ: '{pct} % з {cena}',
    plneniZa: 'Виконання цілі {kdy} ({scenar})',
    plusStavebko: '+ кредит з будівельних заощаджень {castka} на {roky} р. = {splatka}{mes} (власна ставка)',
    poporade: 'По черзі',
    proVsechnyCile: 'Для всіх цілей:',
    pujcite: 'Позичите',
    puvodniNavrh: 'назад до початкової пропозиції',
    realne: 'реально',
    resiSeUveremHotove: 'Накопичується лише те, що заплатите готівкою, решту покриває кредит — платежі починаються від видачі.',
    rezimBezSchodu: 'Обраний шлях рахує рівну платбу — підвищення з початкової пропозиції',
    rokSplaceni: '{n}-й рік погашення',
    rustBez: 'без зростання',
    rustBezRustu: 'План не рахує зі зростанням внеску — і налаштування жодного не передбачає.',
    rustChybi: 'Зростання зарплати поки НЕ ВРАХОВАНО — у плані немає кроків. Натисніть Врахувати зростання зарплати.',
    rustLisi: 'Кроки зростання зарплати в плані ВІДРІЗНЯЮТЬСЯ від налаштування — план рахує з них. Узгодьте їх кнопкою Врахувати зростання зарплати.',
    rustLisiKratce: 'у плані інші кроки',
    rustLisiZahod: 'План рахує з кроків зростання зарплати, але з налаштування жодне зростання не виходить — відкиньте їх, щоб план відповідав налаштуванню.',
    rustMzdy: 'Зростання зарплати',
    rustNepocita: 'поки не враховано',
    rustPopis: '{pct} {baze} кожні {krok} р.',
    rustRealne: 'реально, понад інфляцію — план рахує в сьогоднішніх цінах і інфляцію не додає.',
    rustRucniPolozka: '+{castka} з {rok}',
    rustSablonaNeRucniAno: 'шаблон поки ні · у плані є ручний {rucni}',
    rustSedi: 'План рахує з цим темпом — кроки зростання зарплати в плані відповідають налаштуванню.',
    rustVPlanu: 'у плані ({n} кроків)',
    rustVPlanuPo: 'у плані: {n} до ренти, {po} аж після її початку',
    schodyAria: 'Місячний внесок зростає з {od} до {do}.',
    seZastavou: 'із заставою',
    sjednotit: 'узгодити з планом',
    skrytGraf: 'сховати графік',
    splatkaMesicne: 'Щомісячний платіж',
    splatkaRozpis: 'іпотека {hypo} + будівельні заощадження {stavebko} ({roky})',
    spotrVychozi: 'Порожнє поле = орієнтовно {sazba} % на {roky} р. (щонайбільше {max} р.) — перевірити в банку.',
    srovnatRust: 'Узгодити з налаштуванням',
    stavebkoZaRoky: 'Кредит з будівельних заощаджень {castka} за {roky}',
    upravit: 'змінити',
    upravitRucne: 'змінити суми вручну',
    uverSpotrebitelsky: 'споживчий кредит',
    uverStavebko: 'кредит з будівельних заощаджень',
    uzMate: 'Вже маєте',
    vPlanuNestaci: 'у плані — недостатньо',
    vRoce: 'у {rok}',
    vetaRoku: 'вкладено {vlozeno} · вартість {hodnota} · дохід {vynos}',
    vlastniProfil: 'власний профіль: {profil}',
    vlastniZdroje: 'власні кошти',
    vlozeno: 'Вкладено',
    vlozite: 'Вкладете',
    volitelne: "необов'язково",
    volnychJen: 'вільних маєте {volne}',
    vybrano: 'вибрано',
    vynos: 'дохід',
    zPrebytku: 'з місячного надлишку',
    zTohoHotove: 'з того готівкою',
    zVolnych: 'з вільних грошей (маєте {volne})',
    zahoditKrokyTitul: 'Видалить із плану кроки зростання зарплати із шаблону — план потім рахує без них, точно як налаштовано.',
    zapocitatRust: 'Врахувати зростання зарплати',
  },
  /* BLOK:kartaCile END */
  /* BLOK:klientEmail START — generuje scratchpad/slovnik.py, ručně needitovat */
  klientEmail: {
    chybaAdresa: 'Перевір e-mail клієнта.',
    chybaPredmet: 'Додай тему.',
    chybaTelo: 'Додай текст листа.',
    crmBezEmailu: 'У клієнта в CRM немає e-mail — додай його вручну.',
    dalsiOdkaz: 'Створити ще одне посилання',
    introFixace: 'Добрий день, надсилаю модель фіксації іпотеки. Ключове — друге число: платіж після закінчення фіксації. Якщо що, озвіться.',
    introHistoricka: 'Добрий день, надсилаю обіцяну модель історичного розвитку інвестиції. Подивіться на цифри — і, якщо що, озвіться.',
    introModelace: 'Добрий день, надсилаю обіцяну модель. Подивіться і, якщо що, озвіться.',
    klientNepovinne: 'Клієнт (необовʼязково)',
    komu: 'Кому',
    kopirovaniChyba: 'Не вдалося скопіювати.',
    kopirovat: 'Копіювати',
    modelaceVPdf: 'Модель у PDF',
    nadpis: 'Надіслати клієнтові',
    najdiKlienta: 'Знайди клієнта за імʼям…',
    neniEmail: 'Це не схоже на адресу e-mail.',
    nepropojeny: 'E-mail у застосунку ще не підключено. Відкриється твоя поштова програма з готовим листом — надсилання підтвердиш там. (Підключити можна в Налаштуваннях.)',
    neznamyTransport: 'Не вдалося зʼясувати, чи підключено e-mail у застосунку. Відкриється твоя поштова програма з готовим листом — надсилання підтвердиш там.',
    odejdeGmail: 'Лист піде з твого Gmail.',
    odejdeGmailAdresa: 'Лист піде з твого Gmail {email}.',
    odejdeSmtp: 'Лист піде з твоєї робочої пошти.',
    odejdeSmtpAdresa: 'Лист піде з твоєї робочої пошти {email}.',
    odesilam: 'Надсилаю…',
    odeslanToast: 'Лист надіслано клієнтові.',
    odeslanoKlientovi: 'Надіслано клієнтові.',
    odeslatChyba: 'Лист не вдалося надіслати.',
    odeslatNa: 'Надіслати на {adresa}',
    odkazChyba: 'Посилання зараз не вдалося створити. Спробуйте, будь ласка, ще раз.',
    otevrete: 'Відкрийте її тут:',
    otevrit: 'Відкрити',
    otevritPostu: 'Відкрити поштову програму',
    ozveteSe: 'Якщо щось не сходиться або виникнуть запитання, озвіться — спокійно все разом переглянемо.',
    pdfChyba: 'PDF не вдалося створити.',
    pdfStazenoToast: 'PDF завантажено — додай його до листа.',
    pdfVeStazenych: 'PDF збережено в теці Завантаження.',
    popis: 'Обери клієнта, додай вступне повідомлення й створи посилання на цю модель.',
    popisHotovo: 'Посилання готове — надішли його клієнтові.',
    poslatEmailem: 'Надіслати поштою',
    postaOtevrena: 'Лист відкрився у твоїй поштовій програмі. Застосунок його НЕ НАДІСЛАВ — надішли його звідти.',
    pozdrav: 'Добрий день,',
    pozdravJmeno: 'Добрий день, {osloveni},',
    predmet: 'Тема',
    predmetVychozi: 'Модель для вас',
    priloha: 'У вкладенні надсилаю те саме у PDF.',
    prilohyNeumi: 'E-mail із застосунку поки не підтримує вкладень. PDF завантажиться до тебе — додай його вручну, або клієнтові вистачить посилання на модель у тексті вище.',
    sPozdravem: 'З повагою',
    schuzka: 'Домовитися про зустріч',
    spojitSe: 'Звʼязатися',
    stahnoutPdf: 'Завантажити PDF',
    textPrecti: 'Текст — прочитай його перед надсиланням',
    titulFixace: 'Фіксація іпотеки — що буде після неї',
    titulHistoricka: 'Історичний розвиток інвестиції',
    titulHypoteka: 'Іпотечна модель',
    titulInvestice: 'Інвестиційна модель',
    uvodVychozi: 'надсилаю модель, яку ми разом переглядали.',
    uvodniPh: 'Добрий день, надсилаю обіцяну модель…',
    uvodniZprava: 'Вступне повідомлення',
    vytvarim: 'Створюю…',
    vytvarimOdkaz: 'Створюю посилання…',
    vytvoritOdkaz: 'Створити посилання',
    whatsapp: 'Написати у WhatsApp',
    zavolejte: 'Або просто зателефонуйте мені: {tel}',
    zjistuji: 'Зʼясовую, як піде лист…',
    zkopirovano: 'Скопійовано',
  },
  /* BLOK:klientEmail END */
  /* BLOK:pdfVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  pdfVystup: {
    ctaVychozi: 'Домовтеся про зустріч',
    dalsiKrok: 'Наступний крок',
    disclaimer: 'Модель орієнтовна й ґрунтується на історичних даних. Минула дохідність не гарантує майбутньої. Інвестиції на ринках капіталу несуть ризик втрати частини або всієї вкладеної суми.',
    financniPoradenstvi: 'Фінансове консультування',
    inv: {
      hero: 'Очікувана вартість',
      projekce: 'Прогноз за роками',
      scenare: 'Сценарії наприкінці періоду',
      thOcekavany: 'Очікуваний',
      thOptimisticky: 'Оптимістичний',
      thPesimisticky: 'Песимістичний',
      thRok: 'Рік',
      thVklady: 'Внески',
      titul: 'Інвестиційна модель',
    },
    jakTomuRozumet: 'Як це розуміти',
    modelace: 'Модель',
    modelaceDisclaimer: 'Необовʼязкова орієнтовна модель. Конкретні умови й ціни уточнимо разом.',
    platnaDo: 'Дійсна до',
    pripravenoPro: 'Підготовлено для',
    qrAlt: 'QR-код',
    qrNavod: 'Відскануйте QR-код камерою телефона — відкриється посилання для звʼязку з консультантом.',
    rozpis: 'Детальний розпис',
    souhrn: 'Підсумок',
    vstupy: 'Вхідні параметри',
    vypracoval: 'Підготував',
  },
  /* BLOK:pdfVystup END */
  /* BLOK:zivotkoPdf START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoPdf: {
    cenaChybi: 'Конкретну ціну доповнить консультант відповідно до обраної страхової компанії — тому в цьому документі її немає.',
    cenaDen: 'У перерахунку на день це {den}.',
    cenaHlava: 'На одного члена родини {hlava} на день.',
    cenaPct: 'Це {pct} % доходу родини.',
    cenaStoji: 'Увесь цей захист коштує {cena} на місяць.',
    cilMesicne: '{nazev} {castka}/міс.',
    cilVychozi: 'ціль',
    disclaimer: 'Орієнтовне рекомендоване покриття за методикою beplan. Конкретний страховий внесок і умови — за обраною страховою компанією. Останнє слово за консультантом.',
    heroLabel: 'Скільки потребує родина, якщо годувальник помре',
    heroLabelInvalidita: 'Скільки потребує родина, якщо годувальник не зможе працювати',
    inCena: 'Вартість покриття / міс.',
    inNezbytne: 'Необхідні витрати / міс.',
    inOsob: 'Осіб у родині',
    inPrijem: 'Дохід родини / міс.',
    inVarianta: 'Варіант покриття',
    inZajistitNa: 'Забезпечити на',
    metodika: 'Методика {verze}.',
    naDen: '{castka}/день',
    nar1: 'Сьогодні родина має {prijem} на місяць. Уявіть, що частину з цього втратить.',
    nar2: 'Якщо дохід знизиться на 5 % ({p5} на місяць), це неприємно — але ви впораєтеся. Зниження на 25 % ({p25}) ще можна витримати, лише затягнувши пасок. Зниження на 50 % ({p50}) бюджет уже не витримає. А зниження на 100 % ({p100}) — це кінець планів, а не просто туго затягнутий пасок.',
    nar3: 'Саме ці два важкі кінці драбини розвʼязує пропозиція: {inval} на випадок інвалідності, {smrt} на випадок смерті та {pn} за кожен день хвороби чи травми. Пораховано на {roky} наперед, із ваших власних цифр — а не з таблиці середніх значень.',
    nar4: 'Крім того, {tnu} на стійкі наслідки травми (що важчі, то вища виплата) і {zav} у разі тяжкої хвороби — рак, інфаркт, інсульт. Це гроші на лікування й на час, а не на рахунки.',
    nar5: 'Захист вирішує, що буде, коли щось піде не так. Цілі родини вирішують, що буде, коли все вийде: {cile}. Разом {suma} на місяць.',
    narrativeTitle: 'Чому саме стільки',
    rokyFew: '{n} роки',
    rokyMany: '{n} років',
    rokyOne: '{n} рік',
    sumInval: 'Якщо не зможе працювати (інвалідність)',
    sumPn: 'Коротка хвороба / травма (непрацездатність)',
    sumSmrt: 'У разі смерті',
    summaryTitle: 'Що буде, якщо…',
    tableTitle: 'Покриття за особами',
    thInvalidita: 'Інвалідність',
    thOsoba: 'Особа',
    thPn: 'Непрацездатність/день',
    thSmrt: 'Смерть',
    thTrvale: 'Стійкі наслідки',
    thVazna: 'Тяжка хвороба',
    titul: 'Пропозиція захисту родини',
    vic10: 'У таблиці перші 5 і останні 5 осіб із загалом {n} — підсумкові цифри вгорі за всю родину.',
  },
  /* BLOK:zivotkoPdf END */
  /* BLOK:vzhledKontrola START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzhledKontrola: {
    ariaHistVyvoj: 'Зміна вартості інвестиції {od}–{do}: вкладено {vlozeno}, вартість {hodnota}, ощадний рахунок {sporeni}',
    ariaRozlozeni: 'Розподіл портфеля',
    smazatCil: 'Вилучити ціль',
    smazatOsobu: 'Вилучити особу',
    snizit: 'Зменшити',
    zrusitVyber: 'Скасувати вибір періоду',
    zvysit: 'Збільшити',
  },
  /* BLOK:vzhledKontrola END */
  /* BLOK:odkladaniZam START — generuje scratchpad/slovnik.py, ručně needitovat */
  odkladaniZam: {
    kino: {
      a5Zam: '+ {castka} роботодавець перераховує прямо на пенсійне накопичення',
      prijem503020: 'Чистий місячний дохід включно з внеском роботодавця',
      tokAria: 'Із зарплати {prijem} і внеску роботодавця {zam} {stranou} йде вбік, {zivot} залишається на життя.',
      vyplataPlus: '+ внесок роботодавця {castka}',
    },
    novyCrmOdklada: 'Відкладає {pct} % доходу включно з внеском роботодавця · ідеал 20 % = {castka}',
    pochvala: 'Ви відкладаєте {pct} % доходу включно з внеском роботодавця ({castka})',
    vc: 'включно з внеском роботодавця',
    vodopad: {
      nejvys: 'Найбільше можна відкласти {castka} = {pct} % доходу включно з внеском роботодавця',
      odkladDnes: 'Сьогодні відкладається {castka} = {pct} % доходу включно з внеском роботодавця (власні внески {vklady} + внесок роботодавця {zam} + вільні гроші {volne}).',
      odkladDohoda: 'Відкладається {castka} = {pct} % доходу включно з внеском роботодавця (власні внески {vklady} + внесок роботодавця {zam} + погоджена сума {dohoda}).',
      posuvnikPct: '{pct} % доходу включно з внеском роботодавця =',
      posuvnikPrazdny: '{pct} % доходу включно з внеском роботодавця = —',
      stranouDnes: 'сьогодні відкладається {pct} % доходу включно з внеском роботодавця',
      stranouDohoda: 'з погодженою сумою відкладається {pct} % доходу включно з внеском роботодавця',
      uzBezi: 'Уже йде {castka} (внески на заощадження {vklady} + внесок роботодавця {zam})',
    },
    zaklad: 'з {zaklad} включно з внеском роботодавця {zam}',
  },
  /* BLOK:odkladaniZam END */
  /* BLOK:fixaceVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  fixaceVystup: {
    disclaimer: 'Історія ставок ґрунтується на щомісячній статистиці ЧНБ (нові житлові кредити за тривалістю фіксації, 2006–2026). Ставка після закінчення фіксації — МОДЕЛЬОВАНЕ значення, а не прогноз: фактичну ставку визначать ринок і банк на момент рефіксації.',
    dlouha: 'Довга фіксація',
    fixaceZa: '{roky} за {sazba}',
    hero: 'Платіж після {po} за ставки {sazba}',
    kratka: 'Коротка фіксація',
    nar1: 'Графік показує, як змінюватиметься ваш платіж протягом усього строку — а не лише в перші роки фіксації. Коротка фіксація сьогодні має нижчий платіж, але після її закінчення платіж перерахують за ставкою, яка діятиме тоді. Її сьогодні ніхто не знає.',
    nar2: 'Червона лінія на графіку — це ваш бюджет. Якщо платіж після рефіксації її перевищить, це проблема — і саме цей ризик приховує нижчий сьогоднішній платіж.',
    nar3: 'Історія ставок в інструменті — це реальна щомісячна статистика Чеського національного банку. Це не прогноз: це свідчення того, як часто й наскільки сильно змінювалися ставки в Чехії.',
    pdfChyba: 'PDF не вдалося згенерувати',
    poLetechFew: '{n} років',
    poLetechMany: '{n} років',
    poLetechOne: '{n} року',
    rokyFew: '{n} роки',
    rokyMany: '{n} років',
    rokyOne: '{n} рік',
    sazbaPo: 'Ставка після рефіксації (модельована)',
    sazbaUnese: 'Ставка, яку бюджет ще витримає',
    splatkaDlouha: 'Платіж при фіксації на {roky}',
    splatkaPo: 'Платіж після {po} за {sazba}',
    splatkaTed: 'Платіж зараз (коротка фіксація)',
    splatnost: 'Строк погашення',
    unese: 'Посильний платіж',
    unesePct: '{castka} ({pct} % доходу)',
    vyse: 'Сума іпотеки',
  },
  /* BLOK:fixaceVystup END */
  /* BLOK:kinoPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoPrijmy: {
    a1BigDoplnte: 'Доповніть доходи — і ми їх розподілимо',
    a1BigPrijem: 'Ваш чистий місячний дохід',
    a1Kicker: 'Куди зникають гроші',
    a1L1: 'Більшість людей не знає, скільки і на що витрачає.',
    a1L2: 'Без системи наприкінці місяця не лишається нічого.',
    a1Nar: '«Давайте подивимося, як розподілити ваші гроші, щоб щось лишилося й на мрії.»',
    a1Title: 'Куди щомісяця тікають гроші?',
    a2Big: 'Проста система, яка працює',
    a2Kicker: 'Правило',
    a2L1: '50 % — необхідні витрати: житло, їжа, енергія, платежі.',
    a2L2: '30 % — стиль життя: радощі, хобі, ресторани.',
    a2L3: '20 % — відкладати на цілі: резерв, інвестиції, рента.',
    a2Title: 'Правило 50 / 30 / 20',
    a3Kicker: 'Скільки у ВАС',
    a3L2: '20 % = {castka} на довгострокові цілі.',
    a3Title: '20 % — рушій вашої незалежності',
    a6Big: 'Ваш шлях до свободи',
    a6Kicker: 'Почніть сьогодні',
    a6L1: 'З часом ці 20 % стануть вашою рентою.',
    a6L2: 'Регулярність + час = гроші почнуть працювати на вас.',
    a6Nar: '«Ці 20 % сьогодні — ваша фінансова незалежність завтра. Давайте почнемо.»',
    a6Title: '20 % регулярно = фінансова незалежність',
    dejstviAria: 'Дія {n}',
    nazev: 'Доходи та витрати',
  },
  /* BLOK:kinoPrijmy END */
  /* BLOK:kinoRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoRizika: {
    a1: {
      aria: 'Шлях до ваших цілей: {cile}.',
      ariaBezCilu: 'Шлях до цілей, які ми ще доповнимо.',
      ariaDalsi: 'Шлях до ваших цілей: {cile} і ще {n}.',
      cile: '{cile}.',
      cileADalsi: '{cile} та інші.',
      dalsiCilFew: 'і ще {n} цілі',
      dalsiCilMany: 'і ще {n} цілей',
      dalsiCilOne: 'і ще {n} ціль',
      kicker: 'Ваш план',
      radekBezCilu: 'Цілі ми доповнимо разом.',
      radekKrok: 'Крок за кроком, як ми домовилися.',
      rezie: 'Дайте клієнтові хвилинку подивитися.',
      tahak: '«Це ваш план: {cile}. Крок за кроком.»',
      tahakBezCilu: '«Перш ніж планувати, скажіть, чого хочете досягти.»',
      tahakDalsi: '«Це ваш план: {cile} та інші. Крок за кроком.»',
      tahakHned: '{cil} одразу',
      tahakVRoce: '{cil} у {rok} році',
      titulek: 'Це ваш план',
      titulekBezCilu: 'План будуємо на ваших цілях',
    },
    a1Big: 'Що може загрожувати плану?',
    a1Kicker: 'Спершу захист',
    a1L1: 'План має стояти на міцному фундаменті — на захисті.',
    a1L2: 'Одна втрата доходу може зруйнувати всі цілі разом.',
    a1Nar: '«Перш ніж будувати мрії, треба забезпечити основу. Інакше одна біда змете весь план.»',
    a1Title: 'Спершу захищаємо, потім будуємо',
    a2: {
      aria: 'Над шляхом до цілей три хмари: втрата доходу (хвороба, травма, інвалідність, смерть) — найбільша, втрата майна (пожежа, вода, крадіжка) і відповідальність за шкоду іншим.',
      invalidita: 'Інвалідність',
      kicker: 'Ризики',
      kradez: 'Крадіжка',
      majetek: 'Втрата майна',
      nejvetsi: 'Найбільший',
      nemoc: 'Хвороба',
      pozar: 'Пожежа',
      radek1: 'Ризиків багато.',
      radek2: 'Головні три: дохід, майно та відповідальність.',
      rezie: 'Не оцінюйте й не лякайте.',
      skodaJinemu: 'Шкода іншим',
      tahak: '«План розраховує, що все піде за задумом. Але життя іноді приносить хмару. Ризиків багато — головні три: дохід, майно та відповідальність.»',
      titulek: 'Що може загрожувати плану?',
      umrti: 'Смерть',
      uraz: 'Травма',
      voda: 'Вода',
    },
    a2BezDeti: 'Ваш дохід утримує все домогосподарство.',
    a2BezHypo: 'Без доходу зупиниться все інше.',
    a2Big: 'Дохід = рушій усього плану',
    a2DetiFew: 'У вас {n} дитини — родина тримається на вашому доході.',
    a2DetiMany: 'У вас {n} дітей — родина тримається на вашому доході.',
    a2DetiOne: 'У вас {n} дитина — родина тримається на вашому доході.',
    a2Hypo: 'Іпотеку треба сплачувати навіть у разі втрати доходу.',
    a2Kicker: 'Ризик № 1',
    a2L2: 'Інвалідність, тривала хвороба, смерть — страхування доходу.',
    a2Nar: '«Найбільший ризик — не ринок, а втрата здатності заробляти. Це ми вирішуємо першим.»',
    a3: {
      ariaBezPrijmu: 'План тримається на доході, якого ми поки не знаємо.',
      ariaDopad: 'Коли {jmeno} довго не може працювати: {dopad} ({pozn}).',
      ariaMensiDil: '{jmeno} несе меншу частину.',
      ariaNese: 'Його несе {jmeno}.',
      ariaNevime: 'Коли {jmeno} довго не може працювати, скільки залишиться на цілі, порахуємо наступного разу разом із державними виплатами.',
      ariaVetsiDil: '{jmeno} несе більшу частину.',
      ariaZaklad: 'План тримається на доході {castka} на місяць.',
      bezDavek: 'без державних виплат',
      jede: 'План триватиме далі',
      kicker: 'Найбільший ризик',
      klient1: 'Клієнт 1',
      klient2: 'Клієнт 2',
      mene: 'На цілі залишиться менше',
      nemuze: '{jmeno} довго не може працювати',
      nevime: 'Що залишиться, порахуємо наступного разу',
      nevimePozn: 'разом із державними виплатами',
      nezbyde: 'На цілі не залишиться',
      obaPracuji: 'Обоє працюють',
      pasivni: 'Пасивний дохід',
      pracuje: '{jmeno} працює',
      prijemDoplnime: 'Дохід доповнимо',
      radek: 'Весь план тримається на вашому доході.',
      radekBezPrijmu1: 'Весь план тримається на доході.',
      radekBezPrijmu2: 'Доходів поки немає — доповнимо їх.',
      rezie: 'Натисніть кнопки під малюнком. Покриття сьогодні не рахуйте.',
      skupinaAria: 'Що як',
      tahakBezPrijmu: '«Весь план тримається на доході. Доповнимо його, а наступного разу покажемо, що його тримає.»',
      tahakJede: '«Весь план тримається на вашому доході. Коли {jmeno} довго не може працювати, план триватиме далі. Частину компенсувала б держава — скільки, порахуємо наступного разу.»',
      tahakMene: '«Весь план тримається на вашому доході. Коли {jmeno} довго не може працювати, на цілі залишиться менше. Частину компенсувала б держава — скільки, порахуємо наступного разу.»',
      tahakNevime: '«Весь план тримається на вашому доході. Коли {jmeno} довго не може працювати, дохід падає. Скільки залишиться на цілі і скільки компенсує держава, порахуємо наступного разу.»',
      tahakNezbyde: '«Весь план тримається на вашому доході. Коли {jmeno} довго не може працювати, на цілі не залишиться. Частину компенсувала б держава — скільки, порахуємо наступного разу.»',
      vasPlan: 'ВАШ ПЛАН',
      velkePopis: 'щомісяця тримає весь план',
      vychoziBezPrijmu: 'Без доходів не знаємо, що тримає план',
      vychoziJede: 'Дохід надходить, план працює',
      vychoziMene: 'На цілі зараз залишається менше, обговоримо в плані',
      vychoziNezbyva: 'На цілі зараз не залишається, обговоримо в плані',
    },
    a3Auto: 'Авто → ОСЦПВ + каско.',
    a3Big: 'Повний щит для родини',
    a3Domacnost: 'Домашнє майно та обладнання — страхування майна.',
    a3Firma: 'Фірма → страхування фірми та перерви в діяльності.',
    a3Kicker: 'Майно й відповідальність',
    a3L2: 'Відповідальність (зокрема перед роботодавцем), правовий захист.',
    a3Nar: '«Окрім доходу, ми стежимо за майном, відповідальністю, авто, правовим захистом, а в підприємців — і за фірмою.»',
    a3Nemovitost: 'Нерухомість + домашнє майно — страхування майна.',
    a3Title: 'Що ми захищаємо',
    a4: {
      aria: 'Ваші цілі під пунктирним щитом: захист доповнимо на наступній зустрічі.',
      coKryje: 'Що це покриває, а що ні',
      coMate: 'Що у вас є',
      domluveno: '(домовлено)',
      jakZapadne: 'Як це вписується в план',
      kicker: 'Наступного разу',
      naDalsiSchuzce: 'На наступній зустрічі',
      pojistneSmlouvy: 'страхові договори',
      radek: 'Сьогодні нічого не вирішуємо.',
      rezie: 'Потім у Підсумку позначте документ Страхові договори.',
      rezieHotovo: 'Документ Страхові договори в Підсумку вже позначено.',
      sSebou: 'Візьміть із собою:',
      tahak: '«У межах фінансового плану ми подивимося і на ваш захист — що маєте сьогодні, що він покриває, а що ні. Перевіримо, чи можна заощадити або застрахуватися розумніше, і покажемо, як це вписується в увесь план.»',
      titulek: 'На наступній зустрічі ми їх розберемо',
    },
    a4Big: 'Захист = спокій для всього плану',
    a4Kicker: 'Підсумок',
    a4L1: 'Переглянемо кожне покриття — щоб родина ніколи не лишилася ні з чим.',
    a4L2: 'Будувати має сенс лише добре захищений план.',
    a4L3: 'Це нудно, але це абсолютна основа.',
    a4Nar: '«Можливо, це найважливіша частина. Давайте разом переглянемо, що у вас покрито і де прогалини.»',
    a4Title: 'Це ми разом переглянемо',
    cil: {
      auto: 'Авто',
      bydleni: 'Житло',
      cil: 'Ціль',
      deti: 'Діти',
      dnes: 'сьогодні',
      investice: 'Інвестиції',
      podnikani: 'Бізнес',
      rekonstrukce: 'Ремонт',
      renta: 'Рента',
      rezerva: 'Резерв',
    },
    iAuto: 'Авто (ОСЦПВ + каско)',
    iDomacnost: 'Домашнє майно',
    iFirma: 'Фірма / діяльність',
    iInvalidita: 'Інвалідність / хвороба',
    iNemovitost: 'Нерухомість',
    iOdpovednost: 'Відповідальність',
    iPravni: 'Правовий захист',
    iUmrti: 'Смерть (родина)',
    iVypadek: 'Втрата доходу',
    iZamestnani: 'Робота',
    nazev: 'Захист від ризиків',
  },
  /* BLOK:kinoRizika END */
  /* BLOK:histKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  histKalk: {
    alokacePomery: 'Розподіл · частки',
    bezPoplatku: 'Без комісій. Введи їх, щоб клієнт бачив, скільки його грошей піде на витрати.',
    bezpecnaRenta: 'Безпечна місячна рента',
    brzdaBez: 'Без гальма',
    brzdaCil: 'На ціль',
    brzdaNadpis: 'Гальмо (поступове зниження ризику)',
    brzdaPopisBez: 'Розподіл незмінний увесь час.',
    brzdaPopisCil: 'Останні ~10 років — перехід у готівку (разова ціль).',
    brzdaPopisRenta: 'Помірне зниження ризику, більше акцій (рента).',
    brzdaRenta: 'На ренту',
    cilovaCastka: 'Цільова сума за цей горизонт',
    disclaimer: 'Модель ґрунтується на реальних історичних даних 1926–2026. Минула дохідність не гарантує майбутньої. Інвестиції несуть ризик втрат.',
    doba: 'Строк',
    dobaInvestice: 'Строк інвестування',
    dobaVyplaty: 'Строк виплат (років)',
    hodnotaDnes: 'Вартість сьогодні',
    hodnotaRealne: 'Реальна вартість',
    jednorazove: 'Одноразово',
    jednorazovyVklad: 'Одноразовий внесок',
    koncova: 'Кінцева вартість портфеля',
    krize: {
      k1929: 'Крах 1929',
      k1973: 'Нафтова криза',
      k1987: 'Чорний понеділок',
      k2000: 'Дотком',
      k2008: 'Фінансова криза',
      k2011: 'Боргова криза',
      k2020: 'Covid',
      k2022: 'Війна в Україні',
    },
    krizeKonec: 'У цих даних ринок щоразу відновлювався.',
    krizeVetaFew: 'За цей час інвестиція пройшла через {n} кризи — і все одно завершилася на {castka}.',
    krizeVetaMany: 'За цей час інвестиція пройшла через {n} криз — і все одно завершилася на {castka}.',
    krizeVetaOne: 'За цей час інвестиція пройшла через {n} кризу — і все одно завершилася на {castka}.',
    legInvestice: 'Інвестиція',
    legSporici: 'Ощадний рахунок',
    legVlozeno: 'Вкладено',
    letZkratka: 'р.',
    mesicne: 'Щомісяця',
    mesicneHodnota: '{castka}/міс.',
    modCil: 'Ціль',
    modRenta: 'Рента',
    nar1: 'Графік показує, як розвивалися б ваші гроші на реальних історичних даних ринків, а не на обіцянках. За ці роки були кризи й падіння — і все ж у довгостроковій перспективі вартість зростала. Найважливіше — почати й витримати.',
    nar2: 'Минула дохідність не гарантує майбутньої. Ринки в короткостроковій перспективі коливаються, і вартість інвестиції може й знизитися. Модель допомагає зрозуміти принцип, а не обіцяє конкретну дохідність.',
    nar3: 'Найбільший союзник — час: завдяки складному відсотку кожен наступний рік працює на вашу користь. Тому варто почати якомога раніше, навіть із меншої суми.',
    nastroje: 'Інструменти',
    navicVeta: 'Порівняно з ощадним рахунком (грошовий ринок) на {castka} більше — стільки коштувала «надійність» готівки.',
    nejhorsim: 'найгіршому',
    nom: 'ном.',
    nominalne: 'номінально',
    obdobi: 'Період',
    obdobiDvojtecka: 'Період:',
    pdfChyba: 'PDF не вдалося згенерувати',
    poplatky: 'Комісії',
    poplatkyCelkem: 'Загалом комісії заберуть у вас {castka} — разом із дохідністю, яку ці гроші вже не заробили.',
    portfolio: 'Портфель',
    portfolioMix: 'Склад портфеля',
    potrebujeteMesicne: 'Потрібно щомісяця',
    pouzit: 'Використати в розрахунку',
    pravidelneMesicne: 'Щомісяця',
    preset: {
      dynamicky: 'Динамічний',
      konzervativni: 'Консервативний',
      moderni: 'Сучасний',
      vyvazeny: 'Збалансований',
      zlaty: 'Із золотом',
    },
    priJednorazovem: 'За одноразового внеску {castka} і розподілу {alokace}.',
    prubeznyPct: 'Поточна % (на рік)',
    real: 'реал.',
    realne: 'реально',
    realneOd: 'реально лише з 8/1946 (раніших даних про інфляцію немає)',
    rentaMaloHistorie: 'Для цього розподілу бракує історії, щоб перевірити весь строк виплат ({roky}) — скороти строк або зменш молоді класи (BTC, REIT, MSCI).',
    rentaVydrzi: 'З накопичених {castka} цього вистачило б на {roky} навіть у {nejhorsim} історичному періоді (інакше довше).',
    rokyFew: '{n} роки',
    rokyMany: '{n} років',
    rokyOne: '{n} рік',
    souhrnReal: 'Моделювання на реальній історії (8/1946–2026, {n} періодів, після інфляції):',
    sporiciByDal: 'Ощадний рахунок дав би',
    staciJednorazovy: '0 {mena} (вистачить одноразового)',
    titul: 'Історичний калькулятор',
    trida: {
      akcie: 'Акції',
      btc: 'Біткоїн',
      dluhopisy: 'Облігації',
      em: 'Ринки, що розвиваються',
      msci: 'MSCI World',
      ndx: 'NASDAQ-100',
      pt: 'Грошовий ринок',
      reit: 'Нерухомість',
      zlato: 'Золото',
    },
    typ: 'Тип:',
    vlozenoCelkem: 'Вкладено загалом',
    vstupniPct: 'Вхідна комісія %',
    vstupniPoplatek: 'Вхідна комісія: {castka} із вкладених {vlozeno}.',
    vynosPa: 'Дохідність річна',
    vyvojNadpis: 'Зміна вартості інвестиції',
    zdrojDat1: 'Дані: SBBI/Ibbotson US щомісячно 1926–2026 (Акції = S&P 500 з дивідендами, Облігації = довгострокові державні США, Грошовий ринок = T-Bills, Інфляція = US CPI). Золото = LBMA з 1968 · MSCI World з 1985 (з оцінкою дивідендів 2 % річних) · Нерухомість = індекс REIT з 2004 · Біткоїн з 2010.',
    zdrojDat2: 'Дохідність річна = внутрішня норма дохідності грошових потоків. Минула дохідність не гарантує майбутньої.',
    zhodnoceni: 'Приріст',
    zkraceno: 'скорочено до {roky} (молодий клас активів)',
  },
  /* BLOK:histKalk END */
  /* BLOK:alokaceGraf START — generuje scratchpad/slovnik.py, ručně needitovat */
  alokaceGraf: {
    celkem: 'Загалом',
    faze: {
      drzeni: 'Тримаємо. Ринок коливається, план — ні.',
      hotovost: 'Гроші в готівці. Жодного ринкового ризику.',
      odprodej: 'Продаємо акції й купуємо облігації — ціль наближається.',
      start: 'Купуємо — гроші йдуть в акції.',
    },
    mesicuFew: '{n} місяці',
    mesicuMany: '{n} місяців',
    mesicuOne: '{n} місяць',
    nadpis: 'Куди течуть гроші з часом',
    pauza: 'Пауза',
    prehrat: 'Відтворити',
    rok: '{n}-й рік',
    zpetNaCelek: 'Назад до всього періоду',
  },
  /* BLOK:alokaceGraf END */
  /* BLOK:fondyRenta START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondyRenta: {
    mimo: ' (інші рахунки та фонди, які не отримала жодна ціль) — усі фінансові активи ',
    prehled: 'Фонди → рента',
    prehledRezerva: 'Фонди → резерв',
    prerozdeluje: 'План одноразово перерозподіляє ліквідні рахунки, будівельні заощадження, пенсійні накопичення та фонди. Поза ним залишається ',
    rozpocetDoRenty: ' — це фонди та інвестиційне страхування життя, які клієнт уже має; план зараховує їх до ренти.',
    rozpocetKCilum: ' — це фонди та інвестиційне страхування життя, які клієнт уже має; план призначив їх цілям відповідно до потоку грошей.',
    rozpocetRezervaRenta: ' — це фонди та інвестиційне страхування життя, які клієнт уже має; план спершу поповнить із них резерв ({rezerva}), решту зараховує до ренти.',
  },
  /* BLOK:fondyRenta END */
  /* BLOK:kinoZavazky START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZavazky: {
    a0: {
      radek: 'В аналізі немає жодного кредиту.',
      tahak: '«Жодного кредиту не сплачуєте. Гроші, які пішли б банку, можуть працювати на вас.»',
      titulek: 'Боргів у вас немає',
    },
    a1: {
      ariaChybi: '{nazev}: {stav}.',
      ariaDluzite: 'Ви винні {castka}.',
      ariaUroky: 'Відсотками ще сплатите {castka}.',
      ariaUrokyCast: 'Відсотками ще сплатите {castka} за кредитами з відомою ставкою.',
      ariaUver: '{nazev}: борг {dluh}, відсотки {uroky}, погашено у {rok} році.',
      dluh: 'борг',
      dluhNeklesa: 'Борг не зменшується',
      dluhZnamy: 'борг із відомою ставкою',
      doplnteSplatku: 'Додайте платіж',
      doplnteUrok: 'Додайте ставку',
      doplnteZustatek: 'Додайте залишок',
      kicker: 'Ваші борги',
      popisNespocitame: 'відсотки поки не порахуємо',
      popisNikdy: 'платіж не покриває навіть відсотки',
      radekChybi: '{nazev}: {stav}, у сумі відсутній.',
      radekChybiBez: '{nazev}: {stav}.',
      radekDluzite: 'Ви винні {castka}.',
      radekNaSto: 'До кожних {sto} боргу ви додаєте банку {kolik}.',
      subDluh: 'борг {castka}',
      tahak: '«Борг коштує не лише те, що ви позичили. Ось скільки ви ще доплатите банку.»',
      tahakDoplnte: '«Подивимося в договорі ставку. Тоді одразу побачите, скільки доплатите банку.»',
      tip: 'Внесіть ставку з договору. Кіно тоді порахує відсотки й кінець виплат.',
      titulek: 'Скільки вам коштують борги',
      urokyBance: 'відсотки банку',
      velkePopis: 'ще сплатите банку відсотками',
    },
    a2: {
      ariaDobry: 'Добрий борг на житло {castka}.',
      ariaDobrySazba: 'Добрий борг на житло {castka} під {sazba}.',
      ariaJenBydleni: 'Лише борг на житло {castka}.',
      ariaPolozka: '{nazev} {sazba} на рік',
      ariaPolozkaBez: '{nazev}, ставку не вказано',
      ariaSpatny: 'Поганий борг {castka}: {seznam}.',
      ariaZadny: 'Поганих боргів у вас немає.',
      bydlite: 'Ви в ньому живете · нерухомість {castka}',
      dobry: 'Добрий борг',
      dobryProc: 'житло',
      firemni: 'Бізнес-кредит',
      firemniProc: 'бізнес · до кроку не належить',
      kicker: 'Добрий і поганий борг',
      radekChybiUrok: 'У поганих боргів не вказано ставку.',
      radekHypo: 'Іпотека {sazba}.',
      radekJenBydleni: 'У вас лише борг на житло.',
      radekNetyka: 'Крок «Позбутися поганих боргів» вас не стосується.',
      radekPrvni: 'Погані борги погашаються першими.',
      radekSazba: '{druh} коштує {sazba} на рік.',
      radekZadnaSpotreba: 'Жодного споживчого кредиту.',
      spatny: 'Поганий борг',
      spatnyProc: 'споживання',
      spatnyZadnyProc: 'споживчий кредит, кредитка, овердрафт',
      tahak: '«Дорогі кредити й кредитки закриємо першими. Відсотки ви сплачуєте напевно, дохід від інвестицій — ні.»',
      tahakZadny: '«Іпотека — це борг, у якому ви живете. Споживчого кредиту чи кредитки не маєте, це добра новина.»',
      titulek: 'Не кожен борг однаковий',
      titulekZadny: 'Поганих боргів у вас немає',
      velkePopis: 'поганий борг · {druhy}',
      velkePopisZadny: 'поганий борг',
      zadny: 'Немає',
    },
    a3: {
      ariaBez: 'Без доплат: погані борги погашено за {za}, відсотки {urok}.',
      ariaNavic: 'З {castka} доплати щомісяця: без поганих боргів за {za} замість {puvodne}, на відсотках заощадите {usetreno}.',
      ariaNesplati: 'Навіть із {castka} доплати щомісяця погані борги не погасяться.',
      jezdecAria: 'Скільки щомісяця доплачувати на погані борги',
      kicker: 'Що як',
      mesZkr: '{n} міс.',
      navicMesicne: 'Додатково щомісяця',
      navicNejdrivSem: 'доплата спершу сюди',
      nic: 'Нічого',
      nikdy: 'ніколи',
      nikdyPopis: 'платіж менший за відсотки · борг росте',
      popisPosunte: 'посуньте, скільки надішлете додатково',
      popisRoste: 'навіть із такою доплатою борг не зменшується',
      popisSplaceno: 'погашено за {za}',
      popisUsetrite: 'заощадите на відсотках',
      pozn: 'Пораховано з платежу та ставки в договорі. Платіж погашеного кредиту звільняється для вас, доплата йде на наступний борг.',
      radekDnes: 'Зараз без поганих боргів за {za}.',
      radekDriv: 'На {kolik} раніше.',
      radekNejdrazsi: 'Доплата йде спершу на найдорожчий борг.',
      radekNikdy: '{nazev}: платіж не покриває навіть відсотки.',
      radekZa: 'Без поганих боргів за {za} замість {puvodne}.',
      rychlaVolba: 'Швидкий вибір',
      tahak: '«Кожна додаткова сума йде на найдорожчий борг. Що не заплатите банку, залишиться вам.»',
      titulek: 'Погасити погані борги раніше',
      valuetext: '{castka} на місяць',
      velkeRoste: 'Досі зростає',
      velkeZastavi: 'Борг зупиниться',
      volne: 'Вільні {castka}',
      zCilu: '{castka} з цього йшло б із грошей на цілі, доки борги не погашено.',
    },
    a4: {
      aria: 'Після кінця фіксації за ставки {sazba} платіж становитиме {po} замість {pred}.',
      dnes: 'Сьогодні · {sazba}',
      jakoDnes: 'як сьогодні',
      jezdecAria: 'Ставка іпотеки після кінця фіксації',
      kicker: 'Іпотека',
      oDvaBody: 'на 2 пункти більше',
      po: 'Після фіксації · {sazba}',
      pozn: 'Ставку після фіксації сьогодні ніхто не знає. Строк лишається, змінюється платіж.',
      poznTrh: 'Середня на ринку сьогодні: Swiss Life Hypoindex {obdobi}.',
      prumerTrhu: 'середня на ринку сьогодні',
      radekSplatka: 'Платіж перерахують: {pred} → {po}.',
      radekZustatek: 'Наприкінці фіксації залишиться {castka} боргу.',
      sazbaPoFixaci: 'Ставка після фіксації',
      tahak: '«Фіксація колись закінчиться. Тепер знаємо, що станеться з платежем, якщо ставка зросте.»',
      titulek: 'Кінець фіксації: {kdy}',
      velkePopis: 'щомісячний платіж за ставки {sazba}',
    },
    a5: {
      ariaDnes: 'На цілі сьогодні {castka} щомісяця.',
      ariaOd: 'З {rok} року {castka}.',
      ariaRenta: 'Рента з {rok} року.',
      dnes: 'сьогодні',
      kicker: 'Після погашення',
      naCile: 'на цілі щомісяця',
      navicNaDluhy: '{castka} додатково на борги',
      poRenteFew: 'Іпотека закінчиться через {n} роки після початку ренти.',
      poRenteMany: 'Іпотека закінчиться через {n} років після початку ренти.',
      poRenteOne: 'Іпотека закінчиться через {n} рік після початку ренти.',
      popisDoplnte: 'без них не знаємо, коли борги закінчаться',
      poznModel: 'Сьогодні на цілі {castka} щомісяця з вільних грошей, ще не погоджено. Звільнені платежі — з договорів. Інші доходи й витрати рахуємо як сьогодні.',
      poznOdsouhlaseno: 'Сьогодні на цілі {castka} щомісяця, як погоджено в аналізі. Звільнені платежі — з договорів. Інші доходи й витрати рахуємо як сьогодні.',
      predRentouFew: 'Закінчиться за {n} роки до ренти.',
      predRentouMany: 'Закінчиться за {n} років до ренти.',
      predRentouOne: 'Закінчиться за {n} рік до ренти.',
      radekHypo: 'У {rok} році закінчиться іпотека. Ще {castka}.',
      radekUsetreno: 'Заощаджені відсотки {castka} залишаться вам.',
      splaceno: '{nazev}: погашено',
      startRenty: 'початок ренти',
      tahak: '«Коли борги закінчаться, ці гроші працюватимуть на вас.»',
      tip: 'Внесіть дату кінця виплат іпотеки з договору.',
      titulek: 'Гроші, які звільняться',
      velkeDoplnte: 'Додайте платежі',
      velkePopis: 'щомісяця додатково на цілі · з {rok} року',
    },
    mesiceFew: '{n} місяці',
    mesiceMany: '{n} місяців',
    mesiceOne: '{n} місяць',
    nazev: 'Зобов’язання',
    prezTlacitko: 'Запустити кіно: Скільки коштують борги',
    splacenoVRoce: 'погашено у {rok} році',
    stav: {
      bezJistiny: 'залишок не вказано',
      bezSplatky: 'платіж не вказано',
      bezUroku: 'ставку не вказано',
      nikdy: 'платіж не покриває навіть відсотки',
    },
    tlacitko: 'Кіно про борги',
    uver: 'Кредит',
  },
  /* BLOK:kinoZavazky END */
  /* BLOK:rizikoVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  rizikoVysvetleni: {
    dite: {
      potreba: 'уся потреба',
      sablonaKrok: 'Зразок для дитячого договору',
      sablonaTitul: 'Шаблон: чому саме ця сума',
      sablonaToggle: 'Чому саме ця сума',
      sablonaVeta: 'Зразок із практики консультанта, а не розрахунок із цифр клієнта — перепишіть його олівцем за пропозицією страховика.',
      strop: 'Межа страхування',
      stropPod: 'дитячі договори страхують приблизно до {strop}, решта {zbytek} належить до резерву',
      trvaleTitul: 'Як складається страхова сума дитини',
      trvaleToggle: 'Як розраховується страхова сума дитини',
      vypadekPod: '{kdo}: {prijem} на {roky}, сьогоднішня вартість з дохідністю 4 % понад інфляцію',
      zavazneKrok1: 'Річний дохід батька, який доглядає',
      zavazneKrok1Pod: '{kdo}: {prijem} × 12',
      zavazneStropPod: 'дитячі договори покривають приблизно до {strop}, решта {zbytek} належить до резерву',
    },
    odskodne: {
      krok1: 'Втрата, яку ніщо не покриває',
      krok1PodOdZacatku: 'резерв не покриє навіть місяця: {prijem} − лікарняні {stat}',
      krok1PodRezerva: 'перші місяці тримає резерв, далі платить страховка від непрацездатності — виплата покривала б те саме',
      krok1PodVypnuto: 'виплату вимкнено',
      krok2: 'Межа: виплати щонайбільше до чистого доходу',
      krok2Pod: '{prijem} − лікарняні {stat} − непрацездатність {pn}',
      model: 'Виплата покриває дні, коли страховка від непрацездатності ще не платить, а резерву не вистачає. Усі виплати разом не можуть перевищити чистий дохід — такого не застрахує жодна страхова.',
      titul: 'Як складається щоденна виплата за травму',
      toggle: 'Як розраховується щоденна виплата за травму',
      vysledek: 'Ліміт щоденної виплати за травму',
      vysledekPod: 'менше з двох чисел, округлено до десятків',
    },
    pn: {
      krok1: 'Чистий дохід',
      krok1Vydaje: 'Частка необхідних витрат',
      krok1VydajeSplatky: 'Частка необхідних витрат і платежів за кредитами',
      krok2: 'Що дасть держава',
      krok3: 'Втрата доходу',
      krok3Pod: '{prijem} − {stat}',
      krok4: 'Щоденна виплата',
      krok4Pod: '{vypadek} ÷ {dni} днів',
      krok5: 'Відколи страховка платить',
      krok5Hodnota: 'з {mesic}-го місяця',
      krok5Info: 'Період очікування = скільки цілих місяців витримає резерв, щонайбільше 3. Довший період очікування = дешевша страховка.',
      krok5Pod: 'резерв {rezerva} = {nasobek}× необхідні витрати ({vydaje}) — до того тримає він',
      krok5PodNula: 'резерв {rezerva} не покриє навіть одного місяця необхідних витрат ({vydaje})',
      model: 'Орієнтовна модель, не гарантія: лікарняні за правилами 2026 року, фактичну суму визначає держава. Період очікування і виплату визначають умови страхування.',
      odDneOsvc: 'виплачується з {den}-го дня',
      odDneZam: 'виплачується з {den}-го дня, до того компенсацію зарплати платить роботодавець',
      omezeno: 'щонайбільше до чистого доходу',
      predpoklad: 'рахуємо з обовʼязковим лікарняним страхуванням',
      sazbaInfo: 'Рахуємо 60 % — ставку перших 30 днів. З 31-го дня держава платить 66 %, з 61-го — 72 %, тож модель обережна.',
      statBez: 'Без лікарняного страхування — лікарняні не виплачуються.',
      statOsvc: 'ФОП без лікарняного страхування — лікарняні не виплачуються.',
      statRozpad: 'брутто ≈ {hruba} → денна база {dvz} → після редукції {rdvz} → {sazba} % = {den} × 30 днів',
      statRozpadSK: 'брутто ≈ {hruba} → денна база {dvz} → {sazba} % = {den} × 30 днів',
      strop: 'межа: щонайбільше {strop} — з денної бази понад {hranice} не рахується нічого',
      stropSK: 'межа: денна база щонайбільше {hranice}',
      titul: 'Як складається щоденна виплата',
      toggle: 'Як розраховується непрацездатність',
      varianty: 'Однаково в усіх варіантах покриття — коротку втрату доходу не зменшуємо.',
      vysledek: 'Ліміт непрацездатності',
    },
    rucne: 'На картці вручну {rucni}, розраховано {spocitano}.',
    skryt: 'Сховати розрахунок',
    zaokrouhleni: 'Рядки заокруглені, їхня сума може трохи відрізнятися.',
    zavazne: {
      krok1: 'Річний чистий дохід',
      krok1Pod: '{prijem} × 12',
      krok2: 'На скільки років',
      krok2Hodnota: '× {roky}',
      krok2Pod: 'вибір 1 / 2 / 3 роки під рядком',
      titul: 'Як складається сума на критичні захворювання',
      toggle: 'Як розраховуються критичні захворювання',
      vysledek: 'Ліміт критичних захворювань',
    },
  },
  /* BLOK:rizikoVysvetleni END */
  /* BLOK:fondKategorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondKategorie: {
    'akcie-em': 'Акції – ринки, що розвиваються',
    'akcie-eu': 'Акції – Європа',
    'akcie-svet': 'Акції – світ',
    'akcie-tech': 'Акції – технології',
    'akcie-usa': 'Акції – США',
    dluhopisy: 'Облігації',
    fond: 'Фонд',
    fondA: 'Фонд A',
    fondB: 'Фонд B',
    krypto: 'Крипто (ETP)',
    nemovitosti: 'Фонди нерухомості',
    penizni: 'Грошового ринку / консервативні',
    smisene: 'Змішані',
    zlato: 'Золото / сировина',
  },
  /* BLOK:fondKategorie END */
  /* BLOK:kino503020 START — generuje scratchpad/slovnik.py, ručně needitovat */
  kino503020: {
    a1: {
      aria: 'Правило 50/30/20: з доходу {prijem} відкладається {stranou}, на життя {styl}, на необхідне разом із платежами {nezbytne}.',
      bezPrijmu: 'Без доходу правило не розподілимо.',
      kat: {
        bonusy: 'бонуси',
        pasivni: 'пасивний дохід',
      },
      kicker: 'Правило',
      osoba: 'Особа {n}',
      prijem: 'чистий дохід',
      prijemDomacnosti: 'чистий дохід домогосподарства',
      radek1: 'Половина на необхідне.',
      radek2: 'Трохи менше третини на життя.',
      radek3: 'П’ята частина — відкласти.',
      splatkyNadRozpocet: 'Платежі зараз забирають більше, ніж правило залишає на витрати.',
      tahak: '«Перевірене правило: з {prijem} половина на необхідне, трохи менше третини на життя і п’ята частина — на майбутнє. Мінімум — десята частина.»',
      titulek: '50 / 30 / 20',
      zamestnavatel: 'роботодавець {castka}',
    },
    a2: {
      aria: 'Сьогодні відкладається {pct} % ({stranou}). {radek} {dily}.',
      ariaPravidlo: 'Правило: відкласти 20 %, на життя 30 %, необхідне й платежі 50 %.',
      ariaSchodek: 'Сьогодні щомісяця бракує {chybi}: витрати й платежі перевищують дохід. Нічого не відкладається, внески на заощадження — у витратах.',
      bezVydaju: 'Додайте витрати, і ми порахуємо, скільки ви справді відкладаєте.',
      bezVydajuVizual: 'Без витрат відсоток не стверджуємо.',
      dohodaNad: 'Домовлена сума на {castka} вища за вільні гроші.',
      kicker: 'Ви сьогодні',
      nesoulad: 'Внески вищі за витрати, перевірте розбивку витрат.',
      poznVklady: 'разом із внесками на заощадження',
      poznZam: 'з них {castka} від роботодавця',
      pravidlo: 'Правило',
      prepinacAria: 'Що показати',
      radekIdeal: 'Це ідеал. ✓',
      radekMinimum: 'Мінімум у вас є. До ідеалу бракує {chybi}.',
      radekPod: 'До мінімуму бракує {chybi} на місяць.',
      radekRychle: 'Цілі виконуються дуже швидко. ✓',
      radekSchodek: 'Перш ніж відкладати, треба закрити цю різницю.',
      tahakBezVydaju: '«Перш ніж назвати відсоток, разом додамо витрати.»',
      tahakCastVolne: 'З них {zbyva} у вас є у вільних грошах, решту шукатимемо у витратах.',
      tahakIdeal: '«Ви відкладаєте {pct} % доходу. Це ідеал. Тепер ідеться про те, куди ці гроші спрямуємо.»',
      tahakMinimum: 'Ви відкладаєте {pct} % доходу. Мінімум є, до ідеалу бракує {chybi}.',
      tahakPod: 'Ви відкладаєте {pct} % доходу. До мінімуму бракує {chybi}.',
      tahakRychle: '«Ви відкладаєте {pct} % доходу, тож цілі виконуються дуже швидко. Подбаймо, щоб вистачало й на життя.»',
      tahakSchodek: '«Сьогодні щомісяця бракує {chybi}. Перш ніж відкладати, маємо закрити цю різницю.»',
      tahakVolne: 'Вони у вас є у вільних грошах, урізати не треба.',
      tahakVydaje: 'Вільних грошей на це зараз немає, шукатимемо їх у витратах.',
      titulek: 'Де ви сьогодні',
      velkeBezVydaju: 'витрати не введено',
      velkePopis: 'доходу відкладається · {castka}',
      velkeSchodek: 'щомісяця бракує',
      vyDnes: 'Ви сьогодні',
      zbyvaPred: 'Вільно залишається',
    },
    a3: {
      aria: 'При {pct} % відкладається {stranou}, вільно залишається {zbyva}. Необхідне й платежі не змінюються.',
      ariaStyl: 'При {pct} % відкладається {stranou}, з них {styl} зі стилю життя. Необхідне й платежі не змінюються.',
      kicker: 'А якщо',
      pct: {
        necelych: 'майже {pct} %',
        pres: 'понад {pct} %',
        presne: '{pct} %',
      },
      pokryto: 'Це покривають внески, які вже йдуть ({vklady}).',
      radekSchodek: 'При дефіциті спершу витрати, потім відсотки.',
      staci: 'Вистачить вільних грошей.',
      tahak: '«Спробуйте самі. З внесків і вільних грошей можна найбільше {max} на місяць, це {pct}. Понад це ми б уже брали з вашого життя.»',
      tahakSchodek: '«Відкладати з боргу не має сенсу. Спершу знайдемо ці {chybi}, потім повернемося до відсотків.»',
      titulek: 'Де на це взяти',
      velkePopis: 'відкладати щомісяця',
      velkeSchodek: 'немає з чого відкладати',
      zbyva: 'Залишається {castka}.',
      zeStylu: 'Зі стилю життя урізати {castka} на місяць.',
    },
    a4: {
      ariaBezCile: 'Ренти в цілях поки немає.',
      ariaChybi: 'До ренти, яка прогодує родину, бракує {chybi} на місяць.',
      ariaPotreba: 'Родині потрібно {potreba} на місяць.',
      ariaSedi: 'Рента в цілях {zadano} прогодує родину.',
      ariaSplatky: 'З них {nazev} {splatky} ({proc}).',
      bezSporeni: 'Без сьогоднішніх заощаджень {castka}, на ренті ви вже не відкладаєте.',
      bezUveru: 'Без кредитів, погашених до ренти.',
      bezUveruRok: 'Без кредитів, погашених до {rok} року.',
      chybiMesicne: 'бракує {chybi} на місяць',
      kapital: 'Для ренти {potreba} у сьогоднішніх цінах потрібен капітал приблизно',
      kicker: 'Рантьє',
      potrebuje: 'Родині потрібно',
      pravni: 'Модель за ставкою зняття приблизно {sazba} на рік ({profil} профіль). Це не дохідність і не гарантія, реальність може відрізнятися.',
      radekPotreba: 'Родині потрібно {potreba} на місяць.',
      radekSoucet: 'Витрати {vydaje} + {nazev} {splatky} = {potreba} на місяць.',
      splatky: 'платежі',
      splatkyBezi: 'тривають і на ренті',
      splatkyNeznamyKonec: 'кінець не можна порахувати, додайте відсоток',
      tahak: '«Рантьє — не той, хто багато заробляє. Це той, за кого рахунки оплачує майно.»',
      tahakUrok: '(Додайте відсоток або залишок кредиту, застосунок порахує, чи закінчиться він до ренти.)',
      titulek: 'Скільки має покрити рента?',
      vCilech: 'Рента в цілях',
      vCilechJe: 'У цілях є {zadano}.',
      vCilechNeni: 'У цілях ренти поки немає.',
      velkeBezCile: 'на місяць має бути рента',
      velkeChybi: 'на місяць бракує до ренти, яка прогодує родину',
      velkeSedi: 'рента в цілях прогодує родину ✓',
      zTohoSplatky: 'з них {nazev}',
    },
    ctverecek: '1 квадратик = 1 % доходу ({castka} на місяць)',
    dil: {
      nad: 'З них понад дохід',
      nezbytne: 'Необхідне',
      nezbytneVse: 'Необхідне з платежами',
      splatky: 'Платежі за кредитами',
      stranou: 'Відкладено',
      styl: 'Стиль життя',
      volne: 'Залишається вільно',
      vydaje: 'Витрати (без розбивки)',
      zVkladu: 'З внесків і вільних грошей',
      zestylu: 'Зі стилю життя',
    },
    doplnPrijmy: 'Додайте доходи',
    nazev: 'Доходи · 50/30/20',
    prah: {
      ideal: '{pct} % ідеал',
      minimum: '{pct} % мінімум',
      rychle: '{pct} % швидко',
    },
    prahPrijem: 'дохід',
    profil: {
      dynamicky: 'динамічний',
      konzervativni: 'консервативний',
      vyvazeny: 'збалансований',
    },
    uvozovky: '«{text}»',
  },
  /* BLOK:kino503020 END */
  /* BLOK:portfolioKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  portfolioKarta: {
    investice: 'Інвестиції',
    odhadBj: '* оцінка з підписаних BJ',
    penze: 'Пенсія',
    pojisteni: 'Страхування',
    proviceYtd: 'Комісія з початку року',
    rezerva: 'Резерв',
    rocniVynos: 'Річна дохідність',
    titul: 'Портфель клієнта',
    zadnyProdukt: 'Жодного інвестиційного продукту',
  },
  /* BLOK:portfolioKarta END */
  /* BLOK:kinoZdroje START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZdroje: {
    a1: {
      ariaFin: 'Фінансове майно {castka}.',
      ariaKapsa: '{nazev} {castka}, {kdy}.',
      ariaNefin: '{nazev} {castka}: до цілей не враховується.',
      ariaPrazdna: '{nazev}: нічого не внесено.',
      doplnte: 'Додайте майно',
      kicker: 'Ваші гроші',
      nefinPopis: 'до цілей не враховується',
      nemovitost: 'Нерухомість',
      nevime: 'Поки не знаємо, де лежать гроші.',
      podil: '{pct} % лежить {misto}.',
      polovina: 'Половина лежить {misto}.',
      radek2: 'Не все доступне однаково швидко.',
      tahak: '«Перш ніж заощаджувати нові гроші, погляньмо, що вже маєте. Часто це більше, ніж люди думають.»',
      titulek: 'Гроші, які вже маєте',
      velkePopis: 'фінансове майно',
      vse: 'Усе лежить {misto}.',
    },
    a2: {
      ariaZisk: 'За 10 років {castka} на рахунку купить стільки, скільки сьогодні {za}; відсоток вищий за інфляцію {inflace}.',
      ariaZtrata: 'За 10 років {castka} на рахунку купить лише стільки, скільки сьогодні {za}, при інфляції {inflace} на рік.',
      bezUroku: 'Рахунок без відсотків.',
      dnes: 'сьогодні {castka}',
      kicker: 'Інфляція',
      pilulkyAria: 'Яка інфляція',
      radekZisk: 'За 10 років {castka} купить те, що сьогодні {za}.',
      radekZtrata: 'За 10 років {castka} купить лише те, що сьогодні {za}.',
      tahak: '«Інфляція — тихий злодій. Число у виписці не зникне, але купите за нього дедалі менше.»',
      titulek: 'На рахунку гроші тихо втрачають',
      titulekStaci: 'Відсоток поки встигає за інфляцією',
      urok: 'Відсоток на рахунку {urok}.',
      urokNezadan: 'Відсоток рахунку не внесено, рахуємо 0 %.',
      velkePopis: 'купівельна спроможність за 10 років · інфляція {inflace}',
      volba: {
        cil: {
          cnb: 'ціль ЧНБ',
          ecb: 'ціль ЄЦБ',
        },
        historie: 'як {od}–{do}',
        plan: 'припущення плану',
      },
      zdrojCZK: 'План рахує з {plan} (припущення). ЧСУ: {rok} {posledni}, середнє 2016–2025 {prumer}. Ціль ЧНБ 2 %.',
      zdrojEUR: 'План рахує з {plan} (припущення). Ціль ЄЦБ 2 %.',
      zdrojJiny: 'План рахує з інфляцією {plan} (припущення).',
    },
    a3: {
      ariaNic: 'Нічого не працює.',
      ariaPodRezervou: '{rezerva}: на рахунку {ucet}, бракує {chybi}.',
      ariaSrovnani: 'Прогноз {roky}: якщо {x} залишиться на рахунку, купить як сьогодні {ucet}. Якщо працюватиме за профілем плану, модельно це {model}, у гіршому сценарії {horsi}, у кращому {lepsi}. Дохідність не гарантована.',
      chybi: 'бракує {castka}',
      dlouhyCil: 'довга ціль (рента)',
      jenNad: 'Лише понад резерв',
      jezdecAria: 'Скільки грошей з рахунку могло б працювати',
      kicker: 'А якщо',
      model: 'Модель: {roky} як ціль {cil}, профіль {profil}, у сьогоднішніх грошах, без комісій і податків. Дохідність не гарантована, дужка над смугою = гірший і кращий сценарій плану. Рахунок: відсоток {urok}, інфляція {inflace}.',
      naUctu: 'на рахунку {castka}',
      nadRezervu: 'понад резерв {castka}',
      nic: 'Нічого',
      pasmo: 'гірший сценарій {horsi} · кращий {lepsi}',
      pracuje: 'Працює',
      pracujeModel: 'Працює · модель',
      radekJenNad: 'Понад нього лише {castka}.',
      radekKlesla: 'Резерв зменшився б до {castka}.',
      radekNaUctu: 'На рахунку {castka}.',
      radekNad: 'Понад нього {castka}.',
      radekRezerva: 'Резерв становить {castka}.',
      radekRezervaNa: 'Резерв на {n} міс. становить {castka}.',
      radekRezervaZustava: 'Резерв {castka} залишається на рахунку.',
      rezerva: 'резерв · {castka}',
      rezervaNa: 'резерв на {n} міс. · {castka}',
      sniInflace: 'з’їсть інфляція',
      tahak: '«Резерв залишимо на рахунку, його не чіпаємо. Гроші понад нього можуть працювати.»',
      titulek: 'Резерв залишиться, решта може працювати',
      titulekPodRezervou: 'Спершу весь резерв',
      titulekRezerva: 'Частина резерву працювала б',
      urokNad: 'з відсотка понад інфляцію',
      valuetextRezerva: '{x}, з них {rezerva} з резерву',
      varovani: '{castka} пішло б із резерву. Тоді він не був би повним.',
      velkeChybiRezerva: 'бракує до резерву',
      velkeNic: 'нічого не працює',
      velkePasmo: 'гірший сценарій {horsi} · кращий {lepsi}',
      velkePopis: '{roky} більше · модель, дохідність не гарантована',
      velkeZRezervy: 'бракувало б у резерві',
      vlozenoVynos: 'вкладено {x} + модельна дохідність {vynos}',
      zUctu: 'з рахунку',
      zustaneNaUctu: 'Залишиться на рахунку',
    },
    a4: {
      ariaBez: 'Без грошей, які маєте: {popis}.',
      ariaS: 'З грошима, які маєте: {popis}.',
      bezNich: 'Без них',
      cil: 'Ціль',
      dnesPct: 'сьогодні {pct} %',
      hotovaDoMes: 'готово до {n} міс.',
      hotovaHned: 'готово одразу',
      hotovaZaMes: 'готово за {n} міс.',
      kTerminu: 'до терміну',
      kTerminuPct: 'до терміну {pct} %',
      kicker: 'Ваші цілі',
      mesicne: '{castka}/міс.',
      nepriradeno: {
        investice: 'Інвестиції',
        stavebko: 'Решта будівельних заощаджень',
        ucty: 'Решта на рахунках',
      },
      nepriradenoPopis: 'план їх поки не спрямує на жодну ціль',
      plusOdkladani: '+ відкладання',
      plusVynos: '+ дохідність (модель)',
      poMesicne: 'по {castka} на місяць',
      pozn: 'Той самий розрахунок, що й Пропозиція рішення, у сьогоднішніх грошах. Дохідність — модель, не обіцянка.',
      radekBez: '{cil} мала б до терміну {bez} % замість {s} %.',
      radekS: '{cil} до терміну {s} % замість {bez} %.',
      radekStejne: 'Без них план вийшов би так само.',
      renta: 'Рента',
      rezerva: 'Резерв',
      sPenezi: 'З грошима, які маєте',
      segmentAria: 'Порівняння',
      tahak: '«Ще одне джерело для досягнення ваших цілей — гроші, які ви вже маєте.»',
      titulek: 'Ще одне джерело для ваших цілей',
      vVeku: 'у {vek} років',
      vVekuPoStartu: 'у {vek} років · після початку ренти',
      velkeNic: 'Поки нічого',
      velkeNicPopis: 'до терміну цілей з майна нічого не надійде',
      velkePopis: 'план спрямує на цілі до їхнього терміну',
      vetaRezervaBez: 'Без них резерв заощаджувався б {n} міс.',
      vetaRezervaDoMes: 'Резерв готовий до {n} міс.',
      vetaRezervaHned: 'Резерв готовий одразу.',
      vetaRezervaPct: 'Резерв сьогодні на {pct} %.',
      vetaRezervaZa: 'Резерв буде готовий за {n} міс.',
      vlastniZdroje: 'власні кошти {castka}',
      zaMes: 'за {n} міс.',
      zatimNic: 'поки нічого',
      zdrojPenzijko: 'пенсійні заощадження',
    },
    kapsa: {
      investice: 'Інвестиції',
      nezapsano: 'нічого не внесено',
      penzijko: 'Пенсійні заощадження',
      stavebko: 'Будівельні заощадження',
      ucty: {
        bezny: 'Поточний рахунок',
        hotovost: 'Готівка',
        sporici: 'Ощадний рахунок',
        ucty: 'Рахунки',
      },
    },
    kdy: {
      castHned: 'частина одразу',
      hned: 'одразу',
      investice: 'за кілька днів',
      penzijko: 'у {vek} років',
      stavebko: 'до {n} міс.',
    },
    misto: {
      investice: 'в інвестиціях',
      penzijko: 'у пенсійних заощадженнях',
      stavebko: 'у будівельних заощадженнях',
      ucty: {
        bezny: 'на поточному рахунку',
        hotovost: 'у готівці',
        sporici: 'на ощадному рахунку',
        ucty: 'на рахунках',
      },
    },
    nazev: 'Ресурси',
    osa: {
      dnes: 'сьогодні',
      zaRokyFew: 'за {n} роки',
      zaRokyMany: 'за {n} років',
      zaRokyOne: 'за {n} рік',
    },
    prezTlacitko: 'Запустити кіно: Гроші, які вже маєте',
    rokyFew: '{n} роки',
    rokyMany: '{n} років',
    rokyOne: '{n} рік',
    tlacitko: 'Кіно Ресурси',
    tlacitkoTitle: 'Відтворити кіно: Гроші, які вже маєте',
    zaRokyFew: 'за {n} роки',
    zaRokyMany: 'за {n} років',
    zaRokyOne: 'за {n} рік',
  },
  /* BLOK:kinoZdroje END */
  /* BLOK:predAPo START — generuje scratchpad/slovnik.py, ručně needitovat */
  predAPo: {
    cena: 'Ціна',
    hlavicka: {
      dnes: 'Сьогодні',
      kryti: 'Покриття ×',
      nove: 'Нове',
    },
    infoDalsiRizika: 'Ліміти всіх ризиків (інвалідність, смерть, непрацездатність, тяжкі захворювання, тривалі наслідки, щоденна виплата) доповните в аналізі за особами: Страхові договори → Ризики в договорах.',
    infoNema: '«немає» = жоден записаний договір цей ризик не покриває. «не введено» = договір є, але ліміт у ньому не вказано.',
    infoRozsah: 'Для домогосподарства без вибраної особи кратність покриття не показуємо — порівнювався б договір однієї людини з новим покриттям обох.',
    mene: 'менше',
    nema: 'немає',
    spolecna: 'вкл. спільний договір',
    spolecnaU: 'спільний договір · платіж у {kdo}',
    stitekNove: 'нове',
    ztrata: 'втрата',
  },
  /* BLOK:predAPo END */
  /* BLOK:podkladyKlienta START — generuje scratchpad/slovnik.py, ručně needitovat */
  podkladyKlienta: {
    dny: {
      '0': 'у неділю',
      '1': 'у понеділок',
      '2': 'у вівторок',
      '3': 'у середу',
      '4': 'у четвер',
      '5': 'у п’ятницю',
      '6': 'у суботу',
    },
    dok: {
      leasing: 'договір лізингу',
      naSchuzce: 'заповнимо разом на зустрічі',
      pojistna: 'страховий договір',
      portfolio: 'виписка з портфеля',
      smlouvaVypis: 'договір і остання виписка',
      triMesice: 'за останні 3 місяці',
      uverova: 'кредитний договір і виписка залишку',
      vypis: 'остання виписка',
      vypisUctu: 'виписка з рахунку',
      zustatek: 'поточний залишок',
    },
    nazev: {
      akcie: 'Акції',
      cennosti: 'Страхування цінностей',
      cizimena: 'Валютний рахунок',
      danove: 'Податкова декларація за {rok} рік',
      dip: 'Довгостроковий інвестиційний продукт (DIP)',
      dluhopisy: 'Облігації',
      dps: 'Пенсійні заощадження (DPS)',
      fondy: 'Фонди / ETF',
      investice: 'Інвестиції',
      krypto: 'Криптовалюти',
      kzp: 'Накопичувальне страхування життя',
      pojistka: 'Страховий договір',
      pripojisteni: 'Додаткове пенсійне страхування',
      sporici: 'Ощадний рахунок',
      stavebko: 'Будівельні заощадження',
      terminovany: 'Строковий депозит',
      uver: 'Кредит',
      vypisy: 'Виписки з поточного рахунку',
    },
    platno: {
      emailem: 'Список я надішлю вам і поштою',
      idealne: 'Бажано до зустрічі',
      kicker: 'Підсумок',
      papiry: 'Папери можна принести й на зустріч',
      pod: 'Достатньо скану або фото з телефону.',
      posleteNa: 'Надішліть на',
      prazdne: 'Поки нічого — доповнимо на наступній зустрічі.',
      titul: 'Що мені від вас знадобиться',
      zpravou: 'Список я надішлю вам і повідомленням',
    },
    pocetSmluvFew: '{n} договори',
    pocetSmluvMany: '{n} договорів',
    pocetSmluvOne: '{n} договір',
    ui: {
      bezEmailu: '{kdo} — немає пошти.',
      bezKontaktu: 'без контакту',
      bezTelefonu: '{kdo} — немає телефону.',
      chybaRada: 'Спробуйте ще раз або відкрийте повідомлення у своїй поштовій програмі.',
      chybaTitul: 'Не вдалося надіслати — нічого не відправлено',
      chybiMujEmail: 'У повідомленні немає вашої пошти — клієнт не знатиме, куди надіслати скани.',
      cisloVarovani: 'схоже на номер договору — краще не пишіть його в повідомлення',
      detailEmail: 'Надіслано {kdy} поштою · {komu}',
      detailMailto: 'Відкрито в поштовій програмі {kdy} · {komu} · надішліть звідти',
      detailWa: 'Відкрито у WhatsApp {kdy} · {komu} · надішліть звідти',
      dokumentFew: 'документи',
      dokumentMany: 'документів',
      dokumentOne: 'документ',
      doplnitEmail: 'Додати пошту у Вступі',
      doplnitNastaveni: 'Додати публічну пошту в Налаштуваннях',
      doplnitTelefon: 'Додати телефон у Вступі',
      emailUctu: 'У повідомленні — пошта підключеного облікового запису',
      instituceChybi: 'установу не вказано',
      jazyk: 'Мова повідомлення',
      jen: 'лише {kanal}',
      kanalEmail: 'пошта',
      kanalEmailSpatny: 'пошта в неправильному форматі',
      kanalTelefon: 'телефон',
      kdyCas: '{den} о {cas}',
      klient: 'Клієнт',
      komu: 'Кому надіслати',
      kopirovaniChyba: 'Не вдалося скопіювати — виділіть текст і скопіюйте вручну.',
      kopirovat: 'Копіювати',
      neodeslano: 'Ще не надіслано',
      nicVybrano: 'Нічого не вибрано — повідомлення не надішлеться',
      odebrat: 'Вилучити: {nazev}',
      odesilam: 'Надсилаю…',
      odeslanoEmail: 'Надіслано {den} поштою',
      odeslanoToast: 'Лист надіслано клієнтові.',
      odeslatChyba: 'Надсилання не вдалося.',
      opravitEmail: 'Виправити пошту у Вступі',
      otevritPostu: 'Відкрити в поштовій програмі',
      plusDotaznik: '+ анкета на зустрічі',
      pocetPred: 'У повідомленні буде',
      pod: 'Складено з ресурсів, зобов’язань і майна в аналізі',
      podleMajetku: 'за майном: {nazev}',
      polozkaMajetku: 'об’єкт майна',
      poslatEmail: 'Надіслати поштою',
      poslatWa: 'Надіслати через WhatsApp',
      pozdeji: 'надасть пізніше',
      poznGmail: 'Буде надіслано з вашого Gmail {email}',
      poznGmailBez: 'Буде надіслано з вашого Gmail',
      poznMailto: 'Відкриє вашу поштову програму — надішліть звідти',
      poznSmtp: 'Буде надіслано з вашої робочої пошти {email}',
      poznSmtpBez: 'Буде надіслано з вашої робочої пошти',
      poznWa: 'Відкриє WhatsApp з готовим текстом — надішліть звідти',
      poznZjistuji: 'Перевіряю, як буде надіслано лист…',
      predanoWa: 'Передано у WhatsApp {den}',
      predmet: 'Тема',
      pridat: 'Додати',
      pridatLabel: 'Власна позиція',
      pridatPh: 'напр. договір купівлі квартири',
      pripravenoEmail: 'Підготовлено в пошті {den}',
      rozbalit: 'Показати все повідомлення',
      sbalit: 'Згорнути повідомлення',
      skupina: {
        dalsi: 'Інше',
        pojisteni: 'Страхування',
        sporeni: 'Заощадження та інвестиції',
        uvery: 'Кредити',
      },
      spatnyEmail: '{kdo} — пошта в неправильному форматі ({email}).',
      terminAnalyza: 'Термін, записаний в аналізі: {kdy}',
      terminDiar: 'Термін із щоденника: {kdy}',
      terminProbehl: 'Термін в аналізі ({kdy}) уже минув — у повідомленні його немає',
      terminZadny: 'У щоденнику немає наступної зустрічі — терміну в повідомленні немає',
      titul: 'Що має надати клієнт',
      vlastni: 'власна позиція',
      waBezEmailu: 'Без вашої пошти клієнт надіслав би скани у WhatsApp.',
      zkopirovano: 'Текст повідомлення скопійовано.',
      zkusitZnovu: 'Спробувати ще раз',
      zmena: 'Після надсилання повідомлення змінилося — надішліть його знову.',
      znovuEmail: 'Надіслати знову поштою',
      znovuWa: 'Надіслати знову через WhatsApp',
      zpravaPod: 'Клієнт надішле скани на вашу пошту',
      zpravaTitul: 'Повідомлення для клієнта',
    },
    viceFew: '{n} договори: {dok} до кожного',
    viceMany: '{n} договорів: {dok} до кожного',
    viceOne: '{n} договір: {dok}',
    zprava: {
      dotaznik: 'Інвестиційну анкету заповнимо разом на зустрічі.',
      fotka: 'Достатньо фото з телефону, головне, щоб його було добре видно.',
      kamEmail: 'Надішліть їх, будь ласка, на мою пошту {email}, коли матимете хвилинку.',
      kamEmailTermin: 'Надішліть їх, будь ласка, на мою пошту {email}, бажано до нашої наступної зустрічі {den}',
      kamOdpoved: 'Надішліть їх, будь ласка, у відповідь на цей лист, коли матимете хвилинку.',
      kamOdpovedTermin: 'Надішліть їх, будь ласка, у відповідь на цей лист, бажано до нашої наступної зустрічі {den}',
      nevadi: 'Якщо щось не знайдете, нічого страшного — розберемося разом. Папери можна принести й на зустріч.',
      pozdrav: 'Добрий день,',
      pozdravJmeno: 'Добрий день, {osloveni},',
      predmet: 'Документи для підготовки пропозиції',
      predmetTermin: 'Документи до нашої наступної зустрічі',
      uvod: 'дякую за нашу зустріч. Щоб підготувати пропозицію, надішліть мені, будь ласка, скани або фото цих документів:',
    },
  },
  /* BLOK:podkladyKlienta END */
  /* BLOK:vykonTymu START — generuje scratchpad/slovnik.py, ručně needitovat */
  vykonTymu: {
    aktivita: {
      aria: '{metrika} за останні {tydnu} тижнів: позначено виконаними усього {soucet}, тижнева ціль {cil}, нижче цілі {pod} з {ukoncenych} завершених тижнів.',
      ariaBezCile: '{metrika} за останні {tydnu} тижнів: позначено виконаними усього {soucet}, тижневу ціль не встановлено.',
      ariaCast: '{metrika} за останні {tydnu} тижнів: позначено виконаними усього {soucet}. Тижневу ціль має лише {s} з {celkem} людей, тому виконання команди не оцінюємо.',
      ariaNovyCil: '{metrika} за останні {tydnu} тижнів: позначено виконаними усього {soucet}, тижнева ціль {cil}, поки жодного завершеного тижня з ціллю.',
      cil: 'ціль {n}',
      cilCast: 'ціль має лише {s} з {celkem} людей, тож лінію цілі команди не малюємо',
      cilDrive: 'раніше ціль {n}',
      hovory: 'Дзвінки',
      nadpis: 'Активність за тижнями',
      neodskrtnuto: 'Не позначено в щоденнику, у стовпці й ціль не враховано: {n}',
      prazdno: 'За останні {tydnu} тижнів у клієнтів не позначено виконаним жодного дзвінка чи зустрічі.',
      probiha: 'триває',
      radekZalohy: '{datum}: {n}',
      schuzky: 'Зустрічі',
      typNeznamy: 'Без типу, не враховано: {n}',
    },
    bezJmena: 'Без імені',
    cil: {
      chyba: 'Не вдалося зберегти ціль.',
      hodnoty: 'Дзвінків на тиждень: {hovory} · зустрічей на тиждень: {schuzky}',
      hovory: 'Дзвінків на тиждень',
      jenPrimy: 'Ціль встановлює безпосередній менеджер.',
      nadpis: 'Тижнева ціль активності',
      nastavil: 'Встановив {jmeno}, {datum}',
      neplatny: 'Введи ціле число від 0 до 200.',
      prazdne: 'Порожнє поле означає без цілі.',
      schuzky: 'Зустрічей на тиждень',
      ukladam: 'Зберігаємо…',
      ulozeno: 'Тижневу ціль збережено.',
      ulozit: 'Зберегти ціль',
      zpet: 'Назад',
      zrusit: 'Скасувати ціль',
      zrusitPotvrdit: 'Справді скасувати тижневу ціль?',
    },
    detail: {
      chyba: 'Не вдалося завантажити результати консультанта.',
      hlubsi: 'Клієнтів та угоди відкриває його безпосередній менеджер.',
      koucink: 'Коучинг',
      nacitam: 'Завантажуємо результати консультанта…',
      nadpis: 'Результати: {jmeno}',
      pipelineObchody: 'Клієнти та угоди',
      zavrit: 'Закрити',
    },
    drobecky: {
      aria: 'Рівні команди',
      ja: 'Я',
      zpet: 'Назад до моєї команди',
    },
    faze: {
      a1: 'Знайомство',
      a2: 'Аналіз',
      p1: 'Фінансовий план',
      p2: 'Презентація',
      volani: 'Дзвінки',
    },
    informace: {
      odpojeni: 'Відключити тебе може лише менеджер — він прибере тебе в «Моїй команді». Сам відключитися не можна.',
      potvrzeno: 'Твій менеджер і менеджери над ним бачать твоїх клієнтів, pipeline, цілі та результати (дзвінки й зустрічі з клієнтами за тижнями). Особисті записи в щоденнику ніколи, весь щоденник лише з твоєї згоди. Менеджер може встановити тобі тижневу ціль дзвінків і зустрічей.',
      pozvat: 'Введи його email. Створиться запрошення, яке він має сам прийняти в Налаштуваннях — лише тоді побачиш його клієнтів, угоди, цілі та результати (дзвінки й зустрічі з клієнтами за тижнями). Весь щоденник лише з його згоди, особисті записи ніколи. Email не надсилаємо, посилання надішли йому сам.',
      prijeti: 'Після прийняття твій менеджер і менеджери над ним бачитимуть твоїх клієнтів, pipeline, цілі та результати: скільки дзвінків і зустрічей з клієнтами ти маєш щотижня і коли востаннє контактував із клієнтом. Особисті записи в щоденнику ніколи, весь щоденник лише з твоєї згоди.',
      rozumim: 'Зрозуміло',
      vzdy: 'Незалежно від цього вибору менеджер бачить результати: скільки дзвінків і зустрічей з клієнтами ти маєш щотижня і коли востаннє контактував із клієнтом. Без назв, часу й місць. Особисті записи ніколи.',
      zvonecek: 'Твій менеджер і менеджери над ним бачать твоїх клієнтів, pipeline, цілі та результати: скільки дзвінків і зустрічей з клієнтами ти маєш щотижня і коли востаннє контактував із клієнтом. Особисті записи в щоденнику ніколи, весь щоденник лише з твоєї згоди.',
      zvonecekNadpis: 'Що бачить твій менеджер',
    },
    kontrola: {
      dniBezFew: '{n} дні без записаної дії',
      dniBezMany: '{n} днів без записаної дії',
      dniBezOne: '{n} день без записаної дії',
      krokAno: 'Заплановано',
      krokNe: 'Немає',
      krokPoTerminu: 'Прострочено',
      mene: 'Показати менше',
      nadpis: 'На перевірку',
      nicZaOkno: 'Нічого за останні {dni} днів',
      nicZapsano: 'Нічого не записано',
      oriznuto: 'Показано {zobrazeno} з {celkem}.',
      popis: 'Активні клієнти, у яких {prah} і більше днів не записано жодної дії.',
      prazdno: 'Ніхто не чекає довше ніж {prah} днів.',
      sloupecFaze: 'Етап',
      sloupecKlient: 'Клієнт',
      sloupecKrok: 'Наступний крок',
      sloupecPoradce: 'Консультант',
      sloupecPosledni: 'Остання записана дія',
      sloupecVeFazi: 'На етапі',
      veFaziFew: '{n} дні',
      veFaziMany: '{n} днів',
      veFaziNevime: 'відстежуємо з {datum}',
      veFaziOne: '{n} день',
      vice: 'Показати всі {n}',
    },
    kpi: {
      bezKroku: 'Без наступного кроку',
      bezKrokuPod: 'активні клієнти без запланованої дії',
      pipelineBj: 'BJ у pipeline',
      pipelineBjPod: 'Від знайомства до презентації',
      schuzkyTyden: 'Зустрічі цього тижня',
      schuzkyTydenPod: 'з клієнтами, позначені в щоденнику',
      vAktivite: 'Активні клієнти',
      vAktivitePod: 'Від дзвінків до презентації',
    },
    nadpis: 'Результати команди',
    pipeline: {
      aria: 'Pipeline за консультантами: найбільше активних клієнтів має {jmeno} ({pocet}).',
      detail: 'Деталі',
      klientuFew: '{n} клієнти',
      klientuMany: '{n} клієнтів',
      klientuOne: '{n} клієнт',
      nadpis: 'Pipeline за консультантами',
      prazdny: 'Немає активних клієнтів',
      radekAria: '{jmeno}: активних клієнтів {pocet}, pipeline {bj} BJ. {rozpad}',
      segment: '{faze} {pocet}',
      tym: 'Команда · {pocet}',
    },
    poznamka: {
      kratce: 'Лише записані робочі активності.',
      cyklus: 'У команді є замкнене коло зв’язків, кожного показуємо лише один раз.',
      faze: 'З {datum} відстежуємо переходи між етапами.',
      hloubka: 'Команда має понад 5 рівнів, глибші рівні не показуємо.',
      oriznuto: 'Даних більше, ніж можемо порахувати за раз, числа є нижньою оцінкою.',
      patra: 'Числа вгорі охоплюють усю команду разом із рівнями під нею, рядки консультантів показують лише їхніх власних клієнтів.',
      zdroj: 'Рахуємо лише робочі дії, записані в клієнта в щоденнику та на часовій шкалі клієнта. Дзвінки, зустрічі й виконання цілі лише позначені як виконані. Особисті записи ніколи. Чого консультант не записав, ми не бачимо, і це ще не означає, що він не працює.',
    },
    stav: {
      bezCile: 'Ціль не встановлено',
      chyba: 'Значно нижче цілі',
      minulyChyba: 'Минулого тижня: значно нижче цілі',
      minulyOk: 'Минулого тижня: ціль виконано',
      minulyPozor: 'Минулого тижня: нижче цілі',
      ok: 'Виконує тижневу ціль',
      pozor: 'Нижче цілі',
    },
    stavy: {
      bezPristupu: 'До цієї команди ти вже не маєш доступу.',
      chyba: 'Не вдалося завантажити результати команди.',
      nacitam: 'Завантажуємо результати команди…',
      nedostupne: 'Результати команди з’являться після оновлення сервера.',
      prazdnyTym: 'Безпосередньо під вами поки нікого немає — рейтинг нижче показує всю мережу.',
      vrcholy: 'Команди в системі',
      vrcholyPopis: 'Обери команду, яку хочеш переглянути.',
      znovu: 'Спробувати знову',
    },
    zebricek: {
      jenObsazenost: 'Щоденник показує лише зайнятість — зустрічі з клієнтами з нього не розпізнати.',
    },
  },
  /* BLOK:vykonTymu END */
  /* BLOK:pruvodce START — generuje scratchpad/slovnik.py, ručně needitovat */
  pruvodce: {
    akce: {
      domluvitTermin: 'Домовитися про зустріч',
      jeToSpravne: 'Це правильно',
      kinoRizik: 'Запустити кіно ризиків',
      nemaMajetek: 'Без майна',
      nemaZavazky: 'Без кредитів і полісів',
      opraveno: 'Виправлено на {hodnota}',
      opravit: 'Виправити на {hodnota}',
      oznaceno: 'Позначено як правильне',
      prejit: 'Перейти',
      prejitNezbytne: 'Перейти до необхідних витрат',
      prejitObvykle: 'Перейти до звичайних витрат',
      prejitPrijmy: 'Перейти до доходів',
      prejitVydaje: 'Перейти до витрат',
      prohodit: 'Поміняти місцями',
      prohozeno: 'Поміняно',
      vratit: 'Повернути',
    },
    brana: {
      dalsi: 'і ще {n}',
      duvod: {
        dalsiSchuzka: 'Доповнимо на наступній зустрічі',
        jiny: 'Інша причина',
        nechce: 'На прохання клієнта без даних',
        podklady: 'Клієнт надасть документи',
      },
      min: {
        cil: 'Ціль із сумою та терміном',
        osoby: 'Особи та дати народження',
        prijmy: 'Доходи',
        vydaje: 'Витрати',
      },
      minimum: 'Обовʼязковий мінімум',
      minimumSplneno: 'Обовʼязковий мінімум виконано',
      nadpis: 'Готово до плану?',
      planOrientacni: 'План орієнтовний — бракує:',
      podezrele: 'Підозрілі числа',
      pokracovat: 'Продовжити до плану',
      poradiNezapsano: 'Згода з порядком цілей: не записано',
      poradiZapsano: 'Згода з порядком цілей: записано {datum}',
      pozdeji: 'Бракує, але можна продовжити',
      poznamka: 'Примітка (необовʼязково)',
      proc: 'Чому продовжуєте? (необовʼязково)',
      slozka: 'Для теки клієнта: {n}',
      zaznamy: 'Записи із зустрічі',
      zbyvaFew: 'Ще {n} пункти не заповнено — план розрахуємо, але цифри будуть орієнтовні. Доповніть, коли зможете.',
      zbyvaMany: 'Ще {n} пунктів не заповнено — план розрахуємо, але цифри будуть орієнтовні. Доповніть, коли зможете.',
      zbyvaOne: 'Ще {n} пункт не заповнено — план розрахуємо, але цифри будуть орієнтовні. Доповніть, коли зможете.',
      zbyvaSeznamFew: 'Ще {n} пункти: {seznam}',
      zbyvaSeznamMany: 'Ще {n} пунктів: {seznam}',
      zbyvaSeznamOne: 'Ще {n} пункт: {seznam}',
      zpet: 'Назад до аналізу',
    },
    chybi: {
      castka: 'сума',
      cil: '{nazev}: {co}',
      cilBezNazvu: 'Ціль без назви',
      diteKCili: 'Ціль для дітей, але жодної дитини',
      dodaPozdeji: '{smlouva}: клієнт надасть',
      doplnRizika: 'Додайте ризики: {smlouva}',
      jmenoK1: 'Імʼя та прізвище клієнта',
      komuPatri: 'Чиї ризики: {smlouva}',
      narozeniDite: 'Дата народження дитини {jmeno}',
      narozeniK1: 'Дата народження клієнта',
      narozeniPartner: 'Дата народження партнера — без неї захист партнера не розрахуємо',
      nezbytne: 'Необхідні витрати',
      prazdneDite: 'Порожній рядок дитини',
      prijemBezOsoby: 'Дохід 2-ї особи без особи',
      smlouva: 'Договір',
      termin: 'термін',
      titul: 'Бракує:',
    },
    jednotka: {
      letFew: '{n} роки',
      letMany: '{n} років',
      letOne: '{n} рік',
    },
    kontrola: {
      V1: {
        hlaska: 'Витрати {V} більші ніж 5× доходи {P}.',
        hlaskaBezOpravy: 'Витрати {V} більші ніж 5× доходи {P}. Обидва числа правильні?',
        kratce: 'Витрати набагато вищі за доходи',
        otazka: 'Скільки вам коштує звичайний місяць, без платежів за кредитами?',
      },
      V10: {
        hlaska: 'Дата народження {datum} у майбутньому.',
        kratce: 'Народження в майбутньому',
        otazka: 'Можете повторити дату народження?',
      },
      V11: {
        hlaska: 'Виходить вік {n}. Рік народження правильний?',
        kratce: 'Вік не сходиться',
        otazka: 'Можете повторити дату народження?',
      },
      V12: {
        hlaska: 'Дата народження дитини {datum} не відповідає батькам.',
        kratce: 'Дитина старша за батька',
        otazka: 'Яка дата народження дитини?',
      },
      V13: {
        hlaska: 'З доходів залишається {Z}, відкладаєте {X}. Витрати правильні?',
        kratce: 'Непояснений залишок',
        otazka: 'Куди йдуть гроші, що залишаються?',
      },
      V14: {
        hlaska: 'Витрати {V} більші ніж 2,5× доходи {P}. Обидва числа правильні?',
        kratce: 'Витрати вищі за доходи',
        otazka: 'Скільки вам коштує звичайний місяць, без платежів за кредитами?',
      },
      V15: {
        hlaska: 'Витрати {V} становлять лише {x} % доходів {P}. Витрати правильні?',
        kratce: 'Витрати набагато нижчі за доходи',
        otazka: 'Скільки вам коштує звичайний місяць, без платежів за кредитами?',
      },
      V2: {
        hlaska: 'Необхідні витрати {N} вищі за звичайні {V}.',
        hlaskaBezOpravy: 'Необхідні витрати {N} вищі за звичайні {V}. Обидва числа правильні?',
        hlaskaObvykle: 'Звичайні витрати {V} нижчі за необхідні {N}.',
        kratce: 'Необхідні витрати вищі за звичайні',
        otazka: 'Скільки вам щомісяця конче потрібно, якби довелося заощаджувати?',
      },
      V3: {
        hlaska: 'Дохід {X} більший ніж 10× витрати {V}.',
        hlaskaBezOpravy: 'Дохід {X} більший ніж 10× витрати {V}. Чи це не за рік? Щомісяця {mesicne}.',
        hlaskaNejiste: 'Дохід {X} більший ніж 10× витрати {V}. Обидва числа правильні?',
        kratce: 'Дохід, імовірно, за рік',
        otazka: 'Це чистий дохід за місяць чи за рік?',
      },
      V4: {
        hlaska: 'Погоджений надлишок {X} вищий за доходи {P}.',
        hlaskaBezOpravy: 'Погоджений надлишок {X} вищий за доходи {P}. Надлишок правильний?',
        kratce: 'Надлишок вищий за доходи',
        otazka: 'Скільки ви можете щомісяця відкладати без обмежень для себе?',
      },
      V5: {
        hlaska: 'Термін {roky} схожий на рік календаря.',
        hlaskaBezOpravy: 'Термін {roky} схожий на рік календаря. За скільки років це має бути?',
        kratce: 'Термін записаний як рік',
        otazka: 'За скільки років ви хочете цього досягти?',
      },
      V6: {
        hlaska: 'Рента {X} на місяць більша ніж 20× дохід. Чи це не загальна сума?',
        kratce: 'Рента схожа на капітал',
        otazka: 'Скільки ви хотіли б отримувати щомісяця?',
      },
      V7: {
        hlaska: 'Ставка {u} % схожа на десятковий дріб.',
        hlaskaBezOpravy: 'Ставка {u} % незвично низька. Правильно?',
        kratce: 'Ставка як десятковий дріб',
        otazka: 'Яка відсоткова ставка у вашому договорі?',
      },
      V8: {
        hlaska: 'Ставка {u} % за житловим кредитом незвично висока.',
        hlaskaBezOpravy: 'Ставка {u} % за житловим кредитом незвично висока. Правильно?',
        kratce: 'Висока ставка за житловим кредитом',
        otazka: 'Яка відсоткова ставка у вашому договорі?',
      },
      V9: {
        hlaska: 'Платіж {s} більший ніж 20× залишок {j}.',
        hlaskaBezOpravy: 'Платіж {s} більший ніж 20× залишок {j}. Чи не переплутані?',
        kratce: 'Платіж і залишок переплутані',
        otazka: 'Скільки вам залишилося виплатити і скільки ви платите щомісяця?',
      },
    },
    kratce: {
      bezNazvu: 'Без назви',
      cislo: 'номер договору',
      instituce: 'установа',
      investiceUdaje: '{nazev}: {co}',
      menaDatum: '{nazev}: дата курсу {mena}',
      menaKurz: '{nazev}: курс {mena}',
      menaStary: '{nazev}: старий курс {mena}',
      nemovitostPojisteni: '{nazev}: страхування нерухомості',
      obe: 'установа і номер договору',
      obecne: 'Доповнити дані',
      vozidloPojistka: '{nazev}: обовʼязкове страхування авто',
      vozidloVyroci: '{nazev}: річниця страхування',
      zavazekCisla: '{nazev}: залишок і платіж',
    },
    krok: {
      cile: 'Цілі',
      hodnoty: 'Очікування і цінності',
      majetek: 'Майно',
      predstaveni: 'Час',
      prijmy: 'Доходи та витрати',
      rizika: 'Ризики',
      rodina: 'Родина',
      zavazky: 'Зобовʼязання',
      zaver: 'Підсумок',
    },
    nav: 'Кроки аналізу',
    otazka: {
      prepinac: 'Питання для клієнта',
      skryt: 'Сховати питання',
      titul: 'Питання для клієнта',
      zobrazit: 'Показати питання',
    },
    otevrit: 'Показати кроки аналізу',
    souhrn: '{hotovo} з {celkem} готово',
    stav: {
      chybiFew: 'бракує {n}',
      chybiMany: 'бракує {n}',
      chybiOne: 'бракує {n}',
      hotovo: 'готово',
      keKontroleFew: '{n} до перевірки',
      keKontroleMany: '{n} до перевірки',
      keKontroleOne: '{n} до перевірки',
      nezacato: 'не розпочато',
    },
    zde: 'ви тут',
  },
  /* BLOK:pruvodce END */
  /* ВИХІДНИЙ ПЛАН ДЛЯ КЛІЄНТА (25. 10. 2026, N1) — див. cs.js */
  planVystup: {
    financniPlan: 'Фінансовий план',
    obsah: 'Зміст',
    upozorneniNadpis: 'Важливі застереження',
    upozorneni1: 'Цей фінансовий план аналізує ваші заощадження та інвестиції, уточнює ваші фінансові цілі та пропонує шлях до їх досягнення з урахуванням вашої толерантності до ризику.',
    upozorneni2: 'Усі рекомендації ґрунтуються на даних, які ви нам надали. Розрахунки дохідності інвестицій є лише ілюстрацією — минула дохідність не гарантує майбутньої.',
    upozorneni3: 'План складено з даних, відомих на дату створення, і його потрібно регулярно оновлювати, особливо коли змінюються обставини, за яких він виник.',
    upozorneni4: 'Остаточне рішення про реалізацію рекомендацій завжди лише за вами. Операції можуть мати податкові наслідки — радимо обговорити їх із податковим консультантом.',
    bezZmenNadpis: 'Виконання ваших цілей, якщо нічого не зміните',
    bezZmenPopis: 'На скільки відсотків сьогодні покриють ваші цілі гроші, які ви вже маєте — без нових внесків. Ціль має бути на 100 %.',
    bezZmenCoUkazuje: 'Графік показує: 1. наскільки наповнений ваш ліквідний резерв на непередбачені ситуації, 2. на скільки відсотків ви профінансуєте стратегічні цілі, що купуються за гроші, 3. на скільки відсотків ви досягнете бажаного рівня життя з моменту фінансової незалежності.',
    vychazimeNadpis: 'У плані виходимо з такої інформації',
    vychazimePopis: 'Як і в інших сферах життя, в особистих фінансах важливо знати навіщо. Тому спочатку ваші цінності та великі стратегічні цілі — лише з ними кожен крок плану має сенс.',
    cileNadpis: 'Ваші стратегічні цілі, що купуються за гроші',
    popisCile: 'Опис цілі',
    majetek: 'Майно',
    hodnota: 'Вартість',
    cisteJmeni: 'Чисті активи (майно − борги)',
    rozpisNadpis: 'Детальний розпис доходів і витрат',
    prijmy: 'Доходи',
    vydaje: 'Витрати',
    rocniCastka: 'Річна сума',
    mesicniPrumer: 'Місячний середній',
    procentoZCelku: 'Відсоток від загалу',
    procentoZPrijmu: 'Відсоток від доходів',
    cistyPrijem: 'Чистий дохід — {jmeno}',
    ostatniPrijem: 'Інші доходи — {jmeno}',
    pasivniPrijem: 'Пасивні доходи (оренда, виплати)',
    bonusy: 'Бонуси та премії (річно ÷ 12)',
    vydajeCelkem: 'Витрати та платежі разом',
    prebytekDeficit: 'Надлишок / дефіцит',
    mesicne: 'щомісяця',
    zajisteniNadpis: 'Страхування — забезпечення потреб у разі несподіваної події',
    investiceNadpis: 'Інвестиції — у поєднанні із забезпеченням особистих цілей',
    alokaceSouhrn: 'Розподіл портфеля — підсумок',
    tridaAktiv: 'Клас активів',
    aktualne: 'Зараз',
    zmena: 'Зміна',
    doporuceno: 'Рекомендовано',
    celkem: 'Разом',
    nezarazeno: 'Не віднесено (пенсійні, страхові та альтернативні продукти)',
    nezarazenoPozn: 'Відсотки трьох класів рахуються лише з грошового ринку, облігацій та акцій. Не віднесені продукти план розглядає біля окремих цілей залежно від того, коли гроші стають доступними.',
    alokaceDleCilu: 'Розподіл за цілями',
    alokaceDleCiluPopis: 'Стратегічний розподіл коштів, призначених окремим цілям, за їхнім горизонтом. Сума рядків — розподіл усього плану; він не враховує ліквідність продуктів ані їхню поточну ринкову оцінку.',
    penezniTrh: 'Грошовий ринок',
    penezniTrhKratce: 'Грошовий',
    dluhopisy: 'Облігації',
    akcie: 'Акції',
    zdrojeCilu: 'З чого оплачуються цілі',
    zdrojeCiluPopis: 'Які рахунки та продукти план призначає якій цілі та скільки на неї щомісяця відкладається. Одноразовий внесок = гроші, які на ціль ще треба вкласти.',
    dumNadpis: 'Ваш план на одному малюнку',
    dumPopis: 'Фундамент (резерв і захист) несе поверхи з вашими цілями, впорядкованими за терміном; нагорі фінансова незалежність. Зелене = скільки цілі план покриє після реалізації.',
    dumAria: 'Будинок плану: {pointa}.',
    dumZaklady: 'Фундамент',
    dumRezerva: 'Резерв {castka}',
    dumRezervaRadek: 'Резерв',
    dumRenta: 'рента {castka}',
    dumVlastniZdroje: 'з них власні кошти {castka}',
    dumZajisteniVse: 'захист за пропозицією: покрито',
    dumZajisteniChybi: 'бракує захисту: {seznam}',
    dumZajisteniChybiVeta: 'Захист за пропозицією поки не покриває: {seznam}.',
    dumZdrojMajetek: 'Майно · одноразово',
    dumZdrojPrebytek: 'Надлишок · щомісяця',
    dumZbyva: 'залишається {castka}',
    dumPrecerpano: 'перевитрачено на {castka}',
    dumLegMate: 'маєте / виконано',
    dumLegChybi: 'бракує',
    dumLegNezname: 'неможливо розрахувати',
    dumLegTok: 'потік грошей з майна та надлишку',
    dumLegVyska: 'висота поверху за сумою, вище = пізніше',
    dumHotoveNadpis: 'Що готово',
    dumHotove: 'Після реалізації план повністю покриє: {seznam}.',
    dumHotoveNic: 'Поки план не покриває повністю жодної цілі.',
    dumVolne: 'Вільними залишається {castka}.',
    dumChybiNadpis: 'Чого бракує',
    dumChybi: 'План поки не покриває повністю: {seznam}.',
    dumChybiNic: 'Нічого, після реалізації план покриє всі цілі.',
    dumNezname: 'Неможливо розрахувати: {seznam}.',
    dumKrokNadpis: 'Наступний крок',
    dumKrokRealizace: 'Реалізувати план: з нинішнього майна {jednorazove} одноразово і з надлишку {mesicne} на цілі.',
    dumKrokCil: 'Потім у цілі {nazev} ({pct}) змінити суму, термін або щомісячний внесок, щоб план покрив її повністю.',
    dumKrokPrecerpano: 'План бере більше грошей, ніж є в наявності (перевитрачено на {castka}). Зменште якусь ціль або перенесіть термін.',
    dumCil: 'Ціль',
    dumKdy: 'Коли',
    dumCastka: 'Сума',
    dumJednorazove: 'Одноразово',
    dumMesicne: 'Щомісяця',
    dumSplneno: 'Виконано',
    tokyJednorazove: 'Потік грошей: одноразово з майна',
    tokyMesicne: 'Потік грошей: щомісяця з надлишку',
    tokyAria: '{druh}: {seznam}.',
    pravidelneMesicne: 'регулярна інвестиція',
    pritok: 'майбутнє надходження',
    diverzifikace: 'Диверсифікація',
    diverzifikacePopis: 'Що з більшої кількості ракурсів розподілений портфель (валюти, керуючі, емітенти), то краще він захищений від однієї невдачі. Методика: не більше 5 % майна в одного корпоративного емітента.',
    menyChip: 'Валюти: {pocet} ({meny}) · домашня валюта {pct} %',
    spravciChip: 'Установи та керуючі: {pocet} · найбільший {nazev} {pct} %',
    emitentChip: 'Понад {limit} % в одного емітента: {polozky}',
    zrealizujeteNadpis: 'Виконання ваших цілей, якщо реалізуєте наші рекомендації',
    zrealizujetePopis: 'Ліворуч стан сьогодні, праворуч після реалізації плану. Ціль має бути на 100 %.',
    vyvojNadpis: 'Аналіз майна та грошового потоку рік за роком',
    vyvojPopis: 'Портфель на фінансову незалежність за планом: скільки буде вкладено загалом і яку вартість він матиме (у сьогоднішніх цінах, за очікуваною дохідністю обраного розподілу).',
    rok: 'Рік',
    vlozenoCelkem: 'Вкладено загалом',
    hodnotaPortfolia: 'Вартість портфеля',
    podilCile: 'Частка цілі',
    vyvojPozn: 'Результати є орієнтовними і не можуть вважатися обіцянкою майбутнього.',
    vypisNadpis: 'Виписка майна',
    vypisPopis: 'структура майна на дату плану — за класами активів, валютами та установами',
    majetekCelkem: 'Майно разом',
    financniAktiva: 'Фінансові активи',
    nefinancniMajetek: 'Нефінансове майно',
    dluhy: 'Борги',
    podleTrid: 'За класами активів',
    podleMen: 'За валютами',
    podleInstituci: 'За установами та керуючими (фінансові активи)',
    pokracovani: 'продовження',
    ostatni: 'інші',
    krytoZdroji: 'покрито ресурсами',
    neuvedeno: 'установу не вказано',
    nezapocteno: 'Не враховано — немає чинного курсу: {polozky}',
    polozky: 'Позиції',
    polozka: 'Позиція',
    instituce: 'Установа',
    cilovaAlokace: 'Цільовий розподіл × поточний (фінансові активи)',
    rozdil: 'Різниця',
    tridaPenezni: 'Грошовий ринок (рахунки, заощадження)',
    tridaDluhopisy: 'Облігації',
    tridaAkcie: 'Акції',
    tridaAlternativni: 'Альтернативні та інші інвестиції',
    tridaPenzijni: 'Пенсійні продукти',
    tridaPojisteni: 'Страхування життя з накопиченням',
    tridaNemovitosti: 'Нерухомість, авто, цінності',
    tridaFirma: 'Фірма / підприємництво',
    vytvoreno: 'Створено',
    strana: 'Сторінка',
  },
  /* BLOK:navrhV2 START — Návrh řešení v 9 krocích (15. 10. 2026). Zdroj: lib/navrh/texty/*.js,
     shodu hlídá lib/navrh/__tests__/slovnikNavrhV2.test.js — needitovat ručně, upravit text v lib/navrh/texty. */
  navrhV2: {
    dilna: {
      titul: 'Майстерня',
      podtitul: 'робочий стіл радника · клієнт її не бачить',
      sekce: {
        pripraveno: 'Готово для клієнта?',
        penize: 'Розподіл грошей',
        penizePod: 'раніше Таблиця / Підсумок',
        texty: 'Тексти для клієнта',
        textyPod: 'пропозиція системи, доки ви не напишете власний',
        produkty: 'Розподіл активів, комісії та продукти',
        nastaveni: 'Налаштування розрахунку та методика',
        poznamka: 'Нотатка та виплати',
      },
      znacka: {
        chyba: 'помилка',
        pozor: 'увага',
        info: 'бракує даних',
      },
      pripraveno: {
        vecOne: '{n} пункт',
        vecFew: '{n} пункти',
        vecMany: '{n} пунктів',
        nicNeblokujeKratce: 'ніщо не блокує',
        blokujeKratce: 'блокує презентацію',
        vsePripraveno: 'усе готово',
        blokujeNadpis: 'Блокує презентацію',
        chybiNadpis: 'Бракує, але можна продовжити',
        tiskNadpis: 'Для друкованого плану',
        nicNeblokuje: 'Ніщо не блокує — доходи й план розраховані за чинною методикою',
        nicNeblokujePostaru: 'Ніщо не блокує — доходи внесено, план поки розрахований по-старому',
        nicNechybi: 'Нічого не бракує.',
        prejit: 'Перейти',
        doplnitVAnalyze: 'Доповнити в аналізі',
        otevrit: 'Відкрити',
      },
      polozka: {
        prijemPrijmy: 'Бракує доходів — без них план не розрахувати',
        prijemNula: 'Надлишок нульовий — плану нічого розподіляти',
        cenaOchrany: 'Бракує ціни захисту для варіанта {varianta} — крок 8 і «До і після» поки без ціни',
        cenaOchranyCast: 'Ціну захисту для варіанта {varianta} внесено лише для частини осіб',
        majetekOne: 'Майно та відповідальність: {n} договір чекає на ціну страховика',
        majetekFew: 'Майно та відповідальність: {n} договори чекають на ціну страховика',
        majetekMany: 'Майно та відповідальність: {n} договорів чекають на ціну страховика',
        majetekOverit: 'Майно та відповідальність: зміст договору змінився після внесення ціни — перевірте ціну (договорів: {n})',
        uverDnes: 'Поточний кредит ({nazev}): бракує {co}',
        coUrok: 'відсоткової ставки',
        coKonec: 'дати закінчення виплат',
        coOba: 'відсоткової ставки та дати закінчення виплат',
        bydleni: '{nazev}: фінансування {pct} % поки лише пропозиція системи — оберіть його з клієнтом',
        bydleniBezPct: '{nazev}: фінансування поки лише пропозиція системи — оберіть його з клієнтом',
        schodek: 'Дефіцит після отримання кредитів: {kroky} на місяць',
        schodekKrok: 'з {rok} {castka}',
        partner: '{jmeno}: бракує дати народження — захист не розраховано',
        staryPlan: 'План розраховано по-старому (методика {datum}) — перерахунок у Налаштуваннях розрахунку',
        nadPrebytek: 'План бере з надлишку {plan}, а надлишок {prebytek} — щомісяця бракує {chybi}. Змініть суми в Розподілі грошей',
        rezervaDosporit: 'З планом резерв буде лише на {pct} % — з надлишку можна доповнити {castkaMes} на місяць протягом {mesicu} міс. (крок 4)',
        rezerva: 'З планом резерв буде лише на {pct} % — вільного надлишку на доповнення немає',
        cilBezCastky: 'Ціль «{nazev}» не має суми — план її не рахує',
        cilBezTerminu: 'Ціль «{nazev}» не має терміну — план на неї не відкладає',
        cilBezObojiho: 'Ціль «{nazev}» не має ні суми, ні терміну — план її не рахує',
        zivotPod20: 'На вільні витрати залишиться лише {pct} % доходу ({castka} на місяць) — радимо 20–30 %. Клієнт побачить це на кроці 8',
      },
      tisk: {
        produkty: 'Продукти',
        coKdyProc: 'Що / Коли / Чому',
        poznamka: 'Нотатка до пропозиції',
        starobni: 'Пенсія за віком',
        navrhSystemu: 'пропозиція системи',
        upraveno: 'змінено радником',
        zadnyRadek: 'жодного рядка',
        prazdna: 'порожня',
        vyplnena: 'заповнена',
        nezadano: 'не внесено — не друкується',
        rucne: 'внесено вручну',
        radkuOne: '{n} рядок',
        radkuFew: '{n} рядки',
        radkuMany: '{n} рядків',
      },
      penize: {
        prebytek: 'Надлишок',
        naPlan: 'На план сьогодні',
        zbyva: 'Залишається постійно',
        presuny: 'Перекази із заощаджень',
        drziSplatka: 'сьогодні {castka}, потім його забирає платіж за кредитом',
        odkud: 'Звідки йдуть гроші',
        kam: 'Куди',
        podlePlanu: 'за планом',
        rozdelenoRucne: 'розподілено вручну за сумами',
        zatimNikam: 'поки нікуди',
        vLetech: 'у {vek} років',
        zadneZdroje: 'У клієнта немає заощаджень, які можна розподілити.',
        rust: 'Зростання зарплати та надходження',
        pritokyCile: 'Одноразові надходження до цілей',
        tabulka: 'Таблиця A4 альбомна',
        tabulkaNeulozeno: 'Пропозицію не вдалося зберегти — таблиця показала б стару версію.',
        prehled: 'Розподіл за цілями',
        sloupec: {
          cil: 'Ціль',
          kdy: 'Коли',
          kolik: 'Скільки',
          jednorazove: 'Одноразово',
          mesicne: 'Щомісяця',
          dosazeno: 'Досягнуто',
        },
        plusKroky: '+ збільшення з часом',
        rucne: 'Змінити розподіл вручну',
        rucnePod: 'одноразово й щомісяця за цілями, звідки йдуть гроші',
      },
      texty: {
        cile: 'Тексти до цілей',
        coKdyProc: 'Що / Коли / Чому для друкованого плану',
        co: 'Що',
        kdy: 'Коли',
        proc: 'Чому',
        coPlaceholder: 'Що ми рекомендуємо',
        pridatRadek: 'Додати рядок',
        smazatRadek: 'Видалити рядок',
        pojistky: 'Рішення щодо полісів',
      },
      produkty: {
        alokace: 'Розподіл активів',
        alokaceZProfilu: 'Розподіл за профілем {profil}',
        alokaceRucne: 'Розподіл змінено вручну',
        akcie: 'Акції',
        dluhopisy: 'Облігації',
        hotovost: 'Готівка',
        upravitAlokaci: 'Змінити розподіл',
        hotovo: 'Готово',
        soucet: 'Разом {pct} %',
        soucetSpatne: 'Разом {pct} % — має бути 100 %',
        zpetNaProfil: 'Назад до профілю',
        vstupni: 'Вхідна комісія % ({min}–{max})',
        sprava: 'Комісія за управління % на рік ({min}–{max})',
        nezadano: 'не внесено',
        spravaVychozi: 'Порожнє поле = у графіках стандартна комісія {pct} %.',
        titul: 'Продукти',
        nazev: 'Назва продукту',
        castka: 'Сума',
        akce: 'Дія',
        koupit: 'Купити',
        prodat: 'Продати',
        ponechat: 'Залишити',
        navysit: 'Збільшити',
        pridat: 'Додати продукт',
        smazat: 'Видалити продукт',
        zadnyRadek: 'Поки жодного рядка.',
        sjednat: 'Оформити → Договір',
        sjednatPopis: 'Клієнт згоден? Продукти підставляться в договір.',
      },
      nastaveni: {
        profil: 'Профіль',
        scenar: 'Сценарій',
        metodikaAktualni: 'Методика {datum} — чинна, перераховувати нічого.',
        metodikaBezZmen: 'Методика {datum} — для цього клієнта нова методика нічого не змінює.',
      },
      poznamka: {
        placeholder: 'Нотатка до рішення — друкується в повному плані',
        davky: 'Соціальні виплати для друкованого плану',
        odhad: 'оцінка за доходом',
        rucne: 'внесено вручну',
        zpetNaOdhad: 'Назад до оцінки',
        starobniNezadano: 'Пенсія за віком: не внесено — друкований план її не покаже.',
      },
    },
    kroky14: {
      krok1: {
        nadpis: 'Навіщо ми це робимо',
        citace: '«{text}»',
        analyza: '{jmena}, аналіз {datum}',
        spojka: 'і',
        cileAria: 'Ваші цілі',
        mesicneOd: '{castka} щомісяця · з {rok}',
        vDnesnichCenach: 'у сьогоднішніх цінах',
        renta: 'Фінансова незалежність',
        uverem: 'у кредит',
        castkaNezadana: 'суму не вказано',
        bezTerminu: 'без терміну',
      },
      krok2: {
        nadpis: 'Де ви сьогодні',
        majetek: 'Майно',
        naUctech: 'На рахунках',
        sporeni: 'Заощадження та інвестиції',
        nemovitosti: 'Нерухомість',
        celkem: 'Разом',
        dluhy: 'борги {castka}',
        bezDluhu: 'без боргів',
        ze100: 'З кожних 100 {sym} доходу',
        dnes: 'Сьогодні',
        sPrebytkem: 'З надлишком',
        prebytek: 'Надлишок {castka} щомісяця',
        odsouhlaseny: 'погоджений',
        nadVolne: '{castka} з нього візьмемо з витрат на життя (Життя {a} → {b})',
        dobre: 'Що ви робите добре',
        odklad: 'Ви відкладаєте {pct} % доходу ({castka}) · з надлишком {pctPo} %',
        odkladJen: 'Ви відкладаєте {pct} % доходу ({castka})',
        rezerva: 'Резерв готовий на {pct} %',
        rezervaHotova: 'Резерв у вас готовий',
        most: 'Якщо {jmeno} не може працювати, родині бракує {castka} щомісяця',
        mostJeden: 'При інвалідності бракує {castka} щомісяця',
        mostAkce: 'Захист',
        detail: 'Склад майна та кредити',
        budouci: 'Майбутнє майно: {nazev}',
        uvery: 'Кредити сьогодні',
        zbyva: 'залишається {castka}',
        splatka: 'платіж {castka}',
        hypoChybi: 'В іпотеці бракує ставки та дати кінця виплат — модель з’явиться після доповнення.',
      },
      krok3: {
        nadpis: 'Захист доходу',
        rucniOne: '{n} ручна зміна',
        rucniFew: '{n} ручні зміни',
        rucniMany: '{n} ручних змін',
        vratitVse: 'Повернути все',
        invalidita: 'Найгірший ризик — інвалідність',
        dnes: 'Сьогодні',
        nemuze: '{jmeno} не може працювати',
        nemuzeJeden: 'Якщо ви не можете працювати',
        duchod: 'пенсія по інвалідності',
        potreba: 'потреба {castka}',
        chybi: 'Бракує {castka} щомісяця',
        nicNechybi: 'Доходи покриють потребу, нічого не бракує',
        prumer: 'пенсія по інвалідності {castka} — середнє значення',
        aria: 'Сьогодні надходить {dnes}. Якщо {jmeno} не може працювати, надійде {prijde}, а потреба {potreba} щомісяця.',
        ariaJeden: 'Сьогодні надходить {dnes}. Якщо ви не можете працювати, надійде {prijde}, а потреба {potreba} щомісяця.',
        pojistka: 'У вас уже є якась страховка?',
        platba: '{castka} щомісяця',
        platbaNezadana: 'платіж не введено',
        predApo: 'До і після',
        veta: 'Якщо {jmeno} втратить здоров’я, родина отримає {nove} замість {dnes}.',
        vetaJeden: 'Якщо ви втратите здоров’я, отримаєте {nove} замість {dnes}.',
        vetaNema: 'Якщо {jmeno} втратить здоров’я, родина отримає {nove}. Сьогодні нічого.',
        vetaNemaJeden: 'Якщо ви втратите здоров’я, отримаєте {nove}. Сьогодні нічого.',
        vetaBez: 'Якщо {jmeno} втратить здоров’я, родина отримає {nove}.',
        vetaBezJeden: 'Якщо ви втратите здоров’я, отримаєте {nove}.',
        dovetek: 'Нове = на початку, з роками зменшується.',
        vetaCena: 'Зараз ви платите {dnes} на місяць, по-новому {nove}.',
        vetaCenaJen: 'По-новому платитимете {nove} на місяць.',
        dalsiRizika: 'Інші ризики · {n}',
        pojistne: 'внесок {dnes} → {nove}',
        pojistneNove: 'внесок {nove}',
        rizikOne: '{n} ризик',
        rizikFew: '{n} ризики',
        rizikMany: '{n} ризиків',
        dnesNezadano: 'сьогодні не вказано',
        jakSePocita: 'Як це рахується',
        nespocteno: '{jmeno}: не розраховано — бракує дати народження',
        doplnit: 'Доповнити в аналізі',
        varianty: 'Яке велике покриття ви хочете?',
        invaliditaKoho: 'Інвалідність · {jmeno}',
        invaliditaSloupec: 'Інвалідність',
        variantaSloupec: 'Варіант',
        cena: 'Ціна',
        cenaNezadana: 'ціну ще не введено',
        mesicne: '{castka} щомісяця',
        zvoleno: 'обрано',
        ulozeno: 'Збережено: {nazev}',
        vratit: 'Повернути',
        coZnamenaji: 'Що означають варіанти',
        majetek: 'Майно та відповідальність',
        bezSmluvMajetku: 'Немає договору на майно',
        vysvetlitMajetek: 'Пояснити страхування майна',
        upravitKryti: 'Змінити суми та параметри покриття',
      },
      krok4: {
        nadpis: 'Резерв',
        cil: 'Мета {castka}',
        zakladOne: '{n} місяць необхідних витрат і платежів ({castka})',
        zakladFew: '{n} місяці необхідних витрат і платежів ({castka})',
        zakladMany: '{n} місяців необхідних витрат і платежів ({castka})',
        mate: 'Маєте',
        chybi: 'Бракує',
        zFondu: 'Доповнимо з фондів',
        zaOne: 'через {n} місяць',
        zaFew: 'через {n} місяці',
        zaMany: 'через {n} місяців',
        kde: 'На ощадному рахунку або у фонді грошового ринку, не в акціях.',
        hotova: 'Резерв готовий',
        aria: 'Резерв сьогодні {dnes} %, з планом {po} %',
        dnesPct: 'сьогодні {pct} %',
        poPct: 'з планом {pct} %',
        dosporitNabidka: 'Доповнити {castka} на місяць протягом {mesicu} міс.',
        dosporeni: 'Доповнимо з надлишку {castka} на місяць протягом {mesicu} міс.',
        dosporitZrusit: 'Скасувати доповнення',
      },
      nezadano: 'не введено',
    },
    kroky56: {
      k5: {
        nadpis: 'Ваші цілі',
        cipyAria: 'Ваші цілі за роками',
        uverem: 'у кредит',
        renta: 'Рента',
        profilRadek: 'Профіль: {profil} · {scenar} · зниження ризику перед ціллю',
        zmenitVDilne: 'Змінити в Майстерні',
        zadneCile: 'Крім резерву та ренти, у плані немає інших цілей.',
      },
      profil: {
        dynamicky: 'Динамічний',
        vyvazeny: 'Збалансований',
        konzervativni: 'Консервативний',
      },
      karta: {
        castkaRok: '{castka} · {rok}',
        vek: '{jmeno} у {vek} років',
        plneni: 'сьогодні {dnes} % → з планом {po} %',
        sPlanem: 'з планом {po} %',
        mesicne: 'Щомісяця',
        jednorazove: 'Одноразово',
        splatkaOd: 'Платіж з {rok}',
        bezPenez: 'Поки без грошей',
        chybi: 'бракує {castka}',
        modelove: 'За моделлю у {rok}',
        cil: 'Ціль',
        splneno: 'досягнуто',
        chybiNadpis: 'Бракує',
        upravitCil: 'Змінити суму та рік цілі',
        castkaPole: 'Сума цілі',
        rokPole: 'Рік цілі',
        pouzit: 'Застосувати',
        zrusit: 'Скасувати',
        vratit: 'Повернути значення з аналізу',
        upraveno: 'змінено',
        detail: 'Деталі',
        glideNadpis: 'Як змінюється склад',
        prvni: 'Перший рік',
        polovina: 'Посередині',
        posledni: 'Останній рік',
        slozeni: 'акції {akcie} % · облігації {dluhopisy} % · готівка {cash} %',
        jakInvestovat: 'Як інвестувати',
        jakInvestovatText: 'За планом, профіль {profil}: перед ціллю акції поступово продаються, останній рік усе в готівці.',
      },
      duvod: {
        splatka: 'З {rok} увесь надлишок забирає платіж за кредитом «{popis}» — щомісяця сюди нічого не лишається.',
        drivejsi: 'Сьогодні надлишок іде на попередні цілі.',
        bezTerminu: 'Ціль поки не має терміну — план на неї не відкладає.',
        jine: 'План поки що сюди нічого не спрямовує.',
      },
      fin: {
        krok1: 'Як ви профінансуєте купівлю',
        jakZaplatit: 'Як оплатите',
        zaplatitSporenim: 'Накопичити все',
        zaplatitUverem: 'У кредит',
        krok2: 'Накопичити власні кошти',
        uver: 'Кредит',
        hypoteka: 'Іпотека',
        uverem100: '100 % у кредит',
        hotove: 'Готівкою',
        hotovePct: '{pct} %',
        produkt: 'Вид кредиту',
        spotrebitelsky: 'Споживчий',
        stavebko: 'З будівельних заощаджень',
        splatnost: 'Строк',
        urokRocne: 'Відсоток річних',
        volba: 'Варіант',
        vlastniZdroje: 'Власні кошти',
        mesicneDoKoupe: 'Щомісяця до купівлі',
        splatka: 'Платіж',
        a10: '10 % власних',
        a20: '20 % власних',
        a30: '30 % власних',
        a100: '100 % з будівельними заощадженнями',
        zastava: '100 % під заставу нерухомості',
        duvodVek: 'лише до 36 років · у {rok} {jmeno} буде {vek}',
        duvodVekNbs: 'лише перше житло до 35 років · у {rok} {jmeno} буде {vek}',
        duvodDo2026: 'при купівлі до кінця 2026 року лише 20 % власних коштів',
        duvodNemovitost: 'лише перше житло без іншої нерухомості',
        duvodK2: 'бракує дати народження другого позичальника',
        duvodVekNeznamy: 'бракує дати народження',
        duvodNelze: 'цей варіант план не вміє порахувати',
        a100Rozpis: 'іпотека {hypo} + будівельні заощадження {stavebko}',
        zastavaRadek: 'застава: {nazev} {castka}',
        zatizeni: 'перевірте обтяження — на нерухомості є іпотека',
        hypoInfo: 'Іпотека {sazba} % на {roky}',
        dalsiMoznosti: 'Інші варіанти фінансування',
        klientVolba: '{volba} · {uver} на {roky}',
        sporitVysledek: 'За моделлю за {roky}: {hodnota} з {cil}',
        bezVlastnich: 'Власні кошти не потрібні — усю ціну покриває кредит.',
        schodek: 'З {rok} у бюджеті бракує {castka} щомісяця.',
      },
      k6: {
        nadpis: 'Рента',
        nazev: 'Фінансова незалежність',
        podnadpis: '{castka} щомісяця в сьогоднішніх цінах · з {rok}',
        kapital: 'Потрібний капітал',
        kapitalPozn: 'зняття 4 % на рік, безстрокова рента',
        planDava: 'План дає за моделлю',
        pasmo: '{od} – {do}',
        pasmoPozn: 'від гіршого до кращого сценарію',
        poPoplatcichCastka: 'після комісій {castka}',
        poPoplatcichPct: 'після комісій {pct} %',
        dnes: 'сьогодні',
        zdrojRadek: '{popis} · {kdy}',
        zdrojVek: '{rok}, у {vek}',
        mesicneOdDneska: 'Щомісяця від сьогодні',
        mesicnePopo: 'Щомісяця {kroky}',
        mesicneOd: 'Щомісяця з {rok}',
        az: 'до {castka}',
        zdrojeDoRenty: 'Будівельні та пенсійні заощадження до ренти',
        ano: 'так',
        ne: 'ні',
        doCeho: 'У що інвестуємо',
        rentier: 'Рентний портфель: акції {akcie} % · облігації {dluhopisy} % · готівка {cash} %. Зберігається й під час виплат ренти.',
        bezRenty: 'Рента в аналізі поки не задана.',
      },
      graf: {
        vlozeno: 'Вкладено',
        modelove: 'За моделлю',
        poPoplatcich: 'Після комісій',
        pasmo: 'від гіршого до кращого сценарію',
        pasmoBublina: 'Гірший – кращий сценарій',
        cil: 'Ціль {castka}',
        kapital: 'Капітал {castka}',
        aria: '{nazev}: за моделлю {hodnota} у {rok} з {cil}, у гіршому сценарії {od}, у кращому {do}, після комісій {po}. Модель, не гарантія.',
        vetaRoku: 'Вкладено {vlozeno} · за моделлю {hodnota} · після комісій {po}',
        dnes: 'сьогодні',
      },
      letOne: '{n} рік',
      letFew: '{n} роки',
      letMany: '{n} років',
    },
    kroky79: {
      k7: {
        sPlanem: 'З планом',
        naUctu: 'На ощадному рахунку',
        poPoplatcich: 'після комісій',
        pasmo: 'гірший – кращий сценарій',
        pasmoBublina: 'Гірший – кращий сценарій',
        veta: 'Ті самі гроші, ті самі цілі: через {roky} за моделлю {sPlanem} з планом (у гіршому сценарії {horsi}), {naUctu} на ощадному рахунку.',
        vetaSPoplatky: 'Ті самі гроші, ті самі цілі: через {roky} за моделлю {sPlanem} з планом до комісій ({poPoplatcich} після комісій, у гіршому сценарії {horsi}), {naUctu} на ощадному рахунку.',
        vetaUcet: 'Ощадний рахунок = ті самі гроші в той самий день, ставка ощадного рахунку {sazba} % на рік понад інфляцію (у сьогоднішніх цінах).',
        chybiNaUctu: 'На ощадному рахунку у {rok} році на «{cil}» бракувало б {castka}.',
        vetaRoku: 'З планом {sPlanem} · на ощадному рахунку {naUctu}',
        aria: 'Через {roky} за моделлю {sPlanem} з планом до комісій, {poPoplatcich} після комісій, у гіршому сценарії {horsi}, на ощадному рахунку {naUctu}. Модель, не гарантія.',
        dnes: 'сьогодні',
        schodek: 'Після отримання кредитів плану бракує {seznam} на місяць — спершу вирішимо це (крок 8).',
        schodekPrez: 'Після отримання кредитів плану бракує {seznam} на місяць — спершу вирішимо це.',
        postaru: 'Розраховано за старою методикою — порівняння з’явиться після перерахунку.',
        prepocitat: 'Перерахувати',
        bezCilu: 'План поки не спрямовує гроші в жодну ціль — нема що порівнювати.',
        odklad: 'Скільки коштує відкладання',
        odkladUvod: 'Скільки на місяць потрібно на ренту {renta}:',
        odkladDnes: 'якщо почнете сьогодні',
        odkladZa: 'якщо почнете через {roky}',
        mesicneCastka: '{castka} на місяць',
      },
      k8: {
        mesicne: 'Щомісяця',
        mesicneRozpad: 'захист {ochrana} (сьогодні {dnes}) · інвестиції {investice}',
        mesicneBezCeny: 'інвестиції {investice} · захист поки без ціни',
        mesicneBezNove: 'інвестиції {investice} · без нового захисту',
        bezNoveOchrany: 'без нового захисту',
        vicNezDnes: 'на {castka} більше, ніж сьогодні',
        orientacne: 'орієнтовно {castka} · оцінка застосунку, не віднімається',
        jednorazove: 'Нові гроші одноразово',
        presunyUvod: 'Перенесемо з ваших заощаджень:',
        presun: '{odkud} → {kam}',
        vRoce: 'у {rok} році',
        zaMesicu: 'через {n} міс.',
        odkud: {
          ucty: 'рахунки та будівельні заощадження',
          fondy: 'фонди',
          penzijko: 'пенсійні заощадження',
          pritok: 'майбутній дохід',
          dopocet: 'додатковий внесок',
        },
        kam: {
          rezerva: 'резерв',
          renta: 'рента',
        },
        vetaPrebytek: 'З надлишку {prebytek} на план іде {plan}, залишається {zbyva}.',
        vetaPrebytekDrzi: 'З надлишку {prebytek} на план іде {plan}.',
        vetaNadPrebytek: 'План бере з надлишку {plan}, а надлишок {prebytek} — щомісяця бракує {chybi}.',
        vetaDrzi: 'Решту {castka} план на цілі не використає: з {rok} року її забере платіж за кредитом «{uver}».',
        schodek: 'Після отримання кредитів бракує {seznam} на місяць.',
        schodekPolozka: 'з {rok} року {castka}',
        stovka: 'На вільні витрати (понад обов’язкові) вам залишиться {pct} % доходу ({castka} на місяць) — радимо від 20 до 30 %.',
        ochranaOsob: 'Захист осіб',
        cenaOsoby: '{jmeno} · на місяць',
        cenaDeti: 'Діти · на місяць',
        cenaPh: 'ціна від страховика',
        pojistne: 'Страховий внесок: сьогодні {dnes} → {nove}',
        pojistneRozdil: '({rozdil})',
        cenaNezadana: 'ціну ще не введено',
        majetek: 'Майно та відповідальність',
        smlouvyOne: '{n} договір',
        smlouvyFew: '{n} договори',
        smlouvyMany: '{n} договорів',
        investice: 'Інвестиції',
        poplatky: 'вхідна комісія {vstupni} % · управління {sprava} % на рік',
        poplatkyNezadane: 'вхідна комісія та управління: не введено',
        mesicneCastka: '{castka} на місяць',
        rozdeleni: 'Розподіл надлишку',
        zUspor: 'Одноразово із заощаджень',
        zPrebytku: 'Щомісяця з надлишку {prebytek}',
        ochranaRozdil: 'захист (різниця проти сьогодні)',
        zbyvaDnes: 'залишається сьогодні',
        udalostSplatka: 'з {rok} року · платіж за кредитом «{popis}»',
        udalostDoplaceno: 'у {rok} році · виплачено «{popis}»',
        udalostRenta: 'з {rok} року · більше на ренту',
        uvolniSe: 'звільниться',
        cashflow: 'Грошовий потік у часі',
        cashflowAria: 'Графік грошового потоку плану: сьогодні залишається {dnes} на місяць, у найгіршому році {nejhorsi}.',
        zmenitVDilne: 'Змінити в Майстерні',
      },
      k9: {
        tri: {
          zajistit: 'Захистити дохід і майно',
          rezervaDluhy: 'Резерв і дорогі борги',
          investovat: 'Інвестувати',
        },
        ochrana: '{varianta} · {cena} на місяць',
        ochranaBezCeny: '{varianta} · ціну ще не введено',
        ochranaBezNove: '{varianta} · без нового захисту',
        majetek: 'майно {smlouvy}',
        majetekCena: 'майно {smlouvy} · {cena} на місяць',
        rezerva: 'Резерв {castka}',
        rezervaHotovo: 'Резерв {castka} · готово',
        dluhy: 'погасити кредит {castka}',
        investice: '{castka} на місяць на цілі',
        investiceSchodek: 'Поки {castka} на місяць · з {rok} року бракує {chybi}',
        chybiPodklad: 'бракує даних',
        smysl: 'Чи має це для вас сенс?',
        citace: 'На початку ви сказали: «{hodnoty}»',
        domluveno: 'Домовлено',
        ja: 'Я (консультант)',
        vy: 'Ви',
        vyJmena: 'Ви ({jmena})',
        a: 'і',
      },
      doma: {
        tlacitko: 'Обміркуємо це вдома',
        ukladam: 'Зберігаю…',
        neulozeno: 'План не вдалося зберегти. Спробуйте, будь ласка, ще раз.',
        titul: 'Ваш фінансовий план',
        intro: 'Добрий день, надсилаю план, який ми разом переглянули. Спокійно перегляньте його вдома й дайте знати.',
      },
      snimek: {
        hero: 'План щомісяця',
        heroBezCeny: 'Інвестиції щомісяця (захист поки без ціни)',
        poPoplatcich: 'Після комісій через {roky}',
        pro: 'Для',
        prebytek: 'Надлишок',
        naPlan: 'З надлишку на план',
        presuny: 'Перенесено із заощаджень',
        ochrana: 'Захист · {varianta}',
        investice: 'Інвестиції щомісяця',
        sPlanem: 'З планом через {roky}',
        naUctu: 'На ощадному рахунку',
        garance: 'Модель із ваших чисел, не гарантія.',
      },
    },
    ramec: {
      analyza: 'Аналіз',
      zpetNaAnalyzu: 'Назад до аналізу',
      navrhDatum: 'Пропозиція рішення · {datum}',
      klient: 'Клієнт',
      spojka: 'і',
      pasek: {
        popis: 'Щомісяця',
        prebytek: 'Надлишок',
        plan: 'план',
        splatky: 'платежі за кредитами',
        zbyva: 'залишається',
        chybi: 'бракує',
      },
      pohled: {
        skupina: 'Вигляд',
        dilna: 'Майстерня',
        plan: 'План',
        klient: 'Для клієнта',
      },
      kDoplneni: 'Доповнити: {n}',
      ulozeni: {
        neulozeno: 'Не збережено',
        uklada: 'Зберігаю…',
        ulozeno: 'Збережено {cas}',
        chyba: 'Не збережено',
        offline: 'Офлайн',
        zkusitZnovu: 'Спробувати ще раз',
        chybaText: 'Зміни не вдалося зберегти.',
      },
      prezentovat: 'Презентувати',
      prezentovatBlokuje: 'Поки що не можна презентувати: {duvod}',
      zpetDoUprav: 'Назад до редагування',
      dalsiKrok: 'Наступний крок',
      krokZ: 'Крок {n} з {z}',
      krokyPlanu: 'Кроки плану',
      znacka: {
        chyba: 'помилка',
        pozor: 'увага',
        info: 'бракує даних',
      },
      nacitani: 'Завантажую пропозицію…',
      chybaNacteni: 'Пропозицію не вдалося завантажити.',
      bezPrijmu: {
        kroky: 'Кроки 3–9',
        veta: 'Без доходів план не розрахувати — додайте доходи в аналізі.',
        vetaNula: 'Надлишок нульовий або від’ємний — плану нема з чого платити. Змініть витрати або надлишок в аналізі.',
        akce: 'Перейти до доходів',
      },
      dialogChybi: {
        nadpis: 'Клієнт побачить, чого ще бракує',
        dalsi: 'Ще в Майстерні: {n}',
        doplnit: 'Доповнити',
        prezentovat: 'Все одно презентувати',
        zrusit: 'Назад',
      },
      staryPlan: {
        veta: 'Розраховано за старою методикою ({datum})',
        vetaBezData: 'Розраховано за старою методикою',
        prepocitat: 'Перерахувати',
        coSeZmeni: 'Що зміниться',
      },
      offline: 'Офлайн · зміни збережуться після підключення.',
      prezentace: {
        oblast: 'Презентація плану',
        krokZ: 'крок {n} з {z}',
        cilZ: 'ціль {n} з {z}',
        dalsi: 'Далі',
        predchozi: 'Назад',
        konec: 'Завершити презентацію',
        dokoncit: 'Завершити',
      },
      uvod: {
        nadpis: 'Ваш фінансовий план',
        veta: 'Пройдемо його разом крок за кроком.',
      },
      dveZpravy: {
        nadpis: 'У мене для вас дві новини',
        dobraCile: 'Перша — добра: [[ваших цілей вдасться досягти.]]',
        dobraPlan: 'Добра новина: [[у вас є план.]]',
        lepsiCesta: 'А ще краща: ви йдете до них [[безпечнішим шляхом]].',
        lepsiDrive: 'А ще краща: жити з капіталу ви зможете [[вже через {za}]] — на {o} раніше.',
        rentaNa: 'Рента поки що на [[{pct} %]] — і ми точно бачимо, що з цим робити.',
        rentaNezadana: 'Ціль ренти ще не задана.',
      },
      dialogStary: {
        nadpis: 'План розраховано за старою методикою ({datum})',
        nadpisBezData: 'План розраховано за старою методикою',
        text: 'Старий розрахунок залишається, доки ви його не перерахуєте. Крок 7 з’явиться в презентації лише після перерахунку.',
        postaru: 'Презентувати за старою методикою',
        prepocitat: 'Перерахувати й презентувати',
        zrusit: 'Назад',
      },
    },
    kroky: {
      proc: 'Навіщо',
      dnes: 'Де ви сьогодні',
      zajisteni: 'Захист',
      rezerva: 'Резерв',
      cile: 'Цілі',
      renta: 'Рента',
      dveCesty: 'Два шляхи',
      kolik: 'Скільки це коштує',
      triKroky: 'Три кроки',
    },
    zaklad: {
      krokCislo: 'Крок {n}',
      stitek: {
        nezadano: 'не вказано',
        navrh: 'пропозиція',
        postaru: 'пораховано по-старому',
        odhad: 'оцінка',
        poplatky: 'комісії не вказано',
      },
      model: {
        veta: 'Модельно · {scenar} · у сьогоднішніх цінах · до комісій',
        cara: 'пунктирна лінія',
        scenar: {
          realisticky: 'реалістичний сценарій',
          pesimisticky: 'песимістичний сценарій',
          optimisticky: 'оптимістичний сценарій',
        },
        garance: 'Модель за вашими цифрами, а не гарантія.',
      },
      poplatky: {
        vychozi: 'після стандартної комісії за управління {sprava} %',
        zadane: 'після комісій: вхідна {vstupni} %, управління {sprava} %',
        legenda: '{cara} = {popis}',
        legendaCastka: '{cara} = {popis}: {castka}',
      },
      nacitani: 'Завантажую цифри плану…',
    },
  },
  /* BLOK:navrhV2 END */
  trychtyrBuilder: {
    title: "Воронка від А до Я",
    info: "Сім кроків за методикою Konverzky: магніт → сторінка → подяка → дзвінок → міні-вебінар → листи → реклама та вимірювання. Шаблони заповнюєш сам, нічого не генерує ШІ; зберігається на сервері для тебе.",
    krokN: "Крок {n}", hotovo: "Готово", rozpracovano: "У роботі", nezacato: "Не почато", postup: "Прогрес", hotovychKroku: "{h} з {n} готово",
    ulozit: "Зберегти", ukladam: "Зберігаю…", ulozeno: "Збережено {cas}", ulozenoBezCasu: "Збережено", neulozeno: "Не збережено", ulozeniSelhalo: "Збереження не вдалося", zkusitZnovu: "Спробувати знову",
    mistniKopie: "Сервер недоступний — ти працюєш із локальною копією з цього браузера. Спробую зберегти знову.",
    nacitam: "Завантаження…", povinne: "обов’язкове", vyber: "— вибери —",
    vlozitSablonu: "Вставити шаблон", pouzitNavrh: "Застосувати пропозицію до порожніх полів", dosaditTitulek: "Вставити в заголовок", pravidlaTitulku: "Правила заголовка",
    mojeOdkazy: "Мої посилання для поширення", nahledBezSlugu: "Поки лише попередній перегляд — для робочого посилання налаштуй адресу візитки в", nastaveni: "Налаштування",
    otevrit: "Відкрити", kopirovat: "Копіювати", zkopirovano: "Скопійовано", kopieSelhala: "Не вдалося скопіювати", tisk: "Друк / PDF", tiskSelhal: "Не вдалося відкрити друк",
    zasady: "6 правил системи продажу", krokyHovoru: "9 кроків дзвінка", beaty: "Сценарій крок за кроком (порядок обов’язковий)",
    emailyOblouk: "Прогрівальна дуга — 6 днів + доставка", emailyNoBooking: "Якщо після запиту не бронює термін", emailySekvence: "E-mail-послідовність",
    den: "День", cil: "Мета", predmet: "Тема", nahledRadek: "Рядок попереднього перегляду", telo: "Текст", ctaTlacitko: "Текст посилання (CTA)", testPraveRuky: "Тест правої руки", kopirovatSekvenci: "Копіювати всю послідовність",
    uhly: "Рекламні кути — реклама продає клік", kanaly: "Канали та налаштування", navodMereni: "Вимірювання крок за кроком", otevritNastaveni: "Налаштування сайту → Вимірювання", idNastaveno: "ID налаштовано", idChybi: "ID відсутній", format: "формат",
    checklist: "Перевірка перед запуском", predchozi: "Назад", dalsi: "Наступний крок",
  },
};

export default uk;
